window.PS_COLLECTION ={
 "collection": {
  "id": "gid://shopify/Collection/295199899832",
  "title": "Lab Grown Diamonds",
  "handle": "lab-grown-diamonds",
  "url": "https://primestyle.com/collections/lab-grown-diamonds",
  "description": "",
  "count": 978
 },
 "generatedAt": "2026-08-23T23:54:48Z",
 "products": [
  {
   "rank": 1,
   "id": "gid://shopify/Product/10155069014200",
   "title": "1.00CT Round Cut Lab Grown Diamonds Stud Earrings - $373.99",
   "url": "/products/docapp-free-gift-1-00ct-round-cut-lab-grown-diamonds-stud-earrings-373-99",
   "handle": "docapp-free-gift-1-00ct-round-cut-lab-grown-diamonds-stud-earrings-373-99",
   "priceNow": 373.99,
   "priceWas": 1121.97,
   "pctOff": 67,
   "core": null,
   "inStock": true,
   "createdAt": "2025-11-28T10:07:32Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/15415LB_w1_0f1cdc36-f203-4669-9648-cde1dcc21f87.jpg?v=1703182580"
   },
   "carat": 1.0
  },
  {
   "rank": 2,
   "id": "gid://shopify/Product/7476265943224",
   "title": "2.60 CT Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-15713lb",
   "handle": "wedding-bands-15713lb",
   "priceNow": 1883.99,
   "priceWas": 5840.0,
   "pctOff": 68,
   "core": "15713",
   "inStock": true,
   "createdAt": "2024-03-10T18:51:51Z",
   "shape": "princess",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/18MHFIi21CzjzeH708YKyTo37puJhfHVW",
      "b": "https://lh3.googleusercontent.com/d/1TLLvm1AJWRrCc3sX6MADG805U_Zmq0K0",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1_Z6XGNbi6nwiI3mCQq3Wovc8nreXCQG5",
      "b": "https://lh3.googleusercontent.com/d/1Jxf6JpBPKsJCELqwyZqAAysWn8FrC-Ix",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Vq2HBCLS6oEwMuxOHhxZyYVugmqbLSb7",
      "b": "https://lh3.googleusercontent.com/d/1-AHf9yUVRrz8pBpGF9XAWyM87ty1ijwS",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_ff64d04c-c94c-4f3c-937f-7cc0a51a0017.jpg?v=1763699079"
   },
   "carat": 2.6
  },
  {
   "rank": 3,
   "id": "gid://shopify/Product/7305421815992",
   "title": "2.50-8.00 CT Princess Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/2-50-5-00-ct-princess-cut-lab-grown-diamonds-bridal-set-15714lb",
   "handle": "2-50-5-00-ct-princess-cut-lab-grown-diamonds-bridal-set-15714lb",
   "priceNow": 2601.99,
   "priceWas": 8070.0,
   "pctOff": 68,
   "core": "15714",
   "inStock": true,
   "createdAt": "2023-08-10T19:11:18Z",
   "shape": "princess",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1dJGxlRH5kR3xZNPs_OmRID7NGOHlDI3o",
      "b": "https://lh3.googleusercontent.com/d/1XM3ekYNVv7Rnj6NCRIlOf2AMIaU0h6jf",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1xvwBY2hfnWYsw51EYVcFOMON-mV0Y8xJ",
      "b": "https://lh3.googleusercontent.com/d/1SLWeqkD3edTciJwPyRHQ5A_aqk2Dbdds",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1zZA-aLmaynPQfqmACaPdl1MzWBjceK5d",
      "b": "https://lh3.googleusercontent.com/d/1Ly_tu1p9g_dFfKg8MWEr4ndpmJOaUukA",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/250-500-ct-princess-cut-lab-grown-diamonds-bridal-set-537260.jpg?v=1714761141"
   },
   "carat": 2.5,
   "caratMax": 8.0
  },
  {
   "rank": 4,
   "id": "gid://shopify/Product/10153269067960",
   "title": "2.00 CT Round Cut Lab Grown Diamonds in 14KT White Gold  Stud Earrings",
   "url": "/products/2-00-ct-round-cut-lab-grown-diamonds-in-14kt-white-gold-stud-earrings",
   "handle": "2-00-ct-round-cut-lab-grown-diamonds-in-14kt-white-gold-stud-earrings",
   "priceNow": 860.99,
   "priceWas": 3115.0,
   "pctOff": 72,
   "core": "200",
   "inStock": true,
   "createdAt": "2025-11-27T22:03:55Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-round-cut-lab-grown-diamonds-stud-earrings-425997.jpg?v=1698786141"
   },
   "carat": 2.0
  },
  {
   "rank": 5,
   "id": "gid://shopify/Product/7685897781432",
   "title": "5.20-10.70 CT Emerald & Princess Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-71641lb",
   "handle": "bridal-sets-71641lb",
   "priceNow": 4040.99,
   "priceWas": 12530.0,
   "pctOff": 68,
   "core": "71641",
   "inStock": true,
   "createdAt": "2024-05-14T18:16:37Z",
   "shape": "princess",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_b8febab3-4423-4f5c-8ef5-33d99c45e03d.jpg?v=1715712086",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_b8febab3-4423-4f5c-8ef5-33d99c45e03d.jpg?v=1715712086",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y3_efcf6647-25ec-451a-b3cb-e5ef9ea77805.jpg?v=1763698110",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r3_1a986683-1e4a-4e99-b20c-bb15e19f92a2.jpg?v=1763698109"
    }
   },
   "carat": 5.2,
   "caratMax": 10.7
  },
  {
   "rank": 6,
   "id": "gid://shopify/Product/7328603504824",
   "title": "0.60-5.00 CT Round Cut Lab Grown Diamonds - Stud Earrings",
   "url": "/products/0-60-5-00-ct-round-cut-lab-grown-diamonds-stud-earrings-15415lb",
   "handle": "0-60-5-00-ct-round-cut-lab-grown-diamonds-stud-earrings-15415lb",
   "priceNow": 1062.99,
   "priceWas": 3300.0,
   "pctOff": 68,
   "core": "15415",
   "inStock": true,
   "createdAt": "2023-10-19T09:09:29Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1BM4PwSwhVJr6fsMsGNCGB2KpujgyM1qU",
      "b": "https://lh3.googleusercontent.com/d/1D-K9IFJutWUvmB_6roWARcXF1JpUbyg2",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1dkt2j729wXyZjXOgIWB5Vd9Hh59wSuyT",
      "b": "https://lh3.googleusercontent.com/d/1PxsJlTPYSQd4ltc8TnBqahLpViJVMxMd",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1rr2U33FnzWo0fP1YHiIWsFXUcLR1pbag",
      "b": "https://lh3.googleusercontent.com/d/1S1wQ2foV9nzFsDbW8IymtldfZ-YlqSqv",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-round-cut-lab-grown-diamonds-stud-earrings-425997.jpg?v=1698786141"
   },
   "carat": 0.6,
   "caratMax": 5.0
  },
  {
   "rank": 7,
   "id": "gid://shopify/Product/7305422012600",
   "title": "1.90-7.40 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-90-4-40-ct-round-princess-cut-lab-grown-diamonds-bridal-set-21039lb",
   "handle": "1-90-4-40-ct-round-princess-cut-lab-grown-diamonds-bridal-set-21039lb",
   "priceNow": 3050.99,
   "priceWas": 9460.0,
   "pctOff": 68,
   "core": "21039",
   "inStock": true,
   "createdAt": "2023-08-10T19:11:53Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/190-440-ct-round-princess-cut-lab-grown-diamonds-bridal-set-631108.jpg?v=1714760986",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/190-440-ct-round-princess-cut-lab-grown-diamonds-bridal-set-631108.jpg?v=1714760986",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/190-440-ct-round-princess-cut-lab-grown-diamonds-bridal-set-350332.jpg?v=1763699374",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/190-440-ct-round-princess-cut-lab-grown-diamonds-bridal-set-338616.jpg?v=1763699374"
    }
   },
   "carat": 1.9,
   "caratMax": 7.4
  },
  {
   "rank": 8,
   "id": "gid://shopify/Product/7305308930232",
   "title": "1.15-6.65 CT Heart & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-15-3-65-ct-round-heart-cut-lab-grown-diamonds-bridal-set-110354lb",
   "handle": "1-15-3-65-ct-round-heart-cut-lab-grown-diamonds-bridal-set-110354lb",
   "priceNow": 1938.99,
   "priceWas": 6010.0,
   "pctOff": 68,
   "core": "110354",
   "inStock": true,
   "createdAt": "2023-08-09T19:32:00Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1kOVApY1JPq03sCg349nwBad-uPTw8jq4",
      "b": "https://lh3.googleusercontent.com/d/1RTF8iA2VokdVhQ0SQ8z5f_ZjDnrKnnZL",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1K1pKViXuTcI1TLDORZOj4Drwye50X0Ct",
      "b": "https://lh3.googleusercontent.com/d/1IDcuBF4kUQIIJwssewvn7Nf5mt1Tvf8M",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1xlF_7rAI9dTIrBa9Uxy5i5Xv3GPP5Sye",
      "b": "https://lh3.googleusercontent.com/d/1EX1eQpdS6RWGsIAaSvUQ_XUQt55YWXYJ",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/115-365-ct-round-heart-cut-lab-grown-diamonds-bridal-set-472069.jpg?v=1714676247"
   },
   "carat": 1.15,
   "caratMax": 6.65
  },
  {
   "rank": 9,
   "id": "gid://shopify/Product/7301511053496",
   "title": "0.50-6.00 CT Round Cut Lab Grown Diamonds - Solitaire Pendant",
   "url": "/products/0-50-3-00-ct-round-cut-lab-grown-diamonds-solitaire-pendant-21001lb",
   "handle": "0-50-3-00-ct-round-cut-lab-grown-diamonds-solitaire-pendant-21001lb",
   "priceNow": 831.99,
   "priceWas": 2830.0,
   "pctOff": 71,
   "core": "21001",
   "inStock": true,
   "createdAt": "2023-07-14T22:53:04Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-round-cut-lab-grown-diamonds-solitaire-pendant-136909.jpg?v=1699393723"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 10,
   "id": "gid://shopify/Product/10155922030776",
   "title": "8.00 CT Round Cut Diamonds - Diamond Necklace",
   "url": "/products/8-00-ct-round-cut-diamonds-diamond-necklace",
   "handle": "8-00-ct-round-cut-diamonds-diamond-necklace",
   "priceNow": 4286.99,
   "priceWas": 12675.0,
   "pctOff": 66,
   "core": "30020",
   "inStock": true,
   "createdAt": "2025-11-30T16:31:58Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/WhatsApp_Image_2025-12-01_at_08.41.56_4a7f05b2.jpg?v=1768436769",
    "byColor": {
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/WhatsApp_Image_2025-12-01_at_08.41.56_38529af7.jpg?v=1768436769",
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/WhatsApp_Image_2025-12-01_at_08.41.56_4a7f05b2.jpg?v=1768436769"
    }
   },
   "carat": 8.0
  },
  {
   "rank": 11,
   "id": "gid://shopify/Product/7369471033528",
   "title": "Luxury 0.15 CT Lab Diamond Pendant – $173.99",
   "url": "/products/0-15-ct-round-cut-diamonds-solitaire-pendant-in-silver",
   "handle": "0-15-ct-round-cut-diamonds-solitaire-pendant-in-silver",
   "priceNow": 173.99,
   "priceWas": 566.0,
   "pctOff": 69,
   "core": null,
   "inStock": true,
   "createdAt": "2023-11-16T14:18:35Z",
   "shape": null,
   "origin": "lab",
   "rating": 4.0,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/015-ct-round-cut-lab-grown-diamonds-solitaire-pendant-in-silver-257075.jpg?v=1742507732"
   },
   "carat": 0.15
  },
  {
   "rank": 12,
   "id": "gid://shopify/Product/7304432550072",
   "title": "1.00-6.50 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-00-3-50-ct-round-cut-lab-grown-diamonds-bridal-set-21026lb",
   "handle": "1-00-3-50-ct-round-cut-lab-grown-diamonds-bridal-set-21026lb",
   "priceNow": 1501.99,
   "priceWas": 4660.0,
   "pctOff": 68,
   "core": "21026",
   "inStock": true,
   "createdAt": "2023-08-04T00:17:33Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-350-ct-round-cut-lab-grown-diamonds-bridal-set-276609.jpg?v=1714757363",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-350-ct-round-cut-lab-grown-diamonds-bridal-set-276609.jpg?v=1714757363",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-350-ct-round-cut-lab-grown-diamonds-bridal-set-325643.jpg?v=1763699564",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-350-ct-round-cut-lab-grown-diamonds-bridal-set-227500.jpg?v=1763699564"
    }
   },
   "carat": 1.0,
   "caratMax": 6.5
  },
  {
   "rank": 13,
   "id": "gid://shopify/Product/10153262612664",
   "title": "1.00 CT Round Cut Lab Grown Diamonds in 14KT White Gold  Stud Earrings",
   "url": "/products/1-00-ct-round-cut-lab-grown-diamonds-in-14kt-white-gold-stud-earrings",
   "handle": "1-00-ct-round-cut-lab-grown-diamonds-in-14kt-white-gold-stud-earrings",
   "priceNow": 530.99,
   "priceWas": 3115.0,
   "pctOff": 83,
   "core": "1",
   "inStock": true,
   "createdAt": "2025-11-27T21:18:17Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-round-cut-lab-grown-diamonds-stud-earrings-425997.jpg?v=1698786141"
   },
   "carat": 1.0
  },
  {
   "rank": 14,
   "id": "gid://shopify/Product/7641272418488",
   "title": "1.05-6.55 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-16028lb",
   "handle": "bridal-sets-16028lb",
   "priceNow": 2037.99,
   "priceWas": 6320.0,
   "pctOff": 68,
   "core": "16028",
   "inStock": true,
   "createdAt": "2024-04-26T15:52:21Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1TXc6yxo1ECRC2ck70qJeEEPqD-W3qs5e",
      "b": "https://lh3.googleusercontent.com/d/1Mb5KP-BG9Q1NVyBhAweu0f4YQ-pKll2x",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/111lHxHQ7NU4WpFWo7UxhDBYpCd_CPd5l",
      "b": "https://lh3.googleusercontent.com/d/1EpFu5s6R6bY4Hr80QYOS0zVCHKx0kRn1",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1facQqZZwXKf-rJad_yFONw4Zg3k6wEZZ",
      "b": "https://lh3.googleusercontent.com/d/1gVVRHt6rW-U1l8Cm2lVTXg7OqVodL3dQ",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_f5b6a06b-a366-422e-bc5e-c7795a3d2002.jpg?v=1714154966"
   },
   "carat": 1.05,
   "caratMax": 6.55
  },
  {
   "rank": 15,
   "id": "gid://shopify/Product/7476266205368",
   "title": "1.00 CT Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-16036lb",
   "handle": "wedding-bands-16036lb",
   "priceNow": 1296.99,
   "priceWas": 4020.0,
   "pctOff": 68,
   "core": "16036",
   "inStock": true,
   "createdAt": "2024-03-10T18:51:56Z",
   "shape": "princess",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1PGsdDfJKZOq6wKBkEqgxRqIqx2kgJyt2",
      "b": "https://lh3.googleusercontent.com/d/1j2X-6sN0cenodKQE-nofdfFyugCmtWdY",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1uDvNVmL0i5djHUdzTWUCVB-Y6b7wQLI1",
      "b": "https://lh3.googleusercontent.com/d/1OWOelVHM_EAcejmWDZ4Vgo-Rq8xTLWWm",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1tPNUvGql4yDRaHN6JtiRjD0GHFiVgVnG",
      "b": "https://lh3.googleusercontent.com/d/1GJScTJ5dv03324Yu0SZxHtImBwql6w3d",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_6a84275b-e71d-4fd6-9667-b4a0fc01f1c9.jpg?v=1763698996"
   },
   "carat": 1.0
  },
  {
   "rank": 16,
   "id": "gid://shopify/Product/7303136903352",
   "title": "0.50-6.00 CT Oval Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/0-50-3-00-ct-oval-cut-lab-grown-diamonds-solitaire-ring-21012lb",
   "handle": "0-50-3-00-ct-oval-cut-lab-grown-diamonds-solitaire-ring-21012lb",
   "priceNow": 1327.99,
   "priceWas": 4120.0,
   "pctOff": 68,
   "core": "21012",
   "inStock": true,
   "createdAt": "2023-07-26T17:47:59Z",
   "shape": "oval",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-oval-cut-lab-grown-diamonds-solitaire-ring-235391.jpg?v=1763748632"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 17,
   "id": "gid://shopify/Product/7601926537400",
   "title": "1.15-6.65 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-15246lb",
   "handle": "engagement-rings-15246lb",
   "priceNow": 2320.99,
   "priceWas": 7200.0,
   "pctOff": 68,
   "core": "15246",
   "inStock": true,
   "createdAt": "2024-04-19T15:30:10Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1mHZ8tCTmsiyJfuaFKG--3CyYLRAv9ScH",
      "b": "https://lh3.googleusercontent.com/d/19wihNe5-dwSXJr7PY7t3GWbQ21IiVuSv",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/15ZR_hknNxpRxmrm9R9y3QhLiBStSmgY3",
      "b": "https://lh3.googleusercontent.com/d/1KeX6XQDhtvtUoSpVVEASrBOAq4UnCQZd",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1GS6F-iGjP-rR-beamj1wJ0hY9NZGG-_Z",
      "b": "https://lh3.googleusercontent.com/d/1LdF42KFlhg7Bq940TrjHTzBEihmrhK1A",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_6b353f2a-8b35-4a6d-8493-187b0fcabc29.jpg?v=1765414836"
   },
   "carat": 1.15,
   "caratMax": 6.65
  },
  {
   "rank": 18,
   "id": "gid://shopify/Product/7300756668600",
   "title": "1.50-5.00 CT Round Cut Lab Grown Diamonds - Eternity Rings",
   "url": "/products/1-50-5-00-ct-round-cut-lab-grown-diamonds-eternity-ring-71732lb",
   "handle": "1-50-5-00-ct-round-cut-lab-grown-diamonds-eternity-ring-71732lb",
   "priceNow": 1247.99,
   "priceWas": 3870.0,
   "pctOff": 68,
   "core": "71732",
   "inStock": true,
   "createdAt": "2023-07-10T20:54:59Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1__SI_r_pqzSyn2T074JbbRCVcU_kgdNv",
      "b": "https://lh3.googleusercontent.com/d/1JP-nPp-FByLjmtCGw_wfEsTYribKK0j3",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1qz8Ur4I4Ezh0IDYc1py6jcaAZVi5XuiT",
      "b": "https://lh3.googleusercontent.com/d/1GJX_TnxTLVW5VAE-HNnN2CoOllllUNx6",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1m_jvSRPMRmiSCyji-cS-rUxuvW-ah_Ks",
      "b": "https://lh3.googleusercontent.com/d/1AthgtrkskMe1luvjh74_N4kZ7WgCN0CA",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/150-500-ct-round-cut-lab-grown-diamonds-eternity-ring-839436.jpg?v=1697640162"
   },
   "carat": 1.5,
   "caratMax": 5.0
  },
  {
   "rank": 19,
   "id": "gid://shopify/Product/7303610007736",
   "title": "1.85-7.35 CT Emerald & Princess Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/1-85-4-35-ct-princess-emerald-cut-lab-grown-diamonds-engagement-ring-15665lb",
   "handle": "1-85-4-35-ct-princess-emerald-cut-lab-grown-diamonds-engagement-ring-15665lb",
   "priceNow": 2001.99,
   "priceWas": 6210.0,
   "pctOff": 68,
   "core": "15665",
   "inStock": true,
   "createdAt": "2023-07-28T19:23:48Z",
   "shape": "princess",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1T5keD9fMnkbBgCsBNTvPt_aLWnJlTGA7",
      "b": "https://lh3.googleusercontent.com/d/1Y7ePgiAVjKPXuPhWnBrynmsqgtVi8bCG",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1lgJvfhycDcTfBeufGoKuKlbnx_KzX6KU",
      "b": "https://lh3.googleusercontent.com/d/1XImkvHw6qpCD72kvn3q5xL0rwq4m_sF7",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1OuviZzfkrEiWJfNfo0LJD7t_7VZtZy5h",
      "b": "https://lh3.googleusercontent.com/d/1BxBQ2-XsehPePM39c6TLWAud9Qx2IWX6",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/185-435-ct-princess-emerald-cut-lab-grown-diamonds-engagement-ring-220388.jpg?v=1765415305"
   },
   "carat": 1.85,
   "caratMax": 7.35
  },
  {
   "rank": 20,
   "id": "gid://shopify/Product/10153265987768",
   "title": "1.50 CT Round Cut Lab Grown Diamonds in 14KT Yellow Gold Stud Earrings",
   "url": "/products/1-50-ct-round-cut-lab-grown-diamonds-in-14kt-yellow-gold-stud-earrings",
   "handle": "1-50-ct-round-cut-lab-grown-diamonds-in-14kt-yellow-gold-stud-earrings",
   "priceNow": 700.99,
   "priceWas": 3335.0,
   "pctOff": 79,
   "core": "150",
   "inStock": true,
   "createdAt": "2025-11-27T21:40:12Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-round-cut-lab-grown-diamonds-stud-earrings-900416.jpg?v=1763699330"
   },
   "carat": 1.5
  },
  {
   "rank": 21,
   "id": "gid://shopify/Product/7397672911032",
   "title": "0.30CT Round Cut Lab Grown Diamonds - Stud Earrings in Silver",
   "url": "/products/0-30ct-round-cut-lab-grown-diamonds-stud-earrings-in-silver",
   "handle": "0-30ct-round-cut-lab-grown-diamonds-stud-earrings-in-silver",
   "priceNow": 203.99,
   "priceWas": 623.99,
   "pctOff": 67,
   "core": null,
   "inStock": true,
   "createdAt": "2023-12-21T18:11:51Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/15415LB_w1_0f1cdc36-f203-4669-9648-cde1dcc21f87.jpg?v=1703182580"
   },
   "carat": 0.3
  },
  {
   "rank": 22,
   "id": "gid://shopify/Product/7330473672888",
   "title": "0.60-5.00 CT Round Cut Lab Grown Diamonds - Stud Earrings",
   "url": "/products/0-60-5-00-ct-round-cut-lab-grown-diamonds-stud-earrings-71197lb",
   "handle": "0-60-5-00-ct-round-cut-lab-grown-diamonds-stud-earrings-71197lb",
   "priceNow": 1200.99,
   "priceWas": 3720.0,
   "pctOff": 68,
   "core": "71197",
   "inStock": true,
   "createdAt": "2023-10-20T09:20:31Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1eMtcppX8W6kshvt2Yd2eEdlvhGxsVJts",
      "b": "https://lh3.googleusercontent.com/d/1MCWxqORoB82tRUVkUXBtwZq6CmJ_nNCa",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1lxGynrcyWCgNXLgI7E_AOS9rt7w6S7jt",
      "b": "https://lh3.googleusercontent.com/d/1FYPlkt7mbn2_YV_B5QPPpsIsfozN0FsX",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/10o5aNZHonR8YXzUxpjmtt1aB8sfbJ7vY",
      "b": "https://lh3.googleusercontent.com/d/1XFnTTuTtsMS-8uy2TuVhWqnVIyI3iCvp",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-round-cut-lab-grown-diamonds-stud-earrings-218982.jpg?v=1698786142"
   },
   "carat": 0.6,
   "caratMax": 5.0
  },
  {
   "rank": 23,
   "id": "gid://shopify/Product/7304057815224",
   "title": "1.75-7.25 CT Round Cut Lab Grown Diamonds - Three Stone Rings",
   "url": "/products/1-75-4-25-ct-round-cut-lab-grown-diamonds-three-stone-ring-15313lb",
   "handle": "1-75-4-25-ct-round-cut-lab-grown-diamonds-three-stone-ring-15313lb",
   "priceNow": 2034.99,
   "priceWas": 6310.0,
   "pctOff": 68,
   "core": "15313",
   "inStock": true,
   "createdAt": "2023-08-01T23:59:51Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1wIkyiXFgdVYQOtpaB33XRNkn9nfZxLF_",
      "b": "https://lh3.googleusercontent.com/d/1iT_ySP2UBA4UYriaNO3hLXfPn-XVfkx3",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1gsnlA5cxz9lFFFMYT2QqHxC-mH8x2uV8",
      "b": "https://lh3.googleusercontent.com/d/18kIJ7Z9wgMh1M3PyRXsUw4E5Kk5GgZDR",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1YQVGRIK8nfgWjjSmRLLijiQ_bH53vRZB",
      "b": "https://lh3.googleusercontent.com/d/114_jwiyIemGMrmZmqDRShXhppt-uv_ti",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/175-425-ct-round-cut-lab-grown-diamonds-three-stone-ring-861114.jpg?v=1763766474"
   },
   "carat": 1.75,
   "caratMax": 7.25
  },
  {
   "rank": 24,
   "id": "gid://shopify/Product/7301365399736",
   "title": "0.50-6.00 CT Round Cut Lab Grown Diamonds - Solitaire Pendant",
   "url": "/products/0-50-3-00-ct-round-cut-lab-grown-diamonds-solitaire-pendant-102690rdlb",
   "handle": "0-50-3-00-ct-round-cut-lab-grown-diamonds-solitaire-pendant-102690rdlb",
   "priceNow": 1106.99,
   "priceWas": 3430.0,
   "pctOff": 68,
   "core": "102690",
   "inStock": true,
   "createdAt": "2023-07-13T22:11:40Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1u2BL4RbwVrafM-VwBgck1lrA1WRI-WKV",
      "b": "https://lh3.googleusercontent.com/d/1udW0FvvZlmSxcO2itIjUBBn51x2VdGxz",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1-0b-VkMEhCfdrI7Csp_eaaxppFHX8C6N",
      "b": "https://lh3.googleusercontent.com/d/1mWDu5MKSLP_UjNqEDq1xmwEEJPFahpTT",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1-PLqcq_7KTDGMtsmNwMPlafcVFUoHOLZ",
      "b": "https://lh3.googleusercontent.com/d/1XyVv1xKMs2O_gio934bEJ4tCWmJqXEH2",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-round-cut-lab-grown-diamonds-solitaire-pendant-882207.jpg?v=1697640146"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 25,
   "id": "gid://shopify/Product/10151565689016",
   "title": "2.20-5.20 CT Emerald & Princess Cut Fancy Blue Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-15231bl",
   "handle": "engagement-rings-15231bl",
   "priceNow": 2126.99,
   "priceWas": 6140.0,
   "pctOff": 65,
   "core": "15231",
   "inStock": true,
   "createdAt": "2025-11-26T00:23:51Z",
   "shape": "princess",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1lQ6jfQzUNzqQUIRfQJqtlv57DFaGauiS",
      "b": "https://lh3.googleusercontent.com/d/1Ouz9ByhrsIsyBT0NhROpyfmkhPuKC7_H",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1DXIDSL42Bqld7KcFhNGQShQxnWJ-IO8r",
      "b": "https://lh3.googleusercontent.com/d/159IN5CNgsfy5rhFOSLsTR8FrhaUnhynr",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1oan6gFQB7KVWhIAxdfza0UoFG41BzLU_",
      "b": "https://lh3.googleusercontent.com/d/12CKA_DujR50KL08Ycd2J7CXbtr5Y88mG",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/images7_3fccc1f8-4255-43f6-aba8-edc8023a5b1c.png?v=1768437906"
   },
   "carat": 2.2,
   "caratMax": 5.2,
   "fancyColor": "blue"
  },
  {
   "rank": 26,
   "id": "gid://shopify/Product/7641271173304",
   "title": "2.10-7.60 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-15332lb",
   "handle": "bridal-sets-15332lb",
   "priceNow": 3306.99,
   "priceWas": 10250.0,
   "pctOff": 68,
   "core": "15332",
   "inStock": true,
   "createdAt": "2024-04-26T15:50:59Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1HwDP7pzMQmAJDsnxpdgyy3_fER5-KsL2",
      "b": "https://lh3.googleusercontent.com/d/1NFofrr4zrEI6n6t1QA3C5auS6z7ZxCLK",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1VExtXBr3FRdGy-RM5jDdvafXzn5pHc2n",
      "b": "https://lh3.googleusercontent.com/d/13MdSohlMJrBQOxc3o474rYXtKftLNXwf",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1l8gSkVgxPKm8s_-DSPm_2LhaK6C5kUI7",
      "b": "https://lh3.googleusercontent.com/d/1YRv888wDe5oEupe0E2cLbJfd1kynITGB",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_dc9a99ee-e006-4c90-9bf7-2c962d68711f.jpg?v=1714149981"
   },
   "carat": 2.1,
   "caratMax": 7.6
  },
  {
   "rank": 27,
   "id": "gid://shopify/Product/7613666263224",
   "title": "1.70-7.20 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-16049lb",
   "handle": "engagement-rings-16049lb",
   "priceNow": 2667.99,
   "priceWas": 8270.0,
   "pctOff": 68,
   "core": "16049",
   "inStock": true,
   "createdAt": "2024-04-22T15:44:45Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1_26Jiw6RasFV-vHaiMy3mTGaQc8JzFEZ",
      "b": "https://lh3.googleusercontent.com/d/17g3CoMH2EJrnT61ASZnaxYNTL_u96VAr",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1QGhWcsjpXuzAa4Ic1gPfAtW2HLUjrIY3",
      "b": "https://lh3.googleusercontent.com/d/1ac3P-UU0CtE2dUVzqK89oPBHYUhUKdpt",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1qV8yXy4ZU0iuC66LKIy2jMx42Dbyor80",
      "b": "https://lh3.googleusercontent.com/d/1ukV8K9FGBZXMfMf8PF1TQU2lKx02A-qK",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_17a35098-5f71-415e-ad37-7d68733a4c7c.jpg?v=1765415419"
   },
   "carat": 1.7,
   "caratMax": 7.2
  },
  {
   "rank": 28,
   "id": "gid://shopify/Product/7601926176952",
   "title": "1.30-6.80 CT Princess Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-15233lb",
   "handle": "engagement-rings-15233lb",
   "priceNow": 1779.99,
   "priceWas": 5520.0,
   "pctOff": 68,
   "core": "15233",
   "inStock": true,
   "createdAt": "2024-04-19T15:29:35Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1HXBXbzL1GJxsng9Pnoa19vWPJnSBt9Qf",
      "b": "https://lh3.googleusercontent.com/d/1_P7dH7KIY4S7clXL3FFCehcW0UdAPlBZ",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1rvC1bgyfq_aaqCM_aSBoASjohs8zGID5",
      "b": "https://lh3.googleusercontent.com/d/1ziEMMer2-i6YdrwxZ5s1yOjt5X7b6WvX",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1iBBDZZFzCSqdjA0ZECypbCk5TVLD41FF",
      "b": "https://lh3.googleusercontent.com/d/1xW-2oH02CW-THZJAj2VLk0zODzM9KoqM",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_9964b640-90b5-4498-81dd-623c1ffe1f46.jpg?v=1765414861"
   },
   "carat": 1.3,
   "caratMax": 6.8
  },
  {
   "rank": 29,
   "id": "gid://shopify/Product/7305710665912",
   "title": "0.90-6.40 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/0-90-3-40-ct-round-princess-cut-lab-grown-diamonds-bridal-set-21059lb",
   "handle": "0-90-3-40-ct-round-princess-cut-lab-grown-diamonds-bridal-set-21059lb",
   "priceNow": 1787.99,
   "priceWas": 5540.0,
   "pctOff": 68,
   "core": "21059",
   "inStock": true,
   "createdAt": "2023-08-11T22:38:11Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/090-340-ct-round-princess-cut-lab-grown-diamonds-bridal-set-437998.jpg?v=1714675359",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/090-340-ct-round-princess-cut-lab-grown-diamonds-bridal-set-437998.jpg?v=1714675359",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/090-340-ct-round-princess-cut-lab-grown-diamonds-bridal-set-505334.jpg?v=1763699363",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/090-340-ct-round-princess-cut-lab-grown-diamonds-bridal-set-824935.jpg?v=1763699363"
    }
   },
   "carat": 0.9,
   "caratMax": 6.4
  },
  {
   "rank": 30,
   "id": "gid://shopify/Product/7305326461112",
   "title": "1.20-6.70 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-20-3-70-ct-round-cut-lab-grown-diamonds-bridal-set-21036lb",
   "handle": "1-20-3-70-ct-round-cut-lab-grown-diamonds-bridal-set-21036lb",
   "priceNow": 1987.99,
   "priceWas": 6160.0,
   "pctOff": 68,
   "core": "21036",
   "inStock": true,
   "createdAt": "2023-08-09T22:38:20Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/120-370-ct-round-cut-lab-grown-diamonds-bridal-set-839857.jpg?v=1714675514",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/120-370-ct-round-cut-lab-grown-diamonds-bridal-set-839857.jpg?v=1714675514",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/120-370-ct-round-cut-lab-grown-diamonds-bridal-set-823004.jpg?v=1763699521",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/120-370-ct-round-cut-lab-grown-diamonds-bridal-set-896795.jpg?v=1763699521"
    }
   },
   "carat": 1.2,
   "caratMax": 6.7
  },
  {
   "rank": 31,
   "id": "gid://shopify/Product/7304057880760",
   "title": "1.50-7.00 CT Princess Cut Lab Grown Diamonds - Three Stone Rings",
   "url": "/products/1-50-4-00-ct-princess-cut-lab-grown-diamonds-three-stone-ring-15330lb",
   "handle": "1-50-4-00-ct-princess-cut-lab-grown-diamonds-three-stone-ring-15330lb",
   "priceNow": 1928.99,
   "priceWas": 5980.0,
   "pctOff": 68,
   "core": "15330",
   "inStock": true,
   "createdAt": "2023-08-02T00:00:02Z",
   "shape": "princess",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1f0X0bTJceiKl8NAVLRPT7QejIfsB5nj6",
      "b": "https://lh3.googleusercontent.com/d/1hD47s31cnG3dr70Ge1m0mPSkmrbBsUK5",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1h6lTxGpn8guYFKB0OEF7qpH04hIYjSPe",
      "b": "https://lh3.googleusercontent.com/d/15MeVRnCA154hFDE0OH4-Or7BpYab696b",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1n35yM4wXvIAraB-RmX41Kkzq30e0EBSc",
      "b": "https://lh3.googleusercontent.com/d/1mywT1_zgygGqVAH5CRRFsngmH63PIBKE",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/150-400-ct-princess-cut-lab-grown-diamonds-three-stone-ring-609419.jpg?v=1763766481"
   },
   "carat": 1.5,
   "caratMax": 7.0
  },
  {
   "rank": 32,
   "id": "gid://shopify/Product/7303609876664",
   "title": "1.55-7.05 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/1-55-4-05-ct-round-princess-cut-lab-grown-diamonds-engagement-ring-15686lb",
   "handle": "1-55-4-05-ct-round-princess-cut-lab-grown-diamonds-engagement-ring-15686lb",
   "priceNow": 2333.99,
   "priceWas": 7240.0,
   "pctOff": 68,
   "core": "15686",
   "inStock": true,
   "createdAt": "2023-07-28T19:23:35Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1wDDH4taTv3wHh6naAiTMoJOdlBRBcXeJ",
      "b": "https://lh3.googleusercontent.com/d/1rf1AGBrkb3Anf6UW-OIDxF4bNmt3REy1",
      "angles": [
       5,
       6
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1BPlhJixVq6dcjMyxppDnS8HP7jbZpDqy",
      "b": "https://lh3.googleusercontent.com/d/1EvJWKtkL0X2dZjjSF9g0UKMsZAmc4dIl",
      "angles": [
       5,
       6
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1OWbYYvkyYIjjrK4ouG6-GGjPvirkqn8H",
      "b": "https://lh3.googleusercontent.com/d/1wfmQ7ctMOwQ7dMmtnP_enqyEjsdaQ-QU",
      "angles": [
       5,
       6
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/155-405-ct-round-princess-cut-lab-grown-diamonds-engagement-ring-101083.jpg?v=1765415315"
   },
   "carat": 1.55,
   "caratMax": 7.05
  },
  {
   "rank": 33,
   "id": "gid://shopify/Product/7301496438968",
   "title": "0.50-6.00 CT Round Cut Lab Grown Diamonds - Solitaire Pendant",
   "url": "/products/0-50-3-00-ct-round-cut-lab-grown-diamonds-solitaire-pendant-15504rdlb",
   "handle": "0-50-3-00-ct-round-cut-lab-grown-diamonds-solitaire-pendant-15504rdlb",
   "priceNow": 968.99,
   "priceWas": 3200.0,
   "pctOff": 70,
   "core": "15504",
   "inStock": true,
   "createdAt": "2023-07-14T19:34:58Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-round-cut-lab-grown-diamonds-solitaire-pendant-731301.jpg?v=1697640146"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 34,
   "id": "gid://shopify/Product/7300738777272",
   "title": "2.50-6.00 CT Round Cut Lab Grown Diamonds - Eternity Rings",
   "url": "/products/2-50-6-00-ct-round-cut-lab-grown-diamonds-eternity-ring-71731lb",
   "handle": "2-50-6-00-ct-round-cut-lab-grown-diamonds-eternity-ring-71731lb",
   "priceNow": 1751.99,
   "priceWas": 5430.0,
   "pctOff": 68,
   "core": "71731",
   "inStock": true,
   "createdAt": "2023-07-10T18:12:55Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1RdRVrvP8xX5OvMJHAKhSDzhKbf7lqoL1",
      "b": "https://lh3.googleusercontent.com/d/1t0vkZWg21XRRHSpas0JmRFO-ilMWnoH5",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/14Zq98jHOF_jRyLh0DB_8bc1tBkBvsLtx",
      "b": "https://lh3.googleusercontent.com/d/1JWr26chJCMhdsPjIRaE6YQ5VfHUQBfTV",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Os2ckkHi5R3Nc3tSejwgydEEztSMrjOe",
      "b": "https://lh3.googleusercontent.com/d/1CHFV5A1RdoXBUpzaya7IwOKB9TrAZAbL",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/250-600-ct-round-cut-lab-grown-diamonds-eternity-ring-102753.jpg?v=1697640168"
   },
   "carat": 2.5,
   "caratMax": 6.0
  },
  {
   "rank": 35,
   "id": "gid://shopify/Product/7300093870264",
   "title": "4.00-7.00 CT Emerald Cut Lab Grown Diamonds - Eternity Rings",
   "url": "/products/4-00-7-00-ct-emerald-cut-lab-grown-diamonds-eternity-ring-71716lb",
   "handle": "4-00-7-00-ct-emerald-cut-lab-grown-diamonds-eternity-ring-71716lb",
   "priceNow": 2511.99,
   "priceWas": 7790.0,
   "pctOff": 68,
   "core": "71716",
   "inStock": true,
   "createdAt": "2023-07-05T15:32:30Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1ZWsSPca4XeEzzdR4MfpOVMLNy76e5CPw",
      "b": "https://lh3.googleusercontent.com/d/1w1Lhs25m3_V3NLhmsgQGFf5R6H_eQjQU",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1YS84ELDLfnA7QbNNXe9A9WfHIUwNi7n6",
      "b": "https://lh3.googleusercontent.com/d/19VsMo1jbTVt_C5ZfOwNljX09zPUPooX_",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1m4ziMurLEVzagf2QgBob9UZShqX-UWvt",
      "b": "https://lh3.googleusercontent.com/d/1BBCBUdUjdw1ezeN83Nkc50B36Bfr5V8x",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/400-700-ct-emerald-cut-diamonds-eternity-ring-471324.jpg?v=1697633495"
   },
   "carat": 4.0,
   "caratMax": 7.0
  },
  {
   "rank": 36,
   "id": "gid://shopify/Product/7300093837496",
   "title": "2.00-6.00 CT Round Cut Lab Grown Diamonds - Eternity Rings",
   "url": "/products/2-00-6-00-ct-round-cut-lab-grown-diamonds-eternity-ring-71722lb",
   "handle": "2-00-6-00-ct-round-cut-lab-grown-diamonds-eternity-ring-71722lb",
   "priceNow": 1357.99,
   "priceWas": 4210.0,
   "pctOff": 68,
   "core": "71722",
   "inStock": true,
   "createdAt": "2023-07-05T15:32:14Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1BqKmxmVsvQkwHwjhFsORuNBn3xcI_gaJ",
      "b": "https://lh3.googleusercontent.com/d/1x5vzhOgniEp1qtlrVGKZqWvEhRkYM3VA",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1GNrWfjlV0tNYbGClkLT_gbimVqe5sjcb",
      "b": "https://lh3.googleusercontent.com/d/1tQ1WWz7l95bnas6K9KkkpEuUUek2OkeX",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1b0Bf0SaWvqH26Gb-YEj7s3d3LWHVxCwL",
      "b": "https://lh3.googleusercontent.com/d/1rUEgHEAbXzwnB4Ej2lHmazm3Yg3wc5Se",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-600-ct-round-cut-lab-grown-diamonds-eternity-ring-110395.jpg?v=1698240601"
   },
   "carat": 2.0,
   "caratMax": 6.0
  },
  {
   "rank": 37,
   "id": "gid://shopify/Product/9121636188344",
   "title": "0.85-6.35 CT Emerald & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-21102lbem",
   "handle": "engagement-rings-21102lbem",
   "priceNow": 1499.99,
   "priceWas": 4650.0,
   "pctOff": 68,
   "core": "21102",
   "inStock": true,
   "createdAt": "2024-06-12T17:54:53Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_b279cabb-4599-4551-988c-d774a88ed435.jpg?v=1765415411",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_b279cabb-4599-4551-988c-d774a88ed435.jpg?v=1765415411",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y2_8b673a82-5b19-48dd-a979-64549b9cb675.jpg?v=1765415414",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r2_317e5b45-7576-405f-ad4a-1882f8c62aff.jpg?v=1765415416"
    }
   },
   "carat": 0.85,
   "caratMax": 6.35
  },
  {
   "rank": 38,
   "id": "gid://shopify/Product/9078363095224",
   "title": "0.50-6.00 CT Princess Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-15412lb",
   "handle": "solitaire-rings-15412lb",
   "priceNow": 1620.99,
   "priceWas": 5030.0,
   "pctOff": 68,
   "core": "15412",
   "inStock": true,
   "createdAt": "2024-05-28T17:02:33Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/11Ye8f1Yt66ZnsoTrXwgp8hOmn_NxUzHG",
      "b": "https://lh3.googleusercontent.com/d/1bBAmVRvqX4dRsI2T8J9tY4dMHddWBTTH",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1IifRvNvauEnvwSIxKiw1XD6FFHGlcvfv",
      "b": "https://lh3.googleusercontent.com/d/1xolgweqsRNoYDBMwVhf64yZRq8vOniLK",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/167Rdlx-Gj7Ir8oIj-3hZ1SmrFMw2-zdu",
      "b": "https://lh3.googleusercontent.com/d/1UhEEXZawEJ_LjHEag5DcIISxpbH2ymNC",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold2_Diamond_08d63572-aaed-49c8-83b1-75bfa50a6649.jpg?v=1763748625"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 39,
   "id": "gid://shopify/Product/9077562704056",
   "title": "0.80 CT Round Cut Lab Grown Diamonds - Mens Wedding Bands",
   "url": "/products/mens-wedding-bands-15662lb",
   "handle": "mens-wedding-bands-15662lb",
   "priceNow": 1785.99,
   "priceWas": 5540.0,
   "pctOff": 68,
   "core": "15662",
   "inStock": true,
   "createdAt": "2024-05-28T10:40:21Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_fcaf57ac-dba0-4555-a1d8-aff06ca6654e.jpg?v=1717005926",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_fcaf57ac-dba0-4555-a1d8-aff06ca6654e.jpg?v=1717005926",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y3_dadc58c9-7a89-47aa-8b2e-86332dfb6ae0.jpg?v=1763697807",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r3_2fa1d77c-92c0-444b-a5f7-90e98df56c54.jpg?v=1763697806"
    }
   },
   "carat": 0.8
  },
  {
   "rank": 40,
   "id": "gid://shopify/Product/7664254189752",
   "title": "1.15-6.65 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110338lb",
   "handle": "bridal-sets-110338lb",
   "priceNow": 3093.99,
   "priceWas": 9590.0,
   "pctOff": 68,
   "core": "110338",
   "inStock": true,
   "createdAt": "2024-04-30T15:38:13Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1Jiazto4Zps3dqnhjMoS45C8jLwG_qUxa",
      "b": "https://lh3.googleusercontent.com/d/1UZtx2z4W-W0-ZG-hiaGhatZ3LfkSjGeQ",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1XFPslFUvpH7vZjbB0X2xVHHHvzeKaQAK",
      "b": "https://lh3.googleusercontent.com/d/16-6-0KX4ahg1dV_NaOlSWQJQ9CB3nyhI",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1CZJBm_m0aZey_8mVfgjqt8RffN5XIrKQ",
      "b": "https://lh3.googleusercontent.com/d/1O4neeHW-5lsZL8CVfQV99a9HwHVCwhGw",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_52363dc3-007a-437d-ab7c-1d4535997d55.jpg?v=1714497055"
   },
   "carat": 1.15,
   "caratMax": 6.65
  },
  {
   "rank": 41,
   "id": "gid://shopify/Product/7485706666168",
   "title": "0.30 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-110353lb",
   "handle": "wedding-bands-110353lb",
   "priceNow": 948.99,
   "priceWas": 3230.0,
   "pctOff": 71,
   "core": "110353",
   "inStock": true,
   "createdAt": "2024-03-13T16:27:07Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1aKE1GqXvuxvMcZAMgt6Pmh09SW6e1HBk",
      "b": "https://lh3.googleusercontent.com/d/1YWcDtLvu4F8JJZz2sQn1HvOCBA-fVEUT",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1x_ZrpX624tNpwDFnxvznbMCamcIJhqmj",
      "b": "https://lh3.googleusercontent.com/d/1vYxzHoA9oHc90DQ2Fl9AGmIqNiJzao6z",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1DS4Q_se4C3gtZFKkDDIAc72BhdR9dFfE",
      "b": "https://lh3.googleusercontent.com/d/115VG5Hkz_8wCJogJGBdKXFZ73FoQPGR6",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_aa9eb675-af4c-43a9-b71a-2851c8f1a580.jpg?v=1710347418"
   },
   "carat": 0.3
  },
  {
   "rank": 42,
   "id": "gid://shopify/Product/7485704765624",
   "title": "2.00 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-15274lb",
   "handle": "wedding-bands-15274lb",
   "priceNow": 1692.99,
   "priceWas": 5250.0,
   "pctOff": 68,
   "core": "15274",
   "inStock": true,
   "createdAt": "2024-03-13T16:25:30Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1J90haBLNE738KLuu7Nq1cwLkntodxtFi",
      "b": "https://lh3.googleusercontent.com/d/1DXEbqcDjEgRt5c9InpCkUOSTqXVHSQgX",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1H9BJL0UodxXevVhfVJHqsmEwkBnljJxv",
      "b": "https://lh3.googleusercontent.com/d/1vXCjzwt0gTJoedtBMoKZk6Wwu6BtyB2a",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1WSj_4Old5bmpwufOi_gWk0GgPXY5Jw3l",
      "b": "https://lh3.googleusercontent.com/d/1YhvDjwGSKB_x_ZVtKM6ZBOugg2SrUaSP",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_03457330-b3c0-4311-91ab-e6382b3067b7.jpg?v=1763698994"
   },
   "carat": 2.0
  },
  {
   "rank": 43,
   "id": "gid://shopify/Product/7330474655928",
   "title": "0.70-5.10 CT Round Cut Lab Grown Diamonds - Stud Earrings",
   "url": "/products/0-70-5-10-ct-round-cut-lab-grown-diamonds-stud-earrings-71900lb",
   "handle": "0-70-5-10-ct-round-cut-lab-grown-diamonds-stud-earrings-71900lb",
   "priceNow": 1368.99,
   "priceWas": 4240.0,
   "pctOff": 68,
   "core": "71900",
   "inStock": true,
   "createdAt": "2023-10-20T09:21:19Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1nFQ4g2juJ7RjDFbCK0lCvVM2tCwDVr5t",
      "b": "https://lh3.googleusercontent.com/d/1JhLVhV7hRzvwTg9JMjKodBEqoNd8jgz0",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1ANzZCSha6D6V0-IRQw-y6jov2-O9Pi9O",
      "b": "https://lh3.googleusercontent.com/d/1pa44m1mgym7KT2jbPPY7rLASCSInHcKh",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ff_qr-Yra43IiYbXwMn9sXsjNfymwFwv",
      "b": "https://lh3.googleusercontent.com/d/1GDNVYGvt4NRydKQttH70ZJJWyky4O2ES",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/070-510-ct-round-cut-lab-grown-diamonds-stud-earrings-118780.jpg?v=1705958370"
   },
   "carat": 0.7,
   "caratMax": 5.1
  },
  {
   "rank": 44,
   "id": "gid://shopify/Product/7328604258488",
   "title": "0.60-5.00 CT Round Cut Lab Grown Diamonds - Stud Earrings",
   "url": "/products/0-60-5-00-ct-round-cut-lab-grown-diamonds-stud-earrings-15417lb",
   "handle": "0-60-5-00-ct-round-cut-lab-grown-diamonds-stud-earrings-15417lb",
   "priceNow": 1062.99,
   "priceWas": 3300.0,
   "pctOff": 68,
   "core": "15417",
   "inStock": true,
   "createdAt": "2023-10-19T09:09:42Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1ktqLheKxW970T6nwGWAX0tSqC-J_V_Zi",
      "b": "https://lh3.googleusercontent.com/d/1rzd-JLvSRvylRfWDiCZ3XX6PFXnZqH7I",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1Bq70S-wYDgfzlzBFNAy7RhCimp4QpgGK",
      "b": "https://lh3.googleusercontent.com/d/1gxTTOtz7c8NxTqusN2b_syJ1QxoOq9S3",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1uqdmyuXs4zumaIDvNBsFSTO_3fZ5lK8C",
      "b": "https://lh3.googleusercontent.com/d/10G-26A-GD9RzspP9mRucRxlhzGx6bFZt",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-round-cut-lab-grown-diamonds-stud-earrings-541993.jpg?v=1698786142"
   },
   "carat": 0.6,
   "caratMax": 5.0
  },
  {
   "rank": 45,
   "id": "gid://shopify/Product/7305710272696",
   "title": "0.90-6.40 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/0-90-3-40-ct-round-princess-cut-lab-grown-diamonds-bridal-set-21054lb",
   "handle": "0-90-3-40-ct-round-princess-cut-lab-grown-diamonds-bridal-set-21054lb",
   "priceNow": 1724.99,
   "priceWas": 5350.0,
   "pctOff": 68,
   "core": "21054",
   "inStock": true,
   "createdAt": "2023-08-11T22:37:18Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/090-340-ct-round-princess-cut-lab-grown-diamonds-bridal-set-687807.jpg?v=1714760268",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/090-340-ct-round-princess-cut-lab-grown-diamonds-bridal-set-687807.jpg?v=1714760268",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/090-340-ct-round-princess-cut-lab-grown-diamonds-bridal-set-844504.jpg?v=1763699363",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/090-340-ct-round-princess-cut-lab-grown-diamonds-bridal-set-843452.jpg?v=1763699363"
    }
   },
   "carat": 0.9,
   "caratMax": 6.4
  },
  {
   "rank": 46,
   "id": "gid://shopify/Product/7304432255160",
   "title": "2.10-7.60 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/2-10-4-60-ct-round-cut-lab-grown-diamonds-bridal-set-21019lb",
   "handle": "2-10-4-60-ct-round-cut-lab-grown-diamonds-bridal-set-21019lb",
   "priceNow": 2961.99,
   "priceWas": 9180.0,
   "pctOff": 68,
   "core": "21019",
   "inStock": true,
   "createdAt": "2023-08-04T00:16:47Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/210-460-ct-round-cut-lab-grown-diamonds-bridal-set-131687.jpg?v=1714675619",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/210-460-ct-round-cut-lab-grown-diamonds-bridal-set-131687.jpg?v=1714675619",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/210-460-ct-round-cut-lab-grown-diamonds-bridal-set-813177.jpg?v=1763699564",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/210-460-ct-round-cut-lab-grown-diamonds-bridal-set-548004.jpg?v=1763699564"
    }
   },
   "carat": 2.1,
   "caratMax": 7.6
  },
  {
   "rank": 47,
   "id": "gid://shopify/Product/7303610204344",
   "title": "1.10-6.60 CT Princess Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/1-10-3-60-ct-princess-cut-lab-grown-diamonds-engagement-ring-15655lb",
   "handle": "1-10-3-60-ct-princess-cut-lab-grown-diamonds-engagement-ring-15655lb",
   "priceNow": 1752.99,
   "priceWas": 5430.0,
   "pctOff": 68,
   "core": "15655",
   "inStock": true,
   "createdAt": "2023-07-28T19:24:14Z",
   "shape": "princess",
   "origin": "lab",
   "rating": 4.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1r8wGeAe9Ti_7K19SbGZf-hq1n8DjZ6nl",
      "b": "https://lh3.googleusercontent.com/d/18mgZxKqVtfgavrmUt9pVFckkHfDUZDGj",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1yjLb8jRoWYt2SUXcxwtyBlGEBVPxa4f4",
      "b": "https://lh3.googleusercontent.com/d/1U9cL-PX-Z-_ndfq1TT7NCJMQieDzxuE_",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1WZPQVAokvEATyjNJBrb1V3XHsmM7EfPL",
      "b": "https://lh3.googleusercontent.com/d/1s4bmZ7HR6jT544BygQrB5n8fbYenj-qQ",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/110-360-ct-princess-cut-lab-grown-diamonds-engagement-ring-706334.jpg?v=1765415289"
   },
   "carat": 1.1,
   "caratMax": 6.6
  },
  {
   "rank": 48,
   "id": "gid://shopify/Product/7303236059320",
   "title": "1.35-6.85 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/1-35-3-85-ct-princess-round-cut-lab-grown-diamonds-engagement-ring-71864lb",
   "handle": "1-35-3-85-ct-princess-round-cut-lab-grown-diamonds-engagement-ring-71864lb",
   "priceNow": 1686.99,
   "priceWas": 5230.0,
   "pctOff": 68,
   "core": "71864",
   "inStock": true,
   "createdAt": "2023-07-26T21:57:44Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1NvBOaQWfEZbNEcM0c_1aY_nXvFMi2-fl",
      "b": "https://lh3.googleusercontent.com/d/1lyuFB5Igb7cKG_jACUTDSxmJAaDfnvk3",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1E9Q0lJHPhx1h5NMk0A4QxkRD_0HmWF4a",
      "b": "https://lh3.googleusercontent.com/d/12iPETjUwa4T6ds0GLf69TG0bqeMOxUGD",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1kmsMBBLkvrS32yUWZEDXFv-fa34wX27V",
      "b": "https://lh3.googleusercontent.com/d/1OfjLhH9GXYEJqfAIGLQYSamhvxtesHmU",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/135-385-ct-princess-round-cut-lab-grown-diamonds-engagement-ring-116111.jpg?v=1714499075"
   },
   "carat": 1.35,
   "caratMax": 6.85
  },
  {
   "rank": 49,
   "id": "gid://shopify/Product/7302629261496",
   "title": "2.00-10.00 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/2-00-10-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-407950lb",
   "handle": "2-00-10-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-407950lb",
   "priceNow": 3136.99,
   "priceWas": 9720.0,
   "pctOff": 68,
   "core": "407950",
   "inStock": true,
   "createdAt": "2023-07-20T22:12:07Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-1000-ct-round-cut-lab-grown-diamonds-tennis-bracelet-142167.jpg?v=1705354263",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-1000-ct-round-cut-lab-grown-diamonds-tennis-bracelet-142167.jpg?v=1705354263",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-1000-ct-round-cut-lab-grown-diamonds-tennis-bracelet-255579.jpg?v=1763699897",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-1000-ct-round-cut-lab-grown-diamonds-tennis-bracelet-895328.jpg?v=1763699898"
    }
   },
   "carat": 2.0,
   "caratMax": 10.0
  },
  {
   "rank": 50,
   "id": "gid://shopify/Product/7301458002104",
   "title": "0.50-6.00 CT Radiant Cut Lab Grown Diamonds - Solitaire Pendant",
   "url": "/products/0-50-3-00-ct-radiant-cut-lab-grown-diamonds-solitaire-pendant-102676ralb",
   "handle": "0-50-3-00-ct-radiant-cut-lab-grown-diamonds-solitaire-pendant-102676ralb",
   "priceNow": 1025.99,
   "priceWas": 3180.0,
   "pctOff": 68,
   "core": "102676",
   "inStock": true,
   "createdAt": "2023-07-14T18:21:22Z",
   "shape": "radiant",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1rsa2R-gvKZPisip1rKrYTmGOGYZh9QcT",
      "b": "https://lh3.googleusercontent.com/d/1tDT-AG1rCXAhoROzxT1LKwIYhW4vHSw9",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1RlZfF78VgJcFLMz8P2JDORrHq8oAaSnR",
      "b": "https://lh3.googleusercontent.com/d/1i6oGRzdUfIo5aGaD4HqjW2UasmmXdBUy",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1EXQrfaZtrMNVMXthx8wbO4eP6eYFXr3u",
      "b": "https://lh3.googleusercontent.com/d/1PUN79_8gQcR471SnZWZXkFw9FFpCE25N",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-radiant-cut-lab-grown-diamonds-solitaire-pendant-803389.jpg?v=1697640146"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 51,
   "id": "gid://shopify/Product/7301457838264",
   "title": "0.50-6.00 CT Round Cut Lab Grown Diamonds - Solitaire Pendant",
   "url": "/products/0-50-3-00-ct-round-cut-lab-grown-diamonds-solitaire-pendant-102676rdlb",
   "handle": "0-50-3-00-ct-round-cut-lab-grown-diamonds-solitaire-pendant-102676rdlb",
   "priceNow": 968.99,
   "priceWas": 3200.0,
   "pctOff": 70,
   "core": "102676",
   "inStock": true,
   "createdAt": "2023-07-14T18:20:08Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1rsa2R-gvKZPisip1rKrYTmGOGYZh9QcT",
      "b": "https://lh3.googleusercontent.com/d/1tDT-AG1rCXAhoROzxT1LKwIYhW4vHSw9",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1RlZfF78VgJcFLMz8P2JDORrHq8oAaSnR",
      "b": "https://lh3.googleusercontent.com/d/1i6oGRzdUfIo5aGaD4HqjW2UasmmXdBUy",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1EXQrfaZtrMNVMXthx8wbO4eP6eYFXr3u",
      "b": "https://lh3.googleusercontent.com/d/1PUN79_8gQcR471SnZWZXkFw9FFpCE25N",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-round-cut-lab-grown-diamonds-solitaire-pendant-897044.jpg?v=1697640146"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 52,
   "id": "gid://shopify/Product/7301071569080",
   "title": "3.00-7.20 CT Round Cut Lab Grown Diamonds - Eternity Rings",
   "url": "/products/3-00-7-20-ct-round-cut-lab-grown-diamonds-eternity-ring-71706lb",
   "handle": "3-00-7-20-ct-round-cut-lab-grown-diamonds-eternity-ring-71706lb",
   "priceNow": 2462.99,
   "priceWas": 7640.0,
   "pctOff": 68,
   "core": "71706",
   "inStock": true,
   "createdAt": "2023-07-11T14:57:59Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1bQUqiFpdid03GdwRHqheG2FIGmITf3DM",
      "b": "https://lh3.googleusercontent.com/d/1jCa9-PC4h7_cEZeNAWccomZe9n1gBGH5",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1t4mzNTDr_IsjBGhbTGA8C2Y6372GV-2F",
      "b": "https://lh3.googleusercontent.com/d/1c-KCanBurAuJShHEEhR8-Kr0d5o-rpXq",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1SqZUMQFQws7GHBbXCS8fVLdWqaOVrTJh",
      "b": "https://lh3.googleusercontent.com/d/1lxbc0DhUBC6GEu8dYRFRv_EK7jj7W-jN",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/300-720-ct-round-cut-lab-grown-diamonds-eternity-ring-376575.jpg?v=1697640169"
   },
   "carat": 3.0,
   "caratMax": 7.2
  },
  {
   "rank": 53,
   "id": "gid://shopify/Product/10155925176504",
   "title": "20.00 CT Round Cut Diamonds - Diamond Necklace",
   "url": "/products/20-00-ct-round-cut-diamonds-diamond-necklace",
   "handle": "20-00-ct-round-cut-diamonds-diamond-necklace",
   "priceNow": 7692.99,
   "priceWas": 20475.0,
   "pctOff": 62,
   "core": "30023",
   "inStock": true,
   "createdAt": "2025-11-30T16:52:22Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/WhatsApp_Image_2025-12-01_at_08.41.56_4a7f05b2.jpg?v=1768436769",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/WhatsApp_Image_2025-12-01_at_08.41.56_4a7f05b2.jpg?v=1768436769",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/WhatsApp_Image_2025-12-01_at_08.41.56_38529af7.jpg?v=1768436769"
    }
   },
   "carat": 20.0
  },
  {
   "rank": 54,
   "id": "gid://shopify/Product/10155924390072",
   "title": "15.00 CT Round Cut Diamonds - Diamond Necklace",
   "url": "/products/15-00-ct-round-cut-diamonds-diamond-necklace",
   "handle": "15-00-ct-round-cut-diamonds-diamond-necklace",
   "priceNow": 6630.0,
   "priceWas": 16575.0,
   "pctOff": 60,
   "core": "30022",
   "inStock": true,
   "createdAt": "2025-11-30T16:49:17Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/WhatsApp_Image_2025-12-01_at_08.41.56_4a7f05b2.jpg?v=1768436769",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/WhatsApp_Image_2025-12-01_at_08.41.56_4a7f05b2.jpg?v=1768436769",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/WhatsApp_Image_2025-12-01_at_08.41.56_38529af7.jpg?v=1768436769"
    }
   },
   "carat": 15.0
  },
  {
   "rank": 55,
   "id": "gid://shopify/Product/10155924193464",
   "title": "10.00 CT Round Cut Diamonds - Diamond Necklace",
   "url": "/products/10-00-ct-round-cut-diamonds-diamond-necklace",
   "handle": "10-00-ct-round-cut-diamonds-diamond-necklace",
   "priceNow": 5102.99,
   "priceWas": 14375.0,
   "pctOff": 65,
   "core": "30021",
   "inStock": true,
   "createdAt": "2025-11-30T16:45:28Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/WhatsApp_Image_2025-12-01_at_08.41.56_4a7f05b2.jpg?v=1768436769",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/WhatsApp_Image_2025-12-01_at_08.41.56_4a7f05b2.jpg?v=1768436769",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/WhatsApp_Image_2025-12-01_at_08.41.56_38529af7.jpg?v=1768436769"
    }
   },
   "carat": 10.0
  },
  {
   "rank": 56,
   "id": "gid://shopify/Product/10155899125944",
   "title": "1.20 CT Round Cut Lab Grown Diamonds - Hoop & Drop Earrings",
   "url": "/products/hoop-and-drop-and-earrings-30019lb",
   "handle": "hoop-and-drop-and-earrings-30019lb",
   "priceNow": 1279.99,
   "priceWas": 3970.0,
   "pctOff": 68,
   "core": "30019",
   "inStock": true,
   "createdAt": "2025-11-30T16:05:04Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_5_5e2a72ed-3675-4184-9c0a-9338905dec20.png?v=1768436769",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_5_5e2a72ed-3675-4184-9c0a-9338905dec20.png?v=1768436769",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_041c9b90-89fa-49eb-afda-6e1e2741134d.png?v=1768436768",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_4_aac70b62-f057-45d4-aeda-c4969c081fce.png?v=1768436769"
    }
   },
   "carat": 1.2
  },
  {
   "rank": 57,
   "id": "gid://shopify/Product/10153277653176",
   "title": "4.00 CT Round Cut Lab Grown Diamonds in 14KT White Gold  Stud Earrings",
   "url": "/products/4-00-ct-round-cut-lab-grown-diamonds-in-14kt-white-gold-stud-earrings",
   "handle": "4-00-ct-round-cut-lab-grown-diamonds-in-14kt-white-gold-stud-earrings",
   "priceNow": 1524.99,
   "priceWas": 6035.0,
   "pctOff": 75,
   "core": "400",
   "inStock": true,
   "createdAt": "2025-11-27T23:40:21Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-round-cut-lab-grown-diamonds-stud-earrings-425997.jpg?v=1698786141"
   },
   "carat": 4.0
  },
  {
   "rank": 58,
   "id": "gid://shopify/Product/9264978559160",
   "title": "4.00-7.00 CT Round Cut Lab Grown Diamonds - Hoop & Drop Earrings",
   "url": "/products/hoop-and-drop-earrings-30003lb",
   "handle": "hoop-and-drop-earrings-30003lb",
   "priceNow": 3392.99,
   "priceWas": 10520.0,
   "pctOff": 68,
   "core": "30003",
   "inStock": true,
   "createdAt": "2024-11-28T20:50:48Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1vMxFshwL122-6G-8QV77iR_ma0K4ukGf",
      "b": "https://lh3.googleusercontent.com/d/13mQrAYSvNnRl0de2tc3yDSCuWgNol6Ow",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/16mkKXvUpV5l7Lrs_SNcIHWd9b0xlh5qy",
      "b": "https://lh3.googleusercontent.com/d/1lYiBEvhAyzbOuuIJy8wMQbsAIvf4G0LB",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1o_O7RJGxSh74NPssIRAibRXsd1cRj11k",
      "b": "https://lh3.googleusercontent.com/d/1lB5ZiDfsNEl0_QiCwtkP8UicssotIyP-",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_e1364922-b7ef-4a23-a4df-d00755cc049e.jpg?v=1763993550"
   },
   "carat": 4.0,
   "caratMax": 7.0
  },
  {
   "rank": 59,
   "id": "gid://shopify/Product/9153143799992",
   "title": "1.60-7.10 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-16022lb",
   "handle": "bridal-sets-16022lb",
   "priceNow": 2391.99,
   "priceWas": 7420.0,
   "pctOff": 68,
   "core": "16022",
   "inStock": true,
   "createdAt": "2024-07-05T14:11:56Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1oSrbXmN3JUwO5hlnP7n4HwIS96jZ1bMt",
      "b": "https://lh3.googleusercontent.com/d/1CedQBe6ZDSg6vXcheY4KzPUB5iyxWLEo",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1MZduKq8j1Gf6opY_zvRz0ipTW8ivgPMC",
      "b": "https://lh3.googleusercontent.com/d/1HCZcluiHdf6-W4uSzs8Q5ZZlIluSMyjI",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1A6Saiu8a-F60_AJXBRXFqsY_tMv82lJh",
      "b": "https://lh3.googleusercontent.com/d/1bFRt5YIkC_qQVej8QTptqfIIJMOXFvNT",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold2_DiamondReal_WhiteMatte_0ca1ac42-9661-49db-8430-6adc81b36f8b.jpg?v=1763697575"
   },
   "carat": 1.6,
   "caratMax": 7.1
  },
  {
   "rank": 60,
   "id": "gid://shopify/Product/9121636909240",
   "title": "0.50-6.00 CT Round Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-21103lb",
   "handle": "solitaire-rings-21103lb",
   "priceNow": 1310.99,
   "priceWas": 4060.0,
   "pctOff": 68,
   "core": "21103",
   "inStock": true,
   "createdAt": "2024-06-12T17:56:08Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_fd724572-b7f1-4628-8d02-4de04261aeeb.jpg?v=1763748614"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 61,
   "id": "gid://shopify/Product/9121636253880",
   "title": "0.85-6.35 CT Oval & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-21102lbov",
   "handle": "engagement-rings-21102lbov",
   "priceNow": 1499.99,
   "priceWas": 4650.0,
   "pctOff": 68,
   "core": "21102",
   "inStock": true,
   "createdAt": "2024-06-12T17:54:58Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_523048ea-b7f7-45c3-9cd8-ec47f2b96a3e.jpg?v=1765415409",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_523048ea-b7f7-45c3-9cd8-ec47f2b96a3e.jpg?v=1765415409",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y2_7122e020-c046-4ff6-bbd8-8d06de528b44.jpg?v=1765415411",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r2_4b67611e-55a6-4f21-b909-f0f35abbd3fc.jpg?v=1765415413"
    }
   },
   "carat": 0.85,
   "caratMax": 6.35
  },
  {
   "rank": 62,
   "id": "gid://shopify/Product/9106073190584",
   "title": "2.95-8.45 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-15708lb",
   "handle": "engagement-rings-15708lb",
   "priceNow": 3875.99,
   "priceWas": 12020.0,
   "pctOff": 68,
   "core": "15708",
   "inStock": true,
   "createdAt": "2024-06-05T15:29:26Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1rPUjhpLATqpU2tvRTGuBLL0M_xvjYs7l",
      "b": "https://lh3.googleusercontent.com/d/1_8s_uh7FiNXDBxqoThOASTMt_xnKDELl",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1ubXcOGxe7K0z6Yl5DLUbKKumkoWvweq8",
      "b": "https://lh3.googleusercontent.com/d/1UoVygLhlYuU7K80D17O5eyXPXUC4dJc6",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/17n3dcPOTtBoagjZ8-l-zKex2l6plZ_N4",
      "b": "https://lh3.googleusercontent.com/d/1O6I8sEE350DSmfFNIo6EKu8HpEPh5M1N",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA_3_proba_Perspective_Diamond_Yellow_Gold2_White_Matte_06ae722b-b144-48cf-b677-954303cced40.jpg?v=1765415410"
   },
   "carat": 2.95,
   "caratMax": 8.45
  },
  {
   "rank": 63,
   "id": "gid://shopify/Product/9083406221496",
   "title": "0.80-6.30 CT Emerald & Round Cut Lab Grown Diamonds - Halo Rings",
   "url": "/products/halo-rings-110439lb",
   "handle": "halo-rings-110439lb",
   "priceNow": 1656.99,
   "priceWas": 5140.0,
   "pctOff": 68,
   "core": "110439",
   "inStock": true,
   "createdAt": "2024-05-29T18:18:34Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold2_Diamond_8ed7d85f-9252-4c89-b590-bea532ef48c5.jpg?v=1763697778",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold2_Diamond_8ed7d85f-9252-4c89-b590-bea532ef48c5.jpg?v=1763697778",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold_Diamond_16d6ef8f-f48e-4b06-b7b5-5a511cb9fec6.jpg?v=1763697778",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold1_Diamond_714e32ca-7985-461b-9140-fe3d633da4e0.jpg?v=1763697778"
    }
   },
   "carat": 0.8,
   "caratMax": 6.3
  },
  {
   "rank": 64,
   "id": "gid://shopify/Product/9077559132344",
   "title": "0.65 CT Princess Cut Lab Grown Diamonds - Mens Wedding Bands",
   "url": "/products/mens-wedding-bands-71536lb",
   "handle": "mens-wedding-bands-71536lb",
   "priceNow": 2169.99,
   "priceWas": 6730.0,
   "pctOff": 68,
   "core": "71536",
   "inStock": true,
   "createdAt": "2024-05-28T10:39:36Z",
   "shape": "princess",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_407f3454-39cb-4f69-91ba-6e63c2048724.jpg?v=1716922521"
   },
   "carat": 0.65
  },
  {
   "rank": 65,
   "id": "gid://shopify/Product/7702551691448",
   "title": "1.30-6.80 CT Princess Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-15232lb",
   "handle": "engagement-rings-15232lb",
   "priceNow": 1903.99,
   "priceWas": 5900.0,
   "pctOff": 68,
   "core": "15232",
   "inStock": true,
   "createdAt": "2024-05-20T17:26:10Z",
   "shape": "princess",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1kXi-PoqgepbYcqAXlw5-hb3qUFvUPeOO",
      "b": "https://lh3.googleusercontent.com/d/1l439MpI6xESNfcWEaThdQOH5_h0cxk7V",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1kBM-aEX4BAq6oPHaYsb3WkDQXj-t5M9a",
      "b": "https://lh3.googleusercontent.com/d/1ABNQ4-VHLHS_vOGG6mVEE3K7Z6boeFYz",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1SOZrIw_k37BmtBxKxbc_StwGNqil2Bty",
      "b": "https://lh3.googleusercontent.com/d/1u1zm1mjW2DKCPVkeceWIjGaavJZXEJy2",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_2f0eddc6-f2d2-4131-a4a8-433167534c53.jpg?v=1765415409"
   },
   "carat": 1.3,
   "caratMax": 6.8
  },
  {
   "rank": 66,
   "id": "gid://shopify/Product/7702551265464",
   "title": "1.50-7.00 CT Marquise Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-15228lb",
   "handle": "engagement-rings-15228lb",
   "priceNow": 1881.99,
   "priceWas": 5830.0,
   "pctOff": 68,
   "core": "15228",
   "inStock": true,
   "createdAt": "2024-05-20T17:25:50Z",
   "shape": "marquise",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1wiHmlvv08hbIr2fGUWb6bWaTFmLBi7y7",
      "b": "https://lh3.googleusercontent.com/d/1Y-HGcfFLYDV0IZGrojTJu0P_LVxXYQtZ",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1V3GHimquxWvFyVjMv1YHrUa7jOIlqKm4",
      "b": "https://lh3.googleusercontent.com/d/13O5XzB4Ga6c-9tXpJBcqeyuprSUghlnZ",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Jb-QOwe9NkEULX69RaggfyDvs8VDskxX",
      "b": "https://lh3.googleusercontent.com/d/1i3cDadYlxBru3iobByLpU3rHrlhKyXIK",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_b9d28274-9bbb-4d8d-be7d-23cde049e7e7.jpg?v=1765415409"
   },
   "carat": 1.5,
   "caratMax": 7.0
  },
  {
   "rank": 67,
   "id": "gid://shopify/Product/7641271730360",
   "title": "2.00-7.50 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-15704lb",
   "handle": "bridal-sets-15704lb",
   "priceNow": 3086.99,
   "priceWas": 9570.0,
   "pctOff": 68,
   "core": "15704",
   "inStock": true,
   "createdAt": "2024-04-26T15:51:31Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1j4ppy7GdFhPxqa-ljioGteHV5IDAQR_b",
      "b": "https://lh3.googleusercontent.com/d/167TLK2Oko6HjmEPW0N1-cx-QXVkFw2qK",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1lDE52-YYvhL8MOHMRNFkJ8-D2pnnHgfW",
      "b": "https://lh3.googleusercontent.com/d/1NAGDELSeEb63wc9AmKwANIHyouItBnpC",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Xf8Pk8_K-ToY6t3RYGmJ5zUWvROKYpqu",
      "b": "https://lh3.googleusercontent.com/d/1wCF4kbFIQYUgnSr0ehETr88Jx-ih5l91",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_f54a6305-5f5f-453c-83be-57a64ebead3f.jpg?v=1714150565"
   },
   "carat": 2.0,
   "caratMax": 7.5
  },
  {
   "rank": 68,
   "id": "gid://shopify/Product/7641271304376",
   "title": "2.35-7.85 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-15634lb",
   "handle": "bridal-sets-15634lb",
   "priceNow": 3500.99,
   "priceWas": 10850.0,
   "pctOff": 68,
   "core": "15634",
   "inStock": true,
   "createdAt": "2024-04-26T15:51:07Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/17k0At6wVLnSNQFJCjcGu9c6q8Mq2d1Vv",
      "b": "https://lh3.googleusercontent.com/d/1Oc1ViS3jalVnuWn9GF9-CaNIb-e3rgWo",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1pCGpDEZJsWagXwQqx-T_pb2iLb83x6H2",
      "b": "https://lh3.googleusercontent.com/d/1dWr88VTeyJNW0r4haTn44G8bGGUzXcFS",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1i4lviKcDDn1gzh9_V6BWT3YJotkUd-w9",
      "b": "https://lh3.googleusercontent.com/d/1WmQqYkCB6ITbsbQ3yQsWV-WDUP5hDYiG",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_837254ff-7832-4df5-b67f-d539a35ad017.jpg?v=1714150037"
   },
   "carat": 2.35,
   "caratMax": 7.85
  },
  {
   "rank": 69,
   "id": "gid://shopify/Product/7641270976696",
   "title": "1.15-6.65 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-71782lb",
   "handle": "bridal-sets-71782lb",
   "priceNow": 1964.99,
   "priceWas": 6090.0,
   "pctOff": 68,
   "core": "71782",
   "inStock": true,
   "createdAt": "2024-04-26T15:50:45Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/11ykPuaj2y_GQaUiIaE1Bk2WHDrWbNrLn",
      "b": "https://lh3.googleusercontent.com/d/1apd4G873Kn3OB7a7TXxoBvi52l5UnD-C",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1-fugEhi_lZiIGO7101JqRIKzNPmJz0wq",
      "b": "https://lh3.googleusercontent.com/d/1fMWis74x9lR31qa8qR9r_7XuImSCSjSj",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1sLzG6vnL5QlQFw99B9VXkgrQtxfe5Doa",
      "b": "https://lh3.googleusercontent.com/d/12jIyYu_j6TjN26fnDI3VKBdIT98F7ccX",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_19375379-3edb-4edf-8222-67a368ff23b1.jpg?v=1714149871"
   },
   "carat": 1.15,
   "caratMax": 6.65
  },
  {
   "rank": 70,
   "id": "gid://shopify/Product/7544414372024",
   "title": "1.10 CT Emerald & Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-15600lb",
   "handle": "wedding-bands-15600lb",
   "priceNow": 1544.99,
   "priceWas": 4790.0,
   "pctOff": 68,
   "core": "15600",
   "inStock": true,
   "createdAt": "2024-04-04T17:44:05Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1SOmjih1XzWxrZGIJGVduQrdGtur5_cYJ",
      "b": "https://lh3.googleusercontent.com/d/1c6kJSeyOzUZ-evHwkYxnxli2F2VvxRV-",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1tJrpkV6PYR_-Rtd79FXLqknV03jnv2Tx",
      "b": "https://lh3.googleusercontent.com/d/1q-n1O0aAxClWrlOMLBrMT_R-TlPeZJ3F",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1V4dVFkcQL0FA3yYrsQZPBCrFpV6NEZJf",
      "b": "https://lh3.googleusercontent.com/d/1iv2-DAuAbs9D_8esjcyEv_b6kDbzKxFt",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_0401c6d7-b5d1-4695-a02e-99cff1da7fd3.jpg?v=1763698614"
   },
   "carat": 1.1
  },
  {
   "rank": 71,
   "id": "gid://shopify/Product/7544414240952",
   "title": "0.80 CT Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-15288lb",
   "handle": "wedding-bands-15288lb",
   "priceNow": 1476.99,
   "priceWas": 4580.0,
   "pctOff": 68,
   "core": "15288",
   "inStock": true,
   "createdAt": "2024-04-04T17:43:55Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/102asl-2X87N_7MUtMRxO_VYzXu3ugu5E",
      "b": "https://lh3.googleusercontent.com/d/159HUcR171xHStkyOwrP-olkWavfwNJ_Y",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/19QaATKnTi6ipgr8eyAx_8tWkFlmCaFzy",
      "b": "https://lh3.googleusercontent.com/d/1hHlMozy98QmrdKZm9RTWVQ0wvU6RNwBU",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1IAIpva6YLsvV-zl1sE9ZzogY5Aq9cKwH",
      "b": "https://lh3.googleusercontent.com/d/1UCpXe_dG4cDYWmbU5m0I4uP2msLLQffv",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_0bde36c9-ab1f-4b3f-a8da-6d6288f4dc28.jpg?v=1712254804"
   },
   "carat": 0.8
  },
  {
   "rank": 72,
   "id": "gid://shopify/Product/7509723021496",
   "title": "1.25-6.75 CT Round Cut Lab Grown Diamonds - Three Stone Rings",
   "url": "/products/three-stone-rings-15311lb",
   "handle": "three-stone-rings-15311lb",
   "priceNow": 1833.99,
   "priceWas": 5690.0,
   "pctOff": 68,
   "core": "15311",
   "inStock": true,
   "createdAt": "2024-03-26T23:43:26Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_3367047d-6003-4607-a660-073e77cb87c6.jpg?v=1763766474",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_3367047d-6003-4607-a660-073e77cb87c6.jpg?v=1763766474",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y3_74d92866-00e6-44d4-91a4-8e198c7464b4.jpg?v=1763766477",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r3_c2ea698c-75ac-4621-a33b-6de15d6243f2.jpg?v=1763766480"
    }
   },
   "carat": 1.25,
   "caratMax": 6.75
  },
  {
   "rank": 73,
   "id": "gid://shopify/Product/7499105042616",
   "title": "1.70 CT Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-15262lb",
   "handle": "wedding-bands-15262lb",
   "priceNow": 1584.99,
   "priceWas": 4910.0,
   "pctOff": 68,
   "core": "15262",
   "inStock": true,
   "createdAt": "2024-03-20T10:10:42Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_2b4ff58c-defe-4e89-bf83-bc5519485f7a.jpg?v=1763698749",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_2b4ff58c-defe-4e89-bf83-bc5519485f7a.jpg?v=1763698749",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y3_99ffa275-5a6e-4dfc-be72-e6a319f07772.jpg?v=1763698750",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r3_b41152f0-c87d-475a-a9bf-fbf48ed1311f.jpg?v=1763698749"
    }
   },
   "carat": 1.7
  },
  {
   "rank": 74,
   "id": "gid://shopify/Product/7499104059576",
   "title": "0.85-6.35 CT Round Cut Lab Grown Diamonds - Three Stone Rings",
   "url": "/products/three-stone-rings-15320lb",
   "handle": "three-stone-rings-15320lb",
   "priceNow": 1657.99,
   "priceWas": 5140.0,
   "pctOff": 68,
   "core": "15320",
   "inStock": true,
   "createdAt": "2024-03-20T10:09:52Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1-lBYV48nGRgc19p_T7urE8wDQatvtJI9",
      "b": "https://lh3.googleusercontent.com/d/1wMp6bnrHDcuAK1WxXQE_wfzClLfWGFK5",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/16Oyf2MT8kLSMhnYX4nTIilq0kV-J_EYf",
      "b": "https://lh3.googleusercontent.com/d/1tJ8eE2hbvA96azsNP4sGvx0IG7aX6WES",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/11B-hwYTaSxH_OKK5lRMi6iWhA9UjGkwr",
      "b": "https://lh3.googleusercontent.com/d/1zDbqVkVAIbmx2Qjdcsa8gVzBhJTdovHR",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_ca4261cf-0f73-4360-aeac-a7104296a7c8.jpg?v=1763766479"
   },
   "carat": 0.85,
   "caratMax": 6.35
  },
  {
   "rank": 75,
   "id": "gid://shopify/Product/7499102617784",
   "title": "1.10 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-15695lb",
   "handle": "wedding-bands-15695lb",
   "priceNow": 1362.99,
   "priceWas": 4230.0,
   "pctOff": 68,
   "core": "15695",
   "inStock": true,
   "createdAt": "2024-03-20T10:08:39Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1JT0hvfozstODeEuFYtGDibtuPazngDkj",
      "b": "https://lh3.googleusercontent.com/d/16FXwyYy-7Fbu3kCphqUyzCl-OUFbFHo9",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1rGWQ4LkH3VQ62UrGYZ7qWZ_KcLSsQ9zq",
      "b": "https://lh3.googleusercontent.com/d/1aUXJEsvJ6GkQT04qKh0aZIIW9jcKGNo-",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1VcGJOCe-u7mHxw53kR8yjnWDhAvfIrxa",
      "b": "https://lh3.googleusercontent.com/d/1J_Uz5ALsGIS2i4BXnvuPGKWu2T_-_E0v",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_0d0e0475-caaa-4d29-884d-d3598c62fcc4.jpg?v=1763698823"
   },
   "carat": 1.1
  },
  {
   "rank": 76,
   "id": "gid://shopify/Product/7488957907128",
   "title": "1.50 CT Princess & Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-16041lb",
   "handle": "wedding-bands-16041lb",
   "priceNow": 1623.99,
   "priceWas": 5030.0,
   "pctOff": 68,
   "core": "16041",
   "inStock": true,
   "createdAt": "2024-03-16T00:44:32Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1dFK-A6BorsKfPCkQxlMAxAq_RmBhA9_y",
      "b": "https://lh3.googleusercontent.com/d/18sKYjiLzACRRnHiyWqCE91LSzYg5wbJe",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1rh-Ka1jRKI8wFuS0tFxr69RRh77zzwmj",
      "b": "https://lh3.googleusercontent.com/d/1q_o_67JymIFyIgAudQYVqmz0BQjGM_mU",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1L4_0vUCeSJjOltRQeAsMiLcUxckd6JLz",
      "b": "https://lh3.googleusercontent.com/d/1hWa0F0bGFtEm9qbuE8WLae1lIVdLX9al",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_45b0fb8b-79df-40ac-acc9-d50617343fe7.jpg?v=1710883856"
   },
   "carat": 1.5
  },
  {
   "rank": 77,
   "id": "gid://shopify/Product/7488957841592",
   "title": "1.40 CT Emerald & Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-15664lb",
   "handle": "wedding-bands-15664lb",
   "priceNow": 1537.99,
   "priceWas": 4770.0,
   "pctOff": 68,
   "core": "15664",
   "inStock": true,
   "createdAt": "2024-03-16T00:44:23Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1yod2az4HklfsXG4SazSW5eshOfY83DQK",
      "b": "https://lh3.googleusercontent.com/d/1IJZBIP5jzpa5WifwTgkomygVd5RpvoBE",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1WIDwGo_yfl__y-bv4WTgPfouyPh2QxS6",
      "b": "https://lh3.googleusercontent.com/d/180sjgMfGh2THqTMqU9RD2GsLRnRnpWJx",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1tS5WY4B2ZSuy_gE59R1cN9Lx-j9pvtDb",
      "b": "https://lh3.googleusercontent.com/d/1IGyq7NOopSKe-yyYwU2UosvYEhnBWHc4",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_e89fc5b6-093f-4940-8d3d-3d85d518b0fa.jpg?v=1763698873"
   },
   "carat": 1.4
  },
  {
   "rank": 78,
   "id": "gid://shopify/Product/7485706174648",
   "title": "0.80 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-15278lb",
   "handle": "wedding-bands-15278lb",
   "priceNow": 1290.99,
   "priceWas": 4000.0,
   "pctOff": 68,
   "core": "15278",
   "inStock": true,
   "createdAt": "2024-03-13T16:26:39Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1YlbLDuGaoBxnVN6OhzWdcGFeIS5QNhJr",
      "b": "https://lh3.googleusercontent.com/d/1YwaSHakW1HH2-xKAeiSVWZFvOYh1H8Uz",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/163QoZf00eTAyZybX3Ao47KlcsqRHd91K",
      "b": "https://lh3.googleusercontent.com/d/1saDfPX3g5T9eGH-dr6V_dHA8LaipmecQ",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1mVvC5MvLwuiJrgI3za2X-ZsWzbB9IU_B",
      "b": "https://lh3.googleusercontent.com/d/19slEGD1JaaA7SHY_lgHfCF8TWt-cJDuj",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_f55a2b36-ad78-419c-a65f-0186d33f189f.jpg?v=1710361401"
   },
   "carat": 0.8
  },
  {
   "rank": 79,
   "id": "gid://shopify/Product/7330474131640",
   "title": "0.60-5.00 CT Round Cut Lab Grown Diamonds - Stud Earrings",
   "url": "/products/0-60-5-00-ct-round-cut-lab-grown-diamonds-stud-earrings-71195lb",
   "handle": "0-60-5-00-ct-round-cut-lab-grown-diamonds-stud-earrings-71195lb",
   "priceNow": 1200.99,
   "priceWas": 3720.0,
   "pctOff": 68,
   "core": "71195",
   "inStock": true,
   "createdAt": "2023-10-20T09:20:54Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1QtTPzvNOi3dKEIg7vSYzMra2H9IQWZ3u",
      "b": "https://lh3.googleusercontent.com/d/1f1lH5f6_qMAUimjoXEao6hkKiUEq72VK",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1cTgSHlF7tG39vY_mJqT8PvCJNtuSIVg5",
      "b": "https://lh3.googleusercontent.com/d/1irGvQj6hDHBqQA1uivFfVevzjvden4Gj",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1C63hL8msWY6v8ZYo9Fopp7z-n9pPtIft",
      "b": "https://lh3.googleusercontent.com/d/10rUjQSFwL55t1wmCHofaKRuUVEjkv-Xw",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-round-cut-lab-grown-diamonds-stud-earrings-218169.jpg?v=1698786142"
   },
   "carat": 0.6,
   "caratMax": 5.0
  },
  {
   "rank": 80,
   "id": "gid://shopify/Product/7328600883384",
   "title": "0.60-5.00 CT Emerald Cut Lab Grown Diamonds - Stud Earrings",
   "url": "/products/0-60-5-00-ct-emerald-cut-lab-grown-diamonds-stud-earrings-15414lb",
   "handle": "0-60-5-00-ct-emerald-cut-lab-grown-diamonds-stud-earrings-15414lb",
   "priceNow": 1092.99,
   "priceWas": 3390.0,
   "pctOff": 68,
   "core": "15414",
   "inStock": true,
   "createdAt": "2023-10-19T09:08:33Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1IBxlzvkmnHUlYV7XjFdCVGKUegaO0Qb7",
      "b": "https://lh3.googleusercontent.com/d/1GrxaGVmM1PQEsR-xRAuKIRyTQeCDNAeb",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1gYBLY1jHzbWi92tAnGs_RJ9q7NZDAIZV",
      "b": "https://lh3.googleusercontent.com/d/1mFvc4klGvTrFtPjhHv3Gc-SGhwJivaII",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Lu1TVkB1IMG7LhIieq9ZMKuv44SdCsPb",
      "b": "https://lh3.googleusercontent.com/d/1fodCMZ4Qw5ispRHRmG4pGeUrVcROKurS",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-emerald-cut-lab-grown-diamonds-stud-earrings-795094.jpg?v=1698786139"
   },
   "carat": 0.6,
   "caratMax": 5.0
  },
  {
   "rank": 81,
   "id": "gid://shopify/Product/7305751986360",
   "title": "1.95-7.45 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-95-4-45-ct-round-cut-lab-grown-diamonds-bridal-set-21069lb",
   "handle": "1-95-4-45-ct-round-cut-lab-grown-diamonds-bridal-set-21069lb",
   "priceNow": 2631.99,
   "priceWas": 8160.0,
   "pctOff": 68,
   "core": "21069",
   "inStock": true,
   "createdAt": "2023-08-12T13:45:06Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/195-445-ct-round-cut-lab-grown-diamonds-bridal-set-154618.jpg?v=1714759048",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/195-445-ct-round-cut-lab-grown-diamonds-bridal-set-154618.jpg?v=1714759048",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/195-445-ct-round-cut-lab-grown-diamonds-bridal-set-173429.jpg?v=1763699332",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/195-445-ct-round-cut-lab-grown-diamonds-bridal-set-767775.jpg?v=1763699332"
    }
   },
   "carat": 1.95,
   "caratMax": 7.45
  },
  {
   "rank": 82,
   "id": "gid://shopify/Product/7305751920824",
   "title": "2.10-7.60 CT Emerald & Princess Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/2-10-4-60-ct-princess-emerald-cut-lab-grown-diamonds-bridal-set-21068lb",
   "handle": "2-10-4-60-ct-princess-emerald-cut-lab-grown-diamonds-bridal-set-21068lb",
   "priceNow": 2468.99,
   "priceWas": 7650.0,
   "pctOff": 68,
   "core": "21068",
   "inStock": true,
   "createdAt": "2023-08-12T13:45:00Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/210-460-ct-princess-emerald-cut-lab-grown-diamonds-bridal-set-474936.jpg?v=1714759104",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/210-460-ct-princess-emerald-cut-lab-grown-diamonds-bridal-set-474936.jpg?v=1714759104",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/210-460-ct-princess-emerald-cut-lab-grown-diamonds-bridal-set-135872.jpg?v=1763699332",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/210-460-ct-princess-emerald-cut-lab-grown-diamonds-bridal-set-123051.jpg?v=1763699332"
    }
   },
   "carat": 2.1,
   "caratMax": 7.6
  },
  {
   "rank": 83,
   "id": "gid://shopify/Product/7305751756984",
   "title": "1.25-6.75 CT Princess Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-25-3-75-ct-princess-cut-lab-grown-diamonds-bridal-set-21063lb",
   "handle": "1-25-3-75-ct-princess-cut-lab-grown-diamonds-bridal-set-21063lb",
   "priceNow": 2093.99,
   "priceWas": 6490.0,
   "pctOff": 68,
   "core": "21063",
   "inStock": true,
   "createdAt": "2023-08-12T13:44:05Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/125-375-ct-princess-cut-lab-grown-diamonds-bridal-set-551605.jpg?v=1714759856",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/125-375-ct-princess-cut-lab-grown-diamonds-bridal-set-551605.jpg?v=1714759856",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/125-375-ct-princess-cut-lab-grown-diamonds-bridal-set-156640.jpg?v=1763699333",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/125-375-ct-princess-cut-lab-grown-diamonds-bridal-set-360635.jpg?v=1763699333"
    }
   },
   "carat": 1.25,
   "caratMax": 6.75
  },
  {
   "rank": 84,
   "id": "gid://shopify/Product/7305751691448",
   "title": "0.75-6.25 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/0-75-3-25-ct-round-princess-cut-lab-grown-diamonds-bridal-set-21061lb",
   "handle": "0-75-3-25-ct-round-princess-cut-lab-grown-diamonds-bridal-set-21061lb",
   "priceNow": 1810.99,
   "priceWas": 5610.0,
   "pctOff": 68,
   "core": "21061",
   "inStock": true,
   "createdAt": "2023-08-12T13:43:41Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/075-325-ct-round-princess-cut-lab-grown-diamonds-bridal-set-975376.jpg?v=1714676198",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/075-325-ct-round-princess-cut-lab-grown-diamonds-bridal-set-975376.jpg?v=1714676198",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/075-325-ct-round-princess-cut-lab-grown-diamonds-bridal-set-650804.jpg?v=1763699363",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/075-325-ct-round-princess-cut-lab-grown-diamonds-bridal-set-111116.jpg?v=1763699363"
    }
   },
   "carat": 0.75,
   "caratMax": 6.25
  },
  {
   "rank": 85,
   "id": "gid://shopify/Product/7305709912248",
   "title": "0.75-6.25 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/0-75-3-25-ct-round-cut-lab-grown-diamonds-bridal-set-21050lb",
   "handle": "0-75-3-25-ct-round-cut-lab-grown-diamonds-bridal-set-21050lb",
   "priceNow": 1867.99,
   "priceWas": 5790.0,
   "pctOff": 68,
   "core": "21050",
   "inStock": true,
   "createdAt": "2023-08-11T22:36:42Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/075-325-ct-round-cut-lab-grown-diamonds-bridal-set-167488.jpg?v=1714675464",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/075-325-ct-round-cut-lab-grown-diamonds-bridal-set-167488.jpg?v=1714675464",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/075-325-ct-round-cut-lab-grown-diamonds-bridal-set-354078.jpg?v=1763699363",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/075-325-ct-round-cut-lab-grown-diamonds-bridal-set-849852.jpg?v=1763699363"
    }
   },
   "carat": 0.75,
   "caratMax": 6.25
  },
  {
   "rank": 86,
   "id": "gid://shopify/Product/7305447112888",
   "title": "0.90-6.40 CT Cushion & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/0-90-3-40-ct-round-cushion-cut-lab-grown-diamonds-bridal-set-21048lb",
   "handle": "0-90-3-40-ct-round-cushion-cut-lab-grown-diamonds-bridal-set-21048lb",
   "priceNow": 2240.99,
   "priceWas": 6950.0,
   "pctOff": 68,
   "core": "21048",
   "inStock": true,
   "createdAt": "2023-08-10T22:57:24Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/090-340-ct-round-cushion-cut-lab-grown-diamonds-bridal-set-150675.jpg?v=1714760478",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/090-340-ct-round-cushion-cut-lab-grown-diamonds-bridal-set-150675.jpg?v=1714760478",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/090-340-ct-round-cushion-cut-lab-grown-diamonds-bridal-set-138308.jpg?v=1763699363",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/090-340-ct-round-cushion-cut-lab-grown-diamonds-bridal-set-119696.jpg?v=1763699363"
    }
   },
   "carat": 0.9,
   "caratMax": 6.4
  },
  {
   "rank": 87,
   "id": "gid://shopify/Product/7305192571064",
   "title": "0.65-6.15 CT Oval & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/0-65-3-15-ct-round-oval-cut-lab-grown-diamonds-bridal-set-21017lb",
   "handle": "0-65-3-15-ct-round-oval-cut-lab-grown-diamonds-bridal-set-21017lb",
   "priceNow": 1337.99,
   "priceWas": 4150.0,
   "pctOff": 68,
   "core": "21017",
   "inStock": true,
   "createdAt": "2023-08-08T18:02:22Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/065-315-ct-round-oval-cut-lab-grown-diamonds-bridal-set-584219.jpg?v=1697640147",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/065-315-ct-round-oval-cut-lab-grown-diamonds-bridal-set-929120.jpg?v=1697640147",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/065-315-ct-round-oval-cut-lab-grown-diamonds-bridal-set-631124.jpg?v=1763699521",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/065-315-ct-round-oval-cut-lab-grown-diamonds-bridal-set-876533.jpg?v=1763699563"
    }
   },
   "carat": 0.65,
   "caratMax": 6.15
  },
  {
   "rank": 88,
   "id": "gid://shopify/Product/7304432484536",
   "title": "1.30-6.80 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-30-3-80-ct-round-cut-lab-grown-diamonds-bridal-set-21024lb",
   "handle": "1-30-3-80-ct-round-cut-lab-grown-diamonds-bridal-set-21024lb",
   "priceNow": 2464.99,
   "priceWas": 7640.0,
   "pctOff": 68,
   "core": "21024",
   "inStock": true,
   "createdAt": "2023-08-04T00:17:22Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/130-380-ct-round-cut-lab-grown-diamonds-bridal-set-461768.jpg?v=1714761729",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/130-380-ct-round-cut-lab-grown-diamonds-bridal-set-461768.jpg?v=1714761729",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/130-380-ct-round-cut-lab-grown-diamonds-bridal-set-590689.jpg?v=1763699564",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/130-380-ct-round-cut-lab-grown-diamonds-bridal-set-745213.jpg?v=1763699564"
    }
   },
   "carat": 1.3,
   "caratMax": 6.8
  },
  {
   "rank": 89,
   "id": "gid://shopify/Product/7304432353464",
   "title": "1.95-7.45 CT Emerald & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-95-4-45-ct-round-emerald-cut-lab-grown-cut-diamonds-bridal-set-21020lb",
   "handle": "1-95-4-45-ct-round-emerald-cut-lab-grown-cut-diamonds-bridal-set-21020lb",
   "priceNow": 2679.99,
   "priceWas": 8310.0,
   "pctOff": 68,
   "core": "21020",
   "inStock": true,
   "createdAt": "2023-08-04T00:17:01Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/195-445-ct-round-emerald-cut-lab-grown-cut-diamonds-bridal-set-884232.jpg?v=1714761882",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/195-445-ct-round-emerald-cut-lab-grown-cut-diamonds-bridal-set-884232.jpg?v=1714761882",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/195-445-ct-round-emerald-cut-lab-grown-cut-diamonds-bridal-set-564531.jpg?v=1763699564",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/195-445-ct-round-emerald-cut-lab-grown-cut-diamonds-bridal-set-928867.jpg?v=1763699564"
    }
   },
   "carat": 1.95,
   "caratMax": 7.45
  },
  {
   "rank": 90,
   "id": "gid://shopify/Product/7304432156856",
   "title": "2.35-7.85 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/2-35-4-85-ct-round-princess-cut-lab-grown-diamonds-bridal-set-15331lb",
   "handle": "2-35-4-85-ct-round-princess-cut-lab-grown-diamonds-bridal-set-15331lb",
   "priceNow": 3008.99,
   "priceWas": 9330.0,
   "pctOff": 68,
   "core": "15331",
   "inStock": true,
   "createdAt": "2023-08-04T00:16:16Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1FcVClLgnQMXpNxbvb5nbqCB5SrDaYXiS",
      "b": "https://lh3.googleusercontent.com/d/1Tf8XyFNfsLLNEHpgb-7yX-74b4Kxh8Qf",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1ybBHWQ_cVTdbFkHCr-Xnkemzx8dQpIv0",
      "b": "https://lh3.googleusercontent.com/d/1lM6xWz1ZJlqTP73SySFlCK6nm3f-m0s-",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1dpWO0cpXtUZ7pQa0Q7uHgVjht8vMtzAG",
      "b": "https://lh3.googleusercontent.com/d/1fFpZtAAq2rd2A3cj5S3P95mFA1ysiJTI",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/235-485-ct-round-princess-cut-lab-grown-diamonds-bridal-set-880745.jpg?v=1714762136"
   },
   "carat": 2.35,
   "caratMax": 7.85
  },
  {
   "rank": 91,
   "id": "gid://shopify/Product/7304057749688",
   "title": "1.10-6.60 CT Round Cut Lab Grown Diamonds - Three Stone Rings",
   "url": "/products/1-10-3-60-ct-round-cut-lab-grown-diamonds-three-stone-ring-15328lb",
   "handle": "1-10-3-60-ct-round-cut-lab-grown-diamonds-three-stone-ring-15328lb",
   "priceNow": 968.99,
   "priceWas": 3290.0,
   "pctOff": 71,
   "core": "15328",
   "inStock": true,
   "createdAt": "2023-08-01T23:59:26Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1IDg-jdHPcmEwGn44JbnXPQ9DG6-TcmaM",
      "b": "https://lh3.googleusercontent.com/d/1yeNnc-GmqUeXXTtc6E9FMqC5g7dgKdAz",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1ro4bWnJChpgDmXKJeHkUZl5YMMKSdQ8b",
      "b": "https://lh3.googleusercontent.com/d/1sPBu9RdtZU2xXPUg8gztGVgvQGSJEwwl",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1YCED0GPXHaIwceHdxXG3f-XRxPla_KR0",
      "b": "https://lh3.googleusercontent.com/d/1FxCrw-7uWzOzj5pAKO2H7yODC86CKj4N",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/110-360-ct-round-cut-lab-grown-diamonds-three-stone-ring-167889.jpg?v=1763766480"
   },
   "carat": 1.1,
   "caratMax": 6.6
  },
  {
   "rank": 92,
   "id": "gid://shopify/Product/7304031207608",
   "title": "0.80-6.30 CT Emerald & Round Cut Lab Grown Diamonds - Halo Rings",
   "url": "/products/0-80-3-30-ct-round-emerald-cut-lab-grown-diamonds-halo-ring-71916lb",
   "handle": "0-80-3-30-ct-round-emerald-cut-lab-grown-diamonds-halo-ring-71916lb",
   "priceNow": 1541.99,
   "priceWas": 4780.0,
   "pctOff": 68,
   "core": "71916",
   "inStock": true,
   "createdAt": "2023-08-01T18:39:39Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1Rr19vMTU1H0QlI05XHGuqWss1e1naYzX",
      "b": "https://lh3.googleusercontent.com/d/1xfhlfHwh7mXpPy8SU5ZN4QIZVhlEqeE7",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1WBx4ekQRZkvGhq0OHGA6AIURiJYmsUwi",
      "b": "https://lh3.googleusercontent.com/d/1FBvL4SXh4_6hxeHYl7LeQUREbQXTvtme",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1xp7pwPZsu3nTXCTwYEJvWcKXsVtH34me",
      "b": "https://lh3.googleusercontent.com/d/1dVTK03KurYqm4Hr0JYOcdWtoWY5Bz9eA",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/080-330-ct-round-emerald-cut-lab-grown-diamonds-halo-ring-438268.jpg?v=1714499691"
   },
   "carat": 0.8,
   "caratMax": 6.3
  },
  {
   "rank": 93,
   "id": "gid://shopify/Product/7303609778360",
   "title": "1.40-6.90 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/1-40-3-90-ct-round-cut-lab-grown-diamonds-engagement-ring-15715lb",
   "handle": "1-40-3-90-ct-round-cut-lab-grown-diamonds-engagement-ring-15715lb",
   "priceNow": 1744.99,
   "priceWas": 5410.0,
   "pctOff": 68,
   "core": "15715",
   "inStock": true,
   "createdAt": "2023-07-28T19:23:28Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1-lXwW97cVChYts3F5l9ZbvBHGvIJR8RV",
      "b": "https://lh3.googleusercontent.com/d/1eKcWYtf-4bQKXPhE8vfLWFWe5oM49YD2",
      "angles": [
       5,
       6
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1HDpyUwd4cWH88ir4tPpv6YT0J7zlIcmx",
      "b": "https://lh3.googleusercontent.com/d/1jatCc2TtC1khe-Ct5Kb1bX2WHW9Rdw0B",
      "angles": [
       5,
       6
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1tLLl9Sk6TXuKHJcuyX93pBCdTgN0GO0L",
      "b": "https://lh3.googleusercontent.com/d/11_t5aXhgaSszkfTUwsBVQdh-ERN1cr4Q",
      "angles": [
       5,
       6
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/140-390-ct-round-cut-lab-grown-diamonds-engagement-ring-103836.jpg?v=1765415316"
   },
   "carat": 1.4,
   "caratMax": 6.9
  },
  {
   "rank": 94,
   "id": "gid://shopify/Product/7303609647288",
   "title": "1.45-6.95 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/1-45-3-95-ct-round-cut-lab-grown-diamonds-engagement-ring-71636lb",
   "handle": "1-45-3-95-ct-round-cut-lab-grown-diamonds-engagement-ring-71636lb",
   "priceNow": 1704.99,
   "priceWas": 5290.0,
   "pctOff": 68,
   "core": "71636",
   "inStock": true,
   "createdAt": "2023-07-28T19:23:07Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1zn0CydM_sv-S3gG7EvQrzBvl8a2Le5Eb",
      "b": "https://lh3.googleusercontent.com/d/1IA1IGv0b_VlIwvK_QyjIjsl13IRlvUjc",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1QxX7jYUiV3ZsxejDK1YprRDz35BhVCSH",
      "b": "https://lh3.googleusercontent.com/d/1YqOu_pN9rFpe0XmvggtQbxZps13yXliC",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1SbjLgeGosL9QuyY7ju0PdQ-nA0WIfS14",
      "b": "https://lh3.googleusercontent.com/d/1FjeY5_Iba4N5KSOvyptMKN7t4OvOEp6J",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/145-395-ct-round-cut-lab-grown-diamonds-engagement-ring-510611.jpg?v=1714498931"
   },
   "carat": 1.45,
   "caratMax": 6.95
  },
  {
   "rank": 95,
   "id": "gid://shopify/Product/7303236223160",
   "title": "0.85-6.35 CT Heart & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/0-85-3-35-ct-round-heart-cut-lab-grown-diamonds-engagement-ring-71834lb",
   "handle": "0-85-3-35-ct-round-heart-cut-lab-grown-diamonds-engagement-ring-71834lb",
   "priceNow": 1362.99,
   "priceWas": 4230.0,
   "pctOff": 68,
   "core": "71834",
   "inStock": true,
   "createdAt": "2023-07-26T21:58:07Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1u7LbI0Di2JtYuaFpvJ-SBjgxu4_9uiux",
      "b": "https://lh3.googleusercontent.com/d/1aaMj_RIz6boSqbLAqH3ZcKAFDIlAb3k4",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1TQG-AEwWffrxpiZj2ZpjAP2KkaScyII7",
      "b": "https://lh3.googleusercontent.com/d/1jf0_-f5Dbvr1TtuBOdulu-CNcY9D6cWI",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ycAFfOW4CAJEnpP1KoEyav5Th7kQdJrD",
      "b": "https://lh3.googleusercontent.com/d/1qyRzZ1cd_IGuBS-bBvHh6SMr0HMoZkR9",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/085-335-ct-round-heart-cut-lab-grown-diamonds-engagement-ring-444296.jpg?v=1714071196"
   },
   "carat": 0.85,
   "caratMax": 6.35
  },
  {
   "rank": 96,
   "id": "gid://shopify/Product/7303236190392",
   "title": "0.95-6.45 CT Oval & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/0-95-3-45-ct-round-oval-cut-lab-grown-diamonds-engagement-ring-71843lb",
   "handle": "0-95-3-45-ct-round-oval-cut-lab-grown-diamonds-engagement-ring-71843lb",
   "priceNow": 1330.99,
   "priceWas": 4130.0,
   "pctOff": 68,
   "core": "71843",
   "inStock": true,
   "createdAt": "2023-07-26T21:58:01Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1YOQvK2TTQ0B_-XlH9eCfLlQObnyP4PhI",
      "b": "https://lh3.googleusercontent.com/d/1K_7IKKxWB7srfzbjTqqUKkWCA4Stxl6t",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1uJq27yaqL-GGIvdDP_PrMQjoF_ICY2_v",
      "b": "https://lh3.googleusercontent.com/d/1V3glKU_J9ZUUbrVbQII_49g6bnOLV94j",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1EfqsT-xpTjx7-DbfoQf7NWbWhe92IOVV",
      "b": "https://lh3.googleusercontent.com/d/1CiqnsdnVbPW6pyPpnE8V7XHk06SXPxSW",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/095-345-ct-round-oval-cut-lab-grown-diamonds-engagement-ring-916895.jpg?v=1714146053"
   },
   "carat": 0.95,
   "caratMax": 6.45
  },
  {
   "rank": 97,
   "id": "gid://shopify/Product/7303235567800",
   "title": "1.05-6.55 CT Round Cut Lab Grown Diamonds - Halo Rings",
   "url": "/products/1-05-3-55-ct-round-cut-lab-grown-diamonds-engagement-ring-21013lb",
   "handle": "1-05-3-55-ct-round-cut-lab-grown-diamonds-engagement-ring-21013lb",
   "priceNow": 1426.99,
   "priceWas": 4420.0,
   "pctOff": 68,
   "core": "21013",
   "inStock": true,
   "createdAt": "2023-07-26T21:55:57Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/105-355-ct-round-cut-lab-grown-diamonds-engagement-ring-696629.jpg?v=1714499713",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/105-355-ct-round-cut-lab-grown-diamonds-engagement-ring-696629.jpg?v=1714499713",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/105-355-ct-round-cut-lab-grown-diamonds-engagement-ring-797401.jpg?v=1763699779",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/105-355-ct-round-cut-lab-grown-diamonds-engagement-ring-179024.jpg?v=1763699779"
    }
   },
   "carat": 1.05,
   "caratMax": 6.55
  },
  {
   "rank": 98,
   "id": "gid://shopify/Product/7302928171192",
   "title": "0.50-6.00 CT Princess Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/0-50-3-00-ct-princess-cut-lab-grown-diamonds-solitaire-ring-71810lb",
   "handle": "0-50-3-00-ct-princess-cut-lab-grown-diamonds-solitaire-ring-71810lb",
   "priceNow": 1620.99,
   "priceWas": 5030.0,
   "pctOff": 68,
   "core": "71810",
   "inStock": true,
   "createdAt": "2023-07-24T23:15:14Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-princess-cut-lab-grown-diamonds-solitaire-ring-149248.jpg?v=1763748619"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 99,
   "id": "gid://shopify/Product/7301496570040",
   "title": "0.50-6.00 CT Oval Cut Lab Grown Diamonds - Solitaire Pendant",
   "url": "/products/0-50-3-00-ct-oval-cut-lab-grown-diamonds-solitaire-pendant-15504ovlb",
   "handle": "0-50-3-00-ct-oval-cut-lab-grown-diamonds-solitaire-pendant-15504ovlb",
   "priceNow": 987.99,
   "priceWas": 3260.0,
   "pctOff": 70,
   "core": "15504",
   "inStock": true,
   "createdAt": "2023-07-14T19:35:51Z",
   "shape": "oval",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-oval-cut-lab-grown-diamonds-solitaire-pendant-535841.jpg?v=1697640143"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 100,
   "id": "gid://shopify/Product/10448394977464",
   "title": "1.70-7.20 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-30101lb",
   "handle": "bridal-sets-30101lb",
   "priceNow": 2169.99,
   "priceWas": 6730.0,
   "pctOff": 68,
   "core": "30101",
   "inStock": true,
   "createdAt": "2026-06-18T19:38:56Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_b8f97146-6202-4094-8230-f6846f402eed.png?v=1782447070",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_b8f97146-6202-4094-8230-f6846f402eed.png?v=1782447070",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_39f4a993-f556-487b-908f-29291e9483c0.png?v=1782447070",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_55557aff-70e5-4420-a4ea-25a4b2030948.png?v=1782447070"
    }
   },
   "carat": 1.7,
   "caratMax": 7.2
  },
  {
   "rank": 101,
   "id": "gid://shopify/Product/10202344521912",
   "title": "4.00-6.00 CT Emerald Cut Blue Sapphires and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71612lbs",
   "handle": "eternity-rings-71612lbs",
   "priceNow": 2338.99,
   "priceWas": 7130.0,
   "pctOff": 67,
   "core": "71612",
   "inStock": true,
   "createdAt": "2026-01-28T16:47:32Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1VHKMdiUobCofk0RIRhDdgAYZaoPhDQnN",
      "b": "https://lh3.googleusercontent.com/d/1-3n-VNRv3Cl-NY5ftT-4ur_rw4K6BjTb",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1a3RqwyWnMk4u8QtD2aBSfi-h4AelIeSF",
      "b": "https://lh3.googleusercontent.com/d/1s4BrSE8hScliuLHcoUj8RsUAFJftLOPL",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1zDeMwL7uiPw4AzEV3ztMTf_8DuRXZg01",
      "b": "https://lh3.googleusercontent.com/d/1Cn7FWejtNnQXyWnhbURN3nkyH_dzr9Uz",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_d721c5ff-25a0-4523-9875-5e47ebe85d47.png?v=1771248188"
   },
   "carat": 4.0,
   "caratMax": 6.0
  },
  {
   "rank": 102,
   "id": "gid://shopify/Product/10155928617144",
   "title": "15.00 CT Round Cut Diamonds - Diamond Necklace",
   "url": "/products/15-00-ct-round-cut-diamonds-diamond-necklace-1",
   "handle": "15-00-ct-round-cut-diamonds-diamond-necklace-1",
   "priceNow": 6630.99,
   "priceWas": 17775.0,
   "pctOff": 63,
   "core": "30026",
   "inStock": true,
   "createdAt": "2025-11-30T17:10:39Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/WhatsApp_Image_2025-12-01_at_08.41.56_53661b3f.jpg?v=1768436769",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/WhatsApp_Image_2025-12-01_at_08.41.56_53661b3f.jpg?v=1768436769",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/WhatsApp_Image_2025-12-01_at_08.41.56_e1c8d1d4.jpg?v=1768436770"
    }
   },
   "carat": 15.0
  },
  {
   "rank": 103,
   "id": "gid://shopify/Product/10155898634424",
   "title": "1.30 CT Round Cut Lab Grown Diamonds - Hoop & Drop Earrings",
   "url": "/products/hoop-and-drop-and-earrings-30015lb",
   "handle": "hoop-and-drop-and-earrings-30015lb",
   "priceNow": 912.99,
   "priceWas": 3100.0,
   "pctOff": 71,
   "core": "30015",
   "inStock": true,
   "createdAt": "2025-11-30T16:04:54Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_5_230e57b4-1454-47ab-88ad-922ad0fc22fa.png?v=1768436768",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_5_230e57b4-1454-47ab-88ad-922ad0fc22fa.png?v=1768436768",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_e2e3e651-dcd9-4f44-af98-3c68f0472860.png?v=1768436769",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_4_5c962af3-856b-4417-bb86-fd546c4fe7df.png?v=1768436770"
    }
   },
   "carat": 1.3
  },
  {
   "rank": 104,
   "id": "gid://shopify/Product/10153189540024",
   "title": "1.00CT Round Cut Lab Grown Diamonds - Stud Earrings in Silver",
   "url": "/products/1-00ct-round-cut-lab-grown-diamonds-stud-earrings-in-silver",
   "handle": "1-00ct-round-cut-lab-grown-diamonds-stud-earrings-in-silver",
   "priceNow": 373.99,
   "priceWas": 1121.97,
   "pctOff": 67,
   "core": null,
   "inStock": true,
   "createdAt": "2025-11-27T14:03:27Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/15415LB_w1_0f1cdc36-f203-4669-9648-cde1dcc21f87.jpg?v=1703182580"
   },
   "carat": 1.0
  },
  {
   "rank": 105,
   "id": "gid://shopify/Product/10151640891576",
   "title": "2.10-5.10 CT Princess & Round Cut Fancy Blue Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110350bl",
   "handle": "bridal-sets-110350bl",
   "priceNow": 2443.99,
   "priceWas": 7380.0,
   "pctOff": 67,
   "core": "110350",
   "inStock": true,
   "createdAt": "2025-11-26T04:28:50Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS27_a38abbd1-35b5-4aa7-a2ef-f7b9bb88d2f6.png?v=1781811614",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS27_a38abbd1-35b5-4aa7-a2ef-f7b9bb88d2f6.png?v=1781811614",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS29_34c418f0-c93f-431d-b1d4-4d2dce0819c4.png?v=1781811614",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS28_ba692fd3-bce0-453d-80c4-2d203cf805fa.png?v=1781811614"
    }
   },
   "carat": 2.1,
   "caratMax": 5.1,
   "fancyColor": "blue"
  },
  {
   "rank": 106,
   "id": "gid://shopify/Product/10151558578360",
   "title": "1.10-4.10 CT Round Cut Fancy Yellow Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71910yl",
   "handle": "engagement-rings-71910yl",
   "priceNow": 1927.99,
   "priceWas": 5865.0,
   "pctOff": 67,
   "core": "71910",
   "inStock": true,
   "createdAt": "2025-11-26T00:07:38Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1mKGXdAgm0uTjcyMSaobcie6cwuEemJhW",
      "b": "https://lh3.googleusercontent.com/d/1iKWMlXaVt-5TTk9bs6wfSqdc99SzFTpz",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1CMTXDguJQF4K42Qz3shnGf9azg945qOl",
      "b": "https://lh3.googleusercontent.com/d/1mC8qru1X91O12-lDQvsHcr_pMTbk8xrG",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/18RdlMl_MIyop7BDPa4YHvyrryh_ZVKm8",
      "b": "https://lh3.googleusercontent.com/d/13n9gq48B20yyUvCJY9VkHvN0xQxgTZwF",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/images7_10e75175-ba10-44cc-ba53-5e9f3d2bbc77.png?v=1768437967"
   },
   "carat": 1.1,
   "caratMax": 4.1,
   "fancyColor": "yellow"
  },
  {
   "rank": 107,
   "id": "gid://shopify/Product/9153145438392",
   "title": "1.10 CT Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-15852lb",
   "handle": "wedding-bands-15852lb",
   "priceNow": 1675.99,
   "priceWas": 5200.0,
   "pctOff": 68,
   "core": "15852",
   "inStock": true,
   "createdAt": "2024-07-05T14:12:48Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1aKh0HHxDZ-_dnb_-_ljTuhwoVkrkt0l5",
      "b": "https://lh3.googleusercontent.com/d/1pD4xmCUdNDo08oQDwuyhugNHmAM6H245",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1nzbt7RicRysLjtvd7LM4rZ0e6YSfnyjE",
      "b": "https://lh3.googleusercontent.com/d/1R83UlKr6GpE7MX5y1sbt3aEK40cGRXvS",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1rx7tBrufuKs0Zd0oJxeU-qCDtgjcTYbH",
      "b": "https://lh3.googleusercontent.com/d/136BzRCHafCkfS_cdvERKe925F895JB1C",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold2_DiamondReal_WhiteMatte_b2df5d85-6d2f-488a-b5d9-5b4a35eadafb.jpg?v=1720203128"
   },
   "carat": 1.1
  },
  {
   "rank": 108,
   "id": "gid://shopify/Product/9153144815800",
   "title": "2.45-7.95 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-16006lb",
   "handle": "bridal-sets-16006lb",
   "priceNow": 3110.99,
   "priceWas": 9640.0,
   "pctOff": 68,
   "core": "16006",
   "inStock": true,
   "createdAt": "2024-07-05T14:12:31Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1PiqkIArtdK4i-2qCxBMHBfA1PBqxmXqt",
      "b": "https://lh3.googleusercontent.com/d/1hYEqPb0M2KN-8Yk0Fw-iRcIw-HFD_32W",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1kCQpUIdCXwGAX1DHlyYvVwj5tJqNRlUi",
      "b": "https://lh3.googleusercontent.com/d/15I7R7VTLqSBYP5FnW2b5Di8SoGjRla6P",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1nI1Cf39uyOWu7pGVUZfQpucx_RjeVsqG",
      "b": "https://lh3.googleusercontent.com/d/1XQZ8RTblILr3rxl00LZ2Qi6k5N8w1f5w",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r3_f0f1162e-e631-46a2-9ea3-6bd3a7267040.jpg?v=1720202421"
   },
   "carat": 2.45,
   "caratMax": 7.95
  },
  {
   "rank": 109,
   "id": "gid://shopify/Product/9153144127672",
   "title": "2.30-7.80 CT Princess Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-15853lb",
   "handle": "bridal-sets-15853lb",
   "priceNow": 3800.99,
   "priceWas": 11780.0,
   "pctOff": 68,
   "core": "15853",
   "inStock": true,
   "createdAt": "2024-07-05T14:12:08Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1y7VLoDCVRptM6Xb9IKMqm3UIAp5ipHSF",
      "b": "https://lh3.googleusercontent.com/d/1ilrWM8TK1S-1bCl3sD7l73_DQ60At1ci",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/15c_6CiGDObq0pjnlzHc_ATkIq687Kf9H",
      "b": "https://lh3.googleusercontent.com/d/13DsjiAKWTTyHUM8lg2NODR8mTGrnHEr6",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1kf97ug5mk5_XzEWE7KJxN68KRNd5XJ9e",
      "b": "https://lh3.googleusercontent.com/d/17oGMx-UFtSeRQBENWZLNFMGNGuMjxABs",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold2_WhiteMatte_DiamondReal_e1fb283b-bbc1-4b72-9d40-8fa94662d2b6.jpg?v=1720201816"
   },
   "carat": 2.3,
   "caratMax": 7.8
  },
  {
   "rank": 110,
   "id": "gid://shopify/Product/9122831302840",
   "title": "0.95-6.45 CT Round Cut Lab Grown Diamonds - Three Stone Rings",
   "url": "/products/three-stone-rings-21099lb",
   "handle": "three-stone-rings-21099lb",
   "priceNow": 1436.99,
   "priceWas": 4450.0,
   "pctOff": 68,
   "core": "21099",
   "inStock": true,
   "createdAt": "2024-06-13T18:25:29Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_22d2fc48-be8d-488b-b05d-6a8b183f33c3.jpg?v=1763766473",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_22d2fc48-be8d-488b-b05d-6a8b183f33c3.jpg?v=1763766473",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y2_41170c7e-1631-48df-843a-fe0571999ba8.jpg?v=1763766475",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r2_dd471404-f81c-4557-843c-61315590d84f.jpg?v=1763766477"
    }
   },
   "carat": 0.95,
   "caratMax": 6.45
  },
  {
   "rank": 111,
   "id": "gid://shopify/Product/9122830319800",
   "title": "0.50-6.00 CT Princess Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-21098lbpr",
   "handle": "solitaire-rings-21098lbpr",
   "priceNow": 1496.99,
   "priceWas": 4640.0,
   "pctOff": 68,
   "core": "21098",
   "inStock": true,
   "createdAt": "2024-06-13T18:24:34Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_922192a7-d13b-4910-afcc-033cc8a8f8c7.jpg?v=1763748632"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 112,
   "id": "gid://shopify/Product/9121636647096",
   "title": "0.50-6.00 CT Oval Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-21103lbov",
   "handle": "solitaire-rings-21103lbov",
   "priceNow": 1327.99,
   "priceWas": 4120.0,
   "pctOff": 68,
   "core": "21103",
   "inStock": true,
   "createdAt": "2024-06-12T17:55:47Z",
   "shape": "oval",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_1dbe8c9b-1947-49e9-be68-6d76f3cf89ca.jpg?v=1763748612"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 113,
   "id": "gid://shopify/Product/9106073682104",
   "title": "0.60-6.10 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110336lb",
   "handle": "bridal-sets-110336lb",
   "priceNow": 3072.99,
   "priceWas": 9530.0,
   "pctOff": 68,
   "core": "110336",
   "inStock": true,
   "createdAt": "2024-06-05T15:30:17Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1fx-J1ey7YQU3j3Z49vAn_6_xXIbi6_c4",
      "b": "https://lh3.googleusercontent.com/d/129cLvJsBeWIv5lF9BdqV_PyxgNlTWz5G",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1SQU-ysrbSMeZ9I5sgDmDWouZfsoZKwR7",
      "b": "https://lh3.googleusercontent.com/d/16K0xzOWr8lh-81fl0jGZzXkTZezp74rN",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1UU0QViwX7N_iFfsPTZnUyyWztIeQvN2P",
      "b": "https://lh3.googleusercontent.com/d/1zrRorr38Otmw8d2baEjbJ6CIb2oFeCW-",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_Diamond_YellowGold2_WhiteMatte_d4e9e71b-8d9e-422d-aff2-6fd5f556429c.jpg?v=1717699118"
   },
   "carat": 0.6,
   "caratMax": 6.1
  },
  {
   "rank": 114,
   "id": "gid://shopify/Product/9106073583800",
   "title": "1.00-6.50 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-15248lb",
   "handle": "engagement-rings-15248lb",
   "priceNow": 2130.99,
   "priceWas": 6610.0,
   "pctOff": 68,
   "core": "15248",
   "inStock": true,
   "createdAt": "2024-06-05T15:30:03Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1zVtkGpTnwju-C-k_xLWxPsytz46St87-",
      "b": "https://lh3.googleusercontent.com/d/1bwZ5gG_uuQw5dt6HnUOV-_vD-tmXMNLp",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1I2nH_XeEjpyUBBGKEkiK8gidUojxTI5p",
      "b": "https://lh3.googleusercontent.com/d/12Adjpgdp9_8BrcHVUq02Ts6s4Xx-OOKn",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1zoksjH-UGcXXTQEmqxhkc7QJ-5n83EiS",
      "b": "https://lh3.googleusercontent.com/d/19-AG719-cmTZw0RsgbwdJwwn4zeqhFqj",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_Diamond_YellowGold2_WhiteMatte_YellowGold_Diamond.jpg?v=1765415410"
   },
   "carat": 1.0,
   "caratMax": 6.5
  },
  {
   "rank": 115,
   "id": "gid://shopify/Product/9078738485432",
   "title": "0.30 CT Round Cut Lab Grown Diamonds - Mens Wedding Bands",
   "url": "/products/mens-wedding-bands-71560lb",
   "handle": "mens-wedding-bands-71560lb",
   "priceNow": 1578.99,
   "priceWas": 4890.0,
   "pctOff": 68,
   "core": "71560",
   "inStock": true,
   "createdAt": "2024-05-28T23:05:21Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_46507367-6bbe-4fc3-ab65-9a5b02756959.jpg?v=1717180055"
   },
   "carat": 0.3
  },
  {
   "rank": 116,
   "id": "gid://shopify/Product/9077562441912",
   "title": "1.00 CT Princess Cut Lab Grown Diamonds - Mens Wedding Bands",
   "url": "/products/mens-wedding-bands-15663lb",
   "handle": "mens-wedding-bands-15663lb",
   "priceNow": 1839.99,
   "priceWas": 5700.0,
   "pctOff": 68,
   "core": "15663",
   "inStock": true,
   "createdAt": "2024-05-28T10:40:16Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_6d56420d-dace-41df-b78a-3c03e0371d24.jpg?v=1763697806",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_6d56420d-dace-41df-b78a-3c03e0371d24.jpg?v=1763697806",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y3_d00270d2-4025-4081-a6c0-891baafc0073.jpg?v=1763697806",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r3_0e1dd854-7104-4979-9185-b9bca52463f4.jpg?v=1763697807"
    }
   },
   "carat": 1.0
  },
  {
   "rank": 117,
   "id": "gid://shopify/Product/9077559951544",
   "title": "1.00 CT Princess Cut Lab Grown Diamonds - Mens Wedding Bands",
   "url": "/products/mens-wedding-bands-71476lb",
   "handle": "mens-wedding-bands-71476lb",
   "priceNow": 1791.99,
   "priceWas": 5560.0,
   "pctOff": 68,
   "core": "71476",
   "inStock": true,
   "createdAt": "2024-05-28T10:39:45Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_cb9566ca-757e-451c-81c5-cb31d0cd07ba.jpg?v=1763697865"
   },
   "carat": 1.0
  },
  {
   "rank": 118,
   "id": "gid://shopify/Product/9077559230648",
   "title": "0.85 CT Round Cut Lab Grown Diamonds - Mens Wedding Bands",
   "url": "/products/mens-wedding-bands-71524lb",
   "handle": "mens-wedding-bands-71524lb",
   "priceNow": 1841.99,
   "priceWas": 5710.0,
   "pctOff": 68,
   "core": "71524",
   "inStock": true,
   "createdAt": "2024-05-28T10:39:37Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_0b078d23-7e41-4238-8919-a8d6899459c0.jpg?v=1716922729",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_0b078d23-7e41-4238-8919-a8d6899459c0.jpg?v=1716922729",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y3_8bc228dd-8b1a-42f3-b198-1cc3445e09f7.jpg?v=1763697866",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r3_74612ffa-84d0-4ef2-a0e8-8e525bb8db04.jpg?v=1763697866"
    }
   },
   "carat": 0.85
  },
  {
   "rank": 119,
   "id": "gid://shopify/Product/9074166694072",
   "title": "1.50 CT Round Cut Lab Grown Diamonds - Mens Wedding Bands",
   "url": "/products/mens-wedding-bands-15671lb",
   "handle": "mens-wedding-bands-15671lb",
   "priceNow": 2084.99,
   "priceWas": 6460.0,
   "pctOff": 68,
   "core": "15671",
   "inStock": true,
   "createdAt": "2024-05-27T22:18:11Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_153344d4-bec9-437d-8597-1e4dd1f41a5c.jpg?v=1716922219"
   },
   "carat": 1.5
  },
  {
   "rank": 120,
   "id": "gid://shopify/Product/9074166104248",
   "title": "0.70 CT Round Cut Lab Grown Diamonds - Mens Wedding Bands",
   "url": "/products/mens-wedding-bands-71210lb",
   "handle": "mens-wedding-bands-71210lb",
   "priceNow": 2559.99,
   "priceWas": 7940.0,
   "pctOff": 68,
   "core": "71210",
   "inStock": true,
   "createdAt": "2024-05-27T22:17:41Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_a977185b-ce67-4d28-8ce1-5fa68b8832c3.jpg?v=1716917188"
   },
   "carat": 0.7
  },
  {
   "rank": 121,
   "id": "gid://shopify/Product/7702551396536",
   "title": "1.35-6.85 CT Marquise & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-15221lb",
   "handle": "engagement-rings-15221lb",
   "priceNow": 2065.99,
   "priceWas": 6400.0,
   "pctOff": 68,
   "core": "15221",
   "inStock": true,
   "createdAt": "2024-05-20T17:25:58Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1SSVDCNB5oNm9ZVtA4ygZLc2xnhzKLfmA",
      "b": "https://lh3.googleusercontent.com/d/19xTGLSPKBmFvoExMn1LiGFbZ8SF_UzH2",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1evBgdb3HQNkLcnLsqt5ZW_MQQbmU-JxB",
      "b": "https://lh3.googleusercontent.com/d/1gOi1Zf__dkfm1an-B-t5sh6iLSaI-lEW",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/125Fn8foq7-BAitxOkQXRCeWPT4xYvkem",
      "b": "https://lh3.googleusercontent.com/d/1oczpUrmOU6MbENcGlMMrLmSWk7VHLYf5",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_c63d39df-5a7f-4181-b3ad-2f93e0074f0f.jpg?v=1765415409"
   },
   "carat": 1.35,
   "caratMax": 6.85
  },
  {
   "rank": 122,
   "id": "gid://shopify/Product/7702550937784",
   "title": "0.95-6.45 CT Princess Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71795lb",
   "handle": "engagement-rings-71795lb",
   "priceNow": 2204.99,
   "priceWas": 6840.0,
   "pctOff": 68,
   "core": "71795",
   "inStock": true,
   "createdAt": "2024-05-20T17:25:34Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1vnXpVqe8fCnCLQ0GeLHZ0EFYKdlTRF-Q",
      "b": "https://lh3.googleusercontent.com/d/1HgdkExo04-DXg1-S9ol88pjuzomNCwhS",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1OVKWQNpcgzarUV2UKvy9uoJpLvO8fbQ4",
      "b": "https://lh3.googleusercontent.com/d/1BQrJBaYEonRC5F-0fmiNS7WLglqK1Aul",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1YOAbO53wYhczjdSv7hIIzGEwhyi_thUG",
      "b": "https://lh3.googleusercontent.com/d/1C8vvFcgLlIAMzcpFIYkmYeQ60mHUMxLQ",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_cb0b0962-47ac-443d-91cb-0305995c3c59.jpg?v=1765415417"
   },
   "carat": 0.95,
   "caratMax": 6.45
  },
  {
   "rank": 123,
   "id": "gid://shopify/Product/7641272778936",
   "title": "5.80-11.30 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-15341lb",
   "handle": "bridal-sets-15341lb",
   "priceNow": 3944.99,
   "priceWas": 12230.0,
   "pctOff": 68,
   "core": "15341",
   "inStock": true,
   "createdAt": "2024-04-26T15:52:46Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1M9vS3_sZs0YMMskXP017FUId-ISsQNWk",
      "b": "https://lh3.googleusercontent.com/d/1x5wz1jdveAIQUp4kJeRyeE5fUlByEi1G",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1clpw_3zcIwHgxy174VphCAonrBhPv-AM",
      "b": "https://lh3.googleusercontent.com/d/1XWjHx50s4GWGISViv5w8dM44p3vjTLlR",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1hQPFaIXrwWWrjE2_Nr0MCQrB_jYaGM_5",
      "b": "https://lh3.googleusercontent.com/d/1etCqhfT8m0AAI8FB7d2nuebKYm9DlFYr",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_5c67a4bd-90fd-4bc2-9c15-ceaae752ed28.jpg?v=1714155498"
   },
   "carat": 5.8,
   "caratMax": 11.3
  },
  {
   "rank": 124,
   "id": "gid://shopify/Product/7641272189112",
   "title": "1.95-7.45 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-71596lb",
   "handle": "bridal-sets-71596lb",
   "priceNow": 3051.99,
   "priceWas": 9460.0,
   "pctOff": 68,
   "core": "71596",
   "inStock": true,
   "createdAt": "2024-04-26T15:52:08Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1k_-98hNvoPRYlMMAMPEmsyy5YA2r1QCy",
      "b": "https://lh3.googleusercontent.com/d/1RWZSEj5pHVpu_9KOfS_lfQ6Xy-6wIbQV",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1nAscox-mBmfYrXRj9d4SqkTnkg770CPq",
      "b": "https://lh3.googleusercontent.com/d/1E8ZA7junVh4hdO59UpJJivmW3OF9K4h7",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1GIFiQ5_WQCnFBAvoPpzSn0048Z-eGebn",
      "b": "https://lh3.googleusercontent.com/d/1ALMitzCFr5RWBQCALJvnaZvq2-CJooWD",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_f29231db-d7ae-415a-ac7e-21a477de3963.jpg?v=1714154757"
   },
   "carat": 1.95,
   "caratMax": 7.45
  },
  {
   "rank": 125,
   "id": "gid://shopify/Product/7641270747320",
   "title": "1.50-7.00 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-71777lb",
   "handle": "bridal-sets-71777lb",
   "priceNow": 2757.99,
   "priceWas": 8550.0,
   "pctOff": 68,
   "core": "71777",
   "inStock": true,
   "createdAt": "2024-04-26T15:50:26Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1HlPw9duQWTQzpxm9NZZkYDyuDC6d2Ygr",
      "b": "https://lh3.googleusercontent.com/d/1621nam83YPco-EZ2wJvHiX_MfIeHoX-Q",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1qn9nsVgrUs5ucyF4DqWtYpFzMCIYA-h4",
      "b": "https://lh3.googleusercontent.com/d/1Hww-QzC5CR-_O68VXz5GNeSIIxWKiP1c",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/151AA8_6Dp2cgCF-8La-3XjpCTW41uiYp",
      "b": "https://lh3.googleusercontent.com/d/1hd_vL5ApyOA2mQ_YBLVHzUWvwUhnFPBk",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_18dd1eec-580f-43fa-8ab4-18aea0ade2a6.jpg?v=1714150999"
   },
   "carat": 1.5,
   "caratMax": 7.0
  },
  {
   "rank": 126,
   "id": "gid://shopify/Product/7622361350328",
   "title": "0.50-6.00 CT Round Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-15385lb",
   "handle": "solitaire-rings-15385lb",
   "priceNow": 1310.99,
   "priceWas": 4060.0,
   "pctOff": 68,
   "core": "15385",
   "inStock": true,
   "createdAt": "2024-04-23T15:35:41Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1KqRRWNeqxjRZR9E33Y6KRz0mjfezgPDf",
      "b": "https://lh3.googleusercontent.com/d/1RL6Fw2IlRgpSeHzlX1wAJ44pf9-x8wi5",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1g2PqsA7bngMV6TSgJMz2R_Ar5fK35HnV",
      "b": "https://lh3.googleusercontent.com/d/18V9uFZbTtZv3sEXj0Sw_-3-8CkgQp6jS",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1QGDTh77B4yxooEHWho0ppM35_pgJ0zDa",
      "b": "https://lh3.googleusercontent.com/d/1g2Py3XR9_-4S7qC0mbWjYbSqPdGClxg2",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_564b0c8f-1838-4f28-b222-a694ea5763a8.jpg?v=1763748620"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 127,
   "id": "gid://shopify/Product/7622360793272",
   "title": "0.50-6.00 CT Round Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-71725lb",
   "handle": "solitaire-rings-71725lb",
   "priceNow": 2434.99,
   "priceWas": 7550.0,
   "pctOff": 68,
   "core": "71725",
   "inStock": true,
   "createdAt": "2024-04-23T15:35:26Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1MTgB6AZhKs6h-Iid-wtaNcC8rqzT4oH5",
      "b": "https://lh3.googleusercontent.com/d/13ea13LKTLgCxSz0I4GKHNTItZC_JWQWW",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1clgEwLlwPlr_m2yRVm_m2Gp5daxJkzM-",
      "b": "https://lh3.googleusercontent.com/d/1DBLb1cRaHEfTKdgDD0KndIsl5_Bnx66Q",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/11tVhGMf_5DSY6RcFui_QumRmH--hg88I",
      "b": "https://lh3.googleusercontent.com/d/1mnEXf3edUbwxkNnnT7HaFYPc95Iy5L5Z",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_71718606-5183-4533-86d3-39510a0e77bf.jpg?v=1763748623"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 128,
   "id": "gid://shopify/Product/7613666525368",
   "title": "1.70-7.20 CT Princess Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-16045lb",
   "handle": "engagement-rings-16045lb",
   "priceNow": 2244.99,
   "priceWas": 6960.0,
   "pctOff": 68,
   "core": "16045",
   "inStock": true,
   "createdAt": "2024-04-22T15:44:53Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1G0kTuKyCNcSSl5LyRytZyF1ER2Vpo6Ju",
      "b": "https://lh3.googleusercontent.com/d/1iXzoXUV4hpdeW9pPeXQNozNdweqG2Yn6",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/19ETyQ1wq77kWcoi82ijVcctiZVUHuX9u",
      "b": "https://lh3.googleusercontent.com/d/10GsXHFl3Pl9wfONwu4Bvgp2fYlc04MYi",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/13noRPFKKsmEqoD88GcncIBSlfdlfv7vy",
      "b": "https://lh3.googleusercontent.com/d/1yvWhcrbmLcgX7E0nQ9Hl0E8a2tNn_-rl",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_c05a469e-fec2-405a-8e7b-e749339004ad.jpg?v=1765415409"
   },
   "carat": 1.7,
   "caratMax": 7.2
  },
  {
   "rank": 129,
   "id": "gid://shopify/Product/7613589782712",
   "title": "1.20-6.70 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71743lb",
   "handle": "engagement-rings-71743lb",
   "priceNow": 2001.99,
   "priceWas": 6210.0,
   "pctOff": 68,
   "core": "71743",
   "inStock": true,
   "createdAt": "2024-04-22T14:39:01Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1t5irv2eidExKEZmNtTn03fa_8d_Z_VLj",
      "b": "https://lh3.googleusercontent.com/d/1IX-reXGxjcPvqfbjP_UIMbN7etUsBTxr",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1PKglYs1qIjKK4ZVZ5UVdFlmP3TV9IkF1",
      "b": "https://lh3.googleusercontent.com/d/1OHQwuySEoFug5jU1KDEKp0KfyxdqsLu2",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Bz5oM4j9C7-vMvasqljzvF5Iqc8ZpkWH",
      "b": "https://lh3.googleusercontent.com/d/1twgNNCRb-R-fpDPujohI_sjZ13ZAhOSk",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_c61023dc-4b06-4dfe-8ba1-53a47753f72d.jpg?v=1765415417"
   },
   "carat": 1.2,
   "caratMax": 6.7
  },
  {
   "rank": 130,
   "id": "gid://shopify/Product/7613588832440",
   "title": "1.10-6.60 CT Round & Triangle Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71869lb",
   "handle": "engagement-rings-71869lb",
   "priceNow": 1663.99,
   "priceWas": 5160.0,
   "pctOff": 68,
   "core": "71869",
   "inStock": true,
   "createdAt": "2024-04-22T14:38:20Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1Fu_vIWUAavK5pk5y0Ur4-5szhBgx_HJu",
      "b": "https://lh3.googleusercontent.com/d/1wAvMgT1NyXTyFgsg39JvJXU0dZE7GhZE",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1A7C3AF34Slq3TENWECP3-G2VS0IVyjvk",
      "b": "https://lh3.googleusercontent.com/d/1WYxVTumEwB268U0chhw2ge1yfoVLTSAC",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1uSnaG95gv8PDyzXnQ2R1ar2bSy9vvFqu",
      "b": "https://lh3.googleusercontent.com/d/1URr7pUmJ70oc_wLWkzDHdAGgswVNfcjp",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_e37688f8-10ba-4d68-963a-886c45cf227f.jpg?v=1765415417"
   },
   "carat": 1.1,
   "caratMax": 6.6
  },
  {
   "rank": 131,
   "id": "gid://shopify/Product/7601926078648",
   "title": "1.00-6.50 CT Princess Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-15667lb",
   "handle": "engagement-rings-15667lb",
   "priceNow": 1917.99,
   "priceWas": 5950.0,
   "pctOff": 68,
   "core": "15667",
   "inStock": true,
   "createdAt": "2024-04-19T15:29:28Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1itqiMWouIKEkcwoaNyloueT-wbNorWZP",
      "b": "https://lh3.googleusercontent.com/d/1fuxxRsyqGtYbBdbSuJhOjEgCAvzfHIN2",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/13PjXw6UXJBfoAixtuE3aVHLUZ2SXiAQg",
      "b": "https://lh3.googleusercontent.com/d/1VCP01Dt2XKSzpl5n6JBwRi4viOtkLjMP",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1438vJJ63LUVmVffK2KpvwyjGD4Jl7li5",
      "b": "https://lh3.googleusercontent.com/d/1NxW3hy65DUt_XwCw6P8ZcfUx3LU1Clt5",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_4029ef65-5bd9-442f-b91e-6af5f4c29912.jpg?v=1765414865"
   },
   "carat": 1.0,
   "caratMax": 6.5
  },
  {
   "rank": 132,
   "id": "gid://shopify/Product/7596596428984",
   "title": "1.15-6.65 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-15241lb",
   "handle": "engagement-rings-15241lb",
   "priceNow": 1858.99,
   "priceWas": 5760.0,
   "pctOff": 68,
   "core": "15241",
   "inStock": true,
   "createdAt": "2024-04-18T15:37:18Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1mMDhHMGz8dHvEA7uWm5PWUsbPOu2k4_7",
      "b": "https://lh3.googleusercontent.com/d/1aY-dUe1SYPsj7qiBNr0RDZJ4nYEwTsU8",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1arpEJBxhrFRG0qRmWNuprtX7mXKDl6tf",
      "b": "https://lh3.googleusercontent.com/d/1rrZUB7MeK__7VXXfGlbWqAj0jn6_h0Gd",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1txUig-jDnkkZLysLfFnA3yWNvMXDHZOv",
      "b": "https://lh3.googleusercontent.com/d/1o4rmPukx7jXE-hhaFxLymHYrPEIgRvJj",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_7a3bc56f-65ae-4db0-8696-c62b68317f64.jpg?v=1765414968"
   },
   "carat": 1.15,
   "caratMax": 6.65
  },
  {
   "rank": 133,
   "id": "gid://shopify/Product/7562057318584",
   "title": "1.10 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-16005lb",
   "handle": "wedding-bands-16005lb",
   "priceNow": 1427.99,
   "priceWas": 4430.0,
   "pctOff": 68,
   "core": "16005",
   "inStock": true,
   "createdAt": "2024-04-10T22:36:18Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1BbRy2dyBi32HUw7M-bAx7VdMWRf_gKbP",
      "b": "https://lh3.googleusercontent.com/d/1xFWNYmu-OP8IZ26SNnJ69Pts6VONs37G",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/17NdMWbRCvfDoZR7SAgpHkSrDTQOQh8kN",
      "b": "https://lh3.googleusercontent.com/d/1wGmb1uH_I0NiLJmzgzpFe4ACoTiAyR0U",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1UpZ7-E67P9oOL_81yblZt2AoH_Kznjt0",
      "b": "https://lh3.googleusercontent.com/d/1zCa0HC174DLI99yjF1clKOt1A8jkGTze",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_3359c38d-7f59-402a-a056-45987540d91d.jpg?v=1763698581"
   },
   "carat": 1.1
  },
  {
   "rank": 134,
   "id": "gid://shopify/Product/7562057285816",
   "title": "0.90-6.40 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71775lb",
   "handle": "engagement-rings-71775lb",
   "priceNow": 1670.99,
   "priceWas": 5180.0,
   "pctOff": 68,
   "core": "71775",
   "inStock": true,
   "createdAt": "2024-04-10T22:36:12Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1yE0UcRgLF31LVvFROyvJEtYv9WXm3XaM",
      "b": "https://lh3.googleusercontent.com/d/1iiKbCNmykpbPKRMIVWso0pWsCUe7rjHc",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1dhWedibxpH6ALUfjhhmA2Zk_6i_KbF32",
      "b": "https://lh3.googleusercontent.com/d/1YpNHKX9KW5yqcJLU7xacxbfPpeN852VP",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1V2r67Ho9LWSNB65lrBS_clJopphOfj7l",
      "b": "https://lh3.googleusercontent.com/d/14_aTf6W7A189qgVD86qFDkOaFh3HFe_C",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_16e05839-c8c0-4020-85b3-89ec937bef99.jpg?v=1765415089"
   },
   "carat": 0.9,
   "caratMax": 6.4
  },
  {
   "rank": 135,
   "id": "gid://shopify/Product/7544414142648",
   "title": "1.35 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-15685lb",
   "handle": "wedding-bands-15685lb",
   "priceNow": 1522.99,
   "priceWas": 4720.0,
   "pctOff": 68,
   "core": "15685",
   "inStock": true,
   "createdAt": "2024-04-04T17:43:50Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1RYiYDenov2Q7mydTYJiivXkvUYnjSUjs",
      "b": "https://lh3.googleusercontent.com/d/1THm1oTldzhVP8eryT_GiZexLR0BOP9Kt",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1cpBUuecfwPaKn5q6da2HILzXnTS11Sp3",
      "b": "https://lh3.googleusercontent.com/d/1AOtlS6a4FdDFwGqR-V2sJQZe5nA2AB_n",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1-sikIFw9XvqIY0h9ZtgBL1J0k4FA-SCk",
      "b": "https://lh3.googleusercontent.com/d/11mUDPO_wEkiS45ad8b8Ep9o2ztqxaV0b",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_0ebcfb74-9be9-4194-9fdd-d92b61fe70ec.jpg?v=1712254641"
   },
   "carat": 1.35
  },
  {
   "rank": 136,
   "id": "gid://shopify/Product/7509723152568",
   "title": "0.30 CT  Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-16024lb",
   "handle": "wedding-bands-16024lb",
   "priceNow": 800.99,
   "priceWas": 2720.0,
   "pctOff": 71,
   "core": "16024",
   "inStock": true,
   "createdAt": "2024-03-26T23:43:44Z",
   "shape": null,
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1JOU_8zy6Rt9smluG7JO-B3rMK40hQQ9t",
      "b": "https://lh3.googleusercontent.com/d/1FDArdAU2y8ayicDapvTMxIRfK-HvsWfF",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1N2Py3dIsW69390ycQqW4hm_jDzPdDixq",
      "b": "https://lh3.googleusercontent.com/d/1BbPpamamh7VBLsViGR_V1HuZz14l2_wT",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1OX5xPrX-trMiml9D1LjuAK70bLUW7G2d",
      "b": "https://lh3.googleusercontent.com/d/1oVDjIyo9bWxS-ihP80AosVfmGjbsSonG",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_3a4eaf54-89d2-45dd-9f58-f79fc83f480e.jpg?v=1763698615"
   },
   "carat": 0.3
  },
  {
   "rank": 137,
   "id": "gid://shopify/Product/7509722988728",
   "title": "1.30-6.80 CT Round Cut Lab Grown Diamonds - Three Stone Rings",
   "url": "/products/three-stone-rings-15316lb",
   "handle": "three-stone-rings-15316lb",
   "priceNow": 1963.99,
   "priceWas": 6090.0,
   "pctOff": 68,
   "core": "15316",
   "inStock": true,
   "createdAt": "2024-03-26T23:43:21Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1wg9O4nLTZxp70I7xDjGjQMYDOX8uzBNH",
      "b": "https://lh3.googleusercontent.com/d/1B-XokVOcs2uqVBgIbhNTdf2i1UacwM6W",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1aNEzeZsvc2B-9Sr0k98PzYei2lU6-q2c",
      "b": "https://lh3.googleusercontent.com/d/1FUQKHRXjEw-C6_T1SVy9DoVy0YMt04Sw",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1vndeRnpBEd3csdwmAYmwAzr4x_9pxYgO",
      "b": "https://lh3.googleusercontent.com/d/1JenPq60whQsRhyU7GTXoSQjYgDMVmo-h",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_ce3d1186-dc7a-474b-b019-94b546108f2a.jpg?v=1763766474"
   },
   "carat": 1.3,
   "caratMax": 6.8
  },
  {
   "rank": 138,
   "id": "gid://shopify/Product/7499104485560",
   "title": "1.25 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-15295lb",
   "handle": "wedding-bands-15295lb",
   "priceNow": 1600.99,
   "priceWas": 4960.0,
   "pctOff": 68,
   "core": "15295",
   "inStock": true,
   "createdAt": "2024-03-20T10:10:14Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1Wd7IOtWcSb7bD92PJVsAHvklLz41WMgG",
      "b": "https://lh3.googleusercontent.com/d/11ItnH6L9nQ9-6r9qM0uw28nGyimeRm_v",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1eWoqQWBDBdoWo3tVUXm5_d6ufhf5v2yb",
      "b": "https://lh3.googleusercontent.com/d/15--6tzUuDnWTjwujpCsKAe2AIv5Biz1J",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1fb0gD50E6fcnuObeMEkCoYyKESuW8_dq",
      "b": "https://lh3.googleusercontent.com/d/17eV0SZV0eRMg0549ASU8vpG865Xc2Y-f",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_0227ba94-6804-4338-bd9a-4c7b15774050.jpg?v=1711104387"
   },
   "carat": 1.25
  },
  {
   "rank": 139,
   "id": "gid://shopify/Product/7499104190648",
   "title": "0.95-6.45 CT Princess Cut Lab Grown Diamonds - Three Stone Rings",
   "url": "/products/three-stone-rings-15306lb",
   "handle": "three-stone-rings-15306lb",
   "priceNow": 1652.99,
   "priceWas": 5120.0,
   "pctOff": 68,
   "core": "15306",
   "inStock": true,
   "createdAt": "2024-03-20T10:09:58Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1NTHu3wV5UTrrru1kEnqXhZg718WQ_-if",
      "b": "https://lh3.googleusercontent.com/d/1y6EMlmH8VmHCWKucH4Vi_AfNCS5GaGzL",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1s18W_V07iX-HBeAS9pEnRDiOS6i-1-tC",
      "b": "https://lh3.googleusercontent.com/d/16_atjnWKKreAbjySmhLJwhX4RK8DP19U",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1EBJwsHYDPgMeUkhn5-bYYj3bn3PQHC38",
      "b": "https://lh3.googleusercontent.com/d/1VsFEgp-GNVimEMCAU8Wd2enZ4P5_Uriu",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_049fee98-9624-43b2-a5ab-c2c85e458253.jpg?v=1763766473"
   },
   "carat": 0.95,
   "caratMax": 6.45
  },
  {
   "rank": 140,
   "id": "gid://shopify/Product/7499103535288",
   "title": "0.75-6.25 CT Round Cut Lab Grown Diamonds - Three Stone Rings",
   "url": "/products/three-stone-rings-15617lb",
   "handle": "three-stone-rings-15617lb",
   "priceNow": 1382.99,
   "priceWas": 4290.0,
   "pctOff": 68,
   "core": "15617",
   "inStock": true,
   "createdAt": "2024-03-20T10:09:24Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_e4411104-5096-4fcf-a15b-6324e3867d8b.jpg?v=1763766477",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_e4411104-5096-4fcf-a15b-6324e3867d8b.jpg?v=1763766477",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y3_6f6ef327-b0d6-4ced-abeb-a817a841a1a9.jpg?v=1763766480",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r3_d9e78abd-2b6b-450f-9768-dbe338640080.jpg?v=1763766483"
    }
   },
   "carat": 0.75,
   "caratMax": 6.25
  },
  {
   "rank": 141,
   "id": "gid://shopify/Product/7488957776056",
   "title": "0.80 CT Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-15703lb",
   "handle": "wedding-bands-15703lb",
   "priceNow": 1283.99,
   "priceWas": 3980.0,
   "pctOff": 68,
   "core": "15703",
   "inStock": true,
   "createdAt": "2024-03-16T00:44:12Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1rMXRvbeCJx_yEwdQ54ls13Udg_DYQQqG",
      "b": "https://lh3.googleusercontent.com/d/1hJAPCkBDPPAej_SOUTj6xR34E726dJXs",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1lP5AUlVOY8Tc9LhfHsapymY1ErCEGghE",
      "b": "https://lh3.googleusercontent.com/d/1dVbt-kFz4fVPglFnFuxFYTm599_WdLDL",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1LDPIUZEmd8LIqACH7wT46ClcW82nWxE3",
      "b": "https://lh3.googleusercontent.com/d/1hVevjesFkiMGQkWdI8x_Qalq1r_rJ3mI",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_fc38bb1b-2c3c-4e28-b313-748d7d61d110.jpg?v=1710885649"
   },
   "carat": 0.8
  },
  {
   "rank": 142,
   "id": "gid://shopify/Product/7488957710520",
   "title": "0.65 CT Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-16075lb",
   "handle": "wedding-bands-16075lb",
   "priceNow": 1327.99,
   "priceWas": 4120.0,
   "pctOff": 68,
   "core": "16075",
   "inStock": true,
   "createdAt": "2024-03-16T00:43:59Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1N_bm9GMbS6dIeWUiVcKN9JDeZeNq-ZbQ",
      "b": "https://lh3.googleusercontent.com/d/1qhA9p9f-yOryQUln-4EtiFaYtoZRx_p_",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1Dz7MNwRyymZXUZA9E4h87s4Oyya8r0L7",
      "b": "https://lh3.googleusercontent.com/d/1jdzrGkKWTSYmUfYOoq0Vs8qUrVkEm1ha",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/11X_DjDzLXgfN_UTWB8xDjesHtvfAzxmr",
      "b": "https://lh3.googleusercontent.com/d/1-6gF2KYSEEooG7apq73EZ68-jRWCxKtm",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_5dd278cd-aff1-4f7c-870c-83794ba1028d.jpg?v=1710887025"
   },
   "carat": 0.65
  },
  {
   "rank": 143,
   "id": "gid://shopify/Product/7476265746616",
   "title": "5.50 CT Emerald Cut Lab Grown Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15365lb",
   "handle": "eternity-rings-15365lb",
   "priceNow": 2875.99,
   "priceWas": 8920.0,
   "pctOff": 68,
   "core": "15365",
   "inStock": true,
   "createdAt": "2024-03-10T18:51:47Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1R9ueVskiiNH56A1yFPudUM2K_ZB5KBh3",
      "b": "https://lh3.googleusercontent.com/d/1tgMqU7jrj-QO5MBMZ9C6l1ao6glrgeLR",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1-biDU5p8I91n-UkCwVrFz7k13eKU82Gy",
      "b": "https://lh3.googleusercontent.com/d/1jF4-Bl3b4TLk5JED2L0UZ5WjEUVBUCzh",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ucJ90lQ_S5p_pz2xfzBNvaMlSuIAXbF4",
      "b": "https://lh3.googleusercontent.com/d/15Obg5fjWHl1sah9HTNjRdbme1gFPzH3H",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_1769e9de-5bba-42cf-bf27-705ae1ef601d.jpg?v=1763699079"
   },
   "carat": 5.5
  },
  {
   "rank": 144,
   "id": "gid://shopify/Product/7476265681080",
   "title": "1.20 CT Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-15268lb",
   "handle": "wedding-bands-15268lb",
   "priceNow": 1650.99,
   "priceWas": 5120.0,
   "pctOff": 68,
   "core": "15268",
   "inStock": true,
   "createdAt": "2024-03-10T18:51:44Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/15pFRPrDme54epMb5RNVzheb6pVDQanRO",
      "b": "https://lh3.googleusercontent.com/d/1WJef3z-DLaMCBtJXXOH_7ELwMn-XKWFs",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1oNpLtvmPh1mHBl8raSkOAzY1gk3C7FcX",
      "b": "https://lh3.googleusercontent.com/d/11wD-Bnay99mW5tB0TjiP70KdqmRybnVd",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1FeifEm2s-J5HVD9UInNWyPgdnjTvryQb",
      "b": "https://lh3.googleusercontent.com/d/1EufTMBKITeOYr_xlyIQ4mntacIhmMd71",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_c65ed64c-3d66-4c82-b181-204d803eee06.jpg?v=1763699103"
   },
   "carat": 1.2
  },
  {
   "rank": 145,
   "id": "gid://shopify/Product/7476265320632",
   "title": "2.00-6.00 CT Round Cut Lab Grown Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71704lb",
   "handle": "eternity-rings-71704lb",
   "priceNow": 1650.99,
   "priceWas": 5120.0,
   "pctOff": 68,
   "core": "71704",
   "inStock": true,
   "createdAt": "2024-03-10T18:51:33Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1Jbp97R54lR_jvl69R3Otd9RXpRNpJUr1",
      "b": "https://lh3.googleusercontent.com/d/1WPHmGAhb1jwnWQokfhOWfUmJMHeeZ687",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1lOdPrhmAB5UhI4ZvnQ0tbdATf2D0gaA4",
      "b": "https://lh3.googleusercontent.com/d/1JaufbOVy4rK1F21ls4gbGqueVldnXMVI",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/14oczLPdsbKVUWa2YZ5U_03f1G1LU4ZUI",
      "b": "https://lh3.googleusercontent.com/d/1B356RBYEIaNKbtFNZPDrV6_GxLDi-znK",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_5bae8740-0551-42b9-9aee-1ec7e9631e68.jpg?v=1710269686"
   },
   "carat": 2.0,
   "caratMax": 6.0
  },
  {
   "rank": 146,
   "id": "gid://shopify/Product/7476265189560",
   "title": "2.50 CT Round Cut Lab Grown Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15375lb",
   "handle": "eternity-rings-15375lb",
   "priceNow": 2010.99,
   "priceWas": 6230.0,
   "pctOff": 68,
   "core": "15375",
   "inStock": true,
   "createdAt": "2024-03-10T18:51:30Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/140y3U9INXdQlqXpzwrS5crz4CurqiUki",
      "b": "https://lh3.googleusercontent.com/d/1j_rUixNKIJ0DELhVf6i25wbmPk_X4kH_",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/12BKxSYDCoBN10gBJkiCh3773vaXc7-7F",
      "b": "https://lh3.googleusercontent.com/d/1InPT1fnEFy6Nc4JjRZmpzAnU5HGFi-fK",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/13SWzEZQf6hlbE54o-uOEEdyD-iCW0NiU",
      "b": "https://lh3.googleusercontent.com/d/1W7oiIhMSi8TRB9kaGzYDM8JXp3MtiOks",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_fda8127d-948b-4c12-abc6-93148df68133.jpg?v=1710271206"
   },
   "carat": 2.5
  },
  {
   "rank": 147,
   "id": "gid://shopify/Product/7476265091256",
   "title": "1.25-4.00 CT Round Cut Lab Grown Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-16072lb",
   "handle": "eternity-rings-16072lb",
   "priceNow": 1487.99,
   "priceWas": 4610.0,
   "pctOff": 68,
   "core": "16072",
   "inStock": true,
   "createdAt": "2024-03-10T18:51:26Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1BZYO1440vZm4rKQ4p9Bkod-9sibRpXWp",
      "b": "https://lh3.googleusercontent.com/d/1lG7QfyBxry_6iJQ1rQkqYPjJU--ySbUC",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1tT3PfyGg4ufXJvJmCYZJjM0Z2cptM1VF",
      "b": "https://lh3.googleusercontent.com/d/10sjC36kn2_6rPZAlyFk01KZRV0VycGsQ",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/16lkI_Mm5vfLqXzMDuqNQqlNmwBFbo8QC",
      "b": "https://lh3.googleusercontent.com/d/16LC5tZTwImWrGMk8oDwAfy35E5AakHXx",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_9f755c17-244c-434d-9df6-53ecacb6e3d8.jpg?v=1710274013"
   },
   "carat": 1.25,
   "caratMax": 4.0
  },
  {
   "rank": 148,
   "id": "gid://shopify/Product/7476264861880",
   "title": "3.00-7.00 CT Princess Cut Lab Grown Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15360lb",
   "handle": "eternity-rings-15360lb",
   "priceNow": 1905.99,
   "priceWas": 5910.0,
   "pctOff": 68,
   "core": "15360",
   "inStock": true,
   "createdAt": "2024-03-10T18:51:19Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1L7zOGr1fjRxZqiIM9Om1WHrau_NdsrWe",
      "b": "https://lh3.googleusercontent.com/d/1dWEyvHL1M5xm58VZQ7TCRYhnZMFfqp33",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1Iw0dfZiNzH6INyrl8i-wE-iMg7QMV5mi",
      "b": "https://lh3.googleusercontent.com/d/1GmdRK2GDqmSL9BUkDwDo351kcFd-b_lU",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1fF3tbenTzoJoAqYrDdAfoxWQjBmfavsN",
      "b": "https://lh3.googleusercontent.com/d/1UjfO28gQWXWQ6maLjldXpTnMPXbMJpmK",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_ec576517-f21d-461a-ab4f-d4dcd3f1b0cc.jpg?v=1763697467"
   },
   "carat": 3.0,
   "caratMax": 7.0
  },
  {
   "rank": 149,
   "id": "gid://shopify/Product/7330472198328",
   "title": "0.60-5.00 CT Oval Cut Lab Grown Diamonds - Stud Earrings",
   "url": "/products/0-60-5-00-ct-oval-cut-lab-grown-diamonds-stud-earrings-71921lb",
   "handle": "0-60-5-00-ct-oval-cut-lab-grown-diamonds-stud-earrings-71921lb",
   "priceNow": 1354.99,
   "priceWas": 4200.0,
   "pctOff": 68,
   "core": "71921",
   "inStock": true,
   "createdAt": "2023-10-20T09:19:13Z",
   "shape": "oval",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1UvTMU0wK15XicVcJmgyOlVKE1R8879bf",
      "b": "https://lh3.googleusercontent.com/d/1iI4GnquiKlE-5MlAt8Wj8sgdlpmwfnh6",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1ylwgzCtOL21tATiewl7MVOIGpVj4nz1w",
      "b": "https://lh3.googleusercontent.com/d/1zkVAsIF6K4ouq_pENoFw2gzlK2msI5C7",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1R9hSkbiSCiF6ZMJCfVtGaLsnRAawlrAp",
      "b": "https://lh3.googleusercontent.com/d/1qLgNtkJ7RFWQXOrVl0lSAet8QvPW01z3",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-oval-cut-lab-grown-diamonds-stud-earrings-195131.jpg?v=1698786140"
   },
   "carat": 0.6,
   "caratMax": 5.0
  },
  {
   "rank": 150,
   "id": "gid://shopify/Product/7328605962424",
   "title": "0.60-5.00 CT Round Cut Lab Grown Diamonds - Stud Earrings",
   "url": "/products/0-60-5-00-ct-round-cut-lab-grown-diamonds-stud-earrings-71193lb",
   "handle": "0-60-5-00-ct-round-cut-lab-grown-diamonds-stud-earrings-71193lb",
   "priceNow": 1062.99,
   "priceWas": 3300.0,
   "pctOff": 68,
   "core": "71193",
   "inStock": true,
   "createdAt": "2023-10-19T09:10:31Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1cT1jIXqAk7RHQOVJixho9I-MTaskZOXi",
      "b": "https://lh3.googleusercontent.com/d/1i7U7sLy5HFu0Kof6r8ebHhi88Zt7o_4l",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/16R3m_kC9P0R_CyRjvk25tmtP31sprMYP",
      "b": "https://lh3.googleusercontent.com/d/1cZY7B3nLEKkP1-JtQBpFs5v0W-HGFLIO",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1mngzxZxHFj0DUputerYb82EdJp1ZwXzV",
      "b": "https://lh3.googleusercontent.com/d/1mclm_GAtoNf33cF0pnH4CSSuWDQ4oZ5v",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-round-cut-lab-grown-diamonds-stud-earrings-545058.jpg?v=1698786142"
   },
   "carat": 0.6,
   "caratMax": 5.0
  },
  {
   "rank": 151,
   "id": "gid://shopify/Product/7328605438136",
   "title": "0.60-5.00 CT Princess Cut Lab Grown Diamonds - Stud Earrings",
   "url": "/products/0-60-5-00-ct-princess-cut-lab-grown-diamonds-stud-earrings-15421lb",
   "handle": "0-60-5-00-ct-princess-cut-lab-grown-diamonds-stud-earrings-15421lb",
   "priceNow": 1092.99,
   "priceWas": 3390.0,
   "pctOff": 68,
   "core": "15421",
   "inStock": true,
   "createdAt": "2023-10-19T09:10:15Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1IZVay0S2xglSd3UYO9aoSgSAB3t8MFAK",
      "b": "https://lh3.googleusercontent.com/d/1kw_cHV2PaWVPKwmghe486HL6BIMR09Wc",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1FLjCWlG2aMH5Q3zrhpAojI6ubJp_Vg2S",
      "b": "https://lh3.googleusercontent.com/d/1NvTxtsAejGK0YxpvaSUO3sbi-E92by-w",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ZrlZwUtTFUM1ppGJ35Kq5exDfPxaqnGu",
      "b": "https://lh3.googleusercontent.com/d/1eD8qHJKGauZC3aFBt8TgD8nHvfCUDftU",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-princess-cut-lab-grown-diamonds-stud-earrings-881538.jpg?v=1698786140"
   },
   "carat": 0.6,
   "caratMax": 5.0
  },
  {
   "rank": 152,
   "id": "gid://shopify/Product/7328604782776",
   "title": "0.60-5.00 CT Round Cut Lab Grown Diamonds - Stud Earrings",
   "url": "/products/0-60-5-00-ct-round-cut-lab-grown-diamonds-stud-earrings-15418lb",
   "handle": "0-60-5-00-ct-round-cut-lab-grown-diamonds-stud-earrings-15418lb",
   "priceNow": 1062.99,
   "priceWas": 3300.0,
   "pctOff": 68,
   "core": "15418",
   "inStock": true,
   "createdAt": "2023-10-19T09:09:51Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1J3hiKWA9K4dsxzLmuWg3ahXHnCmUTVJg",
      "b": "https://lh3.googleusercontent.com/d/1YnPOxqGGUU1rEpMRoJRNM2OUEpBJc9Dk",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/138Mfdlnfu18lThmOpsnobx9MF-DwtaEB",
      "b": "https://lh3.googleusercontent.com/d/1DqvV3IbTgU2zyeeZ8-cGkwyDKoah3rc7",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1oJGxxciDQgfuJqevnoPaMTVB7BcLWTwr",
      "b": "https://lh3.googleusercontent.com/d/1tL6sH1I0OBh1szGH7tBBjGu1MMHwLWEN",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-round-cut-lab-grown-diamonds-stud-earrings-545571.jpg?v=1698786142"
   },
   "carat": 0.6,
   "caratMax": 5.0
  },
  {
   "rank": 153,
   "id": "gid://shopify/Product/7305752412344",
   "title": "1.90-7.40 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-90-4-40-ct-round-princess-cut-lab-grown-diamonds-bridal-set-21073lb",
   "handle": "1-90-4-40-ct-round-princess-cut-lab-grown-diamonds-bridal-set-21073lb",
   "priceNow": 2547.99,
   "priceWas": 7900.0,
   "pctOff": 68,
   "core": "21073",
   "inStock": true,
   "createdAt": "2023-08-12T13:45:47Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/190-440-ct-round-princess-cut-lab-grown-diamonds-bridal-set-569739.jpg?v=1714675680",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/190-440-ct-round-princess-cut-lab-grown-diamonds-bridal-set-569739.jpg?v=1714675680",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/190-440-ct-round-princess-cut-lab-grown-diamonds-bridal-set-798059.jpg?v=1763699331",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/190-440-ct-round-princess-cut-lab-grown-diamonds-bridal-set-971230.jpg?v=1763699331"
    }
   },
   "carat": 1.9,
   "caratMax": 7.4
  },
  {
   "rank": 154,
   "id": "gid://shopify/Product/7305752150200",
   "title": "1.80-7.30 CT Princess Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-80-4-30-ct-princess-cut-lab-grown-diamonds-bridal-set-21071lb",
   "handle": "1-80-4-30-ct-princess-cut-lab-grown-diamonds-bridal-set-21071lb",
   "priceNow": 2616.99,
   "priceWas": 8110.0,
   "pctOff": 68,
   "core": "21071",
   "inStock": true,
   "createdAt": "2023-08-12T13:45:24Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/180-430-ct-princess-cut-lab-grown-diamonds-bridal-set-714822.jpg?v=1714758902",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/180-430-ct-princess-cut-lab-grown-diamonds-bridal-set-714822.jpg?v=1714758902",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/180-430-ct-princess-cut-lab-grown-diamonds-bridal-set-978333.jpg?v=1763699332",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/180-430-ct-princess-cut-lab-grown-diamonds-bridal-set-751714.jpg?v=1763699331"
    }
   },
   "carat": 1.8,
   "caratMax": 7.3
  },
  {
   "rank": 155,
   "id": "gid://shopify/Product/7305446850744",
   "title": "0.65-6.15 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/0-65-3-15-ct-round-cut-lab-grown-diamonds-bridal-set-21043lb",
   "handle": "0-65-3-15-ct-round-cut-lab-grown-diamonds-bridal-set-21043lb",
   "priceNow": 1716.99,
   "priceWas": 5320.0,
   "pctOff": 68,
   "core": "21043",
   "inStock": true,
   "createdAt": "2023-08-10T22:56:35Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/065-315-ct-round-cut-lab-grown-diamonds-bridal-set-587429.jpg?v=1697640148",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/065-315-ct-round-cut-lab-grown-diamonds-bridal-set-109162.jpg?v=1697640148",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/065-315-ct-round-cut-lab-grown-diamonds-bridal-set-431296.jpg?v=1763699365",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/065-315-ct-round-cut-lab-grown-diamonds-bridal-set-581367.jpg?v=1763699373"
    }
   },
   "carat": 0.65,
   "caratMax": 6.15
  },
  {
   "rank": 156,
   "id": "gid://shopify/Product/7305446785208",
   "title": "1.00-6.50 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-00-3-50-ct-round-princess-cut-lab-grown-diamonds-bridal-set-21042lb",
   "handle": "1-00-3-50-ct-round-princess-cut-lab-grown-diamonds-bridal-set-21042lb",
   "priceNow": 2840.99,
   "priceWas": 8810.0,
   "pctOff": 68,
   "core": "21042",
   "inStock": true,
   "createdAt": "2023-08-10T22:56:26Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-350-ct-round-princess-cut-lab-grown-diamonds-bridal-set-670085.jpg?v=1714760761",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-350-ct-round-princess-cut-lab-grown-diamonds-bridal-set-670085.jpg?v=1714760761",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-350-ct-round-princess-cut-lab-grown-diamonds-bridal-set-664151.jpg?v=1763699374",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-350-ct-round-princess-cut-lab-grown-diamonds-bridal-set-118855.jpg?v=1763699374"
    }
   },
   "carat": 1.0,
   "caratMax": 6.5
  },
  {
   "rank": 157,
   "id": "gid://shopify/Product/7305446588600",
   "title": "2.35-7.85 CT Princess Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/2-35-4-85-ct-princess-cut-lab-grown-diamonds-bridal-set-15336lb",
   "handle": "2-35-4-85-ct-princess-cut-lab-grown-diamonds-bridal-set-15336lb",
   "priceNow": 3063.99,
   "priceWas": 9500.0,
   "pctOff": 68,
   "core": "15336",
   "inStock": true,
   "createdAt": "2023-08-10T22:56:08Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/11EviSfmerJs9UzVtoJ1KLMsLXnma_5gQ",
      "b": "https://lh3.googleusercontent.com/d/1CY8XOjv2DX2AWfPvUwIsZ6RrEFML4B8O",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1P4igIeNQ76hJslD4uF3CCPay_ek6HUCH",
      "b": "https://lh3.googleusercontent.com/d/1sVdNV_fpF8cx8rQDnz2R6fZdbyj83gxf",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/19xH1EOV0FvG7japr7_ZGgUXilBQapFkf",
      "b": "https://lh3.googleusercontent.com/d/1XVp3rvbfy51q4o02a0gb8E9cuWdJoOno",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/235-485-ct-princess-cut-lab-grown-diamonds-bridal-set-282990.jpg?v=1714760837"
   },
   "carat": 2.35,
   "caratMax": 7.85
  },
  {
   "rank": 158,
   "id": "gid://shopify/Product/7305422110904",
   "title": "2.40-7.90 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/2-40-4-90-ct-round-cut-lab-grown-diamonds-bridal-set-21038lb",
   "handle": "2-40-4-90-ct-round-cut-lab-grown-diamonds-bridal-set-21038lb",
   "priceNow": 2890.99,
   "priceWas": 8960.0,
   "pctOff": 68,
   "core": "21038",
   "inStock": true,
   "createdAt": "2023-08-10T19:12:06Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/240-490-ct-round-cut-lab-grown-diamonds-bridal-set-220312.jpg?v=1714760928",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/240-490-ct-round-cut-lab-grown-diamonds-bridal-set-220312.jpg?v=1714760928",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/240-490-ct-round-cut-lab-grown-diamonds-bridal-set-170003.jpg?v=1763699374",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/240-490-ct-round-cut-lab-grown-diamonds-bridal-set-228255.jpg?v=1763699374"
    }
   },
   "carat": 2.4,
   "caratMax": 7.9
  },
  {
   "rank": 159,
   "id": "gid://shopify/Product/7305421914296",
   "title": "3.05-8.55 CT Emerald & Princess Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/3-05-5-55-ct-princess-emerald-cut-lab-grown-diamonds-bridal-set-15666lb",
   "handle": "3-05-5-55-ct-princess-emerald-cut-lab-grown-diamonds-bridal-set-15666lb",
   "priceNow": 3301.99,
   "priceWas": 10240.0,
   "pctOff": 68,
   "core": "15666",
   "inStock": true,
   "createdAt": "2023-08-10T19:11:40Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1sLTwEwV__cFvFyXtBdo8qaIJrYIShB6N",
      "b": "https://lh3.googleusercontent.com/d/1Z-BhRAdDgJbkhnls6XlWioJWB_TMVzoR",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1bgMXucN1YRqWrY2uFNyGv-PMaw60rEH6",
      "b": "https://lh3.googleusercontent.com/d/15yVVkERWqYmKETwxLrWWKIxOxn3u8yV9",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1YICDo8FimZpJthkkOb7cc58sLsZfKmRj",
      "b": "https://lh3.googleusercontent.com/d/1c_6AOd_lL2XVQHNdFiexE8UAqtFFnFf4",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/305-555-ct-princess-emerald-cut-lab-grown-diamonds-bridal-set-450098.jpg?v=1714761020"
   },
   "carat": 3.05,
   "caratMax": 8.55
  },
  {
   "rank": 160,
   "id": "gid://shopify/Product/7305326526648",
   "title": "0.90-6.40 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/0-90-3-40-ct-round-cut-lab-grown-diamonds-bridal-set-21037lb",
   "handle": "0-90-3-40-ct-round-cut-lab-grown-diamonds-bridal-set-21037lb",
   "priceNow": 2458.99,
   "priceWas": 7620.0,
   "pctOff": 68,
   "core": "21037",
   "inStock": true,
   "createdAt": "2023-08-09T22:38:36Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/090-340-ct-round-cut-lab-grown-diamonds-bridal-set-435517.jpg?v=1714761259",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/090-340-ct-round-cut-lab-grown-diamonds-bridal-set-435517.jpg?v=1714761259",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/090-340-ct-round-cut-lab-grown-diamonds-bridal-set-481579.jpg?v=1763699374",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/090-340-ct-round-cut-lab-grown-diamonds-bridal-set-518121.jpg?v=1763699374"
    }
   },
   "carat": 0.9,
   "caratMax": 6.4
  },
  {
   "rank": 161,
   "id": "gid://shopify/Product/7304432517304",
   "title": "0.90-6.40 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/0-90-3-40-ct-round-cut-lab-grown-diamonds-bridal-set-21025lb",
   "handle": "0-90-3-40-ct-round-cut-lab-grown-diamonds-bridal-set-21025lb",
   "priceNow": 2019.99,
   "priceWas": 6260.0,
   "pctOff": 68,
   "core": "21025",
   "inStock": true,
   "createdAt": "2023-08-04T00:17:26Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/090-340-ct-round-cut-lab-grown-diamonds-bridal-set-129119.jpg?v=1714758745",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/090-340-ct-round-cut-lab-grown-diamonds-bridal-set-129119.jpg?v=1714758745",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/090-340-ct-round-cut-lab-grown-diamonds-bridal-set-653000.jpg?v=1763699564",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/090-340-ct-round-cut-lab-grown-diamonds-bridal-set-666818.jpg?v=1763699564"
    }
   },
   "carat": 0.9,
   "caratMax": 6.4
  },
  {
   "rank": 162,
   "id": "gid://shopify/Product/7304432419000",
   "title": "1.60-7.10 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-60-4-10-ct-round-cut-lab-grown-diamonds-bridal-set-21022lb",
   "handle": "1-60-4-10-ct-round-cut-lab-grown-diamonds-bridal-set-21022lb",
   "priceNow": 2596.99,
   "priceWas": 8050.0,
   "pctOff": 68,
   "core": "21022",
   "inStock": true,
   "createdAt": "2023-08-04T00:17:11Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/160-410-ct-round-cut-lab-grown-diamonds-bridal-set-857210.jpg?v=1714761811",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/160-410-ct-round-cut-lab-grown-diamonds-bridal-set-857210.jpg?v=1714761811",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/160-410-ct-round-cut-lab-grown-diamonds-bridal-set-486493.jpg?v=1763699564",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/160-410-ct-round-cut-lab-grown-diamonds-bridal-set-778438.jpg?v=1763699564"
    }
   },
   "carat": 1.6,
   "caratMax": 7.1
  },
  {
   "rank": 163,
   "id": "gid://shopify/Product/7304432189624",
   "title": "1.65-7.15 CT Oval & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-65-4-15-ct-round-oval-cut-lab-grown-diamonds-bridal-set-16069lb",
   "handle": "1-65-4-15-ct-round-oval-cut-lab-grown-diamonds-bridal-set-16069lb",
   "priceNow": 2778.99,
   "priceWas": 8610.0,
   "pctOff": 68,
   "core": "16069",
   "inStock": true,
   "createdAt": "2023-08-04T00:16:28Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1NZkH1vPP9Cu_1iHUAGqme4EgIOxAnMNx",
      "b": "https://lh3.googleusercontent.com/d/1wMIpiisJwYgIdSqKKzOsDpKxnJ7g8O3Y",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1TGtnZwM7X8Z03DHzoETUouLah51819u1",
      "b": "https://lh3.googleusercontent.com/d/1GPsMvqZfRjv7sosgg3s3cwViP78Hjego",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1OwzUghztTZhN41TAHyh4ZQbMfgnndY2a",
      "b": "https://lh3.googleusercontent.com/d/1PdwyFLvZbPduECgu55PdR1mzpyQUw7Ka",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/165-415-ct-round-oval-cut-lab-grown-diamonds-bridal-set-375896.jpg?v=1714761993"
   },
   "carat": 1.65,
   "caratMax": 7.15
  },
  {
   "rank": 164,
   "id": "gid://shopify/Product/7304057782456",
   "title": "1.50-7.00 CT Princess Cut Lab Grown Diamonds - Three Stone Rings",
   "url": "/products/1-50-4-00-ct-princess-cut-lab-grown-diamonds-three-stone-ring-15326lb",
   "handle": "1-50-4-00-ct-princess-cut-lab-grown-diamonds-three-stone-ring-15326lb",
   "priceNow": 2052.99,
   "priceWas": 6360.0,
   "pctOff": 68,
   "core": "15326",
   "inStock": true,
   "createdAt": "2023-08-01T23:59:38Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/15QO6Tzy0p0MqjxFftkXgfpBMxvYBMBuC",
      "b": "https://lh3.googleusercontent.com/d/14FwiWl3pEnqAVUTLpoAqz0DMcio8flZD",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1ZVBwVh5tPEYnRDr1sQVNfcXvd5bq-dNt",
      "b": "https://lh3.googleusercontent.com/d/15-FESt_H5lQapdE95bYPpPQNCXqqSGx4",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1mTuh8Zuuojl40q1QEvYaQJG14O0ZnRmB",
      "b": "https://lh3.googleusercontent.com/d/1eEHgaIZGHKXx3WezUazKyOoRi8YHx-93",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/150-400-ct-princess-cut-lab-grown-diamonds-three-stone-ring-504396.jpg?v=1763766477"
   },
   "carat": 1.5,
   "caratMax": 7.0
  },
  {
   "rank": 165,
   "id": "gid://shopify/Product/7304057684152",
   "title": "1.70-7.20 CT Emerald Cut Lab Grown Diamonds - Three Stone Rings",
   "url": "/products/1-70-4-20-ct-emerald-cut-lab-grown-diamonds-three-stone-ring-15623lb",
   "handle": "1-70-4-20-ct-emerald-cut-lab-grown-diamonds-three-stone-ring-15623lb",
   "priceNow": 1860.99,
   "priceWas": 5770.0,
   "pctOff": 68,
   "core": "15623",
   "inStock": true,
   "createdAt": "2023-08-01T23:59:01Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1mXZr4GFGvmVq6RlNBoKFyRzToDYWItLI",
      "b": "https://lh3.googleusercontent.com/d/1XAxNFV2o5Uj1zGBqYAbWOjYeRx4nwfKg",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/19zoZy4BpBqIU-P3sCEdoVoXSZWNhEe3E",
      "b": "https://lh3.googleusercontent.com/d/12Hvq3goJznq5PTJS_y5EezTln4HL41m9",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1siKYA7q5OiFd53Pv6RJx1DMKazxO0_xV",
      "b": "https://lh3.googleusercontent.com/d/1z1GCF880LrnMookuZBaLr7I5M3LGo0vm",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/170-420-ct-emerald-cut-lab-grown-diamonds-three-stone-ring-633855.jpg?v=1763766481"
   },
   "carat": 1.7,
   "caratMax": 7.2
  },
  {
   "rank": 166,
   "id": "gid://shopify/Product/7304057389240",
   "title": "1.55-7.05 CT Princess & Round Cut Lab Grown Diamonds - Three Stone Rings",
   "url": "/products/1-55-4-05-ct-round-princess-cut-lab-grown-diamonds-three-stone-ring-102796lb",
   "handle": "1-55-4-05-ct-round-princess-cut-lab-grown-diamonds-three-stone-ring-102796lb",
   "priceNow": 2067.99,
   "priceWas": 6410.0,
   "pctOff": 68,
   "core": "102796",
   "inStock": true,
   "createdAt": "2023-08-01T23:58:06Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/16iYW6wDiyE3xHpVJUZpnXJoX8tfKJFAd",
      "b": "https://lh3.googleusercontent.com/d/1lbD98O8g3ICj-5qDG47rzSuZhoQar-WB",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1URqCeSVhjOmTAF-bDlMF2wbt6eFLYgj2",
      "b": "https://lh3.googleusercontent.com/d/1C9cD3Q6qFwpUJpF5e9iiztv2Zb-u9FhZ",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1u-V1U2twIC9EJxuQvkPYdRvgityd8al_",
      "b": "https://lh3.googleusercontent.com/d/1wmFw8SgcjKSn9g0n10h5Lgq0Gkrwgrmc",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/155-405-ct-round-princess-cut-lab-grown-diamonds-three-stone-ring-712554.jpg?v=1763766480"
   },
   "carat": 1.55,
   "caratMax": 7.05
  },
  {
   "rank": 167,
   "id": "gid://shopify/Product/7304031240376",
   "title": "0.95-6.45 CT Round Cut Lab Grown Diamonds - Halo Rings",
   "url": "/products/0-95-3-45-ct-round-cut-lab-grown-diamonds-halo-ring-71718lb",
   "handle": "0-95-3-45-ct-round-cut-lab-grown-diamonds-halo-ring-71718lb",
   "priceNow": 1424.99,
   "priceWas": 4420.0,
   "pctOff": 68,
   "core": "71718",
   "inStock": true,
   "createdAt": "2023-08-01T18:39:46Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1NnLyU639y1zhpbcePaPmiFjTtkYRa-UV",
      "b": "https://lh3.googleusercontent.com/d/1pEtYFrLj3lFfA9gyahLzImrUyDkRfARj",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1F4SUE0y--uhKfPz-X1k5o-6DUCPEfxd9",
      "b": "https://lh3.googleusercontent.com/d/1H89Njonomb9CiPYozil1ZJL1En3mGJeK",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/17o4q3N7U7rZ4MG0-KFVb9GGf2o-waGJL",
      "b": "https://lh3.googleusercontent.com/d/1S_LwoCtoZwPJ9fUZOKc9p6Od7v-wYDX7",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/095-345-ct-round-cut-lab-grown-diamonds-halo-ring-417735.jpg?v=1714499754"
   },
   "carat": 0.95,
   "caratMax": 6.45
  },
  {
   "rank": 168,
   "id": "gid://shopify/Product/7303610237112",
   "title": "1.60-7.10 CT Princess Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/1-60-4-10-ct-princess-cut-lab-grown-diamonds-engagement-ring-15651lb",
   "handle": "1-60-4-10-ct-princess-cut-lab-grown-diamonds-engagement-ring-15651lb",
   "priceNow": 2180.99,
   "priceWas": 6760.0,
   "pctOff": 68,
   "core": "15651",
   "inStock": true,
   "createdAt": "2023-07-28T19:24:21Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1JNOrOK3K1A65P8NIlWFMkccaUNmJfHCd",
      "b": "https://lh3.googleusercontent.com/d/1gLIZViBWDWlbS3GTejFVBH0umvPiUaRo",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1e5A_u1XVyLUlURFkqyvv0WbfCm8zaUJE",
      "b": "https://lh3.googleusercontent.com/d/17pi8-NGT0k3YM5NYONBueOtSNb9CAwst",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1BFrIt0tN4kxASdWGMuDVLM2E5G43UyEZ",
      "b": "https://lh3.googleusercontent.com/d/1WsgXDZ9C1WX1HQtbF1ygjDpVfwCsOIhw",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/160-410-ct-princess-cut-lab-grown-diamonds-engagement-ring-160171.jpg?v=1765415289"
   },
   "carat": 1.6,
   "caratMax": 7.1
  },
  {
   "rank": 169,
   "id": "gid://shopify/Product/7303235993784",
   "title": "0.85-6.35 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/0-85-3-35-ct-round-and-princess-cut-lab-grown-diamonds-engagement-ring-71879lb",
   "handle": "0-85-3-35-ct-round-and-princess-cut-lab-grown-diamonds-engagement-ring-71879lb",
   "priceNow": 1464.99,
   "priceWas": 4540.0,
   "pctOff": 68,
   "core": "71879",
   "inStock": true,
   "createdAt": "2023-07-26T21:57:34Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1B8vEB8X5bSSy63HxA8eMbMFKMRqg2MZi",
      "b": "https://lh3.googleusercontent.com/d/1kF-DjHEsd4o_h8rI30pPKKfFe1g-qlGg",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1fu4LIdTdQzyzbZ9nzjmomC_15C6rQ-Vn",
      "b": "https://lh3.googleusercontent.com/d/1vPlLJmArq4aBB3lf5Kfqlg1f-Rkcmljf",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1hzwnRVk0yFPUZiTqQzfHGWgsVi9YHNzB",
      "b": "https://lh3.googleusercontent.com/d/1QGtha1JfbvqtPm8gBv0xZ428tKO4d52y",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/085-335-ct-round-and-princess-cut-lab-grown-diamonds-engagement-ring-995057.jpg?v=1714071263"
   },
   "carat": 0.85,
   "caratMax": 6.35
  },
  {
   "rank": 170,
   "id": "gid://shopify/Product/7303235928248",
   "title": "0.75-6.25 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/0-75-3-25-ct-round-cut-lab-grown-diamonds-engagement-ring-110424lb",
   "handle": "0-75-3-25-ct-round-cut-lab-grown-diamonds-engagement-ring-110424lb",
   "priceNow": 1370.99,
   "priceWas": 4250.0,
   "pctOff": 68,
   "core": "110424",
   "inStock": true,
   "createdAt": "2023-07-26T21:57:08Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1jewv8MqxZW1z6kGuenFtvy_E95TJPnNC",
      "b": "https://lh3.googleusercontent.com/d/1H0caBwgiecK4dv-nw8x5iY6HA3gcpUMq",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1TW3hulFSmyokV7sXMLfP53lp5MIX31s2",
      "b": "https://lh3.googleusercontent.com/d/1_QPUOJgZoo1OucnVPTFKZGz1jmc_bb4X",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1FbyHigKJtNYB76BebcvSoYWPM7ERzFV-",
      "b": "https://lh3.googleusercontent.com/d/1zqDMJVLaBjOqJBNPazKiQeNvhaH_iUUY",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/075-325-ct-round-cut-lab-grown-diamonds-engagement-ring-396427.jpg?v=1714070063"
   },
   "carat": 0.75,
   "caratMax": 6.25
  },
  {
   "rank": 171,
   "id": "gid://shopify/Product/7303235797176",
   "title": "0.70-6.20 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/0-70-3-20-ct-round-cut-lab-grown-diamonds-engagement-ring-103312lb",
   "handle": "0-70-3-20-ct-round-cut-lab-grown-diamonds-engagement-ring-103312lb",
   "priceNow": 1308.99,
   "priceWas": 4060.0,
   "pctOff": 68,
   "core": "103312",
   "inStock": true,
   "createdAt": "2023-07-26T21:56:30Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1_fWAYESLnUgrh3ooFX4N9f1NE5XkXRZx",
      "b": "https://lh3.googleusercontent.com/d/1kaRNgwlx2lEEKVSppQH-gz7kbm9asZh3",
      "angles": [
       5,
       6
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1wNkRVOpoPrDANl4xLIxQKFZhjLa9f8vh",
      "b": "https://lh3.googleusercontent.com/d/1oRUVu452oW8fD3bMsRn9rqWgYkhy6zK0",
      "angles": [
       5,
       6
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1lk76AAd8X8cynyYl8EtoZk57_t0M0A0B",
      "b": "https://lh3.googleusercontent.com/d/1gwUEReGo4XeW7h8Y02YyCD-sazl43M37",
      "angles": [
       5,
       6
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/070-320-ct-round-cut-lab-grown-diamonds-engagement-ring-442510.jpg?v=1714069784"
   },
   "carat": 0.7,
   "caratMax": 6.2
  },
  {
   "rank": 172,
   "id": "gid://shopify/Product/7303235731640",
   "title": "1.65-7.15 CT Emerald & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/1-65-4-15-ct-round-emerald-cut-lab-grown-diamonds-engagement-ring-71858lb",
   "handle": "1-65-4-15-ct-round-emerald-cut-lab-grown-diamonds-engagement-ring-71858lb",
   "priceNow": 1866.99,
   "priceWas": 5790.0,
   "pctOff": 68,
   "core": "71858",
   "inStock": true,
   "createdAt": "2023-07-26T21:56:17Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/15c6pAwIfanj-E22NYrnbGZ25e9jvqoNd",
      "b": "https://lh3.googleusercontent.com/d/1i7IVj8kyKQPb1FFtVAgHquHMct3Poy1u",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1sjrYTBwctP56h6MkIaGo4lu5grJ2W2P_",
      "b": "https://lh3.googleusercontent.com/d/1MU9f8Bkb1KJFgpapNNn37cWZL8CuT9wf",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1aILq4eOPlONIP2thbQsdhRoK05LPlh7P",
      "b": "https://lh3.googleusercontent.com/d/12wCgMTkexFV6SeTrdfuTd0vVqJBzP92E",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/165-415-ct-round-emerald-cut-lab-grown-diamonds-engagement-ring-958286.jpg?v=1714499211"
   },
   "carat": 1.65,
   "caratMax": 7.15
  },
  {
   "rank": 173,
   "id": "gid://shopify/Product/7303137034424",
   "title": "1.05-6.55 CT Oval & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/1-05-3-55-ct-round-oval-cut-lab-grown-diamonds-engagement-ring-16064lb",
   "handle": "1-05-3-55-ct-round-oval-cut-lab-grown-diamonds-engagement-ring-16064lb",
   "priceNow": 1841.99,
   "priceWas": 5710.0,
   "pctOff": 68,
   "core": "16064",
   "inStock": true,
   "createdAt": "2023-07-26T17:48:11Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1hVaDYEWF7AKod99ZgHTH6DGPvYDgf31Q",
      "b": "https://lh3.googleusercontent.com/d/11wPEmLcvaO434BHuu_PEtMgYSYCtQ9f4",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1CCVEOGHaCplit7WVUXfLBy7zMosB3Dss",
      "b": "https://lh3.googleusercontent.com/d/1BI98WLSo8oPxj66HMUhXU32xVPT6W9xX",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ikgajOFZFp7XnjGt772Sj2lSuonAqXqw",
      "b": "https://lh3.googleusercontent.com/d/1dn4oo1S9nYSeSt6gd-Vo9PlP_YHPTF72",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/105-355-ct-round-oval-cut-lab-grown-diamonds-engagement-ring-534945.jpg?v=1714499343"
   },
   "carat": 1.05,
   "caratMax": 6.55
  },
  {
   "rank": 174,
   "id": "gid://shopify/Product/7302928302264",
   "title": "0.50-6.00 CT Princess Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/0-50-3-00-ct-princess-cut-lab-grown-diamonds-solitaire-ring-71648lb",
   "handle": "0-50-3-00-ct-princess-cut-lab-grown-diamonds-solitaire-ring-71648lb",
   "priceNow": 1248.99,
   "priceWas": 3870.0,
   "pctOff": 68,
   "core": "71648",
   "inStock": true,
   "createdAt": "2023-07-24T23:15:43Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1PvNUHgtxWGLEz1pUwCaPICiVh-1eRZG9",
      "b": "https://lh3.googleusercontent.com/d/1aJyEq0-Mp6xSoTPkXLN6RNXWTCpx50Nw",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1ddbqYc1i5UmaBT02V3R_i9rC2Ccfo2LL",
      "b": "https://lh3.googleusercontent.com/d/12kG8klT-xHWufNTGyWfGY2krWb2XLTkv",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1x-zfTVLA36tTZHQ221vkbKk5hjP73BBN",
      "b": "https://lh3.googleusercontent.com/d/1hpppwbBfpwMTz5uRmo9EjWzn6TKOueFM",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-princess-cut-lab-grown-diamonds-solitaire-ring-645668.jpg?v=1763748633"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 175,
   "id": "gid://shopify/Product/7302750273720",
   "title": "0.50-6.00 CT Round Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/0-50-3-00-ct-round-cut-lab-grown-diamonds-solitaire-ring-71695lb",
   "handle": "0-50-3-00-ct-round-cut-lab-grown-diamonds-solitaire-ring-71695lb",
   "priceNow": 1434.99,
   "priceWas": 4450.0,
   "pctOff": 68,
   "core": "71695",
   "inStock": true,
   "createdAt": "2023-07-21T22:32:37Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/19DbihfcCXyGDQkgOAFxE0_jHI_NhtDWy",
      "b": "https://lh3.googleusercontent.com/d/1sBM2NC-2dW7Db5wfXCfCkAFY5VR2CA2A",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1w3Gt15oG0TgP8xW_rC5AMV5E-nq4B6iU",
      "b": "https://lh3.googleusercontent.com/d/1fnxZ7BkaF3HxVcw4fruj6fogrfZDq4Qf",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1lQLv6iWHNIHeU1fnP8mdYg8yqZvTL1yN",
      "b": "https://lh3.googleusercontent.com/d/1aeGD0QrOXjUDWqWd6TqL631hVef83xMI",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-round-cut-lab-grown-diamonds-solitaire-ring-666228.jpg?v=1763748634"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 176,
   "id": "gid://shopify/Product/7302750240952",
   "title": "0.50-6.00 CT Round Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/0-50-3-00-ct-round-cut-lab-grown-diamonds-solitaire-ring-71737lb",
   "handle": "0-50-3-00-ct-round-cut-lab-grown-diamonds-solitaire-ring-71737lb",
   "priceNow": 1310.99,
   "priceWas": 4060.0,
   "pctOff": 68,
   "core": "71737",
   "inStock": true,
   "createdAt": "2023-07-21T22:32:25Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1GKGFj6ZAabGhKaO2jBJw6Fe8grfZiKvW",
      "b": "https://lh3.googleusercontent.com/d/1J-GYaHRQfrFnBjDdNyn56lAqMKsB58jr",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1uU1Jyetu7v182Gl87j8ou4hSsWj3cRTp",
      "b": "https://lh3.googleusercontent.com/d/1OD1N2UbipVMUltVHE0iCCuVPvQutJu3M",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/15i6LW7dgaHOPEaTzX9-6N_-LreLtssJe",
      "b": "https://lh3.googleusercontent.com/d/1qCiucV3BbzKSl4ZtlSKBRCHb7qStUDg8",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-round-cut-lab-grown-diamonds-solitaire-ring-185259.jpg?v=1763748633"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 177,
   "id": "gid://shopify/Product/7302743785656",
   "title": "0.50-6.00 CT Pear Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/0-50-3-00-ct-pear-cut-lab-grown-diamonds-solitaire-ring-71852lb",
   "handle": "0-50-3-00-ct-pear-cut-lab-grown-diamonds-solitaire-ring-71852lb",
   "priceNow": 1563.99,
   "priceWas": 4850.0,
   "pctOff": 68,
   "core": "71852",
   "inStock": true,
   "createdAt": "2023-07-21T21:25:58Z",
   "shape": "pear",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/16z9MDwfghonPRLoj6eNL2WFQ2EbFJg0e",
      "b": "https://lh3.googleusercontent.com/d/1_GTiZl4-HjYgOUe9fijcm2uypBM1WC03",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/17RQHpxzuI-ETuJWd-Pas8Hf-Nx1aEc4i",
      "b": "https://lh3.googleusercontent.com/d/11pb_ojh9MdzGkDXdr0Eh_P8_PUe--nKr",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1QCeI3FMjgtuyvj8STkCw_vvVZ9UNQBYl",
      "b": "https://lh3.googleusercontent.com/d/1lQag4DGdi3UceqgMfuRlI2twB7GH0fbk",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-pear-cut-lab-grown-diamonds-solitaire-ring-522805.jpg?v=1763748612"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 178,
   "id": "gid://shopify/Product/7302629392568",
   "title": "5.00-9.00 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/5-00-9-00-ct-princess-cut-lab-grown-diamonds-tennis-bracelet-316460lb",
   "handle": "5-00-9-00-ct-princess-cut-lab-grown-diamonds-tennis-bracelet-316460lb",
   "priceNow": 4270.99,
   "priceWas": 13240.0,
   "pctOff": 68,
   "core": "316460",
   "inStock": true,
   "createdAt": "2023-07-20T22:12:15Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/500-900-ct-round-cut-lab-grown-diamonds-tennis-bracelet-264101.jpg?v=1705365044",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/500-900-ct-round-cut-lab-grown-diamonds-tennis-bracelet-264101.jpg?v=1705365044",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/500-900-ct-round-cut-lab-grown-diamonds-tennis-bracelet-469871.jpg?v=1763699897",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/500-900-ct-round-cut-lab-grown-diamonds-tennis-bracelet-857997.jpg?v=1763699898"
    }
   },
   "carat": 5.0,
   "caratMax": 9.0
  },
  {
   "rank": 179,
   "id": "gid://shopify/Product/7302629228728",
   "title": "4.00-14.50 CT Princess Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/4-00-14-50-ct-princess-cut-lab-grown-diamonds-tennis-bracelet-409091lb",
   "handle": "4-00-14-50-ct-princess-cut-lab-grown-diamonds-tennis-bracelet-409091lb",
   "priceNow": 5391.99,
   "priceWas": 15640.0,
   "pctOff": 66,
   "core": "409091",
   "inStock": true,
   "createdAt": "2023-07-20T22:12:03Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/400-1450-ct-princess-cut-lab-grown-diamonds-tennis-bracelet-862494.jpg?v=1705364675",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/400-1450-ct-princess-cut-lab-grown-diamonds-tennis-bracelet-862494.jpg?v=1705364675",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/400-1450-ct-princess-cut-lab-grown-diamonds-tennis-bracelet-941460.jpg?v=1763699897",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/400-1450-ct-princess-cut-lab-grown-diamonds-tennis-bracelet-591800.jpg?v=1763699898"
    }
   },
   "carat": 4.0,
   "caratMax": 14.5
  },
  {
   "rank": 180,
   "id": "gid://shopify/Product/7301511119032",
   "title": "0.50-6.00 CT Emerald Cut Lab Grown Diamonds - Solitaire Pendant",
   "url": "/products/0-50-3-00-ct-emerald-cut-lab-grown-diamonds-solitaire-pendant-21003lb",
   "handle": "0-50-3-00-ct-emerald-cut-lab-grown-diamonds-solitaire-pendant-21003lb",
   "priceNow": 850.99,
   "priceWas": 2890.0,
   "pctOff": 71,
   "core": "21003",
   "inStock": true,
   "createdAt": "2023-07-14T22:53:42Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-emerald-cut-lab-grown-diamonds-solitaire-pendant-173828.jpg?v=1698937727"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 181,
   "id": "gid://shopify/Product/7301511086264",
   "title": "0.50-6.00 CT Princess Cut Lab Grown Diamonds - Solitaire Pendant",
   "url": "/products/0-50-3-00-ct-princess-cut-lab-grown-diamonds-solitaire-pendant-21002lb",
   "handle": "0-50-3-00-ct-princess-cut-lab-grown-diamonds-solitaire-pendant-21002lb",
   "priceNow": 900.99,
   "priceWas": 3060.0,
   "pctOff": 71,
   "core": "21002",
   "inStock": true,
   "createdAt": "2023-07-14T22:53:22Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-princess-cut-lab-grown-diamonds-solitaire-pendant-904519.jpg?v=1699393723"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 182,
   "id": "gid://shopify/Product/7301496537272",
   "title": "0.50-6.00 CT Emerald Cut Lab Grown Diamonds - Solitaire Pendant",
   "url": "/products/0-50-3-00-ct-emerald-cut-lab-grown-diamonds-solitaire-pendant-15504emlb",
   "handle": "0-50-3-00-ct-emerald-cut-lab-grown-diamonds-solitaire-pendant-15504emlb",
   "priceNow": 987.99,
   "priceWas": 3260.0,
   "pctOff": 70,
   "core": "15504",
   "inStock": true,
   "createdAt": "2023-07-14T19:35:33Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-emerald-cut-lab-grown-diamonds-solitaire-pendant-653269.jpg?v=1697640142"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 183,
   "id": "gid://shopify/Product/7301457936568",
   "title": "0.50-6.00 CT Oval Cut Lab Grown Diamonds - Solitaire Pendant",
   "url": "/products/0-50-3-00-ct-oval-cut-lab-grown-diamonds-solitaire-pendant-102676ovlb",
   "handle": "0-50-3-00-ct-oval-cut-lab-grown-diamonds-solitaire-pendant-102676ovlb",
   "priceNow": 987.99,
   "priceWas": 3260.0,
   "pctOff": 70,
   "core": "102676",
   "inStock": true,
   "createdAt": "2023-07-14T18:21:04Z",
   "shape": "oval",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1rsa2R-gvKZPisip1rKrYTmGOGYZh9QcT",
      "b": "https://lh3.googleusercontent.com/d/1tDT-AG1rCXAhoROzxT1LKwIYhW4vHSw9",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1RlZfF78VgJcFLMz8P2JDORrHq8oAaSnR",
      "b": "https://lh3.googleusercontent.com/d/1i6oGRzdUfIo5aGaD4HqjW2UasmmXdBUy",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1EXQrfaZtrMNVMXthx8wbO4eP6eYFXr3u",
      "b": "https://lh3.googleusercontent.com/d/1PUN79_8gQcR471SnZWZXkFw9FFpCE25N",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-oval-cut-lab-grown-diamonds-solitaire-pendant-788951.jpg?v=1697640143"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 184,
   "id": "gid://shopify/Product/7301457903800",
   "title": "0.50-6.00 CT Emerald Cut Lab Grown Diamonds - Solitaire Pendant",
   "url": "/products/0-50-3-00-ct-emerald-cut-lab-grown-diamonds-solitaire-pendant-102676emlb",
   "handle": "0-50-3-00-ct-emerald-cut-lab-grown-diamonds-solitaire-pendant-102676emlb",
   "priceNow": 987.99,
   "priceWas": 3260.0,
   "pctOff": 70,
   "core": "102676",
   "inStock": true,
   "createdAt": "2023-07-14T18:20:45Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1rsa2R-gvKZPisip1rKrYTmGOGYZh9QcT",
      "b": "https://lh3.googleusercontent.com/d/1tDT-AG1rCXAhoROzxT1LKwIYhW4vHSw9",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1RlZfF78VgJcFLMz8P2JDORrHq8oAaSnR",
      "b": "https://lh3.googleusercontent.com/d/1i6oGRzdUfIo5aGaD4HqjW2UasmmXdBUy",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1EXQrfaZtrMNVMXthx8wbO4eP6eYFXr3u",
      "b": "https://lh3.googleusercontent.com/d/1PUN79_8gQcR471SnZWZXkFw9FFpCE25N",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-emerald-cut-lab-grown-diamonds-solitaire-pendant-824670.jpg?v=1697640142"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 185,
   "id": "gid://shopify/Product/7301365465272",
   "title": "0.50-6.00 CT Emerald Cut Lab Grown Diamonds - Solitaire Pendant",
   "url": "/products/0-50-3-00-ct-emerald-cut-lab-grown-diamonds-solitaire-pendant-102690emlb",
   "handle": "0-50-3-00-ct-emerald-cut-lab-grown-diamonds-solitaire-pendant-102690emlb",
   "priceNow": 1125.99,
   "priceWas": 3490.0,
   "pctOff": 68,
   "core": "102690",
   "inStock": true,
   "createdAt": "2023-07-13T22:12:14Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1u2BL4RbwVrafM-VwBgck1lrA1WRI-WKV",
      "b": "https://lh3.googleusercontent.com/d/1udW0FvvZlmSxcO2itIjUBBn51x2VdGxz",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1-0b-VkMEhCfdrI7Csp_eaaxppFHX8C6N",
      "b": "https://lh3.googleusercontent.com/d/1mWDu5MKSLP_UjNqEDq1xmwEEJPFahpTT",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1-PLqcq_7KTDGMtsmNwMPlafcVFUoHOLZ",
      "b": "https://lh3.googleusercontent.com/d/1XyVv1xKMs2O_gio934bEJ4tCWmJqXEH2",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-emerald-cut-lab-grown-diamonds-solitaire-pendant-659953.jpg?v=1697640142"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 186,
   "id": "gid://shopify/Product/7301086937272",
   "title": "1.90 CT Princess Cut Lab Grown Diamonds - Eternity Rings",
   "url": "/products/1-90-ct-princess-cut-lab-grown-diamonds-eternity-ring-15361lb",
   "handle": "1-90-ct-princess-cut-lab-grown-diamonds-eternity-ring-15361lb",
   "priceNow": 1751.99,
   "priceWas": 5430.0,
   "pctOff": 68,
   "core": "15361",
   "inStock": true,
   "createdAt": "2023-07-11T18:06:56Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1W__1eLJL5XeAcYMh1IVbvjZMLpPptKFB",
      "b": "https://lh3.googleusercontent.com/d/1E90rhNP15AczsL54nlQ0PYlv_MKfGu8X",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1z7UBGhmaT1cbvNNEI86Rj2QxrfsghQCA",
      "b": "https://lh3.googleusercontent.com/d/1rPZRevqrIq7Uwi9WXHOdN-PJx6-lB0Si",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1vMHMnrNPS7w5GOS3e39aEvwDND3oyymy",
      "b": "https://lh3.googleusercontent.com/d/1IU07xphdt3Q8X8xiR_RVDcNUfluL7UtV",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/190-ct-princess-cut-lab-grown-diamonds-eternity-ring-809027.jpg?v=1697640164"
   },
   "carat": 1.9
  },
  {
   "rank": 187,
   "id": "gid://shopify/Product/7301086904504",
   "title": "1.50 CT Round Cut Lab Grown Diamonds - Eternity Rings",
   "url": "/products/1-50-ct-round-cut-lab-grown-diamonds-eternity-ring-15359lb",
   "handle": "1-50-ct-round-cut-lab-grown-diamonds-eternity-ring-15359lb",
   "priceNow": 1746.99,
   "priceWas": 5420.0,
   "pctOff": 68,
   "core": "15359",
   "inStock": true,
   "createdAt": "2023-07-11T18:06:41Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/162gaN-PECH3wi7UING75pqvbDglF-8vh",
      "b": "https://lh3.googleusercontent.com/d/1p__oZ9UYM-GnE1nASm-5RgbX0dWf4ivI",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1IhYb9cs0WjU2T9aaW2GXKPma057Xsa2C",
      "b": "https://lh3.googleusercontent.com/d/1q1uhiQ27rA86NmnHPcg9UtbKvNx19Qeg",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1DlGOj0NyRKo6F6bBOLZMMZ9t0W3Rh3cy",
      "b": "https://lh3.googleusercontent.com/d/1HfD_95y5H1N59h4Iof_BAhpGN9EvQSDY",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/150-ct-round-cut-lab-grown-diamonds-eternity-ring-859428.jpg?v=1697640161"
   },
   "carat": 1.5
  },
  {
   "rank": 188,
   "id": "gid://shopify/Product/7301079924920",
   "title": "1.80 CT Round Cut Lab Grown Diamonds - Eternity Rings",
   "url": "/products/1-80-ct-round-cut-lab-grown-diamonds-eternity-ring-15956lb",
   "handle": "1-80-ct-round-cut-lab-grown-diamonds-eternity-ring-15956lb",
   "priceNow": 1755.99,
   "priceWas": 5440.0,
   "pctOff": 68,
   "core": "15956",
   "inStock": true,
   "createdAt": "2023-07-11T16:34:02Z",
   "shape": "round",
   "origin": "lab",
   "rating": 3.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1LR5bKSissicQHkCDvq4qATEPnKKOb-Yb",
      "b": "https://lh3.googleusercontent.com/d/1izQXvND-kCF3b1YEwd21RIi2Y0vTRp5v",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1OWAbn0SrCJVla04c4bZm77qlaTk8OQQE",
      "b": "https://lh3.googleusercontent.com/d/1MqM28IZElYMyqx_VevDRwwpRIONc5P_R",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1H-N5JtGqKHVgzOAgjPJFBZEPLFM2IL-R",
      "b": "https://lh3.googleusercontent.com/d/1RnoYKLYPf-qfzDZmgkr13Vwf3P4SrkJD",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/180-ct-round-cut-lab-grown-diamonds-eternity-ring-116294.jpg?v=1697640164"
   },
   "carat": 1.8
  },
  {
   "rank": 189,
   "id": "gid://shopify/Product/7301071732920",
   "title": "2.00-6.00 CT Round Cut Lab Grown Diamonds - Eternity Rings",
   "url": "/products/2-00-6-00-ct-round-cut-lab-grown-diamonds-eternity-ring-71707lb",
   "handle": "2-00-6-00-ct-round-cut-lab-grown-diamonds-eternity-ring-71707lb",
   "priceNow": 1346.99,
   "priceWas": 4180.0,
   "pctOff": 68,
   "core": "71707",
   "inStock": true,
   "createdAt": "2023-07-11T14:58:16Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1K0DG1KyBOatp11Z09iXtUOYP75SluqKP",
      "b": "https://lh3.googleusercontent.com/d/1DPJMO5wKWqXGyYRGfltrZT9xGbj2hdrN",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1NKq9i-ZiDwd20MlRcE1ExS4zWvdpNhf7",
      "b": "https://lh3.googleusercontent.com/d/13ijsKfGaQnoUCoZrgjxuuU7TJh6FTpvd",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1tj2tLeRr-fBYuKuj1E1p9d4CsIJjV7yB",
      "b": "https://lh3.googleusercontent.com/d/13JFVJZ0jMyGzkmpJW3l5zjg0ZGNw95gi",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-600-ct-round-cut-lab-grown-diamonds-eternity-ring-774022.jpg?v=1697640166"
   },
   "carat": 2.0,
   "caratMax": 6.0
  },
  {
   "rank": 190,
   "id": "gid://shopify/Product/10448395665592",
   "title": "0.25 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-30106lb",
   "handle": "wedding-bands-30106lb",
   "priceNow": 909.99,
   "priceWas": 3090.0,
   "pctOff": 71,
   "core": "30106",
   "inStock": true,
   "createdAt": "2026-06-18T19:39:46Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_f845e125-f2dc-4011-ba42-a14adc861654.png?v=1781902270",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_f845e125-f2dc-4011-ba42-a14adc861654.png?v=1781902270",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_24604228-7564-40f7-ab6e-fe5cc7569f77.png?v=1781902270",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_6569fa8f-45ca-4a47-9c49-4b2f58f35bae.png?v=1781902273"
    }
   },
   "carat": 0.25
  },
  {
   "rank": 191,
   "id": "gid://shopify/Product/10448395632824",
   "title": "1.30-6.80 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-30105lb",
   "handle": "bridal-sets-30105lb",
   "priceNow": 2118.99,
   "priceWas": 6570.0,
   "pctOff": 68,
   "core": "30105",
   "inStock": true,
   "createdAt": "2026-06-18T19:39:41Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_58ee33ae-366a-468d-b69c-1a79474fb4ae.png?v=1781902270",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_58ee33ae-366a-468d-b69c-1a79474fb4ae.png?v=1781902270",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_1e86742e-84a2-44d1-aeb5-cae228b57cc6.png?v=1781902271",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_7715b70e-619d-427e-b245-17ac4caeaf23.png?v=1781902270"
    }
   },
   "carat": 1.3,
   "caratMax": 6.8
  },
  {
   "rank": 192,
   "id": "gid://shopify/Product/10448395370680",
   "title": "0.15 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-30104lb",
   "handle": "wedding-bands-30104lb",
   "priceNow": 867.99,
   "priceWas": 2950.0,
   "pctOff": 71,
   "core": "30104",
   "inStock": true,
   "createdAt": "2026-06-18T19:39:23Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_cf785653-8bc7-464d-aeb6-cd978758ac34.png?v=1782359469",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_cf785653-8bc7-464d-aeb6-cd978758ac34.png?v=1782359469",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_f2a9f938-08bc-4078-a4a0-2c08e8ae5eff.png?v=1782359470",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_449bac67-9392-404a-a779-bbf456a5c456.png?v=1782359471"
    }
   },
   "carat": 0.15
  },
  {
   "rank": 193,
   "id": "gid://shopify/Product/10448395206840",
   "title": "1.00-6.50 CT Emerald & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-30103lb",
   "handle": "bridal-sets-30103lb",
   "priceNow": 2024.99,
   "priceWas": 6280.0,
   "pctOff": 68,
   "core": "30103",
   "inStock": true,
   "createdAt": "2026-06-18T19:39:17Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_6db21acf-8943-48f4-9d1a-e24be73df3d1.png?v=1782359469",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_6db21acf-8943-48f4-9d1a-e24be73df3d1.png?v=1782359469",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_276c7cd7-44ce-43a8-a5aa-47d14258ead2.png?v=1782359470",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_f63dd94f-54e9-465f-b4a3-38666d061362.png?v=1782359470"
    }
   },
   "carat": 1.0,
   "caratMax": 6.5
  },
  {
   "rank": 194,
   "id": "gid://shopify/Product/10448395010232",
   "title": "0.45 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-30102lb",
   "handle": "wedding-bands-30102lb",
   "priceNow": 965.99,
   "priceWas": 3280.0,
   "pctOff": 71,
   "core": "30102",
   "inStock": true,
   "createdAt": "2026-06-18T19:39:00Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_807030a2-4a3a-44b0-8dc6-b04508b40385.png?v=1782447070",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_807030a2-4a3a-44b0-8dc6-b04508b40385.png?v=1782447070",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_c86a111f-b413-4e35-967d-0cfdb87c2304.png?v=1782447594",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_87a0e32f-a0bc-4854-8d79-9b36f7cb845e.png?v=1782447581"
    }
   },
   "carat": 0.45
  },
  {
   "rank": 195,
   "id": "gid://shopify/Product/10438658031800",
   "title": "0.55 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-30098lb",
   "handle": "wedding-bands-30098lb",
   "priceNow": 1226.99,
   "priceWas": 3800.0,
   "pctOff": 68,
   "core": "30098",
   "inStock": true,
   "createdAt": "2026-06-09T18:33:55Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_0e0363cb-fe5b-45be-9aa6-76d6389259f1.png?v=1781046995",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_0e0363cb-fe5b-45be-9aa6-76d6389259f1.png?v=1781046995",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_423f8a1f-97f1-4351-b194-7122d4d6a7b6.png?v=1781046994",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_38eace08-900d-43d6-af30-0f429e8e067e.png?v=1781046994"
    }
   },
   "carat": 0.55
  },
  {
   "rank": 196,
   "id": "gid://shopify/Product/10438657900728",
   "title": "1.50-7.00 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-30097lb",
   "handle": "bridal-sets-30097lb",
   "priceNow": 2486.99,
   "priceWas": 7710.0,
   "pctOff": 68,
   "core": "30097",
   "inStock": true,
   "createdAt": "2026-06-09T18:33:45Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_a90fea8d-8076-479c-b8db-5178d22711d9.png?v=1781046995",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_a90fea8d-8076-479c-b8db-5178d22711d9.png?v=1781046995",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_48f2903c-17dd-4ab4-9d92-9a261a1bb5ef.png?v=1781046995",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_bdad2915-911a-43d9-b041-098345156200.png?v=1781046995"
    }
   },
   "carat": 1.5,
   "caratMax": 7.0
  },
  {
   "rank": 197,
   "id": "gid://shopify/Product/10438657736888",
   "title": "1.00 CT Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-30096lb",
   "handle": "wedding-bands-30096lb",
   "priceNow": 1645.99,
   "priceWas": 5100.0,
   "pctOff": 68,
   "core": "30096",
   "inStock": true,
   "createdAt": "2026-06-09T18:33:38Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_8565667d-6b60-4f27-9152-bda5845eac08.png?v=1781137143",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_8565667d-6b60-4f27-9152-bda5845eac08.png?v=1781137143",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_7f495eaa-3a82-4a08-b815-0b43f022cd8b.png?v=1781137143",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_5eae7358-4fdc-4306-b1ce-e068caeb3957.png?v=1781137143"
    }
   },
   "carat": 1.0
  },
  {
   "rank": 198,
   "id": "gid://shopify/Product/10438657638584",
   "title": "3.00-8.50 CT Emerald & Princess Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-30095lb",
   "handle": "bridal-sets-30095lb",
   "priceNow": 3158.99,
   "priceWas": 9790.0,
   "pctOff": 68,
   "core": "30095",
   "inStock": true,
   "createdAt": "2026-06-09T18:33:31Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_f3da7e10-acce-461e-8222-c4a11ff9732b.png?v=1781137144",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_f3da7e10-acce-461e-8222-c4a11ff9732b.png?v=1781137144",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_4f518759-3569-4c47-8dd9-14c640bdf705.png?v=1781137144",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_f18c04bd-a091-4d08-a0e9-50d6aae15983.png?v=1781137145"
    }
   },
   "carat": 3.0,
   "caratMax": 8.5
  },
  {
   "rank": 199,
   "id": "gid://shopify/Product/10438657441976",
   "title": "0.35 CT Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-30094lb",
   "handle": "wedding-bands-30094lb",
   "priceNow": 1048.99,
   "priceWas": 3250.0,
   "pctOff": 68,
   "core": "30094",
   "inStock": true,
   "createdAt": "2026-06-09T18:33:24Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_3a874be3-cf77-4fbe-ae52-f8cc764754f1.png?v=1781137145",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_3a874be3-cf77-4fbe-ae52-f8cc764754f1.png?v=1781137145",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_87d7221e-f4ed-4240-847f-2353a9e33cb6.png?v=1781137145",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_8338a805-78f4-413c-a880-de08420569fc.png?v=1781137145"
    }
   },
   "carat": 0.35
  },
  {
   "rank": 200,
   "id": "gid://shopify/Product/10438657278136",
   "title": "0.95-6.45 CT Emerald & Princess Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-30093lb",
   "handle": "bridal-sets-30093lb",
   "priceNow": 2984.99,
   "priceWas": 9250.0,
   "pctOff": 68,
   "core": "30093",
   "inStock": true,
   "createdAt": "2026-06-09T18:33:15Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_dd4ef381-fc9b-4dcc-a4fd-1d806570ae40.png?v=1781137147",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_dd4ef381-fc9b-4dcc-a4fd-1d806570ae40.png?v=1781137147",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_1d0f5d46-b42d-4c77-8e1c-88ea425a50a8.png?v=1781137148",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_00691ea7-f228-498f-aacc-83c606b10bd4.png?v=1781137147"
    }
   },
   "carat": 0.95,
   "caratMax": 6.45
  },
  {
   "rank": 201,
   "id": "gid://shopify/Product/10438657179832",
   "title": "0.50 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-30092lb",
   "handle": "wedding-bands-30092lb",
   "priceNow": 1099.99,
   "priceWas": 3410.0,
   "pctOff": 68,
   "core": "30092",
   "inStock": true,
   "createdAt": "2026-06-09T18:33:08Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_eb7da1b3-c6eb-48d7-801c-f38727785868.png?v=1781137149",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_eb7da1b3-c6eb-48d7-801c-f38727785868.png?v=1781137149",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_5c0c0b50-608e-420f-8c10-318850b2e215.png?v=1781137149",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_065d02e0-5359-4384-a88a-678186433fda.png?v=1781137149"
    }
   },
   "carat": 0.5
  },
  {
   "rank": 202,
   "id": "gid://shopify/Product/10438657048760",
   "title": "2.00-7.50 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-30091lb",
   "handle": "bridal-sets-30091lb",
   "priceNow": 2999.99,
   "priceWas": 9300.0,
   "pctOff": 68,
   "core": "30091",
   "inStock": true,
   "createdAt": "2026-06-09T18:32:59Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_df356859-8881-4df6-b695-aaaac00ce3d4.png?v=1781137150",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_df356859-8881-4df6-b695-aaaac00ce3d4.png?v=1781137150",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_603cdf85-2f70-4475-bd81-080bfd8ac48d.png?v=1781137150",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_a9d677ed-5ae3-4417-95e7-bd274ef816e9.png?v=1781137150"
    }
   },
   "carat": 2.0,
   "caratMax": 7.5
  },
  {
   "rank": 203,
   "id": "gid://shopify/Product/10438656786616",
   "title": "2.50-8.00 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-30088lb",
   "handle": "bridal-sets-30088lb",
   "priceNow": 3221.99,
   "priceWas": 9990.0,
   "pctOff": 68,
   "core": "30088",
   "inStock": true,
   "createdAt": "2026-06-09T18:32:42Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_9d91075b-a439-4fe0-87b3-23455854febf.png?v=1781137151",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_9d91075b-a439-4fe0-87b3-23455854febf.png?v=1781137151",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_7cc2e497-850b-4101-9494-785851b0a31c.png?v=1781137151",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_a9c87e4f-4328-4575-b78e-28feae0c7252.png?v=1781137151"
    }
   },
   "carat": 2.5,
   "caratMax": 8.0
  },
  {
   "rank": 204,
   "id": "gid://shopify/Product/10438656753848",
   "title": "0.80 CT Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-30087lb",
   "handle": "wedding-bands-30087lb",
   "priceNow": 1267.99,
   "priceWas": 3930.0,
   "pctOff": 68,
   "core": "30087",
   "inStock": true,
   "createdAt": "2026-06-09T18:32:38Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_1e7bfa57-24be-4ee9-905a-a86704a8a7bb.png?v=1781137151",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_1e7bfa57-24be-4ee9-905a-a86704a8a7bb.png?v=1781137151",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_ec12d9ef-3dbe-4001-9b8b-65248faf04a4.png?v=1781137151",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_26ccde2a-dc72-4557-8728-250d284aa0d6.png?v=1781137153"
    }
   },
   "carat": 0.8
  },
  {
   "rank": 205,
   "id": "gid://shopify/Product/10438656491704",
   "title": "2.10-7.60 CT Emerald & Princess Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-30082lb",
   "handle": "bridal-sets-30082lb",
   "priceNow": 2841.99,
   "priceWas": 8810.0,
   "pctOff": 68,
   "core": "30082",
   "inStock": true,
   "createdAt": "2026-06-09T18:32:17Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_fe10d6e8-c45f-4c2c-bb54-b0e5caebc00d.png?v=1781137154",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_fe10d6e8-c45f-4c2c-bb54-b0e5caebc00d.png?v=1781137154",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_04aa4f8a-b395-42ad-839c-8c0a4859a51e.png?v=1781137154",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_ef47412f-3cb2-46ee-bdd1-7a905666ef2b.png?v=1781137154"
    }
   },
   "carat": 2.1,
   "caratMax": 7.6
  },
  {
   "rank": 206,
   "id": "gid://shopify/Product/10438656327864",
   "title": "1.30-6.80 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-30080lb",
   "handle": "bridal-sets-30080lb",
   "priceNow": 2065.99,
   "priceWas": 6400.0,
   "pctOff": 68,
   "core": "30080",
   "inStock": true,
   "createdAt": "2026-06-09T18:32:10Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_09fd5452-09d0-4531-ab74-82ac1db9e7fe.png?v=1781137155",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_09fd5452-09d0-4531-ab74-82ac1db9e7fe.png?v=1781137155",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_5ff947c6-659d-46d5-a229-9171fdd36c68.png?v=1781137155",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_0342c9c7-f245-4962-9640-ee507da7ce70.png?v=1781137155"
    }
   },
   "carat": 1.3,
   "caratMax": 6.8
  },
  {
   "rank": 207,
   "id": "gid://shopify/Product/10438656295096",
   "title": "0.40 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-30079lb",
   "handle": "wedding-bands-30079lb",
   "priceNow": 968.99,
   "priceWas": 3290.0,
   "pctOff": 71,
   "core": "30079",
   "inStock": true,
   "createdAt": "2026-06-09T18:32:05Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_0eefda6c-78f7-4621-9296-a0b26e1aa8cf.png?v=1781137156",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_0eefda6c-78f7-4621-9296-a0b26e1aa8cf.png?v=1781137156",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_d9f9fca4-acb5-4281-9f9e-bfdd547c09bc.png?v=1781137156",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_64f89e12-1290-4462-a699-636dbe59f1f6.png?v=1781137156"
    }
   },
   "carat": 0.4
  },
  {
   "rank": 208,
   "id": "gid://shopify/Product/10424759484600",
   "title": "1.05-6.55 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-30078lb",
   "handle": "bridal-sets-30078lb",
   "priceNow": 2191.99,
   "priceWas": 6800.0,
   "pctOff": 68,
   "core": "30078",
   "inStock": true,
   "createdAt": "2026-05-29T23:20:08Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_2_b69189dd-3ff9-4339-8c7b-635e23b05260.png?v=1780504026",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_2_b69189dd-3ff9-4339-8c7b-635e23b05260.png?v=1780504026",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_84847d2c-73cc-4d16-87e3-5e5b24ef3691.png?v=1780504026",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_1_1c5313b8-cc3d-4e01-b29b-23eab26bc2c8.png?v=1780504026"
    }
   },
   "carat": 1.05,
   "caratMax": 6.55
  },
  {
   "rank": 209,
   "id": "gid://shopify/Product/10424759451832",
   "title": "0.30 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-30077lb",
   "handle": "wedding-bands-30077lb",
   "priceNow": 926.99,
   "priceWas": 3150.0,
   "pctOff": 71,
   "core": "30077",
   "inStock": true,
   "createdAt": "2026-05-29T23:20:07Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_db45ae5c-070e-479a-b3c7-491f7d308c39.png?v=1780504026",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_db45ae5c-070e-479a-b3c7-491f7d308c39.png?v=1780504026",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_ecdbb90c-2e64-4088-b914-7c26f4d2cd3e.png?v=1780504027",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_ef83026c-992d-410d-8504-460be8baa2d7.png?v=1780504026"
    }
   },
   "carat": 0.3
  },
  {
   "rank": 210,
   "id": "gid://shopify/Product/10424759419064",
   "title": "2.30-7.80 CT Princess Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-30076lb",
   "handle": "bridal-sets-30076lb",
   "priceNow": 3149.99,
   "priceWas": 9760.0,
   "pctOff": 68,
   "core": "30076",
   "inStock": true,
   "createdAt": "2026-05-29T23:20:05Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_4fbe6ecf-fc38-4e39-ae43-715f70b660c9.png?v=1780504027",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_4fbe6ecf-fc38-4e39-ae43-715f70b660c9.png?v=1780504027",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_da7c0942-9dad-4cf8-bffe-e9dbcface1ab.png?v=1780504027",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_41a0284d-9705-4af0-8c64-4bde46c8d257.png?v=1780504026"
    }
   },
   "carat": 2.3,
   "caratMax": 7.8
  },
  {
   "rank": 211,
   "id": "gid://shopify/Product/10424759386296",
   "title": "1.00 CT Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-30075lb",
   "handle": "wedding-bands-30075lb",
   "priceNow": 1598.99,
   "priceWas": 4960.0,
   "pctOff": 68,
   "core": "30075",
   "inStock": true,
   "createdAt": "2026-05-29T23:20:03Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_64bc92fc-447e-4912-ad9a-e3b99232e074.png?v=1780504027",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_64bc92fc-447e-4912-ad9a-e3b99232e074.png?v=1780504027",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_1df78002-5acf-4de6-a983-c4ffbbc6befb.png?v=1780504027",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_03fb913c-b676-4add-8a8a-31488a081e4d.png?v=1780504028"
    }
   },
   "carat": 1.0
  },
  {
   "rank": 212,
   "id": "gid://shopify/Product/10424759353528",
   "title": "0.40 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-30074lb",
   "handle": "wedding-bands-30074lb",
   "priceNow": 954.99,
   "priceWas": 3250.0,
   "pctOff": 71,
   "core": "30074",
   "inStock": true,
   "createdAt": "2026-05-29T23:20:02Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_e18697d9-54e0-45e4-8af7-ca8fcbc40814.png?v=1780504029",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_e18697d9-54e0-45e4-8af7-ca8fcbc40814.png?v=1780504029",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_6c60ccf8-fa0e-4545-aada-296ca625945b.png?v=1780504030",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_5b671735-03e6-4f8b-9651-8fe1bd5914c6.png?v=1780504029"
    }
   },
   "carat": 0.4
  },
  {
   "rank": 213,
   "id": "gid://shopify/Product/10424759320760",
   "title": "0.40 CT Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-30073lb",
   "handle": "wedding-bands-30073lb",
   "priceNow": 952.99,
   "priceWas": 3240.0,
   "pctOff": 71,
   "core": "30073",
   "inStock": true,
   "createdAt": "2026-05-29T23:20:00Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_0852b120-967b-49cd-8a82-8876c8072d47.png?v=1780594572",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_0852b120-967b-49cd-8a82-8876c8072d47.png?v=1780594572",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_f58f7fdb-909a-4ef2-8776-67c90b519230.png?v=1780594572",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_139d1853-d030-4280-96c2-457e875439b4.png?v=1780594573"
    }
   },
   "carat": 0.4
  },
  {
   "rank": 214,
   "id": "gid://shopify/Product/10424759287992",
   "title": "0.35 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-30072lb",
   "handle": "wedding-bands-30072lb",
   "priceNow": 939.99,
   "priceWas": 3200.0,
   "pctOff": 71,
   "core": "30072",
   "inStock": true,
   "createdAt": "2026-05-29T23:19:59Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_4c933983-9cbe-4b67-a860-b6672b3054dd.png?v=1780594573",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_4c933983-9cbe-4b67-a860-b6672b3054dd.png?v=1780594573",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_c7663948-f189-4c55-888a-f3a788626abc.png?v=1780594574",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_464c396f-fe91-4132-9bc1-28fc0436f864.png?v=1780594573"
    }
   },
   "carat": 0.35
  },
  {
   "rank": 215,
   "id": "gid://shopify/Product/10424759222456",
   "title": "1.15 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-30071lb",
   "handle": "wedding-bands-30071lb",
   "priceNow": 1559.99,
   "priceWas": 4840.0,
   "pctOff": 68,
   "core": "30071",
   "inStock": true,
   "createdAt": "2026-05-29T23:19:56Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_85ab87c7-e0c6-4176-9f10-d7f188059fd6.png?v=1780594574",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_85ab87c7-e0c6-4176-9f10-d7f188059fd6.png?v=1780594574",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_d27e0c2a-b9a7-4220-ab14-23b630a9bf0c.png?v=1780594574",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_75161f4e-76e4-443f-844a-d21cd40f84ab.png?v=1780594574"
    }
   },
   "carat": 1.15
  },
  {
   "rank": 216,
   "id": "gid://shopify/Product/10424759156920",
   "title": "1.40-6.90 CT Princess Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-30070lb",
   "handle": "bridal-sets-30070lb",
   "priceNow": 2373.99,
   "priceWas": 7360.0,
   "pctOff": 68,
   "core": "30070",
   "inStock": true,
   "createdAt": "2026-05-29T23:19:53Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_2_3e24151d-ef5b-40b3-a78f-3607d4341430.png?v=1780594574",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_2_3e24151d-ef5b-40b3-a78f-3607d4341430.png?v=1780594574",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_71aca91d-bd9b-4746-baf8-efe945102e26.png?v=1780594574",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_1_f52d283b-5604-46eb-8de0-51f193a32678.png?v=1780594575"
    }
   },
   "carat": 1.4,
   "caratMax": 6.9
  },
  {
   "rank": 217,
   "id": "gid://shopify/Product/10424759091384",
   "title": "0.90 CT Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-30069lb",
   "handle": "wedding-bands-30069lb",
   "priceNow": 1423.99,
   "priceWas": 4410.0,
   "pctOff": 68,
   "core": "30069",
   "inStock": true,
   "createdAt": "2026-05-29T23:19:49Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_0738b936-a2b4-4548-8079-ced834473133.png?v=1780504030",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_0738b936-a2b4-4548-8079-ced834473133.png?v=1780504030",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_3f9df7ac-2a7e-49b7-aff9-1b98f32985e2.png?v=1780504030",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_c4e243e5-158e-4ea5-a545-cf2bf07898d7.png?v=1780504030"
    }
   },
   "carat": 0.9
  },
  {
   "rank": 218,
   "id": "gid://shopify/Product/10420700053688",
   "title": "0.80 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-30068lb",
   "handle": "wedding-bands-30068lb",
   "priceNow": 1402.99,
   "priceWas": 4350.0,
   "pctOff": 68,
   "core": "30068",
   "inStock": true,
   "createdAt": "2026-05-27T17:52:51Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_b296818c-90f5-45fe-a530-716f3badfd86.png?v=1779951066",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_b296818c-90f5-45fe-a530-716f3badfd86.png?v=1779951066",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_c9446532-c421-4174-a4b1-3e27af699542.png?v=1779951067",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_3d54b361-4765-4c44-8476-4474d4f4e677.png?v=1779951066"
    }
   },
   "carat": 0.8
  },
  {
   "rank": 219,
   "id": "gid://shopify/Product/10420699988152",
   "title": "2.20-7.70 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-30067lb",
   "handle": "bridal-sets-30067lb",
   "priceNow": 2913.99,
   "priceWas": 9030.0,
   "pctOff": 68,
   "core": "30067",
   "inStock": true,
   "createdAt": "2026-05-27T17:52:48Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_1e8ae85c-690f-4f2d-acd7-ebb59edcfcda.png?v=1779951066",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_1e8ae85c-690f-4f2d-acd7-ebb59edcfcda.png?v=1779951066",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_d92e78c0-86a6-4ada-9f7e-f84009d2ecd8.png?v=1779951066",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_8778b2d1-bb04-4b67-ab32-f4dd901a1f0f.png?v=1779951066"
    }
   },
   "carat": 2.2,
   "caratMax": 7.7
  },
  {
   "rank": 220,
   "id": "gid://shopify/Product/10420699955384",
   "title": "1.30-6.80 CT Princess Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-30066lb",
   "handle": "engagement-rings-30066lb",
   "priceNow": 1519.99,
   "priceWas": 4710.0,
   "pctOff": 68,
   "core": "30066",
   "inStock": true,
   "createdAt": "2026-05-27T17:52:44Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_3210e115-7482-45fe-afa1-ac1626629dda.png?v=1779951068",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_3210e115-7482-45fe-afa1-ac1626629dda.png?v=1779951068",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_6514e088-23d0-4b38-93e8-695abcd3a71c.png?v=1779951068",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_fafec5d6-ba32-4c68-af54-53d2fc722a15.png?v=1779951069"
    }
   },
   "carat": 1.3,
   "caratMax": 6.8
  },
  {
   "rank": 221,
   "id": "gid://shopify/Product/10420699922616",
   "title": "2.30-7.80 CT Princess Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-30065lb",
   "handle": "bridal-sets-30065lb",
   "priceNow": 2597.99,
   "priceWas": 8050.0,
   "pctOff": 68,
   "core": "30065",
   "inStock": true,
   "createdAt": "2026-05-27T17:52:41Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_2938c4a1-73c6-4c27-8e2e-3942bda3fea2.png?v=1779951071",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_2938c4a1-73c6-4c27-8e2e-3942bda3fea2.png?v=1779951071",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_c023011c-cb7c-4b63-b548-9ddddd5578f6.png?v=1779951072",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_df3154b5-990e-4be4-a1bc-b290fec396b2.png?v=1779951072"
    }
   },
   "carat": 2.3,
   "caratMax": 7.8
  },
  {
   "rank": 222,
   "id": "gid://shopify/Product/10420699889848",
   "title": "0.20 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-30064lb",
   "handle": "wedding-bands-30064lb",
   "priceNow": 905.99,
   "priceWas": 3080.0,
   "pctOff": 71,
   "core": "30064",
   "inStock": true,
   "createdAt": "2026-05-27T17:52:39Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_fbc1bfbe-9520-46f8-886b-3288d43e4721.png?v=1779951071",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_fbc1bfbe-9520-46f8-886b-3288d43e4721.png?v=1779951071",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_dc73b36d-58b3-4841-abaf-fac479e02afe.png?v=1779951072",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_b989d706-df82-47f1-8e50-648611d76ec4.png?v=1779951072"
    }
   },
   "carat": 0.2
  },
  {
   "rank": 223,
   "id": "gid://shopify/Product/10420699627704",
   "title": "0.25 CT Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-30056lb",
   "handle": "wedding-bands-30056lb",
   "priceNow": 915.99,
   "priceWas": 3110.0,
   "pctOff": 71,
   "core": "30056",
   "inStock": true,
   "createdAt": "2026-05-27T17:52:31Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_2abb4cc2-1fca-41d1-a540-048ef6c897d1.png?v=1779951074",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_2abb4cc2-1fca-41d1-a540-048ef6c897d1.png?v=1779951074",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_23008e42-a67f-45cf-bb59-55fb90ffc8e3.png?v=1779951074",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_5fcf2d0c-e0af-4500-b84b-767e16af9a6b.png?v=1779951074"
    }
   },
   "carat": 0.25
  },
  {
   "rank": 224,
   "id": "gid://shopify/Product/10420699562168",
   "title": "0.75-6.25 CT Princess Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-30055lb",
   "handle": "bridal-sets-30055lb",
   "priceNow": 1734.99,
   "priceWas": 5380.0,
   "pctOff": 68,
   "core": "30055",
   "inStock": true,
   "createdAt": "2026-05-27T17:52:24Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_572b328e-cc02-4ab0-9b38-a7a03ea452b6.png?v=1779951076",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_572b328e-cc02-4ab0-9b38-a7a03ea452b6.png?v=1779951076",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_fba68c38-b633-48a3-8d09-e23f2e3ba457.png?v=1779951076",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_6c442a4e-e55c-4c08-8a2a-e1fd07fafbde.png?v=1779951077"
    }
   },
   "carat": 0.75,
   "caratMax": 6.25
  },
  {
   "rank": 225,
   "id": "gid://shopify/Product/10419652919480",
   "title": "0.95-6.45 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-30062lb",
   "handle": "bridal-sets-30062lb",
   "priceNow": 1751.99,
   "priceWas": 5430.0,
   "pctOff": 68,
   "core": "30062",
   "inStock": true,
   "createdAt": "2026-05-26T00:14:13Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_e7f090f8-5287-4f50-9bec-c8326e116022.png?v=1779849425",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_e7f090f8-5287-4f50-9bec-c8326e116022.png?v=1779849425",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_884ba2b6-021f-4b93-9606-fcb08b71547a.png?v=1779849425",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_6d5f3c5f-80fe-42f5-b3b7-6faf43e7dd19.png?v=1779849426"
    }
   },
   "carat": 0.95,
   "caratMax": 6.45
  },
  {
   "rank": 226,
   "id": "gid://shopify/Product/10419652821176",
   "title": "0.25 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-30061lb",
   "handle": "wedding-bands-30061lb",
   "priceNow": 819.99,
   "priceWas": 2790.0,
   "pctOff": 71,
   "core": "30061",
   "inStock": true,
   "createdAt": "2026-05-26T00:14:06Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_83166470-4fcc-40b9-8657-797481dae02a.png?v=1779849426",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_83166470-4fcc-40b9-8657-797481dae02a.png?v=1779849426",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_a133de68-fb04-4652-953d-fd7905edab2b.png?v=1779849426",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_c56ef672-560c-4497-a21d-ca75a3a92e68.png?v=1779849426"
    }
   },
   "carat": 0.25
  },
  {
   "rank": 227,
   "id": "gid://shopify/Product/10419652624568",
   "title": "2.00-7.50 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-30059lb",
   "handle": "bridal-sets-30059lb",
   "priceNow": 2303.99,
   "priceWas": 7140.0,
   "pctOff": 68,
   "core": "30059",
   "inStock": true,
   "createdAt": "2026-05-26T00:13:52Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_bf5588da-35d9-4272-9b62-7b8e5550fe19.png?v=1779849432",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_bf5588da-35d9-4272-9b62-7b8e5550fe19.png?v=1779849432",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_f35c2f6e-c6b5-43bb-913b-cb186afd0efa.png?v=1779849432",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_179ea1cc-9fd8-4515-a501-0fffd7f638f5.png?v=1779849432"
    }
   },
   "carat": 2.0,
   "caratMax": 7.5
  },
  {
   "rank": 228,
   "id": "gid://shopify/Product/10419652591800",
   "title": "0.50 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-30058lb",
   "handle": "wedding-bands-30058lb",
   "priceNow": 907.99,
   "priceWas": 3090.0,
   "pctOff": 71,
   "core": "30058",
   "inStock": true,
   "createdAt": "2026-05-26T00:13:48Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_0b76420a-4e64-45f1-a876-5f333fa448da.png?v=1779849431",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_0b76420a-4e64-45f1-a876-5f333fa448da.png?v=1779849431",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_1c4cfa49-89d8-4333-a151-3007429458d8.png?v=1779849431",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_bf4fa247-3a30-493e-b259-a734dfbea453.png?v=1779849431"
    }
   },
   "carat": 0.5
  },
  {
   "rank": 229,
   "id": "gid://shopify/Product/10419652526264",
   "title": "0.15 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-30057lb",
   "handle": "wedding-bands-30057lb",
   "priceNow": 667.99,
   "priceWas": 2270.0,
   "pctOff": 71,
   "core": "30057",
   "inStock": true,
   "createdAt": "2026-05-26T00:13:44Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_3cb7e6f1-dbc9-4e0c-8e46-45b0b4a8e602.png?v=1779849432",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_3cb7e6f1-dbc9-4e0c-8e46-45b0b4a8e602.png?v=1779849432",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_fb182359-3caa-43ca-b50a-0ddc9246daaf.png?v=1779849432",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_210072de-8881-49d0-9786-853e9a181c36.png?v=1779849432"
    }
   },
   "carat": 0.15
  },
  {
   "rank": 230,
   "id": "gid://shopify/Product/10408754708664",
   "title": "0.30 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-30054lb",
   "handle": "wedding-bands-30054lb",
   "priceNow": 1495.99,
   "priceWas": 4640.0,
   "pctOff": 68,
   "core": "30054",
   "inStock": true,
   "createdAt": "2026-05-19T20:50:06Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_545a2c00-60a3-4b94-80f2-cf759a743e3c.png?v=1779256268",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_545a2c00-60a3-4b94-80f2-cf759a743e3c.png?v=1779256268",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_488fcb54-b5aa-4421-9b66-aeff461f3f55.png?v=1779256268",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_72f6bfd1-e7d9-418a-a68f-287facc03196.png?v=1779256268"
    }
   },
   "carat": 0.3
  },
  {
   "rank": 231,
   "id": "gid://shopify/Product/10408754348216",
   "title": "1.45-6.95 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-30053lb",
   "handle": "bridal-sets-30053lb",
   "priceNow": 3078.99,
   "priceWas": 9540.0,
   "pctOff": 68,
   "core": "30053",
   "inStock": true,
   "createdAt": "2026-05-19T20:50:00Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_5f6a4a73-50e1-46f1-8079-87f5eadadf3e.png?v=1779256269",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_5f6a4a73-50e1-46f1-8079-87f5eadadf3e.png?v=1779256269",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_26ba748e-c605-487d-8e4e-b204a8aaedff.png?v=1779256269",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_ca25a8f6-2613-4d94-af42-1f88f25a09a2.png?v=1779256269"
    }
   },
   "carat": 1.45,
   "caratMax": 6.95
  },
  {
   "rank": 232,
   "id": "gid://shopify/Product/10408754118840",
   "title": "0.25 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-30052lb",
   "handle": "wedding-bands-30052lb",
   "priceNow": 909.99,
   "priceWas": 3090.0,
   "pctOff": 71,
   "core": "30052",
   "inStock": true,
   "createdAt": "2026-05-19T20:49:55Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_11_d30d532c-1c8a-4a47-9ec9-53bf6c3f35be.png?v=1779256269",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_11_d30d532c-1c8a-4a47-9ec9-53bf6c3f35be.png?v=1779256269",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_9_f6953ed6-4198-41f6-a5f9-85663998e3c6.png?v=1779256269",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_10_ccbd5b1d-20b7-4d24-9143-3ed9af4cfd5b.png?v=1779256269"
    }
   },
   "carat": 0.25
  },
  {
   "rank": 233,
   "id": "gid://shopify/Product/10408753856696",
   "title": "1.00-6.50 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-30051lb",
   "handle": "bridal-sets-30051lb",
   "priceNow": 2163.99,
   "priceWas": 6710.0,
   "pctOff": 68,
   "core": "30051",
   "inStock": true,
   "createdAt": "2026-05-19T20:49:51Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_ad0fefff-a4b2-41bb-91b8-2f8a48473c5e.png?v=1779256270",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_ad0fefff-a4b2-41bb-91b8-2f8a48473c5e.png?v=1779256270",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_157345a4-0817-4355-ac83-f80b56c5a49e.png?v=1779256270",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_0d60d291-27ae-471e-93eb-bda2511d1f9c.png?v=1779256270"
    }
   },
   "carat": 1.0,
   "caratMax": 6.5
  },
  {
   "rank": 234,
   "id": "gid://shopify/Product/10408753692856",
   "title": "0.25 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-30050lb",
   "handle": "wedding-bands-30050lb",
   "priceNow": 919.99,
   "priceWas": 3130.0,
   "pctOff": 71,
   "core": "30050",
   "inStock": true,
   "createdAt": "2026-05-19T20:49:47Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_22a0582d-2985-437d-b8e4-9cd9bdda4344.png?v=1779256270",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_22a0582d-2985-437d-b8e4-9cd9bdda4344.png?v=1779256270",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_933c6949-fb5f-46c2-9857-c53a27f2aaa3.png?v=1779256270",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_4c5406ac-2c12-4442-ad2e-c8550c1e0a49.png?v=1779256270"
    }
   },
   "carat": 0.25
  },
  {
   "rank": 235,
   "id": "gid://shopify/Product/10376386674872",
   "title": "1.20-6.70 CT Oval & Round Cut Diamonds - Bridal Set",
   "url": "/products/bridal-sets-30048lb",
   "handle": "bridal-sets-30048lb",
   "priceNow": 1885.99,
   "priceWas": 5850.0,
   "pctOff": 68,
   "core": "30048",
   "inStock": true,
   "createdAt": "2026-04-20T22:11:28Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": ""
   },
   "carat": 1.2,
   "caratMax": 6.7
  },
  {
   "rank": 236,
   "id": "gid://shopify/Product/10376386511032",
   "title": "1.00-6.50 CT Emerald & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-30046lb",
   "handle": "bridal-sets-30046lb",
   "priceNow": 2459.99,
   "priceWas": 7630.0,
   "pctOff": 68,
   "core": "30046",
   "inStock": true,
   "createdAt": "2026-04-20T22:11:20Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_2b5bfeb3-55ae-4c80-b983-0d73cdcc90fd.png?v=1776812232",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_2b5bfeb3-55ae-4c80-b983-0d73cdcc90fd.png?v=1776812232",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_0f40c425-9895-4eda-ad41-4f7ad4cf5e96.png?v=1776812232",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_53605d9e-453c-4e18-abab-fa1dd909f0e1.png?v=1776812232"
    }
   },
   "carat": 1.0,
   "caratMax": 6.5
  },
  {
   "rank": 237,
   "id": "gid://shopify/Product/10376386314424",
   "title": "0.90-6.40 CT Princess Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-30041lb",
   "handle": "bridal-sets-30041lb",
   "priceNow": 2468.99,
   "priceWas": 7650.0,
   "pctOff": 68,
   "core": "30041",
   "inStock": true,
   "createdAt": "2026-04-20T22:11:12Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_7d74edd1-6ef2-4e37-a99a-4e2bb18974da.png?v=1776812234",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_7d74edd1-6ef2-4e37-a99a-4e2bb18974da.png?v=1776812234",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_cb9f1bbf-a12a-445f-a02d-e8415e1c8bb8.png?v=1776812234",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_79f15086-3483-400c-818c-991d5afa6a3e.png?v=1776812234"
    }
   },
   "carat": 0.9,
   "caratMax": 6.4
  },
  {
   "rank": 238,
   "id": "gid://shopify/Product/10376386150584",
   "title": "1.15-6.65 CT Emerald & Round Cut Diamonds - Bridal Set",
   "url": "/products/bridal-sets-30039lb",
   "handle": "bridal-sets-30039lb",
   "priceNow": 1876.99,
   "priceWas": 5820.0,
   "pctOff": 68,
   "core": "30039",
   "inStock": true,
   "createdAt": "2026-04-20T22:11:04Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": ""
   },
   "carat": 1.15,
   "caratMax": 6.65
  },
  {
   "rank": 239,
   "id": "gid://shopify/Product/10376386019512",
   "title": "0.70-6.20 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-30038lb",
   "handle": "engagement-rings-30038lb",
   "priceNow": 1427.99,
   "priceWas": 4430.0,
   "pctOff": 68,
   "core": "30038",
   "inStock": true,
   "createdAt": "2026-04-20T22:10:57Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_9.png?v=1776812234",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_9.png?v=1776812234",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_11_7c2c187c-17b2-4922-bc13-462f0d32bc55.png?v=1776812234",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_10_cc93a154-2806-4f3e-8ff9-76b1d04135d0.png?v=1776812234"
    }
   },
   "carat": 0.7,
   "caratMax": 6.2
  },
  {
   "rank": 240,
   "id": "gid://shopify/Product/10376385921208",
   "title": "0.35 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-30049lb",
   "handle": "wedding-bands-30049lb",
   "priceNow": 935.99,
   "priceWas": 3180.0,
   "pctOff": 71,
   "core": "30049",
   "inStock": true,
   "createdAt": "2026-04-20T22:10:54Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_82fe81b9-d33e-4365-812b-bbc37c54a41c.png?v=1776812234",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_82fe81b9-d33e-4365-812b-bbc37c54a41c.png?v=1776812234",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_abcbba0e-9ad4-4487-8334-354ae96f885c.png?v=1776812235",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_77f8b435-d670-4bea-a282-324796a35677.png?v=1776812235"
    }
   },
   "carat": 0.35
  },
  {
   "rank": 241,
   "id": "gid://shopify/Product/10376385822904",
   "title": "0.20 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-30047lb",
   "handle": "wedding-bands-30047lb",
   "priceNow": 906.99,
   "priceWas": 3080.0,
   "pctOff": 71,
   "core": "30047",
   "inStock": true,
   "createdAt": "2026-04-20T22:10:51Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_e559a903-2b54-4045-b1be-abd0f098f2f7.png?v=1776812234",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_e559a903-2b54-4045-b1be-abd0f098f2f7.png?v=1776812234",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_69ecbeff-3789-4139-b01f-80b8e9120ee9.png?v=1776812235",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_7422c482-ac1b-4b4b-a0c6-215da914460f.png?v=1776812234"
    }
   },
   "carat": 0.2
  },
  {
   "rank": 242,
   "id": "gid://shopify/Product/10376385724600",
   "title": "0.15 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-30043lb",
   "handle": "wedding-bands-30043lb",
   "priceNow": 759.99,
   "priceWas": 2580.0,
   "pctOff": 71,
   "core": "30043",
   "inStock": true,
   "createdAt": "2026-04-20T22:10:48Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_5db3013c-8448-45fd-90f7-7e12f5b10c1c.png?v=1776812235",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_5db3013c-8448-45fd-90f7-7e12f5b10c1c.png?v=1776812235",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_15a805c4-b8e2-4cd1-aff7-a82e5e78ba7b.png?v=1776812234",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_9358bb28-8fb6-4709-bfc3-93cd05827220.png?v=1776812235"
    }
   },
   "carat": 0.15
  },
  {
   "rank": 243,
   "id": "gid://shopify/Product/10376385626296",
   "title": "0.40 CT Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-30042lb",
   "handle": "wedding-bands-30042lb",
   "priceNow": 946.99,
   "priceWas": 3220.0,
   "pctOff": 71,
   "core": "30042",
   "inStock": true,
   "createdAt": "2026-04-20T22:10:46Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_50cdead7-1e55-4254-bc41-30666120cc3a.png?v=1776812235",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_50cdead7-1e55-4254-bc41-30666120cc3a.png?v=1776812235",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_480f866a-3039-4c1d-bc4e-22b978392053.png?v=1776812235",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_27515744-0ccf-41e5-bf65-ba07321ec126.png?v=1776812234"
    }
   },
   "carat": 0.4
  },
  {
   "rank": 244,
   "id": "gid://shopify/Product/10376385560760",
   "title": "0.30 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-30040lb",
   "handle": "wedding-bands-30040lb",
   "priceNow": 812.99,
   "priceWas": 2760.0,
   "pctOff": 71,
   "core": "30040",
   "inStock": true,
   "createdAt": "2026-04-20T22:10:43Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_4eef0dc8-b453-41ac-ac2e-92edd0128cd8.png?v=1776812235",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_4eef0dc8-b453-41ac-ac2e-92edd0128cd8.png?v=1776812235",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_b16f10d5-e4a8-464b-b646-fc9c5d52e8a2.png?v=1776812235",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_2d6a3777-20ab-4b6e-b185-b80e056f2690.png?v=1776812235"
    }
   },
   "carat": 0.3
  },
  {
   "rank": 245,
   "id": "gid://shopify/Product/10376385462456",
   "title": "0.65 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-30037lb",
   "handle": "wedding-bands-30037lb",
   "priceNow": 902.99,
   "priceWas": 3070.0,
   "pctOff": 71,
   "core": "30037",
   "inStock": true,
   "createdAt": "2026-04-20T22:10:39Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_b53c5c86-637d-4fd3-b8b1-facef8b687b7.png?v=1776812234",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_b53c5c86-637d-4fd3-b8b1-facef8b687b7.png?v=1776812234",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_32792bd6-fb6d-42ba-980c-4d59b5fc05f6.png?v=1776812234",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_2afdba88-c243-4786-8316-5b9577d3af76.png?v=1776812234"
    }
   },
   "carat": 0.65
  },
  {
   "rank": 246,
   "id": "gid://shopify/Product/10274915451064",
   "title": "0.65 CT Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-rings-15265lb",
   "handle": "wedding-rings-15265lb",
   "priceNow": 1331.99,
   "priceWas": 4130.0,
   "pctOff": 68,
   "core": "15265",
   "inStock": true,
   "createdAt": "2026-03-19T18:39:48Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1sNEZCU32z_QRbfkndhk6iFZYCDjuOv2h",
      "b": "https://lh3.googleusercontent.com/d/1dsPm5GL9UF_7aN14nAdtVIXEWD6UusIp",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1FWYjcOEs96HPltiCzqnK9KdaBz9NoMWc",
      "b": "https://lh3.googleusercontent.com/d/1E2aMQC4NGlNBmn0XiepPIfufq_-qokgf",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1gU8Ng-ndEsfABJuTimMXMzAL7m9AB1S2",
      "b": "https://lh3.googleusercontent.com/d/1nJHUN1G8SHjAGSLHL1GeCM__gXNbU91Z",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_91f5f53d-40c7-4ad4-8004-e8d71abaf460.jpg?v=1774034531"
   },
   "carat": 0.65
  },
  {
   "rank": 247,
   "id": "gid://shopify/Product/10274915418296",
   "title": "0.30 CT Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-rings-30036lb",
   "handle": "wedding-rings-30036lb",
   "priceNow": 927.99,
   "priceWas": 3160.0,
   "pctOff": 71,
   "core": "30036",
   "inStock": true,
   "createdAt": "2026-03-19T18:39:45Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_ee3aca5b-d901-42d5-84ed-115499e11bf9.png?v=1774061410",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_ee3aca5b-d901-42d5-84ed-115499e11bf9.png?v=1774061410",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_09fe7f93-2081-4487-908e-782e3af99d3b.png?v=1774061410",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_edc54960-7679-4299-89a7-bb757fda6cec.png?v=1774061410"
    }
   },
   "carat": 0.3
  },
  {
   "rank": 248,
   "id": "gid://shopify/Product/10274915385528",
   "title": "3.20-8.70 CT Emerald & Princess Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-30035lb",
   "handle": "engagement-rings-30035lb",
   "priceNow": 3056.99,
   "priceWas": 9480.0,
   "pctOff": 68,
   "core": "30035",
   "inStock": true,
   "createdAt": "2026-03-19T18:39:41Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_9d758f16-2701-427b-9be2-cf6b390df271.png?v=1774061411",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_9d758f16-2701-427b-9be2-cf6b390df271.png?v=1774061411",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_c3b39a44-9ceb-4758-a56c-b6793926e101.png?v=1774061412",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_ce155609-3265-494d-ba61-b0a05aef39cb.png?v=1774061412"
    }
   },
   "carat": 3.2,
   "caratMax": 8.7
  },
  {
   "rank": 249,
   "id": "gid://shopify/Product/10274915352760",
   "title": "2.00 CT Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-rings-30034lb",
   "handle": "wedding-rings-30034lb",
   "priceNow": 1666.99,
   "priceWas": 5170.0,
   "pctOff": 68,
   "core": "30034",
   "inStock": true,
   "createdAt": "2026-03-19T18:39:37Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_7ba39c7f-afaf-46b5-a25b-bda42caaca6f.png?v=1774061411",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_7ba39c7f-afaf-46b5-a25b-bda42caaca6f.png?v=1774061411",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_5ebe6592-ad48-4679-a999-cef73794cc7e.png?v=1774061412",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_2d466b0d-d608-4b79-b413-defb913ec96c.png?v=1774061411"
    }
   },
   "carat": 2.0
  },
  {
   "rank": 250,
   "id": "gid://shopify/Product/10274915319992",
   "title": "0.10 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-rings-30033lb",
   "handle": "wedding-rings-30033lb",
   "priceNow": 648.99,
   "priceWas": 2210.0,
   "pctOff": 71,
   "core": "30033",
   "inStock": true,
   "createdAt": "2026-03-19T18:39:35Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_ad66b93e-e08c-4f8d-b3a4-3ebf2fa60074.png?v=1774061412",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_ad66b93e-e08c-4f8d-b3a4-3ebf2fa60074.png?v=1774061412",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_34b3b62c-dd69-4d2b-9322-9109ed8d1245.png?v=1774061414",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_b2b553d5-cce8-473e-846e-8336ea8ff5fe.png?v=1774061412"
    }
   },
   "carat": 0.1
  },
  {
   "rank": 251,
   "id": "gid://shopify/Product/10274915287224",
   "title": "0.60-6.10 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-30032lb",
   "handle": "bridal-sets-30032lb",
   "priceNow": 2620.99,
   "priceWas": 8130.0,
   "pctOff": 68,
   "core": "30032",
   "inStock": true,
   "createdAt": "2026-03-19T18:39:31Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_0691669a-0868-4100-ba43-07b25954956f.png?v=1774061412",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_0691669a-0868-4100-ba43-07b25954956f.png?v=1774061412",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_c8c43cca-acdf-47c5-9b3b-7c21d874ae0d.png?v=1774061413",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_a58d8c0f-cda2-45aa-8976-cbaf514000ed.png?v=1774061412"
    }
   },
   "carat": 0.6,
   "caratMax": 6.1
  },
  {
   "rank": 252,
   "id": "gid://shopify/Product/10274915254456",
   "title": "0.60 CT Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-rings-30031lb",
   "handle": "wedding-rings-30031lb",
   "priceNow": 1222.99,
   "priceWas": 3790.0,
   "pctOff": 68,
   "core": "30031",
   "inStock": true,
   "createdAt": "2026-03-19T18:39:30Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_5aec3d21-01a6-4746-9721-9e756b31dca5.png?v=1774061412",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_5aec3d21-01a6-4746-9721-9e756b31dca5.png?v=1774061412",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_fc33e74b-2c73-489e-8a2a-8beb33930879.png?v=1774061412",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_50a8e55d-4ebf-448c-957e-7c0f1d243f2f.png?v=1774061412"
    }
   },
   "carat": 0.6
  },
  {
   "rank": 253,
   "id": "gid://shopify/Product/10274915221688",
   "title": "0.30 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-rings-30030lb",
   "handle": "wedding-rings-30030lb",
   "priceNow": 1029.99,
   "priceWas": 3190.0,
   "pctOff": 68,
   "core": "30030",
   "inStock": true,
   "createdAt": "2026-03-19T18:39:27Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_5e125642-72b0-4bd0-91ba-945d157e62f9.png?v=1774061413",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_5e125642-72b0-4bd0-91ba-945d157e62f9.png?v=1774061413",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_7931f2c5-798d-494c-b4e4-fadfdb1805e8.png?v=1774061413",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_c39dbfec-b656-4ff0-8a1e-f4e739119cde.png?v=1774061413"
    }
   },
   "carat": 0.3
  },
  {
   "rank": 254,
   "id": "gid://shopify/Product/10274915188920",
   "title": "0.90 CT Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-rings-30029lb",
   "handle": "wedding-rings-30029lb",
   "priceNow": 1225.99,
   "priceWas": 3800.0,
   "pctOff": 68,
   "core": "30029",
   "inStock": true,
   "createdAt": "2026-03-19T18:39:25Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_3feae3f7-09d4-4733-9359-115e9a1ea1bc.png?v=1774061413",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_3feae3f7-09d4-4733-9359-115e9a1ea1bc.png?v=1774061413",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_b59c4798-bd13-4145-8071-6ed64e48154f.png?v=1774061413",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_7fd30359-969d-42a5-9eed-8220a24384d3.png?v=1774061413"
    }
   },
   "carat": 0.9
  },
  {
   "rank": 255,
   "id": "gid://shopify/Product/10274915156152",
   "title": "0.65-6.15 CT Pear & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-30028lb",
   "handle": "bridal-sets-30028lb",
   "priceNow": 1706.99,
   "priceWas": 5290.0,
   "pctOff": 68,
   "core": "30028",
   "inStock": true,
   "createdAt": "2026-03-19T18:39:21Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_371fe34b-e514-47ea-ba99-213084d24bcf.png?v=1774061413",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_371fe34b-e514-47ea-ba99-213084d24bcf.png?v=1774061413",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_35dc819d-6600-4837-9b24-118d163fd4da.png?v=1774061413",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_03a0350c-b1ad-4fb9-a0cd-f8d4b5b2c5e0.png?v=1774061413"
    }
   },
   "carat": 0.65,
   "caratMax": 6.15
  },
  {
   "rank": 256,
   "id": "gid://shopify/Product/10274915123384",
   "title": "0.15 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-rings-30027lb",
   "handle": "wedding-rings-30027lb",
   "priceNow": 657.99,
   "priceWas": 2240.0,
   "pctOff": 71,
   "core": "30027",
   "inStock": true,
   "createdAt": "2026-03-19T18:39:16Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_b69cc115-1ba6-448a-87b3-9f5112e2d186.png?v=1774061414",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_b69cc115-1ba6-448a-87b3-9f5112e2d186.png?v=1774061414",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_92281397-953c-4023-a767-931d7757df3b.png?v=1774061413",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_7_1c07f82d-eca5-4fd4-ab5a-c63f5b4471a4.png?v=1774061413"
    }
   },
   "carat": 0.15
  },
  {
   "rank": 257,
   "id": "gid://shopify/Product/10202344751288",
   "title": "4.20 CT Princess Cut Blue Sapphires and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15957lbs",
   "handle": "eternity-rings-15957lbs",
   "priceNow": 2252.99,
   "priceWas": 6875.0,
   "pctOff": 67,
   "core": "15957",
   "inStock": true,
   "createdAt": "2026-01-28T16:48:11Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1ycrfngL-ryUD8uM9zU0l_YZW_XiwREt1",
      "b": "https://lh3.googleusercontent.com/d/1Fc0R6Oqy4HD7f3Gcd_b_t0E7AxxbPEdb",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1oPEEk5Bl2ZbZWL9dMH1yuyZWUzpHgZDz",
      "b": "https://lh3.googleusercontent.com/d/1xjZMOOI_ru6KlIry9T12v2WXCsQSo0WA",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1kpMbVJG4cIEdPQ37TXsdQpgYkAgwgXvd",
      "b": "https://lh3.googleusercontent.com/d/1ljxf5jVz754OeoM88cF9YvQtSk6H5itG",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_2_cc340677-a6be-4385-93d1-66ae3a655c26.png?v=1771248188"
   },
   "carat": 4.2
  },
  {
   "rank": 258,
   "id": "gid://shopify/Product/10202344718520",
   "title": "3.00 CT Round Cut Blue Sapphires and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15952lbs",
   "handle": "eternity-rings-15952lbs",
   "priceNow": 1893.99,
   "priceWas": 5765.0,
   "pctOff": 67,
   "core": "15952",
   "inStock": true,
   "createdAt": "2026-01-28T16:48:03Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1kWaDprHiD1XpaIKCp92g3Rc0Ri--s2cs",
      "b": "https://lh3.googleusercontent.com/d/165qLyeIYG-rQqVEfUwNC9ve553cmH1jf",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/15PdvE9fqYptMuL0eQUiQxaTlbONGm-bb",
      "b": "https://lh3.googleusercontent.com/d/164sJ5gfa2N6eIf1wuk9Fx5VV1BJUkK_8",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1We1FWEy4WhK0OlD1UulUEYXYU54t1v2m",
      "b": "https://lh3.googleusercontent.com/d/1vrXv57h2IKk_nkJWMVJ6Lv9oKJtxfeMF",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_5_121623fe-c9f6-4f19-9001-c47c07bdfd51.png?v=1771248187"
   },
   "carat": 3.0
  },
  {
   "rank": 259,
   "id": "gid://shopify/Product/10202344652984",
   "title": "2.50 CT Princess Cut Blue Sapphires and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15366lbs",
   "handle": "eternity-rings-15366lbs",
   "priceNow": 1881.99,
   "priceWas": 5735.0,
   "pctOff": 67,
   "core": "15366",
   "inStock": true,
   "createdAt": "2026-01-28T16:47:58Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1RHIMhadpxGXK0gOr2vEi15WzYMbIAp_h",
      "b": "https://lh3.googleusercontent.com/d/13gGAjdLIuqCF93ImqKlnNh4rkmIXr-SV",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1xv4BLMQtdDssV-xaqlToqavmFOzE4JnV",
      "b": "https://lh3.googleusercontent.com/d/123idjBRXAj_jDHBBs1ObkzGE6fG5VtQJ",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1u1MGG_5Nzf02Xp8SkgNDnLimOsmWJXRt",
      "b": "https://lh3.googleusercontent.com/d/1_fJOI6HVrNmbT_2ss-5gs5j4SEvsupTi",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_ab2f93a1-b093-4474-9be7-f973760231e0.png?v=1771248187"
   },
   "carat": 2.5
  },
  {
   "rank": 260,
   "id": "gid://shopify/Product/10202344620216",
   "title": "5.50 CT Emerald Cut Blue Sapphires and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15365lbs",
   "handle": "eternity-rings-15365lbs",
   "priceNow": 2977.99,
   "priceWas": 9085.0,
   "pctOff": 67,
   "core": "15365",
   "inStock": true,
   "createdAt": "2026-01-28T16:47:51Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1R9ueVskiiNH56A1yFPudUM2K_ZB5KBh3",
      "b": "https://lh3.googleusercontent.com/d/1tgMqU7jrj-QO5MBMZ9C6l1ao6glrgeLR",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1-biDU5p8I91n-UkCwVrFz7k13eKU82Gy",
      "b": "https://lh3.googleusercontent.com/d/1jF4-Bl3b4TLk5JED2L0UZ5WjEUVBUCzh",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ucJ90lQ_S5p_pz2xfzBNvaMlSuIAXbF4",
      "b": "https://lh3.googleusercontent.com/d/15Obg5fjWHl1sah9HTNjRdbme1gFPzH3H",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_0b39402f-d886-4790-8120-ec5dbd404739.png?v=1771248187"
   },
   "carat": 5.5
  },
  {
   "rank": 261,
   "id": "gid://shopify/Product/10202344587448",
   "title": "1.00-4.00 CT Round Cut Blue Sapphires and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-16072lbs",
   "handle": "eternity-rings-16072lbs",
   "priceNow": 1591.99,
   "priceWas": 4835.0,
   "pctOff": 67,
   "core": "16072",
   "inStock": true,
   "createdAt": "2026-01-28T16:47:42Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1BZYO1440vZm4rKQ4p9Bkod-9sibRpXWp",
      "b": "https://lh3.googleusercontent.com/d/1lG7QfyBxry_6iJQ1rQkqYPjJU--ySbUC",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1tT3PfyGg4ufXJvJmCYZJjM0Z2cptM1VF",
      "b": "https://lh3.googleusercontent.com/d/10sjC36kn2_6rPZAlyFk01KZRV0VycGsQ",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/16lkI_Mm5vfLqXzMDuqNQqlNmwBFbo8QC",
      "b": "https://lh3.googleusercontent.com/d/16LC5tZTwImWrGMk8oDwAfy35E5AakHXx",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_0e0388a1-0959-4feb-94e8-fe29d73d2cb0.png?v=1771248187"
   },
   "carat": 1.0,
   "caratMax": 4.0
  },
  {
   "rank": 262,
   "id": "gid://shopify/Product/10202344489144",
   "title": "2.00-6.00 CT Round Cut Blue Sapphires and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71704lbs",
   "handle": "eternity-rings-71704lbs",
   "priceNow": 1812.99,
   "priceWas": 5505.0,
   "pctOff": 67,
   "core": "71704",
   "inStock": true,
   "createdAt": "2026-01-28T16:47:24Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1Jbp97R54lR_jvl69R3Otd9RXpRNpJUr1",
      "b": "https://lh3.googleusercontent.com/d/1WPHmGAhb1jwnWQokfhOWfUmJMHeeZ687",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1lOdPrhmAB5UhI4ZvnQ0tbdATf2D0gaA4",
      "b": "https://lh3.googleusercontent.com/d/1JaufbOVy4rK1F21ls4gbGqueVldnXMVI",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/14oczLPdsbKVUWa2YZ5U_03f1G1LU4ZUI",
      "b": "https://lh3.googleusercontent.com/d/1B356RBYEIaNKbtFNZPDrV6_GxLDi-znK",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_2_26f2292e-153f-4c2f-a1df-bf5bac4e1910.png?v=1771248187"
   },
   "carat": 2.0,
   "caratMax": 6.0
  },
  {
   "rank": 263,
   "id": "gid://shopify/Product/10202344456376",
   "title": "2.50 CT Round Cut Blue Sapphires and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15375lbs",
   "handle": "eternity-rings-15375lbs",
   "priceNow": 2053.99,
   "priceWas": 6255.0,
   "pctOff": 67,
   "core": "15375",
   "inStock": true,
   "createdAt": "2026-01-28T16:47:16Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/140y3U9INXdQlqXpzwrS5crz4CurqiUki",
      "b": "https://lh3.googleusercontent.com/d/1j_rUixNKIJ0DELhVf6i25wbmPk_X4kH_",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/12BKxSYDCoBN10gBJkiCh3773vaXc7-7F",
      "b": "https://lh3.googleusercontent.com/d/1InPT1fnEFy6Nc4JjRZmpzAnU5HGFi-fK",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/13SWzEZQf6hlbE54o-uOEEdyD-iCW0NiU",
      "b": "https://lh3.googleusercontent.com/d/1W7oiIhMSi8TRB9kaGzYDM8JXp3MtiOks",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_1a9bfe8b-b43a-4077-81a2-3d781ea2240d.png?v=1771248188"
   },
   "carat": 2.5
  },
  {
   "rank": 264,
   "id": "gid://shopify/Product/10202344358072",
   "title": "2.00-6.00 CT Round Cut Blue Sapphires and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71691lbs",
   "handle": "eternity-rings-71691lbs",
   "priceNow": 1913.99,
   "priceWas": 5835.0,
   "pctOff": 67,
   "core": "71691",
   "inStock": true,
   "createdAt": "2026-01-28T16:46:57Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1OBmY1CACTSLb0NxSHfanHoGuUG-TvK_A",
      "b": "https://lh3.googleusercontent.com/d/1JKalh0IuiPlJsyPUGrbRoIFnataIAj9f",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1_XZ8lb37WAq-3KMPHQVIljAdGBtu8A1O",
      "b": "https://lh3.googleusercontent.com/d/1cT8pin5Uzarl8q70JOzAgj_UugkWAia-",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ktU-OQzLK144qJYAKV-GJysmkSkgBdrL",
      "b": "https://lh3.googleusercontent.com/d/1d71cpGgCjAemaLV8MPe_ezuPtnNEMFoV",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_32146194-eeb5-4b13-8efa-fa617ff135ba.png?v=1771248188"
   },
   "carat": 2.0,
   "caratMax": 6.0
  },
  {
   "rank": 265,
   "id": "gid://shopify/Product/10202344325304",
   "title": "2.20 CT Round Cut Blue Sapphires and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15381lbs",
   "handle": "eternity-rings-15381lbs",
   "priceNow": 2867.99,
   "priceWas": 8700.0,
   "pctOff": 67,
   "core": "15381",
   "inStock": true,
   "createdAt": "2026-01-28T16:46:51Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/11AOCmK2XAyVv5CS4OknTVRCwiK43uotN",
      "b": "https://lh3.googleusercontent.com/d/1MGcM2RaXJdN_fB--SH6cFOSPQoA6jaiS",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1VzvLCPSl3l2yTl3HF9T31ENLCLaZN5os",
      "b": "https://lh3.googleusercontent.com/d/14sMWIJidaggbC_t3Axpi0IIf3DTT5aU8",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1RPfzSn4msK2fbxAJUoCbiBkKbZ47dA9H",
      "b": "https://lh3.googleusercontent.com/d/1_NZmvc8vutUcf7U283m_xucHQTpvDO-0",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_c3c14761-4d74-410b-8c6c-16828448a92b.png?v=1771248188"
   },
   "carat": 2.2
  },
  {
   "rank": 266,
   "id": "gid://shopify/Product/10202344292536",
   "title": "3.00-7.00 CT Princess Cut Blue Sapphires and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15360lbs",
   "handle": "eternity-rings-15360lbs",
   "priceNow": 1881.99,
   "priceWas": 5740.0,
   "pctOff": 67,
   "core": "15360",
   "inStock": true,
   "createdAt": "2026-01-28T16:46:43Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1L7zOGr1fjRxZqiIM9Om1WHrau_NdsrWe",
      "b": "https://lh3.googleusercontent.com/d/1dWEyvHL1M5xm58VZQ7TCRYhnZMFfqp33",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1Iw0dfZiNzH6INyrl8i-wE-iMg7QMV5mi",
      "b": "https://lh3.googleusercontent.com/d/1GmdRK2GDqmSL9BUkDwDo351kcFd-b_lU",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1fF3tbenTzoJoAqYrDdAfoxWQjBmfavsN",
      "b": "https://lh3.googleusercontent.com/d/1UjfO28gQWXWQ6maLjldXpTnMPXbMJpmK",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_2eee8721-997b-4060-a8cf-a1c6d68bd1b2.png?v=1771248188"
   },
   "carat": 3.0,
   "caratMax": 7.0
  },
  {
   "rank": 267,
   "id": "gid://shopify/Product/10202344227000",
   "title": "1.60 CT Princess Cut Blue Sapphires and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15369lbs",
   "handle": "eternity-rings-15369lbs",
   "priceNow": 1514.99,
   "priceWas": 4615.0,
   "pctOff": 67,
   "core": "15369",
   "inStock": true,
   "createdAt": "2026-01-28T16:46:35Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1fkJrD14GS5BvOydh-42xmVFAyyL83iFh",
      "b": "https://lh3.googleusercontent.com/d/1swxxxw0SlP87GfTP1CbdT_Q5IrFZJ6bc",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1hliBZTxixyA8kIqWXZLix64BqRRahOQC",
      "b": "https://lh3.googleusercontent.com/d/16EcqSF1bxtxw6RrOfKyX69iywEtrGzu9",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1sTVoiyoodacTdDPvqdarCuPztym4F4vX",
      "b": "https://lh3.googleusercontent.com/d/1g2nsKr7ECJEu92BinrHSGiXmfImHSDTy",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_2_b441f6f9-349e-4e04-8f8c-a62a16fd3f77.png?v=1771248188"
   },
   "carat": 1.6
  },
  {
   "rank": 268,
   "id": "gid://shopify/Product/10202344194232",
   "title": "1.50 CT Round Cut Blue Sapphires and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15379lbs",
   "handle": "eternity-rings-15379lbs",
   "priceNow": 1380.99,
   "priceWas": 4210.0,
   "pctOff": 67,
   "core": "15379",
   "inStock": true,
   "createdAt": "2026-01-28T16:46:29Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/18XT_v3wI2htyUTkin5DidEW9op5bLe1d",
      "b": "https://lh3.googleusercontent.com/d/13lIRfhMtE-nMQacEehdZMFhIRrujj3zo",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/10TenG4BQC03ZZEAGuq0q7pH7RnmJFnjU",
      "b": "https://lh3.googleusercontent.com/d/1BBbOXtVUReDWLscR4uvp1_WZuCYEF3FT",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1REZUn91Lzbveu9-k5ZMvo5TJewok5l2l",
      "b": "https://lh3.googleusercontent.com/d/190PLWm0kRD10n6fyCAyP-OCTlpIHVfWP",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_2_def8ad73-919f-4f46-ada0-973fd1045670.png?v=1771248188"
   },
   "carat": 1.5
  },
  {
   "rank": 269,
   "id": "gid://shopify/Product/10202344161464",
   "title": "1.50 CT Princess & Round Cut Blue Sapphires and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15947lbs",
   "handle": "eternity-rings-15947lbs",
   "priceNow": 1444.99,
   "priceWas": 4405.0,
   "pctOff": 67,
   "core": "15947",
   "inStock": true,
   "createdAt": "2026-01-28T16:46:17Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1yynZxOtY64RTjfcLyo3WIIW9SXtotDaN",
      "b": "https://lh3.googleusercontent.com/d/1mexvmzWpBg5KzR8I0VooY1Z-4fDk5V_E",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/10HRq2HWnFjyrx_-KolWv7OLLHoerb3sY",
      "b": "https://lh3.googleusercontent.com/d/1lz9E-MqluXEeHaYRcohSmsqtIz9YjmWl",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/10cukc7JldLVNVBwGMq6Tqr5YLJEjivg1",
      "b": "https://lh3.googleusercontent.com/d/1VjY5teaKHHchOkqOsTIYXux-pGi0MK9K",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_2_59c123fe-eb32-4bbe-9ce6-723d2e73cf50.png?v=1771248188"
   },
   "carat": 1.5
  },
  {
   "rank": 270,
   "id": "gid://shopify/Product/10202344128696",
   "title": "5.20 CT Emerald Cut Blue Sapphires and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15955lbs",
   "handle": "eternity-rings-15955lbs",
   "priceNow": 2705.99,
   "priceWas": 8255.0,
   "pctOff": 67,
   "core": "15955",
   "inStock": true,
   "createdAt": "2026-01-28T16:46:09Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1HFCRg5dS54CcAI8nRUt9jfyT9V-WPZQg",
      "b": "https://lh3.googleusercontent.com/d/1Xshg97AadUeVYGfQTpRWxzoL34BQQkEg",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1EAizKjJxllFof9NqcSPSVxwqMdKeu1tt",
      "b": "https://lh3.googleusercontent.com/d/1VqUu6tczDZLvnL0ym_WCdf09eFCHqxPw",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1_scObWzoBFrUz4aiAsrY2o4zHBADaEyG",
      "b": "https://lh3.googleusercontent.com/d/1bu0xsvy0OID172BIv4HmJUAL5gGTfrCp",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_4935b4aa-f86c-4e18-a012-0477ab9bb1c7.png?v=1771248188"
   },
   "carat": 5.2
  },
  {
   "rank": 271,
   "id": "gid://shopify/Product/10202344095928",
   "title": "4.60 CT Princess Cut Blue Sapphires and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15953lbs",
   "handle": "eternity-rings-15953lbs",
   "priceNow": 2778.99,
   "priceWas": 8465.0,
   "pctOff": 67,
   "core": "15953",
   "inStock": true,
   "createdAt": "2026-01-28T16:46:02Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1RIQYoGSvWzabJhx6jtOr1bS5BxC_ksWb",
      "b": "https://lh3.googleusercontent.com/d/1iilSOsdNAyda3VkABHArWWvF0ZI7pPJ_",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/10wFQaAlEDMy_48rVLnJ_-7-_DeIihOep",
      "b": "https://lh3.googleusercontent.com/d/1sVVsW01d6QhLnf5bIwcUMbGU88H8-HHw",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1a0eB7oUXF1z7IU52768KB7on0LK0hfB1",
      "b": "https://lh3.googleusercontent.com/d/12hKPlE0nH-XGIXgSaPZ3_Xpj3UeFk2DH",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_52f09d47-1ed7-48b8-9d28-3c7e9e21cc69.png?v=1771248188"
   },
   "carat": 4.6
  },
  {
   "rank": 272,
   "id": "gid://shopify/Product/10202344030392",
   "title": "1.70 CT Round Cut Blue Sapphires and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15951lbs",
   "handle": "eternity-rings-15951lbs",
   "priceNow": 1872.99,
   "priceWas": 5695.0,
   "pctOff": 67,
   "core": "15951",
   "inStock": true,
   "createdAt": "2026-01-28T16:45:55Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1e8GZnToV9m175HlJ9dLAlHAI0jX-0IXK",
      "b": "https://lh3.googleusercontent.com/d/1YvxQcHX0xYlxv9dNbNNf8v-ylijpLcu-",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1hEWP9zMxkUA4iDT4KGvf6HgzuJlqozJn",
      "b": "https://lh3.googleusercontent.com/d/1oTAUUjXHfvSHomclYhXWqp5yu2T2BmaA",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1JiVTsM-6iU6-qlmV7iKtjPRrCHzvoSxe",
      "b": "https://lh3.googleusercontent.com/d/1PLBKbLc9zjFI0Aa4jnPEvCd7GX3I3pBc",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_f042521f-e4c3-48a1-b973-4ecb56f4ca2d.png?v=1771248190"
   },
   "carat": 1.7
  },
  {
   "rank": 273,
   "id": "gid://shopify/Product/10202343964856",
   "title": "1.80 CT Round Cut Blue Sapphires and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15956lbs",
   "handle": "eternity-rings-15956lbs",
   "priceNow": 1985.99,
   "priceWas": 6045.0,
   "pctOff": 67,
   "core": "15956",
   "inStock": true,
   "createdAt": "2026-01-28T16:45:47Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1LR5bKSissicQHkCDvq4qATEPnKKOb-Yb",
      "b": "https://lh3.googleusercontent.com/d/1izQXvND-kCF3b1YEwd21RIi2Y0vTRp5v",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1OWAbn0SrCJVla04c4bZm77qlaTk8OQQE",
      "b": "https://lh3.googleusercontent.com/d/1MqM28IZElYMyqx_VevDRwwpRIONc5P_R",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1H-N5JtGqKHVgzOAgjPJFBZEPLFM2IL-R",
      "b": "https://lh3.googleusercontent.com/d/1RnoYKLYPf-qfzDZmgkr13Vwf3P4SrkJD",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_2_c9ee34b8-39ab-4f97-ba45-01e21dea0b0c.png?v=1771248191"
   },
   "carat": 1.8
  },
  {
   "rank": 274,
   "id": "gid://shopify/Product/10202343932088",
   "title": "1.50-5.00 CT Round Cut Blue Sapphires and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71689lbs",
   "handle": "eternity-rings-71689lbs",
   "priceNow": 1359.99,
   "priceWas": 4135.0,
   "pctOff": 67,
   "core": "71689",
   "inStock": true,
   "createdAt": "2026-01-28T16:45:42Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1bI-wqQ8OBaGb_KpO71vts7FSat2V-XPl",
      "b": "https://lh3.googleusercontent.com/d/1ialtB6_kZfrp29jrr9gyLadzRRHIFlMz",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1CUxz4xZyf_tvGmjA-jK6VqnS8EwQ33D2",
      "b": "https://lh3.googleusercontent.com/d/1G_7BG94YEvgtVev9gN1CC5X5LtyDttI4",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Jfs0kAM4o5Zj7QLaAiwIy7V0rdd1Tg_L",
      "b": "https://lh3.googleusercontent.com/d/1exNrY1wCf8Y5HXztmlCFd6VxvehFadA5",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_2_a762e333-cd63-4e20-8b82-fce1f2ba9b10.png?v=1771248190"
   },
   "carat": 1.5,
   "caratMax": 5.0
  },
  {
   "rank": 275,
   "id": "gid://shopify/Product/10202343899320",
   "title": "1.50-5.00 CT Round Cut Blue Sapphires and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71688lbs",
   "handle": "eternity-rings-71688lbs",
   "priceNow": 1359.99,
   "priceWas": 4135.0,
   "pctOff": 67,
   "core": "71688",
   "inStock": true,
   "createdAt": "2026-01-28T16:45:34Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/13fQQ9e7xP-xGJl1ihSeJ289QBnzMFYCj",
      "b": "https://lh3.googleusercontent.com/d/1qKlIOrs9EAkSgEuMnhq30kPO297E5IFb",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1DelxLSdZEwB76Eck1JHRTWdwHMiapH9q",
      "b": "https://lh3.googleusercontent.com/d/1YOQFlHqrYSCwWqG6zCn9IiGWIzj50nNR",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1pZ29gUXUr5KdN0_8DhFLgGvHwc3Ve99t",
      "b": "https://lh3.googleusercontent.com/d/1BKiYj9E2jbq055Lmt2e6SyW5Lo3Nhts1",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_2_fda466e5-67f1-49bf-91ae-d5f369902a6b.png?v=1771248190"
   },
   "carat": 1.5,
   "caratMax": 5.0
  },
  {
   "rank": 276,
   "id": "gid://shopify/Product/10202343866552",
   "title": "1.50-5.00 CT Round Cut Blue Sapphires and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71690lbs",
   "handle": "eternity-rings-71690lbs",
   "priceNow": 1594.99,
   "priceWas": 4845.0,
   "pctOff": 67,
   "core": "71690",
   "inStock": true,
   "createdAt": "2026-01-28T16:45:26Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1mYRjX_77un3E-LRxtUpwvEsWepcTMv9G",
      "b": "https://lh3.googleusercontent.com/d/1HUcZueo8dpMrnsVxY6tr13DU_opR3O3-",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1Lk6XpyAFEPFP0ZVWgLqSLiKnah7AQRa-",
      "b": "https://lh3.googleusercontent.com/d/1OTtNFrldsGThPxCYaX3yfAMD-LpGuJi1",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/10HJG-eih88gmqWNbxRv6XnagWv3eSX11",
      "b": "https://lh3.googleusercontent.com/d/1KNpnxNoP-Rv-IAABv4I7ELxWQYPaPsC3",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_2_4c5511fa-635c-4b22-be53-ce005307bba5.png?v=1771248190"
   },
   "carat": 1.5,
   "caratMax": 5.0
  },
  {
   "rank": 277,
   "id": "gid://shopify/Product/10202343833784",
   "title": "4.00-6.00 CT Round Cut Blue Sapphires and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71708lbs",
   "handle": "eternity-rings-71708lbs",
   "priceNow": 3772.99,
   "priceWas": 11470.0,
   "pctOff": 67,
   "core": "71708",
   "inStock": true,
   "createdAt": "2026-01-28T16:45:10Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1N1v5mYDxU_i5zzIGUEFd3PETKbgSqddW",
      "b": "https://lh3.googleusercontent.com/d/18cWic6CatdFH3_9dAcyIUF-ReEMAuHM_",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1fsJOq5L5UyNrq5W7XvPZE12pvTjnnh2t",
      "b": "https://lh3.googleusercontent.com/d/1x4fWNBKmRix_UDX2P7jVpW-HST0ngOt5",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1f-qBhcACozUbLGypVXTK2FDWGUiD4Le1",
      "b": "https://lh3.googleusercontent.com/d/1_nzr76UaA-LaG1v_cM9lRFr6d6gDyj9z",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_2_de0622dc-a170-4a64-9eef-a2676da24637.png?v=1771248191"
   },
   "carat": 4.0,
   "caratMax": 6.0
  },
  {
   "rank": 278,
   "id": "gid://shopify/Product/10202343768248",
   "title": "2.00-6.00 CT Round Cut Blue Sapphires and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71707lbs",
   "handle": "eternity-rings-71707lbs",
   "priceNow": 1452.99,
   "priceWas": 4425.0,
   "pctOff": 67,
   "core": "71707",
   "inStock": true,
   "createdAt": "2026-01-28T16:44:52Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1K0DG1KyBOatp11Z09iXtUOYP75SluqKP",
      "b": "https://lh3.googleusercontent.com/d/1DPJMO5wKWqXGyYRGfltrZT9xGbj2hdrN",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1NKq9i-ZiDwd20MlRcE1ExS4zWvdpNhf7",
      "b": "https://lh3.googleusercontent.com/d/13ijsKfGaQnoUCoZrgjxuuU7TJh6FTpvd",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1tj2tLeRr-fBYuKuj1E1p9d4CsIJjV7yB",
      "b": "https://lh3.googleusercontent.com/d/13JFVJZ0jMyGzkmpJW3l5zjg0ZGNw95gi",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_2_ce1ae35e-6665-49ca-85f7-926625090749.png?v=1771248191"
   },
   "carat": 2.0,
   "caratMax": 6.0
  },
  {
   "rank": 279,
   "id": "gid://shopify/Product/10202343735480",
   "title": "3.00-7.20 CT Round Cut Blue Sapphires and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71706lbs",
   "handle": "eternity-rings-71706lbs",
   "priceNow": 2407.99,
   "priceWas": 7325.0,
   "pctOff": 67,
   "core": "71706",
   "inStock": true,
   "createdAt": "2026-01-28T16:44:44Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1bQUqiFpdid03GdwRHqheG2FIGmITf3DM",
      "b": "https://lh3.googleusercontent.com/d/1jCa9-PC4h7_cEZeNAWccomZe9n1gBGH5",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1t4mzNTDr_IsjBGhbTGA8C2Y6372GV-2F",
      "b": "https://lh3.googleusercontent.com/d/1c-KCanBurAuJShHEEhR8-Kr0d5o-rpXq",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1SqZUMQFQws7GHBbXCS8fVLdWqaOVrTJh",
      "b": "https://lh3.googleusercontent.com/d/1lxbc0DhUBC6GEu8dYRFRv_EK7jj7W-jN",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_2_11bdefbf-db08-4bba-845a-75bee6c5c108.png?v=1771248190"
   },
   "carat": 3.0,
   "caratMax": 7.2
  },
  {
   "rank": 280,
   "id": "gid://shopify/Product/10202343669944",
   "title": "2.00-4.00 CT Princess Cut Blue Sapphires and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71705lbs",
   "handle": "eternity-rings-71705lbs",
   "priceNow": 1653.99,
   "priceWas": 5030.0,
   "pctOff": 67,
   "core": "71705",
   "inStock": true,
   "createdAt": "2026-01-28T16:44:37Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1pQvVo2k1RjZ_1Y--f09ogyiKkBebkcB5",
      "b": "https://lh3.googleusercontent.com/d/1N89bvy2kaeYyuTvVwwkKw_q-TALVvcUq",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/15vDe1ohz9XYE0b_jWINYy7Cd3gEvKbwj",
      "b": "https://lh3.googleusercontent.com/d/1SjWwYjW3_nNtZi0sf_BeyCgMixHXhbzB",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1XFRoieftKceGUYdEFFZI-IIXZL0uM-U5",
      "b": "https://lh3.googleusercontent.com/d/1LKj4RijZmVWz-ciYtajKRuJ_Ekv8ysm8",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_f5c42e04-fadb-4c40-8675-ecd196ce0361.png?v=1771248190"
   },
   "carat": 2.0,
   "caratMax": 4.0
  },
  {
   "rank": 281,
   "id": "gid://shopify/Product/10202343637176",
   "title": "2.00-6.00 CT Round Cut Blue Sapphires and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71722lbs",
   "handle": "eternity-rings-71722lbs",
   "priceNow": 1463.99,
   "priceWas": 4465.0,
   "pctOff": 67,
   "core": "71722",
   "inStock": true,
   "createdAt": "2026-01-28T16:44:31Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1BqKmxmVsvQkwHwjhFsORuNBn3xcI_gaJ",
      "b": "https://lh3.googleusercontent.com/d/1x5vzhOgniEp1qtlrVGKZqWvEhRkYM3VA",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1GNrWfjlV0tNYbGClkLT_gbimVqe5sjcb",
      "b": "https://lh3.googleusercontent.com/d/1tQ1WWz7l95bnas6K9KkkpEuUUek2OkeX",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1b0Bf0SaWvqH26Gb-YEj7s3d3LWHVxCwL",
      "b": "https://lh3.googleusercontent.com/d/1rUEgHEAbXzwnB4Ej2lHmazm3Yg3wc5Se",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_2_4a6bfaed-2667-4501-9095-9bcd906c836b.png?v=1771248190"
   },
   "carat": 2.0,
   "caratMax": 6.0
  },
  {
   "rank": 282,
   "id": "gid://shopify/Product/10202343571640",
   "title": "2.50 CT Emerald Cut Blue Sapphires and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71757lbs",
   "handle": "eternity-rings-71757lbs",
   "priceNow": 2119.99,
   "priceWas": 6435.0,
   "pctOff": 67,
   "core": "71757",
   "inStock": true,
   "createdAt": "2026-01-28T16:44:24Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1YxARV1Z6IcnD42nWssE1MBXeeDFRITNh",
      "b": "https://lh3.googleusercontent.com/d/16MIMdoqBGuEBSFSxJJx-j2QglSGPF20G",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1qawBkw8rleHIiK0aD9vY85gGBq3cq18j",
      "b": "https://lh3.googleusercontent.com/d/1rjdk-ugk-Ra0krNB5sXpNX8ZHkaSURqh",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ue43VndeFDURBNF9tlK_qce1CWjS9Zsv",
      "b": "https://lh3.googleusercontent.com/d/1hOu4S7U-cDBbq3GvZeR7XWKQjxthcAyI",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_2_8808e077-efa4-404b-a57d-98b9a8f85db9.png?v=1771248190"
   },
   "carat": 2.5
  },
  {
   "rank": 283,
   "id": "gid://shopify/Product/10202343538872",
   "title": "1.50-5.00 CT Round Cut Blue Sapphires and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71732lbs",
   "handle": "eternity-rings-71732lbs",
   "priceNow": 1359.99,
   "priceWas": 4135.0,
   "pctOff": 67,
   "core": "71732",
   "inStock": true,
   "createdAt": "2026-01-28T16:44:16Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1__SI_r_pqzSyn2T074JbbRCVcU_kgdNv",
      "b": "https://lh3.googleusercontent.com/d/1JP-nPp-FByLjmtCGw_wfEsTYribKK0j3",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1qz8Ur4I4Ezh0IDYc1py6jcaAZVi5XuiT",
      "b": "https://lh3.googleusercontent.com/d/1GJX_TnxTLVW5VAE-HNnN2CoOllllUNx6",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1m_jvSRPMRmiSCyji-cS-rUxuvW-ah_Ks",
      "b": "https://lh3.googleusercontent.com/d/1AthgtrkskMe1luvjh74_N4kZ7WgCN0CA",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_2_fd6de892-1403-4b99-818d-4dd2788a48d2.png?v=1771248191"
   },
   "carat": 1.5,
   "caratMax": 5.0
  },
  {
   "rank": 284,
   "id": "gid://shopify/Product/10202343506104",
   "title": "2.50-6.00 CT Round Cut Blue Sapphires and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71731lbs",
   "handle": "eternity-rings-71731lbs",
   "priceNow": 1905.99,
   "priceWas": 5795.0,
   "pctOff": 67,
   "core": "71731",
   "inStock": true,
   "createdAt": "2026-01-28T16:44:09Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1RdRVrvP8xX5OvMJHAKhSDzhKbf7lqoL1",
      "b": "https://lh3.googleusercontent.com/d/1t0vkZWg21XRRHSpas0JmRFO-ilMWnoH5",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/14Zq98jHOF_jRyLh0DB_8bc1tBkBvsLtx",
      "b": "https://lh3.googleusercontent.com/d/1JWr26chJCMhdsPjIRaE6YQ5VfHUQBfTV",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Os2ckkHi5R3Nc3tSejwgydEEztSMrjOe",
      "b": "https://lh3.googleusercontent.com/d/1CHFV5A1RdoXBUpzaya7IwOKB9TrAZAbL",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_2_8fc74184-d2d1-4f51-b9b1-28f991829a8e.png?v=1771248190"
   },
   "carat": 2.5,
   "caratMax": 6.0
  },
  {
   "rank": 285,
   "id": "gid://shopify/Product/10202343407800",
   "title": "0.50-2.00 CT Round Cut Blue Sapphires and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71730lbs",
   "handle": "eternity-rings-71730lbs",
   "priceNow": 1045.99,
   "priceWas": 3455.0,
   "pctOff": 70,
   "core": "71730",
   "inStock": true,
   "createdAt": "2026-01-28T16:44:01Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1NEclVh_byFVu1-CdlMgDVxgNt0Mzs0rk",
      "b": "https://lh3.googleusercontent.com/d/1ToUBvs5qggoh_YPku9SkdPmJYEgTNem3",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1TJQO-B0LCHrulkrpKjk0Y41X4U7A_TbF",
      "b": "https://lh3.googleusercontent.com/d/1sMZrORvdCT1kcm-GnRSAUMuZuY13OWLV",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1bXszf4wyCRyoqaZfhldBzrmQJTRyjMZg",
      "b": "https://lh3.googleusercontent.com/d/1savTjO-HpAslVmRMBRwDfzwBgrGVqrZM",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_2_9c13607b-f5cc-4a2b-aeb2-f35443d26162.png?v=1771248191"
   },
   "carat": 0.5,
   "caratMax": 2.0
  },
  {
   "rank": 286,
   "id": "gid://shopify/Product/10202343342264",
   "title": "4.00-7.00 CT Emerald Cut Blue Sapphires and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71716lbs",
   "handle": "eternity-rings-71716lbs",
   "priceNow": 2666.99,
   "priceWas": 8115.0,
   "pctOff": 67,
   "core": "71716",
   "inStock": true,
   "createdAt": "2026-01-28T16:43:49Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1ZWsSPca4XeEzzdR4MfpOVMLNy76e5CPw",
      "b": "https://lh3.googleusercontent.com/d/1w1Lhs25m3_V3NLhmsgQGFf5R6H_eQjQU",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1YS84ELDLfnA7QbNNXe9A9WfHIUwNi7n6",
      "b": "https://lh3.googleusercontent.com/d/19VsMo1jbTVt_C5ZfOwNljX09zPUPooX_",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1m4ziMurLEVzagf2QgBob9UZShqX-UWvt",
      "b": "https://lh3.googleusercontent.com/d/1BBCBUdUjdw1ezeN83Nkc50B36Bfr5V8x",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_2_4942f1d8-1e61-4f7e-ae93-be429fde31fb.png?v=1771248190"
   },
   "carat": 4.0,
   "caratMax": 7.0
  },
  {
   "rank": 287,
   "id": "gid://shopify/Product/10202343309496",
   "title": "7.20 CT Round Cut Blue Sapphires and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15958lbs",
   "handle": "eternity-rings-15958lbs",
   "priceNow": 3933.99,
   "priceWas": 11975.0,
   "pctOff": 67,
   "core": "15958",
   "inStock": true,
   "createdAt": "2026-01-28T16:43:39Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/10tla2_o9XH24wTO6PsjIcdiodvnREIYn",
      "b": "https://lh3.googleusercontent.com/d/1RZd-K66Qiz-Nzpp3JKZsnaEwUkUUTIfe",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1D7jgS1WdsD661ocW-MKUYkdcvJVP_kpc",
      "b": "https://lh3.googleusercontent.com/d/1uiq-7z7aGmuaOTTi_cf052NhmIvA-FWR",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1z4OSHuhXsZtProGnKysETL4884D6blev",
      "b": "https://lh3.googleusercontent.com/d/13Kea_LwTycWfAyyXUVOvt9TBEF7etBYO",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_2_7849ff92-bf07-4ac6-b514-8ce5f964ff71.png?v=1771248247"
   },
   "carat": 7.2
  },
  {
   "rank": 288,
   "id": "gid://shopify/Product/10202343276728",
   "title": "5.20 CT Emerald Cut Blue Sapphires and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-16206lbs",
   "handle": "eternity-rings-16206lbs",
   "priceNow": 2705.99,
   "priceWas": 8255.0,
   "pctOff": 67,
   "core": "16206",
   "inStock": true,
   "createdAt": "2026-01-28T16:43:32Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1Flnm_CiP2a0TUMvlECFPar7ZCSSbPcYE",
      "b": "https://lh3.googleusercontent.com/d/1Le-IMLevIyV0JitdheBgQNfUEx5qPXtN",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/19_ZPKRbAYN5Oo0fmnvHrT1uoXcSF20sx",
      "b": "https://lh3.googleusercontent.com/d/1aGmg-kD2Xq3r2_S5EgAljAaNT55BltEP",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1rtHbI7XHBVatQKGgQbR61ZQH0KMvdIGL",
      "b": "https://lh3.googleusercontent.com/d/1p1bINDQfPiOYE86WMs67navUeEUewoNV",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_2_f61df696-9ab5-441f-96dc-2b8b8d239399.png?v=1771248248"
   },
   "carat": 5.2
  },
  {
   "rank": 289,
   "id": "gid://shopify/Product/10202343243960",
   "title": "4.10 CT Round Cut Blue Sapphires and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71640lbs",
   "handle": "eternity-rings-71640lbs",
   "priceNow": 2128.99,
   "priceWas": 6485.0,
   "pctOff": 67,
   "core": "71640",
   "inStock": true,
   "createdAt": "2026-01-28T16:43:23Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1OAUT_Zk-9xmK0K0CTsxZHbeJVE4yULs6",
      "b": "https://lh3.googleusercontent.com/d/1wLHdl4bD_de0Lo87PpnnPo-2GBtmnsiO",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1i7QONHC3NJISpimt-WNwBdM2BIvqHXBp",
      "b": "https://lh3.googleusercontent.com/d/1jGHNb4-81WTxI9S9JQGhg8MvUa_OJxXE",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1rRVeCM_50r_Dbrh96KP2VFh2iQF7RCPj",
      "b": "https://lh3.googleusercontent.com/d/1GqWhxJkmFr8RSmxV-eh8HSUhbSCIoXxA",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_2_f4ed0d99-7152-439a-a61f-eb5d1df48c0d.png?v=1771248249"
   },
   "carat": 4.1
  },
  {
   "rank": 290,
   "id": "gid://shopify/Product/10202323288248",
   "title": "2.50 CT Princess Cut Green Emeralds and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15366lbge",
   "handle": "eternity-rings-15366lbge",
   "priceNow": 1881.99,
   "priceWas": 5735.0,
   "pctOff": 67,
   "core": "15366",
   "inStock": true,
   "createdAt": "2026-01-28T14:57:55Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1RHIMhadpxGXK0gOr2vEi15WzYMbIAp_h",
      "b": "https://lh3.googleusercontent.com/d/13gGAjdLIuqCF93ImqKlnNh4rkmIXr-SV",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1xv4BLMQtdDssV-xaqlToqavmFOzE4JnV",
      "b": "https://lh3.googleusercontent.com/d/123idjBRXAj_jDHBBs1ObkzGE6fG5VtQJ",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1u1MGG_5Nzf02Xp8SkgNDnLimOsmWJXRt",
      "b": "https://lh3.googleusercontent.com/d/1_fJOI6HVrNmbT_2ss-5gs5j4SEvsupTi",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_172b252a-4d01-4d50-8e78-0b74f3787cae.png?v=1771248249"
   },
   "carat": 2.5
  },
  {
   "rank": 291,
   "id": "gid://shopify/Product/10202323222712",
   "title": "3.00-7.00 CT Princess Cut Green Emeralds and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15360lbge",
   "handle": "eternity-rings-15360lbge",
   "priceNow": 1881.99,
   "priceWas": 5740.0,
   "pctOff": 67,
   "core": "15360",
   "inStock": true,
   "createdAt": "2026-01-28T14:57:36Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1L7zOGr1fjRxZqiIM9Om1WHrau_NdsrWe",
      "b": "https://lh3.googleusercontent.com/d/1dWEyvHL1M5xm58VZQ7TCRYhnZMFfqp33",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1Iw0dfZiNzH6INyrl8i-wE-iMg7QMV5mi",
      "b": "https://lh3.googleusercontent.com/d/1GmdRK2GDqmSL9BUkDwDo351kcFd-b_lU",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1fF3tbenTzoJoAqYrDdAfoxWQjBmfavsN",
      "b": "https://lh3.googleusercontent.com/d/1UjfO28gQWXWQ6maLjldXpTnMPXbMJpmK",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_68fb245f-a59c-419e-a16e-ff1d54a72f11.png?v=1771248249"
   },
   "carat": 3.0,
   "caratMax": 7.0
  },
  {
   "rank": 292,
   "id": "gid://shopify/Product/10202322337976",
   "title": "4.20 CT Princess Cut Green Emeralds and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15957lbge",
   "handle": "eternity-rings-15957lbge",
   "priceNow": 2252.99,
   "priceWas": 6875.0,
   "pctOff": 67,
   "core": "15957",
   "inStock": true,
   "createdAt": "2026-01-28T14:53:41Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1ycrfngL-ryUD8uM9zU0l_YZW_XiwREt1",
      "b": "https://lh3.googleusercontent.com/d/1Fc0R6Oqy4HD7f3Gcd_b_t0E7AxxbPEdb",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1oPEEk5Bl2ZbZWL9dMH1yuyZWUzpHgZDz",
      "b": "https://lh3.googleusercontent.com/d/1xjZMOOI_ru6KlIry9T12v2WXCsQSo0WA",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1kpMbVJG4cIEdPQ37TXsdQpgYkAgwgXvd",
      "b": "https://lh3.googleusercontent.com/d/1ljxf5jVz754OeoM88cF9YvQtSk6H5itG",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_b95b76be-8392-428e-844c-d05c0ff38842.png?v=1771248249"
   },
   "carat": 4.2
  },
  {
   "rank": 293,
   "id": "gid://shopify/Product/10202322239672",
   "title": "3.00 CT Round Cut Green Emeralds and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15952lbge",
   "handle": "eternity-rings-15952lbge",
   "priceNow": 1893.99,
   "priceWas": 5765.0,
   "pctOff": 67,
   "core": "15952",
   "inStock": true,
   "createdAt": "2026-01-28T14:53:35Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1kWaDprHiD1XpaIKCp92g3Rc0Ri--s2cs",
      "b": "https://lh3.googleusercontent.com/d/165qLyeIYG-rQqVEfUwNC9ve553cmH1jf",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/15PdvE9fqYptMuL0eQUiQxaTlbONGm-bb",
      "b": "https://lh3.googleusercontent.com/d/164sJ5gfa2N6eIf1wuk9Fx5VV1BJUkK_8",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1We1FWEy4WhK0OlD1UulUEYXYU54t1v2m",
      "b": "https://lh3.googleusercontent.com/d/1vrXv57h2IKk_nkJWMVJ6Lv9oKJtxfeMF",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_f23898e3-67fe-45cc-a9e5-0b2536bbe77a.png?v=1771248249"
   },
   "carat": 3.0
  },
  {
   "rank": 294,
   "id": "gid://shopify/Product/10202322108600",
   "title": "5.50 CT Emerald Cut Green Emeralds and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15365lbge",
   "handle": "eternity-rings-15365lbge",
   "priceNow": 2977.99,
   "priceWas": 9085.0,
   "pctOff": 67,
   "core": "15365",
   "inStock": true,
   "createdAt": "2026-01-28T14:53:26Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1R9ueVskiiNH56A1yFPudUM2K_ZB5KBh3",
      "b": "https://lh3.googleusercontent.com/d/1tgMqU7jrj-QO5MBMZ9C6l1ao6glrgeLR",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1-biDU5p8I91n-UkCwVrFz7k13eKU82Gy",
      "b": "https://lh3.googleusercontent.com/d/1jF4-Bl3b4TLk5JED2L0UZ5WjEUVBUCzh",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ucJ90lQ_S5p_pz2xfzBNvaMlSuIAXbF4",
      "b": "https://lh3.googleusercontent.com/d/15Obg5fjWHl1sah9HTNjRdbme1gFPzH3H",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_681d8070-a585-4899-b645-8ffa174ed28f.png?v=1771248249"
   },
   "carat": 5.5
  },
  {
   "rank": 295,
   "id": "gid://shopify/Product/10202322043064",
   "title": "1.00-4.00 CT Round Cut Green Emeralds and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-16072lbge",
   "handle": "eternity-rings-16072lbge",
   "priceNow": 1591.99,
   "priceWas": 4835.0,
   "pctOff": 67,
   "core": "16072",
   "inStock": true,
   "createdAt": "2026-01-28T14:53:17Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1BZYO1440vZm4rKQ4p9Bkod-9sibRpXWp",
      "b": "https://lh3.googleusercontent.com/d/1lG7QfyBxry_6iJQ1rQkqYPjJU--ySbUC",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1tT3PfyGg4ufXJvJmCYZJjM0Z2cptM1VF",
      "b": "https://lh3.googleusercontent.com/d/10sjC36kn2_6rPZAlyFk01KZRV0VycGsQ",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/16lkI_Mm5vfLqXzMDuqNQqlNmwBFbo8QC",
      "b": "https://lh3.googleusercontent.com/d/16LC5tZTwImWrGMk8oDwAfy35E5AakHXx",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_a5d176ea-7be5-46cb-b5fe-26ea23d16056.png?v=1771248249"
   },
   "carat": 1.0,
   "caratMax": 4.0
  },
  {
   "rank": 296,
   "id": "gid://shopify/Product/10202321944760",
   "title": "4.00-6.00 CT Emerald Cut Green Emeralds and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71612lbge",
   "handle": "eternity-rings-71612lbge",
   "priceNow": 2338.99,
   "priceWas": 7130.0,
   "pctOff": 67,
   "core": "71612",
   "inStock": true,
   "createdAt": "2026-01-28T14:53:11Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1VHKMdiUobCofk0RIRhDdgAYZaoPhDQnN",
      "b": "https://lh3.googleusercontent.com/d/1-3n-VNRv3Cl-NY5ftT-4ur_rw4K6BjTb",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1a3RqwyWnMk4u8QtD2aBSfi-h4AelIeSF",
      "b": "https://lh3.googleusercontent.com/d/1s4BrSE8hScliuLHcoUj8RsUAFJftLOPL",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1zDeMwL7uiPw4AzEV3ztMTf_8DuRXZg01",
      "b": "https://lh3.googleusercontent.com/d/1Cn7FWejtNnQXyWnhbURN3nkyH_dzr9Uz",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_4682f2e2-a7de-4ace-b7c3-6f3a1a853420.png?v=1771248249"
   },
   "carat": 4.0,
   "caratMax": 6.0
  },
  {
   "rank": 297,
   "id": "gid://shopify/Product/10202321911992",
   "title": "2.00-6.00 CT Round Cut Green Emeralds and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71704lbge",
   "handle": "eternity-rings-71704lbge",
   "priceNow": 1812.99,
   "priceWas": 5505.0,
   "pctOff": 67,
   "core": "71704",
   "inStock": true,
   "createdAt": "2026-01-28T14:53:00Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1Jbp97R54lR_jvl69R3Otd9RXpRNpJUr1",
      "b": "https://lh3.googleusercontent.com/d/1WPHmGAhb1jwnWQokfhOWfUmJMHeeZ687",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1lOdPrhmAB5UhI4ZvnQ0tbdATf2D0gaA4",
      "b": "https://lh3.googleusercontent.com/d/1JaufbOVy4rK1F21ls4gbGqueVldnXMVI",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/14oczLPdsbKVUWa2YZ5U_03f1G1LU4ZUI",
      "b": "https://lh3.googleusercontent.com/d/1B356RBYEIaNKbtFNZPDrV6_GxLDi-znK",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_fc76e0a2-356b-4df5-8af0-e5dcf7085745.png?v=1771248249"
   },
   "carat": 2.0,
   "caratMax": 6.0
  },
  {
   "rank": 298,
   "id": "gid://shopify/Product/10202321879224",
   "title": "2.50 CT Round Cut Green Emeralds and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15375lbge",
   "handle": "eternity-rings-15375lbge",
   "priceNow": 2053.99,
   "priceWas": 6255.0,
   "pctOff": 67,
   "core": "15375",
   "inStock": true,
   "createdAt": "2026-01-28T14:52:53Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/140y3U9INXdQlqXpzwrS5crz4CurqiUki",
      "b": "https://lh3.googleusercontent.com/d/1j_rUixNKIJ0DELhVf6i25wbmPk_X4kH_",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/12BKxSYDCoBN10gBJkiCh3773vaXc7-7F",
      "b": "https://lh3.googleusercontent.com/d/1InPT1fnEFy6Nc4JjRZmpzAnU5HGFi-fK",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/13SWzEZQf6hlbE54o-uOEEdyD-iCW0NiU",
      "b": "https://lh3.googleusercontent.com/d/1W7oiIhMSi8TRB9kaGzYDM8JXp3MtiOks",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_45812ac8-b5fd-4f03-8b5c-c229fc630c8e.png?v=1771248249"
   },
   "carat": 2.5
  },
  {
   "rank": 299,
   "id": "gid://shopify/Product/10202321780920",
   "title": "2.00-6.00 CT Round Cut Green Emeralds and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71691lbge",
   "handle": "eternity-rings-71691lbge",
   "priceNow": 1913.99,
   "priceWas": 5835.0,
   "pctOff": 67,
   "core": "71691",
   "inStock": true,
   "createdAt": "2026-01-28T14:52:43Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1OBmY1CACTSLb0NxSHfanHoGuUG-TvK_A",
      "b": "https://lh3.googleusercontent.com/d/1JKalh0IuiPlJsyPUGrbRoIFnataIAj9f",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1_XZ8lb37WAq-3KMPHQVIljAdGBtu8A1O",
      "b": "https://lh3.googleusercontent.com/d/1cT8pin5Uzarl8q70JOzAgj_UugkWAia-",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ktU-OQzLK144qJYAKV-GJysmkSkgBdrL",
      "b": "https://lh3.googleusercontent.com/d/1d71cpGgCjAemaLV8MPe_ezuPtnNEMFoV",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_5_a3eec9db-15e4-41af-8e21-77f32afb831b.png?v=1771248249"
   },
   "carat": 2.0,
   "caratMax": 6.0
  },
  {
   "rank": 300,
   "id": "gid://shopify/Product/10202321682616",
   "title": "2.20 CT Round Cut Green Emeralds and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15381lbge",
   "handle": "eternity-rings-15381lbge",
   "priceNow": 2867.99,
   "priceWas": 8700.0,
   "pctOff": 67,
   "core": "15381",
   "inStock": true,
   "createdAt": "2026-01-28T14:52:37Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/11AOCmK2XAyVv5CS4OknTVRCwiK43uotN",
      "b": "https://lh3.googleusercontent.com/d/1MGcM2RaXJdN_fB--SH6cFOSPQoA6jaiS",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1VzvLCPSl3l2yTl3HF9T31ENLCLaZN5os",
      "b": "https://lh3.googleusercontent.com/d/14sMWIJidaggbC_t3Axpi0IIf3DTT5aU8",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1RPfzSn4msK2fbxAJUoCbiBkKbZ47dA9H",
      "b": "https://lh3.googleusercontent.com/d/1_NZmvc8vutUcf7U283m_xucHQTpvDO-0",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_09f6bcb8-2127-4ed1-88e5-d316f5e6cf47.png?v=1771248249"
   },
   "carat": 2.2
  },
  {
   "rank": 301,
   "id": "gid://shopify/Product/10202321551544",
   "title": "1.60 CT Princess Cut Green Emeralds and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15369lbge",
   "handle": "eternity-rings-15369lbge",
   "priceNow": 1514.99,
   "priceWas": 4615.0,
   "pctOff": 67,
   "core": "15369",
   "inStock": true,
   "createdAt": "2026-01-28T14:52:27Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1fkJrD14GS5BvOydh-42xmVFAyyL83iFh",
      "b": "https://lh3.googleusercontent.com/d/1swxxxw0SlP87GfTP1CbdT_Q5IrFZJ6bc",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1hliBZTxixyA8kIqWXZLix64BqRRahOQC",
      "b": "https://lh3.googleusercontent.com/d/16EcqSF1bxtxw6RrOfKyX69iywEtrGzu9",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1sTVoiyoodacTdDPvqdarCuPztym4F4vX",
      "b": "https://lh3.googleusercontent.com/d/1g2nsKr7ECJEu92BinrHSGiXmfImHSDTy",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_8c209ee2-d2f0-49cf-9ea6-ccb39a993175.png?v=1771248249"
   },
   "carat": 1.6
  },
  {
   "rank": 302,
   "id": "gid://shopify/Product/10202321518776",
   "title": "1.50 CT Round Cut Green Emeralds and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15379lbge",
   "handle": "eternity-rings-15379lbge",
   "priceNow": 1380.99,
   "priceWas": 4210.0,
   "pctOff": 67,
   "core": "15379",
   "inStock": true,
   "createdAt": "2026-01-28T14:52:19Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/18XT_v3wI2htyUTkin5DidEW9op5bLe1d",
      "b": "https://lh3.googleusercontent.com/d/13lIRfhMtE-nMQacEehdZMFhIRrujj3zo",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/10TenG4BQC03ZZEAGuq0q7pH7RnmJFnjU",
      "b": "https://lh3.googleusercontent.com/d/1BBbOXtVUReDWLscR4uvp1_WZuCYEF3FT",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1REZUn91Lzbveu9-k5ZMvo5TJewok5l2l",
      "b": "https://lh3.googleusercontent.com/d/190PLWm0kRD10n6fyCAyP-OCTlpIHVfWP",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_bb06efa8-4ca1-448d-9fea-35953fc62d31.png?v=1771248249"
   },
   "carat": 1.5
  },
  {
   "rank": 303,
   "id": "gid://shopify/Product/10202321420472",
   "title": "1.50 CT Princess & Round Cut Green Emeralds and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15947lbge",
   "handle": "eternity-rings-15947lbge",
   "priceNow": 1444.99,
   "priceWas": 4405.0,
   "pctOff": 67,
   "core": "15947",
   "inStock": true,
   "createdAt": "2026-01-28T14:52:12Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1yynZxOtY64RTjfcLyo3WIIW9SXtotDaN",
      "b": "https://lh3.googleusercontent.com/d/1mexvmzWpBg5KzR8I0VooY1Z-4fDk5V_E",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/10HRq2HWnFjyrx_-KolWv7OLLHoerb3sY",
      "b": "https://lh3.googleusercontent.com/d/1lz9E-MqluXEeHaYRcohSmsqtIz9YjmWl",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/10cukc7JldLVNVBwGMq6Tqr5YLJEjivg1",
      "b": "https://lh3.googleusercontent.com/d/1VjY5teaKHHchOkqOsTIYXux-pGi0MK9K",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_b9c47bea-6d0e-4b4b-8385-90237edb3bff.png?v=1771248251"
   },
   "carat": 1.5
  },
  {
   "rank": 304,
   "id": "gid://shopify/Product/10202321322168",
   "title": "5.20 CT Emerald Cut Green Emeralds and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15955lbge",
   "handle": "eternity-rings-15955lbge",
   "priceNow": 2705.99,
   "priceWas": 8255.0,
   "pctOff": 67,
   "core": "15955",
   "inStock": true,
   "createdAt": "2026-01-28T14:52:02Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1HFCRg5dS54CcAI8nRUt9jfyT9V-WPZQg",
      "b": "https://lh3.googleusercontent.com/d/1Xshg97AadUeVYGfQTpRWxzoL34BQQkEg",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1EAizKjJxllFof9NqcSPSVxwqMdKeu1tt",
      "b": "https://lh3.googleusercontent.com/d/1VqUu6tczDZLvnL0ym_WCdf09eFCHqxPw",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1_scObWzoBFrUz4aiAsrY2o4zHBADaEyG",
      "b": "https://lh3.googleusercontent.com/d/1bu0xsvy0OID172BIv4HmJUAL5gGTfrCp",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_c566ab53-b854-4f33-9a21-134f83723a7d.png?v=1771248251"
   },
   "carat": 5.2
  },
  {
   "rank": 305,
   "id": "gid://shopify/Product/10202321289400",
   "title": "4.60 CT Princess Cut Green Emeralds and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15953lbge",
   "handle": "eternity-rings-15953lbge",
   "priceNow": 2778.99,
   "priceWas": 8465.0,
   "pctOff": 67,
   "core": "15953",
   "inStock": true,
   "createdAt": "2026-01-28T14:51:55Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1RIQYoGSvWzabJhx6jtOr1bS5BxC_ksWb",
      "b": "https://lh3.googleusercontent.com/d/1iilSOsdNAyda3VkABHArWWvF0ZI7pPJ_",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/10wFQaAlEDMy_48rVLnJ_-7-_DeIihOep",
      "b": "https://lh3.googleusercontent.com/d/1sVVsW01d6QhLnf5bIwcUMbGU88H8-HHw",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1a0eB7oUXF1z7IU52768KB7on0LK0hfB1",
      "b": "https://lh3.googleusercontent.com/d/12hKPlE0nH-XGIXgSaPZ3_Xpj3UeFk2DH",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_53d50737-ecd9-43dc-b41c-0eff1a238b5c.png?v=1771248251"
   },
   "carat": 4.6
  },
  {
   "rank": 306,
   "id": "gid://shopify/Product/10202321191096",
   "title": "1.70 CT Round Cut Green Emeralds and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15951lbge",
   "handle": "eternity-rings-15951lbge",
   "priceNow": 1872.99,
   "priceWas": 5695.0,
   "pctOff": 67,
   "core": "15951",
   "inStock": true,
   "createdAt": "2026-01-28T14:51:44Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1e8GZnToV9m175HlJ9dLAlHAI0jX-0IXK",
      "b": "https://lh3.googleusercontent.com/d/1YvxQcHX0xYlxv9dNbNNf8v-ylijpLcu-",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1hEWP9zMxkUA4iDT4KGvf6HgzuJlqozJn",
      "b": "https://lh3.googleusercontent.com/d/1oTAUUjXHfvSHomclYhXWqp5yu2T2BmaA",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1JiVTsM-6iU6-qlmV7iKtjPRrCHzvoSxe",
      "b": "https://lh3.googleusercontent.com/d/1PLBKbLc9zjFI0Aa4jnPEvCd7GX3I3pBc",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_375d920b-b6e6-4280-81b4-2d7b2588ddf7.png?v=1771248251"
   },
   "carat": 1.7
  },
  {
   "rank": 307,
   "id": "gid://shopify/Product/10202321158328",
   "title": "1.80 CT Round Cut Green Emeralds and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15956lbge",
   "handle": "eternity-rings-15956lbge",
   "priceNow": 1985.99,
   "priceWas": 6045.0,
   "pctOff": 67,
   "core": "15956",
   "inStock": true,
   "createdAt": "2026-01-28T14:51:36Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1LR5bKSissicQHkCDvq4qATEPnKKOb-Yb",
      "b": "https://lh3.googleusercontent.com/d/1izQXvND-kCF3b1YEwd21RIi2Y0vTRp5v",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1OWAbn0SrCJVla04c4bZm77qlaTk8OQQE",
      "b": "https://lh3.googleusercontent.com/d/1MqM28IZElYMyqx_VevDRwwpRIONc5P_R",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1H-N5JtGqKHVgzOAgjPJFBZEPLFM2IL-R",
      "b": "https://lh3.googleusercontent.com/d/1RnoYKLYPf-qfzDZmgkr13Vwf3P4SrkJD",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_c31fa476-bcdc-4db5-b4cb-0913f953eda8.png?v=1771248251"
   },
   "carat": 1.8
  },
  {
   "rank": 308,
   "id": "gid://shopify/Product/10202321092792",
   "title": "1.50-5.00 CT Round Cut Green Emeralds and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71689lbge",
   "handle": "eternity-rings-71689lbge",
   "priceNow": 1359.99,
   "priceWas": 4135.0,
   "pctOff": 67,
   "core": "71689",
   "inStock": true,
   "createdAt": "2026-01-28T14:51:27Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1bI-wqQ8OBaGb_KpO71vts7FSat2V-XPl",
      "b": "https://lh3.googleusercontent.com/d/1ialtB6_kZfrp29jrr9gyLadzRRHIFlMz",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1CUxz4xZyf_tvGmjA-jK6VqnS8EwQ33D2",
      "b": "https://lh3.googleusercontent.com/d/1G_7BG94YEvgtVev9gN1CC5X5LtyDttI4",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Jfs0kAM4o5Zj7QLaAiwIy7V0rdd1Tg_L",
      "b": "https://lh3.googleusercontent.com/d/1exNrY1wCf8Y5HXztmlCFd6VxvehFadA5",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_f68eeb7a-f79c-4496-9978-e3bfed9a9b6c.png?v=1771248251"
   },
   "carat": 1.5,
   "caratMax": 5.0
  },
  {
   "rank": 309,
   "id": "gid://shopify/Product/10202321060024",
   "title": "1.50-5.00 CT Round Cut Green Emeralds and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71688lbge",
   "handle": "eternity-rings-71688lbge",
   "priceNow": 1359.99,
   "priceWas": 4135.0,
   "pctOff": 67,
   "core": "71688",
   "inStock": true,
   "createdAt": "2026-01-28T14:51:20Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/13fQQ9e7xP-xGJl1ihSeJ289QBnzMFYCj",
      "b": "https://lh3.googleusercontent.com/d/1qKlIOrs9EAkSgEuMnhq30kPO297E5IFb",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1DelxLSdZEwB76Eck1JHRTWdwHMiapH9q",
      "b": "https://lh3.googleusercontent.com/d/1YOQFlHqrYSCwWqG6zCn9IiGWIzj50nNR",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1pZ29gUXUr5KdN0_8DhFLgGvHwc3Ve99t",
      "b": "https://lh3.googleusercontent.com/d/1BKiYj9E2jbq055Lmt2e6SyW5Lo3Nhts1",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_2bf09fc9-a54f-4e5f-b458-4dd15830126a.png?v=1771248251"
   },
   "carat": 1.5,
   "caratMax": 5.0
  },
  {
   "rank": 310,
   "id": "gid://shopify/Product/10202320994488",
   "title": "1.50-5.00 CT Round Cut Green Emeralds and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71690lbge",
   "handle": "eternity-rings-71690lbge",
   "priceNow": 1594.99,
   "priceWas": 4845.0,
   "pctOff": 67,
   "core": "71690",
   "inStock": true,
   "createdAt": "2026-01-28T14:51:12Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1mYRjX_77un3E-LRxtUpwvEsWepcTMv9G",
      "b": "https://lh3.googleusercontent.com/d/1HUcZueo8dpMrnsVxY6tr13DU_opR3O3-",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1Lk6XpyAFEPFP0ZVWgLqSLiKnah7AQRa-",
      "b": "https://lh3.googleusercontent.com/d/1OTtNFrldsGThPxCYaX3yfAMD-LpGuJi1",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/10HJG-eih88gmqWNbxRv6XnagWv3eSX11",
      "b": "https://lh3.googleusercontent.com/d/1KNpnxNoP-Rv-IAABv4I7ELxWQYPaPsC3",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_8d444cd4-68b5-4d57-b207-6bdd5b16e1d8.png?v=1771248251"
   },
   "carat": 1.5,
   "caratMax": 5.0
  },
  {
   "rank": 311,
   "id": "gid://shopify/Product/10202320928952",
   "title": "4.00-6.00 CT Round Cut Green Emeralds and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71708lbge",
   "handle": "eternity-rings-71708lbge",
   "priceNow": 3772.99,
   "priceWas": 11470.0,
   "pctOff": 67,
   "core": "71708",
   "inStock": true,
   "createdAt": "2026-01-28T14:51:05Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1N1v5mYDxU_i5zzIGUEFd3PETKbgSqddW",
      "b": "https://lh3.googleusercontent.com/d/18cWic6CatdFH3_9dAcyIUF-ReEMAuHM_",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1fsJOq5L5UyNrq5W7XvPZE12pvTjnnh2t",
      "b": "https://lh3.googleusercontent.com/d/1x4fWNBKmRix_UDX2P7jVpW-HST0ngOt5",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1f-qBhcACozUbLGypVXTK2FDWGUiD4Le1",
      "b": "https://lh3.googleusercontent.com/d/1_nzr76UaA-LaG1v_cM9lRFr6d6gDyj9z",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_f930d23c-63ec-4a24-ab28-ed00b3c1d101.png?v=1771248251"
   },
   "carat": 4.0,
   "caratMax": 6.0
  },
  {
   "rank": 312,
   "id": "gid://shopify/Product/10202320896184",
   "title": "2.00-6.00 CT Round Cut Green Emeralds and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71707lbge",
   "handle": "eternity-rings-71707lbge",
   "priceNow": 1452.99,
   "priceWas": 4425.0,
   "pctOff": 67,
   "core": "71707",
   "inStock": true,
   "createdAt": "2026-01-28T14:50:58Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1K0DG1KyBOatp11Z09iXtUOYP75SluqKP",
      "b": "https://lh3.googleusercontent.com/d/1DPJMO5wKWqXGyYRGfltrZT9xGbj2hdrN",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1NKq9i-ZiDwd20MlRcE1ExS4zWvdpNhf7",
      "b": "https://lh3.googleusercontent.com/d/13ijsKfGaQnoUCoZrgjxuuU7TJh6FTpvd",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1tj2tLeRr-fBYuKuj1E1p9d4CsIJjV7yB",
      "b": "https://lh3.googleusercontent.com/d/13JFVJZ0jMyGzkmpJW3l5zjg0ZGNw95gi",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_95a08f3a-2ec1-41fa-bb35-b492a7d194b5.png?v=1771248251"
   },
   "carat": 2.0,
   "caratMax": 6.0
  },
  {
   "rank": 313,
   "id": "gid://shopify/Product/10202320863416",
   "title": "3.00-7.20 CT Round Cut Green Emeralds and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71706lbge",
   "handle": "eternity-rings-71706lbge",
   "priceNow": 2407.99,
   "priceWas": 7325.0,
   "pctOff": 67,
   "core": "71706",
   "inStock": true,
   "createdAt": "2026-01-28T14:50:49Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1bQUqiFpdid03GdwRHqheG2FIGmITf3DM",
      "b": "https://lh3.googleusercontent.com/d/1jCa9-PC4h7_cEZeNAWccomZe9n1gBGH5",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1t4mzNTDr_IsjBGhbTGA8C2Y6372GV-2F",
      "b": "https://lh3.googleusercontent.com/d/1c-KCanBurAuJShHEEhR8-Kr0d5o-rpXq",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1SqZUMQFQws7GHBbXCS8fVLdWqaOVrTJh",
      "b": "https://lh3.googleusercontent.com/d/1lxbc0DhUBC6GEu8dYRFRv_EK7jj7W-jN",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_3610e69a-ffc9-4aa6-97b2-5d0adb97729a.png?v=1771248251"
   },
   "carat": 3.0,
   "caratMax": 7.2
  },
  {
   "rank": 314,
   "id": "gid://shopify/Product/10202320830648",
   "title": "2.00-4.00 CT Princess Cut Green Emeralds and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71705lbge",
   "handle": "eternity-rings-71705lbge",
   "priceNow": 1653.99,
   "priceWas": 5030.0,
   "pctOff": 67,
   "core": "71705",
   "inStock": true,
   "createdAt": "2026-01-28T14:50:41Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1pQvVo2k1RjZ_1Y--f09ogyiKkBebkcB5",
      "b": "https://lh3.googleusercontent.com/d/1N89bvy2kaeYyuTvVwwkKw_q-TALVvcUq",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/15vDe1ohz9XYE0b_jWINYy7Cd3gEvKbwj",
      "b": "https://lh3.googleusercontent.com/d/1SjWwYjW3_nNtZi0sf_BeyCgMixHXhbzB",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1XFRoieftKceGUYdEFFZI-IIXZL0uM-U5",
      "b": "https://lh3.googleusercontent.com/d/1LKj4RijZmVWz-ciYtajKRuJ_Ekv8ysm8",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_acd0cda3-f083-4237-975c-a9d5afa76071.png?v=1771248251"
   },
   "carat": 2.0,
   "caratMax": 4.0
  },
  {
   "rank": 315,
   "id": "gid://shopify/Product/10202320797880",
   "title": "2.00-6.00 CT Round Cut Green Emeralds and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71722lbge",
   "handle": "eternity-rings-71722lbge",
   "priceNow": 1463.99,
   "priceWas": 4465.0,
   "pctOff": 67,
   "core": "71722",
   "inStock": true,
   "createdAt": "2026-01-28T14:50:34Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1BqKmxmVsvQkwHwjhFsORuNBn3xcI_gaJ",
      "b": "https://lh3.googleusercontent.com/d/1x5vzhOgniEp1qtlrVGKZqWvEhRkYM3VA",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1GNrWfjlV0tNYbGClkLT_gbimVqe5sjcb",
      "b": "https://lh3.googleusercontent.com/d/1tQ1WWz7l95bnas6K9KkkpEuUUek2OkeX",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1b0Bf0SaWvqH26Gb-YEj7s3d3LWHVxCwL",
      "b": "https://lh3.googleusercontent.com/d/1rUEgHEAbXzwnB4Ej2lHmazm3Yg3wc5Se",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_56bf7b4b-c0d2-4407-af50-8cb41bdd5ba7.png?v=1771248251"
   },
   "carat": 2.0,
   "caratMax": 6.0
  },
  {
   "rank": 316,
   "id": "gid://shopify/Product/10202320765112",
   "title": "2.50 CT Emerald Cut Green Emeralds and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71757lbge",
   "handle": "eternity-rings-71757lbge",
   "priceNow": 2119.99,
   "priceWas": 6435.0,
   "pctOff": 67,
   "core": "71757",
   "inStock": true,
   "createdAt": "2026-01-28T14:50:27Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1YxARV1Z6IcnD42nWssE1MBXeeDFRITNh",
      "b": "https://lh3.googleusercontent.com/d/16MIMdoqBGuEBSFSxJJx-j2QglSGPF20G",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1qawBkw8rleHIiK0aD9vY85gGBq3cq18j",
      "b": "https://lh3.googleusercontent.com/d/1rjdk-ugk-Ra0krNB5sXpNX8ZHkaSURqh",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ue43VndeFDURBNF9tlK_qce1CWjS9Zsv",
      "b": "https://lh3.googleusercontent.com/d/1hOu4S7U-cDBbq3GvZeR7XWKQjxthcAyI",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_52f82538-765d-415f-9795-1d5e4cb356fe.png?v=1771248251"
   },
   "carat": 2.5
  },
  {
   "rank": 317,
   "id": "gid://shopify/Product/10202320732344",
   "title": "1.50-5.00 CT Round Cut Green Emeralds and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71732lbge",
   "handle": "eternity-rings-71732lbge",
   "priceNow": 1359.99,
   "priceWas": 4135.0,
   "pctOff": 67,
   "core": "71732",
   "inStock": true,
   "createdAt": "2026-01-28T14:50:18Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1__SI_r_pqzSyn2T074JbbRCVcU_kgdNv",
      "b": "https://lh3.googleusercontent.com/d/1JP-nPp-FByLjmtCGw_wfEsTYribKK0j3",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1qz8Ur4I4Ezh0IDYc1py6jcaAZVi5XuiT",
      "b": "https://lh3.googleusercontent.com/d/1GJX_TnxTLVW5VAE-HNnN2CoOllllUNx6",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1m_jvSRPMRmiSCyji-cS-rUxuvW-ah_Ks",
      "b": "https://lh3.googleusercontent.com/d/1AthgtrkskMe1luvjh74_N4kZ7WgCN0CA",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_9d6d895d-bed3-45a4-942e-4853f45b0a25.png?v=1771248251"
   },
   "carat": 1.5,
   "caratMax": 5.0
  },
  {
   "rank": 318,
   "id": "gid://shopify/Product/10202320699576",
   "title": "2.50-6.00 CT Round Cut Green Emeralds and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71731lbge",
   "handle": "eternity-rings-71731lbge",
   "priceNow": 1905.99,
   "priceWas": 5795.0,
   "pctOff": 67,
   "core": "71731",
   "inStock": true,
   "createdAt": "2026-01-28T14:50:08Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1RdRVrvP8xX5OvMJHAKhSDzhKbf7lqoL1",
      "b": "https://lh3.googleusercontent.com/d/1t0vkZWg21XRRHSpas0JmRFO-ilMWnoH5",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/14Zq98jHOF_jRyLh0DB_8bc1tBkBvsLtx",
      "b": "https://lh3.googleusercontent.com/d/1JWr26chJCMhdsPjIRaE6YQ5VfHUQBfTV",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Os2ckkHi5R3Nc3tSejwgydEEztSMrjOe",
      "b": "https://lh3.googleusercontent.com/d/1CHFV5A1RdoXBUpzaya7IwOKB9TrAZAbL",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_789d6c21-055a-4fd2-b68b-d49e5dab1597.png?v=1771248306"
   },
   "carat": 2.5,
   "caratMax": 6.0
  },
  {
   "rank": 319,
   "id": "gid://shopify/Product/10202320535736",
   "title": "0.50-2.00 CT Round Cut Green Emeralds and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71730lbge",
   "handle": "eternity-rings-71730lbge",
   "priceNow": 1045.99,
   "priceWas": 3455.0,
   "pctOff": 70,
   "core": "71730",
   "inStock": true,
   "createdAt": "2026-01-28T14:50:01Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1NEclVh_byFVu1-CdlMgDVxgNt0Mzs0rk",
      "b": "https://lh3.googleusercontent.com/d/1ToUBvs5qggoh_YPku9SkdPmJYEgTNem3",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1TJQO-B0LCHrulkrpKjk0Y41X4U7A_TbF",
      "b": "https://lh3.googleusercontent.com/d/1sMZrORvdCT1kcm-GnRSAUMuZuY13OWLV",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1bXszf4wyCRyoqaZfhldBzrmQJTRyjMZg",
      "b": "https://lh3.googleusercontent.com/d/1savTjO-HpAslVmRMBRwDfzwBgrGVqrZM",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_270531ae-1641-4b78-b8d0-10f7fbfde4f2.png?v=1771248306"
   },
   "carat": 0.5,
   "caratMax": 2.0
  },
  {
   "rank": 320,
   "id": "gid://shopify/Product/10202320470200",
   "title": "4.00-7.00 CT Emerald Cut Green Emeralds and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71716lbge",
   "handle": "eternity-rings-71716lbge",
   "priceNow": 2666.99,
   "priceWas": 8115.0,
   "pctOff": 67,
   "core": "71716",
   "inStock": true,
   "createdAt": "2026-01-28T14:49:53Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1ZWsSPca4XeEzzdR4MfpOVMLNy76e5CPw",
      "b": "https://lh3.googleusercontent.com/d/1w1Lhs25m3_V3NLhmsgQGFf5R6H_eQjQU",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1YS84ELDLfnA7QbNNXe9A9WfHIUwNi7n6",
      "b": "https://lh3.googleusercontent.com/d/19VsMo1jbTVt_C5ZfOwNljX09zPUPooX_",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1m4ziMurLEVzagf2QgBob9UZShqX-UWvt",
      "b": "https://lh3.googleusercontent.com/d/1BBCBUdUjdw1ezeN83Nkc50B36Bfr5V8x",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_d7c1bc52-04c0-4a35-9f84-ddcb56cccb0a.png?v=1771248306"
   },
   "carat": 4.0,
   "caratMax": 7.0
  },
  {
   "rank": 321,
   "id": "gid://shopify/Product/10202320437432",
   "title": "7.20 CT Round Cut Green Emeralds and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15958lbge",
   "handle": "eternity-rings-15958lbge",
   "priceNow": 3933.99,
   "priceWas": 11975.0,
   "pctOff": 67,
   "core": "15958",
   "inStock": true,
   "createdAt": "2026-01-28T14:49:46Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/10tla2_o9XH24wTO6PsjIcdiodvnREIYn",
      "b": "https://lh3.googleusercontent.com/d/1RZd-K66Qiz-Nzpp3JKZsnaEwUkUUTIfe",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1D7jgS1WdsD661ocW-MKUYkdcvJVP_kpc",
      "b": "https://lh3.googleusercontent.com/d/1uiq-7z7aGmuaOTTi_cf052NhmIvA-FWR",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1z4OSHuhXsZtProGnKysETL4884D6blev",
      "b": "https://lh3.googleusercontent.com/d/13Kea_LwTycWfAyyXUVOvt9TBEF7etBYO",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_c8e7826b-ca26-4c2d-a778-38e176b346e0.png?v=1771248306"
   },
   "carat": 7.2
  },
  {
   "rank": 322,
   "id": "gid://shopify/Product/10202320371896",
   "title": "5.20 CT Emerald Cut Green Emeralds and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-16206lbge",
   "handle": "eternity-rings-16206lbge",
   "priceNow": 2705.99,
   "priceWas": 8255.0,
   "pctOff": 67,
   "core": "16206",
   "inStock": true,
   "createdAt": "2026-01-28T14:49:40Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1Flnm_CiP2a0TUMvlECFPar7ZCSSbPcYE",
      "b": "https://lh3.googleusercontent.com/d/1Le-IMLevIyV0JitdheBgQNfUEx5qPXtN",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/19_ZPKRbAYN5Oo0fmnvHrT1uoXcSF20sx",
      "b": "https://lh3.googleusercontent.com/d/1aGmg-kD2Xq3r2_S5EgAljAaNT55BltEP",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1rtHbI7XHBVatQKGgQbR61ZQH0KMvdIGL",
      "b": "https://lh3.googleusercontent.com/d/1p1bINDQfPiOYE86WMs67navUeEUewoNV",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_ba96aa20-f5b5-45ef-bfd0-8993b5cd61cc.png?v=1771248306"
   },
   "carat": 5.2
  },
  {
   "rank": 323,
   "id": "gid://shopify/Product/10202320339128",
   "title": "4.10 CT Round Cut Green Emeralds and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71640lbge",
   "handle": "eternity-rings-71640lbge",
   "priceNow": 2128.99,
   "priceWas": 6485.0,
   "pctOff": 67,
   "core": "71640",
   "inStock": true,
   "createdAt": "2026-01-28T14:49:32Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1OAUT_Zk-9xmK0K0CTsxZHbeJVE4yULs6",
      "b": "https://lh3.googleusercontent.com/d/1wLHdl4bD_de0Lo87PpnnPo-2GBtmnsiO",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1i7QONHC3NJISpimt-WNwBdM2BIvqHXBp",
      "b": "https://lh3.googleusercontent.com/d/1jGHNb4-81WTxI9S9JQGhg8MvUa_OJxXE",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1rRVeCM_50r_Dbrh96KP2VFh2iQF7RCPj",
      "b": "https://lh3.googleusercontent.com/d/1GqWhxJkmFr8RSmxV-eh8HSUhbSCIoXxA",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_dbaafa29-c2fd-446d-aac0-70a78eab427c.png?v=1771248306"
   },
   "carat": 4.1
  },
  {
   "rank": 324,
   "id": "gid://shopify/Product/10202013663416",
   "title": "4.20 CT Princess Cut Rubies and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15957lbr",
   "handle": "eternity-rings-15957lbr",
   "priceNow": 2252.99,
   "priceWas": 6875.0,
   "pctOff": 67,
   "core": "15957",
   "inStock": true,
   "createdAt": "2026-01-27T22:36:21Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1ycrfngL-ryUD8uM9zU0l_YZW_XiwREt1",
      "b": "https://lh3.googleusercontent.com/d/1Fc0R6Oqy4HD7f3Gcd_b_t0E7AxxbPEdb",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1oPEEk5Bl2ZbZWL9dMH1yuyZWUzpHgZDz",
      "b": "https://lh3.googleusercontent.com/d/1xjZMOOI_ru6KlIry9T12v2WXCsQSo0WA",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1kpMbVJG4cIEdPQ37TXsdQpgYkAgwgXvd",
      "b": "https://lh3.googleusercontent.com/d/1ljxf5jVz754OeoM88cF9YvQtSk6H5itG",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_3c09347e-6430-4569-88e6-1a344e67a5ee.png?v=1771248306"
   },
   "carat": 4.2
  },
  {
   "rank": 325,
   "id": "gid://shopify/Product/10202013630648",
   "title": "3.00 CT Round Cut Rubies and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15952lbr",
   "handle": "eternity-rings-15952lbr",
   "priceNow": 1893.99,
   "priceWas": 5765.0,
   "pctOff": 67,
   "core": "15952",
   "inStock": true,
   "createdAt": "2026-01-27T22:36:13Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1kWaDprHiD1XpaIKCp92g3Rc0Ri--s2cs",
      "b": "https://lh3.googleusercontent.com/d/165qLyeIYG-rQqVEfUwNC9ve553cmH1jf",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/15PdvE9fqYptMuL0eQUiQxaTlbONGm-bb",
      "b": "https://lh3.googleusercontent.com/d/164sJ5gfa2N6eIf1wuk9Fx5VV1BJUkK_8",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1We1FWEy4WhK0OlD1UulUEYXYU54t1v2m",
      "b": "https://lh3.googleusercontent.com/d/1vrXv57h2IKk_nkJWMVJ6Lv9oKJtxfeMF",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8099dac8-9d87-4a18-95d4-e77e7d35db4d.png?v=1771248306"
   },
   "carat": 3.0
  },
  {
   "rank": 326,
   "id": "gid://shopify/Product/10202013565112",
   "title": "5.50 CT Emerald Cut Rubies and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15365lbr",
   "handle": "eternity-rings-15365lbr",
   "priceNow": 2977.99,
   "priceWas": 9085.0,
   "pctOff": 67,
   "core": "15365",
   "inStock": true,
   "createdAt": "2026-01-27T22:36:01Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1R9ueVskiiNH56A1yFPudUM2K_ZB5KBh3",
      "b": "https://lh3.googleusercontent.com/d/1tgMqU7jrj-QO5MBMZ9C6l1ao6glrgeLR",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1-biDU5p8I91n-UkCwVrFz7k13eKU82Gy",
      "b": "https://lh3.googleusercontent.com/d/1jF4-Bl3b4TLk5JED2L0UZ5WjEUVBUCzh",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ucJ90lQ_S5p_pz2xfzBNvaMlSuIAXbF4",
      "b": "https://lh3.googleusercontent.com/d/15Obg5fjWHl1sah9HTNjRdbme1gFPzH3H",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_2_6f1b087c-947b-45cb-bb00-56112039af9b.png?v=1771248306"
   },
   "carat": 5.5
  },
  {
   "rank": 327,
   "id": "gid://shopify/Product/10202013532344",
   "title": "1.00-4.00 CT Round Cut Rubies and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-16072lbr",
   "handle": "eternity-rings-16072lbr",
   "priceNow": 1591.99,
   "priceWas": 4835.0,
   "pctOff": 67,
   "core": "16072",
   "inStock": true,
   "createdAt": "2026-01-27T22:35:50Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1BZYO1440vZm4rKQ4p9Bkod-9sibRpXWp",
      "b": "https://lh3.googleusercontent.com/d/1lG7QfyBxry_6iJQ1rQkqYPjJU--ySbUC",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1tT3PfyGg4ufXJvJmCYZJjM0Z2cptM1VF",
      "b": "https://lh3.googleusercontent.com/d/10sjC36kn2_6rPZAlyFk01KZRV0VycGsQ",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/16lkI_Mm5vfLqXzMDuqNQqlNmwBFbo8QC",
      "b": "https://lh3.googleusercontent.com/d/16LC5tZTwImWrGMk8oDwAfy35E5AakHXx",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_2_0966d077-0d37-41af-aa55-9777eb64ed4c.png?v=1771248306"
   },
   "carat": 1.0,
   "caratMax": 4.0
  },
  {
   "rank": 328,
   "id": "gid://shopify/Product/10202013499576",
   "title": "4.00-6.00 CT Emerald Cut Rubies and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71612lbr",
   "handle": "eternity-rings-71612lbr",
   "priceNow": 2338.99,
   "priceWas": 7130.0,
   "pctOff": 67,
   "core": "71612",
   "inStock": true,
   "createdAt": "2026-01-27T22:35:43Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1VHKMdiUobCofk0RIRhDdgAYZaoPhDQnN",
      "b": "https://lh3.googleusercontent.com/d/1-3n-VNRv3Cl-NY5ftT-4ur_rw4K6BjTb",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1a3RqwyWnMk4u8QtD2aBSfi-h4AelIeSF",
      "b": "https://lh3.googleusercontent.com/d/1s4BrSE8hScliuLHcoUj8RsUAFJftLOPL",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1zDeMwL7uiPw4AzEV3ztMTf_8DuRXZg01",
      "b": "https://lh3.googleusercontent.com/d/1Cn7FWejtNnQXyWnhbURN3nkyH_dzr9Uz",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_2_8035e326-399a-48de-a35d-bdc2e89737fb.png?v=1771248306"
   },
   "carat": 4.0,
   "caratMax": 6.0
  },
  {
   "rank": 329,
   "id": "gid://shopify/Product/10202013434040",
   "title": "2.00-6.00 CT Round Cut Rubies and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71704lbr",
   "handle": "eternity-rings-71704lbr",
   "priceNow": 1812.99,
   "priceWas": 5505.0,
   "pctOff": 67,
   "core": "71704",
   "inStock": true,
   "createdAt": "2026-01-27T22:35:33Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1Jbp97R54lR_jvl69R3Otd9RXpRNpJUr1",
      "b": "https://lh3.googleusercontent.com/d/1WPHmGAhb1jwnWQokfhOWfUmJMHeeZ687",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1lOdPrhmAB5UhI4ZvnQ0tbdATf2D0gaA4",
      "b": "https://lh3.googleusercontent.com/d/1JaufbOVy4rK1F21ls4gbGqueVldnXMVI",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/14oczLPdsbKVUWa2YZ5U_03f1G1LU4ZUI",
      "b": "https://lh3.googleusercontent.com/d/1B356RBYEIaNKbtFNZPDrV6_GxLDi-znK",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3.png?v=1771248306"
   },
   "carat": 2.0,
   "caratMax": 6.0
  },
  {
   "rank": 330,
   "id": "gid://shopify/Product/10202013401272",
   "title": "2.50 CT Round Cut Rubies and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15375lbr",
   "handle": "eternity-rings-15375lbr",
   "priceNow": 2053.99,
   "priceWas": 6255.0,
   "pctOff": 67,
   "core": "15375",
   "inStock": true,
   "createdAt": "2026-01-27T22:35:23Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/140y3U9INXdQlqXpzwrS5crz4CurqiUki",
      "b": "https://lh3.googleusercontent.com/d/1j_rUixNKIJ0DELhVf6i25wbmPk_X4kH_",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/12BKxSYDCoBN10gBJkiCh3773vaXc7-7F",
      "b": "https://lh3.googleusercontent.com/d/1InPT1fnEFy6Nc4JjRZmpzAnU5HGFi-fK",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/13SWzEZQf6hlbE54o-uOEEdyD-iCW0NiU",
      "b": "https://lh3.googleusercontent.com/d/1W7oiIhMSi8TRB9kaGzYDM8JXp3MtiOks",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_2_cd1792ba-8c9f-4f1d-a562-a0d92e97020a.png?v=1771248306"
   },
   "carat": 2.5
  },
  {
   "rank": 331,
   "id": "gid://shopify/Product/10202013368504",
   "title": "2.00-6.00 CT Round Cut Rubies and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71691lbr",
   "handle": "eternity-rings-71691lbr",
   "priceNow": 1913.99,
   "priceWas": 5835.0,
   "pctOff": 67,
   "core": "71691",
   "inStock": true,
   "createdAt": "2026-01-27T22:35:12Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1OBmY1CACTSLb0NxSHfanHoGuUG-TvK_A",
      "b": "https://lh3.googleusercontent.com/d/1JKalh0IuiPlJsyPUGrbRoIFnataIAj9f",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1_XZ8lb37WAq-3KMPHQVIljAdGBtu8A1O",
      "b": "https://lh3.googleusercontent.com/d/1cT8pin5Uzarl8q70JOzAgj_UugkWAia-",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ktU-OQzLK144qJYAKV-GJysmkSkgBdrL",
      "b": "https://lh3.googleusercontent.com/d/1d71cpGgCjAemaLV8MPe_ezuPtnNEMFoV",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_67a06499-eb5a-407b-be2a-533126c1af46.png?v=1771248306"
   },
   "carat": 2.0,
   "caratMax": 6.0
  },
  {
   "rank": 332,
   "id": "gid://shopify/Product/10202013270200",
   "title": "2.20 CT Round Cut Rubies and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15381lbr",
   "handle": "eternity-rings-15381lbr",
   "priceNow": 2867.99,
   "priceWas": 8700.0,
   "pctOff": 67,
   "core": "15381",
   "inStock": true,
   "createdAt": "2026-01-27T22:35:01Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/11AOCmK2XAyVv5CS4OknTVRCwiK43uotN",
      "b": "https://lh3.googleusercontent.com/d/1MGcM2RaXJdN_fB--SH6cFOSPQoA6jaiS",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1VzvLCPSl3l2yTl3HF9T31ENLCLaZN5os",
      "b": "https://lh3.googleusercontent.com/d/14sMWIJidaggbC_t3Axpi0IIf3DTT5aU8",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1RPfzSn4msK2fbxAJUoCbiBkKbZ47dA9H",
      "b": "https://lh3.googleusercontent.com/d/1_NZmvc8vutUcf7U283m_xucHQTpvDO-0",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_2_8b79aab1-2af3-4d4c-8448-9412ca989c9c.png?v=1771248306"
   },
   "carat": 2.2
  },
  {
   "rank": 333,
   "id": "gid://shopify/Product/10202013171896",
   "title": "1.60 CT Princess Cut Rubies and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15369lbr",
   "handle": "eternity-rings-15369lbr",
   "priceNow": 1514.99,
   "priceWas": 4615.0,
   "pctOff": 67,
   "core": "15369",
   "inStock": true,
   "createdAt": "2026-01-27T22:34:52Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1fkJrD14GS5BvOydh-42xmVFAyyL83iFh",
      "b": "https://lh3.googleusercontent.com/d/1swxxxw0SlP87GfTP1CbdT_Q5IrFZJ6bc",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1hliBZTxixyA8kIqWXZLix64BqRRahOQC",
      "b": "https://lh3.googleusercontent.com/d/16EcqSF1bxtxw6RrOfKyX69iywEtrGzu9",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1sTVoiyoodacTdDPvqdarCuPztym4F4vX",
      "b": "https://lh3.googleusercontent.com/d/1g2nsKr7ECJEu92BinrHSGiXmfImHSDTy",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_b3ef31ed-5f74-407a-a23f-c5abcf024cbb.png?v=1771248307"
   },
   "carat": 1.6
  },
  {
   "rank": 334,
   "id": "gid://shopify/Product/10202013139128",
   "title": "1.50 CT Round Cut Rubies and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15379lbr",
   "handle": "eternity-rings-15379lbr",
   "priceNow": 1380.99,
   "priceWas": 4210.0,
   "pctOff": 67,
   "core": "15379",
   "inStock": true,
   "createdAt": "2026-01-27T22:34:46Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/18XT_v3wI2htyUTkin5DidEW9op5bLe1d",
      "b": "https://lh3.googleusercontent.com/d/13lIRfhMtE-nMQacEehdZMFhIRrujj3zo",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/10TenG4BQC03ZZEAGuq0q7pH7RnmJFnjU",
      "b": "https://lh3.googleusercontent.com/d/1BBbOXtVUReDWLscR4uvp1_WZuCYEF3FT",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1REZUn91Lzbveu9-k5ZMvo5TJewok5l2l",
      "b": "https://lh3.googleusercontent.com/d/190PLWm0kRD10n6fyCAyP-OCTlpIHVfWP",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_d49a70e9-7765-4156-a640-23feeb80beed.png?v=1771248309"
   },
   "carat": 1.5
  },
  {
   "rank": 335,
   "id": "gid://shopify/Product/10202013106360",
   "title": "1.50 CT Princess & Round Cut Rubies and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15947lbr",
   "handle": "eternity-rings-15947lbr",
   "priceNow": 1444.99,
   "priceWas": 4405.0,
   "pctOff": 67,
   "core": "15947",
   "inStock": true,
   "createdAt": "2026-01-27T22:34:39Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1yynZxOtY64RTjfcLyo3WIIW9SXtotDaN",
      "b": "https://lh3.googleusercontent.com/d/1mexvmzWpBg5KzR8I0VooY1Z-4fDk5V_E",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/10HRq2HWnFjyrx_-KolWv7OLLHoerb3sY",
      "b": "https://lh3.googleusercontent.com/d/1lz9E-MqluXEeHaYRcohSmsqtIz9YjmWl",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/10cukc7JldLVNVBwGMq6Tqr5YLJEjivg1",
      "b": "https://lh3.googleusercontent.com/d/1VjY5teaKHHchOkqOsTIYXux-pGi0MK9K",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_a0b7654b-60dd-448e-8d75-706fc13c8fd1.png?v=1771248309"
   },
   "carat": 1.5
  },
  {
   "rank": 336,
   "id": "gid://shopify/Product/10202013040824",
   "title": "5.20 CT Emerald Cut Rubies and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15955lbr",
   "handle": "eternity-rings-15955lbr",
   "priceNow": 2705.99,
   "priceWas": 8255.0,
   "pctOff": 67,
   "core": "15955",
   "inStock": true,
   "createdAt": "2026-01-27T22:34:30Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1HFCRg5dS54CcAI8nRUt9jfyT9V-WPZQg",
      "b": "https://lh3.googleusercontent.com/d/1Xshg97AadUeVYGfQTpRWxzoL34BQQkEg",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1EAizKjJxllFof9NqcSPSVxwqMdKeu1tt",
      "b": "https://lh3.googleusercontent.com/d/1VqUu6tczDZLvnL0ym_WCdf09eFCHqxPw",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1_scObWzoBFrUz4aiAsrY2o4zHBADaEyG",
      "b": "https://lh3.googleusercontent.com/d/1bu0xsvy0OID172BIv4HmJUAL5gGTfrCp",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_2_7b37a603-de17-4955-af5a-42d4c81f6091.png?v=1771248308"
   },
   "carat": 5.2
  },
  {
   "rank": 337,
   "id": "gid://shopify/Product/10202012975288",
   "title": "4.60 CT Princess Cut Rubies and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15953lbr",
   "handle": "eternity-rings-15953lbr",
   "priceNow": 2778.99,
   "priceWas": 8465.0,
   "pctOff": 67,
   "core": "15953",
   "inStock": true,
   "createdAt": "2026-01-27T22:34:23Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1RIQYoGSvWzabJhx6jtOr1bS5BxC_ksWb",
      "b": "https://lh3.googleusercontent.com/d/1iilSOsdNAyda3VkABHArWWvF0ZI7pPJ_",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/10wFQaAlEDMy_48rVLnJ_-7-_DeIihOep",
      "b": "https://lh3.googleusercontent.com/d/1sVVsW01d6QhLnf5bIwcUMbGU88H8-HHw",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1a0eB7oUXF1z7IU52768KB7on0LK0hfB1",
      "b": "https://lh3.googleusercontent.com/d/12hKPlE0nH-XGIXgSaPZ3_Xpj3UeFk2DH",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_2_7e2459e6-e1ec-47ec-92a0-cf4937f5d7f5.png?v=1771248309"
   },
   "carat": 4.6
  },
  {
   "rank": 338,
   "id": "gid://shopify/Product/10202012942520",
   "title": "1.70 CT Round Cut Rubies and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15951lbr",
   "handle": "eternity-rings-15951lbr",
   "priceNow": 1872.99,
   "priceWas": 5695.0,
   "pctOff": 67,
   "core": "15951",
   "inStock": true,
   "createdAt": "2026-01-27T22:34:17Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1e8GZnToV9m175HlJ9dLAlHAI0jX-0IXK",
      "b": "https://lh3.googleusercontent.com/d/1YvxQcHX0xYlxv9dNbNNf8v-ylijpLcu-",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1hEWP9zMxkUA4iDT4KGvf6HgzuJlqozJn",
      "b": "https://lh3.googleusercontent.com/d/1oTAUUjXHfvSHomclYhXWqp5yu2T2BmaA",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1JiVTsM-6iU6-qlmV7iKtjPRrCHzvoSxe",
      "b": "https://lh3.googleusercontent.com/d/1PLBKbLc9zjFI0Aa4jnPEvCd7GX3I3pBc",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_2_d3be86a9-9ffe-46ba-a918-bc10a7566ffd.png?v=1771248308"
   },
   "carat": 1.7
  },
  {
   "rank": 339,
   "id": "gid://shopify/Product/10202012909752",
   "title": "1.80 CT Round Cut Rubies and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15956lbr",
   "handle": "eternity-rings-15956lbr",
   "priceNow": 1985.99,
   "priceWas": 6045.0,
   "pctOff": 67,
   "core": "15956",
   "inStock": true,
   "createdAt": "2026-01-27T22:34:10Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1LR5bKSissicQHkCDvq4qATEPnKKOb-Yb",
      "b": "https://lh3.googleusercontent.com/d/1izQXvND-kCF3b1YEwd21RIi2Y0vTRp5v",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1OWAbn0SrCJVla04c4bZm77qlaTk8OQQE",
      "b": "https://lh3.googleusercontent.com/d/1MqM28IZElYMyqx_VevDRwwpRIONc5P_R",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1H-N5JtGqKHVgzOAgjPJFBZEPLFM2IL-R",
      "b": "https://lh3.googleusercontent.com/d/1RnoYKLYPf-qfzDZmgkr13Vwf3P4SrkJD",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_3ad0b12e-67ec-4527-8255-30802a9c142c.png?v=1771248309"
   },
   "carat": 1.8
  },
  {
   "rank": 340,
   "id": "gid://shopify/Product/10202012844216",
   "title": "1.50-5.00 CT Round Cut Rubies and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71689lbr",
   "handle": "eternity-rings-71689lbr",
   "priceNow": 1359.99,
   "priceWas": 4135.0,
   "pctOff": 67,
   "core": "71689",
   "inStock": true,
   "createdAt": "2026-01-27T22:34:02Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1bI-wqQ8OBaGb_KpO71vts7FSat2V-XPl",
      "b": "https://lh3.googleusercontent.com/d/1ialtB6_kZfrp29jrr9gyLadzRRHIFlMz",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1CUxz4xZyf_tvGmjA-jK6VqnS8EwQ33D2",
      "b": "https://lh3.googleusercontent.com/d/1G_7BG94YEvgtVev9gN1CC5X5LtyDttI4",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Jfs0kAM4o5Zj7QLaAiwIy7V0rdd1Tg_L",
      "b": "https://lh3.googleusercontent.com/d/1exNrY1wCf8Y5HXztmlCFd6VxvehFadA5",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_93f6f138-2774-442d-9cbe-286ce25199c8.png?v=1771248308"
   },
   "carat": 1.5,
   "caratMax": 5.0
  },
  {
   "rank": 341,
   "id": "gid://shopify/Product/10202012811448",
   "title": "1.50-5.00 CT Round Cut Rubies and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71688lbr",
   "handle": "eternity-rings-71688lbr",
   "priceNow": 1359.99,
   "priceWas": 4135.0,
   "pctOff": 67,
   "core": "71688",
   "inStock": true,
   "createdAt": "2026-01-27T22:33:55Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/13fQQ9e7xP-xGJl1ihSeJ289QBnzMFYCj",
      "b": "https://lh3.googleusercontent.com/d/1qKlIOrs9EAkSgEuMnhq30kPO297E5IFb",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1DelxLSdZEwB76Eck1JHRTWdwHMiapH9q",
      "b": "https://lh3.googleusercontent.com/d/1YOQFlHqrYSCwWqG6zCn9IiGWIzj50nNR",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1pZ29gUXUr5KdN0_8DhFLgGvHwc3Ve99t",
      "b": "https://lh3.googleusercontent.com/d/1BKiYj9E2jbq055Lmt2e6SyW5Lo3Nhts1",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_97c6a247-b8a2-45cf-8c30-7d74f62a92b3.png?v=1771248308"
   },
   "carat": 1.5,
   "caratMax": 5.0
  },
  {
   "rank": 342,
   "id": "gid://shopify/Product/10202012778680",
   "title": "1.50-5.00 CT Round Cut Rubies and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71690lbr",
   "handle": "eternity-rings-71690lbr",
   "priceNow": 1594.99,
   "priceWas": 4845.0,
   "pctOff": 67,
   "core": "71690",
   "inStock": true,
   "createdAt": "2026-01-27T22:33:49Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1mYRjX_77un3E-LRxtUpwvEsWepcTMv9G",
      "b": "https://lh3.googleusercontent.com/d/1HUcZueo8dpMrnsVxY6tr13DU_opR3O3-",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1Lk6XpyAFEPFP0ZVWgLqSLiKnah7AQRa-",
      "b": "https://lh3.googleusercontent.com/d/1OTtNFrldsGThPxCYaX3yfAMD-LpGuJi1",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/10HJG-eih88gmqWNbxRv6XnagWv3eSX11",
      "b": "https://lh3.googleusercontent.com/d/1KNpnxNoP-Rv-IAABv4I7ELxWQYPaPsC3",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_146c5791-5853-4f3a-9d83-420bec94900a.png?v=1771248308"
   },
   "carat": 1.5,
   "caratMax": 5.0
  },
  {
   "rank": 343,
   "id": "gid://shopify/Product/10202012745912",
   "title": "4.00-6.00 CT Round Cut Rubies and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71708lbr",
   "handle": "eternity-rings-71708lbr",
   "priceNow": 3772.99,
   "priceWas": 11470.0,
   "pctOff": 67,
   "core": "71708",
   "inStock": true,
   "createdAt": "2026-01-27T22:33:42Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1N1v5mYDxU_i5zzIGUEFd3PETKbgSqddW",
      "b": "https://lh3.googleusercontent.com/d/18cWic6CatdFH3_9dAcyIUF-ReEMAuHM_",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1fsJOq5L5UyNrq5W7XvPZE12pvTjnnh2t",
      "b": "https://lh3.googleusercontent.com/d/1x4fWNBKmRix_UDX2P7jVpW-HST0ngOt5",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1f-qBhcACozUbLGypVXTK2FDWGUiD4Le1",
      "b": "https://lh3.googleusercontent.com/d/1_nzr76UaA-LaG1v_cM9lRFr6d6gDyj9z",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_a3592cd0-d402-4521-80f1-e64f7b272a3a.png?v=1771248308"
   },
   "carat": 4.0,
   "caratMax": 6.0
  },
  {
   "rank": 344,
   "id": "gid://shopify/Product/10202012713144",
   "title": "2.00-6.00 CT Round Cut Rubies and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71707lbr",
   "handle": "eternity-rings-71707lbr",
   "priceNow": 1452.99,
   "priceWas": 4425.0,
   "pctOff": 67,
   "core": "71707",
   "inStock": true,
   "createdAt": "2026-01-27T22:33:35Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1K0DG1KyBOatp11Z09iXtUOYP75SluqKP",
      "b": "https://lh3.googleusercontent.com/d/1DPJMO5wKWqXGyYRGfltrZT9xGbj2hdrN",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1NKq9i-ZiDwd20MlRcE1ExS4zWvdpNhf7",
      "b": "https://lh3.googleusercontent.com/d/13ijsKfGaQnoUCoZrgjxuuU7TJh6FTpvd",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1tj2tLeRr-fBYuKuj1E1p9d4CsIJjV7yB",
      "b": "https://lh3.googleusercontent.com/d/13JFVJZ0jMyGzkmpJW3l5zjg0ZGNw95gi",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_193fec12-201a-4c40-a8b2-74b9f0b5190d.png?v=1771248308"
   },
   "carat": 2.0,
   "caratMax": 6.0
  },
  {
   "rank": 345,
   "id": "gid://shopify/Product/10202012680376",
   "title": "3.00-7.20 CT Round Cut Rubies and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71706lbr",
   "handle": "eternity-rings-71706lbr",
   "priceNow": 2407.99,
   "priceWas": 7325.0,
   "pctOff": 67,
   "core": "71706",
   "inStock": true,
   "createdAt": "2026-01-27T22:33:29Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1bQUqiFpdid03GdwRHqheG2FIGmITf3DM",
      "b": "https://lh3.googleusercontent.com/d/1jCa9-PC4h7_cEZeNAWccomZe9n1gBGH5",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1t4mzNTDr_IsjBGhbTGA8C2Y6372GV-2F",
      "b": "https://lh3.googleusercontent.com/d/1c-KCanBurAuJShHEEhR8-Kr0d5o-rpXq",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1SqZUMQFQws7GHBbXCS8fVLdWqaOVrTJh",
      "b": "https://lh3.googleusercontent.com/d/1lxbc0DhUBC6GEu8dYRFRv_EK7jj7W-jN",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_0ae8a1ed-34a2-4637-ad09-cc274bd39d8f.png?v=1771248308"
   },
   "carat": 3.0,
   "caratMax": 7.2
  },
  {
   "rank": 346,
   "id": "gid://shopify/Product/10202012647608",
   "title": "2.00-4.00 CT Princess Cut Rubies and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71705lbr",
   "handle": "eternity-rings-71705lbr",
   "priceNow": 1653.99,
   "priceWas": 5030.0,
   "pctOff": 67,
   "core": "71705",
   "inStock": true,
   "createdAt": "2026-01-27T22:33:24Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1pQvVo2k1RjZ_1Y--f09ogyiKkBebkcB5",
      "b": "https://lh3.googleusercontent.com/d/1N89bvy2kaeYyuTvVwwkKw_q-TALVvcUq",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/15vDe1ohz9XYE0b_jWINYy7Cd3gEvKbwj",
      "b": "https://lh3.googleusercontent.com/d/1SjWwYjW3_nNtZi0sf_BeyCgMixHXhbzB",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1XFRoieftKceGUYdEFFZI-IIXZL0uM-U5",
      "b": "https://lh3.googleusercontent.com/d/1LKj4RijZmVWz-ciYtajKRuJ_Ekv8ysm8",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_2_323ae301-25dd-4624-9032-1cc347201915.png?v=1771248309"
   },
   "carat": 2.0,
   "caratMax": 4.0
  },
  {
   "rank": 347,
   "id": "gid://shopify/Product/10202012549304",
   "title": "2.00-6.00 CT Round Cut Rubies and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71722lbr",
   "handle": "eternity-rings-71722lbr",
   "priceNow": 1463.99,
   "priceWas": 4465.0,
   "pctOff": 67,
   "core": "71722",
   "inStock": true,
   "createdAt": "2026-01-27T22:33:17Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1BqKmxmVsvQkwHwjhFsORuNBn3xcI_gaJ",
      "b": "https://lh3.googleusercontent.com/d/1x5vzhOgniEp1qtlrVGKZqWvEhRkYM3VA",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1GNrWfjlV0tNYbGClkLT_gbimVqe5sjcb",
      "b": "https://lh3.googleusercontent.com/d/1tQ1WWz7l95bnas6K9KkkpEuUUek2OkeX",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1b0Bf0SaWvqH26Gb-YEj7s3d3LWHVxCwL",
      "b": "https://lh3.googleusercontent.com/d/1rUEgHEAbXzwnB4Ej2lHmazm3Yg3wc5Se",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_78dc3dd6-9561-4b43-a940-292131b3391f.png?v=1771248308"
   },
   "carat": 2.0,
   "caratMax": 6.0
  },
  {
   "rank": 348,
   "id": "gid://shopify/Product/10202012516536",
   "title": "2.50 CT Emerald Cut Rubies and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71757lbr",
   "handle": "eternity-rings-71757lbr",
   "priceNow": 2119.99,
   "priceWas": 6435.0,
   "pctOff": 67,
   "core": "71757",
   "inStock": true,
   "createdAt": "2026-01-27T22:33:11Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1YxARV1Z6IcnD42nWssE1MBXeeDFRITNh",
      "b": "https://lh3.googleusercontent.com/d/16MIMdoqBGuEBSFSxJJx-j2QglSGPF20G",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1qawBkw8rleHIiK0aD9vY85gGBq3cq18j",
      "b": "https://lh3.googleusercontent.com/d/1rjdk-ugk-Ra0krNB5sXpNX8ZHkaSURqh",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ue43VndeFDURBNF9tlK_qce1CWjS9Zsv",
      "b": "https://lh3.googleusercontent.com/d/1hOu4S7U-cDBbq3GvZeR7XWKQjxthcAyI",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_8_9cfc6592-b68d-474b-be79-f73659ee5576.png?v=1771248310"
   },
   "carat": 2.5
  },
  {
   "rank": 349,
   "id": "gid://shopify/Product/10202012483768",
   "title": "1.50-5.00 CT Round Cut Rubies and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71732lbr",
   "handle": "eternity-rings-71732lbr",
   "priceNow": 1359.99,
   "priceWas": 4135.0,
   "pctOff": 67,
   "core": "71732",
   "inStock": true,
   "createdAt": "2026-01-27T22:33:06Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1__SI_r_pqzSyn2T074JbbRCVcU_kgdNv",
      "b": "https://lh3.googleusercontent.com/d/1JP-nPp-FByLjmtCGw_wfEsTYribKK0j3",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1qz8Ur4I4Ezh0IDYc1py6jcaAZVi5XuiT",
      "b": "https://lh3.googleusercontent.com/d/1GJX_TnxTLVW5VAE-HNnN2CoOllllUNx6",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1m_jvSRPMRmiSCyji-cS-rUxuvW-ah_Ks",
      "b": "https://lh3.googleusercontent.com/d/1AthgtrkskMe1luvjh74_N4kZ7WgCN0CA",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_ed62f0f3-fb17-4e67-866a-c72f72e6857a.png?v=1771248366"
   },
   "carat": 1.5,
   "caratMax": 5.0
  },
  {
   "rank": 350,
   "id": "gid://shopify/Product/10202012418232",
   "title": "2.50-6.00 CT Round Cut Rubies and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71731lbr",
   "handle": "eternity-rings-71731lbr",
   "priceNow": 1905.99,
   "priceWas": 5795.0,
   "pctOff": 67,
   "core": "71731",
   "inStock": true,
   "createdAt": "2026-01-27T22:32:59Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1RdRVrvP8xX5OvMJHAKhSDzhKbf7lqoL1",
      "b": "https://lh3.googleusercontent.com/d/1t0vkZWg21XRRHSpas0JmRFO-ilMWnoH5",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/14Zq98jHOF_jRyLh0DB_8bc1tBkBvsLtx",
      "b": "https://lh3.googleusercontent.com/d/1JWr26chJCMhdsPjIRaE6YQ5VfHUQBfTV",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Os2ckkHi5R3Nc3tSejwgydEEztSMrjOe",
      "b": "https://lh3.googleusercontent.com/d/1CHFV5A1RdoXBUpzaya7IwOKB9TrAZAbL",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_8203a809-c8b1-4b7c-89be-4e87efb36f35.png?v=1771248366"
   },
   "carat": 2.5,
   "caratMax": 6.0
  },
  {
   "rank": 351,
   "id": "gid://shopify/Product/10202012385464",
   "title": "0.50-2.00 CT Round Cut Rubies and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71730lbr",
   "handle": "eternity-rings-71730lbr",
   "priceNow": 1045.99,
   "priceWas": 3455.0,
   "pctOff": 70,
   "core": "71730",
   "inStock": true,
   "createdAt": "2026-01-27T22:32:53Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1NEclVh_byFVu1-CdlMgDVxgNt0Mzs0rk",
      "b": "https://lh3.googleusercontent.com/d/1ToUBvs5qggoh_YPku9SkdPmJYEgTNem3",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1TJQO-B0LCHrulkrpKjk0Y41X4U7A_TbF",
      "b": "https://lh3.googleusercontent.com/d/1sMZrORvdCT1kcm-GnRSAUMuZuY13OWLV",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1bXszf4wyCRyoqaZfhldBzrmQJTRyjMZg",
      "b": "https://lh3.googleusercontent.com/d/1savTjO-HpAslVmRMBRwDfzwBgrGVqrZM",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_342fc175-79bc-4b67-b565-6e72140e6e65.png?v=1771248367"
   },
   "carat": 0.5,
   "caratMax": 2.0
  },
  {
   "rank": 352,
   "id": "gid://shopify/Product/10202012352696",
   "title": "4.00-7.00 CT Emerald Cut Rubies and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71716lbr",
   "handle": "eternity-rings-71716lbr",
   "priceNow": 2666.99,
   "priceWas": 8115.0,
   "pctOff": 67,
   "core": "71716",
   "inStock": true,
   "createdAt": "2026-01-27T22:32:47Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1ZWsSPca4XeEzzdR4MfpOVMLNy76e5CPw",
      "b": "https://lh3.googleusercontent.com/d/1w1Lhs25m3_V3NLhmsgQGFf5R6H_eQjQU",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1YS84ELDLfnA7QbNNXe9A9WfHIUwNi7n6",
      "b": "https://lh3.googleusercontent.com/d/19VsMo1jbTVt_C5ZfOwNljX09zPUPooX_",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1m4ziMurLEVzagf2QgBob9UZShqX-UWvt",
      "b": "https://lh3.googleusercontent.com/d/1BBCBUdUjdw1ezeN83Nkc50B36Bfr5V8x",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_0230b902-e46f-4e45-bc70-35b594e4af1f.png?v=1771248367"
   },
   "carat": 4.0,
   "caratMax": 7.0
  },
  {
   "rank": 353,
   "id": "gid://shopify/Product/10202012287160",
   "title": "7.20 CT Round Cut Rubies and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15958lbr",
   "handle": "eternity-rings-15958lbr",
   "priceNow": 3933.99,
   "priceWas": 11975.0,
   "pctOff": 67,
   "core": "15958",
   "inStock": true,
   "createdAt": "2026-01-27T22:32:39Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/10tla2_o9XH24wTO6PsjIcdiodvnREIYn",
      "b": "https://lh3.googleusercontent.com/d/1RZd-K66Qiz-Nzpp3JKZsnaEwUkUUTIfe",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1D7jgS1WdsD661ocW-MKUYkdcvJVP_kpc",
      "b": "https://lh3.googleusercontent.com/d/1uiq-7z7aGmuaOTTi_cf052NhmIvA-FWR",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1z4OSHuhXsZtProGnKysETL4884D6blev",
      "b": "https://lh3.googleusercontent.com/d/13Kea_LwTycWfAyyXUVOvt9TBEF7etBYO",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_63155802-5d6a-447c-876e-94eb352b69d7.png?v=1771248367"
   },
   "carat": 7.2
  },
  {
   "rank": 354,
   "id": "gid://shopify/Product/10202012221624",
   "title": "5.20 CT Emerald Cut Rubies and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-16206lbr",
   "handle": "eternity-rings-16206lbr",
   "priceNow": 2705.99,
   "priceWas": 8255.0,
   "pctOff": 67,
   "core": "16206",
   "inStock": true,
   "createdAt": "2026-01-27T22:32:31Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1Flnm_CiP2a0TUMvlECFPar7ZCSSbPcYE",
      "b": "https://lh3.googleusercontent.com/d/1Le-IMLevIyV0JitdheBgQNfUEx5qPXtN",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/19_ZPKRbAYN5Oo0fmnvHrT1uoXcSF20sx",
      "b": "https://lh3.googleusercontent.com/d/1aGmg-kD2Xq3r2_S5EgAljAaNT55BltEP",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1rtHbI7XHBVatQKGgQbR61ZQH0KMvdIGL",
      "b": "https://lh3.googleusercontent.com/d/1p1bINDQfPiOYE86WMs67navUeEUewoNV",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_4ddcf4ce-3dbb-4599-9dd4-40c4b8e10224.png?v=1771248367"
   },
   "carat": 5.2
  },
  {
   "rank": 355,
   "id": "gid://shopify/Product/10202012090552",
   "title": "4.10 CT Round Cut Rubies and Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71640lbr",
   "handle": "eternity-rings-71640lbr",
   "priceNow": 2128.99,
   "priceWas": 6485.0,
   "pctOff": 67,
   "core": "71640",
   "inStock": true,
   "createdAt": "2026-01-27T22:32:22Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1OAUT_Zk-9xmK0K0CTsxZHbeJVE4yULs6",
      "b": "https://lh3.googleusercontent.com/d/1wLHdl4bD_de0Lo87PpnnPo-2GBtmnsiO",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1i7QONHC3NJISpimt-WNwBdM2BIvqHXBp",
      "b": "https://lh3.googleusercontent.com/d/1jGHNb4-81WTxI9S9JQGhg8MvUa_OJxXE",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1rRVeCM_50r_Dbrh96KP2VFh2iQF7RCPj",
      "b": "https://lh3.googleusercontent.com/d/1GqWhxJkmFr8RSmxV-eh8HSUhbSCIoXxA",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_8e7d5043-24c1-42fc-bb68-c921850547be.png?v=1771248367"
   },
   "carat": 4.1
  },
  {
   "rank": 356,
   "id": "gid://shopify/Product/10158949302456",
   "title": "1.40 CT Round Cut Lab Grown Diamonds - Mens Wedding Bands",
   "url": "/products/mens-wedding-bands-15660lb",
   "handle": "mens-wedding-bands-15660lb",
   "priceNow": 2434.99,
   "priceWas": 7550.0,
   "pctOff": 68,
   "core": "15660",
   "inStock": true,
   "createdAt": "2025-12-04T23:28:34Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/140-ct-round-cut-diamonds-mens-wedding-band-986943.jpg?v=1673900377",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/140-ct-round-cut-diamonds-mens-wedding-band-986943.jpg?v=1673900377",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/140-ct-round-cut-diamonds-mens-wedding-band-583278.jpg?v=1669766390",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/140-ct-round-cut-diamonds-mens-wedding-band-670334.jpg?v=1669766390"
    }
   },
   "carat": 1.4
  },
  {
   "rank": 357,
   "id": "gid://shopify/Product/10155926061240",
   "title": "10.00 CT Round Cut Diamonds - Diamond Necklace",
   "url": "/products/10-00-ct-round-cut-diamonds-diamond-necklace-1",
   "handle": "10-00-ct-round-cut-diamonds-diamond-necklace-1",
   "priceNow": 5738.99,
   "priceWas": 15775.0,
   "pctOff": 64,
   "core": "30025",
   "inStock": true,
   "createdAt": "2025-11-30T17:02:00Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/WhatsApp_Image_2025-12-01_at_08.41.56_53661b3f.jpg?v=1768436769",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/WhatsApp_Image_2025-12-01_at_08.41.56_53661b3f.jpg?v=1768436769",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/WhatsApp_Image_2025-12-01_at_08.41.56_e1c8d1d4.jpg?v=1768436770"
    }
   },
   "carat": 10.0
  },
  {
   "rank": 358,
   "id": "gid://shopify/Product/10155925438648",
   "title": "5.00 CT Round Cut Diamonds - Diamond Necklace",
   "url": "/products/5-00-ct-round-cut-diamonds-diamond-necklace",
   "handle": "5-00-ct-round-cut-diamonds-diamond-necklace",
   "priceNow": 4831.99,
   "priceWas": 12275.0,
   "pctOff": 61,
   "core": "30024",
   "inStock": true,
   "createdAt": "2025-11-30T16:57:28Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/WhatsApp_Image_2025-12-01_at_08.41.56_53661b3f.jpg?v=1768436769",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/WhatsApp_Image_2025-12-01_at_08.41.56_53661b3f.jpg?v=1768436769",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/WhatsApp_Image_2025-12-01_at_08.41.56_e1c8d1d4.jpg?v=1768436770"
    }
   },
   "carat": 5.0
  },
  {
   "rank": 359,
   "id": "gid://shopify/Product/10155899060408",
   "title": "1.60 CT Round Cut Lab Grown Diamonds - Hoop & Drop Earrings",
   "url": "/products/hoop-and-drop-and-earrings-30018lb",
   "handle": "hoop-and-drop-and-earrings-30018lb",
   "priceNow": 1575.99,
   "priceWas": 4890.0,
   "pctOff": 68,
   "core": "30018",
   "inStock": true,
   "createdAt": "2025-11-30T16:05:02Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_5_ab15af49-33d5-4971-bc94-f87dd019a2e0.png?v=1768436769",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_5_ab15af49-33d5-4971-bc94-f87dd019a2e0.png?v=1768436769",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_27123d33-c5e3-4ee8-88da-30317fbfaccd.png?v=1768436769",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_4_72d59251-f634-48a2-ad34-f507174b8528.png?v=1768436769"
    }
   },
   "carat": 1.6
  },
  {
   "rank": 360,
   "id": "gid://shopify/Product/10155898863800",
   "title": "1.25 CT Round Cut Lab Grown Diamonds - Hoop & Drop Earrings",
   "url": "/products/hoop-and-drop-and-earrings-30017lb",
   "handle": "hoop-and-drop-and-earrings-30017lb",
   "priceNow": 1484.99,
   "priceWas": 4600.0,
   "pctOff": 68,
   "core": "30017",
   "inStock": true,
   "createdAt": "2025-11-30T16:04:59Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_5_ab01df3c-7444-404c-9ca6-21a38725b818.png?v=1768436769",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_5_ab01df3c-7444-404c-9ca6-21a38725b818.png?v=1768436769",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_53b01df6-be9e-4828-9424-3c5a7aea3a57.png?v=1768436769",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_4_63f50a0c-6c57-4e54-83bf-5bbdfbe4f2d3.png?v=1768436769"
    }
   },
   "carat": 1.25
  },
  {
   "rank": 361,
   "id": "gid://shopify/Product/10155898372280",
   "title": "3.25 CT Round Cut Lab Grown Diamonds - Hoop & Drop Earrings",
   "url": "/products/hoop-and-drop-and-earrings-30013lb",
   "handle": "hoop-and-drop-and-earrings-30013lb",
   "priceNow": 2347.99,
   "priceWas": 7280.0,
   "pctOff": 68,
   "core": "30013",
   "inStock": true,
   "createdAt": "2025-11-30T16:04:46Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_5_8633527c-215f-4da1-a3ac-581d7046f594.png?v=1768436769",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_5_8633527c-215f-4da1-a3ac-581d7046f594.png?v=1768436769",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_a0778b6c-b408-46ec-a840-b055c1788a4b.png?v=1768436769",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_4_7c54612a-37df-4288-aab7-6c93bb4ae113.png?v=1768436769"
    }
   },
   "carat": 3.25
  },
  {
   "rank": 362,
   "id": "gid://shopify/Product/10155898110136",
   "title": "0.20 CT Round Cut Lab Grown Diamonds - Hoop & Drop Earrings",
   "url": "/products/hoop-and-drop-and-earrings-30010lb",
   "handle": "hoop-and-drop-and-earrings-30010lb",
   "priceNow": 870.99,
   "priceWas": 2960.0,
   "pctOff": 71,
   "core": "30010",
   "inStock": true,
   "createdAt": "2025-11-30T16:04:39Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_5_4198fb41-6600-4e39-bcf4-ff22d78b293d.png?v=1768436769",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_5_4198fb41-6600-4e39-bcf4-ff22d78b293d.png?v=1768436769",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_3_8a4c8f20-aa1d-40d8-942c-1004a405aa6c.png?v=1768436770",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_4_1d4a0a3f-0436-4f97-989e-18d865253c8a.png?v=1768436770"
    }
   },
   "carat": 0.2
  },
  {
   "rank": 363,
   "id": "gid://shopify/Product/10153282502840",
   "title": "6.00 CT Round Cut Lab Grown Diamonds in 14KT White Gold  Stud Earrings",
   "url": "/products/6-00-ct-round-cut-lab-grown-diamonds-in-14kt-white-gold-stud-earrings",
   "handle": "6-00-ct-round-cut-lab-grown-diamonds-in-14kt-white-gold-stud-earrings",
   "priceNow": 2250.99,
   "priceWas": 7675.0,
   "pctOff": 71,
   "core": "600",
   "inStock": true,
   "createdAt": "2025-11-28T00:04:09Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-round-cut-lab-grown-diamonds-stud-earrings-425997.jpg?v=1698786141"
   },
   "carat": 6.0
  },
  {
   "rank": 364,
   "id": "gid://shopify/Product/10153282207928",
   "title": "5.00 CT Round Cut Lab Grown Diamonds in 14KT Yellow Gold Stud Earrings",
   "url": "/products/5-00-ct-round-cut-lab-grown-diamonds-in-14kt-yellow-gold-stud-earrings",
   "handle": "5-00-ct-round-cut-lab-grown-diamonds-in-14kt-yellow-gold-stud-earrings",
   "priceNow": 1901.99,
   "priceWas": 7015.0,
   "pctOff": 73,
   "core": "500",
   "inStock": true,
   "createdAt": "2025-11-27T23:59:11Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-round-cut-lab-grown-diamonds-stud-earrings-900416.jpg?v=1763699330"
   },
   "carat": 5.0
  },
  {
   "rank": 365,
   "id": "gid://shopify/Product/10153275392184",
   "title": "3.00 CT Round Cut Lab Grown Diamonds in 14KT Yellow Gold Stud Earrings",
   "url": "/products/3-00-ct-round-cut-lab-grown-diamonds-in-14kt-yellow-gold-stud-earrings",
   "handle": "3-00-ct-round-cut-lab-grown-diamonds-in-14kt-yellow-gold-stud-earrings",
   "priceNow": 1161.99,
   "priceWas": 7015.0,
   "pctOff": 83,
   "core": "300",
   "inStock": true,
   "createdAt": "2025-11-27T23:13:42Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-round-cut-lab-grown-diamonds-stud-earrings-900416.jpg?v=1763699330"
   },
   "carat": 3.0
  },
  {
   "rank": 366,
   "id": "gid://shopify/Product/10151640858808",
   "title": "1.45-4.45 CT Round Cut Fancy Blue Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110348bl",
   "handle": "bridal-sets-110348bl",
   "priceNow": 4760.99,
   "priceWas": 14520.0,
   "pctOff": 67,
   "core": "110348",
   "inStock": true,
   "createdAt": "2025-11-26T04:28:48Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS27_9016b434-f65c-443c-8d59-685240f93a3a.png?v=1781811614",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS27_9016b434-f65c-443c-8d59-685240f93a3a.png?v=1781811614",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS29_fd77ff1a-94e2-4cea-8238-d0d1ce6d7ce0.png?v=1781811614",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS28_55f1a04d-b253-4a59-b6dc-d248fcfe7d4d.png?v=1781811614"
    }
   },
   "carat": 1.45,
   "caratMax": 4.45,
   "fancyColor": "blue"
  },
  {
   "rank": 367,
   "id": "gid://shopify/Product/10151640826040",
   "title": "1.75-4.75 CT Round Cut Fancy Blue Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110346bl",
   "handle": "bridal-sets-110346bl",
   "priceNow": 2476.99,
   "priceWas": 7420.0,
   "pctOff": 67,
   "core": "110346",
   "inStock": true,
   "createdAt": "2025-11-26T04:28:47Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS27_f3efa6be-5d31-4d06-a0db-75a0163aa2ef.png?v=1781811614",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS27_f3efa6be-5d31-4d06-a0db-75a0163aa2ef.png?v=1781811614",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS29_ab7939d0-e248-4d39-bf48-564ecc269f53.png?v=1781811614",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS28_03f2d884-52fc-4e74-88b2-e4e6d510b70d.png?v=1781811614"
    }
   },
   "carat": 1.75,
   "caratMax": 4.75,
   "fancyColor": "blue"
  },
  {
   "rank": 368,
   "id": "gid://shopify/Product/10151640760504",
   "title": "1.55-4.55 CT Round Cut Fancy Blue Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110344bl",
   "handle": "bridal-sets-110344bl",
   "priceNow": 3630.99,
   "priceWas": 10920.0,
   "pctOff": 67,
   "core": "110344",
   "inStock": true,
   "createdAt": "2025-11-26T04:28:22Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS27_886091cb-8e0c-45db-93af-0351f7b324b4.png?v=1781811614",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS27_886091cb-8e0c-45db-93af-0351f7b324b4.png?v=1781811614",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS29_66f762a1-041a-40b6-bd6d-a90c3bc216e6.png?v=1781811615",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS28_c35eef8b-1375-4ad6-be87-917b452ba101.png?v=1781811614"
    }
   },
   "carat": 1.55,
   "caratMax": 4.55,
   "fancyColor": "blue"
  },
  {
   "rank": 369,
   "id": "gid://shopify/Product/10151640727736",
   "title": "1.75-4.75 CT Oval & Round Cut Fancy Blue Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110342bl",
   "handle": "bridal-sets-110342bl",
   "priceNow": 2019.99,
   "priceWas": 6060.0,
   "pctOff": 67,
   "core": "110342",
   "inStock": true,
   "createdAt": "2025-11-26T04:28:22Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS27_7f846331-e4bf-415d-bcf1-0a13cf144b80.png?v=1781811615",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS27_7f846331-e4bf-415d-bcf1-0a13cf144b80.png?v=1781811615",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS29_7ac6ac8d-b48a-42d3-a149-bee1e4b224cb.png?v=1781811614",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS28_bc07e723-9877-4178-8876-8be0fc94cd05.png?v=1781811614"
    }
   },
   "carat": 1.75,
   "caratMax": 4.75,
   "fancyColor": "blue"
  },
  {
   "rank": 370,
   "id": "gid://shopify/Product/10151640694968",
   "title": "1.85-4.85 CT Princess & Round Cut Fancy Blue Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110340bl",
   "handle": "bridal-sets-110340bl",
   "priceNow": 2422.99,
   "priceWas": 7250.0,
   "pctOff": 67,
   "core": "110340",
   "inStock": true,
   "createdAt": "2025-11-26T04:28:20Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS27_9791ccbf-1f3b-4019-b29a-1505ad33b253.png?v=1781811618",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS27_9791ccbf-1f3b-4019-b29a-1505ad33b253.png?v=1781811618",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS29_b5d82efa-4b40-45de-8bc2-b0ec46d1c9dd.png?v=1781811615",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS28_6d17e4b8-a919-4717-a8d7-ad1baaa2c971.png?v=1781811615"
    }
   },
   "carat": 1.85,
   "caratMax": 4.85,
   "fancyColor": "blue"
  },
  {
   "rank": 371,
   "id": "gid://shopify/Product/10151608254648",
   "title": "2.10-5.10 CT Princess & Round Cut Fancy Pink Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110350pk",
   "handle": "bridal-sets-110350pk",
   "priceNow": 2453.99,
   "priceWas": 7610.0,
   "pctOff": 68,
   "core": "110350",
   "inStock": true,
   "createdAt": "2025-11-26T02:08:34Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS27_bc818793-c889-4e44-a82e-1f15985bd1a8.png?v=1781806028",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS27_bc818793-c889-4e44-a82e-1f15985bd1a8.png?v=1781806028",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS29_1efd3d2b-b531-47d2-967c-f9d53657f4a5.png?v=1781806028",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS28_57c891ca-94b2-48eb-8b88-2fbf6f80c8d9.png?v=1781806028"
    }
   },
   "carat": 2.1,
   "caratMax": 5.1,
   "fancyColor": "pink"
  },
  {
   "rank": 372,
   "id": "gid://shopify/Product/10151608221880",
   "title": "1.45-4.45 CT Round Cut Fancy Pink Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110348pk",
   "handle": "bridal-sets-110348pk",
   "priceNow": 4699.99,
   "priceWas": 14570.0,
   "pctOff": 68,
   "core": "110348",
   "inStock": true,
   "createdAt": "2025-11-26T02:08:32Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS27_4acbd75f-8d5c-4031-b9c8-0a8f508ff81b.png?v=1781806028",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS27_4acbd75f-8d5c-4031-b9c8-0a8f508ff81b.png?v=1781806028",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS29_8ea1822e-bf4c-4313-9619-56cf3edfdd28.png?v=1781806027",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS28_4b7e656e-6191-4089-9a33-151f4c556661.png?v=1781806028"
    }
   },
   "carat": 1.45,
   "caratMax": 4.45,
   "fancyColor": "pink"
  },
  {
   "rank": 373,
   "id": "gid://shopify/Product/10151608189112",
   "title": "1.75-4.75 CT Round Cut Fancy Pink Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110346pk",
   "handle": "bridal-sets-110346pk",
   "priceNow": 2411.99,
   "priceWas": 7480.0,
   "pctOff": 68,
   "core": "110346",
   "inStock": true,
   "createdAt": "2025-11-26T02:08:30Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS27_6e94ad54-36aa-4672-a47c-c36c93654d41.png?v=1781806028",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS27_6e94ad54-36aa-4672-a47c-c36c93654d41.png?v=1781806028",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS29_6acb3c6c-9980-443f-8b88-546e7b9c177b.png?v=1781806027",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS28_aae505b9-498e-4661-8a4c-e9a6b4a51f53.png?v=1781806028"
    }
   },
   "carat": 1.75,
   "caratMax": 4.75,
   "fancyColor": "pink"
  },
  {
   "rank": 374,
   "id": "gid://shopify/Product/10151608123576",
   "title": "1.55-4.55 CT Round Cut Fancy Pink Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110344pk",
   "handle": "bridal-sets-110344pk",
   "priceNow": 3548.99,
   "priceWas": 11000.0,
   "pctOff": 68,
   "core": "110344",
   "inStock": true,
   "createdAt": "2025-11-26T02:08:08Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS27_db23486a-5510-47fe-bac3-f63b6ef38437.png?v=1781801216",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS27_db23486a-5510-47fe-bac3-f63b6ef38437.png?v=1781801216",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS29_116221ca-f2ec-4ed2-9537-a22ef34b2f68.png?v=1781801217",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS28_fc13ea87-29e7-4bb4-8609-d3f4ca36525d.png?v=1781801216"
    }
   },
   "carat": 1.55,
   "caratMax": 4.55,
   "fancyColor": "pink"
  },
  {
   "rank": 375,
   "id": "gid://shopify/Product/10151608058040",
   "title": "1.75-4.75 CT Oval & Round Cut Fancy Pink Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110342pk",
   "handle": "bridal-sets-110342pk",
   "priceNow": 1991.99,
   "priceWas": 6180.0,
   "pctOff": 68,
   "core": "110342",
   "inStock": true,
   "createdAt": "2025-11-26T02:08:05Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS27_cab61982-3ced-4f89-9534-ff450b0f14da.png?v=1781806027",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS27_cab61982-3ced-4f89-9534-ff450b0f14da.png?v=1781806027",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS29_c4861327-1089-41c7-9496-74a7fc3b37b6.png?v=1781806028",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS28_88cec285-a83e-40c6-a1b3-859081a8e012.png?v=1781806028"
    }
   },
   "carat": 1.75,
   "caratMax": 4.75,
   "fancyColor": "pink"
  },
  {
   "rank": 376,
   "id": "gid://shopify/Product/10151608025272",
   "title": "1.85-4.85 CT Princess & Round Cut Fancy Pink Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110340pk",
   "handle": "bridal-sets-110340pk",
   "priceNow": 2357.99,
   "priceWas": 7310.0,
   "pctOff": 68,
   "core": "110340",
   "inStock": true,
   "createdAt": "2025-11-26T02:08:04Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS27_b70c45da-6527-4473-84aa-fcb5e502359f.png?v=1781806027",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS27_b70c45da-6527-4473-84aa-fcb5e502359f.png?v=1781806027",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS29_f6d48e82-5411-4d98-9e26-7833b90f482f.png?v=1781806027",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS28_c4c0e619-3576-48da-b50c-88209db090df.png?v=1781806027"
    }
   },
   "carat": 1.85,
   "caratMax": 4.85,
   "fancyColor": "pink"
  },
  {
   "rank": 377,
   "id": "gid://shopify/Product/10151602847928",
   "title": "2.10-5.10 CT Princess & Round Cut Fancy Yellow Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110350yl",
   "handle": "bridal-sets-110350yl",
   "priceNow": 2443.99,
   "priceWas": 8010.0,
   "pctOff": 69,
   "core": "110350",
   "inStock": true,
   "createdAt": "2025-11-26T01:52:13Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS29_6b58a25e-265d-4e84-8067-fcaa7cb3729a.png?v=1781802038",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS29_6b58a25e-265d-4e84-8067-fcaa7cb3729a.png?v=1781802038",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS27_540090ae-76ab-4db3-ad42-4fb454aec7c3.png?v=1781802038",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS28_069d36b4-c1b9-405c-9d6b-9497535ed7d9.png?v=1781802038"
    }
   },
   "carat": 2.1,
   "caratMax": 5.1,
   "fancyColor": "yellow"
  },
  {
   "rank": 378,
   "id": "gid://shopify/Product/10151602815160",
   "title": "1.45-4.45 CT Round Cut Fancy Yellow Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110348yl",
   "handle": "bridal-sets-110348yl",
   "priceNow": 4760.99,
   "priceWas": 15000.0,
   "pctOff": 68,
   "core": "110348",
   "inStock": true,
   "createdAt": "2025-11-26T01:52:13Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS29_c3f37c67-de9d-43e0-bdc6-977488f81dac.png?v=1781802055",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS29_c3f37c67-de9d-43e0-bdc6-977488f81dac.png?v=1781802055",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS27_48b6f9a8-f817-475b-ac79-4c80f6e75f9b.png?v=1781802055",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS28_8408780d-40a5-4ed6-9b00-7e03b983c766.png?v=1781802055"
    }
   },
   "carat": 1.45,
   "caratMax": 4.45,
   "fancyColor": "yellow"
  },
  {
   "rank": 379,
   "id": "gid://shopify/Product/10151602749624",
   "title": "1.75-4.75 CT Round Cut Fancy Yellow Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110346yl",
   "handle": "bridal-sets-110346yl",
   "priceNow": 2476.99,
   "priceWas": 7940.0,
   "pctOff": 69,
   "core": "110346",
   "inStock": true,
   "createdAt": "2025-11-26T01:52:13Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS29_f5d9db06-a98e-4218-8041-30f5bb5b7f06.png?v=1781802073",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS29_f5d9db06-a98e-4218-8041-30f5bb5b7f06.png?v=1781802073",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS27_20f953de-4d53-4bca-aea1-1056ac2ff27a.png?v=1781802073",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS28_a900a38a-edfc-4a05-8670-fc87a3d3370f.png?v=1781802073"
    }
   },
   "carat": 1.75,
   "caratMax": 4.75,
   "fancyColor": "yellow"
  },
  {
   "rank": 380,
   "id": "gid://shopify/Product/10151602618552",
   "title": "1.55-4.55 CT Round Cut Fancy Yellow Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110344yl",
   "handle": "bridal-sets-110344yl",
   "priceNow": 3630.99,
   "priceWas": 10890.0,
   "pctOff": 67,
   "core": "110344",
   "inStock": true,
   "createdAt": "2025-11-26T01:51:45Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS29_a23bc85a-0c4b-45ee-a83e-206668028a4c.png?v=1781806027",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS29_a23bc85a-0c4b-45ee-a83e-206668028a4c.png?v=1781806027",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS27_a6967feb-462d-4f39-af55-55e6415d091b.png?v=1781806027",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS28_3c26dd5c-5f17-4b04-a1a2-81883054b8e6.png?v=1781806028"
    }
   },
   "carat": 1.55,
   "caratMax": 4.55,
   "fancyColor": "yellow"
  },
  {
   "rank": 381,
   "id": "gid://shopify/Product/10151602585784",
   "title": "1.75-4.75 CT Oval & Round Cut Fancy Yellow Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110342yl",
   "handle": "bridal-sets-110342yl",
   "priceNow": 2019.99,
   "priceWas": 6000.0,
   "pctOff": 66,
   "core": "110342",
   "inStock": true,
   "createdAt": "2025-11-26T01:51:45Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS29_fe125a21-502a-473d-97c3-08147ef194f7.png?v=1781806027",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS29_fe125a21-502a-473d-97c3-08147ef194f7.png?v=1781806027",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS27_75014d02-ef34-40c0-9e5d-707c1c287ebc.png?v=1781806027",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS28_68caf68a-29a5-4f1b-8850-e6dd978a3f1f.png?v=1781806028"
    }
   },
   "carat": 1.75,
   "caratMax": 4.75,
   "fancyColor": "yellow"
  },
  {
   "rank": 382,
   "id": "gid://shopify/Product/10151602520248",
   "title": "1.85-4.85 CT Princess & Round Cut Fancy Yellow Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110340yl",
   "handle": "bridal-sets-110340yl",
   "priceNow": 2422.99,
   "priceWas": 7770.0,
   "pctOff": 69,
   "core": "110340",
   "inStock": true,
   "createdAt": "2025-11-26T01:51:45Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS29_f562df33-f734-49ba-b99e-21850b9fd6cf.png?v=1781806030",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS29_f562df33-f734-49ba-b99e-21850b9fd6cf.png?v=1781806030",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS27_6566e609-7a4f-42ea-b264-871dfbad7d9b.png?v=1781806030",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS28_d91211f7-d560-4c04-b378-b6042de43ce7.png?v=1781806031"
    }
   },
   "carat": 1.85,
   "caratMax": 4.85,
   "fancyColor": "yellow"
  },
  {
   "rank": 383,
   "id": "gid://shopify/Product/10151560315064",
   "title": "1.70-4.70 CT Princess & Round Cut Fancy Yellow Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71608yl",
   "handle": "engagement-rings-71608yl",
   "priceNow": 2130.99,
   "priceWas": 6495.0,
   "pctOff": 67,
   "core": "71608",
   "inStock": true,
   "createdAt": "2025-11-26T00:10:38Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/images7_7eaea7c0-5756-462c-882a-d31088b0b279.png?v=1768437908",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/images7_7eaea7c0-5756-462c-882a-d31088b0b279.png?v=1768437908",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/images9_afae1641-af0b-4dc1-b7b4-75e7d7da8b84.png?v=1768437908",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/images8_a54faa15-189f-4982-9aad-bf5eadc684a9.png?v=1768437909"
    }
   },
   "carat": 1.7,
   "caratMax": 4.7,
   "fancyColor": "yellow"
  },
  {
   "rank": 384,
   "id": "gid://shopify/Product/10151560249528",
   "title": "1.20-4.20 CT Round Cut Fancy Yellow Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-103312yl",
   "handle": "engagement-rings-103312yl",
   "priceNow": 1570.99,
   "priceWas": 4800.0,
   "pctOff": 67,
   "core": "103312",
   "inStock": true,
   "createdAt": "2025-11-26T00:10:33Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1NIwiRqvMJc4m9idWV-Rt5o9xgVgYRgD-",
      "b": "https://lh3.googleusercontent.com/d/1Yhobgbe3enyQBPNRV8rSq2al1g3Co2cW",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1XFScKod9I8bGIZmUSnm51kLYK4aTbyIE",
      "b": "https://lh3.googleusercontent.com/d/1PRrrA2B6LhSQBR5SL5vgBzN_NcveZKzp",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1XTqZUS4tKBALEHPwZbmh-GAsOfZCN1mk",
      "b": "https://lh3.googleusercontent.com/d/1bPGvN1B9yUPZkT8gEFeSnmhQ6Op3JJ6T",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/images9_100db06d-e38e-4c81-a98a-05c17d13591d.png?v=1768437908"
   },
   "carat": 1.2,
   "caratMax": 4.2,
   "fancyColor": "yellow"
  },
  {
   "rank": 385,
   "id": "gid://shopify/Product/10151560020152",
   "title": "1.75-4.75 CT Princess & Round Cut Fancy Yellow Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-110428yl",
   "handle": "engagement-rings-110428yl",
   "priceNow": 2044.99,
   "priceWas": 6235.0,
   "pctOff": 67,
   "core": "110428",
   "inStock": true,
   "createdAt": "2025-11-26T00:10:08Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1dlCkOhJaTfrprr9aaQ1e2W95Z0ZwASjR",
      "b": "https://lh3.googleusercontent.com/d/1Cj-kuMp0oJBoYty1BPXwKdBTJzlutGlM",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1wogAkj7_ky7411_exVwbPwK8aeMdntOY",
      "b": "https://lh3.googleusercontent.com/d/1N3pgKS5y9O2JEtyl3Em815nNyj9VA05A",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1A1Xfx5FvQmOsMtk2jDhybdvVmOmKGEi6",
      "b": "https://lh3.googleusercontent.com/d/134Jw7FidMtI4W1xMsEvdUgNimlC6yuxV",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/images9_ab0063d6-48d9-4493-980c-ced381bd9a9f.png?v=1768437909"
   },
   "carat": 1.75,
   "caratMax": 4.75,
   "fancyColor": "yellow"
  },
  {
   "rank": 386,
   "id": "gid://shopify/Product/10151559725240",
   "title": "1.25-4.25 CT Round Cut Fancy Yellow Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-110424yl",
   "handle": "engagement-rings-110424yl",
   "priceNow": 1906.99,
   "priceWas": 5805.0,
   "pctOff": 67,
   "core": "110424",
   "inStock": true,
   "createdAt": "2025-11-26T00:09:38Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/images9_3830aae4-3553-4a4f-b6f5-6d405ca15020.png?v=1768437909",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/images9_3830aae4-3553-4a4f-b6f5-6d405ca15020.png?v=1768437909",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/images7_3f7022de-10df-4853-a1be-62f6129ad2a1.png?v=1768437909",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/images8_415f418e-5279-4e2d-94f5-dcde7b687f71.png?v=1768437909"
    }
   },
   "carat": 1.25,
   "caratMax": 4.25,
   "fancyColor": "yellow"
  },
  {
   "rank": 387,
   "id": "gid://shopify/Product/10151559692472",
   "title": "1.20-4.20 CT Round Cut Fancy Yellow Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-110423yl",
   "handle": "engagement-rings-110423yl",
   "priceNow": 1860.99,
   "priceWas": 5665.0,
   "pctOff": 67,
   "core": "110423",
   "inStock": true,
   "createdAt": "2025-11-26T00:09:35Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1qjANBw1Zune6EMFt4u1Mjj-areXCHcVi",
      "b": "https://lh3.googleusercontent.com/d/1edOJ9repG5pz4l56Fnu8S2JmtjAlsh2x",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1FI3veE3DiV-vGzeI6AKyli1VzfUWkZlU",
      "b": "https://lh3.googleusercontent.com/d/1ZCqFTxyPpOpgJQ_D00PQjL_aYvAVh-7b",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1biqcsBZ3XOws5g91KnYTlBmWW3GVDtNO",
      "b": "https://lh3.googleusercontent.com/d/1LSfW0uwImP_aQr2FMpgLhCJ_cRvHqJnh",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/images9_a6081132-f52c-4aa3-923d-80c8de754fa7.png?v=1768437909"
   },
   "carat": 1.2,
   "caratMax": 4.2,
   "fancyColor": "yellow"
  },
  {
   "rank": 388,
   "id": "gid://shopify/Product/10151559397560",
   "title": "1.45-4.45 CT Round Cut Fancy Yellow Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71938yl",
   "handle": "engagement-rings-71938yl",
   "priceNow": 2021.99,
   "priceWas": 6165.0,
   "pctOff": 67,
   "core": "71938",
   "inStock": true,
   "createdAt": "2025-11-26T00:09:03Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/15T2unJTyaxdCGwuBZ8Hc0uafbOXdMjTS",
      "b": "https://lh3.googleusercontent.com/d/1XY00s23pW1sOdhT65Db526TImEpmRmdN",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/198yLt3Jv3GjPYIkSCzycySlEo5nOX3k1",
      "b": "https://lh3.googleusercontent.com/d/1Sa57dWt15NoUnLqmKdSjr76kCbuZ8YiE",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/10SiM1H1JPb7AW6TKmnPNbD7IKbp7jmmT",
      "b": "https://lh3.googleusercontent.com/d/1GMlTrz7wrin2WwyL3SO33QtDHlZg2cBa",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/images9_9765aaca-6f95-4873-862d-100f55e14ea6.png?v=1768437910"
   },
   "carat": 1.45,
   "caratMax": 4.45,
   "fancyColor": "yellow"
  },
  {
   "rank": 389,
   "id": "gid://shopify/Product/10151559332024",
   "title": "1.25-4.25 CT Round Cut Fancy Yellow Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71937yl",
   "handle": "engagement-rings-71937yl",
   "priceNow": 1943.99,
   "priceWas": 5925.0,
   "pctOff": 67,
   "core": "71937",
   "inStock": true,
   "createdAt": "2025-11-26T00:09:00Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1DGBPDdymnjxymjf7BfWgiZBR7Crk3_oE",
      "b": "https://lh3.googleusercontent.com/d/1vm-p35bqFcZnBdHJK3Cx6uI2LjTY1yBA",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1-MB1yATN6plsTxXi3faCDTV1RcXZr1l9",
      "b": "https://lh3.googleusercontent.com/d/1GPdUuWyS-_GkJag2IybPJEWy6nKDkGIf",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1WtlQbanN1jnTZzgpqNtYrCDy4SSDAjMU",
      "b": "https://lh3.googleusercontent.com/d/1YDdY2kc7FhKiiyP2dhPvykJCHi_Cnhhh",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/images9_53be03e4-540e-406e-a23b-abff804bf7a5.png?v=1768437910"
   },
   "carat": 1.25,
   "caratMax": 4.25,
   "fancyColor": "yellow"
  },
  {
   "rank": 390,
   "id": "gid://shopify/Product/10151559102648",
   "title": "1.30-4.30 CT Round Cut Fancy Yellow Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71931yl",
   "handle": "engagement-rings-71931yl",
   "priceNow": 1625.99,
   "priceWas": 4970.0,
   "pctOff": 67,
   "core": "71931",
   "inStock": true,
   "createdAt": "2025-11-26T00:08:35Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1UAuZQqAjTROWYix5Fy9dfL-XcW9GJlGR",
      "b": "https://lh3.googleusercontent.com/d/1TnMhxeyYO2svfWPwQaEWFgcFAblctYpv",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1X63_jDzoLm_yJcsttJqoUIfIeYOp5kcI",
      "b": "https://lh3.googleusercontent.com/d/16B5Mj-Dxk2RHQbwzP5wu7N13QgjRIT9F",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/11TO2omGEI9NljYCwR4tyTK7Or0xJ4Pwd",
      "b": "https://lh3.googleusercontent.com/d/1s9DEPbyqn3LksjzOrQo7-G90olzdYJJI",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/images9_36cc6d38-2e84-453f-a021-f43ca4cc79e3.png?v=1768437911"
   },
   "carat": 1.3,
   "caratMax": 4.3,
   "fancyColor": "yellow"
  },
  {
   "rank": 391,
   "id": "gid://shopify/Product/10151559004344",
   "title": "1.40-4.40 CT Round Cut Fancy Yellow Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71929yl",
   "handle": "engagement-rings-71929yl",
   "priceNow": 1969.99,
   "priceWas": 6005.0,
   "pctOff": 67,
   "core": "71929",
   "inStock": true,
   "createdAt": "2025-11-26T00:08:30Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1n2GYZQCRve_ySBfgcRdoWQNcBbNhbJpH",
      "b": "https://lh3.googleusercontent.com/d/14tSKcuakmxYR8ChsESL_F-Cp5X_x3fEr",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1RUe3zH48QLCo_M1TcTmPbAfcYWHZ7Gya",
      "b": "https://lh3.googleusercontent.com/d/10QHo1sPD91LbP_K_fyvy9tSbsgjfiSGZ",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1OsbhZIFDekLOIIqVoh-eGVGzM2IOoCov",
      "b": "https://lh3.googleusercontent.com/d/1XE3dsoddZ6EyubRnR6teqNH2HNvdaSwA",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/images9_25cb8374-b5f9-4adb-8510-a3909b2bbbc9.png?v=1768437910"
   },
   "carat": 1.4,
   "caratMax": 4.4,
   "fancyColor": "yellow"
  },
  {
   "rank": 392,
   "id": "gid://shopify/Product/10151558807736",
   "title": "1.35-4.35 CT Round Cut Fancy Yellow Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71912yl",
   "handle": "engagement-rings-71912yl",
   "priceNow": 1638.99,
   "priceWas": 5010.0,
   "pctOff": 67,
   "core": "71912",
   "inStock": true,
   "createdAt": "2025-11-26T00:08:04Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1jjU05g-bwNGdsg6OjcKzngdrV2WZObSc",
      "b": "https://lh3.googleusercontent.com/d/1tb3tsPUYYes1h8QvQMq62J74whEALcOP",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1pugXFk4nurEaVkqV6jQD9XUcFi3L-dlV",
      "b": "https://lh3.googleusercontent.com/d/1DRHtH4mUQzBdJcnVzoIQwot0y7d3H-XN",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1tXINjcrOAHVxIsqz80rUwhLcof0bIodD",
      "b": "https://lh3.googleusercontent.com/d/1EyQBxVAdTmJ3wMDIFAjU-uRCF1TtkjWE",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_32_a2413cbe-c6ea-432b-8feb-ee1c3a0ce178.png?v=1768437967"
   },
   "carat": 1.35,
   "caratMax": 4.35,
   "fancyColor": "yellow"
  },
  {
   "rank": 393,
   "id": "gid://shopify/Product/10151558774968",
   "title": "1.85-4.85 CT Round Cut Fancy Yellow Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71911yl",
   "handle": "engagement-rings-71911yl",
   "priceNow": 1895.99,
   "priceWas": 5795.0,
   "pctOff": 67,
   "core": "71911",
   "inStock": true,
   "createdAt": "2025-11-26T00:08:00Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1t7Q9KKmkhetNb9OcJlfqTKQTTORX62ns",
      "b": "https://lh3.googleusercontent.com/d/1dk9s6qZW6oJVs-cGrTLJBZEYNg8wtUNw",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1De5phpzdA1Tx4dMs90jbgWi4y88lkX9j",
      "b": "https://lh3.googleusercontent.com/d/1mpU0TKnnlXE8j_1Rm1cowRAKn64VHwb4",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1MG60RBC6TiYGImMBNi5r_UPAF-AO0ZaC",
      "b": "https://lh3.googleusercontent.com/d/1bXHBvEm_aMlTGDNSnud3fr5ShQMDAUMi",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/images9_5694049b-e46f-400a-8d7b-a61c98c366c0.png?v=1768437967"
   },
   "carat": 1.85,
   "caratMax": 4.85,
   "fancyColor": "yellow"
  },
  {
   "rank": 394,
   "id": "gid://shopify/Product/10151558512824",
   "title": "1.50-4.50 CT Round Cut Fancy Yellow Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71909yl",
   "handle": "engagement-rings-71909yl",
   "priceNow": 2030.99,
   "priceWas": 6195.0,
   "pctOff": 67,
   "core": "71909",
   "inStock": true,
   "createdAt": "2025-11-26T00:07:34Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1jegxUP25JwkYacCCKGT51wzgznv4HIm-",
      "b": "https://lh3.googleusercontent.com/d/1ifSkNY6XdehQgQYM9Pp2o0CjWId6RDaw",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1cqC80asaZfuSDpaoHGHM1MCREPMSy1WW",
      "b": "https://lh3.googleusercontent.com/d/1b7m6cCW8S5zRP_fehJ3JSkbIVeenUzcF",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1vS_kjSsLyoyUdrYJh0MelZwOKAUbXIhY",
      "b": "https://lh3.googleusercontent.com/d/1k2JfRpA_62pUFxvJydClG_R_0g38h6N5",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/images9_96d1cbc5-5924-4c8e-8763-afba3f2335f9.png?v=1768437969"
   },
   "carat": 1.5,
   "caratMax": 4.5,
   "fancyColor": "yellow"
  },
  {
   "rank": 395,
   "id": "gid://shopify/Product/10151558480056",
   "title": "1.70-4.70 CT Princess & Round Cut Fancy Yellow Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71906yl",
   "handle": "engagement-rings-71906yl",
   "priceNow": 2045.99,
   "priceWas": 6225.0,
   "pctOff": 67,
   "core": "71906",
   "inStock": true,
   "createdAt": "2025-11-26T00:07:34Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1PqVjcCDvaJczbUZBFW8VRyy7Qbs5IsLI",
      "b": "https://lh3.googleusercontent.com/d/1lwmLU-V1K6qA99lO4uoKrM4Jr_0DJmMG",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1D0VFJWSOrTBflbKXVsQw62Kl-iTW-X7o",
      "b": "https://lh3.googleusercontent.com/d/1VfXM4U42LB6PBfwiN9cBtr7kjuQm5g69",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1dQmC_rvtdXeyKQIfA-y9AAGekqB2Zf0q",
      "b": "https://lh3.googleusercontent.com/d/1slborRC0hFaxBOSK98Jg4pKLruOySBb5",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/images1_6543ac02-8bb4-44a0-b36c-dec0ac5699da.png?v=1768437968"
   },
   "carat": 1.7,
   "caratMax": 4.7,
   "fancyColor": "yellow"
  },
  {
   "rank": 396,
   "id": "gid://shopify/Product/10151558381752",
   "title": "1.47-4.47 CT Round Cut Fancy Yellow Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71905yl",
   "handle": "engagement-rings-71905yl",
   "priceNow": 2219.99,
   "priceWas": 6745.0,
   "pctOff": 67,
   "core": "71905",
   "inStock": true,
   "createdAt": "2025-11-26T00:07:30Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1Xo5UbbSbaJ-uETOqkPNrQXPEzBBaSQRf",
      "b": "https://lh3.googleusercontent.com/d/1zs91PQohK1HKl8ScA1sVyolPlW4zz7Qn",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1Z4QIw0FLsjiybiBCZwFwes6SYCFwYFzY",
      "b": "https://lh3.googleusercontent.com/d/1UzCIOCHPNi-KrtZgeoRFyDorAqnftiwR",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/11jpd3TICZS0_QAf0wjcwRDxL-tKjNaGX",
      "b": "https://lh3.googleusercontent.com/d/1hjehnpoMM7r6sTq6qkthaxgcZtjsGlSb",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/images9_aa519f3e-5ece-4b0a-8ea9-b1bbe501ceab.png?v=1769814042"
   },
   "carat": 1.47,
   "caratMax": 4.47,
   "fancyColor": "yellow"
  },
  {
   "rank": 397,
   "id": "gid://shopify/Product/10151558119608",
   "title": "1.27-4.27 CT Round Cut Fancy Yellow Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71897yl",
   "handle": "engagement-rings-71897yl",
   "priceNow": 2130.99,
   "priceWas": 6465.0,
   "pctOff": 67,
   "core": "71897",
   "inStock": true,
   "createdAt": "2025-11-26T00:07:07Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1JTpGhZKrJt42hUnhknSZrvLrOWrZ1A57",
      "b": "https://lh3.googleusercontent.com/d/1d_yXkiV0vtuWg7WLFvdjcklB45_qJlV6",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1f_1IGLsMA_dd4vrRLnAU_WCrKneSjEk_",
      "b": "https://lh3.googleusercontent.com/d/1Dmf_nLucYadkA6fPtaUmd10cOuHgSQeQ",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1R1N9IF04Hl-tDko5F7FroVDESEPRmQJT",
      "b": "https://lh3.googleusercontent.com/d/1qPBXJ6SwNoQ_LUDheu45hIUssld8pZd7",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/images9_f4be745d-7c79-457a-bc1b-3a1412f8c357.png?v=1768437968"
   },
   "carat": 1.27,
   "caratMax": 4.27,
   "fancyColor": "yellow"
  },
  {
   "rank": 398,
   "id": "gid://shopify/Product/10151558054072",
   "title": "1.25-4.25 CT Round Cut Fancy Yellow Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71896yl",
   "handle": "engagement-rings-71896yl",
   "priceNow": 1753.99,
   "priceWas": 5355.0,
   "pctOff": 67,
   "core": "71896",
   "inStock": true,
   "createdAt": "2025-11-26T00:07:04Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1MJfgSumdKmTDfLwJBAX8P7iJG5TexuXA",
      "b": "https://lh3.googleusercontent.com/d/1eCe0jzdrYyLYJ7F2YHcmaV3hExUisU5O",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1JQs_AhsxtNdHE5SjKXEMqZ3B8gXK2U2E",
      "b": "https://lh3.googleusercontent.com/d/1hGzKxJk58XbOfB2GSk8mLbFRE2tzls7f",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/15UoGaQ8tRTT4AayUidtzueDTY0z6xgiw",
      "b": "https://lh3.googleusercontent.com/d/1QW4ZcP_r2pkrv1c_ihw-1t7OPfoTB2uv",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/images9_023a2fbd-0c00-4431-a483-c28698309c61.png?v=1768437968"
   },
   "carat": 1.25,
   "caratMax": 4.25,
   "fancyColor": "yellow"
  },
  {
   "rank": 399,
   "id": "gid://shopify/Product/10151558021304",
   "title": "1.49-4.49 CT Round Cut Fancy Yellow Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71894yl",
   "handle": "engagement-rings-71894yl",
   "priceNow": 1970.99,
   "priceWas": 6010.0,
   "pctOff": 67,
   "core": "71894",
   "inStock": true,
   "createdAt": "2025-11-26T00:07:04Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1Aa7prYm1a9Urg0VaOJ05_ReCHWi-dgFO",
      "b": "https://lh3.googleusercontent.com/d/1DNEuBEdQIuWxSHVLd5wtE0Xlb-OkzNIY",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1B41G3NQX8thAL7aHSL3RDa4QsmUCXg4F",
      "b": "https://lh3.googleusercontent.com/d/1Epn5gVsWWJ6z3AjCjpUM_1tUyzdZUTI_",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1h_tqPFBFIqvC6xZZ2gBUSC4w_b6n43dE",
      "b": "https://lh3.googleusercontent.com/d/1QeakYyRK5Pk8X_pyGRMY9xYyWo9YdP4-",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/images9_dd0ee3c7-ce06-4652-ab04-9c98e3c8e2af.png?v=1768437968"
   },
   "carat": 1.49,
   "caratMax": 4.49,
   "fancyColor": "yellow"
  },
  {
   "rank": 400,
   "id": "gid://shopify/Product/10145128415416",
   "title": "0.80-6.30 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/0-80-3-30-ct-round-cut-lab-grown-diamonds-bridal-set-21041lb",
   "handle": "0-80-3-30-ct-round-cut-lab-grown-diamonds-bridal-set-21041lb",
   "priceNow": 2484.99,
   "priceWas": 7700.0,
   "pctOff": 68,
   "core": "21041",
   "inStock": true,
   "createdAt": "2025-11-20T02:05:43Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/080-330-ct-round-cut-lab-grown-diamonds-bridal-set-501786.jpg?v=1763605793",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/080-330-ct-round-cut-lab-grown-diamonds-bridal-set-501786.jpg?v=1763605793",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/080-330-ct-round-cut-lab-grown-diamonds-bridal-set-407403.jpg?v=1763697352",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/080-330-ct-round-cut-lab-grown-diamonds-bridal-set-497175.jpg?v=1763697352"
    }
   },
   "carat": 0.8,
   "caratMax": 6.3
  },
  {
   "rank": 401,
   "id": "gid://shopify/Product/9267852017848",
   "title": "4.00-10.00 CT Radiant Cut Lab Grown Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-40003lb",
   "handle": "eternity-rings-40003lb",
   "priceNow": 2311.99,
   "priceWas": 7170.0,
   "pctOff": 68,
   "core": "40003",
   "inStock": true,
   "createdAt": "2024-12-03T18:20:47Z",
   "shape": "radiant",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/radiant_8d73f42a-386a-4a35-b3ce-765c2a531aa7.jpg?v=1763697465",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/radiant_90073d3d-c271-467a-936f-ea1b662401df.jpg?v=1763697466",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/radiant_90073d3d-c271-467a-936f-ea1b662401df.jpg?v=1763697466",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/radiant_90073d3d-c271-467a-936f-ea1b662401df.jpg?v=1763697466"
    }
   },
   "carat": 4.0,
   "caratMax": 10.0
  },
  {
   "rank": 402,
   "id": "gid://shopify/Product/9267851985080",
   "title": "2.00-8.00 CT Cushion Cut Lab Grown Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-40002lb",
   "handle": "eternity-rings-40002lb",
   "priceNow": 1616.99,
   "priceWas": 5010.0,
   "pctOff": 68,
   "core": "40002",
   "inStock": true,
   "createdAt": "2024-12-03T18:20:44Z",
   "shape": "cushion",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/cushioncorrect.jpg?v=1763697465",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/cushioncorrect.jpg?v=1763697465",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/cushioncorrect.jpg?v=1763697465",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/cushioncorrect.jpg?v=1763697465"
    }
   },
   "carat": 2.0,
   "caratMax": 8.0
  },
  {
   "rank": 403,
   "id": "gid://shopify/Product/9267851854008",
   "title": "2.00-10.00 CT Oval Cut Lab Grown Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-40001lb",
   "handle": "eternity-rings-40001lb",
   "priceNow": 1594.99,
   "priceWas": 4940.0,
   "pctOff": 68,
   "core": "40001",
   "inStock": true,
   "createdAt": "2024-12-03T18:20:32Z",
   "shape": "oval",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/eternityova_849c7b64-26aa-41e7-a2ac-6a07fd5d4a51.jpg?v=1763697465",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/eternityova_849c7b64-26aa-41e7-a2ac-6a07fd5d4a51.jpg?v=1763697465",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/eternityova_849c7b64-26aa-41e7-a2ac-6a07fd5d4a51.jpg?v=1763697465",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/eternityova_849c7b64-26aa-41e7-a2ac-6a07fd5d4a51.jpg?v=1763697465"
    }
   },
   "carat": 2.0,
   "caratMax": 10.0
  },
  {
   "rank": 404,
   "id": "gid://shopify/Product/9264978657464",
   "title": "5.50-8.50 CT Princess Cut Lab Grown Diamonds - Hoop & Drop Earrings",
   "url": "/products/hoop-and-drop-earrings-30005lb",
   "handle": "hoop-and-drop-earrings-30005lb",
   "priceNow": 2988.99,
   "priceWas": 9270.0,
   "pctOff": 68,
   "core": "30005",
   "inStock": true,
   "createdAt": "2024-11-28T20:50:56Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1stlT5wtz7U6EMqLZ_ZJ6wPMh66nS9-Ug",
      "b": "https://lh3.googleusercontent.com/d/1rJbPRlGuJmPH6ObqQeDy-KZYIomcTqfC",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1Pbk41r8mCvyIhy31rMMaNTfyzl2ZcMq8",
      "b": "https://lh3.googleusercontent.com/d/1eW8eT3ojZZZqd3iVEQoSj8aI3DUngvkO",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Ldn7xewqTTzRhoS7VHkZINvOW5XAa5Ai",
      "b": "https://lh3.googleusercontent.com/d/1Sa3N0F4npGn0JXnraT7xu8zpGqlripQn",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_540cc71d-f419-4fad-8b71-30d2eea24ce1.jpg?v=1729613338"
   },
   "carat": 5.5,
   "caratMax": 8.5
  },
  {
   "rank": 405,
   "id": "gid://shopify/Product/9264978591928",
   "title": "0.75-1.25 CT Round Cut Lab Grown Diamonds - Hoop & Drop Earrings",
   "url": "/products/hoop-and-drop-earrings-30004lb",
   "handle": "hoop-and-drop-earrings-30004lb",
   "priceNow": 1834.99,
   "priceWas": 5690.0,
   "pctOff": 68,
   "core": "30004",
   "inStock": true,
   "createdAt": "2024-11-28T20:50:52Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/11fu7z7BM5mB0_RVDIOBz8McqWcQ_KWLV",
      "b": "https://lh3.googleusercontent.com/d/1w01L1xvlGgL4chXkBsTtM4P-sr-99nbZ",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1VC0f8U0vCDwGkJk9srAkswKHr8eKXfqx",
      "b": "https://lh3.googleusercontent.com/d/1nMut0QE2_BURZrtuGHXWTy89axtM1QES",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1m0004q-Fu3ZCuFlXUWQPDbThU6Gd1_J3",
      "b": "https://lh3.googleusercontent.com/d/1bf5ZMyPo7-DXr2nCZ1_Lw4vUdn7gDJQt",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_b21e3b54-784b-4b08-b2ea-7ebf23c8bcb7.jpg?v=1729625083"
   },
   "carat": 0.75,
   "caratMax": 1.25
  },
  {
   "rank": 406,
   "id": "gid://shopify/Product/9264978526392",
   "title": "3.50-10.00 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/tennis-bracelets-71114lb",
   "handle": "tennis-bracelets-71114lb",
   "priceNow": 3999.99,
   "priceWas": 12400.0,
   "pctOff": 68,
   "core": "71114",
   "inStock": true,
   "createdAt": "2024-11-28T20:50:43Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/71114LB_w2_b78bc265-836d-44ed-9ef4-d39987959192.jpg?v=1763993600",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/71114LB_w2_b78bc265-836d-44ed-9ef4-d39987959192.jpg?v=1763993600",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/71114LB_y2_1b02d788-f1b7-4d86-8e0b-f6637aa45503.jpg?v=1763993602",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/71114LB_r2_871a554f-19b8-4ccb-b74f-0447a6bb554d.jpg?v=1763993605"
    }
   },
   "carat": 3.5,
   "caratMax": 10.0
  },
  {
   "rank": 407,
   "id": "gid://shopify/Product/9264978493624",
   "title": "0.75-1.50 CT Round Cut Lab Grown Diamonds - Hoop & Drop Earrings",
   "url": "/products/hoop-and-drop-earrings-30002lb",
   "handle": "hoop-and-drop-earrings-30002lb",
   "priceNow": 1174.99,
   "priceWas": 3640.0,
   "pctOff": 68,
   "core": "30002",
   "inStock": true,
   "createdAt": "2024-11-28T20:50:38Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1UlHIuUBUJl4orOsbaQwk243mV1bF9xnd",
      "b": "https://lh3.googleusercontent.com/d/1LotsaNLKfGiOeQvTLkpUBoQIzM8_vC4G",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1AK5kIaIwlvOv2lRbMVrsUOfGqZ7Sh4BH",
      "b": "https://lh3.googleusercontent.com/d/1r4-drTX3Zgxd09pE7METun5CGEVFfAZR",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1T81Jwk6XPuAuZn8f6vjDYBS_eZCWB2Gw",
      "b": "https://lh3.googleusercontent.com/d/1eagV1ozFZvLdwjS2LhpEgjIVtL0L6KBn",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_e53f6f42-d3ef-49a8-8db2-4f68788b76cf.jpg?v=1763993564"
   },
   "carat": 0.75,
   "caratMax": 1.5
  },
  {
   "rank": 408,
   "id": "gid://shopify/Product/9264978460856",
   "title": "0.75-1.50 CT Round Cut Lab Grown Diamonds - Hoop & Drop Earrings",
   "url": "/products/hoop-and-drop-earrings-30001lb",
   "handle": "hoop-and-drop-earrings-30001lb",
   "priceNow": 909.99,
   "priceWas": 3090.0,
   "pctOff": 71,
   "core": "30001",
   "inStock": true,
   "createdAt": "2024-11-28T20:50:35Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1ayDD0ZIkwX74nhmHftlet5vxID8GwUWV",
      "b": "https://lh3.googleusercontent.com/d/1xThN0KhBCj0kQVAA5vNGz7WSycveX7V2",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1hN95KslQ2z3Nf2EM8Lb2LdXLFPZbz15X",
      "b": "https://lh3.googleusercontent.com/d/1mW8MLgr24ZmsHm_3lsOYzXnQHQM37V4I",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1FqSjbWilEAMczv_3GE5Au5DGORU1E_hX",
      "b": "https://lh3.googleusercontent.com/d/16qJwNfwdGBTGZtF2kKsVTq7wCHknlm20",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_a5856dc7-221c-4c76-b357-e7ae0b539c07.jpg?v=1763993549"
   },
   "carat": 0.75,
   "caratMax": 1.5
  },
  {
   "rank": 409,
   "id": "gid://shopify/Product/9264219160760",
   "title": "7.10 CT Princess Cut Lab Grown Diamonds - Hoop & Drop Earrings",
   "url": "/products/hoop-drop-earrings-110382lb",
   "handle": "hoop-drop-earrings-110382lb",
   "priceNow": 5320.99,
   "priceWas": 15430.0,
   "pctOff": 66,
   "core": "110382",
   "inStock": true,
   "createdAt": "2024-11-26T23:44:10Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/710-ct-princess-cut-diamonds-hoop-drop-earrings-848176.jpg?v=1763993565",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/710-ct-princess-cut-diamonds-hoop-drop-earrings-848176.jpg?v=1763993565",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/710-ct-princess-cut-diamonds-hoop-drop-earrings-844616.jpg?v=1763993566",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/710-ct-princess-cut-diamonds-hoop-drop-earrings-679417.jpg?v=1763993567"
    }
   },
   "carat": 7.1
  },
  {
   "rank": 410,
   "id": "gid://shopify/Product/9264219127992",
   "title": "0.10 CT Round Cut Lab Grown Diamonds - Hoop &  Drop Earrings",
   "url": "/products/hoop-drop-earrings-110381lb",
   "handle": "hoop-drop-earrings-110381lb",
   "priceNow": 702.99,
   "priceWas": 2256.99,
   "pctOff": 69,
   "core": "110381",
   "inStock": true,
   "createdAt": "2024-11-26T23:44:06Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/010-ct-round-cut-diamonds-hoop-drop-earrings-716941.jpg?v=1669765392",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/010-ct-round-cut-diamonds-hoop-drop-earrings-716941.jpg?v=1669765392",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/010-ct-round-cut-diamonds-hoop-drop-earrings-449198.jpg?v=1669765392",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/010-ct-round-cut-diamonds-hoop-drop-earrings-143213.jpg?v=1669765392"
    }
   },
   "carat": 0.1
  },
  {
   "rank": 411,
   "id": "gid://shopify/Product/9264219095224",
   "title": "0.50 CT Round Cut Lab Grown Diamonds - Hoop &  Drop Earrings",
   "url": "/products/hoop-drop-earrings-110380lb",
   "handle": "hoop-drop-earrings-110380lb",
   "priceNow": 1104.99,
   "priceWas": 3395.99,
   "pctOff": 67,
   "core": "110380",
   "inStock": true,
   "createdAt": "2024-11-26T23:44:02Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-ct-round-cut-diamonds-hoop-drop-earrings-137562.jpg?v=1669765978",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-ct-round-cut-diamonds-hoop-drop-earrings-137562.jpg?v=1669765978",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-ct-round-cut-diamonds-hoop-drop-earrings-623691.jpg?v=1669765978",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-ct-round-cut-diamonds-hoop-drop-earrings-390379.jpg?v=1669765978"
    }
   },
   "carat": 0.5
  },
  {
   "rank": 412,
   "id": "gid://shopify/Product/9264219062456",
   "title": "0.30 CT Round Cut Lab Grown Diamonds - Hoop &  Drop Earrings",
   "url": "/products/hoop-drop-earrings-110379lb",
   "handle": "hoop-drop-earrings-110379lb",
   "priceNow": 1436.99,
   "priceWas": 4628.99,
   "pctOff": 69,
   "core": "110379",
   "inStock": true,
   "createdAt": "2024-11-26T23:43:54Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/030-ct-round-cut-diamonds-hoop-drop-earrings-426467.jpg?v=1669765445",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/030-ct-round-cut-diamonds-hoop-drop-earrings-426467.jpg?v=1669765445",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/030-ct-round-cut-diamonds-hoop-drop-earrings-290725.jpg?v=1669765445",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/030-ct-round-cut-diamonds-hoop-drop-earrings-669834.jpg?v=1669765445"
    }
   },
   "carat": 0.3
  },
  {
   "rank": 413,
   "id": "gid://shopify/Product/9264218996920",
   "title": "0.10 CT Round Cut Lab Grown Diamonds - Hoop &  Drop Earrings",
   "url": "/products/hoop-drop-earrings-110378lb",
   "handle": "hoop-drop-earrings-110378lb",
   "priceNow": 549.99,
   "priceWas": 1673.99,
   "pctOff": 67,
   "core": "110378",
   "inStock": true,
   "createdAt": "2024-11-26T23:43:50Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/010-ct-round-cut-diamonds-hoop-drop-earrings-456255.jpg?v=1669765392",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/010-ct-round-cut-diamonds-hoop-drop-earrings-456255.jpg?v=1669765392",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/010-ct-round-cut-diamonds-hoop-drop-earrings-255353.jpg?v=1669765392",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/010-ct-round-cut-diamonds-hoop-drop-earrings-249095.jpg?v=1669765392"
    }
   },
   "carat": 0.1
  },
  {
   "rank": 414,
   "id": "gid://shopify/Product/9264218964152",
   "title": "0.10 CT Round Cut Lab Grown Diamonds - Hoop & Drop Earrings",
   "url": "/products/hoop-drop-earrings-110377lb",
   "handle": "hoop-drop-earrings-110377lb",
   "priceNow": 1161.99,
   "priceWas": 3600.0,
   "pctOff": 68,
   "core": "110377",
   "inStock": true,
   "createdAt": "2024-11-26T23:43:46Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/010-ct-round-cut-diamonds-hoop-drop-earrings-464554.jpg?v=1763993586",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/010-ct-round-cut-diamonds-hoop-drop-earrings-464554.jpg?v=1763993586",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/010-ct-round-cut-diamonds-hoop-drop-earrings-172275.jpg?v=1763993588",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/010-ct-round-cut-diamonds-hoop-drop-earrings-155482.jpg?v=1763993588"
    }
   },
   "carat": 0.1
  },
  {
   "rank": 415,
   "id": "gid://shopify/Product/9264218931384",
   "title": "0.40 CT Round Cut Lab Grown Diamonds - Hoop & Drop Earrings",
   "url": "/products/hoop-drop-earrings-110376lb",
   "handle": "hoop-drop-earrings-110376lb",
   "priceNow": 2318.99,
   "priceWas": 7190.0,
   "pctOff": 68,
   "core": "110376",
   "inStock": true,
   "createdAt": "2024-11-26T23:43:42Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/040-ct-round-cut-diamonds-hoop-drop-earrings-408947.jpg?v=1763993560",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/040-ct-round-cut-diamonds-hoop-drop-earrings-408947.jpg?v=1763993560",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/040-ct-round-cut-diamonds-hoop-drop-earrings-864342.jpg?v=1763993561",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/040-ct-round-cut-diamonds-hoop-drop-earrings-897605.jpg?v=1763993560"
    }
   },
   "carat": 0.4
  },
  {
   "rank": 416,
   "id": "gid://shopify/Product/9264218865848",
   "title": "0.50 CT Round Cut Lab Grown Diamonds - Hoop &  Drop Earrings",
   "url": "/products/hoop-drop-earrings-110375lb",
   "handle": "hoop-drop-earrings-110375lb",
   "priceNow": 610.99,
   "priceWas": 2010.99,
   "pctOff": 70,
   "core": "110375",
   "inStock": true,
   "createdAt": "2024-11-26T23:43:38Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-ct-round-cut-diamonds-hoop-drop-earrings-903186.jpg?v=1669765845",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-ct-round-cut-diamonds-hoop-drop-earrings-903186.jpg?v=1669765845",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-ct-round-cut-diamonds-hoop-drop-earrings-217192.jpg?v=1669765845",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-ct-round-cut-diamonds-hoop-drop-earrings-634546.jpg?v=1669765845"
    }
   },
   "carat": 0.5
  },
  {
   "rank": 417,
   "id": "gid://shopify/Product/9264218833080",
   "title": "0.20 CT Round Cut Lab Grown Diamonds - Hoop &  Drop Earrings",
   "url": "/products/hoop-drop-earrings-110374lb",
   "handle": "hoop-drop-earrings-110374lb",
   "priceNow": 1270.99,
   "priceWas": 4089.99,
   "pctOff": 69,
   "core": "110374",
   "inStock": true,
   "createdAt": "2024-11-26T23:43:34Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/020-ct-round-cut-diamonds-hoop-drop-earrings-780497.jpg?v=1669765364",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/020-ct-round-cut-diamonds-hoop-drop-earrings-780497.jpg?v=1669765364",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/020-ct-round-cut-diamonds-hoop-drop-earrings-197633.jpg?v=1669765364",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/020-ct-round-cut-diamonds-hoop-drop-earrings-645010.jpg?v=1669765364"
    }
   },
   "carat": 0.2
  },
  {
   "rank": 418,
   "id": "gid://shopify/Product/9264218767544",
   "title": "0.30 CT Round Cut Lab Grown Diamonds - Hoop &  Drop Earrings",
   "url": "/products/hoop-drop-earrings-110373lb",
   "handle": "hoop-drop-earrings-110373lb",
   "priceNow": 752.99,
   "priceWas": 2336.99,
   "pctOff": 68,
   "core": "110373",
   "inStock": true,
   "createdAt": "2024-11-26T23:43:30Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/030-ct-round-cut-diamonds-hoop-drop-earrings-577924.jpg?v=1669765435",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/030-ct-round-cut-diamonds-hoop-drop-earrings-577924.jpg?v=1669765435",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/030-ct-round-cut-diamonds-hoop-drop-earrings-995260.jpg?v=1669765435",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/030-ct-round-cut-diamonds-hoop-drop-earrings-580697.jpg?v=1669765435"
    }
   },
   "carat": 0.3
  },
  {
   "rank": 419,
   "id": "gid://shopify/Product/9264218636472",
   "title": "0.50 CT Round Cut Lab Grown Diamonds - Hoop &  Drop Earrings",
   "url": "/products/hoop-drop-earrings-110372lb",
   "handle": "hoop-drop-earrings-110372lb",
   "priceNow": 1523.99,
   "priceWas": 5050.99,
   "pctOff": 70,
   "core": "110372",
   "inStock": true,
   "createdAt": "2024-11-26T23:43:26Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-ct-round-cut-diamonds-hoop-drop-earrings-513093.jpg?v=1669765919",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-ct-round-cut-diamonds-hoop-drop-earrings-513093.jpg?v=1669765919",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-ct-round-cut-diamonds-hoop-drop-earrings-690954.jpg?v=1669765919",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-ct-round-cut-diamonds-hoop-drop-earrings-312957.jpg?v=1669765919"
    }
   },
   "carat": 0.5
  },
  {
   "rank": 420,
   "id": "gid://shopify/Product/9264218603704",
   "title": "0.30 CT Round Cut Lab Grown Diamonds - Hoop &  Drop Earrings",
   "url": "/products/hoop-drop-earrings-110371lb",
   "handle": "hoop-drop-earrings-110371lb",
   "priceNow": 1107.99,
   "priceWas": 3520.99,
   "pctOff": 69,
   "core": "110371",
   "inStock": true,
   "createdAt": "2024-11-26T23:43:20Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/030-ct-round-cut-diamonds-hoop-drop-earrings-862128.jpg?v=1669765437",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/030-ct-round-cut-diamonds-hoop-drop-earrings-862128.jpg?v=1669765437",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/030-ct-round-cut-diamonds-hoop-drop-earrings-899292.jpg?v=1669765437",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/030-ct-round-cut-diamonds-hoop-drop-earrings-986320.jpg?v=1669765437"
    }
   },
   "carat": 0.3
  },
  {
   "rank": 421,
   "id": "gid://shopify/Product/9264218538168",
   "title": "0.10 CT Round Cut Lab Grown Diamonds - Hoop &  Drop Earrings",
   "url": "/products/hoop-drop-earrings-110370lb",
   "handle": "hoop-drop-earrings-110370lb",
   "priceNow": 670.99,
   "priceWas": 2198.99,
   "pctOff": 69,
   "core": "110370",
   "inStock": true,
   "createdAt": "2024-11-26T23:43:14Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/010-ct-round-cut-diamonds-hoop-drop-earrings-169690.jpg?v=1669765391",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/010-ct-round-cut-diamonds-hoop-drop-earrings-169690.jpg?v=1669765391",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/010-ct-round-cut-diamonds-hoop-drop-earrings-782576.jpg?v=1669765392",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/010-ct-round-cut-diamonds-hoop-drop-earrings-875988.jpg?v=1669765392"
    }
   },
   "carat": 0.1
  },
  {
   "rank": 422,
   "id": "gid://shopify/Product/9264218472632",
   "title": "0.10 CT Round Cut Lab Grown Diamonds - Hoop &  Drop Earrings",
   "url": "/products/hoop-drop-earrings-110369lb",
   "handle": "hoop-drop-earrings-110369lb",
   "priceNow": 856.99,
   "priceWas": 2681.99,
   "pctOff": 68,
   "core": "110369",
   "inStock": true,
   "createdAt": "2024-11-26T23:43:09Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/010-ct-round-cut-diamonds-hoop-drop-earrings-424159.jpg?v=1669765366",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/010-ct-round-cut-diamonds-hoop-drop-earrings-424159.jpg?v=1669765366",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/010-ct-round-cut-diamonds-hoop-drop-earrings-601180.jpg?v=1669765366",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/010-ct-round-cut-diamonds-hoop-drop-earrings-779486.jpg?v=1669765366"
    }
   },
   "carat": 0.1
  },
  {
   "rank": 423,
   "id": "gid://shopify/Product/9264218407096",
   "title": "0.30 CT Round Cut Lab Grown Diamonds - Hoop &  Drop Earrings",
   "url": "/products/hoop-drop-earrings-110368lb",
   "handle": "hoop-drop-earrings-110368lb",
   "priceNow": 1306.99,
   "priceWas": 4042.99,
   "pctOff": 68,
   "core": "110368",
   "inStock": true,
   "createdAt": "2024-11-26T23:43:05Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/030-ct-round-cut-diamonds-hoop-drop-earrings-196885.jpg?v=1669765442",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/030-ct-round-cut-diamonds-hoop-drop-earrings-196885.jpg?v=1669765442",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/030-ct-round-cut-diamonds-hoop-drop-earrings-629238.jpg?v=1669765442",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/030-ct-round-cut-diamonds-hoop-drop-earrings-916527.jpg?v=1669765442"
    }
   },
   "carat": 0.3
  },
  {
   "rank": 424,
   "id": "gid://shopify/Product/9264218308792",
   "title": "0.30 CT Round Cut Lab Grown Diamonds - Hoop &  Drop Earrings",
   "url": "/products/hoop-drop-earrings-110367lb",
   "handle": "hoop-drop-earrings-110367lb",
   "priceNow": 1206.99,
   "priceWas": 3813.99,
   "pctOff": 68,
   "core": "110367",
   "inStock": true,
   "createdAt": "2024-11-26T23:43:01Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/030-ct-round-cut-diamonds-hoop-drop-earrings-920801.jpg?v=1669765425",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/030-ct-round-cut-diamonds-hoop-drop-earrings-920801.jpg?v=1669765425",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/030-ct-round-cut-diamonds-hoop-drop-earrings-802313.jpg?v=1669765425",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/030-ct-round-cut-diamonds-hoop-drop-earrings-777734.jpg?v=1669765425"
    }
   },
   "carat": 0.3
  },
  {
   "rank": 425,
   "id": "gid://shopify/Product/9258654859448",
   "title": "7.00-15.50 CT Emerald Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/tennis-bracelets-21106lb",
   "handle": "tennis-bracelets-21106lb",
   "priceNow": 5066.99,
   "priceWas": 14690.0,
   "pctOff": 66,
   "core": "21106",
   "inStock": true,
   "createdAt": "2024-11-17T22:49:01Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/WhatsApp_Image_2024-12-11_at_13.56.51_31a6d0c4.jpg?v=1763697498",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/WhatsApp_Image_2024-12-11_at_13.56.51_31a6d0c4.jpg?v=1763697498",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/WhatsApp_Image_2024-12-11_at_13.56.51_31a6d0c4.jpg?v=1763697498",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/WhatsApp_Image_2024-12-11_at_13.56.51_31a6d0c4.jpg?v=1763697498"
    }
   },
   "carat": 7.0,
   "caratMax": 15.5
  },
  {
   "rank": 426,
   "id": "gid://shopify/Product/9258654826680",
   "title": "9.00-16.50 CT Oval Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/tennis-bracelets-21105lb",
   "handle": "tennis-bracelets-21105lb",
   "priceNow": 6234.99,
   "priceWas": 18080.0,
   "pctOff": 66,
   "core": "21105",
   "inStock": true,
   "createdAt": "2024-11-17T22:48:49Z",
   "shape": "oval",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/ovaltennis.jpg?v=1763697498",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/ovaltennis.jpg?v=1763697498",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/ovaltennis.jpg?v=1763697498",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/ovaltennis.jpg?v=1763697498"
    }
   },
   "carat": 9.0,
   "caratMax": 16.5
  },
  {
   "rank": 427,
   "id": "gid://shopify/Product/9258654793912",
   "title": "4.00-14.50 CT Princess Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/tennis-bracelets-409021lb",
   "handle": "tennis-bracelets-409021lb",
   "priceNow": 4436.99,
   "priceWas": 13750.0,
   "pctOff": 68,
   "core": "409021",
   "inStock": true,
   "createdAt": "2024-11-17T22:48:44Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/400-1350-ct-round-cut-lab-grown-diamonds-tennis-bracelet-462499.jpg?v=1705363224",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/400-1350-ct-round-cut-lab-grown-diamonds-tennis-bracelet-462499.jpg?v=1705363224",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/400-1350-ct-round-cut-lab-grown-diamonds-tennis-bracelet-165532.jpg?v=1763697499",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/400-1350-ct-round-cut-lab-grown-diamonds-tennis-bracelet-797354.jpg?v=1763697499"
    }
   },
   "carat": 4.0,
   "caratMax": 14.5
  },
  {
   "rank": 428,
   "id": "gid://shopify/Product/9258654728376",
   "title": "2.00-9.00 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/tennis-bracelets-316873lb",
   "handle": "tennis-bracelets-316873lb",
   "priceNow": 3116.99,
   "priceWas": 9660.0,
   "pctOff": 68,
   "core": "316873",
   "inStock": true,
   "createdAt": "2024-11-17T22:48:32Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-400-ct-round-cut-lab-grown-diamonds-tennis-bracelet-995553.jpg?v=1705353650",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-400-ct-round-cut-lab-grown-diamonds-tennis-bracelet-995553.jpg?v=1705353650",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-400-ct-round-cut-lab-grown-diamonds-tennis-bracelet-816791.jpg?v=1763697499",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-400-ct-round-cut-lab-grown-diamonds-tennis-bracelet-922601.jpg?v=1763697499"
    }
   },
   "carat": 2.0,
   "caratMax": 9.0
  },
  {
   "rank": 429,
   "id": "gid://shopify/Product/9246811095224",
   "title": "11.90 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-30009lb",
   "handle": "engagement-rings-30009lb",
   "priceNow": 5530.99,
   "priceWas": 16040.0,
   "pctOff": 66,
   "core": "30009",
   "inStock": true,
   "createdAt": "2024-10-30T17:08:57Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_024fe2e4-6518-40e6-a726-12889f808042.jpg?v=1765415442",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_024fe2e4-6518-40e6-a726-12889f808042.jpg?v=1765415442",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y3_9728a7e6-c086-4352-b0c7-d7847fa75302.jpg?v=1765415444",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r3_0592f69d-6be8-438d-af20-2609569f6505.jpg?v=1765415446"
    }
   },
   "carat": 11.9
  },
  {
   "rank": 430,
   "id": "gid://shopify/Product/9246810964152",
   "title": "11.65 CT Round Cut Lab Grown Diamonds - Halo Rings",
   "url": "/products/halo-rings-30008lb",
   "handle": "halo-rings-30008lb",
   "priceNow": 14144.99,
   "priceWas": 38250.0,
   "pctOff": 63,
   "core": "30008",
   "inStock": true,
   "createdAt": "2024-10-30T17:08:46Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1CjvUxe6fSa2PLEFXOtRPhci6MFAx0qJp",
      "b": "https://lh3.googleusercontent.com/d/1LJAYeHlG5CqRluF-5HqAovKl5CkCfMgr",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1NMfiN4xvuXZU-7bpj4zCN729HtRwASEx",
      "b": "https://lh3.googleusercontent.com/d/1UKE8NWhSRObhOPJYFI5oOqLwShx950jQ",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/17gA12zDXhwMxOutomf1TMDyeknWDz_-m",
      "b": "https://lh3.googleusercontent.com/d/126HV4ybVv_AWNVLdWDLKlhmEfOp42ZtU",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_f8022d4f-959f-4192-bd06-80dedb24e536.jpg?v=1765415408"
   },
   "carat": 11.65
  },
  {
   "rank": 431,
   "id": "gid://shopify/Product/9153147502776",
   "title": "1.20 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-16060lb",
   "handle": "wedding-bands-16060lb",
   "priceNow": 1490.99,
   "priceWas": 4620.0,
   "pctOff": 68,
   "core": "16060",
   "inStock": true,
   "createdAt": "2024-07-05T14:13:32Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/12HNCm2eVaGv_uYa7E8iHCjizXchpMZ52",
      "b": "https://lh3.googleusercontent.com/d/1gHRkK4vJP7k82oTQ86GBbE2P_0e65M0c",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1SxQPOvVo7fPUNLBL2zaFgWXSByEH_zhR",
      "b": "https://lh3.googleusercontent.com/d/1KEw2dwdxoABxk_AkvUbb_eI6cGrMABqT",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Td-sbapPDXu504VthJtrvk7z8_x5QSKx",
      "b": "https://lh3.googleusercontent.com/d/1wj5BnEzFDBkZzJpEKLzkasWUAN9ScEbV",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold2_DiamondReal_f5f5fde5-77ed-4102-8f9f-8d179b58fc31.jpg?v=1720204485"
   },
   "carat": 1.2
  },
  {
   "rank": 432,
   "id": "gid://shopify/Product/9153147306168",
   "title": "0.15 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71456lb",
   "handle": "wedding-bands-71456lb",
   "priceNow": 1172.99,
   "priceWas": 3640.0,
   "pctOff": 68,
   "core": "71456",
   "inStock": true,
   "createdAt": "2024-07-05T14:13:27Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1ynyDGI8DfOM0-VXDUIg0RwiFcpZDzomF",
      "b": "https://lh3.googleusercontent.com/d/1bRSwEQugyvx_qcnFjdkd4DzV0k0kIC2J",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1WqmU2mq_bSvOdNe2P0NPB_PQrdSMW9le",
      "b": "https://lh3.googleusercontent.com/d/1NmlpKQAFgUZyPsvOJ_YV0yKuDOJNq4pD",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ubIOG2wYr_aU-NZQhVefAAarjfQSmE4h",
      "b": "https://lh3.googleusercontent.com/d/1E0bmItzKR7m0obTggfW9DTtJNstCegUr",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold2_DiamondReal_873cc138-af2c-4ea9-906c-fe3062d36e29.jpg?v=1720204162"
   },
   "carat": 0.15
  },
  {
   "rank": 433,
   "id": "gid://shopify/Product/9153147076792",
   "title": "0.15 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71564lb",
   "handle": "wedding-bands-71564lb",
   "priceNow": 1174.99,
   "priceWas": 3640.0,
   "pctOff": 68,
   "core": "71564",
   "inStock": true,
   "createdAt": "2024-07-05T14:13:21Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold2_DiamondReal.jpg?v=1720204021",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold2_DiamondReal.jpg?v=1720204021",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold_DiamondReal.jpg?v=1763697501",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold1_DiamondReal.jpg?v=1763697500"
    }
   },
   "carat": 0.15
  },
  {
   "rank": 434,
   "id": "gid://shopify/Product/9153146847416",
   "title": "0.95-6.45 CT Round Cut Lab Grown Diamonds - Three Stone Rings",
   "url": "/products/three-stone-rings-15308lb",
   "handle": "three-stone-rings-15308lb",
   "priceNow": 1560.99,
   "priceWas": 4840.0,
   "pctOff": 68,
   "core": "15308",
   "inStock": true,
   "createdAt": "2024-07-05T14:13:16Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1lj_zP0_OMIOUzbmBjzKRnzy1FZt5Wnex",
      "b": "https://lh3.googleusercontent.com/d/1Bgd2H2MXrEX4CDZc1ns5GZnV7XwX3tce",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1FGH0_XU1K0Y98X75zpJ_ay-V0GLncC2P",
      "b": "https://lh3.googleusercontent.com/d/1STjskFNMRU2hWg1_B5Wdff2tahklljL_",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1N9Ja63eV-o_GDHLGLP3WR9fU6h7CswV1",
      "b": "https://lh3.googleusercontent.com/d/1ndMpg-0WEzPEfvdKziknAP9TA0pF6dO-",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_DiamondReal_YellowGold2.jpg?v=1763766481"
   },
   "carat": 0.95,
   "caratMax": 6.45
  },
  {
   "rank": 435,
   "id": "gid://shopify/Product/9153146585272",
   "title": "0.75-6.25 CT Princess Cut Lab Grown Diamonds - Three Stone Rings",
   "url": "/products/three-stone-rings-15615lb",
   "handle": "three-stone-rings-15615lb",
   "priceNow": 1461.99,
   "priceWas": 4530.0,
   "pctOff": 68,
   "core": "15615",
   "inStock": true,
   "createdAt": "2024-07-05T14:13:10Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1-Ahz4IxvYOPJD5ADXOEpj3qqWs-b1Rkr",
      "b": "https://lh3.googleusercontent.com/d/1h2uouLUp6Ix0vYiPhaRkUTwB8C5EL-rq",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/12ZIr_-_geu2eWq_LUniJT2Jh-KWRXlGI",
      "b": "https://lh3.googleusercontent.com/d/1Tol17zmakij8qiU2IlHGhsaqbO5UdcQm",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1EUMc4OpbVfR_GwqrI5l08iCV6X16aToI",
      "b": "https://lh3.googleusercontent.com/d/15QcTeJqcWvfQ9kH8jjgQUggrN6Vm1c8f",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA_3_proba_Perspective_Yellow_Gold2_Diamond_Real_White_Matte_3c071054-3c83-4bfc-890e-b9a5947995fa.jpg?v=1763766480"
   },
   "carat": 0.75,
   "caratMax": 6.25
  },
  {
   "rank": 436,
   "id": "gid://shopify/Product/9153146159288",
   "title": "0.75-6.25 CT Round Cut Lab Grown Diamonds - Three Stone Rings",
   "url": "/products/three-stone-rings-15618lb",
   "handle": "three-stone-rings-15618lb",
   "priceNow": 1382.99,
   "priceWas": 4290.0,
   "pctOff": 68,
   "core": "15618",
   "inStock": true,
   "createdAt": "2024-07-05T14:13:01Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1gkdzTls1xiay1Ehgi_L83nq5YR3EItUj",
      "b": "https://lh3.googleusercontent.com/d/1EcyHH2_Up6jJwFZi9wDvHRMWnbjHVYzN",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1dKmasv2PcYJkJdiv90RUnM4dLh0oaQ5j",
      "b": "https://lh3.googleusercontent.com/d/1aOrUX1rfMDJuVmfyzt_zyxhk72ihOck3",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1MnxdXASbklAO8X5OZz17o0S9oG_s277m",
      "b": "https://lh3.googleusercontent.com/d/1HLmhQtj6BPBi7z1TDygPBASVLl4Vvdnq",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold2_DiamondReal_WhiteMatte_6030d276-c6db-481b-9957-9dd198713a67.jpg?v=1763766480"
   },
   "carat": 0.75,
   "caratMax": 6.25
  },
  {
   "rank": 437,
   "id": "gid://shopify/Product/9153145766072",
   "title": "1.40-6.90 CT Emerald & Round Cut Lab Grown Diamonds - Three Stone Rings",
   "url": "/products/three-stone-rings-15659lb",
   "handle": "three-stone-rings-15659lb",
   "priceNow": 1896.99,
   "priceWas": 5880.0,
   "pctOff": 68,
   "core": "15659",
   "inStock": true,
   "createdAt": "2024-07-05T14:12:54Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1JZy4i5v8wTdGjUrePACH7LmliwCjlJgu",
      "b": "https://lh3.googleusercontent.com/d/1WbZSxgw4OFpWtTZeQxoBTZIgJeupvUiu",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1loRHVQN_vbVykhfQYz1e0wsszNj0iU6s",
      "b": "https://lh3.googleusercontent.com/d/1slmtEHrZ2ZgQS-_n9CjZVfOlYdaFva6L",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1a1OMAl4EwbtK66M9tW0WurkeYw6XlmgK",
      "b": "https://lh3.googleusercontent.com/d/1XjT-MfnIDu-5uFQRfJoLDrBQMLYFAI2k",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold2_DiamondReal_WhiteMatte_a158e94a-83a2-46d2-a332-e69d9c277bfe.jpg?v=1763766479"
   },
   "carat": 1.4,
   "caratMax": 6.9
  },
  {
   "rank": 438,
   "id": "gid://shopify/Product/9153145274552",
   "title": "0.30 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-16027lb",
   "handle": "wedding-bands-16027lb",
   "priceNow": 916.99,
   "priceWas": 3120.0,
   "pctOff": 71,
   "core": "16027",
   "inStock": true,
   "createdAt": "2024-07-05T14:12:43Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1ydw7l6ynU7T13TSWOmei702-NbLaCrBd",
      "b": "https://lh3.googleusercontent.com/d/1Pn6-7AEepD2EM4UdkdE6ItjP3qRTEyUu",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/12OLGtS-2WM4kTv_ZtkI446JCtvd6W06g",
      "b": "https://lh3.googleusercontent.com/d/1IE00i3rgFlLKI2JPTXvsfyUfNCEwdCEO",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Ub2CUUaHTGlBLOPRzeH2Rdqm9DDYedc2",
      "b": "https://lh3.googleusercontent.com/d/1rZDmTCKTkrsLnspHNpMWdSFzoyyI4siY",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold2_DiamondReal_WhiteMatte_f59fd88d-e766-446d-8026-1a480781c7a2.jpg?v=1763697501"
   },
   "carat": 0.3
  },
  {
   "rank": 439,
   "id": "gid://shopify/Product/9153145012408",
   "title": "1.15-6.65 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110355lb",
   "handle": "bridal-sets-110355lb",
   "priceNow": 2240.99,
   "priceWas": 6950.0,
   "pctOff": 68,
   "core": "110355",
   "inStock": true,
   "createdAt": "2024-07-05T14:12:35Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/10vFkiI1-e7777c-uKZdUzTbmrmdS_pkw",
      "b": "https://lh3.googleusercontent.com/d/1uso4ceC7YOMIGccPYEnscTn9XZU6cK8M",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1gyNNn3X6bbqlVH-LSLoRHKjLWwLIJd0v",
      "b": "https://lh3.googleusercontent.com/d/1p8LwpWVwdfOARdOIyQmSG4CH8oNr6moO",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1T7S1gzuS1cs8ZTWLAxQV2n3agsHujst8",
      "b": "https://lh3.googleusercontent.com/d/1zq3dUqWRd9zAfn1igd4Oa4obuzYpx2k6",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold2_WhiteMatte_DiamondReal_bf8cf72c-17e1-48a9-b831-855722c4ce16.jpg?v=1720202671"
   },
   "carat": 1.15,
   "caratMax": 6.65
  },
  {
   "rank": 440,
   "id": "gid://shopify/Product/9153144520888",
   "title": "3.50-9.00 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-15678lb",
   "handle": "bridal-sets-15678lb",
   "priceNow": 4086.99,
   "priceWas": 12670.0,
   "pctOff": 68,
   "core": "15678",
   "inStock": true,
   "createdAt": "2024-07-05T14:12:24Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1zVQ2xj4QOaHpA5C7ixWk8EO6Kp5jxsDb",
      "b": "https://lh3.googleusercontent.com/d/1dGBwj6PokDQqcF1B3MGUqAVXGihLGCPV",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1oV4nWv_rE8P5Ca00YZU-P8Z7sF0qptLF",
      "b": "https://lh3.googleusercontent.com/d/1kK85tKiELIoe6z4M3_QrdFLQAqGAgvT5",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ZqnUEoApysfuAKL2JJpewrtGNN55YzBi",
      "b": "https://lh3.googleusercontent.com/d/15rVH276_JmzF0fHNiWsLA-JsdT7tF8t1",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold2_WhiteMatte_DiamondReal_6e174f1d-4887-49f5-a22e-9b84acbc4987.jpg?v=1720202233"
   },
   "carat": 3.5,
   "caratMax": 9.0
  },
  {
   "rank": 441,
   "id": "gid://shopify/Product/9153143472312",
   "title": "2.50-8.00 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-71604lb",
   "handle": "bridal-sets-71604lb",
   "priceNow": 3487.99,
   "priceWas": 10810.0,
   "pctOff": 68,
   "core": "71604",
   "inStock": true,
   "createdAt": "2024-07-05T14:11:49Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1h6BcI2NhHSd3WbE4DQ6zH-bkwd5-x51F",
      "b": "https://lh3.googleusercontent.com/d/159tYGgqHWgQVAqWdYIwxVMTI63Fgop4X",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/11ST6vgE9HEvbgQU8JOEJbNqEfPxrXYKq",
      "b": "https://lh3.googleusercontent.com/d/1jZkf-7CEfrb48XtXCSr9DkTIJ85wgSbg",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1-HWwu0Y_5fBQPTx2RrcUXm8VeajvVIMf",
      "b": "https://lh3.googleusercontent.com/d/1vIdS3Qu7ujpMlAYgCscWRuYdDpGaM9Rw",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA_3_proba_Perspective_Yellow_Gold2_White_Matte_Diamond_Real_e839f785-1933-434b-ae59-82880dd99e0d.jpg?v=1720201505"
   },
   "carat": 2.5,
   "caratMax": 8.0
  },
  {
   "rank": 442,
   "id": "gid://shopify/Product/9153143144632",
   "title": "1.10-6.60 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110326lb",
   "handle": "bridal-sets-110326lb",
   "priceNow": 4205.99,
   "priceWas": 13040.0,
   "pctOff": 68,
   "core": "110326",
   "inStock": true,
   "createdAt": "2024-07-05T14:11:37Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/19ZSUTVMOPs0PckPVk9E8h4ycwQ_-hnX6",
      "b": "https://lh3.googleusercontent.com/d/1nD_84IdyTgn87UUbj7tGdY1sAdREwIdX",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1mb-HnjBXxvHUsnqkn7rvhFWbY9xpXQwz",
      "b": "https://lh3.googleusercontent.com/d/1TaFNURBKhN3vmDTrSwZ0dolZ10bHO-U3",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1_1KEqyrtxWOq1_8DqIAUNNviRyozO3Pw",
      "b": "https://lh3.googleusercontent.com/d/1WapHAGKQhCcvjP-C1yHQ2hRca_tYjkip",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold2_WhiteMatte_DiamondReal_890e886b-f257-4b98-9762-9100b7e37132.jpg?v=1720201224"
   },
   "carat": 1.1,
   "caratMax": 6.6
  },
  {
   "rank": 443,
   "id": "gid://shopify/Product/9153142718648",
   "title": "0.95-6.45 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110348lb",
   "handle": "bridal-sets-110348lb",
   "priceNow": 6078.99,
   "priceWas": 17630.0,
   "pctOff": 66,
   "core": "110348",
   "inStock": true,
   "createdAt": "2024-07-05T14:11:25Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA_3_proba_Perspective_Yellow_Gold2_White_Matte_Diamond_Real_d2c69b6c-54b4-469f-9dc3-178db1e34508.jpg?v=1720200972",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA_3_proba_Perspective_Yellow_Gold2_White_Matte_Diamond_Real_d2c69b6c-54b4-469f-9dc3-178db1e34508.jpg?v=1720200972",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA_3_proba_Perspective_Yellow_Gold_White_Matte_Diamond_Real_481a8e18-52d2-4aa6-8ead-a541552a8234.jpg?v=1763697576",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA_3_proba_Perspective_Yellow_Gold1_White_Matte_Diamond_Real_1e020018-f804-49d9-8a47-615c29ac1baf.jpg?v=1763697576"
    }
   },
   "carat": 0.95,
   "caratMax": 6.45
  },
  {
   "rank": 444,
   "id": "gid://shopify/Product/9153142194360",
   "title": "1.60-7.10 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110350lb",
   "handle": "bridal-sets-110350lb",
   "priceNow": 3012.99,
   "priceWas": 9340.0,
   "pctOff": 68,
   "core": "110350",
   "inStock": true,
   "createdAt": "2024-07-05T14:11:12Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1bMJ4f5INERl453Y0hcXIMXupgwx1AnAY",
      "b": "https://lh3.googleusercontent.com/d/1TA9f81lISzD4k3vfcGFeerBCIT6f_rp2",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1whrr07DI4I2QbO4YGZKS0IXvZKyoU15S",
      "b": "https://lh3.googleusercontent.com/d/13JfYIm1HKVfnoR4_WvXP6RDCw3zn_lYk",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ySRvRoRk4vsrDFgMwncHxzxQRs6IWowr",
      "b": "https://lh3.googleusercontent.com/d/1lUmOg60OEU5p6kTSG1KJUKl1XuzCUoDj",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold2_WhiteMatte_DiamondReal.jpg?v=1763697576"
   },
   "carat": 1.6,
   "caratMax": 7.1
  },
  {
   "rank": 445,
   "id": "gid://shopify/Product/9126588809400",
   "title": "0.85-6.35 CT Round Cut Lab Grown Diamonds - Halo Rings",
   "url": "/products/halo-rings-21104lb",
   "handle": "halo-rings-21104lb",
   "priceNow": 1514.99,
   "priceWas": 4700.0,
   "pctOff": 68,
   "core": "21104",
   "inStock": true,
   "createdAt": "2024-06-17T17:57:43Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_fb97a15f-f846-4b26-bbf4-b3560a92308b.jpg?v=1763697576",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_fb97a15f-f846-4b26-bbf4-b3560a92308b.jpg?v=1763697576",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y2_1f9d3243-807f-4ed6-ada0-2a359e3cf881.jpg?v=1763697576",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r2_f0f0b270-b517-4513-a59b-833eccec79f8.jpg?v=1763697576"
    }
   },
   "carat": 0.85,
   "caratMax": 6.35
  },
  {
   "rank": 446,
   "id": "gid://shopify/Product/9126588678328",
   "title": "0.85-6.35 CT Princess & Round Cut Lab Grown Diamonds - Halo Rings",
   "url": "/products/halo-rings-21104lbpr",
   "handle": "halo-rings-21104lbpr",
   "priceNow": 1576.99,
   "priceWas": 4890.0,
   "pctOff": 68,
   "core": "21104",
   "inStock": true,
   "createdAt": "2024-06-17T17:57:36Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_aa26df71-c622-4512-99d0-4681e6f21654.jpg?v=1763697576",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_aa26df71-c622-4512-99d0-4681e6f21654.jpg?v=1763697576",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y2_72af0bc2-6823-4f7d-89c1-2c68bbf2bc4c.jpg?v=1763697576",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r2_0f5e4040-a363-4248-8b7b-d67ead1edd37.jpg?v=1763697576"
    }
   },
   "carat": 0.85,
   "caratMax": 6.35
  },
  {
   "rank": 447,
   "id": "gid://shopify/Product/9126588612792",
   "title": "0.85-6.35 CT Pear & Round Cut Lab Grown Diamonds - Halo Rings",
   "url": "/products/halo-rings-21104lbpe",
   "handle": "halo-rings-21104lbpe",
   "priceNow": 1519.99,
   "priceWas": 4710.0,
   "pctOff": 68,
   "core": "21104",
   "inStock": true,
   "createdAt": "2024-06-17T17:57:27Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_c5118882-9c60-474b-b545-243d05c9bfcc.jpg?v=1763697576",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_c5118882-9c60-474b-b545-243d05c9bfcc.jpg?v=1763697576",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y2_51085703-970a-4abc-bfc0-1c931a630159.jpg?v=1763697576",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r2_a82a3796-3854-43c0-bf31-944f2c4dc948.jpg?v=1763697576"
    }
   },
   "carat": 0.85,
   "caratMax": 6.35
  },
  {
   "rank": 448,
   "id": "gid://shopify/Product/9126588481720",
   "title": "0.85-6.35 CT Oval & Round Cut Lab Grown Diamonds - Halo Rings",
   "url": "/products/halo-rings-21104lbov",
   "handle": "halo-rings-21104lbov",
   "priceNow": 1531.99,
   "priceWas": 4750.0,
   "pctOff": 68,
   "core": "21104",
   "inStock": true,
   "createdAt": "2024-06-17T17:57:21Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_280f8537-382c-4de7-8ef2-041a7d714eef.jpg?v=1763697576",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_280f8537-382c-4de7-8ef2-041a7d714eef.jpg?v=1763697576",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y2_fb283e68-bff1-4ece-aa90-aa58f384e885.jpg?v=1763697576",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r2_04dab2e1-eedf-436d-9a15-19571db9ca3f.jpg?v=1763697576"
    }
   },
   "carat": 0.85,
   "caratMax": 6.35
  },
  {
   "rank": 449,
   "id": "gid://shopify/Product/9126588154040",
   "title": "0.85-6.35 CT Emerald & Round Cut Lab Grown Diamonds - Halo Rings",
   "url": "/products/halo-rings-21104lbem",
   "handle": "halo-rings-21104lbem",
   "priceNow": 1531.99,
   "priceWas": 4750.0,
   "pctOff": 68,
   "core": "21104",
   "inStock": true,
   "createdAt": "2024-06-17T17:57:13Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_dd5c5bfb-ad23-4846-9b09-7d54ee7680c6.jpg?v=1763697576",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_dd5c5bfb-ad23-4846-9b09-7d54ee7680c6.jpg?v=1763697576",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y2_88876e7b-a49f-4747-8735-237c3607e233.jpg?v=1763697576",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r2_2d8be7c3-4805-47c3-9639-16944b8d0000.jpg?v=1763697576"
    }
   },
   "carat": 0.85,
   "caratMax": 6.35
  },
  {
   "rank": 450,
   "id": "gid://shopify/Product/9126587859128",
   "title": "1.10-6.60 CT Round Cut Lab Grown Diamonds - Halo Rings",
   "url": "/products/halo-rings-21100lb",
   "handle": "halo-rings-21100lb",
   "priceNow": 2068.99,
   "priceWas": 6410.0,
   "pctOff": 68,
   "core": "21100",
   "inStock": true,
   "createdAt": "2024-06-17T17:57:04Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_8baee1db-306c-46c8-b363-4e03416a86d7.jpg?v=1763697577",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_8baee1db-306c-46c8-b363-4e03416a86d7.jpg?v=1763697577",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y2_59edda3b-41bc-41b9-a2d4-15ed6cdc3ff9.jpg?v=1763697576",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r2_8da3c3a3-f513-47da-bbc7-a0adfbf5bf63.jpg?v=1763697577"
    }
   },
   "carat": 1.1,
   "caratMax": 6.6
  },
  {
   "rank": 451,
   "id": "gid://shopify/Product/9126587629752",
   "title": "1.10-6.60 CT Princess & Round Cut Lab Grown Diamonds - Halo Rings",
   "url": "/products/halo-rings-21100lbpr",
   "handle": "halo-rings-21100lbpr",
   "priceNow": 2130.99,
   "priceWas": 6610.0,
   "pctOff": 68,
   "core": "21100",
   "inStock": true,
   "createdAt": "2024-06-17T17:56:58Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_5499beee-5476-4bc5-9799-4f4bd7e02e32.jpg?v=1718648564",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_5499beee-5476-4bc5-9799-4f4bd7e02e32.jpg?v=1718648564",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y2_fcbfdfcc-4b01-4392-9c74-b63d8b28cfd5.jpg?v=1763697577",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r2_8c14d26e-df5b-473d-8f8e-32be5490c51b.jpg?v=1763697577"
    }
   },
   "carat": 1.1,
   "caratMax": 6.6
  },
  {
   "rank": 452,
   "id": "gid://shopify/Product/9126587400376",
   "title": "1.10-6.60 CT Pear & Round Cut Lab Grown Diamonds - Halo Rings",
   "url": "/products/halo-rings-21100lbpe",
   "handle": "halo-rings-21100lbpe",
   "priceNow": 2074.99,
   "priceWas": 6430.0,
   "pctOff": 68,
   "core": "21100",
   "inStock": true,
   "createdAt": "2024-06-17T17:56:51Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_db92779b-a248-44e2-b5c0-fb8af9b427cd.jpg?v=1763697577",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_db92779b-a248-44e2-b5c0-fb8af9b427cd.jpg?v=1763697577",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y2_91d48e5b-5d08-4056-a3d2-24d04fc66db1.jpg?v=1763697577",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r2_783cb910-9f2e-434b-a0e4-2fb8f242208f.jpg?v=1763697577"
    }
   },
   "carat": 1.1,
   "caratMax": 6.6
  },
  {
   "rank": 453,
   "id": "gid://shopify/Product/9126587007160",
   "title": "1.10-6.60 CT Oval & Round Cut Lab Grown Diamonds - Halo Rings",
   "url": "/products/halo-rings-21100lbov",
   "handle": "halo-rings-21100lbov",
   "priceNow": 2085.99,
   "priceWas": 6470.0,
   "pctOff": 68,
   "core": "21100",
   "inStock": true,
   "createdAt": "2024-06-17T17:56:38Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_565f0700-65df-48c1-8cd3-dbfb98806757.jpg?v=1763697577",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_565f0700-65df-48c1-8cd3-dbfb98806757.jpg?v=1763697577",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y2_162b2574-d986-459e-b629-cd9a46ae3e58.jpg?v=1763697577",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r2_68315a5f-4e5d-4c0c-810a-22ce9836dfa8.jpg?v=1763697577"
    }
   },
   "carat": 1.1,
   "caratMax": 6.6
  },
  {
   "rank": 454,
   "id": "gid://shopify/Product/9126586646712",
   "title": "1.10-6.60 CT Emerald & Round Cut Lab Grown Diamonds - Halo Rings",
   "url": "/products/halo-rings-21100lbem",
   "handle": "halo-rings-21100lbem",
   "priceNow": 2085.99,
   "priceWas": 6470.0,
   "pctOff": 68,
   "core": "21100",
   "inStock": true,
   "createdAt": "2024-06-17T17:56:26Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_1a5fb6d6-ec97-42ef-a953-c38bc0c70551.jpg?v=1763697577",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_1a5fb6d6-ec97-42ef-a953-c38bc0c70551.jpg?v=1763697577",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y2_828d3959-fd44-4d9a-9567-3a32a3b05295.jpg?v=1763697577",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r2_681fa55d-6309-4713-b3fc-206d214bee84.jpg?v=1763697577"
    }
   },
   "carat": 1.1,
   "caratMax": 6.6
  },
  {
   "rank": 455,
   "id": "gid://shopify/Product/9122831237304",
   "title": "0.95-6.45 CT Princess & Round Cut Lab Grown Diamonds - Three Stone Rings",
   "url": "/products/three-stone-rings-21099lbpr",
   "handle": "three-stone-rings-21099lbpr",
   "priceNow": 1498.99,
   "priceWas": 4650.0,
   "pctOff": 68,
   "core": "21099",
   "inStock": true,
   "createdAt": "2024-06-13T18:25:21Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_d7be209a-e8cf-49a0-ac7c-94b1c486b7c5.jpg?v=1763766475",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_d7be209a-e8cf-49a0-ac7c-94b1c486b7c5.jpg?v=1763766475",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y2_407e9b86-1f59-42a9-93af-26a388cd0dc1.jpg?v=1763766477",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r2_3c9af63e-8a3b-4453-b02e-21d162275020.jpg?v=1763766479"
    }
   },
   "carat": 0.95,
   "caratMax": 6.45
  },
  {
   "rank": 456,
   "id": "gid://shopify/Product/9122831073464",
   "title": "0.95-6.45 CT Pear & Round Cut Lab Grown Diamonds - Three Stone Rings",
   "url": "/products/three-stone-rings-21099lbpe",
   "handle": "three-stone-rings-21099lbpe",
   "priceNow": 1442.99,
   "priceWas": 4470.0,
   "pctOff": 68,
   "core": "21099",
   "inStock": true,
   "createdAt": "2024-06-13T18:25:12Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_087c2d67-8ae3-4ac1-961e-184f8aecf78d.jpg?v=1763766480",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_087c2d67-8ae3-4ac1-961e-184f8aecf78d.jpg?v=1763766480",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y2_588424ee-25f8-4e54-bf5d-2f5b05c9aa44.jpg?v=1763766483",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r2_170adb06-4140-4544-9eea-eb56aed5dd9b.jpg?v=1763766485"
    }
   },
   "carat": 0.95,
   "caratMax": 6.45
  },
  {
   "rank": 457,
   "id": "gid://shopify/Product/9122830975160",
   "title": "0.95-6.45 CT Oval & Round Cut Lab Grown Diamonds - Three Stone Rings",
   "url": "/products/three-stone-rings-21099lbov",
   "handle": "three-stone-rings-21099lbov",
   "priceNow": 1453.99,
   "priceWas": 4510.0,
   "pctOff": 68,
   "core": "21099",
   "inStock": true,
   "createdAt": "2024-06-13T18:24:59Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_c70903fa-600e-453c-b7bb-8b41e31f1222.jpg?v=1763766479",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_c70903fa-600e-453c-b7bb-8b41e31f1222.jpg?v=1763766479",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y2_b7eafcab-46c0-4b71-9f5a-0067559159d2.jpg?v=1763766481",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r2_e7526963-180f-4e0a-a44a-21123e0ea791.jpg?v=1763766483"
    }
   },
   "carat": 0.95,
   "caratMax": 6.45
  },
  {
   "rank": 458,
   "id": "gid://shopify/Product/9122830844088",
   "title": "0.95-6.45 CT Emerald & Round Cut Lab Grown Diamonds - Three Stone Rings",
   "url": "/products/three-stone-rings-21099lbem",
   "handle": "three-stone-rings-21099lbem",
   "priceNow": 1453.99,
   "priceWas": 4510.0,
   "pctOff": 68,
   "core": "21099",
   "inStock": true,
   "createdAt": "2024-06-13T18:24:49Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_e439128b-7d93-47c6-98c4-87d9cdb3d783.jpg?v=1763766478",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_e439128b-7d93-47c6-98c4-87d9cdb3d783.jpg?v=1763766478",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y2_b7e00e6f-e9b7-4a94-a3b9-ba5eeedf736e.jpg?v=1763766480",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r2_02529764-5079-4d6a-b8f9-b3c31ecf5905.jpg?v=1763766482"
    }
   },
   "carat": 0.95,
   "caratMax": 6.45
  },
  {
   "rank": 459,
   "id": "gid://shopify/Product/9122830647480",
   "title": "0.50-6.00 CT Round Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-21098lb",
   "handle": "solitaire-rings-21098lb",
   "priceNow": 1434.99,
   "priceWas": 4450.0,
   "pctOff": 68,
   "core": "21098",
   "inStock": true,
   "createdAt": "2024-06-13T18:24:42Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_36085ebe-1a12-4804-9248-e48a14fa8ae5.jpg?v=1763748623"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 460,
   "id": "gid://shopify/Product/9122830155960",
   "title": "0.50-6.00 CT Pear Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-21098lbpe",
   "handle": "solitaire-rings-21098lbpe",
   "priceNow": 1440.99,
   "priceWas": 4470.0,
   "pctOff": 68,
   "core": "21098",
   "inStock": true,
   "createdAt": "2024-06-13T18:24:27Z",
   "shape": "pear",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_6eeba376-339e-44c8-9a53-1ca491ff352e.jpg?v=1763748612"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 461,
   "id": "gid://shopify/Product/9122830024888",
   "title": "0.50-6.00 CT Oval Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-21098lbov",
   "handle": "solitaire-rings-21098lbov",
   "priceNow": 1451.99,
   "priceWas": 4500.0,
   "pctOff": 68,
   "core": "21098",
   "inStock": true,
   "createdAt": "2024-06-13T18:24:19Z",
   "shape": "oval",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_740020d3-f081-4dcf-bc24-78a405e1d6fc.jpg?v=1763748621"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 462,
   "id": "gid://shopify/Product/9122829959352",
   "title": "0.50-6.00 CT Emerald Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-21098lbem",
   "handle": "solitaire-rings-21098lbem",
   "priceNow": 1451.99,
   "priceWas": 4500.0,
   "pctOff": 68,
   "core": "21098",
   "inStock": true,
   "createdAt": "2024-06-13T18:24:10Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_64cae36a-a0e4-4d5b-ab46-2bf4d4983874.jpg?v=1763748612"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 463,
   "id": "gid://shopify/Product/9122816360632",
   "title": "1.15-6.65 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-21097lb",
   "handle": "engagement-rings-21097lb",
   "priceNow": 1953.99,
   "priceWas": 6060.0,
   "pctOff": 68,
   "core": "21097",
   "inStock": true,
   "createdAt": "2024-06-13T17:54:58Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_73e4c2c4-51ff-461a-8aa2-13f7d348b2a2.jpg?v=1765415408",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_73e4c2c4-51ff-461a-8aa2-13f7d348b2a2.jpg?v=1765415408",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y2_8bf57ed8-bd52-4296-bbcc-4e2fd7df1675.jpg?v=1765415411",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r2_92b859b6-a6cf-4118-9580-73ffb3ce01cb.jpg?v=1765415413"
    }
   },
   "carat": 1.15,
   "caratMax": 6.65
  },
  {
   "rank": 464,
   "id": "gid://shopify/Product/9122816295096",
   "title": "1.15-6.65 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-21097lbpr",
   "handle": "engagement-rings-21097lbpr",
   "priceNow": 2014.99,
   "priceWas": 6250.0,
   "pctOff": 68,
   "core": "21097",
   "inStock": true,
   "createdAt": "2024-06-13T17:54:53Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_d037bd20-5f65-4a77-bb08-75e17fc2b05c.jpg?v=1765415407",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_d037bd20-5f65-4a77-bb08-75e17fc2b05c.jpg?v=1765415407",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y2_145d67ce-e090-4ff3-b9c2-f7f5160edbd3.jpg?v=1765415410",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r2_6ef1be9b-5ecf-4c3e-b8c4-ede679761cfe.jpg?v=1765415412"
    }
   },
   "carat": 1.15,
   "caratMax": 6.65
  },
  {
   "rank": 465,
   "id": "gid://shopify/Product/9122816196792",
   "title": "1.15-6.65 CT Pear & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-21097lbpe",
   "handle": "engagement-rings-21097lbpe",
   "priceNow": 1958.99,
   "priceWas": 6070.0,
   "pctOff": 68,
   "core": "21097",
   "inStock": true,
   "createdAt": "2024-06-13T17:54:44Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_9ac1472b-8734-43d3-bee2-07fed5898273.jpg?v=1765415409",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_9ac1472b-8734-43d3-bee2-07fed5898273.jpg?v=1765415409",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y2_7573483c-d316-46d3-b948-19c6c990de7e.jpg?v=1765415412",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r2_22b32bb9-0ffc-4ef1-b2fa-54d6e39afe95.jpg?v=1765415414"
    }
   },
   "carat": 1.15,
   "caratMax": 6.65
  },
  {
   "rank": 466,
   "id": "gid://shopify/Product/9122816065720",
   "title": "1.15-6.65 CT Oval & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-21097lbov",
   "handle": "engagement-rings-21097lbov",
   "priceNow": 1969.99,
   "priceWas": 6110.0,
   "pctOff": 68,
   "core": "21097",
   "inStock": true,
   "createdAt": "2024-06-13T17:54:36Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_cad1e315-1e6a-4546-899b-5764bd518b00.jpg?v=1765415408",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_cad1e315-1e6a-4546-899b-5764bd518b00.jpg?v=1765415408",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y2_605ba86f-4ce7-4554-bc93-838945e8ae8f.jpg?v=1765415411",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r2_521e046c-49af-4f4f-b78a-e5f82654f185.jpg?v=1765415413"
    }
   },
   "carat": 1.15,
   "caratMax": 6.65
  },
  {
   "rank": 467,
   "id": "gid://shopify/Product/9122815934648",
   "title": "1.15-6.65 CT Emerald & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-21097lbem",
   "handle": "engagement-rings-21097lbem",
   "priceNow": 1969.99,
   "priceWas": 6110.0,
   "pctOff": 68,
   "core": "21097",
   "inStock": true,
   "createdAt": "2024-06-13T17:54:26Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_f30988c6-35e4-44fc-87d9-dcde73345082.jpg?v=1765415408",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_f30988c6-35e4-44fc-87d9-dcde73345082.jpg?v=1765415408",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y2_9de521af-d738-43f1-8c42-83560982eb67.jpg?v=1765415410",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r2_e2ddee5d-780a-4c3a-a77f-9e777b092e23.jpg?v=1765415412"
    }
   },
   "carat": 1.15,
   "caratMax": 6.65
  },
  {
   "rank": 468,
   "id": "gid://shopify/Product/9121661681848",
   "title": "0.95-6.45 CT Round Cut Lab Grown Diamonds - Halo Rings",
   "url": "/products/halo-rings-21095lb",
   "handle": "halo-rings-21095lb",
   "priceNow": 1694.99,
   "priceWas": 5250.0,
   "pctOff": 68,
   "core": "21095",
   "inStock": true,
   "createdAt": "2024-06-12T18:43:25Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/12J7BcHj5Sa6Mff_n5vcOoWCFY3dF6_04",
      "b": "https://lh3.googleusercontent.com/d/1tCre8_fLj5os6Aw_bbDmNl8BnDOS1xkg",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/18Yd6kfApF0BqFoaCip7FxiXESfn8c8sE",
      "b": "https://lh3.googleusercontent.com/d/1bMJBw34ZRLOvNI6mMs0Ohr2l8YlfZ6_g",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1WH5L0_tKe_AyPQSmqpnPFhlymcNvL_0f",
      "b": "https://lh3.googleusercontent.com/d/1yiGJEju2HhJdMTQngYbSWv2qyTML098t",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_adeb4446-eced-45e2-8067-54a61f1117e6.jpg?v=1763697633"
   },
   "carat": 0.95,
   "caratMax": 6.45
  },
  {
   "rank": 469,
   "id": "gid://shopify/Product/9121661649080",
   "title": "0.95-6.45 CT Princess & Round Cut Lab Grown Diamonds - Halo Rings",
   "url": "/products/halo-rings-21095lbpr",
   "handle": "halo-rings-21095lbpr",
   "priceNow": 1756.99,
   "priceWas": 5450.0,
   "pctOff": 68,
   "core": "21095",
   "inStock": true,
   "createdAt": "2024-06-12T18:43:15Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/12J7BcHj5Sa6Mff_n5vcOoWCFY3dF6_04",
      "b": "https://lh3.googleusercontent.com/d/1tCre8_fLj5os6Aw_bbDmNl8BnDOS1xkg",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/18Yd6kfApF0BqFoaCip7FxiXESfn8c8sE",
      "b": "https://lh3.googleusercontent.com/d/1bMJBw34ZRLOvNI6mMs0Ohr2l8YlfZ6_g",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1WH5L0_tKe_AyPQSmqpnPFhlymcNvL_0f",
      "b": "https://lh3.googleusercontent.com/d/1yiGJEju2HhJdMTQngYbSWv2qyTML098t",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_84c352be-be79-4ed8-b1e6-75381f40d5d8.jpg?v=1763697632"
   },
   "carat": 0.95,
   "caratMax": 6.45
  },
  {
   "rank": 470,
   "id": "gid://shopify/Product/9121661583544",
   "title": "0.95-6.45 CT Pear & Round Cut Lab Grown Diamonds - Halo Rings",
   "url": "/products/halo-rings-21095lbpe",
   "handle": "halo-rings-21095lbpe",
   "priceNow": 1699.99,
   "priceWas": 5270.0,
   "pctOff": 68,
   "core": "21095",
   "inStock": true,
   "createdAt": "2024-06-12T18:43:07Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/12J7BcHj5Sa6Mff_n5vcOoWCFY3dF6_04",
      "b": "https://lh3.googleusercontent.com/d/1tCre8_fLj5os6Aw_bbDmNl8BnDOS1xkg",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/18Yd6kfApF0BqFoaCip7FxiXESfn8c8sE",
      "b": "https://lh3.googleusercontent.com/d/1bMJBw34ZRLOvNI6mMs0Ohr2l8YlfZ6_g",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1WH5L0_tKe_AyPQSmqpnPFhlymcNvL_0f",
      "b": "https://lh3.googleusercontent.com/d/1yiGJEju2HhJdMTQngYbSWv2qyTML098t",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_7d08e513-2830-4c4b-bc98-b17fe53c4245.jpg?v=1763697633"
   },
   "carat": 0.95,
   "caratMax": 6.45
  },
  {
   "rank": 471,
   "id": "gid://shopify/Product/9121661485240",
   "title": "0.95-6.45 CT Oval & Round Cut Lab Grown Diamonds - Halo Rings",
   "url": "/products/halo-rings-21095lbov",
   "handle": "halo-rings-21095lbov",
   "priceNow": 1711.99,
   "priceWas": 5310.0,
   "pctOff": 68,
   "core": "21095",
   "inStock": true,
   "createdAt": "2024-06-12T18:42:57Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/12J7BcHj5Sa6Mff_n5vcOoWCFY3dF6_04",
      "b": "https://lh3.googleusercontent.com/d/1tCre8_fLj5os6Aw_bbDmNl8BnDOS1xkg",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/18Yd6kfApF0BqFoaCip7FxiXESfn8c8sE",
      "b": "https://lh3.googleusercontent.com/d/1bMJBw34ZRLOvNI6mMs0Ohr2l8YlfZ6_g",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1WH5L0_tKe_AyPQSmqpnPFhlymcNvL_0f",
      "b": "https://lh3.googleusercontent.com/d/1yiGJEju2HhJdMTQngYbSWv2qyTML098t",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_4e62d636-6db4-4982-b55f-869ee28cdc34.jpg?v=1763697632"
   },
   "carat": 0.95,
   "caratMax": 6.45
  },
  {
   "rank": 472,
   "id": "gid://shopify/Product/9121661452472",
   "title": "0.95-6.45 CT Emerald & Round Cut Lab Grown Diamonds - Halo Rings",
   "url": "/products/halo-rings-21095lbem",
   "handle": "halo-rings-21095lbem",
   "priceNow": 1711.99,
   "priceWas": 5310.0,
   "pctOff": 68,
   "core": "21095",
   "inStock": true,
   "createdAt": "2024-06-12T18:42:46Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/12J7BcHj5Sa6Mff_n5vcOoWCFY3dF6_04",
      "b": "https://lh3.googleusercontent.com/d/1tCre8_fLj5os6Aw_bbDmNl8BnDOS1xkg",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/18Yd6kfApF0BqFoaCip7FxiXESfn8c8sE",
      "b": "https://lh3.googleusercontent.com/d/1bMJBw34ZRLOvNI6mMs0Ohr2l8YlfZ6_g",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1WH5L0_tKe_AyPQSmqpnPFhlymcNvL_0f",
      "b": "https://lh3.googleusercontent.com/d/1yiGJEju2HhJdMTQngYbSWv2qyTML098t",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_cd0eaa4f-a7f3-4731-aad3-a8014ff9b55e.jpg?v=1763697632"
   },
   "carat": 0.95,
   "caratMax": 6.45
  },
  {
   "rank": 473,
   "id": "gid://shopify/Product/9121636810936",
   "title": "0.50-6.00 CT Princess Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-21103lbpr",
   "handle": "solitaire-rings-21103lbpr",
   "priceNow": 1372.99,
   "priceWas": 4260.0,
   "pctOff": 68,
   "core": "21103",
   "inStock": true,
   "createdAt": "2024-06-12T17:56:01Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_f516dd46-258a-4c0b-92de-f3b01cfd60a9.jpg?v=1763748614"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 474,
   "id": "gid://shopify/Product/9121636745400",
   "title": "0.50-6.00 CT Pear Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-21103lbpe",
   "handle": "solitaire-rings-21103lbpe",
   "priceNow": 1316.99,
   "priceWas": 4080.0,
   "pctOff": 68,
   "core": "21103",
   "inStock": true,
   "createdAt": "2024-06-12T17:55:54Z",
   "shape": "pear",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_03e02bb2-81b5-41e7-b9e6-92e92b6aad70.jpg?v=1763748611"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 475,
   "id": "gid://shopify/Product/9121636581560",
   "title": "0.50-6.00 CT Emerald Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-21103lbem",
   "handle": "solitaire-rings-21103lbem",
   "priceNow": 1327.99,
   "priceWas": 4120.0,
   "pctOff": 68,
   "core": "21103",
   "inStock": true,
   "createdAt": "2024-06-12T17:55:37Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_a827a4a6-b991-4877-a62f-6ad3d2b16f3b.jpg?v=1763748611"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 476,
   "id": "gid://shopify/Product/9121636450488",
   "title": "0.85-6.35 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-21102lb",
   "handle": "engagement-rings-21102lb",
   "priceNow": 1482.99,
   "priceWas": 4600.0,
   "pctOff": 68,
   "core": "21102",
   "inStock": true,
   "createdAt": "2024-06-12T17:55:27Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_ab4d783e-c248-4a39-8d2f-3d5fc0ae7e17.jpg?v=1765415408",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_ab4d783e-c248-4a39-8d2f-3d5fc0ae7e17.jpg?v=1765415408",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y2_0417ec41-6884-4ea5-bda1-96136c5a8e9b.jpg?v=1765415410",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r2_5762a0d0-1c38-4b5b-849b-6434a9f1c89e.jpg?v=1765415413"
    }
   },
   "carat": 0.85,
   "caratMax": 6.35
  },
  {
   "rank": 477,
   "id": "gid://shopify/Product/9121636384952",
   "title": "0.85-6.35 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-21102lbpr",
   "handle": "engagement-rings-21102lbpr",
   "priceNow": 1544.99,
   "priceWas": 4790.0,
   "pctOff": 68,
   "core": "21102",
   "inStock": true,
   "createdAt": "2024-06-12T17:55:19Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_f8bda034-02f0-43c2-9727-8d25260c9513.jpg?v=1765415407",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_f8bda034-02f0-43c2-9727-8d25260c9513.jpg?v=1765415407",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y2_21c79f1b-307b-49d9-9030-e1af3d98c04e.jpg?v=1765415410",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r2_6a905a81-7978-41df-b340-f4a282bea094.jpg?v=1765415412"
    }
   },
   "carat": 0.85,
   "caratMax": 6.35
  },
  {
   "rank": 478,
   "id": "gid://shopify/Product/9121636286648",
   "title": "0.85-6.35 CT Pear & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-21102lbpe",
   "handle": "engagement-rings-21102lbpe",
   "priceNow": 1488.99,
   "priceWas": 4620.0,
   "pctOff": 68,
   "core": "21102",
   "inStock": true,
   "createdAt": "2024-06-12T17:55:06Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_8351041a-19e0-49f3-b8ee-34bda6dfbd2f.jpg?v=1765415410",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_8351041a-19e0-49f3-b8ee-34bda6dfbd2f.jpg?v=1765415410",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y2_a9dc13fb-1b80-4749-9aa3-a39409692d64.jpg?v=1765415412",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r2_a24d9c60-104f-4ec5-8fb7-1dee16259e6b.jpg?v=1765415414"
    }
   },
   "carat": 0.85,
   "caratMax": 6.35
  },
  {
   "rank": 479,
   "id": "gid://shopify/Product/9106074271928",
   "title": "1.05-6.55 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-15230lb",
   "handle": "engagement-rings-15230lb",
   "priceNow": 2094.99,
   "priceWas": 6490.0,
   "pctOff": 68,
   "core": "15230",
   "inStock": true,
   "createdAt": "2024-06-05T15:30:57Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1CVZsMWuavIZylVz8Qoa9uaOj8Z_w0-N2",
      "b": "https://lh3.googleusercontent.com/d/1aqq6v2RGIgu35WGPTVmSgz8FEVG3Uxac",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1HQDQ-65rNVRw16nzm6GNsnR7wkaLqiYO",
      "b": "https://lh3.googleusercontent.com/d/16R5YXDc1ce6tyRg0aJNFUirxqLbSO2hk",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1gk6E0da_PMaELNIJ-O69Bs9BWnqf5Yiy",
      "b": "https://lh3.googleusercontent.com/d/1j4HWbVZymwuvdBnG63uTh6xmjJm2IDgd",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_Diamond_YellowGold2_WhiteMatte_YellowGold_09ce62f8-d9c5-4d34-aedd-81c79117a100.jpg?v=1765415409"
   },
   "carat": 1.05,
   "caratMax": 6.55
  },
  {
   "rank": 480,
   "id": "gid://shopify/Product/9106074140856",
   "title": "2.05-7.55 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-15335lb",
   "handle": "bridal-sets-15335lb",
   "priceNow": 3251.99,
   "priceWas": 10080.0,
   "pctOff": 68,
   "core": "15335",
   "inStock": true,
   "createdAt": "2024-06-05T15:30:51Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1MWO-6w8XuYZ8JEe0Z_l1KprstB0X0gwg",
      "b": "https://lh3.googleusercontent.com/d/18FmyGn3AYkSgLtOTXU1Km0ZK6ottEg_s",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1PzQbi4aYr8sn62Y3Vbahri_fGVoOlN7h",
      "b": "https://lh3.googleusercontent.com/d/1hJMsQIPfe63zg9Q0mbahFcOfIXCAxYFu",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Tf-k5lt4yqZPMZ93WD1oZb_sBlsXtGn7",
      "b": "https://lh3.googleusercontent.com/d/1Xn9jpA9gvNNq_P3LkgHFckMssLb0d7Df",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_Diamond_YellowGold2_WhiteMatte_Diamond_9c979699-49bc-4288-9d06-87cb62bddaff.jpg?v=1763697638"
   },
   "carat": 2.05,
   "caratMax": 7.55
  },
  {
   "rank": 481,
   "id": "gid://shopify/Product/9106074075320",
   "title": "1.90-7.40 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-15337lb",
   "handle": "bridal-sets-15337lb",
   "priceNow": 3109.99,
   "priceWas": 9640.0,
   "pctOff": 68,
   "core": "15337",
   "inStock": true,
   "createdAt": "2024-06-05T15:30:45Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1YmTDnR1gPmbP_cUrKAAcbW-gcYm_hisL",
      "b": "https://lh3.googleusercontent.com/d/1xCUWRxeuMc7MiAiVhU2hlT3rg3IUGtsT",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1b4amuE9YkpWxkO65sbBL5VMMejuuu1r6",
      "b": "https://lh3.googleusercontent.com/d/1uZqofg7-zTB-1ry1O70KbEMvdxqUAQZp",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1sN6kYRoe1cyaVpJnq0YosIsz7ntg6E8j",
      "b": "https://lh3.googleusercontent.com/d/1kQc4cV4Ae17myXA7VwVwjoD2AiKw6B1Q",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_Diamond_YellowGold2_WhiteMatte_14fd98b0-5be7-4f24-9621-66d41107b690.jpg?v=1763697638"
   },
   "carat": 1.9,
   "caratMax": 7.4
  },
  {
   "rank": 482,
   "id": "gid://shopify/Product/9106073944248",
   "title": "0.50-6.00 CT Princess Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-16273lb",
   "handle": "solitaire-rings-16273lb",
   "priceNow": 2171.99,
   "priceWas": 6730.0,
   "pctOff": 68,
   "core": "16273",
   "inStock": true,
   "createdAt": "2024-06-05T15:30:31Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1uHHXjItzbWJI584nGkP0u_gQDyQOYgxw",
      "b": "https://lh3.googleusercontent.com/d/1F8Em1nekvJxnQNvYH--qHoV0Ho34xVyu",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1c38a7RRGVNLGbQe1Zv7cm0AAojkk9fuf",
      "b": "https://lh3.googleusercontent.com/d/1TrTS1XTv1P4L_PF9l5sZXGwFefmXDSVC",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Xb0ozqJ52C8eK5OK2BvQu3joxQFyWMCy",
      "b": "https://lh3.googleusercontent.com/d/1ATQV9CoYwApaCHdI6dy6ZcMtpma6uRIK",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_Diamond_YellowGold2_WhiteMatte_8556ec9b-7aae-4047-b2c9-85b3ceccc0b1.jpg?v=1763748628"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 483,
   "id": "gid://shopify/Product/9106073813176",
   "title": "0.50-6.00 CT Marquise Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-16274lb",
   "handle": "solitaire-rings-16274lb",
   "priceNow": 2193.99,
   "priceWas": 6800.0,
   "pctOff": 68,
   "core": "16274",
   "inStock": true,
   "createdAt": "2024-06-05T15:30:25Z",
   "shape": "marquise",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1xDenNb9qlBcJpku4aajW-tk3J_XjtBGa",
      "b": "https://lh3.googleusercontent.com/d/1xWrWvUgd99cnGRk-AEh48-sbuaE3XHFO",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/11kG5bZk7lP524oDomH29s7m4yEdwI4nH",
      "b": "https://lh3.googleusercontent.com/d/16gG1vLdvMZOnuASp-2_WAgHCl3l1plF9",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1XeJCqH-hRLaHPVMnRmDJe0kI9ePLAxwi",
      "b": "https://lh3.googleusercontent.com/d/13Pja7SsXgaYEuFv3w3EboHRog9Jkvjvg",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_Diamond_YellowGold2_WhiteMatte_412a6a32-e4b1-4195-b173-b27f57d46992.jpg?v=1763748616"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 484,
   "id": "gid://shopify/Product/9106073649336",
   "title": "0.90-6.40 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110405lb",
   "handle": "bridal-sets-110405lb",
   "priceNow": 2531.99,
   "priceWas": 7850.0,
   "pctOff": 68,
   "core": "110405",
   "inStock": true,
   "createdAt": "2024-06-05T15:30:09Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1uuKKSEWtsryr_vxTBEq9aFUSroe8ABns",
      "b": "https://lh3.googleusercontent.com/d/1wT3fFkN9Qio5Oa1gStqpsAZ39A-zsS76",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1X-DvoJFml-TRkV77RvcfllQ4QMH1HhXQ",
      "b": "https://lh3.googleusercontent.com/d/1jvcOOIrQMz9IeKRAjoi4IdqevLbY50wV",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1JXkI2uCdZUCLAlshHCTP-CzalhhqHTx7",
      "b": "https://lh3.googleusercontent.com/d/1Le1X3hXgurXE02X0BcUmIzK1Tc5GVue9",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_Diamond_YellowGold2_WhiteMatte_1a65d5c2-f4c4-40e0-af36-dcde1893cef4.jpg?v=1717698160"
   },
   "carat": 0.9,
   "caratMax": 6.4
  },
  {
   "rank": 485,
   "id": "gid://shopify/Product/9106073518264",
   "title": "1.90-7.40 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-15333lb",
   "handle": "bridal-sets-15333lb",
   "priceNow": 3384.99,
   "priceWas": 10490.0,
   "pctOff": 68,
   "core": "15333",
   "inStock": true,
   "createdAt": "2024-06-05T15:29:56Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1CDFO8hSnbCWD1AqjZXuc6ouinxauAccx",
      "b": "https://lh3.googleusercontent.com/d/1l6N5GIxlXUgIadY59L_XQk9rPG7WQ_y6",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1wTxo81XNSkBDM88gWytttTLTOebKmBsK",
      "b": "https://lh3.googleusercontent.com/d/1t1GP-mjavcTGubl2Rw843ALKnnAENR_I",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1u5ECWufEn0ecY_tzoWEybXNh76hj2cbf",
      "b": "https://lh3.googleusercontent.com/d/1Vok88q6NiRnMoEh0Sd-emM6vn708x9a4",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_Diamond_YellowGold2_WhiteMatte_0c23d18e-5e4f-4b23-98c8-ebf48224c5a6.jpg?v=1763697639"
   },
   "carat": 1.9,
   "caratMax": 7.4
  },
  {
   "rank": 486,
   "id": "gid://shopify/Product/9106073452728",
   "title": "1.35-6.85 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-15334lb",
   "handle": "bridal-sets-15334lb",
   "priceNow": 3356.99,
   "priceWas": 10410.0,
   "pctOff": 68,
   "core": "15334",
   "inStock": true,
   "createdAt": "2024-06-05T15:29:48Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1xd-zjjM6tkrsa8s5uM79GVoAnUbtbhiv",
      "b": "https://lh3.googleusercontent.com/d/1_Y9UiYj0LRHLtLigp2Gl5RCxJYIi8zZN",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1latkQRvndHKSdSVfR4aZXfmJ5suRrrMx",
      "b": "https://lh3.googleusercontent.com/d/1aTe-MyVXYmrXlL6m10iIKg3n-0yKGIhC",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1qMBvFkT3XOoq8L29KQQf7dTOh2bpx7NL",
      "b": "https://lh3.googleusercontent.com/d/1CLsL5vmrj2OIZ_UTZnW8iMTIyizs9GeQ",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_Diamond_YellowGold2_WhiteMatte_4ddd954d-4a00-4fe7-a8a9-400fdcf82721.jpg?v=1763697639"
   },
   "carat": 1.35,
   "caratMax": 6.85
  },
  {
   "rank": 487,
   "id": "gid://shopify/Product/9106073354424",
   "title": "0.50-6.00 CT Emerald Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-15401lb",
   "handle": "solitaire-rings-15401lb",
   "priceNow": 1575.99,
   "priceWas": 4890.0,
   "pctOff": 68,
   "core": "15401",
   "inStock": true,
   "createdAt": "2024-06-05T15:29:41Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1jxOKThtV06mSA5YRYhCVvL9fMUBi-5vB",
      "b": "https://lh3.googleusercontent.com/d/1DTp1NWoqekeQd0hrqDCGneAnJVH67QPr",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1IkypipyE2sJFFX35mhMvwtAlL7U_cjSV",
      "b": "https://lh3.googleusercontent.com/d/1hQywzLr2ARYmoB0pif6xW0JVkoItjiye",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1WYNQZdxXXMj9sFZovl9whf_ii3BrwJZp",
      "b": "https://lh3.googleusercontent.com/d/1iUHwPqjsEB3Fj82qAVT22dsxXSyl086y",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_Diamond_YellowGold2_WhiteMatte_b68408df-e8e0-4ebc-b67a-13ab7e9f617b.jpg?v=1763748613"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 488,
   "id": "gid://shopify/Product/9106073288888",
   "title": "0.50-6.00 CT Princess Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-15611lb",
   "handle": "solitaire-rings-15611lb",
   "priceNow": 1743.99,
   "priceWas": 5410.0,
   "pctOff": 68,
   "core": "15611",
   "inStock": true,
   "createdAt": "2024-06-05T15:29:35Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1vuAZlBvgOU2qrTmzDbqJ-uwoLcDvp1LN",
      "b": "https://lh3.googleusercontent.com/d/17N936qg9F6Fpkt5kD6JG2z1u6UXdK1tq",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1KTdy1CNzg3Z6kJyYIZ9pxqrGvDDBHkzz",
      "b": "https://lh3.googleusercontent.com/d/1EFg7NE8ALjoEhg2Y_nESSIUBQX_vqphc",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1PbIC5ZXA6wQrMa73Oe5e1vK92V7lGLxV",
      "b": "https://lh3.googleusercontent.com/d/1POBHgT4uOTxKaE6eJJM_lUg5vbv2YyI2",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold2_WhiteMatte_Diamond_1645b557-8336-4c01-9779-c034b52c175f.jpg?v=1763748622"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 489,
   "id": "gid://shopify/Product/9106073092280",
   "title": "4.00 CT Round Cut Lab Grown Diamonds - Eternity Ring",
   "url": "/products/eternity-rings-15948lb",
   "handle": "eternity-rings-15948lb",
   "priceNow": 2739.99,
   "priceWas": 8657.99,
   "pctOff": 68,
   "core": "15948",
   "inStock": true,
   "createdAt": "2024-06-05T15:29:22Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold2_Diamond_34fa4ebb-407a-4868-ab6c-888da4fd1748.jpg?v=1717687053",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold2_Diamond_34fa4ebb-407a-4868-ab6c-888da4fd1748.jpg?v=1717687053",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold_Diamond_4d7d6f2c-2b42-4fb0-84a9-4d0643703d62.jpg?v=1717687053",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold1_Diamond_1301ee73-66a5-44dd-9af3-7599bbe97d9f.jpg?v=1717687053"
    }
   },
   "carat": 4.0
  },
  {
   "rank": 490,
   "id": "gid://shopify/Product/9106073059512",
   "title": "2.20-7.70 CT Emerald & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-16012lb",
   "handle": "engagement-rings-16012lb",
   "priceNow": 3018.99,
   "priceWas": 9360.0,
   "pctOff": 68,
   "core": "16012",
   "inStock": true,
   "createdAt": "2024-06-05T15:29:16Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1-GHK_vp-JxGzRJPHuE18mUHCL5F2Fqqw",
      "b": "https://lh3.googleusercontent.com/d/1_f-azlz7EcuqLkysxTI9badwpGH5vBkF",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1nb9XZqHIJJNwSBFyFgCbdI6Gj3M6SX8G",
      "b": "https://lh3.googleusercontent.com/d/1spqPGJDsJ-unqdiPmD_u_uuiWdlh0IBg",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/14C1sF2w0qvR6F4uHyLOiPbNaKojLdWV9",
      "b": "https://lh3.googleusercontent.com/d/1B_Ui1Y_V44Ibm2wn6ChP4P69wn7blbZ2",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA_3_proba_Perspective_Diamond_Yellow_Gold2_White_Matte_ce92d270-a72c-48a9-aa3f-9b64862cfd84.jpg?v=1765415412"
   },
   "carat": 2.2,
   "caratMax": 7.7
  },
  {
   "rank": 491,
   "id": "gid://shopify/Product/9106072928440",
   "title": "0.50-6.00 CT Emerald Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-16250lb",
   "handle": "solitaire-rings-16250lb",
   "priceNow": 1698.99,
   "priceWas": 5270.0,
   "pctOff": 68,
   "core": "16250",
   "inStock": true,
   "createdAt": "2024-06-05T15:29:02Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1YxKOOdvejFUfPd1lEkcPfu83ztWIO6ea",
      "b": "https://lh3.googleusercontent.com/d/1Wya8TKgCswLeuKFR7ZpzWdLFeUkmtF_V",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1ry7gGr7K_9Sui4QpTH781o0gZNRuabiJ",
      "b": "https://lh3.googleusercontent.com/d/18V9PId_Aw30Wza8_lAag2wMSov9C5Afk",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1n8SOjiVo--675PbP8HXCeT9X3-UBhk6R",
      "b": "https://lh3.googleusercontent.com/d/1o-JstRlA5-k--qb7r5FnpbU_TK8dWEBl",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_Diamond_YellowGold2_WhiteMatte_0c190242-0913-4599-8691-d4195be69307.jpg?v=1763748611"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 492,
   "id": "gid://shopify/Product/9083409006776",
   "title": "0.50-6.00 CT Marquise Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-16251lb",
   "handle": "solitaire-rings-16251lb",
   "priceNow": 1698.99,
   "priceWas": 5270.0,
   "pctOff": 68,
   "core": "16251",
   "inStock": true,
   "createdAt": "2024-05-29T18:19:44Z",
   "shape": "marquise",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1MUSg0x8DTmVvUHCV57_WZkuhSPJJI5Is",
      "b": "https://lh3.googleusercontent.com/d/1LVK3snNpc5L6qkn6omKcDNA3vRQUyeoJ",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1__1TZlCXuIoRyr55e-YTikVcc6p8ljXI",
      "b": "https://lh3.googleusercontent.com/d/1yyQk38I8UscDgfZU6plapNDgFobeNs3t",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Jddp3ngNDBi2CK7rlnJVsz1UOiaO7Agm",
      "b": "https://lh3.googleusercontent.com/d/1EDbBljOFqKsPNDJVwvlUxuYFiW0FU0dI",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA_3_proba_Perspective_Diamond_Yellow_Gold2_White_Matte.jpg?v=1763748633"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 493,
   "id": "gid://shopify/Product/9083408842936",
   "title": "0.50-6.00 CT Princess Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-71666lb",
   "handle": "solitaire-rings-71666lb",
   "priceNow": 1620.99,
   "priceWas": 5030.0,
   "pctOff": 68,
   "core": "71666",
   "inStock": true,
   "createdAt": "2024-05-29T18:19:40Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1LHYdM0DghhAtZN_f7wfDJOoD68vvEiZZ",
      "b": "https://lh3.googleusercontent.com/d/1wjZZncGiVi7TW0Emo_8Qp63-ig8oe7Bi",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1g6Ez8haWsdqmmcj9A-Qjwh7kNfrnYHaz",
      "b": "https://lh3.googleusercontent.com/d/1gMRbF3ieflBd0cJ9J8AHePbbdWx4sR_B",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1cu3lfl3pZ1GVl-b4nr6OH29LLtZafRHy",
      "b": "https://lh3.googleusercontent.com/d/1Bwv_LFt07LlSTD4KUIZ4IsxGeauyo0aB",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold2_WhiteMatte_Diamond_36b1809f-d2ce-4ef0-bc81-42719c13ccba.jpg?v=1763748633"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 494,
   "id": "gid://shopify/Product/9083408711864",
   "title": "1.40-6.90 CT Round Cut Lab Grown Diamonds - Three Stone Rings",
   "url": "/products/three-stone-rings-71698lb",
   "handle": "three-stone-rings-71698lb",
   "priceNow": 2217.99,
   "priceWas": 6880.0,
   "pctOff": 68,
   "core": "71698",
   "inStock": true,
   "createdAt": "2024-05-29T18:19:35Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1kjCXPYKBovT55_yWKJdHcKyJsDxk_Jck",
      "b": "https://lh3.googleusercontent.com/d/12inVr1yH_fvFUb1rF29l7_Cj3ujVlIE1",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/19IEWldOXQBdFqSwzpqrWRkieaX0D_UOQ",
      "b": "https://lh3.googleusercontent.com/d/1NgPiXJ0rR1U1CSU1GCoKVn23X3wvjbJR",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Lio0rij3fOrJCxC6zKglRXcw7KrEGoLX",
      "b": "https://lh3.googleusercontent.com/d/1V4rrWWMSSKDIWX96srK87dYtJI5ewmfT",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold2_Diamond_e6e7cc0e-6985-434e-9644-3c44ea85b772.jpg?v=1763766479"
   },
   "carat": 1.4,
   "caratMax": 6.9
  },
  {
   "rank": 495,
   "id": "gid://shopify/Product/9083408482488",
   "title": "2.30-7.80 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71714lb",
   "handle": "engagement-rings-71714lb",
   "priceNow": 3263.99,
   "priceWas": 10120.0,
   "pctOff": 68,
   "core": "71714",
   "inStock": true,
   "createdAt": "2024-05-29T18:19:29Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1dHtJnJOolWQPMF5203z5denO6iuuM8Gt",
      "b": "https://lh3.googleusercontent.com/d/1e8oWNV7-U6T-wrGHKDqQi5_CcWjXeYju",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1uH7qS8OhDlfyoedycpIPij8CxyowEO2b",
      "b": "https://lh3.googleusercontent.com/d/15l1p-Dg87_jx-Xfg_r75Xn-cBtdUz3xB",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1kb9sOwysJvXjYELGn82DlZjvk72PDHJu",
      "b": "https://lh3.googleusercontent.com/d/19wRUYIEV2crAJ9JurzAwPzzBZTPIXUUF",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_Diamond_YellowGold2_WhiteMatte_cd7f4c22-dd9b-4e9c-8f0f-539156fb04a4.jpg?v=1765415419"
   },
   "carat": 2.3,
   "caratMax": 7.8
  },
  {
   "rank": 496,
   "id": "gid://shopify/Product/9083408154808",
   "title": "0.50-6.00 CT Round Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-71820lb",
   "handle": "solitaire-rings-71820lb",
   "priceNow": 1558.99,
   "priceWas": 4830.0,
   "pctOff": 68,
   "core": "71820",
   "inStock": true,
   "createdAt": "2024-05-29T18:19:18Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_Diamond_YellowGold2_WhiteMatte_778f2da7-013a-426c-9693-a55f4886be34.jpg?v=1763748633"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 497,
   "id": "gid://shopify/Product/9083407859896",
   "title": "0.75-6.25 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71893lb",
   "handle": "engagement-rings-71893lb",
   "priceNow": 1741.99,
   "priceWas": 5400.0,
   "pctOff": 68,
   "core": "71893",
   "inStock": true,
   "createdAt": "2024-05-29T18:19:06Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1PAcr9GVX8_B40n0e_aknNfed4oafbSSR",
      "b": "https://lh3.googleusercontent.com/d/1U7nnuPhCDrzlKfiymZ-2NkZv5JD4bePa",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1UinKxGeNrrNHczhBpo-jlV3LFCy6Vi7t",
      "b": "https://lh3.googleusercontent.com/d/14xmk2_VXI41qTdkdbHDbJQyPxBYIa6RO",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Rj3qrAtL9q6_URrxhP16-C82xn-M8mDl",
      "b": "https://lh3.googleusercontent.com/d/1CgTQ9eshrjdYmcz0eRO3AXY0lCi56N5L",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_WhiteMatte_Diamond_YellowGold2_72e40c21-88d8-48cc-b273-b2c67532d4c6.jpg?v=1765415412"
   },
   "carat": 0.75,
   "caratMax": 6.25
  },
  {
   "rank": 498,
   "id": "gid://shopify/Product/9083407761592",
   "title": "0.30 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-110364lb",
   "handle": "wedding-bands-110364lb",
   "priceNow": 948.99,
   "priceWas": 3230.0,
   "pctOff": 71,
   "core": "110364",
   "inStock": true,
   "createdAt": "2024-05-29T18:19:04Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1P2dIUm307JLh8lU-l7FpzPI9sKwQz494",
      "b": "https://lh3.googleusercontent.com/d/1jXUB5DFrNLJLPuMuu-qiEpgbrTyDFmUa",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1m9XgX_JujEU_kmTAUaqddFHW3kVA2uD7",
      "b": "https://lh3.googleusercontent.com/d/1L0OAlyfN9BkgpM2DTavafmClHpcCuwy1",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1CdfiLBuD3en6nR2IQS5ck5aAbLG8lpKw",
      "b": "https://lh3.googleusercontent.com/d/16-1TJHbgggSDU9zr0mb0MDD3dyDVDew9",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold2_Diamond_38a662c8-d049-4943-b62e-407f4d4c147a.jpg?v=1717181006"
   },
   "carat": 0.3
  },
  {
   "rank": 499,
   "id": "gid://shopify/Product/9083407499448",
   "title": "0.50-6.00 CT Cushion Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-71887lb",
   "handle": "solitaire-rings-71887lb",
   "priceNow": 1496.99,
   "priceWas": 4640.0,
   "pctOff": 68,
   "core": "71887",
   "inStock": true,
   "createdAt": "2024-05-29T18:18:56Z",
   "shape": "cushion",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_Diamond_YellowGold2_0997623f-d6ea-44f1-80b1-245d90312baf.jpg?v=1763748633"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 500,
   "id": "gid://shopify/Product/9083407368376",
   "title": "0.70-6.20 CT Round Cut Lab Grown Diamonds - Halo Rings",
   "url": "/products/halo-rings-71907lb",
   "handle": "halo-rings-71907lb",
   "priceNow": 1657.99,
   "priceWas": 5140.0,
   "pctOff": 68,
   "core": "71907",
   "inStock": true,
   "createdAt": "2024-05-29T18:18:51Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_94565de7-ba12-452c-8d05-fb94d0f84a2d.jpg?v=1763766473",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_94565de7-ba12-452c-8d05-fb94d0f84a2d.jpg?v=1763766473",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y3_08aa453c-245c-4acb-bac5-018d11c28914.jpg?v=1763766475",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r3_924308e4-1bab-400c-b1c8-a06095ea1961.jpg?v=1763766478"
    }
   },
   "carat": 0.7,
   "caratMax": 6.2
  },
  {
   "rank": 501,
   "id": "gid://shopify/Product/9083407106232",
   "title": "0.50-6.00 CT Round Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-71815lb",
   "handle": "solitaire-rings-71815lb",
   "priceNow": 1558.99,
   "priceWas": 4830.0,
   "pctOff": 68,
   "core": "71815",
   "inStock": true,
   "createdAt": "2024-05-29T18:18:46Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold2_Diamond_5045c607-c170-42a3-a263-6a050a900496.jpg?v=1763748634"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 502,
   "id": "gid://shopify/Product/9083406680248",
   "title": "1.20-6.70 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71608lb",
   "handle": "engagement-rings-71608lb",
   "priceNow": 1963.99,
   "priceWas": 6090.0,
   "pctOff": 68,
   "core": "71608",
   "inStock": true,
   "createdAt": "2024-05-29T18:18:41Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1omEm9AR3p91dnoOdZSjcubYRWiC_LzrO",
      "b": "https://lh3.googleusercontent.com/d/1VMVRuNks64epDUgdQw5XR83NXpy5KlMc",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/15LICAjjsZhoBheCGsTTvz2fL6ZkVjboh",
      "b": "https://lh3.googleusercontent.com/d/11cFMA0QnCzuNSwLsSDbmGk4CN6Vzq0vD",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/13w-4dmzD8LWw8iDpD7dJBsKkiP20i8mY",
      "b": "https://lh3.googleusercontent.com/d/1xG7kyjiqio_HdTGq7a2--Z6-4CEGvXex",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_0c477714-41c6-4e4c-a4c8-f74291105292.jpg?v=1765415410"
   },
   "carat": 1.2,
   "caratMax": 6.7
  },
  {
   "rank": 503,
   "id": "gid://shopify/Product/9078738747576",
   "title": "2.30-7.80 CT Princess Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71846lb",
   "handle": "engagement-rings-71846lb",
   "priceNow": 2855.99,
   "priceWas": 8850.0,
   "pctOff": 68,
   "core": "71846",
   "inStock": true,
   "createdAt": "2024-05-28T23:05:37Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/19cC7XipI01cp2pFySvRH9NddiUvLIvwH",
      "b": "https://lh3.googleusercontent.com/d/17a6QYo2f_8TKUhLlJt5ary-7v8E_TxUr",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1RddErwj3jxxH7G-ktqavZsM8tSXJLcBp",
      "b": "https://lh3.googleusercontent.com/d/1_4_sRikvwyktJhXd7lhk3-bfTWzP6wr0",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1n9ogLw-Gb9z9erBlAnjqRZq6QvL1NfvU",
      "b": "https://lh3.googleusercontent.com/d/13TGhH-SoYi6YrwOqQqop7HbxGai758dC",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_cc21df1c-515b-49c9-b416-ba740c133e68.jpg?v=1765415418"
   },
   "carat": 2.3,
   "caratMax": 7.8
  },
  {
   "rank": 504,
   "id": "gid://shopify/Product/9078738616504",
   "title": "0.50-6.00 CT Round Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-110387lb",
   "handle": "solitaire-rings-110387lb",
   "priceNow": 1310.99,
   "priceWas": 4060.0,
   "pctOff": 68,
   "core": "110387",
   "inStock": true,
   "createdAt": "2024-05-28T23:05:31Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold2_Diamond_00b6b726-6a82-4106-b28f-f28ede67bb57.jpg?v=1763748634"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 505,
   "id": "gid://shopify/Product/9078738550968",
   "title": "0.65 CT Round Cut Lab Grown Diamonds - Mens Wedding Bands",
   "url": "/products/mens-wedding-bands-71213lb",
   "handle": "mens-wedding-bands-71213lb",
   "priceNow": 1656.99,
   "priceWas": 5140.0,
   "pctOff": 68,
   "core": "71213",
   "inStock": true,
   "createdAt": "2024-05-28T23:05:24Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_c0505e15-5b64-4c38-895d-f27f0fe16ef2.jpg?v=1717180422"
   },
   "carat": 0.65
  },
  {
   "rank": 506,
   "id": "gid://shopify/Product/9078738387128",
   "title": "0.50-6.00 CT Round Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-110385lb",
   "handle": "solitaire-rings-110385lb",
   "priceNow": 2789.99,
   "priceWas": 8650.0,
   "pctOff": 68,
   "core": "110385",
   "inStock": true,
   "createdAt": "2024-05-28T23:05:12Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold2_Diamond_14442ba0-cc75-4418-bc3e-e479d000bea1.jpg?v=1763748633"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 507,
   "id": "gid://shopify/Product/9078738321592",
   "title": "0.40 CT Round Cut Lab Grown Diamonds - Mens Wedding Bands",
   "url": "/products/mens-wedding-bands-71252lb",
   "handle": "mens-wedding-bands-71252lb",
   "priceNow": 1706.99,
   "priceWas": 5290.0,
   "pctOff": 68,
   "core": "71252",
   "inStock": true,
   "createdAt": "2024-05-28T23:05:09Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_b11a01ec-c005-4cde-ac62-0756152ae0dd.jpg?v=1717179963"
   },
   "carat": 0.4
  },
  {
   "rank": 508,
   "id": "gid://shopify/Product/9078738190520",
   "title": "0.50-6.00 CT Marquise Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-16262lb",
   "handle": "solitaire-rings-16262lb",
   "priceNow": 1327.99,
   "priceWas": 4120.0,
   "pctOff": 68,
   "core": "16262",
   "inStock": true,
   "createdAt": "2024-05-28T23:04:57Z",
   "shape": "marquise",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1wgkGugn81vMYao3LENZaUbvp3yk_A325",
      "b": "https://lh3.googleusercontent.com/d/1TrP01SSpfYHhGHVCL-_wsCwTc7XFi8be",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1FvpYrvqu0I-v8rLZfCaSznZ1utyiGlUI",
      "b": "https://lh3.googleusercontent.com/d/1Axf3XMTQ2GNZkQKmv0gNTBKHZiL5hstK",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Jx4huxqqaKXlCbZpjBQnvoKvKk_xyhzs",
      "b": "https://lh3.googleusercontent.com/d/1lTd0HQz0HBHSKcqupEt9SLP6J6tC_ULJ",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_1ae8158a-7873-48e8-9c8f-5d9f36282a82.jpg?v=1763748634"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 509,
   "id": "gid://shopify/Product/9078738059448",
   "title": "0.50 CT Round Cut Lab Grown Diamonds - Mens Wedding Bands",
   "url": "/products/mens-wedding-bands-15689lb",
   "handle": "mens-wedding-bands-15689lb",
   "priceNow": 1620.99,
   "priceWas": 5030.0,
   "pctOff": 68,
   "core": "15689",
   "inStock": true,
   "createdAt": "2024-05-28T23:04:50Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_87cd6e23-31d4-4d2f-b3bc-46916996989b.jpg?v=1717175736"
   },
   "carat": 0.5
  },
  {
   "rank": 510,
   "id": "gid://shopify/Product/9078362898616",
   "title": "1.80-7.30 CT Emerald Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-15654lb",
   "handle": "engagement-rings-15654lb",
   "priceNow": 2146.99,
   "priceWas": 6660.0,
   "pctOff": 68,
   "core": "15654",
   "inStock": true,
   "createdAt": "2024-05-28T17:02:23Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/15WfxoD4nwKhq4IZC8tFg8BJtNCNYpsVe",
      "b": "https://lh3.googleusercontent.com/d/1umQClEORYByli-p68smaLVAwLn0FaIfw",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1BaXysnDV8TAkuTk4kgYFyTrEF2fButpy",
      "b": "https://lh3.googleusercontent.com/d/1fKdQsqcPZcZarEGKENM2h9uArch-YT8N",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1qbqqfdRCR2tWxb5Hwn6uSrGUZE8yzVrR",
      "b": "https://lh3.googleusercontent.com/d/1aWQI6FgpoMKdyDSi-EydJSzkE0M9mwGh",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_3aa0d7d5-913b-456e-bf42-b57ba510e955.jpg?v=1765415411"
   },
   "carat": 1.8,
   "caratMax": 7.3
  },
  {
   "rank": 511,
   "id": "gid://shopify/Product/9078362800312",
   "title": "0.35 CT Round Cut Lab Grown Diamonds - Mens Wedding Bands",
   "url": "/products/mens-wedding-bands-15681lb",
   "handle": "mens-wedding-bands-15681lb",
   "priceNow": 1793.99,
   "priceWas": 5560.0,
   "pctOff": 68,
   "core": "15681",
   "inStock": true,
   "createdAt": "2024-05-28T17:02:18Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_4c938dc1-831c-4e0c-a00c-dcb5fae56a22.jpg?v=1717175122"
   },
   "carat": 0.35
  },
  {
   "rank": 512,
   "id": "gid://shopify/Product/9078362636472",
   "title": "1.10-6.60 CT Oval & Round Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-15647lb",
   "handle": "solitaire-rings-15647lb",
   "priceNow": 1881.99,
   "priceWas": 5830.0,
   "pctOff": 68,
   "core": "15647",
   "inStock": true,
   "createdAt": "2024-05-28T17:02:10Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1Z8wWnsUczNCMFOgM0bgxQ5fFrwqEeQNE",
      "b": "https://lh3.googleusercontent.com/d/1bG44LWOPCifBNv2tY1o__MHhsvHUA15C",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1775_ttjBwTb9d7rnmd2lX-r4__8EnkRp",
      "b": "https://lh3.googleusercontent.com/d/1e38MWzZ9UQdPlZbiMHNj_hktN0AS1QHD",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1yzp9gPpYlMpc01Fe8G4GQIESAVU97fAq",
      "b": "https://lh3.googleusercontent.com/d/1Nrr5D7MGgcVfHfkJIXMgAQAXeDv2oSwY",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold2_Diamond_Diamond_6c18dfdf-c4c1-433c-affe-01a350a4a9b3.jpg?v=1763748633"
   },
   "carat": 1.1,
   "caratMax": 6.6
  },
  {
   "rank": 513,
   "id": "gid://shopify/Product/9078362276024",
   "title": "2.80-5.30 CT Princess Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-15651lb",
   "handle": "engagement-rings-15651lb",
   "priceNow": 1986.99,
   "priceWas": 8253.99,
   "pctOff": 76,
   "core": "15651",
   "inStock": true,
   "createdAt": "2024-05-28T17:01:56Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1JNOrOK3K1A65P8NIlWFMkccaUNmJfHCd",
      "b": "https://lh3.googleusercontent.com/d/1gLIZViBWDWlbS3GTejFVBH0umvPiUaRo",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1e5A_u1XVyLUlURFkqyvv0WbfCm8zaUJE",
      "b": "https://lh3.googleusercontent.com/d/17pi8-NGT0k3YM5NYONBueOtSNb9CAwst",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1BFrIt0tN4kxASdWGMuDVLM2E5G43UyEZ",
      "b": "https://lh3.googleusercontent.com/d/1WsgXDZ9C1WX1HQtbF1ygjDpVfwCsOIhw",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA_3_proba_Perspective_Yellow_Gold2_Diamond_a709dc2e-ddb8-4cfb-805e-9d6b9454a23c.jpg?v=1717527533"
   },
   "carat": 2.8,
   "caratMax": 5.3
  },
  {
   "rank": 514,
   "id": "gid://shopify/Product/9078362112184",
   "title": "0.75-6.25 CT Cushion & Round Cut Lab Grown Diamonds - Halo Rings",
   "url": "/products/halo-rings-71646lb",
   "handle": "halo-rings-71646lb",
   "priceNow": 2381.99,
   "priceWas": 7380.0,
   "pctOff": 68,
   "core": "71646",
   "inStock": true,
   "createdAt": "2024-05-28T17:01:49Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1nM1TMZXaKXWgzRM-fkoND3Kl2hQYlT8h",
      "b": "https://lh3.googleusercontent.com/d/1TYhU4V_OMrPZ43C1MHqcXYcpInJbooVb",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1tvFgAEfvP8Bf1NTaBQAn5u8rmJO7G3GC",
      "b": "https://lh3.googleusercontent.com/d/1wPC4guY7ME1wwcgWjo0q2FsnxmLABNaR",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/11YovuH_gPuGbFlkmNpbOfSdXtHrq7G7X",
      "b": "https://lh3.googleusercontent.com/d/1ynoUdncAyprli7v7PoCxRFWPT0omLfhQ",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold2_Diamond_Diamond_0836b94d-75d1-46c8-8f51-8a1d1024b3ac.jpg?v=1763697805"
   },
   "carat": 0.75,
   "caratMax": 6.25
  },
  {
   "rank": 515,
   "id": "gid://shopify/Product/9078361981112",
   "title": "0.50-6.00 CT Emerald Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-16271lb",
   "handle": "solitaire-rings-16271lb",
   "priceNow": 2193.99,
   "priceWas": 6800.0,
   "pctOff": 68,
   "core": "16271",
   "inStock": true,
   "createdAt": "2024-05-28T17:01:47Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1uvii6Nayjs9kOoS1gq5HMUZSbi2oo3NV",
      "b": "https://lh3.googleusercontent.com/d/1pfyjj7D8Kdf6NeON_9pHpBmK1v0-S9KC",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1a8h0HP538NCtmuxtA-wTrCIzyFbiJMud",
      "b": "https://lh3.googleusercontent.com/d/1UJtd3iQUlMuYi8bIl9ptjB590M9FDRtd",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1v3dWJgL0BIHkS_B9ZFQ3OPLwBi5BKVEi",
      "b": "https://lh3.googleusercontent.com/d/1rtTBmgiXNptaTpztfDC1mpfymM7a65ws",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold2_35727cbb-03c8-4fbf-8b15-a248cbc852df.jpg?v=1763748632"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 516,
   "id": "gid://shopify/Product/9078361489592",
   "title": "0.50-6.00 CT Radiant Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-16267lb",
   "handle": "solitaire-rings-16267lb",
   "priceNow": 2483.99,
   "priceWas": 7700.0,
   "pctOff": 68,
   "core": "16267",
   "inStock": true,
   "createdAt": "2024-05-28T17:01:26Z",
   "shape": "radiant",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1C-hhdvFlHY_DOj0MaWT0QwFm-NMvjoM6",
      "b": "https://lh3.googleusercontent.com/d/15K20qoQF0gC7exGlDbPTaaDImRi45VUX",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1oAtaHQhUTXVcUvjUDAcMeVxPjKQKZpoa",
      "b": "https://lh3.googleusercontent.com/d/12KiHf5ROap31QFTcAfVwZbjUXZtWz48I",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Dna9yFA83ucny5IjXgrKICaFKLmRw6hL",
      "b": "https://lh3.googleusercontent.com/d/1wxNyPQviD_p0ovNRPgje6aHxRKKK6RJM",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold2_Diamond_0e20fc9f-68c7-4ce1-979d-d64abbfa4293.jpg?v=1763748635"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 517,
   "id": "gid://shopify/Product/9078361260216",
   "title": "0.50-6.00 CT Round Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-71659lb",
   "handle": "solitaire-rings-71659lb",
   "priceNow": 1310.99,
   "priceWas": 4060.0,
   "pctOff": 68,
   "core": "71659",
   "inStock": true,
   "createdAt": "2024-05-28T17:01:13Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1ceZsDeEc8KksHxDYPWrd-c3lsMHs1WZD",
      "b": "https://lh3.googleusercontent.com/d/148Z2RYtdBcxA4-UlWjlKK3EUt8cwNEin",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1Dh9UPMZfdQqrknau5lItzkiGl88pMdfr",
      "b": "https://lh3.googleusercontent.com/d/1a-cvQJFxT6FXGG4NR4DA8NSJff5c1a2s",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1bKBH_s2DMhnj9Q9nw1iGq0kgyoNoyQN_",
      "b": "https://lh3.googleusercontent.com/d/1lOytUkACJIGmOuQpqAqr-D5Vz6OaawgO",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold2_Diamond_a5b15f40-661d-4f8c-8803-3a43660ccfdf.jpg?v=1763748631"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 518,
   "id": "gid://shopify/Product/9078361129144",
   "title": "0.40 CT Round Cut Lab Grown Diamonds - Mens Wedding Bands",
   "url": "/products/mens-wedding-bands-71452lb",
   "handle": "mens-wedding-bands-71452lb",
   "priceNow": 1706.99,
   "priceWas": 5290.0,
   "pctOff": 68,
   "core": "71452",
   "inStock": true,
   "createdAt": "2024-05-28T17:01:07Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_Diamond_YellowGold2_2f963142-b282-43f4-9af2-c3e996633c86.jpg?v=1717006790"
   },
   "carat": 0.4
  },
  {
   "rank": 519,
   "id": "gid://shopify/Product/9078360572088",
   "title": "0.50-6.00 CT Round Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-16269lb",
   "handle": "solitaire-rings-16269lb",
   "priceNow": 2434.99,
   "priceWas": 7550.0,
   "pctOff": 68,
   "core": "16269",
   "inStock": true,
   "createdAt": "2024-05-28T17:00:42Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1ybhUTibnuwcqTl_JmXhmoP39Se_PwLaP",
      "b": "https://lh3.googleusercontent.com/d/10UHlAlovfpz8a8XWR6TYMiacKz-IJJfZ",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1g4QsAzyUokc9Tyr5AQMtqhxyw9hxrzhJ",
      "b": "https://lh3.googleusercontent.com/d/1EV5mNuojSPTxJE7UjK7vrOjim4clSX14",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1giS5fflRnzhqPI1PznkiG-Wu-ZNBP9rE",
      "b": "https://lh3.googleusercontent.com/d/1t1tPkx1CByOH8WvrKi6mrtJJWOlsSaDw",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold2_Diamond_7906697d-d6ec-4353-9b7f-ce9411ad7f62.jpg?v=1763748622"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 520,
   "id": "gid://shopify/Product/9078360244408",
   "title": "3.00-8.50 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71712lb",
   "handle": "engagement-rings-71712lb",
   "priceNow": 2273.99,
   "priceWas": 7050.0,
   "pctOff": 68,
   "core": "71712",
   "inStock": true,
   "createdAt": "2024-05-28T17:00:26Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/14bt-TQygDIe9RvvFjx5EmQHO8GWHWRnN",
      "b": "https://lh3.googleusercontent.com/d/1DvTKigkpAelNQNUMck0Ar1Ft-S_vP706",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1mGs-2A7T8fQKWDWT8qhhvrfHC57qAzpx",
      "b": "https://lh3.googleusercontent.com/d/1-LU8jdgtk1m1uLjtFH-RaUzwlPJBvias",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1flg5FJ0rmZ0T7aihnlzd2vUPNBGRFrQD",
      "b": "https://lh3.googleusercontent.com/d/1VbW76bNkJ7S9jveyOJK28nub9HPB5S3S",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold2_Diamond_1e76c03d-8dd8-425b-bd0c-39305be13795.jpg?v=1765415412"
   },
   "carat": 3.0,
   "caratMax": 8.5
  },
  {
   "rank": 521,
   "id": "gid://shopify/Product/9078359949496",
   "title": "0.50-6.00 CT Emerald Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-16261lb",
   "handle": "solitaire-rings-16261lb",
   "priceNow": 1327.99,
   "priceWas": 4120.0,
   "pctOff": 68,
   "core": "16261",
   "inStock": true,
   "createdAt": "2024-05-28T17:00:11Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1SiWaH77FhOwzrHHHRXg3KZJxBVWgTtOH",
      "b": "https://lh3.googleusercontent.com/d/1zhLFtKq8EaP-qYpJej6X0RZMFbCf2f5N",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1PnRZgH-XLLZ6BPcgKwqw1QrcCoWoF4m6",
      "b": "https://lh3.googleusercontent.com/d/1Tt07-m1KIsBF5fJWGI_iifyvnRJOYD_H",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1M8twhS1Fj5GjvaQ0aoMmetSb-WaX9hPj",
      "b": "https://lh3.googleusercontent.com/d/16rKeTcB0dvE5ktXnNJWTtKGpaZIoxLEU",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/POZICIJA3proba_Perspective_YellowGold2_Diamond_485e70fa-3857-4897-a8ec-09b7c3c361d1.jpg?v=1763748633"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 522,
   "id": "gid://shopify/Product/9077562966200",
   "title": "1.55-7.05 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-15253lb",
   "handle": "engagement-rings-15253lb",
   "priceNow": 2313.99,
   "priceWas": 7170.0,
   "pctOff": 68,
   "core": "15253",
   "inStock": true,
   "createdAt": "2024-05-28T10:40:25Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1WXVttR0DN1BQk6tbO7IawSgwjovhTdap",
      "b": "https://lh3.googleusercontent.com/d/1YixZkDiU-HJnQH62-J22MxemaJtV_kP1",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1mvhcvURzAoYovdjBqYmANPxmCN1B8eSZ",
      "b": "https://lh3.googleusercontent.com/d/1p8cxCy5qq6CPgpBVb70d0HqAwb27B3_o",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1iAJaNl90hFWiBPBq8c1aTaTchio_eNIl",
      "b": "https://lh3.googleusercontent.com/d/127u-OkrpiGxZ_-WgVaWI9-8XGbArAnve",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_444ce074-c925-43a9-be60-f97c1ca4edb2.jpg?v=1765415409"
   },
   "carat": 1.55,
   "caratMax": 7.05
  },
  {
   "rank": 523,
   "id": "gid://shopify/Product/9077562179768",
   "title": "0.80 CT Round Cut Lab Grown Diamonds - Mens Wedding Bands",
   "url": "/products/mens-wedding-bands-15674lb",
   "handle": "mens-wedding-bands-15674lb",
   "priceNow": 2161.99,
   "priceWas": 6700.0,
   "pctOff": 68,
   "core": "15674",
   "inStock": true,
   "createdAt": "2024-05-28T10:40:12Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_1c7b244c-3c68-4bbc-b420-316b20fb8bff.jpg?v=1717005262"
   },
   "carat": 0.8
  },
  {
   "rank": 524,
   "id": "gid://shopify/Product/9077561950392",
   "title": "0.80 CT Round Cut Lab Grown Diamonds - Mens Wedding Bands",
   "url": "/products/mens-wedding-bands-15675lb",
   "handle": "mens-wedding-bands-15675lb",
   "priceNow": 2150.99,
   "priceWas": 6670.0,
   "pctOff": 68,
   "core": "15675",
   "inStock": true,
   "createdAt": "2024-05-28T10:40:09Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_61edb91d-f83b-4384-afa8-7cb983aa7762.jpg?v=1717005228"
   },
   "carat": 0.8
  },
  {
   "rank": 525,
   "id": "gid://shopify/Product/9077561360568",
   "title": "2.00-7.50 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-15683lb",
   "handle": "engagement-rings-15683lb",
   "priceNow": 2361.99,
   "priceWas": 7320.0,
   "pctOff": 68,
   "core": "15683",
   "inStock": true,
   "createdAt": "2024-05-28T10:40:00Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1UVoaUBUp8X1pQ5dP_MwJSZQFyYhdIPSm",
      "b": "https://lh3.googleusercontent.com/d/1CFhY4yRBCDmRxwyGyuguhJ0Hs-2i4s05",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1TCc8uk4X1EKWTpCSevytUNActL_hVvwV",
      "b": "https://lh3.googleusercontent.com/d/1GeKK9nxVijALYnFHlDt_jG0Xcq8aY5Ml",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1LgIEVL_OzL5oAmgaFHnCw5nEVmg6UohE",
      "b": "https://lh3.googleusercontent.com/d/1hmiB_0xMz-2F6aJ8lxoC--6XzykuHMjn",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_f75f9572-8264-487c-85e5-7005aece5b3c.jpg?v=1765415413"
   },
   "carat": 2.0,
   "caratMax": 7.5
  },
  {
   "rank": 526,
   "id": "gid://shopify/Product/9077561000120",
   "title": "1.55-7.05 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-16062lb",
   "handle": "engagement-rings-16062lb",
   "priceNow": 2230.99,
   "priceWas": 6920.0,
   "pctOff": 68,
   "core": "16062",
   "inStock": true,
   "createdAt": "2024-05-28T10:39:56Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1IvotAu9YDSBVsuoWU9QcWh8SI6wVyylX",
      "b": "https://lh3.googleusercontent.com/d/1L34xm17l7cAcK5_FhfKon3beRtL37r8D",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1S8YzgXLPPpXBzYpEELqEmWtUAqsb_sUH",
      "b": "https://lh3.googleusercontent.com/d/13ldnWunACcp9mYKSDXIhHJygXRjXLsgb",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/124tnAZLiuuWYMzygsYwjIl3_5kP_-fEe",
      "b": "https://lh3.googleusercontent.com/d/1_F9-ej6PHr5YJjjIHCVaOAaAj17UoLOH",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_46da90c1-d4e4-4a5b-aebf-56c52912685f.jpg?v=1765415420"
   },
   "carat": 1.55,
   "caratMax": 7.05
  },
  {
   "rank": 527,
   "id": "gid://shopify/Product/9077560475832",
   "title": "1.60-7.10 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-16081lb",
   "handle": "engagement-rings-16081lb",
   "priceNow": 2152.99,
   "priceWas": 6670.0,
   "pctOff": 68,
   "core": "16081",
   "inStock": true,
   "createdAt": "2024-05-28T10:39:50Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1ijDXKnCJ3iiMCXiC3vLxjJfgA3JlaTDo",
      "b": "https://lh3.googleusercontent.com/d/11L5zypaYJpGSJZHaDJXKwJHIdIMV5R-a",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1Hgf4RyzKxRLzqxJUHrnldqUv694DvPcX",
      "b": "https://lh3.googleusercontent.com/d/1a2LlOezzACF9DH4GeHfADl5nzDJTngyz",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/10WSVfY8MHT6TCG3m-1fKYMdDVWC-3rgN",
      "b": "https://lh3.googleusercontent.com/d/1bWJeZAMFZLTPPdbnzWt3MMZ6kFXXr8fP",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_822440bf-a0e2-4f05-aa5e-48f14def8727.jpg?v=1765415412"
   },
   "carat": 1.6,
   "caratMax": 7.1
  },
  {
   "rank": 528,
   "id": "gid://shopify/Product/9077560279224",
   "title": "0.80 CT Round Cut Lab Grown Diamonds - Mens Wedding Bands",
   "url": "/products/mens-wedding-bands-71240lb",
   "handle": "mens-wedding-bands-71240lb",
   "priceNow": 2117.99,
   "priceWas": 6570.0,
   "pctOff": 68,
   "core": "71240",
   "inStock": true,
   "createdAt": "2024-05-28T10:39:49Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_57b3064d-efc4-49be-a9f6-87d890de031b.jpg?v=1717001553"
   },
   "carat": 0.8
  },
  {
   "rank": 529,
   "id": "gid://shopify/Product/9077559558328",
   "title": "1.50 CT Round Cut Lab Grown Diamonds - Mens Wedding Bands",
   "url": "/products/mens-wedding-bands-71512lb",
   "handle": "mens-wedding-bands-71512lb",
   "priceNow": 2285.99,
   "priceWas": 7090.0,
   "pctOff": 68,
   "core": "71512",
   "inStock": true,
   "createdAt": "2024-05-28T10:39:41Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_242db572-3a19-4659-be28-31836fb6671a.jpg?v=1716922821"
   },
   "carat": 1.5
  },
  {
   "rank": 530,
   "id": "gid://shopify/Product/9077558771896",
   "title": "1.00 CT Round Cut Lab Grown Diamonds - Mens Wedding Bands",
   "url": "/products/mens-wedding-bands-71548lb",
   "handle": "mens-wedding-bands-71548lb",
   "priceNow": 1785.99,
   "priceWas": 5540.0,
   "pctOff": 68,
   "core": "71548",
   "inStock": true,
   "createdAt": "2024-05-28T10:39:32Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_aef8ebfc-4fca-4525-828c-ec28f0c068bc.jpg?v=1716922479"
   },
   "carat": 1.0
  },
  {
   "rank": 531,
   "id": "gid://shopify/Product/9077558083768",
   "title": "0.60 CT Round Cut Lab Grown Diamonds - Mens Wedding Bands",
   "url": "/products/mens-wedding-bands-71584lb",
   "handle": "mens-wedding-bands-71584lb",
   "priceNow": 2022.99,
   "priceWas": 6270.0,
   "pctOff": 68,
   "core": "71584",
   "inStock": true,
   "createdAt": "2024-05-28T10:39:21Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_1b9a8dde-cec5-4c8a-a80d-8d7cf6b80eca.jpg?v=1716922434"
   },
   "carat": 0.6
  },
  {
   "rank": 532,
   "id": "gid://shopify/Product/9074166595768",
   "title": "1.50 CT Round Cut Lab Grown Diamonds - Mens Wedding Bands",
   "url": "/products/mens-wedding-bands-15676lb",
   "handle": "mens-wedding-bands-15676lb",
   "priceNow": 2084.99,
   "priceWas": 6460.0,
   "pctOff": 68,
   "core": "15676",
   "inStock": true,
   "createdAt": "2024-05-27T22:18:06Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_d9b8ceb8-d239-426d-a2cd-fb3c9a9c3705.jpg?v=1716922184"
   },
   "carat": 1.5
  },
  {
   "rank": 533,
   "id": "gid://shopify/Product/9074166431928",
   "title": "1.20 CT Round Cut Lab Grown Diamonds - Mens Wedding Bands",
   "url": "/products/mens-wedding-bands-15680lb",
   "handle": "mens-wedding-bands-15680lb",
   "priceNow": 1926.99,
   "priceWas": 5970.0,
   "pctOff": 68,
   "core": "15680",
   "inStock": true,
   "createdAt": "2024-05-27T22:17:59Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_dc24b21c-2f42-45bc-94c2-11e2680c7124.jpg?v=1716921930"
   },
   "carat": 1.2
  },
  {
   "rank": 534,
   "id": "gid://shopify/Product/9074166366392",
   "title": "1.00 CT Princess Cut Lab Grown Diamonds - Mens Wedding Bands",
   "url": "/products/mens-wedding-bands-15687lb",
   "handle": "mens-wedding-bands-15687lb",
   "priceNow": 1933.99,
   "priceWas": 6000.0,
   "pctOff": 68,
   "core": "15687",
   "inStock": true,
   "createdAt": "2024-05-27T22:17:55Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_4a1692df-b036-4c9d-98b5-b55b255e6392.jpg?v=1716918566"
   },
   "carat": 1.0
  },
  {
   "rank": 535,
   "id": "gid://shopify/Product/9074166300856",
   "title": "0.40 CT Princess Cut Lab Grown Diamonds - Mens Wedding Bands",
   "url": "/products/mens-wedding-bands-71198lb",
   "handle": "mens-wedding-bands-71198lb",
   "priceNow": 2669.99,
   "priceWas": 8280.0,
   "pctOff": 68,
   "core": "71198",
   "inStock": true,
   "createdAt": "2024-05-27T22:17:51Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_d2ba8e06-8917-40eb-bf9b-9f28be25386c.jpg?v=1716918974"
   },
   "carat": 0.4
  },
  {
   "rank": 536,
   "id": "gid://shopify/Product/9074166235320",
   "title": "1.50 CT Round Cut Lab Grown Diamonds - Mens Wedding Bands",
   "url": "/products/mens-wedding-bands-71204lb",
   "handle": "mens-wedding-bands-71204lb",
   "priceNow": 2557.99,
   "priceWas": 7930.0,
   "pctOff": 68,
   "core": "71204",
   "inStock": true,
   "createdAt": "2024-05-27T22:17:50Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_ecd77cb6-45b2-43f2-8945-c5473500a396.jpg?v=1716918923"
   },
   "carat": 1.5
  },
  {
   "rank": 537,
   "id": "gid://shopify/Product/9074166169784",
   "title": "1.50 CT Round Cut Lab Grown Diamonds - Mens Wedding Bands",
   "url": "/products/mens-wedding-bands-71207lb",
   "handle": "mens-wedding-bands-71207lb",
   "priceNow": 2476.99,
   "priceWas": 7680.0,
   "pctOff": 68,
   "core": "71207",
   "inStock": true,
   "createdAt": "2024-05-27T22:17:45Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_a4e153f1-5bc5-492b-9e12-ceb45ee65286.jpg?v=1716917582"
   },
   "carat": 1.5
  },
  {
   "rank": 538,
   "id": "gid://shopify/Product/9074165973176",
   "title": "0.90 CT Princess Cut Lab Grown Diamonds - Mens Wedding Bands",
   "url": "/products/mens-wedding-bands-71219lb",
   "handle": "mens-wedding-bands-71219lb",
   "priceNow": 2192.99,
   "priceWas": 6800.0,
   "pctOff": 68,
   "core": "71219",
   "inStock": true,
   "createdAt": "2024-05-27T22:17:38Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_16072520-4c01-4736-b227-22a908e5c315.jpg?v=1716917117"
   },
   "carat": 0.9
  },
  {
   "rank": 539,
   "id": "gid://shopify/Product/9074165842104",
   "title": "1.00 CT Round Cut Lab Grown Diamonds - Mens Wedding Bands",
   "url": "/products/mens-wedding-bands-71440lb",
   "handle": "mens-wedding-bands-71440lb",
   "priceNow": 1982.99,
   "priceWas": 6150.0,
   "pctOff": 68,
   "core": "71440",
   "inStock": true,
   "createdAt": "2024-05-27T22:17:32Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_3bb62ebf-f9cb-4a4d-92c4-5fa4ac348d8c.jpg?v=1716915322"
   },
   "carat": 1.0
  },
  {
   "rank": 540,
   "id": "gid://shopify/Product/9073745723576",
   "title": "1.15-6.65 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71744lb",
   "handle": "engagement-rings-71744lb",
   "priceNow": 1885.99,
   "priceWas": 5850.0,
   "pctOff": 68,
   "core": "71744",
   "inStock": true,
   "createdAt": "2024-05-27T17:23:30Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/18MT_mFq26bgTA5Y9JaJqyd4hRIox9tGv",
      "b": "https://lh3.googleusercontent.com/d/18D14FXWvroO3erwDkT4RZWbZZTPZcW6E",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1O3QcPSPHP5tMEyZGrhnwDSwuvTpLEj8V",
      "b": "https://lh3.googleusercontent.com/d/1uZG7SL9Y6h2lEk40je_YSQEiusJoN6me",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1qxjSdoSoyXo1g8Rmm7YPw-3pOBGeiNMN",
      "b": "https://lh3.googleusercontent.com/d/1fKNQICh7I-527QVWGpqFZHilymvVrSnG",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_2fd9a953-b180-44df-a51b-337e9480bff5.jpg?v=1765415418"
   },
   "carat": 1.15,
   "caratMax": 6.65
  },
  {
   "rank": 541,
   "id": "gid://shopify/Product/9073745592504",
   "title": "1.30-6.80 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71786lb",
   "handle": "engagement-rings-71786lb",
   "priceNow": 2345.99,
   "priceWas": 7270.0,
   "pctOff": 68,
   "core": "71786",
   "inStock": true,
   "createdAt": "2024-05-27T17:23:25Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1y17WexnpKNGyile4N2IKz3Dt0efbxAva",
      "b": "https://lh3.googleusercontent.com/d/112N9i2XaVUdW-EQY-KLfMwA63tpVJyPB",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1gGyWz118MRRNvZKicjegoLv6-hiO_1Y4",
      "b": "https://lh3.googleusercontent.com/d/1o5HBEQukIKvT7f7Yosjj4ErALnN16eFx",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1nnhZSNlrmo9taKcZEfxXN5noD7iXR0VE",
      "b": "https://lh3.googleusercontent.com/d/1bDflGMr_zqmN-TBaJHgBItKgHiASFSBA",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_233f4589-636f-47a7-a5ca-74e51e5541fc.jpg?v=1765415413"
   },
   "carat": 1.3,
   "caratMax": 6.8
  },
  {
   "rank": 542,
   "id": "gid://shopify/Product/9073745395896",
   "title": "0.90-6.40 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71715lb",
   "handle": "engagement-rings-71715lb",
   "priceNow": 2138.99,
   "priceWas": 6630.0,
   "pctOff": 68,
   "core": "71715",
   "inStock": true,
   "createdAt": "2024-05-27T17:23:20Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1qDkxEQbFBCiDqYg5BgmYo3DdRAG_G2SP",
      "b": "https://lh3.googleusercontent.com/d/1CFPZlFYnmMKXaNOK7cQERu-W45oh5ium",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1ES6j6_usbMUUdWLhNG-gDPGhc-kcMVG5",
      "b": "https://lh3.googleusercontent.com/d/1Sat3oVfcSv7Py2T5_RltBmQZIStSyDBc",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1dHVB9qWk8bOk9DXXo23M_Y33-vegK4jZ",
      "b": "https://lh3.googleusercontent.com/d/1tjoLrHmTq6aDzrmlyISRrKhoG6yImbcT",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_d8bfa398-2831-475c-8c99-576120772b5f.jpg?v=1765415416"
   },
   "carat": 0.9,
   "caratMax": 6.4
  },
  {
   "rank": 543,
   "id": "gid://shopify/Product/9073745232056",
   "title": "0.50-6.00 CT Round Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-110389lb",
   "handle": "solitaire-rings-110389lb",
   "priceNow": 1000.99,
   "priceWas": 3100.0,
   "pctOff": 68,
   "core": "110389",
   "inStock": true,
   "createdAt": "2024-05-27T17:23:15Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_3baef17d-260d-4d61-8b5d-c7aa3c28231a.jpg?v=1763748634"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 544,
   "id": "gid://shopify/Product/9073744969912",
   "title": "1.00-6.50 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71909lb",
   "handle": "engagement-rings-71909lb",
   "priceNow": 1848.99,
   "priceWas": 5730.0,
   "pctOff": 68,
   "core": "71909",
   "inStock": true,
   "createdAt": "2024-05-27T17:23:06Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/11iztJTK0izSjI_Yape-RlQzSCLZcfIN6",
      "b": "https://lh3.googleusercontent.com/d/1xgmcftbRWkf_2WD0N9q6xUHAkpNUpvVk",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1epJAODnFvq7lzXW3irRgE8gukaXRoxtn",
      "b": "https://lh3.googleusercontent.com/d/1ER9z6arOx2cJJRSQILFQnYZQsbUVL4Yl",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1LZYvyKwcpfA28Ap59gSCtD4AGWV7rria",
      "b": "https://lh3.googleusercontent.com/d/1oFaxhxvs6I7tdMzegFMrnbjggxAewYfI",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_179ff33b-cd57-4ddb-9b0b-550ee3a6285f.jpg?v=1765415418"
   },
   "carat": 1.0,
   "caratMax": 6.5
  },
  {
   "rank": 545,
   "id": "gid://shopify/Product/9073744740536",
   "title": "1.00-6.50 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71670lb",
   "handle": "engagement-rings-71670lb",
   "priceNow": 2753.99,
   "priceWas": 8540.0,
   "pctOff": 68,
   "core": "71670",
   "inStock": true,
   "createdAt": "2024-05-27T17:22:59Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1_1nfVlNJvasDS3MtvY3J9CR_91betcYu",
      "b": "https://lh3.googleusercontent.com/d/1AXkrkHk9IwZI2b6rjmG4ADzi6FPHFuUI",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1eCxlXwG2QNJ5kY1eRpOuUncBtcgZZwB8",
      "b": "https://lh3.googleusercontent.com/d/1XuLBIoAfLEZISaO0JMm3M_2xaK_cw843",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1qY8F4vkZJJ49k9R-O-7PxAyvJGzhApRo",
      "b": "https://lh3.googleusercontent.com/d/1qd1k4HxyLHyN4_ZlY-HrXCJkWRmoXv9R",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_1fa2b30b-b642-4b0a-9aba-294857c58e73.jpg?v=1765415418"
   },
   "carat": 1.0,
   "caratMax": 6.5
  },
  {
   "rank": 546,
   "id": "gid://shopify/Product/9073744642232",
   "title": "1.20-6.70 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-15226lb",
   "handle": "engagement-rings-15226lb",
   "priceNow": 1717.99,
   "priceWas": 5330.0,
   "pctOff": 68,
   "core": "15226",
   "inStock": true,
   "createdAt": "2024-05-27T17:22:53Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/14NzBhSjCGXRNvgaRY3cjAiRyN_T7il4U",
      "b": "https://lh3.googleusercontent.com/d/1oegcZ061DLRfWR2YOzU75UbyUMyga3FC",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1eYdRmOVUDzv1JE0KFwl4-HopVnsnzLFv",
      "b": "https://lh3.googleusercontent.com/d/1gDUmrCMw9pRo7--fXBqnTnnaSCwTLLdt",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1hHmSbkLVCeSCEHgjQeKwNO0z8OirmVRO",
      "b": "https://lh3.googleusercontent.com/d/1y3AUqSUbhaspnWXhmtz9Qh8HpR2JmOWJ",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_5216f7a3-1d28-478f-a3d6-c085e2847fc3.jpg?v=1765415417"
   },
   "carat": 1.2,
   "caratMax": 6.7
  },
  {
   "rank": 547,
   "id": "gid://shopify/Product/9073744478392",
   "title": "1.35-6.85 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71911lb",
   "handle": "engagement-rings-71911lb",
   "priceNow": 1694.99,
   "priceWas": 5250.0,
   "pctOff": 68,
   "core": "71911",
   "inStock": true,
   "createdAt": "2024-05-27T17:22:48Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1ND0jepjP0pYjOkvXezaRJY_XBLFAHnwa",
      "b": "https://lh3.googleusercontent.com/d/1ClCuyEHY827OL58Au9xUVucqbHo8c52D",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/106xXTRHnoEL-0d4rjM5qQQJ4Gt6l9qLU",
      "b": "https://lh3.googleusercontent.com/d/1POQQxaOcVJ3yP36nIVAKe4hG0Fp24YuG",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/10HnMv2_PD8B08HjupRCwixXgczEOtgr3",
      "b": "https://lh3.googleusercontent.com/d/1T1Qu45omWouCsdiY2srWZoTEZd_dBb4B",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_e586cb4b-eb7f-42a7-9819-5f4f7fa5b909.jpg?v=1765415418"
   },
   "carat": 1.35,
   "caratMax": 6.85
  },
  {
   "rank": 548,
   "id": "gid://shopify/Product/9073744314552",
   "title": "0.90-6.40 CT Round & Taper Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71676lb",
   "handle": "engagement-rings-71676lb",
   "priceNow": 1697.99,
   "priceWas": 5260.0,
   "pctOff": 68,
   "core": "71676",
   "inStock": true,
   "createdAt": "2024-05-27T17:22:43Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1Y9qNjllZ31liur8RHGPPfB_2OfRVEyuz",
      "b": "https://lh3.googleusercontent.com/d/168vKtAaLUA30_Cdj7oUbZSZnVDTnVEbj",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1Q3ISM9WbTOaKdvGnUjD-nInwVkMqHKeC",
      "b": "https://lh3.googleusercontent.com/d/10Dy5v5P7M0FN9WrZOaif4BkmryyFidt7",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1aHcxa73nbmJzOc6iMOU3ZItp5gUNHUA4",
      "b": "https://lh3.googleusercontent.com/d/179QpTNBvvWgkh6yucaiomg1tjQJwVlHV",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_9d529676-213e-4fba-bb5f-68a6832da979.jpg?v=1765415416"
   },
   "carat": 0.9,
   "caratMax": 6.4
  },
  {
   "rank": 549,
   "id": "gid://shopify/Product/7702551560376",
   "title": "1.21 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71941lb",
   "handle": "engagement-rings-71941lb",
   "priceNow": 2168.99,
   "priceWas": 6720.0,
   "pctOff": 68,
   "core": "71941",
   "inStock": true,
   "createdAt": "2024-05-20T17:26:05Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1qFnJTXVNFwIR_8ez6ynDX3fSYd-2VZif",
      "b": "https://lh3.googleusercontent.com/d/1DwbPuvmSIdPFr26HXSW1ZFrTL-344BUy",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1k03_g5h3ZLUFN8GsdbStJ8uxfVpZ45tc",
      "b": "https://lh3.googleusercontent.com/d/14NwcPV7LTw0JwORS-YrAyqdYCIQOoAPd",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Z6ZPeMDqwMB7-UnNl19rYb5pPH5NPdJa",
      "b": "https://lh3.googleusercontent.com/d/1-7ja7AlBbf9RATAfSHf42C5-uXdhi2j8",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_d19dc830-f0e8-4fee-8d42-0fa8e75879ab.jpg?v=1765415412"
   },
   "carat": 1.21
  },
  {
   "rank": 550,
   "id": "gid://shopify/Product/7702551134392",
   "title": "1.30-6.80 CT Princess Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-15705lb",
   "handle": "engagement-rings-15705lb",
   "priceNow": 2191.99,
   "priceWas": 6800.0,
   "pctOff": 68,
   "core": "15705",
   "inStock": true,
   "createdAt": "2024-05-20T17:25:43Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1VLBbVHWZXZLyIadSEpofYq1ZGpSDkrdr",
      "b": "https://lh3.googleusercontent.com/d/1o5fooo0ODD07SyVqCKQrHx70ILZ-3wfG",
      "angles": [
       1,
       2
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1LO7xjNpJDzYgfA4-5TUyCrrSt9Tcq1s7",
      "b": "https://lh3.googleusercontent.com/d/1OZ2oo7ghXAmmL3n-6lgzBGuikEBFZ1YU",
      "angles": [
       1,
       2
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1RLetan3YhEc6AMBOnQ63iq7nVHQH832g",
      "b": "https://lh3.googleusercontent.com/d/190UWT0R0n-h3q4Yz_fx9_iRN3A41Bgnu",
      "angles": [
       1,
       2
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_a159f32d-b239-45bf-b47d-c33cd3036180.jpg?v=1765415416"
   },
   "carat": 1.3,
   "caratMax": 6.8
  },
  {
   "rank": 551,
   "id": "gid://shopify/Product/7702550839480",
   "title": "1.10-6.60 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-15249lb",
   "handle": "engagement-rings-15249lb",
   "priceNow": 1791.99,
   "priceWas": 5560.0,
   "pctOff": 68,
   "core": "15249",
   "inStock": true,
   "createdAt": "2024-05-20T17:25:28Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1WNrscFUjne2zc0emG-Fig-worIbxvevr",
      "b": "https://lh3.googleusercontent.com/d/1RWPjvsq4H9g2N6aDDtn6hpOLL7k9Itvd",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1JJGP9Wk4gai6gxTV-VobF-tNLdJoq-NX",
      "b": "https://lh3.googleusercontent.com/d/1auKtvZ6spNxCxVPtXsoGdykEPnUMjOMO",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1iQESP_9aeLMbuVxQFTNyOLqQ5weJ9E0_",
      "b": "https://lh3.googleusercontent.com/d/1ysRXGPx2-g84z9g8AD4fA5AXp-6VxpXM",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_fe746ebb-95c4-4118-b6b1-461bf0bb807a.jpg?v=1765415416"
   },
   "carat": 1.1,
   "caratMax": 6.6
  },
  {
   "rank": 552,
   "id": "gid://shopify/Product/7702550446264",
   "title": "1.15-6.65 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71719lb",
   "handle": "engagement-rings-71719lb",
   "priceNow": 2009.99,
   "priceWas": 6230.0,
   "pctOff": 68,
   "core": "71719",
   "inStock": true,
   "createdAt": "2024-05-20T17:25:15Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1lXkgDEjd5baHBIx9G25JRv5RU--ZcQ6F",
      "b": "https://lh3.googleusercontent.com/d/11uQeF1YTlOx4RvZbHCLu_SL52tOHqm4W",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1_u6a3iVcdzWZ10ilVcqz_SgH5nrt32Bh",
      "b": "https://lh3.googleusercontent.com/d/1vqEvp1n1U_HKvTngVTVGNtOjv4mlE38x",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/110HyT4kDJ4Ni0wBfKxkr0PrteWwHFBWz",
      "b": "https://lh3.googleusercontent.com/d/1aIXXZyG3p6AKZ5AX8St7uYOMwiyTijbC",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_6e178979-7f32-4c77-b87a-261314a6c675.jpg?v=1765415418"
   },
   "carat": 1.15,
   "caratMax": 6.65
  },
  {
   "rank": 553,
   "id": "gid://shopify/Product/7702550085816",
   "title": "1.50-7.00 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-15390lb",
   "handle": "engagement-rings-15390lb",
   "priceNow": 2119.99,
   "priceWas": 6570.0,
   "pctOff": 68,
   "core": "15390",
   "inStock": true,
   "createdAt": "2024-05-20T17:25:04Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1b24r3wQJUqgIWjooool1yI8mHIcOoTUS",
      "b": "https://lh3.googleusercontent.com/d/13CKNDJH1CvFsHTkkHQyRfNy4sdcvVEsN",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1dtuxzrACO8L_5z4CPv6uv6Fo8__8qzO9",
      "b": "https://lh3.googleusercontent.com/d/1oiasT9f9_ln_7cTXrCXtwKMTCfDEDI0j",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/17YjQbYEeyxrOc2V8mUzgut7ZY-Cus_TV",
      "b": "https://lh3.googleusercontent.com/d/1SR58eTP_nZ_uH8DrSlJRqihMZXTIJ57q",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_a45ec3f0-73dc-4ed2-9fc6-d8f54e61aca6.jpg?v=1765415409"
   },
   "carat": 1.5,
   "caratMax": 7.0
  },
  {
   "rank": 554,
   "id": "gid://shopify/Product/7702549692600",
   "title": "0.90-6.40 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71697lb",
   "handle": "engagement-rings-71697lb",
   "priceNow": 1744.99,
   "priceWas": 5410.0,
   "pctOff": 68,
   "core": "71697",
   "inStock": true,
   "createdAt": "2024-05-20T17:24:52Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1e_Ldb-q3elgxUHaDmEd0oKp2fvLi_ztv",
      "b": "https://lh3.googleusercontent.com/d/1ndIxyEBOxKnGYkoEM_DcqbXVbBWxZFum",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1eBqqBGGt5Kil2eAUC31gRXmeK0oO5gN6",
      "b": "https://lh3.googleusercontent.com/d/1SI3tV0Ri2opuLnTea7GTj7yzMPcDpuk5",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1WEkl4JwzgUwOWcOPJqlEhQF6OyhSkEJp",
      "b": "https://lh3.googleusercontent.com/d/1pycrT52DCzuJMXD58Uup7eKRmLSyOc-B",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_1ec38829-0dfa-4c59-9daf-1f06f903d3c4.jpg?v=1765415417"
   },
   "carat": 0.9,
   "caratMax": 6.4
  },
  {
   "rank": 555,
   "id": "gid://shopify/Product/7702490742968",
   "title": "1.10-6.60 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-15238lb",
   "handle": "engagement-rings-15238lb",
   "priceNow": 1729.99,
   "priceWas": 5360.0,
   "pctOff": 68,
   "core": "15238",
   "inStock": true,
   "createdAt": "2024-05-20T16:59:45Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1lW3eaSEiZBZN3VycuF3fKJ7Vn5_hxbMJ",
      "b": "https://lh3.googleusercontent.com/d/19zb42LttTykZcN6dyIVderDYvMw7WYOx",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/10_yU_pmmfOJw5O0Q00uE1_gNiQoGFcXX",
      "b": "https://lh3.googleusercontent.com/d/1rigl7ftfH_ek8ohR3LT_KHR43PCgNRqM",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1cnWPjonohsDxVlyPLhZ7OAfEG-ZuiWGA",
      "b": "https://lh3.googleusercontent.com/d/1IWl_6F2-LsZbSfK1zggcnagj8VUbV2DU",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_fed48a06-061b-4ea6-96ce-01eb19707d82.jpg?v=1765415419"
   },
   "carat": 1.1,
   "caratMax": 6.6
  },
  {
   "rank": 556,
   "id": "gid://shopify/Product/7702490480824",
   "title": "1.40-6.90 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-15239lb",
   "handle": "engagement-rings-15239lb",
   "priceNow": 1814.99,
   "priceWas": 5630.0,
   "pctOff": 68,
   "core": "15239",
   "inStock": true,
   "createdAt": "2024-05-20T16:59:39Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1SBbZwJLQLmEWMS5uB7d_U_2ejCKOGBfN",
      "b": "https://lh3.googleusercontent.com/d/1RJAl1Su24REfP3dmkvR1k31xKymMd6-E",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1m7V6jlbM2F8GYmu7Qvhq-0ht29Jv6uam",
      "b": "https://lh3.googleusercontent.com/d/1FZVsjUKjjqK7Oqm6zOa4FGqSv6mmhUy2",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/13w-Oy-ntqosUB5qjM2evphpg_gjImuZA",
      "b": "https://lh3.googleusercontent.com/d/1ZJEexqbvc4g_fNpSNj5-4y6y19xvRYli",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_9425a9d1-bab7-48ad-9206-70aa6400379a.jpg?v=1765415409"
   },
   "carat": 1.4,
   "caratMax": 6.9
  },
  {
   "rank": 557,
   "id": "gid://shopify/Product/7702490185912",
   "title": "0.50-6.00 CT Round Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-71736lb",
   "handle": "solitaire-rings-71736lb",
   "priceNow": 1186.99,
   "priceWas": 3680.0,
   "pctOff": 68,
   "core": "71736",
   "inStock": true,
   "createdAt": "2024-05-20T16:59:34Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1mpleDnJ1bl6EH5nqH4bkVU-XcYrhG35s",
      "b": "https://lh3.googleusercontent.com/d/1Fi7ZshvQZeW0GCNLtzjAq5DsEE46cEsU",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1iyOHoRE-CibybNkbBFRVnHM7PFadmMxF",
      "b": "https://lh3.googleusercontent.com/d/1NUrJ_3rhlo6Pl3ZjSM4jn6rGAi50Swa9",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1GSHHp1PRJbZ3YUsDhqoVLvUDLJThDIbl",
      "b": "https://lh3.googleusercontent.com/d/1AzuuikpJW-lhVFcHETYfNlC4J4Hmqfno",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_d02dbd75-6cd3-4c29-93af-af1ccff7de0d.jpg?v=1763748627"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 558,
   "id": "gid://shopify/Product/7702489759928",
   "title": "1.05-6.55 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-16071lb",
   "handle": "engagement-rings-16071lb",
   "priceNow": 1890.99,
   "priceWas": 5860.0,
   "pctOff": 68,
   "core": "16071",
   "inStock": true,
   "createdAt": "2024-05-20T16:59:27Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1ocpIFEIQ50kFi9stNaV0TsG2Ow---J5_",
      "b": "https://lh3.googleusercontent.com/d/1UWxBwI53CqcwFFnE59Klzd3mpnF_e4cM",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1uC8VgNJrcrZ3z1pKqR65_37-qQ1GGIi6",
      "b": "https://lh3.googleusercontent.com/d/1ZkjdGsAGpDAkp6IUZa0oW0WF2FIXohnG",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1pHDtSZGCS1zsXMJZzyoGpa2ax5Kfirrs",
      "b": "https://lh3.googleusercontent.com/d/10a9l15IUaLepxWP8ekrWrSGeE3Ie8r7h",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_cb83bc11-51e3-4872-9f6f-daea3f7ce6ca.jpg?v=1765415410"
   },
   "carat": 1.05,
   "caratMax": 6.55
  },
  {
   "rank": 559,
   "id": "gid://shopify/Product/7690597269688",
   "title": "0.66-6.16 CT Radiant & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71836lb",
   "handle": "engagement-rings-71836lb",
   "priceNow": 2189.99,
   "priceWas": 6790.0,
   "pctOff": 68,
   "core": "71836",
   "inStock": true,
   "createdAt": "2024-05-16T17:38:43Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1AD3-pC4uDBhFhVeEGCj77No-jUw5T8xi",
      "b": "https://lh3.googleusercontent.com/d/1ichKOZ_0Opcp3yHKvSJAVn26jT0yXfiq",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1jWwnDgpFsAT5IyQFsaRD_2pb7zY8c9b9",
      "b": "https://lh3.googleusercontent.com/d/1SnCTVb_vBy6ApHdxpGfm6_umRtri2saQ",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Da2G3crYzqMi67v_hK5UbScm-mg48Jzx",
      "b": "https://lh3.googleusercontent.com/d/1oh7proN4gCLAJyYCt6wevWCKP3_5h0mI",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_a5ba81f1-be47-4c79-a0f5-4de2ae0a1e16.jpg?v=1765415416"
   },
   "carat": 0.66,
   "caratMax": 6.16
  },
  {
   "rank": 560,
   "id": "gid://shopify/Product/7690597171384",
   "title": "1.05-6.55 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-15224lb",
   "handle": "engagement-rings-15224lb",
   "priceNow": 1777.99,
   "priceWas": 5510.0,
   "pctOff": 68,
   "core": "15224",
   "inStock": true,
   "createdAt": "2024-05-16T17:38:36Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1ZrGAKJpWybCVFcLTG6kIh68CrhjIDUe-",
      "b": "https://lh3.googleusercontent.com/d/196K_uQPc46fOn5bpbinFKRx4QDcW3z3H",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1uILNqZwNUYhy-yCjo2n4ffIL9cQL5kb_",
      "b": "https://lh3.googleusercontent.com/d/1h4DWWfPN1Er92Yk0nQ9AdREUDFHohtXW",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1oaYqSEZPojoSkidKreSAvDrby20Xbcj-",
      "b": "https://lh3.googleusercontent.com/d/1iNnqZvpPhP3Z526fVCFIXyGCSEvfr3Bd",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_b2e1d1d5-2c41-473b-9a17-2d94ba2e9cb8.jpg?v=1765415416"
   },
   "carat": 1.05,
   "caratMax": 6.55
  },
  {
   "rank": 561,
   "id": "gid://shopify/Product/7690597040312",
   "title": "0.85-6.35 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71825lb",
   "handle": "engagement-rings-71825lb",
   "priceNow": 1631.99,
   "priceWas": 5060.0,
   "pctOff": 68,
   "core": "71825",
   "inStock": true,
   "createdAt": "2024-05-16T17:38:30Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/18e-4gC9hxGoqCXqmDLkbFRCKH69RRved",
      "b": "https://lh3.googleusercontent.com/d/1k5jr1Yy7ePBHZ-G8tSBuE_pqlHNO4CDh",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1cg6u3y1hfqa_7qi-1rNCiCb13vajg6hH",
      "b": "https://lh3.googleusercontent.com/d/1_QStGh_QvE3hcFwviVmwtvxPzlXWxGFc",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/12-XS9uFf-0-IxVCspY_EVXrfNQ6ZMLvt",
      "b": "https://lh3.googleusercontent.com/d/1R9KGPOJk-jhYezCLoqNsaPYpZBwLwiJg",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_91b3ddf9-228e-4f03-9239-6869ad5fc2ad.jpg?v=1765415415"
   },
   "carat": 0.85,
   "caratMax": 6.35
  },
  {
   "rank": 562,
   "id": "gid://shopify/Product/7690596876472",
   "title": "1.10-6.60 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-16050lb",
   "handle": "engagement-rings-16050lb",
   "priceNow": 1658.99,
   "priceWas": 5140.0,
   "pctOff": 68,
   "core": "16050",
   "inStock": true,
   "createdAt": "2024-05-16T17:38:23Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1oSieZncVwWNRHkuID8BiWx5MA-z4VOuW",
      "b": "https://lh3.googleusercontent.com/d/1YHEOnhvTldjUTR4QISxloQNWBUDp8rZv",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1Gjbm7PZRisJ-huITFE2KB8BYdz8xeHiG",
      "b": "https://lh3.googleusercontent.com/d/1YNJyWuBHQ8UVKRTAwlNVNynO48AAnW9m",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/10DdUfIOpLOnXO_3m7o_38a5s9s0tc4Nm",
      "b": "https://lh3.googleusercontent.com/d/11_JEItD_ZhTRpFss-rdIvlt04rnQK62a",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_37cdacb3-612f-42ad-94c8-df5195bbeda4.jpg?v=1765415415"
   },
   "carat": 1.1,
   "caratMax": 6.6
  },
  {
   "rank": 563,
   "id": "gid://shopify/Product/7690596647096",
   "title": "0.52-6.02 CT Radiant & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71855lb",
   "handle": "engagement-rings-71855lb",
   "priceNow": 1867.99,
   "priceWas": 5790.0,
   "pctOff": 68,
   "core": "71855",
   "inStock": true,
   "createdAt": "2024-05-16T17:38:15Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1bWpMoMc_aC5IN_kK_eHhgo2PpS_04UPP",
      "b": "https://lh3.googleusercontent.com/d/17ILcvWwKZ3NDqfrX_RvtGzjANDlDBOq_",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1ifIY5iW25kd2tzcMTMdAbDIdRhzI6Tme",
      "b": "https://lh3.googleusercontent.com/d/1E76YjM_G2kzE3G0SAvHEwKWqmxrkcC7F",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1pTFv4IAc8oLgfUMiedqQeloX1__-e9WC",
      "b": "https://lh3.googleusercontent.com/d/159d-Gd13EL5xS2QA39SKszQSyo82JEoA",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_1a01c4ba-a20c-449f-8be6-9213d86b2544.jpg?v=1765415415"
   },
   "carat": 0.52,
   "caratMax": 6.02
  },
  {
   "rank": 564,
   "id": "gid://shopify/Product/7690596483256",
   "title": "0.95-6.45 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71871lb",
   "handle": "engagement-rings-71871lb",
   "priceNow": 2016.99,
   "priceWas": 6250.0,
   "pctOff": 68,
   "core": "71871",
   "inStock": true,
   "createdAt": "2024-05-16T17:38:08Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1V4k-yDtDuo-3DWEFF2z2P0htX-HOv5-D",
      "b": "https://lh3.googleusercontent.com/d/1ZuPWiY7BXUmGSDI7FUoI0Ke8KlfS0QQh",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1rOeEHE5OgDeaAMTaWaPNysfovx2jV2o7",
      "b": "https://lh3.googleusercontent.com/d/1q7eE5tFAoQuf5_Lqduh8VjOwwZ8Bak6v",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1buaLkc8AasTJWayGqieKeT0ZqALCxnBN",
      "b": "https://lh3.googleusercontent.com/d/13W3fglm5MaNBsNmsrl5W4xr4TijWG9H8",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_1e7587d5-f06d-46cf-b1bc-dbb905e495a0.jpg?v=1765415411"
   },
   "carat": 0.95,
   "caratMax": 6.45
  },
  {
   "rank": 565,
   "id": "gid://shopify/Product/7690596319416",
   "title": "0.77-6.27 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71897lb",
   "handle": "engagement-rings-71897lb",
   "priceNow": 2080.99,
   "priceWas": 6450.0,
   "pctOff": 68,
   "core": "71897",
   "inStock": true,
   "createdAt": "2024-05-16T17:38:01Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/187NRQIiJC-kTDPjfXfzGy0_Cuk9L9_0g",
      "b": "https://lh3.googleusercontent.com/d/1s4yshsqS3Axana0t8K6jsOw0lG1odiy2",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1msEkFlAfupSrgc95A-P1zZQZYqCSzKAe",
      "b": "https://lh3.googleusercontent.com/d/1iFyWoxTzuFHjOzKR9jsP4QKJa7tol7Og",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1hl3_4ryRq-KNEDeMzgBe9J2kHXMqf9dX",
      "b": "https://lh3.googleusercontent.com/d/1wcGk39K0YNtGQQTcRRWw46QyQuIbVc_J",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_93896fd2-506f-4ec2-a028-af99d6f88baa.jpg?v=1765415416"
   },
   "carat": 0.77,
   "caratMax": 6.27
  },
  {
   "rank": 566,
   "id": "gid://shopify/Product/7690595958968",
   "title": "1.00-6.50 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71692lb",
   "handle": "engagement-rings-71692lb",
   "priceNow": 1896.99,
   "priceWas": 5880.0,
   "pctOff": 68,
   "core": "71692",
   "inStock": true,
   "createdAt": "2024-05-16T17:37:48Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1BcEd_LZaQF0QoImyxpwA3iSD8JiAoz6k",
      "b": "https://lh3.googleusercontent.com/d/1Twng0mZ93Yg1wQN9Z7xZmFc1HY6fPcs5",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/19I1CyOazJsd00DVwmpqXpUn8cY9P2AnN",
      "b": "https://lh3.googleusercontent.com/d/1nk4PFjpC0wJss2emtIKg9HQMx-R_z38D",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1IPiJnYVbr6Z5dU1zL2IniD1TlBQt_CIE",
      "b": "https://lh3.googleusercontent.com/d/1ymS4gB3QPeRyLW4Anfob1_QMooYmseYL",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_f848a53b-e365-4b7b-a1a3-37e0bfb82224.jpg?v=1765415415"
   },
   "carat": 1.0,
   "caratMax": 6.5
  },
  {
   "rank": 567,
   "id": "gid://shopify/Product/7690595762360",
   "title": "1.00-6.50 CT Princess Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-16074lb",
   "handle": "engagement-rings-16074lb",
   "priceNow": 1921.99,
   "priceWas": 5960.0,
   "pctOff": 68,
   "core": "16074",
   "inStock": true,
   "createdAt": "2024-05-16T17:37:43Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1ZN2MtCZPiyAfl69HdqHjbLmkl75PWCTR",
      "b": "https://lh3.googleusercontent.com/d/1b13nGG7dy8iVt6WdXuWWBAeG9vcP3FNe",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1umGk0IHlw9b1Y5GkOOLVtDMHs8YxuaA-",
      "b": "https://lh3.googleusercontent.com/d/1I3j_lmA-yJYPkzmapYjm_efyrm8r6UcR",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1xXlLO6UcpnCGjQAkk-QsO8FBKrN6Sma6",
      "b": "https://lh3.googleusercontent.com/d/1p2cMGfLsV9o6klYNmbkwe6vp0el-KahY",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_3d489a7b-d373-40f6-8ae6-5d2d39ea2016.jpg?v=1765415414"
   },
   "carat": 1.0,
   "caratMax": 6.5
  },
  {
   "rank": 568,
   "id": "gid://shopify/Product/7685898567864",
   "title": "0.70-6.20 CT Princess Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71824lb",
   "handle": "engagement-rings-71824lb",
   "priceNow": 1962.99,
   "priceWas": 6090.0,
   "pctOff": 68,
   "core": "71824",
   "inStock": true,
   "createdAt": "2024-05-14T18:17:42Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/12Ry8U1w18ybg4Mmzhja9VkRydUuhSder",
      "b": "https://lh3.googleusercontent.com/d/1iR_99w3FeXAE8_jLx4dOUFb7l7ssNek-",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1P0fnXN94gs41Qnxz6AeiN62XRP9Dr6LY",
      "b": "https://lh3.googleusercontent.com/d/1O23RoswryiUCQFsAM7nOzx-UlCREyAKn",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Xf_B-64Pc8mj02-ulIxyZCJfmwoEWabW",
      "b": "https://lh3.googleusercontent.com/d/18fsWOEAR8CrPoNY89T1LHPAJX9bisWDb",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_42c36333-f3b7-47b8-8033-ebdcd774f111.jpg?v=1765415419"
   },
   "carat": 0.7,
   "caratMax": 6.2
  },
  {
   "rank": 569,
   "id": "gid://shopify/Product/7685898469560",
   "title": "0.85-6.35 CT Ascher & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71932lb",
   "handle": "engagement-rings-71932lb",
   "priceNow": 1443.99,
   "priceWas": 4480.0,
   "pctOff": 68,
   "core": "71932",
   "inStock": true,
   "createdAt": "2024-05-14T18:17:35Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1WlZNL7g7yu6xZsLGxE8BqNQTk7BJdhen",
      "b": "https://lh3.googleusercontent.com/d/1Si0FUwPJRxVezTBF4y-kifupp7DHabu4",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1vzvhmXktxuo-PMuUJ5rpvfoHJDOvD0yV",
      "b": "https://lh3.googleusercontent.com/d/12WV-_JyRKP61ogf36crC1FMAox_E5vwH",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Wf1vPL8TVqyzgSFbxI4thuD47Z5Pz9AC",
      "b": "https://lh3.googleusercontent.com/d/1EZvBMNmc6WNuGg5ZF5WLnhR5Kuz3bZhe",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_d3fd24a1-963e-47f6-8439-d2a4d2c20f1f.jpg?v=1765415413"
   },
   "carat": 0.85,
   "caratMax": 6.35
  },
  {
   "rank": 570,
   "id": "gid://shopify/Product/7685898436792",
   "title": "0.80-6.30 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71807lb",
   "handle": "engagement-rings-71807lb",
   "priceNow": 1580.99,
   "priceWas": 4900.0,
   "pctOff": 68,
   "core": "71807",
   "inStock": true,
   "createdAt": "2024-05-14T18:17:28Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1_sYR0Lbf70xMTdRprDIiOt6d3HtbqOLs",
      "b": "https://lh3.googleusercontent.com/d/1zRlsH2q1gE47x2g1QqCCir586bF2ffNl",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1PToQ7VvtGUOedF0VMrNvhUgUlY9gyJEX",
      "b": "https://lh3.googleusercontent.com/d/1qm8pBLbuK81IQAfHzUXWRrkOqo1yJCHp",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1jV7Av8-yiFxSYm_TUHOjm7fUGEgcEvY1",
      "b": "https://lh3.googleusercontent.com/d/1eyYrRmCkYpHr57MSnnwXKVBZtJvScPlr",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_e4589003-67c4-4648-98ad-c6cbbff26faa.jpg?v=1765415459"
   },
   "carat": 0.8,
   "caratMax": 6.3
  },
  {
   "rank": 571,
   "id": "gid://shopify/Product/7685898305720",
   "title": "1.05-6.55 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-16010lb",
   "handle": "engagement-rings-16010lb",
   "priceNow": 1678.99,
   "priceWas": 5200.0,
   "pctOff": 68,
   "core": "16010",
   "inStock": true,
   "createdAt": "2024-05-14T18:17:22Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1ow0sm5Torf6CR1wJjzn822GEgcbNOoEQ",
      "b": "https://lh3.googleusercontent.com/d/15uLKDaDz_Qp_O7Mvma3917dJ1h5-Nvpk",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1MbASmhLrmMsuRUZJWTA4zKXte0wDLwk2",
      "b": "https://lh3.googleusercontent.com/d/1qWeO2Fwu9f6VeIyZy_vO2eRR_FDeGIsr",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1IqbZ0EguEBp7kA__ongFN6mrDjbB7vLa",
      "b": "https://lh3.googleusercontent.com/d/1FHVCoCIe70L-6MssaQC74e5ly_g-LKcM",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_228be854-a767-4df9-a5b1-418310f31291.jpg?v=1765415409"
   },
   "carat": 1.05,
   "caratMax": 6.55
  },
  {
   "rank": 572,
   "id": "gid://shopify/Product/7685898272952",
   "title": "0.85-6.35 CT Emerald & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71710lb",
   "handle": "engagement-rings-71710lb",
   "priceNow": 1623.99,
   "priceWas": 5030.0,
   "pctOff": 68,
   "core": "71710",
   "inStock": true,
   "createdAt": "2024-05-14T18:17:15Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/10OibzFd5CNrqwbZ6dwCsYsBUB50ECdCI",
      "b": "https://lh3.googleusercontent.com/d/1ytt7kYxHGCMLFUk0-FuY9u28AXxp6Oz3",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1dmc7-u4Aw4UOfDERA-aAzsR6PCLG6Rfl",
      "b": "https://lh3.googleusercontent.com/d/1-J3KRYPUiwroah4CA43E5oxgwVyHWZjo",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1LvL8GSO2oncHYVgpf0v0ar3S4DSz48sO",
      "b": "https://lh3.googleusercontent.com/d/1PMnXPzU0SJ0dTIY8TJomBmlHdmYc6ASj",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_e50271bf-bc07-495e-97ce-89ca0379079c.jpg?v=1765415419"
   },
   "carat": 0.85,
   "caratMax": 6.35
  },
  {
   "rank": 573,
   "id": "gid://shopify/Product/7685898174648",
   "title": "0.85-6.35 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71769lb",
   "handle": "engagement-rings-71769lb",
   "priceNow": 1959.99,
   "priceWas": 6080.0,
   "pctOff": 68,
   "core": "71769",
   "inStock": true,
   "createdAt": "2024-05-14T18:17:08Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1Dm7FumQCifpJ7-ZgLBlV3l3v-pit3-DN",
      "b": "https://lh3.googleusercontent.com/d/1KAVjtgf8UjS5tXjjIZYFytejS5LyMPB4",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1fQ9UMhSGIGWTQoZMRQQNsY8lWPoZToH1",
      "b": "https://lh3.googleusercontent.com/d/1vbQom6qRhp8TkdICb4nTqkh87EbUgk_G",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/151AzkHQWEG7joy5TISw9bxui1bZHdgZi",
      "b": "https://lh3.googleusercontent.com/d/1ZzwL-TN-ogGifdXfLD6UdsUsSQ97sNDu",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_43a9e5a0-060b-4794-88f8-4980d8bd8f66.jpg?v=1765415413"
   },
   "carat": 0.85,
   "caratMax": 6.35
  },
  {
   "rank": 574,
   "id": "gid://shopify/Product/7685898109112",
   "title": "1.90-7.40 CT Princess Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-15701lb",
   "handle": "bridal-sets-15701lb",
   "priceNow": 3064.99,
   "priceWas": 9500.0,
   "pctOff": 68,
   "core": "15701",
   "inStock": true,
   "createdAt": "2024-05-14T18:16:57Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1D6SyAt-h3zpTiHLlcCps9aPisonI7klH",
      "b": "https://lh3.googleusercontent.com/d/16a7y3uo2d7YIWmZQs-GSUvuZrdG8bDVI",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1sCZWbaVGU7md17l2gNqn5aKorWQvO5CT",
      "b": "https://lh3.googleusercontent.com/d/1k8c4r0V2bvBFQiz74uhUWMfFrwsH5OU5",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1xPeN5ELkE4DFda7OlDdb84HT7sWcDRbR",
      "b": "https://lh3.googleusercontent.com/d/1yqzJAh_JJIyV2XwUMb_7Tnf4q2IaPDN4",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_e3df5ed2-0f80-404a-9e11-e6de9b1f768b.jpg?v=1715883509"
   },
   "carat": 1.9,
   "caratMax": 7.4
  },
  {
   "rank": 575,
   "id": "gid://shopify/Product/7685897846968",
   "title": "2.75-8.25 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-16067lb",
   "handle": "bridal-sets-16067lb",
   "priceNow": 3549.99,
   "priceWas": 11000.0,
   "pctOff": 68,
   "core": "16067",
   "inStock": true,
   "createdAt": "2024-05-14T18:16:43Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/19GHW8I5wriPqYM2Cjfqtxpo6yLtKzNN9",
      "b": "https://lh3.googleusercontent.com/d/162FX8D4W3oXpL1kp8kfvjgkDzK07wQFF",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1a43O_L_O-9TrJ7Ruv2i6bgNjz-RChQqH",
      "b": "https://lh3.googleusercontent.com/d/14L7yKtEL7dmigLEGN6Ssr1PMU-ns9GCY",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1y9EqgLdqdeYliVr3-qFXa1wA_5i8TWyO",
      "b": "https://lh3.googleusercontent.com/d/1h2qnzfNOegOnjIlJCJsCcS5rLVAw_gaQ",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_01ba5ad5-f9ca-416e-b09c-ba3b8afae599.jpg?v=1715881995"
   },
   "carat": 2.75,
   "caratMax": 8.25
  },
  {
   "rank": 576,
   "id": "gid://shopify/Product/7685897650360",
   "title": "0.70-6.20 CT Pear & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110399lb",
   "handle": "bridal-sets-110399lb",
   "priceNow": 2599.99,
   "priceWas": 8060.0,
   "pctOff": 68,
   "core": "110399",
   "inStock": true,
   "createdAt": "2024-05-14T18:16:29Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1gDATybhbl45TPJgVdp-g_Nfthf_8zBet",
      "b": "https://lh3.googleusercontent.com/d/1aTWX5uG3IinWLIfGduxIHCYU8Qz3Hh6E",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1OmscdjHavB5LIQDU0qzE0a7JY8IaHrLe",
      "b": "https://lh3.googleusercontent.com/d/1mokOLflayN9iJ6VJKJEhmud4GSfFin8C",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/13xb9BuohlKH6IkIzQ0zK_LAHPR8dlY1W",
      "b": "https://lh3.googleusercontent.com/d/1CQhXaVCSR6PxT9roSWxVNxMVCsw83xL0",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_b680222a-7137-4ad8-8f75-4592c8035023.jpg?v=1715711705"
   },
   "carat": 0.7,
   "caratMax": 6.2
  },
  {
   "rank": 577,
   "id": "gid://shopify/Product/7664254582968",
   "title": "0.75-6.25 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110320lb",
   "handle": "bridal-sets-110320lb",
   "priceNow": 2601.99,
   "priceWas": 8070.0,
   "pctOff": 68,
   "core": "110320",
   "inStock": true,
   "createdAt": "2024-04-30T15:38:37Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/11WW8R3xzxUMhnVNYrUY6gDLEAUymcsG3",
      "b": "https://lh3.googleusercontent.com/d/1T4h9f1D7J7kjmnVL7I3W5TiZdqPXmdDA",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1udPmol4o0omWLM7s_o7MRPSiYEHDq1gp",
      "b": "https://lh3.googleusercontent.com/d/19eM10Nfp3_5y6_snXfSfXNIhptLEv4sn",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1UUbt5DzxLW1n0ejNSho9IcyHBzF5_ffP",
      "b": "https://lh3.googleusercontent.com/d/1RfGG2o-uhaMLPEsjHoJzFTsOYMHmxv_W",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_09a4f940-daef-4332-97a3-f22a6c5e2b0b.jpg?v=1714497337"
   },
   "carat": 0.75,
   "caratMax": 6.25
  },
  {
   "rank": 578,
   "id": "gid://shopify/Product/7664254484664",
   "title": "0.70-6.20 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110321lb",
   "handle": "bridal-sets-110321lb",
   "priceNow": 3937.99,
   "priceWas": 12210.0,
   "pctOff": 68,
   "core": "110321",
   "inStock": true,
   "createdAt": "2024-04-30T15:38:31Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_bed36e2c-49d4-47cd-8538-f30451decc9b.jpg?v=1714497277",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_bed36e2c-49d4-47cd-8538-f30451decc9b.jpg?v=1714497277",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y3_bccb704a-ebe3-47af-bdc7-cb0abd9ed62e.jpg?v=1763698152",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r3_45f4f3c9-5bc0-462d-b45c-8d75d9636d67.jpg?v=1763698152"
    }
   },
   "carat": 0.7,
   "caratMax": 6.2
  },
  {
   "rank": 579,
   "id": "gid://shopify/Product/7664254386360",
   "title": "1.00-6.50 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110327lb",
   "handle": "bridal-sets-110327lb",
   "priceNow": 4000.99,
   "priceWas": 12400.0,
   "pctOff": 68,
   "core": "110327",
   "inStock": true,
   "createdAt": "2024-04-30T15:38:25Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1GueffrglD1f1q6L2-NMO_YzH7e-rqy5z",
      "b": "https://lh3.googleusercontent.com/d/1ZErmFmkWKy6Tv-nmz4wzm064E8zDV2WN",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1kZ15je_9OAEhglVO0KJyvKBECh7ag7NX",
      "b": "https://lh3.googleusercontent.com/d/1QEu_qj3ewzSG_1_q2D7TU3ueBJ8B3Pjf",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/15mExEobuk5l-hu7e7pzmPrhVgNZW_Ylu",
      "b": "https://lh3.googleusercontent.com/d/12wz0_7-cffwTKvXieSizZ6ZhTkneZ-wy",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_7c2c1126-82e4-4b7d-b06a-27ad12bab178.jpg?v=1714497196"
   },
   "carat": 1.0,
   "caratMax": 6.5
  },
  {
   "rank": 580,
   "id": "gid://shopify/Product/7664254320824",
   "title": "0.85-6.35 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110332lb",
   "handle": "bridal-sets-110332lb",
   "priceNow": 3997.99,
   "priceWas": 12390.0,
   "pctOff": 68,
   "core": "110332",
   "inStock": true,
   "createdAt": "2024-04-30T15:38:19Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1kFylmssf2TJ3TDBxtQi29hMDfJ_Y6jMe",
      "b": "https://lh3.googleusercontent.com/d/1JAhYra-u1RAT0B6tPUwTOH7hQgREBAxE",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1KUenMmdMIJXyq_nCo_kYQUL6f4Z-g0rp",
      "b": "https://lh3.googleusercontent.com/d/17_0FZVlwoIYaR13Yk-UM5ruBKxz_RBgi",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/18UWT2xpBWKzajZ1iLsBwPFA2pPte349J",
      "b": "https://lh3.googleusercontent.com/d/1E3wbs1RXQAxlyUC_oGq4UwhA7KTVx-Xw",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_8a48eb56-f2a0-4c7f-882f-379552438adb.jpg?v=1714497132"
   },
   "carat": 0.85,
   "caratMax": 6.35
  },
  {
   "rank": 581,
   "id": "gid://shopify/Product/7664254091448",
   "title": "1.20-6.70 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110357lb",
   "handle": "bridal-sets-110357lb",
   "priceNow": 2804.99,
   "priceWas": 8700.0,
   "pctOff": 68,
   "core": "110357",
   "inStock": true,
   "createdAt": "2024-04-30T15:38:07Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1nhKN3Pk4iysvlog31i_hgLWMW4cvJjEj",
      "b": "https://lh3.googleusercontent.com/d/1PoA_EdU_w3wnj86oh3YYmarEWT0qT4mc",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1edb6sFMAtkGgEqi4_ZewhCn1O3Vj5NA6",
      "b": "https://lh3.googleusercontent.com/d/1IO25cl7NCoYYZApHHR8nWPjn-zkVFtoD",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1qaJKacT_FfwpgaTXfiGD3mBl05axmQEY",
      "b": "https://lh3.googleusercontent.com/d/1LRhFfYe1is19nj-C8NnzB8OTsEqNWox9",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_b4c11a33-9c85-455f-a61f-039b5c356b57.jpg?v=1714496957"
   },
   "carat": 1.2,
   "caratMax": 6.7
  },
  {
   "rank": 582,
   "id": "gid://shopify/Product/7664254025912",
   "title": "2.30-7.80 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-71788lb",
   "handle": "bridal-sets-71788lb",
   "priceNow": 3572.99,
   "priceWas": 11080.0,
   "pctOff": 68,
   "core": "71788",
   "inStock": true,
   "createdAt": "2024-04-30T15:38:03Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1mcKvG_WdQTGIyNWhvWwasG4CBM4Ri9i4",
      "b": "https://lh3.googleusercontent.com/d/1H_RLVLRT0FNMLTnIjjDST6Amhd2ThNvD",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1cQywzsC0DKzhOKTeiJYb6pxuhZ7OJsys",
      "b": "https://lh3.googleusercontent.com/d/19aNFcOpcnQnuRLXlyF-ajyH3qMfPXZ50",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1DK4lDPVGrztW17ZnkW7a-00SWSc4-aeB",
      "b": "https://lh3.googleusercontent.com/d/1MTXWNsZD-j6PD_KEpE2PBS7RiPYbF5Sd",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_09f0ed20-e6e4-4177-a8a3-90fad5a19b3f.jpg?v=1714496845"
   },
   "carat": 2.3,
   "caratMax": 7.8
  },
  {
   "rank": 583,
   "id": "gid://shopify/Product/7664253993144",
   "title": "1.90-7.40 CT Emerald & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-71822lb",
   "handle": "bridal-sets-71822lb",
   "priceNow": 2648.99,
   "priceWas": 8210.0,
   "pctOff": 68,
   "core": "71822",
   "inStock": true,
   "createdAt": "2024-04-30T15:37:57Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1coftULuLWInb9YhCEaHunIgVJjxbu3qn",
      "b": "https://lh3.googleusercontent.com/d/1rmEvtEIqQgjnOhGsOEVyFyCuoe-j0rPy",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1M6KblzxA3wu1KCcYFuSdASwYK_BF9o-x",
      "b": "https://lh3.googleusercontent.com/d/1ehVNnWKWJnlvvu_xNZ1RrKX001vvsaER",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ILrzqI8HoIS2nilMKZu28qo7FJtiRxQK",
      "b": "https://lh3.googleusercontent.com/d/1gTxKmn-o5XIX2mRCKt4IhFoXCRskSPGa",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_28eda8b6-401b-44d4-9173-a0497c7670cb.jpg?v=1714496773"
   },
   "carat": 1.9,
   "caratMax": 7.4
  },
  {
   "rank": 584,
   "id": "gid://shopify/Product/7664253796536",
   "title": "1.00-6.50 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110330lb",
   "handle": "bridal-sets-110330lb",
   "priceNow": 3070.99,
   "priceWas": 9520.0,
   "pctOff": 68,
   "core": "110330",
   "inStock": true,
   "createdAt": "2024-04-30T15:37:44Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1O8xoIXdPDlAGArSYSAR9wG_1gX_g-yhX",
      "b": "https://lh3.googleusercontent.com/d/1tbQQV6fxioPOOkwar1SCCUp6d76s9NeW",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1S-AEhttbu0sfqsFi-V0r4ZvI85wTQL3a",
      "b": "https://lh3.googleusercontent.com/d/1GgT-HjaPzMW6SGGV-2K_DySf0HPM-Vna",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1W7I9ApV_WTFauqEsyIGsctSPUjS5qkIc",
      "b": "https://lh3.googleusercontent.com/d/1hJqouC-WLhjWfplQZd0cxRx5wMkkiDYY",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_097d62bd-b831-4f16-857f-6625994cfb55.jpg?v=1714496692"
   },
   "carat": 1.0,
   "caratMax": 6.5
  },
  {
   "rank": 585,
   "id": "gid://shopify/Product/7664253698232",
   "title": "1.05-6.55 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110344lb",
   "handle": "bridal-sets-110344lb",
   "priceNow": 4299.99,
   "priceWas": 13330.0,
   "pctOff": 68,
   "core": "110344",
   "inStock": true,
   "createdAt": "2024-04-30T15:37:38Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1IMEnHephEnqwnLHLinwtM4Us0vrw3cIm",
      "b": "https://lh3.googleusercontent.com/d/1Mu2pQp9EjEk7ZmhllQcCHideCYfKUSuN",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1LSyRcMtWFRquaVUXnXDmx6qVcsxoDeUY",
      "b": "https://lh3.googleusercontent.com/d/1R2mPjRK3FUo8DvlT2YxiRcVLa5XnLF-k",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1KNxLu5wj0NTptmyHwtN4wqoTS_tyVNk8",
      "b": "https://lh3.googleusercontent.com/d/1ZHqUyiTKG-C9Pe3EiIxKbWMcNOYFR9-R",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_91c06e0f-a122-4ca1-8f0e-cd81d123ab8c.jpg?v=1714496616"
   },
   "carat": 1.05,
   "caratMax": 6.55
  },
  {
   "rank": 586,
   "id": "gid://shopify/Product/7664253534392",
   "title": "1.10-6.60 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110395lb",
   "handle": "bridal-sets-110395lb",
   "priceNow": 2645.99,
   "priceWas": 8200.0,
   "pctOff": 68,
   "core": "110395",
   "inStock": true,
   "createdAt": "2024-04-30T15:37:28Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/10ttLx-KJzTYm1rvXv8J86hnyeLhyo2Eg",
      "b": "https://lh3.googleusercontent.com/d/13RrKSsZJopxcqS5kSDUWulPHVzt5fnJn",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1YdZd3Vx0qQzmUl5dANxuoR8R_Kb0blBS",
      "b": "https://lh3.googleusercontent.com/d/1mCqPUWUnrTnwMxn35JlPHXOcG2zst-Fw",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1xsaYdOSEPje0CsD2CurVXXok7jQkxlEz",
      "b": "https://lh3.googleusercontent.com/d/103IF7CdPPtr0o9fAQacraLpqT3p_xdLz",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_483201dd-7ab2-4361-a05b-7877706d3fe9.jpg?v=1714497430"
   },
   "carat": 1.1,
   "caratMax": 6.6
  },
  {
   "rank": 587,
   "id": "gid://shopify/Product/7664253403320",
   "title": "1.05-6.55 CT Marquise & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110401lb",
   "handle": "bridal-sets-110401lb",
   "priceNow": 3717.99,
   "priceWas": 11530.0,
   "pctOff": 68,
   "core": "110401",
   "inStock": true,
   "createdAt": "2024-04-30T15:37:16Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1W3SxV6XxJmxPZO0fU2ZzD2AqJV2oj7pq",
      "b": "https://lh3.googleusercontent.com/d/1WVUuPKnj3zqY86S7kcyH-fkeN26svuoQ",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1uc36fsqUEI79dmsoUq4VQPiXL_rmtVKG",
      "b": "https://lh3.googleusercontent.com/d/1UQXvkZjnOTvKulglwJw3v5YYx-QhDRcz",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1I5YByUdp3S6m9juIC8mPY2ijkMZCkyS9",
      "b": "https://lh3.googleusercontent.com/d/11qESQVGe2OwFuGeYcAHPLH0ozDmDOToB",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_ca845341-bc0a-4a56-84f4-64a9d1369eb1.jpg?v=1714495955"
   },
   "carat": 1.05,
   "caratMax": 6.55
  },
  {
   "rank": 588,
   "id": "gid://shopify/Product/7664253337784",
   "title": "0.95-6.45 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-110403lb",
   "handle": "bridal-sets-110403lb",
   "priceNow": 3406.99,
   "priceWas": 10560.0,
   "pctOff": 68,
   "core": "110403",
   "inStock": true,
   "createdAt": "2024-04-30T15:37:12Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1OmNH-cJ7FTTEVF4mj13RcKZM673XWdoM",
      "b": "https://lh3.googleusercontent.com/d/1iO-UKl7F3dwMG9VEChDkN9iViBA4lVL_",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1rGkYWb1XFpKtPGm7w8U6kKTDAY1wLHB2",
      "b": "https://lh3.googleusercontent.com/d/1cSqbJ72E6j1F74ltcUYb5Nig8BTh37UH",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1OO2pMIsnwrHvT3pDqQKRU_c6VWJrdqYO",
      "b": "https://lh3.googleusercontent.com/d/1T2tb3T_CxthOy8H-9POr2BPTMjHGGJid",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_8c2e52c8-d1bd-4d83-a9ef-c18eff6f7e5c.jpg?v=1714495444"
   },
   "carat": 0.95,
   "caratMax": 6.45
  },
  {
   "rank": 589,
   "id": "gid://shopify/Product/7664253239480",
   "title": "1.70-7.20 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-15338lb",
   "handle": "bridal-sets-15338lb",
   "priceNow": 2876.99,
   "priceWas": 8920.0,
   "pctOff": 68,
   "core": "15338",
   "inStock": true,
   "createdAt": "2024-04-30T15:37:03Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1BQOKvnOjV-XZrM0v7cxsAO71D1Izq6GH",
      "b": "https://lh3.googleusercontent.com/d/1IuW9rnzupdI_TYCpYg-k3DIyLRPjr7jz",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1EfbVlQgKGhhVZ2Ta0dCeJZTZY0Mj1s9-",
      "b": "https://lh3.googleusercontent.com/d/1ynw4cK42bc0uzZqCkb-lJYc6n2AazSXu",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1UhCXuH2NmcKYujLYt9h_Y1-ntZZ_9ddr",
      "b": "https://lh3.googleusercontent.com/d/17yN5zVowjn_cfoOU7WatYFiXeHqHIA0O",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_35348c73-3534-4ff9-8036-9ec690bdf1fd.jpg?v=1763698153"
   },
   "carat": 1.7,
   "caratMax": 7.2
  },
  {
   "rank": 590,
   "id": "gid://shopify/Product/7641272910008",
   "title": "1.70-7.20 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-15339lb",
   "handle": "bridal-sets-15339lb",
   "priceNow": 3438.99,
   "priceWas": 10660.0,
   "pctOff": 68,
   "core": "15339",
   "inStock": true,
   "createdAt": "2024-04-26T15:52:52Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1pFxUcg33CgLlYqBizNBhwGeHonjFsrEc",
      "b": "https://lh3.googleusercontent.com/d/1ZNuucI4fIZUQPA9Ds3HZAztxNZbXnxI3",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1Su1ai7o9sXk1r_OAzY-JH9k0MtCN7DWt",
      "b": "https://lh3.googleusercontent.com/d/1Lr8Vb1nTuhgaPn8Cg150ONVfu6aUNYal",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1CXenP2y6Khk6xlLSFvpcqwut9wZX31oq",
      "b": "https://lh3.googleusercontent.com/d/1ysywAqBNjMkBrCn5YymArrJp9AumxCyo",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/wy3_530625c2-c68f-4426-a73c-29ae1bcc252c.jpg?v=1763698153"
   },
   "carat": 1.7,
   "caratMax": 7.2
  },
  {
   "rank": 591,
   "id": "gid://shopify/Product/7641272680632",
   "title": "3.05-8.55 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-15348lb",
   "handle": "bridal-sets-15348lb",
   "priceNow": 3164.99,
   "priceWas": 9810.0,
   "pctOff": 68,
   "core": "15348",
   "inStock": true,
   "createdAt": "2024-04-26T15:52:38Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1ep8z03t8Yzr6fPjxBizqGsuRmfSPqN1w",
      "b": "https://lh3.googleusercontent.com/d/14yoys_3rXJNr4haC3sruSWn4QAUh9q9R",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1T_Nc6VaD8FUyMf2pZBAdBfgQCGJE4NB5",
      "b": "https://lh3.googleusercontent.com/d/1k0MenYQvShWc9AyzwW803KwEPG-d-P7d",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1UJYLr39ZEf0vKY4wnrHaLQeA99DstyDz",
      "b": "https://lh3.googleusercontent.com/d/1attOpYRbuiAq93-qD-aaOoSgemHid_eR",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_7aee729c-b3e5-449d-b2bc-ff4337f61c4c.jpg?v=1714155330"
   },
   "carat": 3.05,
   "caratMax": 8.55
  },
  {
   "rank": 592,
   "id": "gid://shopify/Product/7641272549560",
   "title": "2.15-7.65 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-16003lb",
   "handle": "bridal-sets-16003lb",
   "priceNow": 2806.99,
   "priceWas": 8700.0,
   "pctOff": 68,
   "core": "16003",
   "inStock": true,
   "createdAt": "2024-04-26T15:52:31Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1FK8fJLibK7K96HVS5rWlfvTjALyO9AgF",
      "b": "https://lh3.googleusercontent.com/d/17SttIJNMrYO8CeQnVkppCoDZuHs7_DI0",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1PR05ojBgOpgbEYSZD_dKNSXA5-JAEkFa",
      "b": "https://lh3.googleusercontent.com/d/1vspdy5JI3dbmD51kMhNZ76l-_1l5QjlM",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/15WN88YZ-r6qa9RRbKdEyDgEp2LAliOEz",
      "b": "https://lh3.googleusercontent.com/d/199ZcPQTS8X2FmRazJxoNb08ETWLt3elh",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_fe6ae4c9-170b-43b1-836a-e90e2618fafc.jpg?v=1714155272"
   },
   "carat": 2.15,
   "caratMax": 7.65
  },
  {
   "rank": 593,
   "id": "gid://shopify/Product/7641272352952",
   "title": "2.75-8.25 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-16066lb",
   "handle": "bridal-sets-16066lb",
   "priceNow": 3604.99,
   "priceWas": 11180.0,
   "pctOff": 68,
   "core": "16066",
   "inStock": true,
   "createdAt": "2024-04-26T15:52:17Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1V5rOVs6WkCB_nYOsgaEk__vsKPVuyVHK",
      "b": "https://lh3.googleusercontent.com/d/1OWbjHQwBo_wfjn5w6TLDCdYdF6xXiSzr",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1fYjfTeApfxO-mbQuk6fWo3Yh4hDjZcpc",
      "b": "https://lh3.googleusercontent.com/d/1sf8OHMJ5ALaH8yqqYvusSXkofZhZv8Ah",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1iiiuUEw3bNaVfSLUIaHk9Mjm62F_JrMJ",
      "b": "https://lh3.googleusercontent.com/d/1P9_MZ4RvSc3-x_dcDGTpzWssweOam5e3",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_053a3d0f-9258-496c-bdfd-d3b188c00121.jpg?v=1714154894"
   },
   "carat": 2.75,
   "caratMax": 8.25
  },
  {
   "rank": 594,
   "id": "gid://shopify/Product/7641272156344",
   "title": "2.45-7.95 CT Princess Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-71616lb",
   "handle": "bridal-sets-71616lb",
   "priceNow": 4017.99,
   "priceWas": 12460.0,
   "pctOff": 68,
   "core": "71616",
   "inStock": true,
   "createdAt": "2024-04-26T15:52:01Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1VIvBthqB96wQ1DLG1u6gTh_qLqKp__4m",
      "b": "https://lh3.googleusercontent.com/d/15cO8H3fTzV8MbARWmQ0yqnfLDVe_Ikku",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/10wvpcxDBiDSUQ5SWKyNaRmPfMrx3u6o2",
      "b": "https://lh3.googleusercontent.com/d/1d0xQ4GW4hb8xOwIIxAF8w0qZojSM5iee",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1SNP8ptZUghRMl7tX663OnlUqAgMvFiNl",
      "b": "https://lh3.googleusercontent.com/d/19riZFHBW70bU_Ck4nvWnkX2nV0Z20y_G",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_5c0739c8-b108-4e34-b8f1-902fc2ccb03f.jpg?v=1714154569"
   },
   "carat": 2.45,
   "caratMax": 7.95
  },
  {
   "rank": 595,
   "id": "gid://shopify/Product/7641272090808",
   "title": "2.30-7.80 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-71620lb",
   "handle": "bridal-sets-71620lb",
   "priceNow": 5028.99,
   "priceWas": 14580.0,
   "pctOff": 66,
   "core": "71620",
   "inStock": true,
   "createdAt": "2024-04-26T15:51:53Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1EWbeAaYOpBpbQSeWi4R7bJxxWfHPO8m2",
      "b": "https://lh3.googleusercontent.com/d/1FJyS4wrSNZFgkjCbKbcV2d1xXM7wjlMy",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/14KUlHdapWzMxNd6PDOFxMIJDX87JNhJO",
      "b": "https://lh3.googleusercontent.com/d/1ReMhtfDtq4sJN0j8WV3yIMv4VEKI7N-2",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/12vfvIwWZnKQkHq8d1hIq8p9t95a8R9_-",
      "b": "https://lh3.googleusercontent.com/d/1MWdoEO4jFTM4by3kQbhclpwqfpFImLEo",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_a6ea0cee-60f3-4a44-b8ba-34cfc272fdab.jpg?v=1714154445"
   },
   "carat": 2.3,
   "caratMax": 7.8
  },
  {
   "rank": 596,
   "id": "gid://shopify/Product/7641271992504",
   "title": "1.90-7.40 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-71653lb",
   "handle": "bridal-sets-71653lb",
   "priceNow": 2485.99,
   "priceWas": 7710.0,
   "pctOff": 68,
   "core": "71653",
   "inStock": true,
   "createdAt": "2024-04-26T15:51:47Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/11QfPuaL2o2x1JAongMEBWCMVVQuynFqY",
      "b": "https://lh3.googleusercontent.com/d/1QZ2satvSUQcIrpyel3UWDimU5gScUWkF",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/10F7GoZNXiACauSb7u0-GwjrC3VK0O7aO",
      "b": "https://lh3.googleusercontent.com/d/1gmutGM_mBUKOuZGPLkDu4f0GoXYXrhbV",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/193mVfURqXKulDwDc1uStYUQCAT1SfP-b",
      "b": "https://lh3.googleusercontent.com/d/1EEAxEMpcpriEEnXaL5HkqakTtYNl9nYn",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_48cf50bf-106e-4328-be16-aa4b2f678deb.jpg?v=1714151286"
   },
   "carat": 1.9,
   "caratMax": 7.4
  },
  {
   "rank": 597,
   "id": "gid://shopify/Product/7641271894200",
   "title": "2.20-7.70 CT Princess Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-15707lb",
   "handle": "bridal-sets-15707lb",
   "priceNow": 3422.99,
   "priceWas": 10610.0,
   "pctOff": 68,
   "core": "15707",
   "inStock": true,
   "createdAt": "2024-04-26T15:51:41Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1rLNQNKdUHSTWEDnJFaKwopICY99WZQXW",
      "b": "https://lh3.googleusercontent.com/d/18oSsN90VDKexI4r_JUUmgKlq1Th35hp4",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1S0PtPI6QH2pzDjGTjaC73CLG1ZJBd9J1",
      "b": "https://lh3.googleusercontent.com/d/1TTJ6KypXB9_O4Uc10EI2i4ZT4b-c7j4a",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1LJ8U38Rof2cncP9XKJvDFXk3-DOoU4zf",
      "b": "https://lh3.googleusercontent.com/d/1LakOTIErFDbhPlTHzfsmtabQDVV8oeFW",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_93dd80fc-c693-4434-a0df-3a31e8b0747c.jpg?v=1714150756"
   },
   "carat": 2.2,
   "caratMax": 7.7
  },
  {
   "rank": 598,
   "id": "gid://shopify/Product/7641271599288",
   "title": "3.35-8.85 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-15684lb",
   "handle": "bridal-sets-15684lb",
   "priceNow": 3689.99,
   "priceWas": 11440.0,
   "pctOff": 68,
   "core": "15684",
   "inStock": true,
   "createdAt": "2024-04-26T15:51:23Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1oigIYbB3XmasFtacLyKvYHHJYKYQjREB",
      "b": "https://lh3.googleusercontent.com/d/1OLzGVo3p_XxChcgI8Vo3a0dCRZQ4IUMz",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/19L6GUk-BmHH0r9-HiFC0KrgsWrOOzwr_",
      "b": "https://lh3.googleusercontent.com/d/1-_1Tln0iJw6rxCLKs5aFL-ilshdffyl7",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/198t3mm11LiFSVTSVHIvifMKwH1Z7dPtd",
      "b": "https://lh3.googleusercontent.com/d/1fswSg-QRJrUNs07TQ2o1D0xUuCxO5wKL",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_875e89b2-2ed7-4b95-ad78-46001da4f775.jpg?v=1714150444"
   },
   "carat": 3.35,
   "caratMax": 8.85
  },
  {
   "rank": 599,
   "id": "gid://shopify/Product/7641271468216",
   "title": "1.60-7.10 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-15649lb",
   "handle": "bridal-sets-15649lb",
   "priceNow": 3005.99,
   "priceWas": 9320.0,
   "pctOff": 68,
   "core": "15649",
   "inStock": true,
   "createdAt": "2024-04-26T15:51:15Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1jNTA7UK4mVbFr9mvlgWUl2lJRWvuLkMK",
      "b": "https://lh3.googleusercontent.com/d/1B8Aiu9lbmlas1vAQsjFIY1XxubAu35Gu",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1O-DkkunotOmpdLF4Lz08rkhLOkpJKIkt",
      "b": "https://lh3.googleusercontent.com/d/1l30fGCE9y4EB9psBzRrc5rOU2_eooRJe",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1VsmsuoSqINtsP4WRnM2KwejtcdBKob00",
      "b": "https://lh3.googleusercontent.com/d/1oQZO_iTOKHI_-Fp_s-8kkhcN_mk3rSvk",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_2ecefbc1-62e4-4282-bea3-752cdbee9205.jpg?v=1714150160"
   },
   "carat": 1.6,
   "caratMax": 7.1
  },
  {
   "rank": 600,
   "id": "gid://shopify/Product/7641270812856",
   "title": "1.20-6.70 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/bridal-sets-71779lb",
   "handle": "bridal-sets-71779lb",
   "priceNow": 2235.99,
   "priceWas": 6930.0,
   "pctOff": 68,
   "core": "71779",
   "inStock": true,
   "createdAt": "2024-04-26T15:50:38Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1x70MSGlhBsLoFliD6ZlFSYZsClXFALs3",
      "b": "https://lh3.googleusercontent.com/d/16mgaKBq3xUinx_dvm-DFdqcVfvMz-TIq",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1QBdAnqbUTlO3saXXw-NaHHBDeaaNBGfa",
      "b": "https://lh3.googleusercontent.com/d/15N81xWP4L9Syt_iFScvj3VY8UoaYClj1",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1GlLTtGe0b5XbrWL_W3vUoANtTi-f6b0L",
      "b": "https://lh3.googleusercontent.com/d/1SHXZ5UoOSps8qLutHmb6qR6vstdtJZeg",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_868afc6a-2f32-47a7-a0a4-2043d00b65f7.jpg?v=1714149830"
   },
   "carat": 1.2,
   "caratMax": 6.7
  },
  {
   "rank": 601,
   "id": "gid://shopify/Product/7622457524408",
   "title": "1.25-6.75 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71889lb",
   "handle": "engagement-rings-71889lb",
   "priceNow": 1804.99,
   "priceWas": 5600.0,
   "pctOff": 68,
   "core": "71889",
   "inStock": true,
   "createdAt": "2024-04-23T16:16:01Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1Tf88qUs35QFQ1gZ3P-T1vZZmEDu3Uzb1",
      "b": "https://lh3.googleusercontent.com/d/1VROo-pCf92EsbnaBjXl-SMS3GP0LZ9y5",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1LHpMf4YqcETwvdQ2D-8i_n-5TIFR6z09",
      "b": "https://lh3.googleusercontent.com/d/1Yl8rVjtL7k0tNZQaoE9NSerngWTCixQ4",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1eDS6gvzRd9_G3WccrlhP1vo_18TiIcpO",
      "b": "https://lh3.googleusercontent.com/d/1sr6ZKQCoFGf3UbzG4DFNDYwaHRfg9i7c",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_528e2886-d503-45cc-bf5b-24fff7d9fe92.jpg?v=1765415413"
   },
   "carat": 1.25,
   "caratMax": 6.75
  },
  {
   "rank": 602,
   "id": "gid://shopify/Product/7622457196728",
   "title": "1.70-7.20 CT Emerald & Princess Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-15231lb",
   "handle": "engagement-rings-15231lb",
   "priceNow": 2167.99,
   "priceWas": 6720.0,
   "pctOff": 68,
   "core": "15231",
   "inStock": true,
   "createdAt": "2024-04-23T16:15:55Z",
   "shape": "princess",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/17S_j5ErjMxOBMuMFmnqfLnp3-bM1OwAl",
      "b": "https://lh3.googleusercontent.com/d/1vaW7vlosd8D9TKV8rx2MGwIl3CDfuqH6",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1D6ZeRW3aq0EAZZGqPntFmn7Nx8EWscUZ",
      "b": "https://lh3.googleusercontent.com/d/1tFaqwmN-wSPJ8IMhm2CKsz42nrUTwp8l",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1EaL9_r_A1a6MBFABOFqtGNpvppx_TrvM",
      "b": "https://lh3.googleusercontent.com/d/1EwRrnstGBCRPfQjoxXssUIHTsFY3ja76",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_c6e9e7b2-0e4d-44ba-9dc1-16d01fd088b6.jpg?v=1765415413"
   },
   "carat": 1.7,
   "caratMax": 7.2
  },
  {
   "rank": 603,
   "id": "gid://shopify/Product/7622361710776",
   "title": "1.90-7.40 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-15243lb",
   "handle": "engagement-rings-15243lb",
   "priceNow": 2144.99,
   "priceWas": 6650.0,
   "pctOff": 68,
   "core": "15243",
   "inStock": true,
   "createdAt": "2024-04-23T15:35:48Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1UDiGR7koMxGkVb2_mPiHPkIwuuxhX7BR",
      "b": "https://lh3.googleusercontent.com/d/1Eo2HHZeJmGrqlTWEy3JN9_43x6FzgpxZ",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1LBHzvHjf-GaWaNwg7xBOtIOI5991MnM1",
      "b": "https://lh3.googleusercontent.com/d/1u-yfUxFu35yfpUpy9T6Kn0x52tq2fxNe",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1F8HxdJtec2sqPbp7zx2jo3BU_VsT53pW",
      "b": "https://lh3.googleusercontent.com/d/1xs-Uol7nsuoE0eshQo-M2S0xpmGDqw_T",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_5de926b6-da5b-4406-818e-a3e34d359a95.jpg?v=1765415419"
   },
   "carat": 1.9,
   "caratMax": 7.4
  },
  {
   "rank": 604,
   "id": "gid://shopify/Product/7622360989880",
   "title": "0.50-6.00 CT Round Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-71694lb",
   "handle": "solitaire-rings-71694lb",
   "priceNow": 1558.99,
   "priceWas": 4830.0,
   "pctOff": 68,
   "core": "71694",
   "inStock": true,
   "createdAt": "2024-04-23T15:35:33Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1iJDsKUe6HlZ6dhOD4jePBS3KAvGSXrC4",
      "b": "https://lh3.googleusercontent.com/d/1Vj9DItgpCPO2a6t0BQO2BXcm97kGDJzL",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1tt1oLjltM-XDvvNd7jxsVpt8rVSdVhOa",
      "b": "https://lh3.googleusercontent.com/d/1cAR43J0Db2zBwpQS-RlA__uvrlWzjlpe",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1UjWztT2DKtXSqJQ9PCyNLgyAGkpIz43j",
      "b": "https://lh3.googleusercontent.com/d/1Mr70XYxzaMLwUg0Me_PVwxI9Oxt_aixJ",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_1825bc58-3563-4556-a3ba-12ed6b31729c.jpg?v=1763748633"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 605,
   "id": "gid://shopify/Product/7622360465592",
   "title": "0.50-6.00 CT Radiant Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-71819lb",
   "handle": "solitaire-rings-71819lb",
   "priceNow": 1485.99,
   "priceWas": 4610.0,
   "pctOff": 68,
   "core": "71819",
   "inStock": true,
   "createdAt": "2024-04-23T15:35:18Z",
   "shape": "radiant",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_c92dde78-2536-4bc3-a4ca-2c7804d34396.jpg?v=1763748619"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 606,
   "id": "gid://shopify/Product/7622360170680",
   "title": "1.50-7.00 CT Princess Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71826lb",
   "handle": "engagement-rings-71826lb",
   "priceNow": 2162.99,
   "priceWas": 6710.0,
   "pctOff": 68,
   "core": "71826",
   "inStock": true,
   "createdAt": "2024-04-23T15:35:09Z",
   "shape": "princess",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1CHpScCmvxILU6plK4QzqAWpLYo5Ws7YF",
      "b": "https://lh3.googleusercontent.com/d/1Sef0rdJhY1Ajx5_fY9ZwtfjK_-YGVfb0",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1BG0ZHtep3jgeAhCkbhvsKw50OqtMQQwx",
      "b": "https://lh3.googleusercontent.com/d/15c8xq1fcUgfDSuudsohUco-VlZhOS-rB",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1H7_jInwssooiO96p88RjDU1YHvQETijl",
      "b": "https://lh3.googleusercontent.com/d/1PYMHzWTcVTPDytuzk9H6WV6XtC-BqMYb",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_79ccbd98-89d6-4894-85b2-90dddeb8dc01.jpg?v=1765415414"
   },
   "carat": 1.5,
   "caratMax": 7.0
  },
  {
   "rank": 607,
   "id": "gid://shopify/Product/7622359974072",
   "title": "1.30 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71838lb",
   "handle": "wedding-bands-71838lb",
   "priceNow": 1497.99,
   "priceWas": 4640.0,
   "pctOff": 68,
   "core": "71838",
   "inStock": true,
   "createdAt": "2024-04-23T15:35:02Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1ait6GtEnmUUY7DlOTmaGzUBUyP-u0oGn",
      "b": "https://lh3.googleusercontent.com/d/1LB-BJeYB6i5rb5u7A2CxMMVIFPvBK3Iv",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1xtfEryxcHAzxHey5_NxY5aea2NlTnS_p",
      "b": "https://lh3.googleusercontent.com/d/1g_aXEwJKDA_grnQz3RKCNACPq4J7FhK1",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1jH2SRS6geLYDWJWPbrkdTDYpEcXAU8LN",
      "b": "https://lh3.googleusercontent.com/d/1ctKVY_VcczXdlySG1-lsjeNnOMIAzCS9",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_dfa11f8f-ed34-4707-9f16-7b266e09f223.jpg?v=1763698255"
   },
   "carat": 1.3
  },
  {
   "rank": 608,
   "id": "gid://shopify/Product/7622359679160",
   "title": "0.50-6.00 CT Princess Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-71845lb",
   "handle": "solitaire-rings-71845lb",
   "priceNow": 2115.99,
   "priceWas": 6560.0,
   "pctOff": 68,
   "core": "71845",
   "inStock": true,
   "createdAt": "2024-04-23T15:34:55Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_5b036c15-0a0c-4888-ac1c-18c27b2270e4.jpg?v=1763748634"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 609,
   "id": "gid://shopify/Product/7622359318712",
   "title": "0.50-6.00 CT Round Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-71913lb",
   "handle": "solitaire-rings-71913lb",
   "priceNow": 1681.99,
   "priceWas": 5210.0,
   "pctOff": 68,
   "core": "71913",
   "inStock": true,
   "createdAt": "2024-04-23T15:34:47Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_d22d2481-2d04-469a-ad4a-72196a3faea4.jpg?v=1763748622"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 610,
   "id": "gid://shopify/Product/7622358958264",
   "title": "0.60-6.10 CT Emerald & Princess Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-110420lb",
   "handle": "engagement-rings-110420lb",
   "priceNow": 2732.99,
   "priceWas": 8470.0,
   "pctOff": 68,
   "core": "110420",
   "inStock": true,
   "createdAt": "2024-04-23T15:34:39Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1cRD06haCHLfXfFQAEsUNT5TaOnu3dh_Q",
      "b": "https://lh3.googleusercontent.com/d/1TxxBI1MGzDvTVFOFW9SL9okf4Vc_ZsXm",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1oTHniRK7onD5MGTSnQi6tgOa0QeFOBH-",
      "b": "https://lh3.googleusercontent.com/d/1exZjlH4e_OSz2tXMgebvV6Nd3n724Px6",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/16S4DKpI_dXge4q0ZmKKrhFxSknoIr5ds",
      "b": "https://lh3.googleusercontent.com/d/1w6asoF12xb8OoLDb838-h5v3jTV49aaY",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_4b210872-a98b-4cf9-9c1f-d1f337187067.jpg?v=1765415417"
   },
   "carat": 0.6,
   "caratMax": 6.1
  },
  {
   "rank": 611,
   "id": "gid://shopify/Product/7622358696120",
   "title": "0.95-6.45 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/solitaire-rings-15387lb",
   "handle": "solitaire-rings-15387lb",
   "priceNow": 1649.99,
   "priceWas": 5110.0,
   "pctOff": 68,
   "core": "15387",
   "inStock": true,
   "createdAt": "2024-04-23T15:34:30Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1LrQL0kdCJfyC-snG8bGiJatjrDku-LjG",
      "b": "https://lh3.googleusercontent.com/d/1VCh0qtvi_livxCZVqXqP4Gh38Q18zlIO",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1kNiYpdFihneaCLMfrj6XuuWBOwS6Ut6W",
      "b": "https://lh3.googleusercontent.com/d/1kqeVrUrYiTRSFAvpop2zM4Dvdm8Wllh8",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Lf3hSNFV_scJidEQg8sXS0SnGbO8-RKX",
      "b": "https://lh3.googleusercontent.com/d/1Su7VHbMyf_rj2KdwInyawiOn-9PsDm-x",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_a5aed19e-6fe1-4e9d-8383-c8f44dae17b4.jpg?v=1765415412"
   },
   "carat": 0.95,
   "caratMax": 6.45
  },
  {
   "rank": 612,
   "id": "gid://shopify/Product/7622358401208",
   "title": "0.50-6.00 CT Round Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-15606lb",
   "handle": "solitaire-rings-15606lb",
   "priceNow": 1558.99,
   "priceWas": 4830.0,
   "pctOff": 68,
   "core": "15606",
   "inStock": true,
   "createdAt": "2024-04-23T15:34:21Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/15H1B4oyUE9Jkpkc7MZS8G4HnX4vsvJ4K",
      "b": "https://lh3.googleusercontent.com/d/11ZjskapXQvvvDshKYpbHjypXCKa7PnDh",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/19dqNJ7ggaWpDEYV28IMr927m8D901uDj",
      "b": "https://lh3.googleusercontent.com/d/1dIBgg2GegCUyyWb5WGhSpX8dEqgq4MQ7",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1tuMJ_g-b1VTeYjtvKjOowESbcEGfr0CL",
      "b": "https://lh3.googleusercontent.com/d/1r3VHKPLtZeZwvmyTaAABqqSgeiJ60Qth",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_122babcb-5210-40c9-9103-a183efbdfa77.jpg?v=1763748633"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 613,
   "id": "gid://shopify/Product/7622357942456",
   "title": "0.50-6.00 CT Round Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-16257lb",
   "handle": "solitaire-rings-16257lb",
   "priceNow": 1681.99,
   "priceWas": 5210.0,
   "pctOff": 68,
   "core": "16257",
   "inStock": true,
   "createdAt": "2024-04-23T15:34:08Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1m6IMGeVyCVOFwZOch6c-PO01guYMzWyv",
      "b": "https://lh3.googleusercontent.com/d/1CKzKdjLt1Pkw6sBxRa4u-CfaUm0pxF_U",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1Rnh144w-YWI4rrBuUoctYWI_A8PU_1Bk",
      "b": "https://lh3.googleusercontent.com/d/1Pnf6xXWEpUSrjmexE7rXDwoOzKgAYVFN",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1BXhZ4nr930tzaQE0V9qP9hFnVjkM4h4K",
      "b": "https://lh3.googleusercontent.com/d/1mEENPrTe_vxhwb8oXOYASSH_VZvIxwBD",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_163d6ca6-d408-4cac-9e9b-528f5c0a0d57.jpg?v=1763748624"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 614,
   "id": "gid://shopify/Product/7622357614776",
   "title": "0.50-6.00 CT Round Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-16275lb",
   "handle": "solitaire-rings-16275lb",
   "priceNow": 2176.99,
   "priceWas": 6750.0,
   "pctOff": 68,
   "core": "16275",
   "inStock": true,
   "createdAt": "2024-04-23T15:33:58Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1M1Ii4nzFSloW9-U8j5fFUN2n7jBUM3Gu",
      "b": "https://lh3.googleusercontent.com/d/1IsloX_O2-g3ODBSqRuRjOWQvlMa9v0Mm",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1F0Zpw26e5MwD0x63Ge1azdjJBdxTOT8i",
      "b": "https://lh3.googleusercontent.com/d/19TC0T-iRjFc_qibNXW4-12p3x5GztQMW",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1kfR6OBmGR9xv40AvpvUEOaihqR9sxyw4",
      "b": "https://lh3.googleusercontent.com/d/1hB_4LPT5x8B5kNZtbcytybLBlBRk3Z76",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_8e04eb71-f7dc-40e9-ad5c-34199047b533.jpg?v=1763748634"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 615,
   "id": "gid://shopify/Product/7622357319864",
   "title": "0.50-6.00 CT Round Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-71647lb",
   "handle": "solitaire-rings-71647lb",
   "priceNow": 1929.99,
   "priceWas": 5980.0,
   "pctOff": 68,
   "core": "71647",
   "inStock": true,
   "createdAt": "2024-04-23T15:33:49Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1VnZK5abZAoIco2tgsJJnkeEzwRzpBZlJ",
      "b": "https://lh3.googleusercontent.com/d/1ybefF3uVyNvF1ZAh6vysrQ7ocS9PYcI4",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1g08TKcJ3t4Igxg9lp6zH4RRHANFETfzQ",
      "b": "https://lh3.googleusercontent.com/d/11e_gAa9LWN878aYJEMgXND_TPeH2iDRa",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1w60G7Ka2NJPC8uCYBNaUNrlgTrOl4htS",
      "b": "https://lh3.googleusercontent.com/d/1Gz44AjujfAWu8WxOepf5PG4Mg4Dngdyi",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_7fd592eb-c7ae-43c1-9931-bc7a070f1a59.jpg?v=1763748623"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 616,
   "id": "gid://shopify/Product/7613667573944",
   "title": "0.50-6.00 CT Round Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-71665lb",
   "handle": "solitaire-rings-71665lb",
   "priceNow": 1681.99,
   "priceWas": 5210.0,
   "pctOff": 68,
   "core": "71665",
   "inStock": true,
   "createdAt": "2024-04-22T15:45:35Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1rWmkSvp-i20LeCd4xZp8A6YGtKyIs0RB",
      "b": "https://lh3.googleusercontent.com/d/1bt1ayLPgIRCifftaYhtrwV3ro00Bsb_n",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1JcCPFysfNvdntjJiNLqLu2aQmyMbvLkZ",
      "b": "https://lh3.googleusercontent.com/d/1nCdoxREdJB97p20qDBo2TvLimt5BirWR",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1NjOiM5GfaxvKl-bvJPp3rXok5JfQR4vj",
      "b": "https://lh3.googleusercontent.com/d/1NA4ONIHOOV-ryHKJhf3oOCYhVc_kfpQw",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_3e737ee2-3f2d-4218-9ab9-b469f14c9ee3.jpg?v=1763748625"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 617,
   "id": "gid://shopify/Product/7613667377336",
   "title": "1.72-7.22 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-110429lb",
   "handle": "engagement-rings-110429lb",
   "priceNow": 3823.99,
   "priceWas": 11850.0,
   "pctOff": 68,
   "core": "110429",
   "inStock": true,
   "createdAt": "2024-04-22T15:45:26Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1VHDKOW0BmNbjwrEVzPb8Q6Dz3pKHwd5i",
      "b": "https://lh3.googleusercontent.com/d/1fg21gDdog3nql4q4amysFh65qnn-tiWV",
      "angles": [
       1,
       2
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1yyEbBY6_nk_Q3PFLxDp4_LcHpBDz4haH",
      "b": "https://lh3.googleusercontent.com/d/1pL4TWX2l44GjTXMDqlreF2WSCtHnQkDD",
      "angles": [
       1,
       2
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1kOUn2LQI3hIP49lzDVs2kcqglTJLa7dw",
      "b": "https://lh3.googleusercontent.com/d/1cTGE5BnKx5tcsBIw_Gt0R-hINJpPMcf4",
      "angles": [
       1,
       2
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_032ae7ed-5e9d-4dd9-910d-f8b6b1799a67.jpg?v=1765415411"
   },
   "carat": 1.72,
   "caratMax": 7.22
  },
  {
   "rank": 618,
   "id": "gid://shopify/Product/7613667082424",
   "title": "2.00-7.50 CT Emerald & Princess Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-15710lb",
   "handle": "engagement-rings-15710lb",
   "priceNow": 1980.99,
   "priceWas": 6140.0,
   "pctOff": 68,
   "core": "15710",
   "inStock": true,
   "createdAt": "2024-04-22T15:45:16Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1BbhOEIcZgGzrZiXpP2wOMLXs5QfUzc9f",
      "b": "https://lh3.googleusercontent.com/d/1hdhXMntNvLK9Dtx5MHNDM2g1xlZgmXK6",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/10IZcTzIHk6G-rncHNG17Tk8B2XHM8i_N",
      "b": "https://lh3.googleusercontent.com/d/1fo88gdGY-x0xXYW4geblT7Be7Q-wg4Us",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ngca1KepeH5Kszl5aVhfpE-7Dcqg0AuG",
      "b": "https://lh3.googleusercontent.com/d/1Ivr2zEcWfJgD7xGBUi-H-80DsQ2jD30s",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_df6fe51a-c6d2-4002-a4ad-5045239f6666.jpg?v=1765415409"
   },
   "carat": 2.0,
   "caratMax": 7.5
  },
  {
   "rank": 619,
   "id": "gid://shopify/Product/7613666885816",
   "title": "1.50-7.00 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-16008lb",
   "handle": "engagement-rings-16008lb",
   "priceNow": 2345.99,
   "priceWas": 7270.0,
   "pctOff": 68,
   "core": "16008",
   "inStock": true,
   "createdAt": "2024-04-22T15:45:07Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1m9in408g6CDs387gMsTHH4wy34DETBPt",
      "b": "https://lh3.googleusercontent.com/d/1QgN5XbJoj6_m95b7at93x6CgGxN5cxNR",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1Q-6eXe1rYKZ1MG1YIPU8SbQSQPeHjACh",
      "b": "https://lh3.googleusercontent.com/d/1FbIB-nHOzkQT2LKK92rH1IDua5QgMC5U",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1pmFV0uUZWpw9NXIv5w5lBdXqBNXTB332",
      "b": "https://lh3.googleusercontent.com/d/1PHJI7U72_p1fpaKPpU4oVa428cJHFrkN",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_1c744e9f-9d60-4157-9ad6-6f190632d87b.jpg?v=1765415410"
   },
   "carat": 1.5,
   "caratMax": 7.0
  },
  {
   "rank": 620,
   "id": "gid://shopify/Product/7613666033848",
   "title": "1.40-6.90 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-16052lb",
   "handle": "engagement-rings-16052lb",
   "priceNow": 2172.99,
   "priceWas": 6740.0,
   "pctOff": 68,
   "core": "16052",
   "inStock": true,
   "createdAt": "2024-04-22T15:44:36Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1oI2dH-ZKfXUYRnZW_SNuX5OIwGQK1kdl",
      "b": "https://lh3.googleusercontent.com/d/11Azmgs8W46KyskZWCUbzSVccX6iabEqN",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/17ijE3gJJtN1g3VTYDz5UdSzTm7Ta57Xq",
      "b": "https://lh3.googleusercontent.com/d/11-ZDl8xKMhAZu8jJHDSWv_csgSQDiLVN",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1s0Ue4en7DwvbdWKZJQ8uY6gQb-8Ebsa0",
      "b": "https://lh3.googleusercontent.com/d/1u9s7l5PkylyOadFxneC9vasKWd4C-ZQI",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_f6051eba-89c3-450b-a783-9c9581355568.jpg?v=1765415409"
   },
   "carat": 1.4,
   "caratMax": 6.9
  },
  {
   "rank": 621,
   "id": "gid://shopify/Product/7613665771704",
   "title": "2.20-7.70 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-16080lb",
   "handle": "engagement-rings-16080lb",
   "priceNow": 2113.99,
   "priceWas": 6550.0,
   "pctOff": 68,
   "core": "16080",
   "inStock": true,
   "createdAt": "2024-04-22T15:44:26Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1TllBzK5eSbQr_4vZuSQw0ZLlWuvwS8wH",
      "b": "https://lh3.googleusercontent.com/d/1i5sB2GnKp_1M5hWwOMgL5nIr6fSx42Rs",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1TDqIC_CEu847KMpjtk9RfJLZm1kiv5XK",
      "b": "https://lh3.googleusercontent.com/d/1BB9DyoImrUtKyCZ9ds618S_o_Hja1Bmc",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1jZmBx7PR4OOOPdZgilSgxbeQVywrWpfi",
      "b": "https://lh3.googleusercontent.com/d/1-DT_mlAxoQtFMjdI7HDEFEhC3oWXI4-F",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_12fbc7bc-1040-4fc6-89f4-e553b9ed6cc0.jpg?v=1765415418"
   },
   "carat": 2.2,
   "caratMax": 7.7
  },
  {
   "rank": 622,
   "id": "gid://shopify/Product/7613665673400",
   "title": "0.50-6.00 CT Princess Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-16263lb",
   "handle": "solitaire-rings-16263lb",
   "priceNow": 1372.99,
   "priceWas": 4260.0,
   "pctOff": 68,
   "core": "16263",
   "inStock": true,
   "createdAt": "2024-04-22T15:44:22Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1ykrl2Bsg3f7x5fCScs18SnKHJB4KcW5J",
      "b": "https://lh3.googleusercontent.com/d/14a7SmkJCxIso6eIVXhF4mdMnN6H9bldb",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1Ewi9tkBjnYKe6OxvRaOhSUhLOdxHkQxW",
      "b": "https://lh3.googleusercontent.com/d/1FTd7w9a3mFQQTK_hJuBDsfD085SUSVj5",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1-mXZIMLxhbzUGalDaeBAKFuzlpgbqh7-",
      "b": "https://lh3.googleusercontent.com/d/1pMo2sLx9XnnbQeubLK2HPJP0CqJVPtor",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_5ed2747b-15fc-45ae-a1a6-01b5e6bf2a6b.jpg?v=1763748632"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 623,
   "id": "gid://shopify/Product/7613665444024",
   "title": "1.45-6.95 CT Emerald & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71642lb",
   "handle": "engagement-rings-71642lb",
   "priceNow": 4226.99,
   "priceWas": 13100.0,
   "pctOff": 68,
   "core": "71642",
   "inStock": true,
   "createdAt": "2024-04-22T15:44:15Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1xey9T8kBZWNratqTNrtmUG2aZUTDeRa2",
      "b": "https://lh3.googleusercontent.com/d/1NMlNSdd4bh_lWkAt4ZtO-ZGmRM3JGyFP",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/11xQ9JlAG1AwKdQNV40ghQGQwj4kyWhyF",
      "b": "https://lh3.googleusercontent.com/d/1aqDTceD0aa9AHoqfJZ0pEBMruT1hhJlc",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1DeIj1saTs77jeleaSwMBZc55ThTVGuDt",
      "b": "https://lh3.googleusercontent.com/d/1DKX9qb9_hdrGOfm_BK2ofPtXuVxSg-UI",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_971190be-ecde-42fa-b894-d8ae21815d82.jpg?v=1765415418"
   },
   "carat": 1.45,
   "caratMax": 6.95
  },
  {
   "rank": 624,
   "id": "gid://shopify/Product/7613665247416",
   "title": "0.50-6.00 CT Round Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-71685lb",
   "handle": "solitaire-rings-71685lb",
   "priceNow": 1186.99,
   "priceWas": 3680.0,
   "pctOff": 68,
   "core": "71685",
   "inStock": true,
   "createdAt": "2024-04-22T15:44:06Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_cd014acb-be4e-4d3e-937b-9ff78a579007.jpg?v=1763748634"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 625,
   "id": "gid://shopify/Product/7613665018040",
   "title": "1.55-7.05 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71733lb",
   "handle": "engagement-rings-71733lb",
   "priceNow": 2102.99,
   "priceWas": 6520.0,
   "pctOff": 68,
   "core": "71733",
   "inStock": true,
   "createdAt": "2024-04-22T15:43:57Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1QREtJpYLmnLQl-ZFSwe8sWAhc_NG43xg",
      "b": "https://lh3.googleusercontent.com/d/1bGtTFo9g-ai5tJDy55oIE2_eKBNw6QMV",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1ukSCwPoCorVfqqsHZ85VnadnnnkrW6q1",
      "b": "https://lh3.googleusercontent.com/d/1cHvzP9EpAFn_uZ7fJ01pSa6VBjuBAY9j",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ESHwjZFZQ02Arrtd5f-nrOWhIfSWwMZb",
      "b": "https://lh3.googleusercontent.com/d/1MFpcLrat4VPBbBVrCJtpDRoWYZQyVRzD",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_ed5c9591-92f2-49b6-9828-f544d27a568c.jpg?v=1765415409"
   },
   "carat": 1.55,
   "caratMax": 7.05
  },
  {
   "rank": 626,
   "id": "gid://shopify/Product/7613664886968",
   "title": "2.10-7.60 CT Princess Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71832lb",
   "handle": "engagement-rings-71832lb",
   "priceNow": 2554.99,
   "priceWas": 7920.0,
   "pctOff": 68,
   "core": "71832",
   "inStock": true,
   "createdAt": "2024-04-22T15:43:52Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1VIHb_LzCnhVwkDmS5x4jIO0Cv0-39kVE",
      "b": "https://lh3.googleusercontent.com/d/1ngDBCFdBpuTu486bJGAQ7D7TAgbeQ2Tx",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1JRQn1JjIL0eynup9YUQ6xXlA7bRmnmf3",
      "b": "https://lh3.googleusercontent.com/d/1oGOqna_qWeaCNLHXoXARTmvScRbBDB9F",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1IvTNWrSW7VSsioQ_TbVQM7AEvY35Ww6p",
      "b": "https://lh3.googleusercontent.com/d/1LwYkxpok9On4mezmcZRXo9iXVELJP2V1",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_5b244d11-490f-4c61-ba01-ae4890ddfa9e.jpg?v=1765415410"
   },
   "carat": 2.1,
   "caratMax": 7.6
  },
  {
   "rank": 627,
   "id": "gid://shopify/Product/7613664493752",
   "title": "1.80-7.30 CT Emerald & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71839lb",
   "handle": "engagement-rings-71839lb",
   "priceNow": 2315.99,
   "priceWas": 7180.0,
   "pctOff": 68,
   "core": "71839",
   "inStock": true,
   "createdAt": "2024-04-22T15:43:41Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1S3DMMjmqTEQTowgEwdqdxcZIIozC3iH_",
      "b": "https://lh3.googleusercontent.com/d/1WN5owktUzWmkhEecIWGnjRRbUSk2zya_",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1R-iby5bfUDCKiZLyWUGrrMZx5JlNh_2o",
      "b": "https://lh3.googleusercontent.com/d/1tHLljyqGdLv0cSgZ2gRwUURJs6_AzaQk",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1CyPpP7MswPGeoWwBQ1HBJso0q5_HKpmf",
      "b": "https://lh3.googleusercontent.com/d/1rI_ET-gHSNHYopki52B-Z8DLHj52oaYp",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_929bcc8a-bde7-4a36-8179-4feb012202b1.jpg?v=1765415410"
   },
   "carat": 1.8,
   "caratMax": 7.3
  },
  {
   "rank": 628,
   "id": "gid://shopify/Product/7613590208696",
   "title": "1.55-4.05 CT Princess Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71863lb",
   "handle": "engagement-rings-71863lb",
   "priceNow": 1330.99,
   "priceWas": 4036.99,
   "pctOff": 67,
   "core": "71863",
   "inStock": true,
   "createdAt": "2024-04-22T14:39:21Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_96ecfb45-831f-4928-87a8-24887e67297c.jpg?v=1713803707",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_96ecfb45-831f-4928-87a8-24887e67297c.jpg?v=1713803707",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y3_936baa8d-c58f-40e2-9fce-02151fc9a6ff.jpg?v=1713803707",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r3_cb092e29-afec-46da-a014-6b9b7125a87b.jpg?v=1713803707"
    }
   },
   "carat": 1.55,
   "caratMax": 4.05
  },
  {
   "rank": 629,
   "id": "gid://shopify/Product/7613590077624",
   "title": "1.55-7.05 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71865lb",
   "handle": "engagement-rings-71865lb",
   "priceNow": 1910.99,
   "priceWas": 5920.0,
   "pctOff": 68,
   "core": "71865",
   "inStock": true,
   "createdAt": "2024-04-22T14:39:14Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1gsTcPB9paR16XawZXBBdqsauEk7RBPkU",
      "b": "https://lh3.googleusercontent.com/d/1kJJHu14UklEjsYv3xXIFtpGv3Uv8Rpwf",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/11FxHBEboQoocL32fUnPQ_ZciGXZJbzFO",
      "b": "https://lh3.googleusercontent.com/d/1674GpPA8MQMWodFoAcpMjVVxAmm1FVal",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1VtLyY9Qz_uQJFdQjyv0L0OD1_QDQDtqV",
      "b": "https://lh3.googleusercontent.com/d/1yUhuvt_at6ge1_BYv-pbdfyMSPkb1n4A",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_8c9671a4-3bf2-4af3-967d-ac6b97aaa4cc.jpg?v=1765415452"
   },
   "carat": 1.55,
   "caratMax": 7.05
  },
  {
   "rank": 630,
   "id": "gid://shopify/Product/7613589881016",
   "title": "0.50-6.00 CT Round Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/solitaire-rings-110388lb",
   "handle": "solitaire-rings-110388lb",
   "priceNow": 1434.99,
   "priceWas": 4450.0,
   "pctOff": 68,
   "core": "110388",
   "inStock": true,
   "createdAt": "2024-04-22T14:39:08Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_53233590-c23b-4d3e-9b99-0867f6f1696a.jpg?v=1763748621"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 631,
   "id": "gid://shopify/Product/7613589618872",
   "title": "0.60-6.10 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71754lb",
   "handle": "engagement-rings-71754lb",
   "priceNow": 2598.99,
   "priceWas": 8060.0,
   "pctOff": 68,
   "core": "71754",
   "inStock": true,
   "createdAt": "2024-04-22T14:38:53Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1ZOsjpIxIPy3M2VJE0MJg7bmnqwIRf3yh",
      "b": "https://lh3.googleusercontent.com/d/1H1Oh6OZ_P4ZgNscW_Fgc1vbIfB4pSWY2",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1uRPDhO8WQVQyPcHS4mQDOWlmui7dX83o",
      "b": "https://lh3.googleusercontent.com/d/1qTwIeXmQlEJi4ES_UrwSTYz1UjaR74gL",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1HStoA_puaT5fk7mfOpEIsid6pfXyzir-",
      "b": "https://lh3.googleusercontent.com/d/1WIua0Db3312aT0wd_bu5YurtRe0KfEqY",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_c324b477-b53c-4419-adf1-34ea0c233876.jpg?v=1765415418"
   },
   "carat": 0.6,
   "caratMax": 6.1
  },
  {
   "rank": 632,
   "id": "gid://shopify/Product/7613589422264",
   "title": "1.00-6.50 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71762lb",
   "handle": "engagement-rings-71762lb",
   "priceNow": 2487.99,
   "priceWas": 7710.0,
   "pctOff": 68,
   "core": "71762",
   "inStock": true,
   "createdAt": "2024-04-22T14:38:43Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1M0OqtoNOCOCD_cYXuq7bLcsnfSFL9aSi",
      "b": "https://lh3.googleusercontent.com/d/1LHRkW8j7Rspij5HZDtUsKIQ73s8eGDW0",
      "angles": [
       1,
       2
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1hx7zSOcedbkn44_E_Y4rDf6c2oGgJgwF",
      "b": "https://lh3.googleusercontent.com/d/1i2X1ul3ynEGC1Mr99s4OaxX-8m3vinsV",
      "angles": [
       1,
       2
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1_WcLD8hPOlnIFyyaMo6qKMIY38eTfd2s",
      "b": "https://lh3.googleusercontent.com/d/1i_g478L7V19TRn0B8aJ3qiv51Jh5X3W_",
      "angles": [
       1,
       2
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_c4f5049d-a052-4d07-8159-f3885f1dfd99.jpg?v=1765415409"
   },
   "carat": 1.0,
   "caratMax": 6.5
  },
  {
   "rank": 633,
   "id": "gid://shopify/Product/7613589192888",
   "title": "1.15-6.65 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71766lb",
   "handle": "engagement-rings-71766lb",
   "priceNow": 2126.99,
   "priceWas": 6590.0,
   "pctOff": 68,
   "core": "71766",
   "inStock": true,
   "createdAt": "2024-04-22T14:38:35Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1FCik33ASZPdrzqYftMud23Yr1Xt9PdJK",
      "b": "https://lh3.googleusercontent.com/d/1PLai_AKMWkLTTB6vG5S5hkPUgR5Dx41h",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1DLMiYC47z_sZ26bATGfqpj7YJ2DxYOtq",
      "b": "https://lh3.googleusercontent.com/d/1vM6DiMU-ws2HNDiCJUBGk6OZusCksohd",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Yh_7Ic5YLFgWh2BKvMkdqOieWOgnpXW4",
      "b": "https://lh3.googleusercontent.com/d/1Ld-RvqEtVRWJoAnRV4XbtuA1Xq1Rbwdl",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_c4630ab0-d723-4806-996e-1816904e788e.jpg?v=1765415410"
   },
   "carat": 1.15,
   "caratMax": 6.65
  },
  {
   "rank": 634,
   "id": "gid://shopify/Product/7613589127352",
   "title": "0.30 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71790lb",
   "handle": "wedding-bands-71790lb",
   "priceNow": 828.99,
   "priceWas": 2820.0,
   "pctOff": 71,
   "core": "71790",
   "inStock": true,
   "createdAt": "2024-04-22T14:38:28Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1wkf6aWh6wLVcC_fMxVgP996j8eMUwu5l",
      "b": "https://lh3.googleusercontent.com/d/1o3cFb9mpOpaEK72TjzTjUCEr43lX7LEb",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1512k38f-_qZ1qTm1pS9l6fFouWUwR7r1",
      "b": "https://lh3.googleusercontent.com/d/1TQjMYvfLwm3_JJ5MuEMZkWfa2FnnCJez",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1n30NUO0jRMwD7LP8tOE27DFLXYz2MOLo",
      "b": "https://lh3.googleusercontent.com/d/1l0KrrN25Zw46ZwBTSpF1GhkfL1vjTxgH",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_583b6dcc-532f-475f-8ca9-9bc78a2b7f95.jpg?v=1763698393"
   },
   "carat": 0.3
  },
  {
   "rank": 635,
   "id": "gid://shopify/Product/7601926832312",
   "title": "1.10-6.60 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71876lb",
   "handle": "engagement-rings-71876lb",
   "priceNow": 1900.99,
   "priceWas": 5890.0,
   "pctOff": 68,
   "core": "71876",
   "inStock": true,
   "createdAt": "2024-04-19T15:30:43Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1fyq9OJ7mV1WHgULfV0_k1I2Md9J7f3mV",
      "b": "https://lh3.googleusercontent.com/d/1Kmu8bKrlbbaDxY1KBskKDwxuwoP4p_mU",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1clfJAMd3D7PPeNR4loRrRI6juqjNg3ZG",
      "b": "https://lh3.googleusercontent.com/d/1uJ0NiDTn4WkO4BUq5efstR2Nzt82GkKG",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/11dARoi2MbULtDiO4Q4QV2OkXlz575EQd",
      "b": "https://lh3.googleusercontent.com/d/1L2DQn00qfhWinC5jH1uM9dg0hAwJvGzp",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_b922dadf-07ef-422a-ae6e-af3083f679d7.jpg?v=1765415410"
   },
   "carat": 1.1,
   "caratMax": 6.6
  },
  {
   "rank": 636,
   "id": "gid://shopify/Product/7601926766776",
   "title": "0.97-6.47 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71905lb",
   "handle": "engagement-rings-71905lb",
   "priceNow": 2188.99,
   "priceWas": 6790.0,
   "pctOff": 68,
   "core": "71905",
   "inStock": true,
   "createdAt": "2024-04-19T15:30:36Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1L3G1k-_RxneBnlE4vPUbWzGiZ-8LUD_S",
      "b": "https://lh3.googleusercontent.com/d/1ADPwj6aIfNGgIDTr5NeVxMkOH1XjWByw",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1KpUukNGVDdTU1uktEBYBq_tPfihfjfSH",
      "b": "https://lh3.googleusercontent.com/d/1XUG3AH0yd9NyOdTUIghw3BLgRFzlL6sp",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1pVuZj1OrKaJxT1yFqOkLlZFNCNkyG8da",
      "b": "https://lh3.googleusercontent.com/d/1UIA8y6MNICjMdR-OzmUyCGnLafCz8Zgb",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_41a1d158-59ec-4053-831d-78d45964a133.jpg?v=1765415414"
   },
   "carat": 0.97,
   "caratMax": 6.47
  },
  {
   "rank": 637,
   "id": "gid://shopify/Product/7601926701240",
   "title": "1.30-6.80 CT Emerald & Princess Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-15220lb",
   "handle": "engagement-rings-15220lb",
   "priceNow": 1858.99,
   "priceWas": 5760.0,
   "pctOff": 68,
   "core": "15220",
   "inStock": true,
   "createdAt": "2024-04-19T15:30:29Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1fLDvQhtT7lBoMGVCkbX8Lma3ize3Qju8",
      "b": "https://lh3.googleusercontent.com/d/1X7PbQtANUB_mOjRSiW9OeFQjFAcMedJN",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1qS2K9v6lpmJ87pNThGddld21yS-Vefcf",
      "b": "https://lh3.googleusercontent.com/d/1Ex2pkwcrOqlGbReV1iC4V3VTrdZYGpPd",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1wzkGxvMlRrn8PLst6ap3i8URHDlDaag2",
      "b": "https://lh3.googleusercontent.com/d/1yuTWe6mGgkf80SqYvQM32vMKX2DX3gfG",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_33254a49-61d2-4870-a005-f2f093053a5b.jpg?v=1765414829"
   },
   "carat": 1.3,
   "caratMax": 6.8
  },
  {
   "rank": 638,
   "id": "gid://shopify/Product/7601926635704",
   "title": "1.30-6.80 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-15242lb",
   "handle": "engagement-rings-15242lb",
   "priceNow": 1959.99,
   "priceWas": 6080.0,
   "pctOff": 68,
   "core": "15242",
   "inStock": true,
   "createdAt": "2024-04-19T15:30:19Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1mdX9sGu899xq4k1Y0BI7wgWG58DrFBU2",
      "b": "https://lh3.googleusercontent.com/d/1xl4lrpkfS6np45td3jYkrUnhYCl8hRU4",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1-9cZrVTrwbGAeH1dtwg0hKWnJtRjTNLQ",
      "b": "https://lh3.googleusercontent.com/d/19p0k63Fz7nuhFntXsETC-u6bOhOOawb_",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/126tlDOh-7HfTTzMVWaCpqcwhLM_eP0Mv",
      "b": "https://lh3.googleusercontent.com/d/1CqenfsJn-SUnXl_eA84Pnxna3LL0Bs6X",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_d5dc9263-b7e9-4f39-8c15-87eba3ecc4cb.jpg?v=1765414830"
   },
   "carat": 1.3,
   "caratMax": 6.8
  },
  {
   "rank": 639,
   "id": "gid://shopify/Product/7601926439096",
   "title": "1.35-6.85 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-15635lb",
   "handle": "engagement-rings-15635lb",
   "priceNow": 2110.99,
   "priceWas": 6540.0,
   "pctOff": 68,
   "core": "15635",
   "inStock": true,
   "createdAt": "2024-04-19T15:30:01Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1S7g6ibr1bMfukkI0nqli0kgDdFv0DuzY",
      "b": "https://lh3.googleusercontent.com/d/1iUMiNtNvT2luBwd1fPyXeTIKg9aD96U7",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1Lxe8hW0_RFJvkjM2h70eMoPV9BhTa0fI",
      "b": "https://lh3.googleusercontent.com/d/1ddjGXL-uLxGGwgY1uP8MwLMIfFQAbp5M",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1NVk7KwTPbo5XDGw7Vkq4cLFQsfuo5k1c",
      "b": "https://lh3.googleusercontent.com/d/1vvP0LlrV6p_Yps5pQ2TLOtlz9MFcs-Nj",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_7d1f7f28-9fc9-4971-98fa-0bbcfd4f2549.jpg?v=1765414839"
   },
   "carat": 1.35,
   "caratMax": 6.85
  },
  {
   "rank": 640,
   "id": "gid://shopify/Product/7601926308024",
   "title": "1.35-6.85 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-16004lb",
   "handle": "engagement-rings-16004lb",
   "priceNow": 1877.99,
   "priceWas": 5820.0,
   "pctOff": 68,
   "core": "16004",
   "inStock": true,
   "createdAt": "2024-04-19T15:29:51Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1BIgCEKxBNzcKrr6ar-5IBod7-2UmyQcL",
      "b": "https://lh3.googleusercontent.com/d/1c-PVePqd2bdny0BgMjzveLnUeAxvc0uw",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1AsS1fTHsrqa8-ygh0QL8urLZxfndqkq0",
      "b": "https://lh3.googleusercontent.com/d/1wm3Nz6_m-zSIovMpWOQ--0z9nIPjp8EW",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Ep00Bu0T4GDiZdICD2-wBqZq155xxbX7",
      "b": "https://lh3.googleusercontent.com/d/1l7STGvNEdbV3Hp_RS3zmP4J2cwpk3dZb",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_6c55b016-5e75-4142-8cec-f8f1b5312a7e.jpg?v=1765414857"
   },
   "carat": 1.35,
   "caratMax": 6.85
  },
  {
   "rank": 641,
   "id": "gid://shopify/Product/7601926242488",
   "title": "1.35-6.85 CT Marquise & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-16048lb",
   "handle": "engagement-rings-16048lb",
   "priceNow": 2020.99,
   "priceWas": 6270.0,
   "pctOff": 68,
   "core": "16048",
   "inStock": true,
   "createdAt": "2024-04-19T15:29:43Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1ml74dBkn8ROMQbxCKWhju8n056DX50K8",
      "b": "https://lh3.googleusercontent.com/d/1LuktFsNlTCNg5i-LJw5Uxd_k7c8fGGYm",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1QR_JUtSE35_4rI7PdMEKZOHGXX0m9IEq",
      "b": "https://lh3.googleusercontent.com/d/1cWBJApK7NZ3_5pEdtwPHcs233Iz0KE2g",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1qarkPDcrPG_f96mzvwPE5vm6AZm9dITc",
      "b": "https://lh3.googleusercontent.com/d/1fBo8twE8jM7l9vtcj_EKtq91R8Jb9vh3",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_56d92a56-45a6-47da-8703-26ac55de7c16.jpg?v=1765414856"
   },
   "carat": 1.35,
   "caratMax": 6.85
  },
  {
   "rank": 642,
   "id": "gid://shopify/Product/7601926045880",
   "title": "0.90-6.40 CT Emerald & Taper Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71674lb",
   "handle": "engagement-rings-71674lb",
   "priceNow": 1714.99,
   "priceWas": 5320.0,
   "pctOff": 68,
   "core": "71674",
   "inStock": true,
   "createdAt": "2024-04-19T15:29:21Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1uW6_cWvplnjtveo6X-dhA0FVucHSLzyH",
      "b": "https://lh3.googleusercontent.com/d/1Q38MEV86f-VF07wBLtXOIH1FIZgGzN9V",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1H6sAyTpwehR03YdcRDZ58N4_nDeDNeiD",
      "b": "https://lh3.googleusercontent.com/d/16j4BBrQBagjZKdE3oanNHQn2D0HY6loO",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1kEnwaQOAhakdxY6i9UpSilvfqnPnC1a9",
      "b": "https://lh3.googleusercontent.com/d/13Oqpub3MsAKMlA8Q7xbdw9TfRYB8iLh8",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_5a9eee49-86b2-4c2b-9bd6-16cbb6904f00.jpg?v=1765414882"
   },
   "carat": 0.9,
   "caratMax": 6.4
  },
  {
   "rank": 643,
   "id": "gid://shopify/Product/7601926013112",
   "title": "0.95-6.45 CT Ascher & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71703lb",
   "handle": "engagement-rings-71703lb",
   "priceNow": 1976.99,
   "priceWas": 6130.0,
   "pctOff": 68,
   "core": "71703",
   "inStock": true,
   "createdAt": "2024-04-19T15:29:12Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1OnAgw_7gAksyNAii9zwilDiHGQSNZ--d",
      "b": "https://lh3.googleusercontent.com/d/1_D6yXn0LtMrYWtinoWpaSuCDYwMTiP3-",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1LelaCRksDWWdI2fn2MQnqJaAI6iN5wgK",
      "b": "https://lh3.googleusercontent.com/d/1yFSVmFHE1Aqtsik6hfNa3gQwAB5hr1As",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1na5empBnMebp89YVhUK7i4Inkx_CK1ca",
      "b": "https://lh3.googleusercontent.com/d/1Wn5Go493rvyZ3eK5QaKqjq4RjmUQZKGN",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_bebcb20a-f75b-423f-939a-87969196cfc4.jpg?v=1765414882"
   },
   "carat": 0.95,
   "caratMax": 6.45
  },
  {
   "rank": 644,
   "id": "gid://shopify/Product/7601925914808",
   "title": "0.75-6.25 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71717lb",
   "handle": "engagement-rings-71717lb",
   "priceNow": 2368.99,
   "priceWas": 7340.0,
   "pctOff": 68,
   "core": "71717",
   "inStock": true,
   "createdAt": "2024-04-19T15:29:05Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/13J-KzYCrZLEHEAyLkPp_gq8HShzvJU8U",
      "b": "https://lh3.googleusercontent.com/d/17bArTXgZkREO94glhgOygDWX40GYOSBj",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1YlnGWnGRCdt0bM9S_DHmpAnzWzjIHTCb",
      "b": "https://lh3.googleusercontent.com/d/1D3kLTRnWBCUf3HZ8oSEyuuy9Ufte8P-s",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1NgHOWOYkFGwUkBAXQfUefEutTjmO7JMb",
      "b": "https://lh3.googleusercontent.com/d/1CdxcVHwff1E0mvAFY3jXpefisasK20lQ",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_d9775599-fa73-48a5-a707-e00846545d42.jpg?v=1765414886"
   },
   "carat": 0.75,
   "caratMax": 6.25
  },
  {
   "rank": 645,
   "id": "gid://shopify/Product/7601925849272",
   "title": "0.85-6.35 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71849lb",
   "handle": "engagement-rings-71849lb",
   "priceNow": 2227.99,
   "priceWas": 6910.0,
   "pctOff": 68,
   "core": "71849",
   "inStock": true,
   "createdAt": "2024-04-19T15:28:52Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1abz4Y-uX-OB0Zc44ovwsbWeEWbAI1AlH",
      "b": "https://lh3.googleusercontent.com/d/1Ct3FFUia57sMpFyVAiUvQJuWFg13ByH2",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1kfDE09XW3qkTPk1Nt13VFpRt1Nex2WeO",
      "b": "https://lh3.googleusercontent.com/d/1a8y1M2dAGNEDZUiLFAIz5XEk-KIsO_Is",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Et-976BfSX7RyZtvb8GHapLBOzzewxyi",
      "b": "https://lh3.googleusercontent.com/d/1oR3wyyMFRRnYKhM7Er_CY0SMAVQkm3Bk",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_cae01974-3156-46bd-b43b-f3e4239888e0.jpg?v=1765414891"
   },
   "carat": 0.85,
   "caratMax": 6.35
  },
  {
   "rank": 646,
   "id": "gid://shopify/Product/7596597379256",
   "title": "0.85-6.35 CT Princess Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71851lb",
   "handle": "engagement-rings-71851lb",
   "priceNow": 2288.99,
   "priceWas": 7100.0,
   "pctOff": 68,
   "core": "71851",
   "inStock": true,
   "createdAt": "2024-04-18T15:38:51Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1t2DP_OmQojCztYBuXHPk1zg-QZ_YXTF2",
      "b": "https://lh3.googleusercontent.com/d/1EPyGBqKxzVdohac9NGx4XOK4d2WX4W7m",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1yZPXCORUX1FSijTHik6uqwWVK_TZnF4Z",
      "b": "https://lh3.googleusercontent.com/d/19AKgi2Tf5CqTgw1gdGMkNDimXLsC7Ce7",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1GG8s2Yail-yaRYDXcbn2nfN5YLz-8B-R",
      "b": "https://lh3.googleusercontent.com/d/1jX-0zSTV7EMPNHVqO1obN6GrQBfbdrPi",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_3c5a422d-89d2-482d-90ba-ce2772ddacc8.jpg?v=1765414908"
   },
   "carat": 0.85,
   "caratMax": 6.35
  },
  {
   "rank": 647,
   "id": "gid://shopify/Product/7596597313720",
   "title": "1.20-6.70 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71906lb",
   "handle": "engagement-rings-71906lb",
   "priceNow": 1981.99,
   "priceWas": 6140.0,
   "pctOff": 68,
   "core": "71906",
   "inStock": true,
   "createdAt": "2024-04-18T15:38:45Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/18uP43gdJQQWZDbVB6T_Fj0ol1qOvu8JG",
      "b": "https://lh3.googleusercontent.com/d/1bm5A_Nx5o1oYOyGFy2z1VnkslUJZCNAT",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1iC8_1yPKSWyW-z6oJFpsOZ-eHJsV725X",
      "b": "https://lh3.googleusercontent.com/d/1IX8Ze2Wp3Os6MkSn_xewPK5UIyBOtr5L",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1_HAgBV15ra8oirOQO9tAbVSXI1TGOfkF",
      "b": "https://lh3.googleusercontent.com/d/1ARUa-IrX8WpmLObTTX8tPIZRa5XQwrZZ",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_bd75ad8b-873e-4406-b99a-ac3a713193fa.jpg?v=1765414907"
   },
   "carat": 1.2,
   "caratMax": 6.7
  },
  {
   "rank": 648,
   "id": "gid://shopify/Product/7596597280952",
   "title": "1.15-6.65 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-110426lb",
   "handle": "engagement-rings-110426lb",
   "priceNow": 2062.99,
   "priceWas": 6400.0,
   "pctOff": 68,
   "core": "110426",
   "inStock": true,
   "createdAt": "2024-04-18T15:38:38Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1lMbdxuVN_kgZKK4JFd455UtvYzMj4OOD",
      "b": "https://lh3.googleusercontent.com/d/1Xzz2HwOCJDI_YO6eJ8b7ntY_aIUxrbrJ",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1Qs2xQIj4Ow1y0M4lhX2btxfDlzsZZPos",
      "b": "https://lh3.googleusercontent.com/d/1RqXzjMG9B9I6NZ1wBm6jZ2kNIGIZ1z2f",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1DCyWiAyt0BrOMGQYET1Ixq2J_oGpMNAA",
      "b": "https://lh3.googleusercontent.com/d/1I6GfejG7sYm2cOA00OUfQkhp0jyq3rYX",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_718ba8ac-d5e9-477e-968a-f32140438371.jpg?v=1765414912"
   },
   "carat": 1.15,
   "caratMax": 6.65
  },
  {
   "rank": 649,
   "id": "gid://shopify/Product/7596597215416",
   "title": "1.25-6.75 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-110428lb",
   "handle": "engagement-rings-110428lb",
   "priceNow": 1865.99,
   "priceWas": 5780.0,
   "pctOff": 68,
   "core": "110428",
   "inStock": true,
   "createdAt": "2024-04-18T15:38:30Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/104Zf2iHB6-REhzdfNErQ0Db9HVm4xwVQ",
      "b": "https://lh3.googleusercontent.com/d/1GIOgM8CsiZFpBX4RjGSfvVcYOulz0ZmX",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/13T6tSfFndMZL8nbZ8w6IjuIfDxv0Jbtd",
      "b": "https://lh3.googleusercontent.com/d/1anLRqOCwtjcoXJAMZ7bZoXGYzlj6hBoG",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1W0CUNBybeKEe9EDSYJKRkGu_lieIII6h",
      "b": "https://lh3.googleusercontent.com/d/1XYfLv9cfRIxFjnRveIgcNmA9gFLTmwPW",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_eb626577-4da0-4ee8-b9bd-4589627f94b0.jpg?v=1765414917"
   },
   "carat": 1.25,
   "caratMax": 6.75
  },
  {
   "rank": 650,
   "id": "gid://shopify/Product/7596597084344",
   "title": "0.90-6.40 CT Princess & Taper Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71675lb",
   "handle": "engagement-rings-71675lb",
   "priceNow": 1759.99,
   "priceWas": 5460.0,
   "pctOff": 68,
   "core": "71675",
   "inStock": true,
   "createdAt": "2024-04-18T15:38:23Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1SfaUeohSIfVabgIZoisvAJBjDveMtW5z",
      "b": "https://lh3.googleusercontent.com/d/14AWPLYBu6qtlWEaPTNdHGwCwwimWY4Fm",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1bITYeaj6vIRXt_fJcbiIg0yQp-f7B-xJ",
      "b": "https://lh3.googleusercontent.com/d/1JOvvxKfqY6AadnKAK__aTVmBriJfLGBV",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1PnoRJRiJr3VAwSMXk3KGV4a4R-cJpIAJ",
      "b": "https://lh3.googleusercontent.com/d/1CVyduqpiSIJHLZGO4jGpN4WVcrZ4wq4R",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_7a34c438-d5e2-45c1-bc3c-fe84937e2c65.jpg?v=1765414933"
   },
   "carat": 0.9,
   "caratMax": 6.4
  },
  {
   "rank": 651,
   "id": "gid://shopify/Product/7596596953272",
   "title": "1.00-6.50 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71874lb",
   "handle": "engagement-rings-71874lb",
   "priceNow": 2014.99,
   "priceWas": 6250.0,
   "pctOff": 68,
   "core": "71874",
   "inStock": true,
   "createdAt": "2024-04-18T15:38:13Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1tx1l4nxfBAr4aRDjCly-URuufdeYbB-I",
      "b": "https://lh3.googleusercontent.com/d/1Yuht1vcTI9g06YF3W2Gf2jYsQ9vAUR-b",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/15u4AHs54dhAPzeBpJikRoZbi64XHSItz",
      "b": "https://lh3.googleusercontent.com/d/1G3-u1Uubk-Z-MPWT3_5UBmeZusdMnqml",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/13mojeRxxBcz1KKPKcBYFpBTUWU7Wqkr1",
      "b": "https://lh3.googleusercontent.com/d/1n6KmGFHXxk_W31IVtzravplh97YVrztm",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_cbf9f5cd-239f-4ff5-83b4-0ac671f2f2a2.jpg?v=1765414933"
   },
   "carat": 1.0,
   "caratMax": 6.5
  },
  {
   "rank": 652,
   "id": "gid://shopify/Product/7596596822200",
   "title": "1.20-6.70 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71877lb",
   "handle": "engagement-rings-71877lb",
   "priceNow": 1866.99,
   "priceWas": 5790.0,
   "pctOff": 68,
   "core": "71877",
   "inStock": true,
   "createdAt": "2024-04-18T15:38:05Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1PaytpLfKRZ8xBTi9d_t2kt0H9ynwS8rX",
      "b": "https://lh3.googleusercontent.com/d/1yEy44BOI04E_X3DgCv3spVfZletAsjJa",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1nHY_fO3NlgVYpEO8H0a4Uec_nwXqsbB0",
      "b": "https://lh3.googleusercontent.com/d/1zEXI7nr0ppYfJ7j_ldOZEv-IJqrURiXQ",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1dJqZLvQhFSMErqxTn5UMl4g7NzT_d_fc",
      "b": "https://lh3.googleusercontent.com/d/1GAVd2wA066kSmS-W4-fPaowQu6Uy0f7-",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_4c76fe53-af2c-4b54-b52a-420113fd0e01.jpg?v=1765414937"
   },
   "carat": 1.2,
   "caratMax": 6.7
  },
  {
   "rank": 653,
   "id": "gid://shopify/Product/7596596756664",
   "title": "1.07-6.57 CT Radiant & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71880lb",
   "handle": "engagement-rings-71880lb",
   "priceNow": 1806.99,
   "priceWas": 5600.0,
   "pctOff": 68,
   "core": "71880",
   "inStock": true,
   "createdAt": "2024-04-18T15:37:58Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/16bTs7x_XzO0rycvCAPuoOwd33HO4bp5f",
      "b": "https://lh3.googleusercontent.com/d/1cN0l1V8W9HuXoU9XqxXs7kMWzhyVSfHX",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/17rY94Dm40jZK_m1cO3QFGAgwztNduwtN",
      "b": "https://lh3.googleusercontent.com/d/1IBO-701pEoWeyHD_vogW5YwpfOawgH9Y",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1HewmjZdHDCvVw6JNDFSDMCPWskDW8nxm",
      "b": "https://lh3.googleusercontent.com/d/1p-jfgYxf_0-D2xaTXfx686wPF_9fIww7",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_d69a990d-a26e-47f7-9ffe-1de9960afa88.jpg?v=1765414943"
   },
   "carat": 1.07,
   "caratMax": 6.57
  },
  {
   "rank": 654,
   "id": "gid://shopify/Product/7596596691128",
   "title": "1.15-6.65 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71884lb",
   "handle": "engagement-rings-71884lb",
   "priceNow": 1991.99,
   "priceWas": 6180.0,
   "pctOff": 68,
   "core": "71884",
   "inStock": true,
   "createdAt": "2024-04-18T15:37:48Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1XYqFV06NYwSR8fcAlL3cv_Ko551SDawh",
      "b": "https://lh3.googleusercontent.com/d/1A3qTBYnxZV-kzgUvnk2dSTFhpt9_MvPF",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/11HPAMRwwpykz2L1dpghtFO0tweFpMqVS",
      "b": "https://lh3.googleusercontent.com/d/1hy1G9XoLJIiDi3FDXLqhdFZOgHneClom",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1zICInRyUc_maZFZkcH1yVmGgguNDOypQ",
      "b": "https://lh3.googleusercontent.com/d/1bgYbsxuvkhYrRMQE29B2pVUWwrO5EYcS",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_0cc2f9a2-d9fd-4740-a6d4-2a1366afef4b.jpg?v=1763698489"
   },
   "carat": 1.15,
   "caratMax": 6.65
  },
  {
   "rank": 655,
   "id": "gid://shopify/Product/7596596625592",
   "title": "0.99-6.49 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71894lb",
   "handle": "engagement-rings-71894lb",
   "priceNow": 1768.99,
   "priceWas": 5480.0,
   "pctOff": 68,
   "core": "71894",
   "inStock": true,
   "createdAt": "2024-04-18T15:37:41Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/16cC1Z9iMKcm70EX_L0bgiQKk1RORy-MK",
      "b": "https://lh3.googleusercontent.com/d/1yC5PnHl_ogrT4_TCCQwD3qMhh0h1jhs0",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1UX4YmogYeWVHH3n-DP03Sk0OzVYPU8vg",
      "b": "https://lh3.googleusercontent.com/d/17YTs8Oy2NTUsg2r4BQR-mAnn1_lY3lsT",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1sPF7snynAksXct_fWe9h_jKq5OSepJ6b",
      "b": "https://lh3.googleusercontent.com/d/1Ofck-xVziM3Z0tD8kbzW4M9vy_AQ5yXr",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_c399f0da-5da5-4bc6-aa96-489c9144bf4a.jpg?v=1765414959"
   },
   "carat": 0.99,
   "caratMax": 6.49
  },
  {
   "rank": 656,
   "id": "gid://shopify/Product/7596596527288",
   "title": "0.95-6.45 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-110427lb",
   "handle": "engagement-rings-110427lb",
   "priceNow": 1985.99,
   "priceWas": 6160.0,
   "pctOff": 68,
   "core": "110427",
   "inStock": true,
   "createdAt": "2024-04-18T15:37:34Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1xvqje1y0J-BxIExfGoNWoJ4VkGbn2Nn6",
      "b": "https://lh3.googleusercontent.com/d/1STkQOF0YChWob1NpWk0KJCTsjx6cmCIF",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1KfIywr6U5toPSgYIy_uNbM2ia2YeX5HU",
      "b": "https://lh3.googleusercontent.com/d/1QeLE62DWtFJG3BjoWS9xCpubB3GSssea",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1DKVlvcjUgcJNH_GbGMfWOdli3utCAW4Z",
      "b": "https://lh3.googleusercontent.com/d/1YL_lOjIX6nLejfmUfFkDIOxrF-2VKVfz",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_ad968f36-bb6c-4e43-9a7f-0e913e8e1993.jpg?v=1765414963"
   },
   "carat": 0.95,
   "caratMax": 6.45
  },
  {
   "rank": 657,
   "id": "gid://shopify/Product/7596596396216",
   "title": "1.10-6.60 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-15252lb",
   "handle": "engagement-rings-15252lb",
   "priceNow": 1729.99,
   "priceWas": 5360.0,
   "pctOff": 68,
   "core": "15252",
   "inStock": true,
   "createdAt": "2024-04-18T15:37:10Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1_25hpaetyfHPlojWZTI7jX4bWktoyoww",
      "b": "https://lh3.googleusercontent.com/d/1DClIJjF_Psv9RrD7kF1wGXPRjCCM6oSF",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1bPliJu4Fl1DKqOocQJJZzRrK7hAaEtXK",
      "b": "https://lh3.googleusercontent.com/d/1gNZjHAemm0nczGJF44Q4GeJJAKgCv_aL",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1nxui7vnqNdc2qdj8Zha1BK8LxlYxdP0H",
      "b": "https://lh3.googleusercontent.com/d/1qH0Gsp614cJfFoCpalQdPyqlgZkr3rp9",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_a7f83410-b6eb-418c-9b0d-cf677b43da4b.jpg?v=1765414981"
   },
   "carat": 1.1,
   "caratMax": 6.6
  },
  {
   "rank": 658,
   "id": "gid://shopify/Product/7596596330680",
   "title": "0.90-6.40 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71702lb",
   "handle": "engagement-rings-71702lb",
   "priceNow": 1814.99,
   "priceWas": 5630.0,
   "pctOff": 68,
   "core": "71702",
   "inStock": true,
   "createdAt": "2024-04-18T15:37:02Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1H47EboZXcpj6EdWHnjevG5qT-SlfeZEJ",
      "b": "https://lh3.googleusercontent.com/d/1XcANgwx6_KriPCJUk5_e6veCWLQfXclD",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1JJOAFw7yhmtGb5GG9ZuHyilRwC1umRR1",
      "b": "https://lh3.googleusercontent.com/d/13SFSBjz6v41vSlrH-qiub_Ta3p0iYwl4",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1270OVTuJm398TAPwbtM48tFz49DktPWI",
      "b": "https://lh3.googleusercontent.com/d/1kgXGk7vV4xPi-UDBPXbVretX2SFiFaz3",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_3010a36a-2447-405b-a147-c7480d79a177.jpg?v=1765414984"
   },
   "carat": 0.9,
   "caratMax": 6.4
  },
  {
   "rank": 659,
   "id": "gid://shopify/Product/7596596068536",
   "title": "0.95-6.45 CT Marquise & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71750lb",
   "handle": "engagement-rings-71750lb",
   "priceNow": 1728.99,
   "priceWas": 5360.0,
   "pctOff": 68,
   "core": "71750",
   "inStock": true,
   "createdAt": "2024-04-18T15:36:50Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1OkYHkjMX3hR6cry3Z1UL39SQaoQ1pQmi",
      "b": "https://lh3.googleusercontent.com/d/1WOzwcu3PRmBdPmpToN20GRb8HnDY6mjH",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1fhUU_nFf3TCn_lfKyKMZLCvPGk-_w1e9",
      "b": "https://lh3.googleusercontent.com/d/1NTiFx_hVO_8C1ZaNzRaGI-bPz1E37Gjg",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ET1QZtR0hhgci1dxdApLlvnErlq94sbA",
      "b": "https://lh3.googleusercontent.com/d/1m-J99CjzPelHnK2tZUha8apTF8ewRflc",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_f2000edf-5969-4fc7-90d2-9d1e6ec51139.jpg?v=1765414988"
   },
   "carat": 0.95,
   "caratMax": 6.45
  },
  {
   "rank": 660,
   "id": "gid://shopify/Product/7566851965112",
   "title": "0.84-6.34 CT Cushion & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71833lb",
   "handle": "engagement-rings-71833lb",
   "priceNow": 1838.99,
   "priceWas": 5700.0,
   "pctOff": 68,
   "core": "71833",
   "inStock": true,
   "createdAt": "2024-04-12T18:10:56Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1qQtsJ9yrym-_j2Z04EOSqpsv1DypAmkv",
      "b": "https://lh3.googleusercontent.com/d/1MVMgP4wZAgAwmcZCSqBUQemFEdSYBsCB",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1Z5r78SYLmj6UUi9v2RXziMEySHNilr37",
      "b": "https://lh3.googleusercontent.com/d/1i1xjzByicYa1X5MMjtcgJmi6W-yQ2ek3",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1H-ixn7NaKXncMk3PnThAZSiiqs23X8Nm",
      "b": "https://lh3.googleusercontent.com/d/1r42d8B4f1bXOFTT_jS2sYT7ZOIxqha8_",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_5aa263f5-9c19-45a5-9b64-97fa1fc059b8.jpg?v=1765414992"
   },
   "carat": 0.84,
   "caratMax": 6.34
  },
  {
   "rank": 661,
   "id": "gid://shopify/Product/7566851899576",
   "title": "0.75-6.25 CT Baguette & Marquise & Princess Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71859lb",
   "handle": "engagement-rings-71859lb",
   "priceNow": 2075.99,
   "priceWas": 6440.0,
   "pctOff": 68,
   "core": "71859",
   "inStock": true,
   "createdAt": "2024-04-12T18:10:52Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1QlnvLLGn5wfQInaaLEMarZw6azOOvSve",
      "b": "https://lh3.googleusercontent.com/d/1TFKQP6S1oBMsubrP3w87Jpds_yrqMdL3",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1toNGJj39XjzTT0UsIbxnT16mEshE-p53",
      "b": "https://lh3.googleusercontent.com/d/1ijFIf4VmT_6DiUaXnEtNluaWPIlR4R6H",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1VIPlBFE70AMfeKANl4Umk4XrTI3E22ZQ",
      "b": "https://lh3.googleusercontent.com/d/1ImIgI8HEa_qkQO5E0MMgRtfXIA8ixSj6",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_aa6bda9f-9d46-4500-ba03-74a28a0747ef.jpg?v=1765415006"
   },
   "carat": 0.75,
   "caratMax": 6.25
  },
  {
   "rank": 662,
   "id": "gid://shopify/Product/7566851866808",
   "title": "0.92-6.42 CT Pear & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71860lb",
   "handle": "engagement-rings-71860lb",
   "priceNow": 1751.99,
   "priceWas": 5430.0,
   "pctOff": 68,
   "core": "71860",
   "inStock": true,
   "createdAt": "2024-04-12T18:10:47Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1fX5k_I9-PdAtZTxY1UNpkCJMtDOb8Uhz",
      "b": "https://lh3.googleusercontent.com/d/1SUTfSOJWlcMK4C8Ono3ST3ffGw9F4bMN",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1iFq7wE2ul9OEjQz0L0HeHBYAeeeu373b",
      "b": "https://lh3.googleusercontent.com/d/1P-THq960Bls-soTvM-ql2fPOu7dk3J91",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1T-VwNiM_hL_kuJJDxdlNV_-SFgdM-f5L",
      "b": "https://lh3.googleusercontent.com/d/1b4RNgG6M3vc2Ssl8HZpIz87QOpfPHJIH",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_d7e68acf-b103-428a-bb67-dd37d4bb3d5b.jpg?v=1765415009"
   },
   "carat": 0.92,
   "caratMax": 6.42
  },
  {
   "rank": 663,
   "id": "gid://shopify/Product/7566851702968",
   "title": "0.75-6.25 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71915lb",
   "handle": "engagement-rings-71915lb",
   "priceNow": 1962.99,
   "priceWas": 6090.0,
   "pctOff": 68,
   "core": "71915",
   "inStock": true,
   "createdAt": "2024-04-12T18:10:34Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1kD1VcIAhRsp_055xMYtUQxEPOdECBZ_v",
      "b": "https://lh3.googleusercontent.com/d/1ufUQeFJycNYoVm0f-VGqFnKSSm7PQiW9",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1XgaaxzuVnybrnfeQEAFBuHI_2sV5gFsX",
      "b": "https://lh3.googleusercontent.com/d/15Ho1x-9t36ez93GHFxDLwIb-x1Dz1Sxu",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1mHnbMpBKSSZH-myUsiMrzbkIV4Z-9rmG",
      "b": "https://lh3.googleusercontent.com/d/1eFirtpV1jyKcOO-torda2JGymxN1o1gB",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_1219aa57-28b9-49c4-bf72-dc41d6a84efb.jpg?v=1765415014"
   },
   "carat": 0.75,
   "caratMax": 6.25
  },
  {
   "rank": 664,
   "id": "gid://shopify/Product/7566851637432",
   "title": "0.90-6.40 CT Emerald & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-110425lb",
   "handle": "engagement-rings-110425lb",
   "priceNow": 1759.99,
   "priceWas": 5460.0,
   "pctOff": 68,
   "core": "110425",
   "inStock": true,
   "createdAt": "2024-04-12T18:10:26Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1Dx_2ZYl7yKSMQM-BQx9IY-1QLemlVLue",
      "b": "https://lh3.googleusercontent.com/d/1ld4kCl1QZYo-UA_vcZJnl0q2WoRTIbzV",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1ZeNoZuf0D8GXEuYomSgCmFuiRNx51kAN",
      "b": "https://lh3.googleusercontent.com/d/1rLV_K9_qQzeimYvx9Y9eg1xraP5kJn2Q",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1g1AGBXL2x1SqfSZTpOJ4cXXmpm794Mx-",
      "b": "https://lh3.googleusercontent.com/d/1BIyIdA2ih-Qj2tq85YLMVMCf6C4rVF_F",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_cf664ea6-0b9b-407d-98c4-d6e74274ddd8.jpg?v=1765415018"
   },
   "carat": 0.9,
   "caratMax": 6.4
  },
  {
   "rank": 665,
   "id": "gid://shopify/Product/7566851506360",
   "title": "0.35 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-110339lb",
   "handle": "wedding-bands-110339lb",
   "priceNow": 1649.99,
   "priceWas": 5110.0,
   "pctOff": 68,
   "core": "110339",
   "inStock": true,
   "createdAt": "2024-04-12T18:10:19Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1-YfH9LSY_2FakksFp16yGou6M3Cg6MBN",
      "b": "https://lh3.googleusercontent.com/d/12mSGZqWwE449c5YMG_Mdt5_BypoFTxT2",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/15QSySlvDPmT8ojaPtnecmD3RR0HhPkbk",
      "b": "https://lh3.googleusercontent.com/d/1oFV9C-bdgQ23sCQx2xma3VZlG2_iEkAC",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1R3Alowqm2tURUS9ileJlm714jyld-_CU",
      "b": "https://lh3.googleusercontent.com/d/15bIQz9YYFVxLW-4RUg59GHEkYiJm-3l3",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_7e298b02-fbf2-4082-afe3-127776229ad0.jpg?v=1712948222"
   },
   "carat": 0.35
  },
  {
   "rank": 666,
   "id": "gid://shopify/Product/7566851408056",
   "title": "0.95-6.45 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-16082lb",
   "handle": "engagement-rings-16082lb",
   "priceNow": 1852.99,
   "priceWas": 5740.0,
   "pctOff": 68,
   "core": "16082",
   "inStock": true,
   "createdAt": "2024-04-12T18:10:08Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1zWAj2BL4zygEc1NIz_V0suqxaWldbbqJ",
      "b": "https://lh3.googleusercontent.com/d/10nSQhFHb4ev9ybFjETTvOLICpCkGtpze",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/19i7KjLImr7hq1kM31OsSJexOShbu0j-7",
      "b": "https://lh3.googleusercontent.com/d/19LLLcIt5MvOygE_ZbVZrdw-YbJOvniss",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/16FL-PM2z3yBUlruWL0W-7edTvJ4ACE58",
      "b": "https://lh3.googleusercontent.com/d/1NFH8_sE3X1JT-CfApQ0FwstxMv1ACm2x",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_c491e28a-998e-408f-964c-67e03f5bb063.jpg?v=1765415031"
   },
   "carat": 0.95,
   "caratMax": 6.45
  },
  {
   "rank": 667,
   "id": "gid://shopify/Product/7566851276984",
   "title": "1.10-6.60 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-16020lb",
   "handle": "engagement-rings-16020lb",
   "priceNow": 1596.99,
   "priceWas": 4950.0,
   "pctOff": 68,
   "core": "16020",
   "inStock": true,
   "createdAt": "2024-04-12T18:10:02Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1Vs-OkdGp5ZHSCmkNBUVaUab4XsDTI9q-",
      "b": "https://lh3.googleusercontent.com/d/1eWZzTxXTPn38uL0_nT4z3m2xF7vdYXO-",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/15b3jzPbPlmOuuRn_doJrivapClhOjNlV",
      "b": "https://lh3.googleusercontent.com/d/1KUMEPePEhqEyol0Hd1zZj2YVmY3l5slh",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ySL0hEKW4weiSnK9lElzpFW6vKr2AYoa",
      "b": "https://lh3.googleusercontent.com/d/1rRLBJztdGaFldVltH6XFShMsfVoFeis_",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_8850dad6-3fe5-4d35-b9c7-d71c31895262.jpg?v=1765415035"
   },
   "carat": 1.1,
   "caratMax": 6.6
  },
  {
   "rank": 668,
   "id": "gid://shopify/Product/7566851244216",
   "title": "0.85-6.35 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71687lb",
   "handle": "engagement-rings-71687lb",
   "priceNow": 1777.99,
   "priceWas": 5510.0,
   "pctOff": 68,
   "core": "71687",
   "inStock": true,
   "createdAt": "2024-04-12T18:09:58Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/11Tw_egfNoAfswV26cOyXWMMYdG_LR7mX",
      "b": "https://lh3.googleusercontent.com/d/11MuY_o5Brri-aHFK1XB9GVwW4EdkC7Th",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1ZIkhUY5m4KHRV_QqXYhASSRwOy743pLi",
      "b": "https://lh3.googleusercontent.com/d/13gzua2YDPThBUOItJY4abX8eHx_mz5ID",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1LYXtRo1grkWbaM4XU8bczHcgnF-p_oju",
      "b": "https://lh3.googleusercontent.com/d/1ZIdRhGTXtHokBctxBokLSnf-29HM2yM8",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_a50af641-d0ea-43a4-a3d4-a9a6b8fc6de9.jpg?v=1765415039"
   },
   "carat": 0.85,
   "caratMax": 6.35
  },
  {
   "rank": 669,
   "id": "gid://shopify/Product/7566851113144",
   "title": "0.80-6.30 CT Marquise & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71927lb",
   "handle": "engagement-rings-71927lb",
   "priceNow": 1766.99,
   "priceWas": 5480.0,
   "pctOff": 68,
   "core": "71927",
   "inStock": true,
   "createdAt": "2024-04-12T18:09:45Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1TUiUWZv1Efxp1mXf9U0yA4QpVfaCcE2U",
      "b": "https://lh3.googleusercontent.com/d/1wQYki7yyoMz5CiUtF7jRtH4rSa6ueQMY",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1yAdB4wH_s-oZ_zB2OUvfJe_JcmUeIXss",
      "b": "https://lh3.googleusercontent.com/d/1oKiOl1BvpTNiNetngGekXb2v0N5CXACr",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1woWjwzEJORf8g6WHUplHjrlI-CdfZv3C",
      "b": "https://lh3.googleusercontent.com/d/1OF4ERbft_XJqCEYiw2S27mORawO1JHsQ",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_bccfe17f-b234-4e5f-b010-740b61c98a31.jpg?v=1765415044"
   },
   "carat": 0.8,
   "caratMax": 6.3
  },
  {
   "rank": 670,
   "id": "gid://shopify/Product/7566851047608",
   "title": "0.80-6.30 CT Oval & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71928lb",
   "handle": "engagement-rings-71928lb",
   "priceNow": 1775.99,
   "priceWas": 5510.0,
   "pctOff": 68,
   "core": "71928",
   "inStock": true,
   "createdAt": "2024-04-12T18:09:32Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1ntx5qVlc8SrNzxE-xVPxwYCo9O4UUUXm",
      "b": "https://lh3.googleusercontent.com/d/1ey2YbISKJ4ZhmiddA3WAcrFcZn1FtBuR",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1Qr6aRma-xPXRSa7sjkJVMWFxE0OD5R47",
      "b": "https://lh3.googleusercontent.com/d/1cVDrx5QD0RNMfXB1xuloC20Rtawm-GNl",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/19N1ZtvYG_1y5wKhm4GoeiWolwakkIt4D",
      "b": "https://lh3.googleusercontent.com/d/1TPUy2XBpkq0VoDsPoroHamAAlQhuvStE",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_ab068301-daea-4348-a45f-b32cf5dc20c4.jpg?v=1765415057"
   },
   "carat": 0.8,
   "caratMax": 6.3
  },
  {
   "rank": 671,
   "id": "gid://shopify/Product/7566850982072",
   "title": "0.75-6.25 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71937lb",
   "handle": "engagement-rings-71937lb",
   "priceNow": 1748.99,
   "priceWas": 5420.0,
   "pctOff": 68,
   "core": "71937",
   "inStock": true,
   "createdAt": "2024-04-12T18:09:25Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1IMcrqFkTGEnqR1QkNMkl5f6kn9sRzrpe",
      "b": "https://lh3.googleusercontent.com/d/1yFNXfwg3l9NOmTIQQWQXIFt-GlQRoCD4",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1B9bfkJA5a_ECU28ol2-cu7E_z-TAFAht",
      "b": "https://lh3.googleusercontent.com/d/1v1xfFZqC-vw1ycoG0EXqc77bkAkRcmzM",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Jl7DYJWEAe4xvTPyOYaOwhXsV8gG0hwj",
      "b": "https://lh3.googleusercontent.com/d/1TNsatpbSAWL4VFUznPhRhsgdLbJl2F0j",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_e87ac98c-9049-4b29-b8b0-44b897a1fd6f.jpg?v=1765415060"
   },
   "carat": 0.75,
   "caratMax": 6.25
  },
  {
   "rank": 672,
   "id": "gid://shopify/Product/7566850916536",
   "title": "0.75-6.25 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71908lb",
   "handle": "engagement-rings-71908lb",
   "priceNow": 1842.99,
   "priceWas": 5710.0,
   "pctOff": 68,
   "core": "71908",
   "inStock": true,
   "createdAt": "2024-04-12T18:09:13Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_f2df6207-9370-4fdd-8b8b-f8ea161fb1ba.jpg?v=1765415065",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_f2df6207-9370-4fdd-8b8b-f8ea161fb1ba.jpg?v=1765415065",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y3_bc0d26e1-3267-42c6-9501-01cd3d7ec81d.jpg?v=1765415065",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r3_2616c0e8-50de-4b44-98dd-481fd762b21a.jpg?v=1765415065"
    }
   },
   "carat": 0.75,
   "caratMax": 6.25
  },
  {
   "rank": 673,
   "id": "gid://shopify/Product/7566850818232",
   "title": "1.00-6.50 CT Pear & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71861lb",
   "handle": "engagement-rings-71861lb",
   "priceNow": 1653.99,
   "priceWas": 5130.0,
   "pctOff": 68,
   "core": "71861",
   "inStock": true,
   "createdAt": "2024-04-12T18:09:05Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1w1xAOtNWgIheic_Towx2xq5lyzjgUn_T",
      "b": "https://lh3.googleusercontent.com/d/1JiETnS-BSTT13lzzHn5HtgkN-longuCL",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1TT5VmiUe_O_6eSQyHFzJ3isyh_q_xDQV",
      "b": "https://lh3.googleusercontent.com/d/15vN7sqGTKMFmDvoKYpkPTKO28JLWBHV6",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1lzGe59aA0BwgUOEND2XABR3FSWOmKhQq",
      "b": "https://lh3.googleusercontent.com/d/1RcGihfxRDiq3mb3HZ4yM6M3B2PdsNJFQ",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_ad7f7a39-e327-450a-b08f-9409a4a90702.jpg?v=1765415070"
   },
   "carat": 1.0,
   "caratMax": 6.5
  },
  {
   "rank": 674,
   "id": "gid://shopify/Product/7566850785464",
   "title": "0.15 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71217lb",
   "handle": "wedding-bands-71217lb",
   "priceNow": 1249.99,
   "priceWas": 3870.0,
   "pctOff": 68,
   "core": "71217",
   "inStock": true,
   "createdAt": "2024-04-12T18:08:59Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1JqzsraGlEyvJKBC7c7c4QOJ8CntI7rmZ",
      "b": "https://lh3.googleusercontent.com/d/1Tt1WZ6wdeCV80k-ahlS2HKuZCxCy23P-",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1LwRvlYM36BOiXrPUNncoI-y-90k-S2yH",
      "b": "https://lh3.googleusercontent.com/d/1prtxkfKZNjsqA7ueXufE_T99uU3xmwuj",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1fOX0dZRyt3q726Kqn7sYQpNcPMuvL9XH",
      "b": "https://lh3.googleusercontent.com/d/1e0Pdyza-yCo3GVNKaTZ5RYIyk_etdprk",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_32c89640-b5c6-4cfb-bb47-081e5a068d8e.jpg?v=1712946884"
   },
   "carat": 0.15
  },
  {
   "rank": 675,
   "id": "gid://shopify/Product/7562057515192",
   "title": "0.75-6.25 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71896lb",
   "handle": "engagement-rings-71896lb",
   "priceNow": 1530.99,
   "priceWas": 4750.0,
   "pctOff": 68,
   "core": "71896",
   "inStock": true,
   "createdAt": "2024-04-10T22:36:36Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1Hbtqr9-aOcTgrWBzKqFMQjQYqeE0Lazz",
      "b": "https://lh3.googleusercontent.com/d/1MqDYQZAl3x654WO6I1XfIU1LzCwi3-gh",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1uAd3Jqd27gDXrBwrcTs86NhHvUZGrALL",
      "b": "https://lh3.googleusercontent.com/d/1USSdj-tfAOf-74UzFKz6iRJ-isst3okj",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1OIjAc-EXGka7QGYPxoWyeJ2xohyDpcXc",
      "b": "https://lh3.googleusercontent.com/d/1DQX9r9bdF2u92RE8I-BtuHKXaoFwcuBt",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_27819a25-7e14-41a3-9dd9-c6a61d2386dc.jpg?v=1765415083"
   },
   "carat": 0.75,
   "caratMax": 6.25
  },
  {
   "rank": 676,
   "id": "gid://shopify/Product/7562057482424",
   "title": "0.70-6.20 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71914lb",
   "handle": "engagement-rings-71914lb",
   "priceNow": 1715.99,
   "priceWas": 5320.0,
   "pctOff": 68,
   "core": "71914",
   "inStock": true,
   "createdAt": "2024-04-10T22:36:33Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1SOVtmWftkrKkQeX_hvTuNJQRGRBc1mcR",
      "b": "https://lh3.googleusercontent.com/d/1G1_hKtxtDr5S6pZPkxo-qba0h_bJ9Tdl",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1U4hDMOphk6LDo6Sbn2wh8l7fRPye7ywf",
      "b": "https://lh3.googleusercontent.com/d/1iNaKn3qbrbJfvawTFRaCsKYRN4EstHRq",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Jq9nQfTQ-SD8AttYdfnBD6wQaOLPv6P8",
      "b": "https://lh3.googleusercontent.com/d/1z-jJ_igTY7Wb7r05yRtUhCLpqM24DlPP",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_8a9288f7-b312-41f7-be84-3b9a8c881c09.jpg?v=1765415086"
   },
   "carat": 0.7,
   "caratMax": 6.2
  },
  {
   "rank": 677,
   "id": "gid://shopify/Product/7562057351352",
   "title": "0.15 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-110317lb",
   "handle": "wedding-bands-110317lb",
   "priceNow": 990.99,
   "priceWas": 3370.0,
   "pctOff": 71,
   "core": "110317",
   "inStock": true,
   "createdAt": "2024-04-10T22:36:24Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1b5FJombo40ih5i-yzi3yrHo2Jr6ddbn6",
      "b": "https://lh3.googleusercontent.com/d/1ZEPd1DB0xlY7tyeULppDj7jOsOYQj5x2",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1ANCD2kyGzV_GFb_4zuV9vm_LVlP6sDR2",
      "b": "https://lh3.googleusercontent.com/d/1mH4a3GGbFPpBt3YByykM9u3DLRjggfR0",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1hZbxtkWTX1MHmN3FF8rl5_RBYnLzpcGE",
      "b": "https://lh3.googleusercontent.com/d/1GZeXDoGZUuoczZv4z3IzHyJypCB6omSp",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_49fa366c-f013-4acd-a0d7-73f0b38b5f60.jpg?v=1712862422"
   },
   "carat": 0.15
  },
  {
   "rank": 678,
   "id": "gid://shopify/Product/7562057253048",
   "title": "0.70-6.20 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-110423lb",
   "handle": "engagement-rings-110423lb",
   "priceNow": 1652.99,
   "priceWas": 5120.0,
   "pctOff": 68,
   "core": "110423",
   "inStock": true,
   "createdAt": "2024-04-10T22:36:02Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1wgkBcQSCn90eCJbXEqFDXkMMTO4Av2fu",
      "b": "https://lh3.googleusercontent.com/d/1xZ2iFFqLDtG7_lsJuLlTXRCK9HrTz1_C",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1uIpveHg57SzKu0eq2boqd-BV7Y3U8Eak",
      "b": "https://lh3.googleusercontent.com/d/1tesixlq1pUfy0Z31M9d24LEpAUY_Cbh4",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1YOYtEvGdC94vHMF24aDnwcQT1zUHThvq",
      "b": "https://lh3.googleusercontent.com/d/109Z6L7Of5xuBUGPqsmSHuSOcrtNtOXOs",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_a5c28712-a95d-4829-b196-6a801463c055.jpg?v=1765415095"
   },
   "carat": 0.7,
   "caratMax": 6.2
  },
  {
   "rank": 679,
   "id": "gid://shopify/Product/7562057220280",
   "title": "0.80-6.30 CT Oval & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71831lb",
   "handle": "engagement-rings-71831lb",
   "priceNow": 1712.99,
   "priceWas": 5310.0,
   "pctOff": 68,
   "core": "71831",
   "inStock": true,
   "createdAt": "2024-04-10T22:35:59Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1Y3BjrIMIaafX26bmQCCIfsM1vruElg3y",
      "b": "https://lh3.googleusercontent.com/d/1XUS8tlUdJB5z7fJhclmU4nWkCuzugxlD",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1LfcNufcGimrW8ghrEKWknH6jWFm8LUSc",
      "b": "https://lh3.googleusercontent.com/d/1a9pdaf_wvf_iWNnnCE8Gx-9t4BtiyVIQ",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1gRVe0AuSSp9Fug-cgXRZ6w4s1LWYs-Hh",
      "b": "https://lh3.googleusercontent.com/d/1uL3LW-WgoaA3kk7w2M1Fcm745DoeFbax",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_35e60df8-d74e-401c-84d1-293cef86044e.jpg?v=1765415108"
   },
   "carat": 0.8,
   "caratMax": 6.3
  },
  {
   "rank": 680,
   "id": "gid://shopify/Product/7562057187512",
   "title": "0.90-6.40 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71780lb",
   "handle": "engagement-rings-71780lb",
   "priceNow": 1402.99,
   "priceWas": 4350.0,
   "pctOff": 68,
   "core": "71780",
   "inStock": true,
   "createdAt": "2024-04-10T22:35:54Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1kbMOlGU_KxIfqVN-gyir_S7v2IpDAsI5",
      "b": "https://lh3.googleusercontent.com/d/10C26Xi9ClCFW7MGtIKu7sp1NyhwQ-CE5",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1pBYwvObgPP0TkZlSQJ2VLkKrX-fFMsdO",
      "b": "https://lh3.googleusercontent.com/d/1CKjzCXpO2BSwhoAlLvrk3JX_VuZy_Wul",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1RNVe73a9AQ8twC4HtTResvUFrlCuWJhx",
      "b": "https://lh3.googleusercontent.com/d/1F3xvm7Jq3J9KVAqJHBSfMwwgYbi_kdgm",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_43515182-5391-4ad2-8336-7320b9adfd98.jpg?v=1765415111"
   },
   "carat": 0.9,
   "caratMax": 6.4
  },
  {
   "rank": 681,
   "id": "gid://shopify/Product/7544414732472",
   "title": "0.60 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71776lb",
   "handle": "wedding-bands-71776lb",
   "priceNow": 1152.99,
   "priceWas": 3570.0,
   "pctOff": 68,
   "core": "71776",
   "inStock": true,
   "createdAt": "2024-04-04T17:44:27Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1Nnphc2vnKqnr426a2j6KS-dYbvpL_2N4",
      "b": "https://lh3.googleusercontent.com/d/1X7pi3ca478P5Bt6kisebechyoNGQyyPx",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1zxARy1nmjF006e7sUo00O1NSnz1Kh4bw",
      "b": "https://lh3.googleusercontent.com/d/1nTqvHtYUKv_XjgL7_tp9ZkIphrhRhOHL",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/16qebQU6YaG7Nrqg0Xyi_FW3lJybH102c",
      "b": "https://lh3.googleusercontent.com/d/1gFpb_kFABR6RdTFS6s599j1Gsk0SW-DA",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_325c2f8e-7784-4b74-931b-d72b4e30fe9a.jpg?v=1763698614"
   },
   "carat": 0.6
  },
  {
   "rank": 682,
   "id": "gid://shopify/Product/7544414535864",
   "title": "0.75-6.25 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-103291lb",
   "handle": "engagement-rings-103291lb",
   "priceNow": 1744.99,
   "priceWas": 5410.0,
   "pctOff": 68,
   "core": "103291",
   "inStock": true,
   "createdAt": "2024-04-04T17:44:15Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1KvP2vFcBe0ke68V5f5wfbMNnyJ-jPzwM",
      "b": "https://lh3.googleusercontent.com/d/190NzhnSA3-3YupUhpP0Cng3VIeT5Fqh2",
      "angles": [
       5,
       6
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1kuVNE9JcZ65rymHufvBKhKEKNYs9B--h",
      "b": "https://lh3.googleusercontent.com/d/19OQUm9NvsT_LKmDSeII8U0WxAAVS7Vfx",
      "angles": [
       5,
       6
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ulDFe7-fQ58C8QSQE9h-9pXhqht7ZosV",
      "b": "https://lh3.googleusercontent.com/d/1SFW4xOy2-Iw8ppmkfo6GiI3LbvluesOZ",
      "angles": [
       5,
       6
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_a2ee6031-ba76-4865-9a39-bc8e2b8ed0db.jpg?v=1765415114"
   },
   "carat": 0.75,
   "caratMax": 6.25
  },
  {
   "rank": 683,
   "id": "gid://shopify/Product/7544414404792",
   "title": "0.90-6.40 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71873lb",
   "handle": "engagement-rings-71873lb",
   "priceNow": 1409.99,
   "priceWas": 4370.0,
   "pctOff": 68,
   "core": "71873",
   "inStock": true,
   "createdAt": "2024-04-04T17:44:09Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1WHoj7drVAgwUOf77xo02jSTPp1SFqxbV",
      "b": "https://lh3.googleusercontent.com/d/199x7dWC00FEvkdUzBosVNTUf9rzzZgyy",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1WdGIUWgoaTrMkAQ8Lu7kqUCuOQNmbigP",
      "b": "https://lh3.googleusercontent.com/d/1-UJCL9yn8lNrcB_qy_7wY1UfsB8cKJQy",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1BHJfloMgXXRjSULPW3e2pdvz37cF6CJk",
      "b": "https://lh3.googleusercontent.com/d/1qx7IgWk2nUs-Pclr9VH0Vav4OFUbbo3o",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_db6b4699-22c1-45ed-8017-4a517ad07e6a.jpg?v=1765415121"
   },
   "carat": 0.9,
   "caratMax": 6.4
  },
  {
   "rank": 684,
   "id": "gid://shopify/Product/7544414306488",
   "title": "0.85-6.35 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-16009lb",
   "handle": "engagement-rings-16009lb",
   "priceNow": 1505.99,
   "priceWas": 4670.0,
   "pctOff": 68,
   "core": "16009",
   "inStock": true,
   "createdAt": "2024-04-04T17:43:59Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/11BQ29dGkc-quAtZgWUC5DmQpDh9rZq5g",
      "b": "https://lh3.googleusercontent.com/d/11VrAdesJrdMBjUQdGauid0fbfz6eh4TI",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1SoTPNmMfmFzZFZJTgKpp6D1fCnUSxU1y",
      "b": "https://lh3.googleusercontent.com/d/1ctoruvcgX4zlVNZIVPbFQxQoODEpZgYR",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1IeZjcpk7_pyXuj0LKA7qfdJEX_OYSMOq",
      "b": "https://lh3.googleusercontent.com/d/1cYGswsCgKxiyVKPtD3cns21TxMaPi27V",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_c746fa60-9535-47e8-995f-7a19be8f5264.jpg?v=1765415133"
   },
   "carat": 0.85,
   "caratMax": 6.35
  },
  {
   "rank": 685,
   "id": "gid://shopify/Product/7544414077112",
   "title": "2.90 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-15269lb",
   "handle": "wedding-bands-15269lb",
   "priceNow": 1780.99,
   "priceWas": 5520.0,
   "pctOff": 68,
   "core": "15269",
   "inStock": true,
   "createdAt": "2024-04-04T17:43:45Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1z-q7pw4JevJCW4VnyPW5x-_4GPm4PAP5",
      "b": "https://lh3.googleusercontent.com/d/19s_RI6NpGEDVxPM8DzrhIEh91GVSg3DA",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1Bhxay2Un1-lP-ppMOSx1yjK5M-hi13qZ",
      "b": "https://lh3.googleusercontent.com/d/1Ow4T2qw04yLmFIhtg8-3gCTWShatF_qn",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ZDaQOzgxzxkZei8k1jaU9Z1s4mP7Za7_",
      "b": "https://lh3.googleusercontent.com/d/1m-2cbJ74SkzgKQ1gyJdX2WtEo5Y6sEKE",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_39d466df-625a-43c2-822b-166e1547368f.jpg?v=1712254469"
   },
   "carat": 2.9
  },
  {
   "rank": 686,
   "id": "gid://shopify/Product/7544413880504",
   "title": "0.70-6.20 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71671lb",
   "handle": "engagement-rings-71671lb",
   "priceNow": 1661.99,
   "priceWas": 5150.0,
   "pctOff": 68,
   "core": "71671",
   "inStock": true,
   "createdAt": "2024-04-04T17:43:35Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1jjgD4FuXPaGGR_-V9ZCUMfPz5OIngyS-",
      "b": "https://lh3.googleusercontent.com/d/1BM7JEqGTGLW5_fQfYEbgRG6Wc_18b4rn",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/12h3yMQ0wp36n6rVlZSt_VGZAq25OJPkp",
      "b": "https://lh3.googleusercontent.com/d/1Ww0zkaMG1PsYikjV2ZD_yfAcTx3b6RFW",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/14QXIBNz8KGlPYsCovmBjdxMHj2_TLhHp",
      "b": "https://lh3.googleusercontent.com/d/126wcsmh7ESNTfHDs_S0oPK9JHVvM0l1M",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_137f8735-8f83-40ea-8fa6-1b0b44d509f8.jpg?v=1765415136"
   },
   "carat": 0.7,
   "caratMax": 6.2
  },
  {
   "rank": 687,
   "id": "gid://shopify/Product/7544413716664",
   "title": "0.80-6.30 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-15237lb",
   "handle": "engagement-rings-15237lb",
   "priceNow": 1766.99,
   "priceWas": 5480.0,
   "pctOff": 68,
   "core": "15237",
   "inStock": true,
   "createdAt": "2024-04-04T17:43:26Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1K3mwkG0pQrdx0LPuKskcPJd1p2APQG-r",
      "b": "https://lh3.googleusercontent.com/d/1B5xWsx3fDS72Rqnm0Chfysk9o8Fs9fYH",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1c_ZQoOGh5radidU4DOwR31vM0XaCK63X",
      "b": "https://lh3.googleusercontent.com/d/1ciDiBRSM1WQFxwL7MRwDQzdPNpKctGvI",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1KjO0wnaSsG-VQ2OWjdHyDo6HeYp4RZUG",
      "b": "https://lh3.googleusercontent.com/d/1tBJvo13F0miCjOrFktn9zG7Wv99SBof8",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_e84438e7-a28b-4f31-93f3-1c99f6c34f5f.jpg?v=1765415139"
   },
   "carat": 0.8,
   "caratMax": 6.3
  },
  {
   "rank": 688,
   "id": "gid://shopify/Product/7509723513016",
   "title": "0.90-6.40 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71756lb",
   "handle": "engagement-rings-71756lb",
   "priceNow": 1533.99,
   "priceWas": 4760.0,
   "pctOff": 68,
   "core": "71756",
   "inStock": true,
   "createdAt": "2024-03-26T23:45:11Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1S5Y1G_24D9aJN3JIghiQfCCN8QeDh7at",
      "b": "https://lh3.googleusercontent.com/d/1hU6ATOnHOTQ039-ZJGE4SYdQaDJV8oed",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1kvSCZCavt2ZFy5QDEfbuq-Joqi3i0yBV",
      "b": "https://lh3.googleusercontent.com/d/1u0UNjdRHC-ww43uwnsmvQQdt70bPUwC5",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/11_KsF3wM3-0BnikYxz0wiTRTCaeqefj-",
      "b": "https://lh3.googleusercontent.com/d/1EUyDOhqpK3AXPzfcUK7ugGhvfJxExQT0",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_5398c4d8-fadd-44af-a2af-13b078729b9a.jpg?v=1765415147"
   },
   "carat": 0.9,
   "caratMax": 6.4
  },
  {
   "rank": 689,
   "id": "gid://shopify/Product/7509723480248",
   "title": "0.85-6.35 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71751lb",
   "handle": "engagement-rings-71751lb",
   "priceNow": 1597.99,
   "priceWas": 4950.0,
   "pctOff": 68,
   "core": "71751",
   "inStock": true,
   "createdAt": "2024-03-26T23:44:58Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1-WU44Q4R5l15L1uTEw670KiRS-1bFd8y",
      "b": "https://lh3.googleusercontent.com/d/1JFeN8uQegufakJnmXoIOdUn8IsrbVVED",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1JjwS0xSoWYH5-jaWAyUq-luaZqihz5zO",
      "b": "https://lh3.googleusercontent.com/d/1AxanU72adnRL0PP68hG_Bf4EJ40Wjs9b",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Y681KAXrF-Kvz_JN3ild0wwJimRh74As",
      "b": "https://lh3.googleusercontent.com/d/1Cy1py2-bZtvVcrZODtJKT_wOLF5pfZsj",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_081e29f3-f817-4445-8a25-14b0f5b3c97e.jpg?v=1765415158"
   },
   "carat": 0.85,
   "caratMax": 6.35
  },
  {
   "rank": 690,
   "id": "gid://shopify/Product/7509723447480",
   "title": "0.80-6.30 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71931lb",
   "handle": "engagement-rings-71931lb",
   "priceNow": 1371.99,
   "priceWas": 4250.0,
   "pctOff": 68,
   "core": "71931",
   "inStock": true,
   "createdAt": "2024-03-26T23:44:53Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1tYBI5R1WVl8iMcB7X3jxMGV0hWFjIPX2",
      "b": "https://lh3.googleusercontent.com/d/1AnhcsfCmDJnQ4DdetjRIXyVg5qGuySB3",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1B7DYi7RDP9SXnIxYJjmDmtonr4BOJpL9",
      "b": "https://lh3.googleusercontent.com/d/1fMzvAWwNObdktIIA74Q8yXG6g70rf2eC",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1F3Ou7u88_lbZLMoa9dG1jNLN437fXOZC",
      "b": "https://lh3.googleusercontent.com/d/1-_ZeNoXT6WRtR78dNwY5NsNnqBIVeW0X",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_92e82ebb-c644-4b82-95eb-130e93fbcc3c.jpg?v=1765415161"
   },
   "carat": 0.8,
   "caratMax": 6.3
  },
  {
   "rank": 691,
   "id": "gid://shopify/Product/7509723349176",
   "title": "0.65-6.15 CT Ascher & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71940lb",
   "handle": "engagement-rings-71940lb",
   "priceNow": 1463.99,
   "priceWas": 4540.0,
   "pctOff": 68,
   "core": "71940",
   "inStock": true,
   "createdAt": "2024-03-26T23:44:42Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1GQElnuyMvgKU_3K9vb434Ga-lerf6pk7",
      "b": "https://lh3.googleusercontent.com/d/1erWJ2cbvgG3qQDnMmIED7h5EufbJxMi8",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/177xfMRAKeF9atyIb55D-RsF94Pu3iWac",
      "b": "https://lh3.googleusercontent.com/d/1Gor8OaO-8ZHaioVgdYyuW-s4D6LSP1F0",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1CX9QlTemEZ2I96hJiqwTDI3FzOJOYbAN",
      "b": "https://lh3.googleusercontent.com/d/1B8NMz385k8Y8vp8a9OU-ylr1yUcQ3F0-",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_cb2a35b4-c2da-4514-8781-b25ede7a5072.jpg?v=1765415165"
   },
   "carat": 0.65,
   "caratMax": 6.15
  },
  {
   "rank": 692,
   "id": "gid://shopify/Product/7509723316408",
   "title": "0.65-6.15 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-104010lb",
   "handle": "engagement-rings-104010lb",
   "priceNow": 1702.99,
   "priceWas": 5280.0,
   "pctOff": 68,
   "core": "104010",
   "inStock": true,
   "createdAt": "2024-03-26T23:44:30Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1bXvFpkVkg9XjhrNcGFH0XYwLod3dOkaN",
      "b": "https://lh3.googleusercontent.com/d/1HGPxc_AIH16FmJWqvgrLIBUMhGymEymH",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1zo5TYhqN187b9-A19CBP4sOX3xBv2vi1",
      "b": "https://lh3.googleusercontent.com/d/1k5a7Krl1O6EIDvZI5X948yx_VcqHcdD7",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1bdME-KnGO_5qt-_rHHfwwyGyJcbE-Wi4",
      "b": "https://lh3.googleusercontent.com/d/1TlMWCrnUDbYp9Pk1eXvBo8ygEvQ8Gsm6",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_323f0b65-2b36-4a68-81b1-71768ecf0bdd.jpg?v=1765415173"
   },
   "carat": 0.65,
   "caratMax": 6.15
  },
  {
   "rank": 693,
   "id": "gid://shopify/Product/7509723283640",
   "title": "0.15 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-110319lb",
   "handle": "wedding-bands-110319lb",
   "priceNow": 974.99,
   "priceWas": 3310.0,
   "pctOff": 71,
   "core": "110319",
   "inStock": true,
   "createdAt": "2024-03-26T23:44:19Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1VohFr7mPcn27wMvO2k-cP6sfkqZWBqQ2",
      "b": "https://lh3.googleusercontent.com/d/1wwBrWgswcXz5t8pQRDGxEniIX2_0dTEs",
      "angles": [
       1,
       2
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/19VzirKfKnohOgJzf_uuxaGVyNHJb6Yil",
      "b": "https://lh3.googleusercontent.com/d/18oMA_O-653rhwiM4Ay5tRZ0qwmbfZ-R0",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1d9-6QuKJxpA8SoDHH_ear6o0tzdXNWp0",
      "b": "https://lh3.googleusercontent.com/d/1kyaEdEFHosZd35JMCfV0OzaW5TAYKcyf",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_ed3d4790-1f52-441a-9742-916b8b4d3adb.jpg?v=1711736966"
   },
   "carat": 0.15
  },
  {
   "rank": 694,
   "id": "gid://shopify/Product/7509723250872",
   "title": "0.70-6.20 CT Pear & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71939lb",
   "handle": "engagement-rings-71939lb",
   "priceNow": 1550.99,
   "priceWas": 4810.0,
   "pctOff": 68,
   "core": "71939",
   "inStock": true,
   "createdAt": "2024-03-26T23:44:06Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1rfb_frJYH65emxHgWPeuJ0mFERI66xav",
      "b": "https://lh3.googleusercontent.com/d/1YNpfu4yTb60nXwuCUPC2fBo2_xmwVmtd",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1yk4SK7cqeZxwDjRavFUr_SpO5VFxT9zw",
      "b": "https://lh3.googleusercontent.com/d/1SRolMBqbmHzJlRjqu0isArEIZ7WdWcDX",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1r9G8-MwYm-iOm4XfTXm8V9iSbRLuPVR_",
      "b": "https://lh3.googleusercontent.com/d/1RVDuKCmRLdSokJjQHHW1EEqIVSbPr-u7",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_9fffeb86-6b26-45a3-8c89-95d7b1df5b62.jpg?v=1765415183"
   },
   "carat": 0.7,
   "caratMax": 6.2
  },
  {
   "rank": 695,
   "id": "gid://shopify/Product/7509723218104",
   "title": "0.85-6.35 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71912lb",
   "handle": "engagement-rings-71912lb",
   "priceNow": 1386.99,
   "priceWas": 4300.0,
   "pctOff": 68,
   "core": "71912",
   "inStock": true,
   "createdAt": "2024-03-26T23:43:56Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_e8f3d755-44f3-4a83-a147-b56bd6c5475b.jpg?v=1765415187",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_e8f3d755-44f3-4a83-a147-b56bd6c5475b.jpg?v=1765415187",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y3_24f487e9-1e31-4ce2-bea6-55ffeb0b7f79.jpg?v=1765415187",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r3_d3694964-ee4c-4380-a981-615b70b5195b.jpg?v=1765415187"
    }
   },
   "carat": 0.85,
   "caratMax": 6.35
  },
  {
   "rank": 696,
   "id": "gid://shopify/Product/7509723185336",
   "title": "0.75-6.25 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-110422lb",
   "handle": "engagement-rings-110422lb",
   "priceNow": 1609.99,
   "priceWas": 4990.0,
   "pctOff": 68,
   "core": "110422",
   "inStock": true,
   "createdAt": "2024-03-26T23:43:49Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1Z322A7B2hl2kWuiriR12GGVSPP3Pavt6",
      "b": "https://lh3.googleusercontent.com/d/14f5ZeCnZH6EDm6Bt35gaHGrY9JDrHeMl",
      "angles": [
       5,
       6
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1kUrRP6ivBM0ucRBptOD8OrsWeFfkeeqh",
      "b": "https://lh3.googleusercontent.com/d/1g1vMPZumxbJ2xksD2nEnj2bpprL8PPO4",
      "angles": [
       5,
       6
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1NNZZqP9YuA8b6Q4lEtQBHS1c_KDy9D_l",
      "b": "https://lh3.googleusercontent.com/d/1uO2iVpJrsLU54nfNFUwAKHWUVau4dB8_",
      "angles": [
       5,
       6
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_8ba7d2ed-a934-41b8-868d-b096f7bc45cb.jpg?v=1765415190"
   },
   "carat": 0.75,
   "caratMax": 6.25
  },
  {
   "rank": 697,
   "id": "gid://shopify/Product/7509723119800",
   "title": "0.75-6.25 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71667lb",
   "handle": "engagement-rings-71667lb",
   "priceNow": 1669.99,
   "priceWas": 5180.0,
   "pctOff": 68,
   "core": "71667",
   "inStock": true,
   "createdAt": "2024-03-26T23:43:36Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1D-_4NIOMWPTGZa6xuC8sU7_lrbFKe222",
      "b": "https://lh3.googleusercontent.com/d/1LKgmQ1nynOIYgQ87m0eyJZ-t-zJfzn3h",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1_kMqXrrS2QaqpeQ1AY0z5yUxL64FCrwv",
      "b": "https://lh3.googleusercontent.com/d/1X7uLjTGPr4iWi8dRcbcu8bdTHa5ryrof",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1gwkcc-Ok0BshpVr-wYWtnlhdAoH4kTgr",
      "b": "https://lh3.googleusercontent.com/d/1tr9fD-auDIyZqjb8EWMlZyQRpluFnKSm",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_2ff0ecc7-942c-4423-8987-d271ae2c9e7c.jpg?v=1765415199"
   },
   "carat": 0.75,
   "caratMax": 6.25
  },
  {
   "rank": 698,
   "id": "gid://shopify/Product/7509723087032",
   "title": "0.80 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-15266lb",
   "handle": "wedding-bands-15266lb",
   "priceNow": 1297.99,
   "priceWas": 4020.0,
   "pctOff": 68,
   "core": "15266",
   "inStock": true,
   "createdAt": "2024-03-26T23:43:34Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1vYEtgUrQR1ZsfNBn28ZOGzlM4LrIOo2E",
      "b": "https://lh3.googleusercontent.com/d/1o0V_UvqGeRxoDC5mpSWVRJRhi83vy0Lh",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1uXaekd9vIRBh7_nxPnkt4uMCeQowXwwT",
      "b": "https://lh3.googleusercontent.com/d/1shyNN-ZOY04UIYYErjNHe03IXy8nHh20",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/17FOLg-sWSw38gYF5qkluW0t3j1cbREqq",
      "b": "https://lh3.googleusercontent.com/d/1yRK_2FNVtlnzrUo21lJF3i5vSxdEDi2R",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_d93d4db6-f404-437d-bcf1-730c8f2caf81.jpg?v=1763698615"
   },
   "carat": 0.8
  },
  {
   "rank": 699,
   "id": "gid://shopify/Product/7509722955960",
   "title": "0.75-6.25 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-16026lb",
   "handle": "engagement-rings-16026lb",
   "priceNow": 1293.99,
   "priceWas": 4010.0,
   "pctOff": 68,
   "core": "16026",
   "inStock": true,
   "createdAt": "2024-03-26T23:43:08Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1FO1t9vwdsPGgq4V8S5IgTeXa0J8YZL5k",
      "b": "https://lh3.googleusercontent.com/d/1mGGz1Mf_w8WsFsx8H8BXIPTG6Fq0ssYF",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1uabfK5nkjxZAoRMEwQgjx5lvy3cyHql0",
      "b": "https://lh3.googleusercontent.com/d/1EGLMLPsy4XILMF3Py9Xoo4TNUV3KrRjS",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1x6z0L3velmiKrFDZR1dg_fSwFIS97j15",
      "b": "https://lh3.googleusercontent.com/d/1EJGmsUZajFqZGeQFhE_4Gli26MO7PXtg",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_b74cd448-b7c7-40a8-9638-064402d3c25d.jpg?v=1765415209"
   },
   "carat": 0.75,
   "caratMax": 6.25
  },
  {
   "rank": 700,
   "id": "gid://shopify/Product/7509722923192",
   "title": "0.70-6.20 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71709lb",
   "handle": "engagement-rings-71709lb",
   "priceNow": 1661.99,
   "priceWas": 5150.0,
   "pctOff": 68,
   "core": "71709",
   "inStock": true,
   "createdAt": "2024-03-26T23:42:55Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1f2Chq2Ze8IIWOxeJQeYgXiKtRvoMx9r7",
      "b": "https://lh3.googleusercontent.com/d/1T5HPNEu_5GBU6YNmqJdNEX-o8qLyrT3z",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/10BiW3OuFXoGZtBolJ1wxVY_s8KVvsOP7",
      "b": "https://lh3.googleusercontent.com/d/1OgSRsapv9kuvbXE1r70JBKMVfm8rQMLG",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ZHSfnrOFw1-jwxYFHM505lJ3tvz7PAVI",
      "b": "https://lh3.googleusercontent.com/d/1UoX9rWxCj7d1gwnCv5HjVGTrYlsUtLFw",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_333f5bb0-59f3-4e40-8ab3-4e6dba8cafa6.jpg?v=1765415212"
   },
   "carat": 0.7,
   "caratMax": 6.2
  },
  {
   "rank": 701,
   "id": "gid://shopify/Product/7499113562296",
   "title": "1.05 CT Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-15668lb",
   "handle": "wedding-bands-15668lb",
   "priceNow": 1404.99,
   "priceWas": 4360.0,
   "pctOff": 68,
   "core": "15668",
   "inStock": true,
   "createdAt": "2024-03-20T10:20:31Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1f-QPVc4oi2U-1sDIvXn1x9Fv5NEXHJH6",
      "b": "https://lh3.googleusercontent.com/d/1WqMq9nLxale3imAxHIyqCkl5Wq35NpRo",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1t23CY5ccUuABCYMHnzFWiJ93VQn0Cjlf",
      "b": "https://lh3.googleusercontent.com/d/11150SlppYpqflBiwchLBw-8kxCsnPep2",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1i0f6VFOAuIqJ75RpIolHVPG3r0nC28VY",
      "b": "https://lh3.googleusercontent.com/d/19Prp3XGwjVcPJd9OgUC_bRlXVQPghL-c",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_78a36530-aa6f-4d09-bfdd-771f88346dd4.jpg?v=1763698720"
   },
   "carat": 1.05
  },
  {
   "rank": 702,
   "id": "gid://shopify/Product/7499106058424",
   "title": "1.25-6.75 CT Princess & Round Cut Lab Grown Diamonds - Three Stone Rings",
   "url": "/products/three-stone-rings-71711lb",
   "handle": "three-stone-rings-71711lb",
   "priceNow": 1851.99,
   "priceWas": 5740.0,
   "pctOff": 68,
   "core": "71711",
   "inStock": true,
   "createdAt": "2024-03-20T10:11:40Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1x0ZSr640GL5jodwEGTsGJjjrzHEUZ71S",
      "b": "https://lh3.googleusercontent.com/d/1yHRYhpEN2KIL9apc72XX-K4ZA3B6N_NQ",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1VLcDWOkeczVZ6htFAkmns9xnZhXKMWc6",
      "b": "https://lh3.googleusercontent.com/d/1TyM6jSC3nxXVeoaAwqcjBgPvuvF2pro9",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1hT-jcIaBXFTorUa5wFyM256psWyHGyeQ",
      "b": "https://lh3.googleusercontent.com/d/1ytOAq068KuXiwKK3Y-oApdBuCDI6xQOW",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_7ff8aeca-aba4-47ff-94bc-65e17d3e6d0e.jpg?v=1763766474"
   },
   "carat": 1.25,
   "caratMax": 6.75
  },
  {
   "rank": 703,
   "id": "gid://shopify/Product/7499105894584",
   "title": "0.90-6.40 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71742lb",
   "handle": "engagement-rings-71742lb",
   "priceNow": 1357.99,
   "priceWas": 4210.0,
   "pctOff": 68,
   "core": "71742",
   "inStock": true,
   "createdAt": "2024-03-20T10:11:31Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1iDD5fnHXkvRml7qlCnSTZwJ0g6-JiST7",
      "b": "https://lh3.googleusercontent.com/d/14J2Pg6eqVZ0onDmjGauRjHYdMbzWEba8",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/13ucwfN9ajclOx9kPbxvKBn2x58f0NOqr",
      "b": "https://lh3.googleusercontent.com/d/1tQx7qqjnQBflcZZjVaG3qTWIbPCNgXuw",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1NFqiqA6MO00wTWFoBYet1v_cXYuYfbxb",
      "b": "https://lh3.googleusercontent.com/d/1owWLnfUVzsnqR1N_6Nsl-I7tgQwFkjNX",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_e8fdea66-d63f-4605-a622-ad533ac42d80.jpg?v=1765415214"
   },
   "carat": 0.9,
   "caratMax": 6.4
  },
  {
   "rank": 704,
   "id": "gid://shopify/Product/7499105829048",
   "title": "0.64-6.14 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71872lb",
   "handle": "engagement-rings-71872lb",
   "priceNow": 1597.99,
   "priceWas": 4950.0,
   "pctOff": 68,
   "core": "71872",
   "inStock": true,
   "createdAt": "2024-03-20T10:11:27Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1yZbjUBmaBRWo141Xcth6G8lWtAxYxzbX",
      "b": "https://lh3.googleusercontent.com/d/1ztWOM051GxGk5iVolFayUtNKt38M7cv1",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1gn4rrf5uWXoX32XFu6Nfc36xhtw4pbWb",
      "b": "https://lh3.googleusercontent.com/d/1BKGIcDSOPnumd3sVSpafrCeItdUm07Yv",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1jlYk8_hsk-VkcImCL8rbyJ8c2r-ntuqW",
      "b": "https://lh3.googleusercontent.com/d/18o-1yPBvqchtvUBmcjC6KuLPuOSzQLzz",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_89922392-9bd2-45ff-9af2-389b6827e39c.jpg?v=1765415224"
   },
   "carat": 0.64,
   "caratMax": 6.14
  },
  {
   "rank": 705,
   "id": "gid://shopify/Product/7499105665208",
   "title": "0.60-6.10 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71878lb",
   "handle": "engagement-rings-71878lb",
   "priceNow": 1654.99,
   "priceWas": 5130.0,
   "pctOff": 68,
   "core": "71878",
   "inStock": true,
   "createdAt": "2024-03-20T10:11:17Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1Cv9258Yla4wHiodqAvWiTiyswjwLGI7x",
      "b": "https://lh3.googleusercontent.com/d/1fssixaVX9q9R7vjcHiEc7rHSYDFR3bar",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1zDf6IM0PohYQ02GkXIZsEHBqXrN9-Ibu",
      "b": "https://lh3.googleusercontent.com/d/1lnA2OtLO_bOtMWHFz4-J300tseFUZov1",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/12DKxNoq6d114muxZBsCmmI72hDfbCBFx",
      "b": "https://lh3.googleusercontent.com/d/1TpLLQo2QKE19JNG02KEn0XVHOsWmwUX1",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_96a09a16-5f11-4bf6-a93e-fa6c57432a56.jpg?v=1765415235"
   },
   "carat": 0.6,
   "caratMax": 6.1
  },
  {
   "rank": 706,
   "id": "gid://shopify/Product/7499105599672",
   "title": "0.57-6.07 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71885lb",
   "handle": "engagement-rings-71885lb",
   "priceNow": 1590.99,
   "priceWas": 4930.0,
   "pctOff": 68,
   "core": "71885",
   "inStock": true,
   "createdAt": "2024-03-20T10:11:13Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/173VyoIhR0SeKuZchB5oCopCcPT9bk7jN",
      "b": "https://lh3.googleusercontent.com/d/1QrtzXoZm71t0f72_N3_TyZI6IVIAL9PT",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1dWb8FiMS9NI_wSzedfzaSA1FRH8vGUGq",
      "b": "https://lh3.googleusercontent.com/d/1yG0y69hPKlWQQnStVT2gAbaLyWSQd0Fn",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1MGvZd4ySbbrP9Hzxt7qdxPtkf7_z3roq",
      "b": "https://lh3.googleusercontent.com/d/1aWspYnK0AB-awUekrN4_VQt7aaB4B4OU",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_b8ba0987-75b5-43cf-83ca-45c1a5cb2e46.jpg?v=1765415237"
   },
   "carat": 0.57,
   "caratMax": 6.07
  },
  {
   "rank": 707,
   "id": "gid://shopify/Product/7499105468600",
   "title": "0.60-6.10 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/engagement-rings-71910lb",
   "handle": "engagement-rings-71910lb",
   "priceNow": 1729.99,
   "priceWas": 5360.0,
   "pctOff": 68,
   "core": "71910",
   "inStock": true,
   "createdAt": "2024-03-20T10:11:07Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1_C68LW6d29OQxlLlJmvOtwwfsdfMPwrg",
      "b": "https://lh3.googleusercontent.com/d/1sCOFUX8GWE4a9jEptw6IfF1Kg0NCGJBF",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1Fx2Mm7IG-wggZ4TI16ot3kvTNlV5UmLm",
      "b": "https://lh3.googleusercontent.com/d/1jOwQTiI2caojyfsFpcXIsyUC4BjPU0it",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ac13YA27VTK2ChsasnxBFAUKsWDPzTGS",
      "b": "https://lh3.googleusercontent.com/d/1IABcZxRVSkh9hoKNhmCzHZlxpfj3BcLb",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_c8193d29-fbb0-4e81-8c8f-7eff3ecd9189.jpg?v=1711047167"
   },
   "carat": 0.6,
   "caratMax": 6.1
  },
  {
   "rank": 708,
   "id": "gid://shopify/Product/7499105337528",
   "title": "0.35 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-110347lb",
   "handle": "wedding-bands-110347lb",
   "priceNow": 845.99,
   "priceWas": 2880.0,
   "pctOff": 71,
   "core": "110347",
   "inStock": true,
   "createdAt": "2024-03-20T10:10:59Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1eb7UMRzijUR2SbS4iXr3XS786WEb4S2q",
      "b": "https://lh3.googleusercontent.com/d/1updJE2O427fMFCu3lEowO-zHc2k43jbk",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1S_uOO65b_HfEoHG8hHE2nr_5COX8DubO",
      "b": "https://lh3.googleusercontent.com/d/1EItZdA_zKKEBR2wk-3mzUpj-N0dBLQAC",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/14_oFzdfztl1rsVVF3ABqI8o2lW9k5LVO",
      "b": "https://lh3.googleusercontent.com/d/1ZPRLWtwpY6FE3p9qG4j2kcUl2kFJj_tI",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_a20a73a0-ee65-4fb9-aeb7-387e7b5b6348.jpg?v=1763698749"
   },
   "carat": 0.35
  },
  {
   "rank": 709,
   "id": "gid://shopify/Product/7499105239224",
   "title": "0.25 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-110402lb",
   "handle": "wedding-bands-110402lb",
   "priceNow": 1023.99,
   "priceWas": 3170.0,
   "pctOff": 68,
   "core": "110402",
   "inStock": true,
   "createdAt": "2024-03-20T10:10:53Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1EhJx1CASoXJlRMMqft5s3znWThs4lR8g",
      "b": "https://lh3.googleusercontent.com/d/1Rnm84l23ZSvULPG2v3n0y0k3-eW9p5ef",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1hKr3Cb9ubFKzgEr10nOhhursi0YXDu1z",
      "b": "https://lh3.googleusercontent.com/d/1kRq6lJcEMEJP2SO8hqeOI908zHf03jKg",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ms98Mk8Gee41jr6c2c-97ZV93_1_Ffie",
      "b": "https://lh3.googleusercontent.com/d/1EViDYWMj6ODYCB2unCPL0l5uDayeZ6xn",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_d4891abf-168e-4bbf-9355-6d2bba541d27.jpg?v=1711049870"
   },
   "carat": 0.25
  },
  {
   "rank": 710,
   "id": "gid://shopify/Product/7499104911544",
   "title": "0.70 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-15271lb",
   "handle": "wedding-bands-15271lb",
   "priceNow": 1470.99,
   "priceWas": 4560.0,
   "pctOff": 68,
   "core": "15271",
   "inStock": true,
   "createdAt": "2024-03-20T10:10:37Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1K_kMTgMnm7vZhptb9S400pJzBnby7wMI",
      "b": "https://lh3.googleusercontent.com/d/1BQclkPiU367tIh77JL5moax5ETsWe82u",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1A1B7k75i9nxjZSC6duVisY2EFcXhAol4",
      "b": "https://lh3.googleusercontent.com/d/1Hqt1wUBJi4ZJKCOCqNnil_ZKE8jsKwoZ",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1z1Xlnn3XZUWVrxNqchHQbj9w3uznSC-u",
      "b": "https://lh3.googleusercontent.com/d/1CW7XZlXPkxaUF6oU2ZVTCkTkv42COI2g",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/wy3.jpg?v=1763698749"
   },
   "carat": 0.7
  },
  {
   "rank": 711,
   "id": "gid://shopify/Product/7499104878776",
   "title": "2.00 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-15276lb",
   "handle": "wedding-bands-15276lb",
   "priceNow": 2213.99,
   "priceWas": 6860.0,
   "pctOff": 68,
   "core": "15276",
   "inStock": true,
   "createdAt": "2024-03-20T10:10:35Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1Lm8UdJjYmJmAbzhZPPlbp4F_Qij3qExH",
      "b": "https://lh3.googleusercontent.com/d/108ev7gX9lnfGCFvR6MvwJsDD0vLgfkkE",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1AN_8t31RWUGBpTtkccqa2gUNbWPkFIow",
      "b": "https://lh3.googleusercontent.com/d/1PFJCtdyTiqnKmZCSP_DZL7JvT51VtZrt",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Y6isV0rNGVjjo4S4yX4lbbxbBrVdryWc",
      "b": "https://lh3.googleusercontent.com/d/1Uo2rmP1OQoWAmYhSPvMgQQLN85LsYtTU",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_8cd2a38a-41b0-407b-93c2-16302ccb0b13.jpg?v=1711103457"
   },
   "carat": 2.0
  },
  {
   "rank": 712,
   "id": "gid://shopify/Product/7499104714936",
   "title": "0.80 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-15285lb",
   "handle": "wedding-bands-15285lb",
   "priceNow": 1099.99,
   "priceWas": 3410.0,
   "pctOff": 68,
   "core": "15285",
   "inStock": true,
   "createdAt": "2024-03-20T10:10:25Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/14hIo8iqJSYM3A4IznfjKKayO4vguH7hZ",
      "b": "https://lh3.googleusercontent.com/d/1zPv4dQL7vSaOERD5fIPBWcvAYk7DDJbE",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1oHCN2qmcHms9TtOr3amyg4dHcH2zPX4E",
      "b": "https://lh3.googleusercontent.com/d/1HmpU4iJwGjPpy8ctRFB4GFM2mDuAbkJE",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Wv_sUsFzhoKNINVLdS-5le7hfI7oyYxy",
      "b": "https://lh3.googleusercontent.com/d/1WC66loY0X4jtL2zgGUZZWDhm6uI8zxMx",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_9c077f8d-668c-4343-aacc-ad2a6be7ebdc.jpg?v=1763698749"
   },
   "carat": 0.8
  },
  {
   "rank": 713,
   "id": "gid://shopify/Product/7499104321720",
   "title": "0.90-6.40 CT Princess Cut Lab Grown Diamonds - Three Stone Rings",
   "url": "/products/three-stone-rings-15305lb",
   "handle": "three-stone-rings-15305lb",
   "priceNow": 1512.99,
   "priceWas": 4690.0,
   "pctOff": 68,
   "core": "15305",
   "inStock": true,
   "createdAt": "2024-03-20T10:10:06Z",
   "shape": "princess",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1qKZAPfIenqvSNeFG1SgW4XF2sNjENSVL",
      "b": "https://lh3.googleusercontent.com/d/12R1d7CPRuROaaBxyd53Nxzz9lHittwid",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1PojBuFaH1S9i0YJnpztsZsVrEq-wZPuQ",
      "b": "https://lh3.googleusercontent.com/d/1OI9saSc_IVHm5trHiO6xPo7gGk-0qTyR",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1lSQRxEClzhcIiD2HwyzdKCL2xgwmhfV5",
      "b": "https://lh3.googleusercontent.com/d/17CCPgIQ09Z24ubxFnv40OP5VQRMvXviR",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_2ed76c49-4631-4ceb-89b0-039d9818ee6a.jpg?v=1763766479"
   },
   "carat": 0.9,
   "caratMax": 6.4
  },
  {
   "rank": 714,
   "id": "gid://shopify/Product/7499104157880",
   "title": "0.95-6.45 CT Round Cut Lab Grown Diamonds - Three Stone Rings",
   "url": "/products/three-stone-rings-15318lb",
   "handle": "three-stone-rings-15318lb",
   "priceNow": 1560.99,
   "priceWas": 4840.0,
   "pctOff": 68,
   "core": "15318",
   "inStock": true,
   "createdAt": "2024-03-20T10:09:55Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1Xiu3M9K8ExGULjcYiB3u1TQvK80txjkz",
      "b": "https://lh3.googleusercontent.com/d/1chze8TTrKOB9sRhJ17EX7fzSUjRciPdO",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/18oaWsvsLNfEqnNOEKLfR-OeCFdp4iAwp",
      "b": "https://lh3.googleusercontent.com/d/1yc8pwS53LlsUiCIqMNVNGAZtksssp1PV",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1a5frUGEzIWYYqLyFCF-ccT0KDUIN7aJs",
      "b": "https://lh3.googleusercontent.com/d/1emolHMnVjkJqF2oOLYH1_cGrZe5UWSrU",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_1efc2a3f-124b-483b-9ebc-384e22866960.jpg?v=1763766480"
   },
   "carat": 0.95,
   "caratMax": 6.45
  },
  {
   "rank": 715,
   "id": "gid://shopify/Product/7499103862968",
   "title": "1.20-6.70 CT Round Cut Lab Grown Diamonds - Three Stone Rings",
   "url": "/products/three-stone-rings-15325lb",
   "handle": "three-stone-rings-15325lb",
   "priceNow": 1891.99,
   "priceWas": 5870.0,
   "pctOff": 68,
   "core": "15325",
   "inStock": true,
   "createdAt": "2024-03-20T10:09:43Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/14ZiDOdM8YhQ3q8zkADKbWcMWaNv014D6",
      "b": "https://lh3.googleusercontent.com/d/1bYXVE7XkYgrqDcRY8h-4mCTQEMupIzlq",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1AYadZKy9yNJKWdrOFprEIYxAmaIZauof",
      "b": "https://lh3.googleusercontent.com/d/1-jpFtV_JN20t2B0TpjMuLADhtdUPmCOL",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1RWMmVCMs0SgEKlZ4mGX-zJCsbKjQDTwl",
      "b": "https://lh3.googleusercontent.com/d/1oypmm6FjO539mpWe4zo9uh7E54CuKYNb",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_04a0ea08-cdf4-4507-a232-292d647b5c2c.jpg?v=1763766473"
   },
   "carat": 1.2,
   "caratMax": 6.7
  },
  {
   "rank": 716,
   "id": "gid://shopify/Product/7499103600824",
   "title": "1.15-6.65 CT Princess & Round Cut Lab Grown Diamonds - Three Stone Rings",
   "url": "/products/three-stone-rings-15602lb",
   "handle": "three-stone-rings-15602lb",
   "priceNow": 1490.99,
   "priceWas": 4620.0,
   "pctOff": 68,
   "core": "15602",
   "inStock": true,
   "createdAt": "2024-03-20T10:09:29Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1DLpguLPm3SqsQ7fSSWadCbypofAVSXJO",
      "b": "https://lh3.googleusercontent.com/d/15NtSY86hTT9dZ22V4x0Zhwhe9AawqRMy",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/14V0sLL2P02xO7uwKq-4CMDOHZ-7I9tsH",
      "b": "https://lh3.googleusercontent.com/d/1qMW5AAR_xXkYpOKUuj2lSZ0Y_QzpPHx2",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1wI177PXEXcITNrQTfuMxnn6QZlRgzD0N",
      "b": "https://lh3.googleusercontent.com/d/1U1b-JqvSIyqGKWY2SRaDw0oDRt5b791-",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_b72c6fd5-9ea3-4430-bdc4-828e2e589dbd.jpg?v=1763766480"
   },
   "carat": 1.15,
   "caratMax": 6.65
  },
  {
   "rank": 717,
   "id": "gid://shopify/Product/7499103404216",
   "title": "1.35-6.85 CT Round Cut Lab Grown Diamonds - Three Stone Rings",
   "url": "/products/three-stone-rings-15697lb",
   "handle": "three-stone-rings-15697lb",
   "priceNow": 1846.99,
   "priceWas": 5730.0,
   "pctOff": 68,
   "core": "15697",
   "inStock": true,
   "createdAt": "2024-03-20T10:09:17Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1L15cml7-qto6VNkIysP4oq13GqzwFD-R",
      "b": "https://lh3.googleusercontent.com/d/1wt4UNfeCFBEMZrp0qkhGtGzg6otaH-y7",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1F6F1OSamzsaGJxk2FPsmoMq8q877gy5n",
      "b": "https://lh3.googleusercontent.com/d/1nNvG64S0bCYIBC06x26atJZG9P99ZHz2",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1n0TlOj0lsfcMiiAv-LCCHJUcj9ylETZo",
      "b": "https://lh3.googleusercontent.com/d/1ZLRclpb9WZGL6KCKYfE2nySTBBRZ5XGd",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_501c5d3b-d167-4c44-a9d9-b21bfd984008.jpg?v=1763766473"
   },
   "carat": 1.35,
   "caratMax": 6.85
  },
  {
   "rank": 718,
   "id": "gid://shopify/Product/7499103273144",
   "title": "0.65 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71408lb",
   "handle": "wedding-bands-71408lb",
   "priceNow": 1364.99,
   "priceWas": 4230.0,
   "pctOff": 68,
   "core": "71408",
   "inStock": true,
   "createdAt": "2024-03-20T10:09:13Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1NQrWUgSOExuYxXo9L6eiFQiFLd3zLq4u",
      "b": "https://lh3.googleusercontent.com/d/17amA7U0NEw2ZmD19LQhDS9Et7cZ1yI0f",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/18IHX1ixRehCzu87dbWI2n7zGvJrvBpEw",
      "b": "https://lh3.googleusercontent.com/d/18CPIJ0n9b4ntO6VxVessUed8tKC3Xh26",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1By3AS4gnXRZcZ80JquCC1qW_eidZp2wN",
      "b": "https://lh3.googleusercontent.com/d/1oguaW0mGGFfBz3uUtMYgI7UvgD4WQavJ",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_fde67aa4-2abf-427c-bd50-8f6ca2fa87f4.jpg?v=1711486956"
   },
   "carat": 0.65
  },
  {
   "rank": 719,
   "id": "gid://shopify/Product/7499103174840",
   "title": "0.35 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-110343lb",
   "handle": "wedding-bands-110343lb",
   "priceNow": 1165.99,
   "priceWas": 3610.0,
   "pctOff": 68,
   "core": "110343",
   "inStock": true,
   "createdAt": "2024-03-20T10:09:06Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1dTYJbeitImkUm7K0dzdkK7S9AxD49LqW",
      "b": "https://lh3.googleusercontent.com/d/11RYChQPaI5Iba2u2JN0TvgUtxQuShVS2",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1x9pNF720XIgUiH60Mah6RtEvEUX_gkU7",
      "b": "https://lh3.googleusercontent.com/d/1jwPPfTUkdN_0SQUjhoFGznXvTXRigdf7",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1tFYpsEwKxVvaKDTxDDok9jBgwlpwi0pf",
      "b": "https://lh3.googleusercontent.com/d/1zkqN-aOyxxShViYy2FBknNcPc96TKFrn",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_be66db2d-a8ef-4b82-8350-fb8767cb8083.jpg?v=1763698750"
   },
   "carat": 0.35
  },
  {
   "rank": 720,
   "id": "gid://shopify/Product/7499103076536",
   "title": "0.30 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-110345lb",
   "handle": "wedding-bands-110345lb",
   "priceNow": 1218.99,
   "priceWas": 3780.0,
   "pctOff": 68,
   "core": "110345",
   "inStock": true,
   "createdAt": "2024-03-20T10:09:03Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1njU4N00HzCMx9qnKjSGrRg_cNwU8ToEU",
      "b": "https://lh3.googleusercontent.com/d/1ex5r-_89GLhQtX8SLhXaTEfvtbhUQ-0-",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1UBXxsjqdnPqhGHKpvrD1tPRLujgDQC5v",
      "b": "https://lh3.googleusercontent.com/d/1EfjEa-4vT90Cy43IogTUlVUtWviohkiW",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1l-yWsj3YJjd2bYUBHztk7bskiRMNTZaq",
      "b": "https://lh3.googleusercontent.com/d/1DuqbxE1OMpmekCon4oYJPK3w1nzAOatz",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_3af882a9-27ab-49f5-b23f-25c71804c074.jpg?v=1711487276"
   },
   "carat": 0.3
  },
  {
   "rank": 721,
   "id": "gid://shopify/Product/7499102847160",
   "title": "0.60 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-110351lb",
   "handle": "wedding-bands-110351lb",
   "priceNow": 1348.99,
   "priceWas": 4180.0,
   "pctOff": 68,
   "core": "110351",
   "inStock": true,
   "createdAt": "2024-03-20T10:08:51Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/18SH0iWCELAEYZBqmMKxJC3j-5Rbi2omR",
      "b": "https://lh3.googleusercontent.com/d/15rwV1g4pnTKcW-6drLDVStZj8GH1SAyK",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1BewT70WcGrQCfT4ixPPsaTXHNUAJ9Nox",
      "b": "https://lh3.googleusercontent.com/d/1AmWBZhF1ajWdSpGSZZQGcRVZAHd34MUn",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1f4yl1OF1P9HQo1gpet8BeXqs90Xs_OoW",
      "b": "https://lh3.googleusercontent.com/d/1GBl7OhTUfbOCQmjtruiCxNZkMGY7sx8E",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_096bcfe1-939d-4ee6-8f5c-cf76ce253d51.jpg?v=1711487633"
   },
   "carat": 0.6
  },
  {
   "rank": 722,
   "id": "gid://shopify/Product/7499102748856",
   "title": "2.20 CT Emerald & Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-15690lb",
   "handle": "wedding-bands-15690lb",
   "priceNow": 2353.99,
   "priceWas": 7300.0,
   "pctOff": 68,
   "core": "15690",
   "inStock": true,
   "createdAt": "2024-03-20T10:08:46Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1ZN1_r_YDWa7kBRVNTpmL8pimEueHoo3y",
      "b": "https://lh3.googleusercontent.com/d/1lXADXB4EwuMHWoYUcgPck3isJ8PsVL0U",
      "angles": [
       1,
       2
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1cPvk77BDj8D-zw2Vlk3FrxcLYhS34w6w",
      "b": "https://lh3.googleusercontent.com/d/18ItnKwbh90AflgOQExIIV8l8W4T20Ati",
      "angles": [
       1,
       2
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/12SD2Wtwr84bqN1jyNu_Jlhm29cO2cCHV",
      "b": "https://lh3.googleusercontent.com/d/1YdbWxoqQL1i9pk3vAKINfsp1BYIWTU9W",
      "angles": [
       1,
       2
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/wy3_38fc72e4-5cba-495d-a24d-2c1ed2cbf1a2.jpg?v=1763698750"
   },
   "carat": 2.2
  },
  {
   "rank": 723,
   "id": "gid://shopify/Product/7488958693560",
   "title": "2.80 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-15716lb",
   "handle": "wedding-bands-15716lb",
   "priceNow": 1758.99,
   "priceWas": 5450.0,
   "pctOff": 68,
   "core": "15716",
   "inStock": true,
   "createdAt": "2024-03-16T00:46:50Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1Pp2LmgonpI88I6fIPwz3kJtcCAU2lrzq",
      "b": "https://lh3.googleusercontent.com/d/1A96iivmQZLjNOC2AXqLOk1VpC1mNEZl9",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1EpEEr_4yJ880Qwr8lbF67PKzzfQnoLku",
      "b": "https://lh3.googleusercontent.com/d/1XOVXgRfqS5NatVhttr6kZQXIaDymF4mr",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1vk0gKfudoLAg-WYFyEgd7-RW-MXEgo5r",
      "b": "https://lh3.googleusercontent.com/d/1jxFBmyCcqSxDN_EHyDY4ric8EP0lhYHp",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_8303c860-7326-4bfa-9019-9006921f99ba.jpg?v=1710550295"
   },
   "carat": 2.8
  },
  {
   "rank": 724,
   "id": "gid://shopify/Product/7488958660792",
   "title": "0.45 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-16002lb",
   "handle": "wedding-bands-16002lb",
   "priceNow": 972.99,
   "priceWas": 3310.0,
   "pctOff": 71,
   "core": "16002",
   "inStock": true,
   "createdAt": "2024-03-16T00:46:45Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1jTPWATNQQu3x5012zWVeH4eI4a9E0vE8",
      "b": "https://lh3.googleusercontent.com/d/15rdt-EM1V4F04CgUkg8bgupwY0T1bgVu",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1zex2CV22DpHu4mq_zpmU7CjaDfrEiq7o",
      "b": "https://lh3.googleusercontent.com/d/1xbeo7wM9x1djTMdckKneK449qpGOjB54",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1j_3ETgcfBn_OaX5wcsJixdXR5YpYdOaB",
      "b": "https://lh3.googleusercontent.com/d/1F9gVhaFXvxQb_p4y4_diTdEPylSom7Np",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_bcafe2a4-d10c-484c-9d92-f63b899deddc.jpg?v=1710550492"
   },
   "carat": 0.45
  },
  {
   "rank": 725,
   "id": "gid://shopify/Product/7488958628024",
   "title": "1.10 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-16031lb",
   "handle": "wedding-bands-16031lb",
   "priceNow": 1355.99,
   "priceWas": 4200.0,
   "pctOff": 68,
   "core": "16031",
   "inStock": true,
   "createdAt": "2024-03-16T00:46:35Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1iZ0PoOvnXzCt-_QPYmnjpvxkksJJm3m9",
      "b": "https://lh3.googleusercontent.com/d/18tQaN1u9laawWB3isYq5lp9VIo1oy0Rg",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/18ee9Qpy2YfXKU43qC4B9ORWJ3_w6FXmw",
      "b": "https://lh3.googleusercontent.com/d/1r_SjyM3tNsO4ID42LeY6fOBcgzQbADiJ",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1I0FDOU1QEvkX9WARLJvahly782pIEAxi",
      "b": "https://lh3.googleusercontent.com/d/1QRTubmtYTV3P5xC8r1DWpnHfooed4nee",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_a62aad8c-bdba-448d-90f7-ab87a53f45cc.jpg?v=1763698823"
   },
   "carat": 1.1
  },
  {
   "rank": 726,
   "id": "gid://shopify/Product/7488958562488",
   "title": "0.25 CT Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71199lb",
   "handle": "wedding-bands-71199lb",
   "priceNow": 1838.99,
   "priceWas": 5700.0,
   "pctOff": 68,
   "core": "71199",
   "inStock": true,
   "createdAt": "2024-03-16T00:46:28Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1Y-2vD4wTYau7hnu3LUYZTt7nUU0PZRuU",
      "b": "https://lh3.googleusercontent.com/d/1NPUw57Gg8QiFkSN_ezwtoTmVYIBXaqkn",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1u_e11Xw_BDN9nFrDdYfbitTT77aow3zs",
      "b": "https://lh3.googleusercontent.com/d/100G7NuriJyKVO0w9hBgYVlkJCirRbs7Z",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1A8yRe4_CrNtDpWoDsx31k4qvMbLVNRjl",
      "b": "https://lh3.googleusercontent.com/d/1pHfDTwWMf-QMVY5tU09tQpxMCxglq-6l",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_9ed30780-c03b-46ab-9f87-c8eb60190488.jpg?v=1710551060"
   },
   "carat": 0.25
  },
  {
   "rank": 727,
   "id": "gid://shopify/Product/7488958529720",
   "title": "1.00 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71208lb",
   "handle": "wedding-bands-71208lb",
   "priceNow": 1620.99,
   "priceWas": 5030.0,
   "pctOff": 68,
   "core": "71208",
   "inStock": true,
   "createdAt": "2024-03-16T00:46:23Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1Za1sRY9NmL_7EfUc9MAFVmMnp-v-aWkY",
      "b": "https://lh3.googleusercontent.com/d/194XeTXX4BbiL97MPfTypVnus5mybfeSn",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1trrWkmdpbTk1QqI7mn7wowcLx15iE0lR",
      "b": "https://lh3.googleusercontent.com/d/1CLJYyrwCd6KWB8yl3sWnMKQiD7w389ne",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1PlJRLvAbD89A6vi9kzjwMi3otkw2crWU",
      "b": "https://lh3.googleusercontent.com/d/1NWIlN6d2TQWukPesPXzIzq_xsrJJrKOc",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_f6d5be43-5713-4313-af0f-c56aec89f148.jpg?v=1710551676"
   },
   "carat": 1.0
  },
  {
   "rank": 728,
   "id": "gid://shopify/Product/7488958496952",
   "title": "0.60 CT Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71220lb",
   "handle": "wedding-bands-71220lb",
   "priceNow": 1679.99,
   "priceWas": 5210.0,
   "pctOff": 68,
   "core": "71220",
   "inStock": true,
   "createdAt": "2024-03-16T00:46:20Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1DOdHYcUBBtPjCp7XAS8MubEyoO8SHlHT",
      "b": "https://lh3.googleusercontent.com/d/1VGeH_5A1piVAdfueAY1C-tG3cTMwnkzu",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1XqG7ivJsrrveBDl7X38CFOPEFLLaFq69",
      "b": "https://lh3.googleusercontent.com/d/1ba7qEukROD5wr0tRrhPVdOtSvEtBimVl",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1DBDU90SBDwElc8eaLpa379-Iu5wjSFOY",
      "b": "https://lh3.googleusercontent.com/d/1kcgnMX71tK6YDakIPXvsy0qAo_WfHIII",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_b4b9e6ca-7596-42b3-955b-dc2204712ab1.jpg?v=1710552000"
   },
   "carat": 0.6
  },
  {
   "rank": 729,
   "id": "gid://shopify/Product/7488958431416",
   "title": "0.45 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71268lb",
   "handle": "wedding-bands-71268lb",
   "priceNow": 1286.99,
   "priceWas": 3990.0,
   "pctOff": 68,
   "core": "71268",
   "inStock": true,
   "createdAt": "2024-03-16T00:46:12Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1eNhfafIV_jjzctit3-M5bR8WK9Vs5qAi",
      "b": "https://lh3.googleusercontent.com/d/1vvTZXFYHMKH9PD12m3QpQSBB1mecb2S1",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1_hxH8Nl62Nh-eCr4wev5I0lZ51xqKTfC",
      "b": "https://lh3.googleusercontent.com/d/118t1QqH9a2SoB6Z-YxZMYQHgHSMVW-UE",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Nkp8lu2kdaFl2dQBJ9lmEiSrt7BFd8_A",
      "b": "https://lh3.googleusercontent.com/d/1tylPNWs2kyL_fQQWAp1gs7mH4mgxL8nc",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_6bda5cbf-73a3-4094-8f08-0a352ad15126.jpg?v=1710552195"
   },
   "carat": 0.45
  },
  {
   "rank": 730,
   "id": "gid://shopify/Product/7488958365880",
   "title": "0.50 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71420lb",
   "handle": "wedding-bands-71420lb",
   "priceNow": 1851.99,
   "priceWas": 5740.0,
   "pctOff": 68,
   "core": "71420",
   "inStock": true,
   "createdAt": "2024-03-16T00:46:03Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1zhRXKGkqEYNCe9HAc5Yc_eLHDerk_D_2",
      "b": "https://lh3.googleusercontent.com/d/1TvVmM1qKRq41qAWVgK2LwJi5_hTrmX9U",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/10AdGH73N7B1q2-lNe4NTsM1XCXLUY_xR",
      "b": "https://lh3.googleusercontent.com/d/1hpfgPV6yqkQ8rPO4m_nrOyO2hCwgliOv",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1_bIezPXhcXM76C1T6PA9E5314wah4E-F",
      "b": "https://lh3.googleusercontent.com/d/1FzD5pL67uEBKIcBtoFkhtgGELNKgrg-p",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_8b4fcad7-d7e2-432d-af80-2452613201a4.jpg?v=1710552559"
   },
   "carat": 0.5
  },
  {
   "rank": 731,
   "id": "gid://shopify/Product/7488958333112",
   "title": "0.45 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71432lb",
   "handle": "wedding-bands-71432lb",
   "priceNow": 1610.99,
   "priceWas": 4990.0,
   "pctOff": 68,
   "core": "71432",
   "inStock": true,
   "createdAt": "2024-03-16T00:45:54Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1_g-HxSMq-t8bbl6b_ng1aZa2LwuHU27x",
      "b": "https://lh3.googleusercontent.com/d/1EnR5LGmaWhxNFgQ_5NRvPpwgKepptqhS",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1hRR6563ISXkWaT5XaXV3tzitJugYWkPE",
      "b": "https://lh3.googleusercontent.com/d/1hmAd-Cl1_Jyl2WST_yH8kLvJE2QEkRNj",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1CJLYFE7rJHt7TJkBS9WivJFav6o53AEQ",
      "b": "https://lh3.googleusercontent.com/d/1NKZTzA85G0yodLlC-k072xqAfAq6Tmsd",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_13a6bb86-034e-4b63-829b-5f5dcf9d58ed.jpg?v=1710552995"
   },
   "carat": 0.45
  },
  {
   "rank": 732,
   "id": "gid://shopify/Product/7488958300344",
   "title": "0.75 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71444lb",
   "handle": "wedding-bands-71444lb",
   "priceNow": 1680.99,
   "priceWas": 5210.0,
   "pctOff": 68,
   "core": "71444",
   "inStock": true,
   "createdAt": "2024-03-16T00:45:52Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1LXJTIgSD6XrTFV2eMQnoT4IYWmI8AX8m",
      "b": "https://lh3.googleusercontent.com/d/1W7piap8fYBF3kEuxY6nqDFCFIEfrKvvg",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1DvBNUK4w-WUEF7XubtKYhY4w_62d5h0P",
      "b": "https://lh3.googleusercontent.com/d/1x2fmdIjZGUWlgilmwqsWLhwtyb2Wd1v3",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1aKqejLmEazv7n5ZlvtE_C1jA1BnR9jUU",
      "b": "https://lh3.googleusercontent.com/d/1iDJkEf9kAW75YI_6r2nQf5EXfYlt9jI4",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_3ce69703-51c5-46ac-b18c-2b218941e86b.jpg?v=1710553194"
   },
   "carat": 0.75
  },
  {
   "rank": 733,
   "id": "gid://shopify/Product/7488958267576",
   "title": "0.40 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71468lb",
   "handle": "wedding-bands-71468lb",
   "priceNow": 1800.99,
   "priceWas": 5580.0,
   "pctOff": 68,
   "core": "71468",
   "inStock": true,
   "createdAt": "2024-03-16T00:45:45Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1sw1ye3pUfCe-0blEykbYvVwsIhgcCD8y",
      "b": "https://lh3.googleusercontent.com/d/1KUYRHS74mt7e5BK6pQiVBqws9h1He9KJ",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/12oO67DklOvEYRFIMTK6ktk7mhtKJyDu4",
      "b": "https://lh3.googleusercontent.com/d/1WJ02tpRSslb_h0T5BbCmLQSAvS0UOvAj",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/15bUFObzsika6TPmjMfbBt9IxYT-LKp_-",
      "b": "https://lh3.googleusercontent.com/d/15dFwBWK-vujNoDJhnfNSAWLGYlcODQpm",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_9a38773c-6a4b-48b8-a9e3-f29b2c3f8056.jpg?v=1710797911"
   },
   "carat": 0.4
  },
  {
   "rank": 734,
   "id": "gid://shopify/Product/7488958234808",
   "title": "0.90 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71516lb",
   "handle": "wedding-bands-71516lb",
   "priceNow": 1611.99,
   "priceWas": 5000.0,
   "pctOff": 68,
   "core": "71516",
   "inStock": true,
   "createdAt": "2024-03-16T00:45:36Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1WGIGAEnPUMajyeoe0nTImqqNLe_MPVFP",
      "b": "https://lh3.googleusercontent.com/d/1P5J-KUx-hhqbvFvwKbLGABXi3Bws8xUY",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/11srHjzRF6hYTRg0Q76nokDlD7lFUTUx7",
      "b": "https://lh3.googleusercontent.com/d/1HE0PsqnKJS1aIcUzwYMg0JC21WD6Nr3Z",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1RMuiTUDnNa5KWQf9VzUsnqjwS2XedHKo",
      "b": "https://lh3.googleusercontent.com/d/14TpEJ7YMgsnxalky0bJ71NwRI_-1RfeO",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_82258441-3661-4b92-813a-537143fc5ca3.jpg?v=1710798864"
   },
   "carat": 0.9
  },
  {
   "rank": 735,
   "id": "gid://shopify/Product/7488958202040",
   "title": "0.20 CT Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71540lb",
   "handle": "wedding-bands-71540lb",
   "priceNow": 1369.99,
   "priceWas": 4250.0,
   "pctOff": 68,
   "core": "71540",
   "inStock": true,
   "createdAt": "2024-03-16T00:45:28Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1wLUHyJwt5ex0S7F8Ezs3hwyyDcaEBIbS",
      "b": "https://lh3.googleusercontent.com/d/1Kx4AIl-gh6QUHk6XgR-yRTluelHAa_dH",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1Z_-nSHhyj76SOLHf59oLUjj1LcyGDSPk",
      "b": "https://lh3.googleusercontent.com/d/1AKCy-RZI6jmSS7TT0aGO--K_pGaosl9Y",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/12ijG-iQnf1DNSMEJbFSZlIFCbmWFO-no",
      "b": "https://lh3.googleusercontent.com/d/1-FY6evEprZxH9VXnK6NYbl6pqGyet9Mv",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_d4a1f744-c880-45bc-b3ab-0d0572af0828.jpg?v=1710802365"
   },
   "carat": 0.2
  },
  {
   "rank": 736,
   "id": "gid://shopify/Product/7488958169272",
   "title": "0.50 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71552lb",
   "handle": "wedding-bands-71552lb",
   "priceNow": 1224.99,
   "priceWas": 3800.0,
   "pctOff": 68,
   "core": "71552",
   "inStock": true,
   "createdAt": "2024-03-16T00:45:23Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1d7S-onGSyg4-YR_Q7lJOYoqJorFiytgk",
      "b": "https://lh3.googleusercontent.com/d/1V6agvPZWke5JxvjMgU7TfhKxSVHfzY-c",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1uidCK6SJDYmft9xG5njviCg5I3k5Hr_M",
      "b": "https://lh3.googleusercontent.com/d/1k2B4yTzEGo4D5A660AAZETR_muO_SWpV",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Jc4d8fZ2NJAEzaRm1l5u5Uveu9GIIdX4",
      "b": "https://lh3.googleusercontent.com/d/1mK4wJhZLlNsHbKvZqJheDoTf278KfKRG",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_1c38074b-7a93-4bd3-bff0-e1fff6c41969.jpg?v=1710802601"
   },
   "carat": 0.5
  },
  {
   "rank": 737,
   "id": "gid://shopify/Product/7488958103736",
   "title": "0.25 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71663lb",
   "handle": "wedding-bands-71663lb",
   "priceNow": 1318.99,
   "priceWas": 4090.0,
   "pctOff": 68,
   "core": "71663",
   "inStock": true,
   "createdAt": "2024-03-16T00:45:16Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1UqVETfblU-HzogqAkO1FNmHFqcyRNRlc",
      "b": "https://lh3.googleusercontent.com/d/1zug5Cf1lKJ1hQ2wX0O5m1jPq5ua7asB6",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1MrmP9YiCik4NlKVP5C20eprCfjDTIIZM",
      "b": "https://lh3.googleusercontent.com/d/1tAiwsOmbpJAGE8kppTQZlxtXSL_VNuCd",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1cs48zE_R_cQnlP5uxOhKv0wXH6PbKRlY",
      "b": "https://lh3.googleusercontent.com/d/1GtGgDV1jn6yyfOLps79f2zLBCJ3l0SCd",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_e0081318-4fe8-46bc-9217-92ee4140ad1b.jpg?v=1710804090"
   },
   "carat": 0.25
  },
  {
   "rank": 738,
   "id": "gid://shopify/Product/7488958070968",
   "title": "2.00 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71768lb",
   "handle": "wedding-bands-71768lb",
   "priceNow": 3138.99,
   "priceWas": 9730.0,
   "pctOff": 68,
   "core": "71768",
   "inStock": true,
   "createdAt": "2024-03-16T00:45:08Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1qDtRoQspMYreBhhSs1VHGoxIlUbdqEC6",
      "b": "https://lh3.googleusercontent.com/d/1nqvsXSsHyt5zZlLYaBWc6IbdJVyNQr4c",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1s8kf40aeXfhQ9NJEpLM-jnkjaGWwjpFw",
      "b": "https://lh3.googleusercontent.com/d/1hBLCoSR5w_4FNcT4V-mq8eNhqmhuHD3x",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1vIwoS947h5450woKo5-tr4jCNT0hYD32",
      "b": "https://lh3.googleusercontent.com/d/14kkNJWya3VOvc-BdrgdBDxs3vTF4j6BW",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_d86745d1-b14d-419c-bae3-6674bfed10ba.jpg?v=1710883082"
   },
   "carat": 2.0
  },
  {
   "rank": 739,
   "id": "gid://shopify/Product/7488958038200",
   "title": "1.10 CT Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71793lb",
   "handle": "wedding-bands-71793lb",
   "priceNow": 1346.99,
   "priceWas": 4180.0,
   "pctOff": 68,
   "core": "71793",
   "inStock": true,
   "createdAt": "2024-03-16T00:45:05Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1mTRRQZLH2UK3fks48NEAb3DKJmMhjXh5",
      "b": "https://lh3.googleusercontent.com/d/18XhYDI-HYxpdefEOoBu3qdoVIeT2AksF",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/15YSSjYFq-8oBwLVABxBC6q5Qq-xZBKRl",
      "b": "https://lh3.googleusercontent.com/d/1NinBleTc-4iIZfnc1WtuAK-R0IhCwqE9",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ovvoyHUUZ5SGgTgngiW84EDy-oETiy-1",
      "b": "https://lh3.googleusercontent.com/d/1ScU5N8c-ghv2j40Phd48kzLzsWcHoTnT",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_3bf2c597-e944-42bd-ac41-84265781b603.jpg?v=1710883057"
   },
   "carat": 1.1
  },
  {
   "rank": 740,
   "id": "gid://shopify/Product/7488958005432",
   "title": "0.45 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-110335lb",
   "handle": "wedding-bands-110335lb",
   "priceNow": 863.99,
   "priceWas": 2940.0,
   "pctOff": 71,
   "core": "110335",
   "inStock": true,
   "createdAt": "2024-03-16T00:44:54Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1KPu07BAMH0Bay5BU7EvgaI01m9udOY2T",
      "b": "https://lh3.googleusercontent.com/d/1swiqeHJlxc44NZWS85ntowszoKXK8D1V",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1gIzwFZptHF0VISm6P1imAQnoWLZ1Uw44",
      "b": "https://lh3.googleusercontent.com/d/1JMyvtTn3AY5_p27incbyUh5ZtiPzd3LY",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1cmiRs0eCNowv6dE3wRpf0EvAuGRFFjQb",
      "b": "https://lh3.googleusercontent.com/d/1VAvYZrUAVwCvMO6VaQzkEsns7VqQA5AY",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_a5ee2158-e9e1-4a16-b7d1-eddd40e7b65c.jpg?v=1710883342"
   },
   "carat": 0.45
  },
  {
   "rank": 741,
   "id": "gid://shopify/Product/7488957972664",
   "title": "0.85 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71829lb",
   "handle": "wedding-bands-71829lb",
   "priceNow": 1207.99,
   "priceWas": 3740.0,
   "pctOff": 68,
   "core": "71829",
   "inStock": true,
   "createdAt": "2024-03-16T00:44:43Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1ROAD473x2USdyVvDreX8B71E3CK3PItY",
      "b": "https://lh3.googleusercontent.com/d/1VuLbOhC3_xAj4jE6cxH2EsxLDLe7LicV",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1Yc8H75-nW3l7lwEyyYztlmz2fWdZ4ZVU",
      "b": "https://lh3.googleusercontent.com/d/1BP35-dXobUHGd7EKX-CyTioiUnrmqw9I",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1GJIXANMPweB52-CUBCS_qP738jeLVI7B",
      "b": "https://lh3.googleusercontent.com/d/14l0A3pxFZPGgHqpwST6ktM-BY2Ki4ets",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_69149fb2-f7ba-4a53-806a-d4d582046c9a.jpg?v=1763698873"
   },
   "carat": 0.85
  },
  {
   "rank": 742,
   "id": "gid://shopify/Product/7488957874360",
   "title": "0.20 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-110404lb",
   "handle": "wedding-bands-110404lb",
   "priceNow": 1031.99,
   "priceWas": 3200.0,
   "pctOff": 68,
   "core": "110404",
   "inStock": true,
   "createdAt": "2024-03-16T00:44:30Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1sUAcuhXj2PbL8OB5IArCM41X1tYYUV3D",
      "b": "https://lh3.googleusercontent.com/d/18TvvzO0MNzH7_KiliSOjbSL5fQ2PnMMz",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1KIDRaC0aZKvjx26ElPL20TSlElmX_l1a",
      "b": "https://lh3.googleusercontent.com/d/1wESg5Hbi9uBwk7H-UmFHog-KePU5VSP5",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1FoeBHKn1IpqOwQUl2xbFw3taQxjUS_o5",
      "b": "https://lh3.googleusercontent.com/d/1-ncA3hKCMpogtq8UVL4QKtejte9TEu9a",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_14db5232-d30c-4d83-b662-dfbb48b888ff.jpg?v=1710885281"
   },
   "carat": 0.2
  },
  {
   "rank": 743,
   "id": "gid://shopify/Product/7488957743288",
   "title": "0.25 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71679lb",
   "handle": "wedding-bands-71679lb",
   "priceNow": 1567.99,
   "priceWas": 4860.0,
   "pctOff": 68,
   "core": "71679",
   "inStock": true,
   "createdAt": "2024-03-16T00:44:08Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1WsZs-lrKfMLfncSn14VlK9dis4Qfdrz3",
      "b": "https://lh3.googleusercontent.com/d/1IOWgHXVYJDTlOQUgOzXj-rbV84d0dUEF",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1gKPgwUQAPMS1RiEIKPxiEXmJkp2nXa-a",
      "b": "https://lh3.googleusercontent.com/d/15wQ8VNVYgbhe1aBehNR1cORnUu4KpEXi",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1KDvh4S1BzwSggb9SZ3Oh-KiLa952U8ud",
      "b": "https://lh3.googleusercontent.com/d/1L69NOzy89nFpvG8GP4p2KF_jdAuFlRaI",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_99970cf7-02d0-44d2-b307-3b2ce75dbe03.jpg?v=1710885926"
   },
   "carat": 0.25
  },
  {
   "rank": 744,
   "id": "gid://shopify/Product/7485706567864",
   "title": "1.00 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-15592lb",
   "handle": "wedding-bands-15592lb",
   "priceNow": 1443.99,
   "priceWas": 4480.0,
   "pctOff": 68,
   "core": "15592",
   "inStock": true,
   "createdAt": "2024-03-13T16:27:00Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1OusuNfsXNTlDg3EiJQo-VfX1MpU2Vn9D",
      "b": "https://lh3.googleusercontent.com/d/1RUpKHn9gv8mkzPjD4fAbbRcfbF4rZ8Hn",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1_-T1gRy1hOKBtSM8DtXxDhHi4mg4yuN-",
      "b": "https://lh3.googleusercontent.com/d/1FkZCNDO5vzLSWigY1pr_ned-vxXAo7t6",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1N8J9q3DtBEKYi82fqMjAzUKJnezg5oNy",
      "b": "https://lh3.googleusercontent.com/d/1KB9vhnKwCiqkV9NV-InmsFcUvR9cDD5a",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/SS8_6_44adcb2c-73ec-40c9-97f6-19457d8ca5c2.png?v=1779848226"
   },
   "carat": 1.0
  },
  {
   "rank": 745,
   "id": "gid://shopify/Product/7485706404024",
   "title": "0.15 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-110406lb",
   "handle": "wedding-bands-110406lb",
   "priceNow": 1010.99,
   "priceWas": 3130.0,
   "pctOff": 68,
   "core": "110406",
   "inStock": true,
   "createdAt": "2024-03-13T16:26:51Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1bNDkO3bn7s1oSv9Vo4CRJJLxU0McrMRT",
      "b": "https://lh3.googleusercontent.com/d/1OOJNmkZYEX5ufiBio7uTvvbUeJawHnqz",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/18x8qR_akqhiqETPYPC91BByxkvuRRlmP",
      "b": "https://lh3.googleusercontent.com/d/1QuO2PYFyz4py-pfLkQpqIP9UIrDlLS2t",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1XPJs5dqvVWbZZz7HO8YJEyK9T_P_zUx3",
      "b": "https://lh3.googleusercontent.com/d/1UFa2iPhaZhb7-C__T1DliKvgAHtXhbZ5",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_562ca60c-336b-4d8f-ace2-67012117461f.jpg?v=1710348045"
   },
   "carat": 0.15
  },
  {
   "rank": 746,
   "id": "gid://shopify/Product/7485706043576",
   "title": "0.15 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-110333lb",
   "handle": "wedding-bands-110333lb",
   "priceNow": 1012.99,
   "priceWas": 3140.0,
   "pctOff": 68,
   "core": "110333",
   "inStock": true,
   "createdAt": "2024-03-13T16:26:35Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1m1nWaf6cILJ8nqVNde_fEPdRlsIgcLQl",
      "b": "https://lh3.googleusercontent.com/d/1W3-_h5UzUJq6CR0_2MNulkGFg4H4m5Oo",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/16wpvEoUl3ESqarMMIMj0HoZZekE1Phmw",
      "b": "https://lh3.googleusercontent.com/d/1eF49oubARjMjibwaJiu-FZRNku12MA2b",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1QFdIFwPW_HwQXXtsrXxP8kLkvOeQMCaT",
      "b": "https://lh3.googleusercontent.com/d/1uEyfOmwk2MThehAz8SBz-YMDUO_4eKJk",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_5ec443f5-2711-4338-ae3f-3cd24536f0f8.jpg?v=1710362032"
   },
   "carat": 0.15
  },
  {
   "rank": 747,
   "id": "gid://shopify/Product/7485705846968",
   "title": "0.50 CT Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71789lb",
   "handle": "wedding-bands-71789lb",
   "priceNow": 1080.99,
   "priceWas": 3350.0,
   "pctOff": 68,
   "core": "71789",
   "inStock": true,
   "createdAt": "2024-03-13T16:26:27Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1XbdrTxC_4NfxI4re8sPCZflnBOvT5CXz",
      "b": "https://lh3.googleusercontent.com/d/1viYWLlHAWKmeybqXEPQQiUigWGKmki2w",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1ROK9umZQM1ROFZMy6ipKVUpIdIH5uaQ9",
      "b": "https://lh3.googleusercontent.com/d/1qEQ7taGoJ9BZTPsGw_IAdu254sBqVKlN",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1M78Cj4aaQtcRsaV7eUvRLHsGt-2CUnoa",
      "b": "https://lh3.googleusercontent.com/d/157iPiYhNdmKqqOAlEi4I3KHi4ToRzpcO",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_31de1bf7-297d-433f-a5eb-4ac45bafa1ae.jpg?v=1763698965"
   },
   "carat": 0.5
  },
  {
   "rank": 748,
   "id": "gid://shopify/Product/7485705617592",
   "title": "0.65 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-110360lb",
   "handle": "wedding-bands-110360lb",
   "priceNow": 1419.99,
   "priceWas": 4400.0,
   "pctOff": 68,
   "core": "110360",
   "inStock": true,
   "createdAt": "2024-03-13T16:26:18Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1SbVxi3bA26Qk7309QRKjhGreVFGF4AQG",
      "b": "https://lh3.googleusercontent.com/d/1okSXGfc6VDTTzOlpmHqzlRla5EsUKWHa",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1tWGNEAQp6f3bqCrJ94YacsjmYet7mZhb",
      "b": "https://lh3.googleusercontent.com/d/1RBTvPy1avo7SWyAZMK7SzOVwtEk5B1bm",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1v6DztSib-LI0UxPpkMW4DrMhGhtfaB9h",
      "b": "https://lh3.googleusercontent.com/d/1OfH3moxrMHKIqruAGBqcZ11tmscIR7Gb",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_a870b757-4243-4aee-9a00-c44346808052.jpg?v=1710381528"
   },
   "carat": 0.65
  },
  {
   "rank": 749,
   "id": "gid://shopify/Product/7485705552056",
   "title": "1.00 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71787lb",
   "handle": "wedding-bands-71787lb",
   "priceNow": 1530.99,
   "priceWas": 4750.0,
   "pctOff": 68,
   "core": "71787",
   "inStock": true,
   "createdAt": "2024-03-13T16:26:13Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1a9sIo42eW5kzDs-UvjcjAxxleVdN5P48",
      "b": "https://lh3.googleusercontent.com/d/1qdklUdoptKzup6zwUBq1VdetI4jXJpgw",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/14M5cyAlwTePQU4V8q_o5YhbFkZkg8QAo",
      "b": "https://lh3.googleusercontent.com/d/1ljKItvcpeeboiWt-N7s4naFlSG9C2HnV",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1UBzSYkDtfnU3gk1SVCxARr44N2g-Oivj",
      "b": "https://lh3.googleusercontent.com/d/1eQqskoIWon23qplXqVjggKfeNdaCPoUh",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_aec04b66-f790-4739-bb11-b06f0bc230af.jpg?v=1710381788"
   },
   "carat": 1.0
  },
  {
   "rank": 750,
   "id": "gid://shopify/Product/7485705322680",
   "title": "1.50 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71791lb",
   "handle": "wedding-bands-71791lb",
   "priceNow": 1575.99,
   "priceWas": 4890.0,
   "pctOff": 68,
   "core": "71791",
   "inStock": true,
   "createdAt": "2024-03-13T16:26:04Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1Mc4yfEQVZRV_Gg1o6a7MSi7AhIe9ULiP",
      "b": "https://lh3.googleusercontent.com/d/1m8X7RMb-x7SzmU2ImDEj1YFV-8TQyKXL",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1VARqQSqOIShTox1zYxucEOggbNOoehX2",
      "b": "https://lh3.googleusercontent.com/d/1wMdSf39BdhGc98ZRQCSQYdJaWf-Jbw9A",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/18cEpAOTJwrpFyVVzwZnY5LZ57tKGmQ-B",
      "b": "https://lh3.googleusercontent.com/d/1Dt9dsY-B9Eik1GkiJVNQ0h0LBA39h0C5",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_82737186-1f3d-4adf-855d-a80f06478810.jpg?v=1763698965"
   },
   "carat": 1.5
  },
  {
   "rank": 751,
   "id": "gid://shopify/Product/7485705158840",
   "title": "1.50 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71792lb",
   "handle": "wedding-bands-71792lb",
   "priceNow": 1674.99,
   "priceWas": 5190.0,
   "pctOff": 68,
   "core": "71792",
   "inStock": true,
   "createdAt": "2024-03-13T16:25:59Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1aVQiriTosSpZ8fzegtcJBfE1hzQqk-00",
      "b": "https://lh3.googleusercontent.com/d/1cbHZcabnPbGyPxGJEku99_731tOocloa",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/19a2MesYZ5Fth2xRX8Wq2vIc-euSOUPCc",
      "b": "https://lh3.googleusercontent.com/d/13Om1RccxGCpzFUJgTqfESSkiFZGT6XJr",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1-5q9tIy_N_cxzhJkaV4NEhI-di0p8RQH",
      "b": "https://lh3.googleusercontent.com/d/1FXtDxt6G1HA5r-3WAIdA-EmIb0LbBfUD",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_713f5903-2e2e-4f2d-ac58-ba28bb8acd77.jpg?v=1763698966"
   },
   "carat": 1.5
  },
  {
   "rank": 752,
   "id": "gid://shopify/Product/7485705060536",
   "title": "0.45 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-110358lb",
   "handle": "wedding-bands-110358lb",
   "priceNow": 1296.99,
   "priceWas": 4020.0,
   "pctOff": 68,
   "core": "110358",
   "inStock": true,
   "createdAt": "2024-03-13T16:25:54Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1p0xDGjIY5gXeH0RuFilkhNSrbKJfool4",
      "b": "https://lh3.googleusercontent.com/d/1vDbhKDSw31IwF4NlcHDc81WsP11NuI7z",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1R0EnTR6hhRmlEjJ1cX2VPbOjWHCJXQ-z",
      "b": "https://lh3.googleusercontent.com/d/15fwBZhQimxzEvwSCP6Vc8--UL4k91ih2",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1oRf-d_k_eAg3SQgKtQNlDnum1L6HOZqi",
      "b": "https://lh3.googleusercontent.com/d/1Yl7KsGyFuVJ42GBg9Iqn05uPHxBjjnBd",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_7188d28e-6fa2-48a2-92a7-516f242d9b6f.jpg?v=1710382798"
   },
   "carat": 0.45
  },
  {
   "rank": 753,
   "id": "gid://shopify/Product/7485704896696",
   "title": "0.45 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71770lb",
   "handle": "wedding-bands-71770lb",
   "priceNow": 1277.99,
   "priceWas": 3960.0,
   "pctOff": 68,
   "core": "71770",
   "inStock": true,
   "createdAt": "2024-03-13T16:25:46Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1CJGS_CDYORZgBHgBtZ_UrK2YJYdaon6e",
      "b": "https://lh3.googleusercontent.com/d/1CH9-wPZ-SLKSH9jQw58NHEDp4OzLag1w",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1q5Cgbgs2PGpA1DlV6LzdyV46pmPdInYr",
      "b": "https://lh3.googleusercontent.com/d/1clXOnqEf-rX4ZryLj4qUTYJ8PooBKNSD",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1xkVqmlF-pHeJglvjK7UAVcum5ZTNmz9D",
      "b": "https://lh3.googleusercontent.com/d/1s0-Bvbj_cNPKnaAAFjoL6VIaSmTvxFZ-",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_581dd89c-a4db-4bf1-812c-b8a44e4af0e3.jpg?v=1710384961"
   },
   "carat": 0.45
  },
  {
   "rank": 754,
   "id": "gid://shopify/Product/7485704831160",
   "title": "0.30 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-110396lb",
   "handle": "wedding-bands-110396lb",
   "priceNow": 1229.99,
   "priceWas": 3810.0,
   "pctOff": 68,
   "core": "110396",
   "inStock": true,
   "createdAt": "2024-03-13T16:25:42Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/11XF9EBJuzDaa-MLVtT-vVKrJpL7yYxgO",
      "b": "https://lh3.googleusercontent.com/d/1Jw9QtkaLgM_AD8sti54nQcnwL419mEbq",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/12JfsrHK98k7vI1QPWv8r0oj4g9gRYAg4",
      "b": "https://lh3.googleusercontent.com/d/1kFxMXKy1EBl84sr0xaAM6EG8HggfW9x4",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1jomVPSKQz6lRCJCrygSQffKOVf4Fvf-2",
      "b": "https://lh3.googleusercontent.com/d/1A7OS3Tkdd0N_Ydf1baI3XkF-magdEGzD",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_f9dc6932-fe6b-4825-ba15-c2c76136c6f5.jpg?v=1710385116"
   },
   "carat": 0.3
  },
  {
   "rank": 755,
   "id": "gid://shopify/Product/7485704667320",
   "title": "0.30 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-110366lb",
   "handle": "wedding-bands-110366lb",
   "priceNow": 1044.99,
   "priceWas": 3240.0,
   "pctOff": 68,
   "core": "110366",
   "inStock": true,
   "createdAt": "2024-03-13T16:25:28Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1pml4jy07SDLG04A2pPK7jtvHUOMSY0p9",
      "b": "https://lh3.googleusercontent.com/d/1qZhRrceNeb-rCh278bdHZnmJh_GjSijN",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1buzr0u1jBorAUiMKhPr0jT6YCjYnBvGX",
      "b": "https://lh3.googleusercontent.com/d/1-bQhXKx-Zs1pwMCCffW_yKfvaQUx1TWS",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1FPGS-da1EpCAkjBcP59RgSfahFxDVmG_",
      "b": "https://lh3.googleusercontent.com/d/1M4t5KLnRELYquf5D_qSvOm0Vb8Fv1a2R",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_138d5f91-1f4e-4cec-bd49-f7165417c29c.jpg?v=1710403011"
   },
   "carat": 0.3
  },
  {
   "rank": 756,
   "id": "gid://shopify/Product/7485704536248",
   "title": "0.25 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-110356lb",
   "handle": "wedding-bands-110356lb",
   "priceNow": 923.99,
   "priceWas": 3140.0,
   "pctOff": 71,
   "core": "110356",
   "inStock": true,
   "createdAt": "2024-03-13T16:25:21Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1A8nKwjOsOE80RybgW5571po0pRhXC1vs",
      "b": "https://lh3.googleusercontent.com/d/1Ti8wEgWfLbeEfA5kC8NdoXHfltohzM0y",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/18-32J2PWHSv5Kf8yQAUFdbkOmZON1l-J",
      "b": "https://lh3.googleusercontent.com/d/1pgl1Ix9z_KounI0MOiR58EHsOn86yIiz",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1w4j4qdrT0jD9FVk_8Cpw0aG0k0oFQE-q",
      "b": "https://lh3.googleusercontent.com/d/1P765ssa4YZ7JwNavCzKICIcaWj0mijxm",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_e8c1ef7b-8fbc-472e-8845-2975dc582b27.jpg?v=1710403240"
   },
   "carat": 0.25
  },
  {
   "rank": 757,
   "id": "gid://shopify/Product/7485704372408",
   "title": "1.50 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-15679lb",
   "handle": "wedding-bands-15679lb",
   "priceNow": 1713.99,
   "priceWas": 5310.0,
   "pctOff": 68,
   "core": "15679",
   "inStock": true,
   "createdAt": "2024-03-13T16:25:08Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1JitLcdqLZrE-i9wRqMpPmLC6I2ngqVkD",
      "b": "https://lh3.googleusercontent.com/d/1yTk_SngH_ZNRJlqGeXGnO_kY5-KIL40v",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1JE2Z4ZNm9d9fLA-SeFWWQG5EfAgjldz8",
      "b": "https://lh3.googleusercontent.com/d/1AJ6KpK7EuQyL7H6QcUiY6xiP2FNtM84E",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1GO9eY6c7qMzXRLHREwcpXmRjVYtGzzqE",
      "b": "https://lh3.googleusercontent.com/d/1OW_saC9HFyD-iIFjXCq_TEvCm0RaB1qI",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_1413ac6a-b21c-402d-ad4e-aeb9ea0406fc.jpg?v=1710404496"
   },
   "carat": 1.5
  },
  {
   "rank": 758,
   "id": "gid://shopify/Product/7485704241336",
   "title": "1.00 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-15277lb",
   "handle": "wedding-bands-15277lb",
   "priceNow": 1485.99,
   "priceWas": 4610.0,
   "pctOff": 68,
   "core": "15277",
   "inStock": true,
   "createdAt": "2024-03-13T16:25:03Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/13SfFf4LF6GWfDT-91AuTuCyJ9OBJR2MA",
      "b": "https://lh3.googleusercontent.com/d/1M63LNClxiSTBi1XCkfxv0vkMCfHN2Jfv",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1iFcqt4T4UNESD5XkT8dK8XwJdZQP6os7",
      "b": "https://lh3.googleusercontent.com/d/1sMJwaG2tGeo5xnBjBMr3Y8mZvgSQvs4u",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1zJKj97SQ1xU2ORjraoaIH43dLm72BZQE",
      "b": "https://lh3.googleusercontent.com/d/1YhaM3q-fmkGJ6c3VVMNB7-PP4-JDjQBP",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_35f69d69-bd0b-4350-9778-f5ad006a499f.jpg?v=1763698994"
   },
   "carat": 1.0
  },
  {
   "rank": 759,
   "id": "gid://shopify/Product/7485704077496",
   "title": "0.25 CT Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-110394lb",
   "handle": "wedding-bands-110394lb",
   "priceNow": 1412.99,
   "priceWas": 4380.0,
   "pctOff": 68,
   "core": "110394",
   "inStock": true,
   "createdAt": "2024-03-13T16:24:52Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1-g1Qs1ny8FZVKsMH0uj4KHJ0q33nNJ2l",
      "b": "https://lh3.googleusercontent.com/d/1XZSb7idDWyi9vuhoFObPcV_YEzhzxN7Q",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1dgmZNh5WMqV5GZAvi7XjKo17c5JP41vu",
      "b": "https://lh3.googleusercontent.com/d/1bAHEyd2uQq1A6E4JMfiDWmh1cAmMUlI0",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/17AwULcYR-TOu5wOQ1QH3neMJgdQ5Zc7B",
      "b": "https://lh3.googleusercontent.com/d/1-bSzd5aOg6BwS_xVZ3M6tcFAs-2oREhu",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_dcaf84ee-67f2-4350-aca4-5585d1d5c126.jpg?v=1710405486"
   },
   "carat": 0.25
  },
  {
   "rank": 760,
   "id": "gid://shopify/Product/7485703979192",
   "title": "0.20 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-110328lb",
   "handle": "wedding-bands-110328lb",
   "priceNow": 890.99,
   "priceWas": 3030.0,
   "pctOff": 71,
   "core": "110328",
   "inStock": true,
   "createdAt": "2024-03-13T16:24:46Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1clfVlbx0xjsiqW2KZdVF-Lm0LlW8tWT3",
      "b": "https://lh3.googleusercontent.com/d/1aPTMqxAoTuUiWjHlcwFDpWUzuinrbE2X",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1mDmT3ugXUoWwa7QGY-DSwKrZWkPuUgJq",
      "b": "https://lh3.googleusercontent.com/d/19V-HCKNHmv-Q-u-EbN82CJxLgKRc51yc",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1_bWoSeUnh5qEUt7UDDTjaMV6BbRWaL_g",
      "b": "https://lh3.googleusercontent.com/d/1RQI9DCjaTyQDqoEqmvnYj-Bqs-fb6vSX",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_3a615b81-5ece-417d-b5c8-aa2deca43373.jpg?v=1763698994"
   },
   "carat": 0.2
  },
  {
   "rank": 761,
   "id": "gid://shopify/Product/7476266991800",
   "title": "1.26 CT Oval & Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71828lb",
   "handle": "wedding-bands-71828lb",
   "priceNow": 1672.99,
   "priceWas": 5190.0,
   "pctOff": 68,
   "core": "71828",
   "inStock": true,
   "createdAt": "2024-03-10T18:52:13Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1xokT427zz0FnXy30nLbHDLs-QMEbdX6g",
      "b": "https://lh3.googleusercontent.com/d/1mL_sYZjynhMW5bBoAQeb0Nhzaf-4v0Gr",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1DHTYk8TKtcy2b3thELcP83PzuPiebqmk",
      "b": "https://lh3.googleusercontent.com/d/1vqr2WHJ2cVnipSgr399x2k3MMnUhNiVN",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1E6D46GnF3E0NVJbd3tL1HzNZt3gJw_eS",
      "b": "https://lh3.googleusercontent.com/d/1B_-TScBh-nVO3qpAljB4MfgsnkW3W5vi",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_dd8b62ea-0963-4afe-83d5-2958289d29dd.jpg?v=1763698994"
   },
   "carat": 1.26
  },
  {
   "rank": 762,
   "id": "gid://shopify/Product/7476266959032",
   "title": "0.80 CT Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-15700lb",
   "handle": "wedding-bands-15700lb",
   "priceNow": 1373.99,
   "priceWas": 4260.0,
   "pctOff": 68,
   "core": "15700",
   "inStock": true,
   "createdAt": "2024-03-10T18:52:12Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1VF5AxLr7M2Y0nedZ9YzAlnmt0BSLZyNv",
      "b": "https://lh3.googleusercontent.com/d/1FBnZtP-iRpJdDRFjIy2zQHS9lz_C47Vk",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1ezh91UY5Zh5_eRwdVs_v5QKc0qmsEVEj",
      "b": "https://lh3.googleusercontent.com/d/1vqrrNwEENA3mYxgFwA16FubRHJ9HHaZu",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1nwK7wUnsiuZgy27brcn2p4juupmq5Oaw",
      "b": "https://lh3.googleusercontent.com/d/1YlqYbkZeI9PdlJrbJS-OijD0nrjStHp9",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_88f9d638-bfb0-4ada-9a39-d973fa5b22fd.jpg?v=1763698994"
   },
   "carat": 0.8
  },
  {
   "rank": 763,
   "id": "gid://shopify/Product/7476266893496",
   "title": "0.50 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71798lb",
   "handle": "wedding-bands-71798lb",
   "priceNow": 1103.99,
   "priceWas": 3420.0,
   "pctOff": 68,
   "core": "71798",
   "inStock": true,
   "createdAt": "2024-03-10T18:52:11Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1mgyU0uq52DK_cW47-X_NKoxRaw4rn6wG",
      "b": "https://lh3.googleusercontent.com/d/1cJ9eaiCBgoNpULXyMmRbtbaONOV2sNGT",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1MeWCO9FFLpC3yiY74sGVClAWNnZcjQUf",
      "b": "https://lh3.googleusercontent.com/d/1T3T4ttEOLMo9tEoMjN74aSXXL7G-haJz",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1f8gKouxxvNP1ip5Pg949z3OhzqEJg6AN",
      "b": "https://lh3.googleusercontent.com/d/1biML7qQm9eKpbf9rRHuwDiaaq2SvarKp",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_4a7405e0-4662-47e3-bf53-53c12c91099a.jpg?v=1763698042"
   },
   "carat": 0.5
  },
  {
   "rank": 764,
   "id": "gid://shopify/Product/7476266795192",
   "title": "0.10 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-110322lb",
   "handle": "wedding-bands-110322lb",
   "priceNow": 1353.99,
   "priceWas": 4200.0,
   "pctOff": 68,
   "core": "110322",
   "inStock": true,
   "createdAt": "2024-03-10T18:52:10Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1qn5FtXtgl9X8ETI6m8moksPZTtosDe6Q",
      "b": "https://lh3.googleusercontent.com/d/1pqU4wSY_IRq0qgYe6PQGvq8MADtbRBBt",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1HP5PpOm7peaUT9E4NTXrzpmtEaBOpOQ9",
      "b": "https://lh3.googleusercontent.com/d/1QwkrUjz46wZ7OPrxxlSJOjReM5Z3ntsr",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1RVKqorHUnQz92OdFo50BvPOQ5XoHg9La",
      "b": "https://lh3.googleusercontent.com/d/1uTLmW4UwfYkoq4wn539ib8-LyS-L3mYv",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_938bf114-1928-4a11-a17a-531300016874.jpg?v=1710098692"
   },
   "carat": 0.1
  },
  {
   "rank": 765,
   "id": "gid://shopify/Product/7476266762424",
   "title": "0.45 CT Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71202lb",
   "handle": "wedding-bands-71202lb",
   "priceNow": 1242.99,
   "priceWas": 3850.0,
   "pctOff": 68,
   "core": "71202",
   "inStock": true,
   "createdAt": "2024-03-10T18:52:08Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1PRCzV0S2U9nysLvz5yy4gBvgdxbKYbaO",
      "b": "https://lh3.googleusercontent.com/d/1QEe4-n6YZNwFSp57xxBPJbRwut9fNpBB",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/146TvcH2unQKigHSXJ4wbzyzz5Iq-Zmg1",
      "b": "https://lh3.googleusercontent.com/d/1oEFT4Ilz7__TydTETc2Cw2lmCp56gixP",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1O6dKZV4WzzoYsPdJFfnExTOpyr1coxqV",
      "b": "https://lh3.googleusercontent.com/d/10xYqB2bQ7_Mu4LMEnWRfxEf2-QscRvn8",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_75f57dbc-7217-4bc2-a24d-36bd5692470b.jpg?v=1710099044"
   },
   "carat": 0.45
  },
  {
   "rank": 766,
   "id": "gid://shopify/Product/7476266696888",
   "title": "1.00 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-15692lb",
   "handle": "wedding-bands-15692lb",
   "priceNow": 1483.99,
   "priceWas": 4600.0,
   "pctOff": 68,
   "core": "15692",
   "inStock": true,
   "createdAt": "2024-03-10T18:52:07Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/11rq5nq0_FGO-uSwIBsZ2so4KcMhgR7iJ",
      "b": "https://lh3.googleusercontent.com/d/11oNQzX3DdPwJXPwMf-5ftOP2Oli0Au8U",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1Xc2iRmLNoigCr8WFLDcEKznP6Px6IUro",
      "b": "https://lh3.googleusercontent.com/d/1zrE9HBrq7Jv7Mg0bybOZUuMDXmuRqJfK",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/11RNbrwIvcUbMrNC0ekl0Ds1wYSJM99ub",
      "b": "https://lh3.googleusercontent.com/d/1n_syl31g-rq4byIgipxZ57hpxqKsa9Sf",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_26d5bbe5-5d74-422b-b494-124747268a51.jpg?v=1710099772"
   },
   "carat": 1.0
  },
  {
   "rank": 767,
   "id": "gid://shopify/Product/7476266631352",
   "title": "0.80 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71821lb",
   "handle": "wedding-bands-71821lb",
   "priceNow": 1099.99,
   "priceWas": 3410.0,
   "pctOff": 68,
   "core": "71821",
   "inStock": true,
   "createdAt": "2024-03-10T18:52:06Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1459ht-SFGJLqE7rTAm_FTVXDsVtH_oTH",
      "b": "https://lh3.googleusercontent.com/d/117vFyLMbKhBgdeyM4q5-fKx0pblv8jki",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1wm4lz-EYQJ4HW0mPN64q3X35-IwexQJ9",
      "b": "https://lh3.googleusercontent.com/d/1o8q6tgPjvOO8InC4d2-8hKh31nUunnnf",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1resafwIfctAaxhN_OOijI-XPrTSa6UDD",
      "b": "https://lh3.googleusercontent.com/d/1r9pxix1dgHYF2a9fxkS5CmgsMpOb6l9b",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_0f1f40de-69d4-4ce0-9eb4-b64e2e1484a5.jpg?v=1763698995"
   },
   "carat": 0.8
  },
  {
   "rank": 768,
   "id": "gid://shopify/Product/7476266565816",
   "title": "0.35 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71232lb",
   "handle": "wedding-bands-71232lb",
   "priceNow": 1640.99,
   "priceWas": 5090.0,
   "pctOff": 68,
   "core": "71232",
   "inStock": true,
   "createdAt": "2024-03-10T18:52:05Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1kmINKkZwdMaHSyIFcjrS6CCpSYW7Sdeo",
      "b": "https://lh3.googleusercontent.com/d/1QudvnxweESvtM15EbL3IUA9dvlrx1E0E",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1n5sMxqRzLB5HkUAXvAkqjlhdQKcX4OfT",
      "b": "https://lh3.googleusercontent.com/d/1OhiE9h9Y5VYL5fa2a91X9XvNuNbQtpyE",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1sgZWzsrBbBZxLjbfZe84gWYvNbst61lY",
      "b": "https://lh3.googleusercontent.com/d/18PwVRZuuyhUBP1ojBNZsKlEkKnhczomJ",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_e8db5641-9648-4e53-8533-c5dd32a72fee.jpg?v=1710100296"
   },
   "carat": 0.35
  },
  {
   "rank": 769,
   "id": "gid://shopify/Product/7476266533048",
   "title": "0.90 CT Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-15299lb",
   "handle": "wedding-bands-15299lb",
   "priceNow": 1368.99,
   "priceWas": 4240.0,
   "pctOff": 68,
   "core": "15299",
   "inStock": true,
   "createdAt": "2024-03-10T18:52:04Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1jg9Tv9safgBSXoSzKTAIrr93CoHulHc_",
      "b": "https://lh3.googleusercontent.com/d/1B8XaArOMCrZAnC-MqGR4-gBvShk9PNFV",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1jOdIml1SBRpkVO_F5HUyg6ee4TvBhzxz",
      "b": "https://lh3.googleusercontent.com/d/1H4eq1kPAH9-j1Rs3ZWK-cOrdywbyaHVq",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1GAbER9PIX_ydghj9ZwT--jong4iLeghi",
      "b": "https://lh3.googleusercontent.com/d/1fM9TZ33yHgohoseFmJGy2GeW3NMPTMPY",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_85f8d74c-3c29-4017-8ccf-d78cef741209.jpg?v=1763698995"
   },
   "carat": 0.9
  },
  {
   "rank": 770,
   "id": "gid://shopify/Product/7476266500280",
   "title": "0.25 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-110323lb",
   "handle": "wedding-bands-110323lb",
   "priceNow": 920.99,
   "priceWas": 3130.0,
   "pctOff": 71,
   "core": "110323",
   "inStock": true,
   "createdAt": "2024-03-10T18:52:03Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1LVHOnhYwYsc7jmSG-jfzkgkTn3-oxqYL",
      "b": "https://lh3.googleusercontent.com/d/1yeZ5k40yQBZDgfxUTWWAdL1PMlilrlhd",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1Sj-e2bRV12lO5hII-8oJOW6i0Fd4ZHG7",
      "b": "https://lh3.googleusercontent.com/d/1-q1bxp36mPkpMYrmxVqH_Rx0N_mf2y-q",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1TYUyez3dE4hABDamBySMI4jqgofRt5dx",
      "b": "https://lh3.googleusercontent.com/d/1L0dH3w_qqppVmabp4dBevJgfKZuGKVf2",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_2da5c949-fdc9-41b6-b013-9206f9eef2fd.jpg?v=1710102237"
   },
   "carat": 0.25
  },
  {
   "rank": 771,
   "id": "gid://shopify/Product/7476266467512",
   "title": "0.60 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-16035lb",
   "handle": "wedding-bands-16035lb",
   "priceNow": 955.99,
   "priceWas": 3250.0,
   "pctOff": 71,
   "core": "16035",
   "inStock": true,
   "createdAt": "2024-03-10T18:52:01Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1SSONMSK9mjvqyKiItukOEoZg6ASD6_-B",
      "b": "https://lh3.googleusercontent.com/d/1fcdwc2ZNhUi9SDZUrPDvM7nB_zeG0Ssc",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/13DUKjThOoDzX9K2iSNIAuVK_EgsQhZLv",
      "b": "https://lh3.googleusercontent.com/d/11ji6KQ4ceBqjx2S6EgVn09an5nCCgKbn",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1s36P0IE-SBZsw0ufimntxgFo04vgQAeS",
      "b": "https://lh3.googleusercontent.com/d/18lHAwksP11lGl4wVYUYSMX3PGX-umQ8n",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_c01871c7-f136-4ccf-958d-96e0555fa335.jpg?v=1763698995"
   },
   "carat": 0.6
  },
  {
   "rank": 772,
   "id": "gid://shopify/Product/7476266401976",
   "title": "2.00 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71624lb",
   "handle": "wedding-bands-71624lb",
   "priceNow": 1562.99,
   "priceWas": 4850.0,
   "pctOff": 68,
   "core": "71624",
   "inStock": true,
   "createdAt": "2024-03-10T18:52:00Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1TkJWG2WJ_KVnZAAIagni4m_Sc8dTcdEU",
      "b": "https://lh3.googleusercontent.com/d/1cJoTCrzRwe6nmKpgx4nG9jnSB9T9x4tI",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1pgPfDwhDPVDpSRTymQ6PhY0bgMvtSWhr",
      "b": "https://lh3.googleusercontent.com/d/17IzIiImEwfVt6L0W43rgq0K78tKef_UE",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1tnJN1YxJD6KKD_2HLlMBO7JF9_7ReoGb",
      "b": "https://lh3.googleusercontent.com/d/1VO9jHBC9d6tFsfSeo8xoxWQffbrmb2Cg",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_fdcb2b98-4f58-409e-8f21-79e25c517836.jpg?v=1763698995"
   },
   "carat": 2.0
  },
  {
   "rank": 773,
   "id": "gid://shopify/Product/7476266369208",
   "title": "0.25 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-110398lb",
   "handle": "wedding-bands-110398lb",
   "priceNow": 926.99,
   "priceWas": 3150.0,
   "pctOff": 71,
   "core": "110398",
   "inStock": true,
   "createdAt": "2024-03-10T18:51:59Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_5a470d67-fb0b-4b72-bf20-71379775c224.jpg?v=1710104713",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_5a470d67-fb0b-4b72-bf20-71379775c224.jpg?v=1710104713",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y3_badf2472-0edb-443b-bcfc-dfda1f706ed1.jpg?v=1763698995",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r3_5827518e-0175-44a0-a340-95e6b8fd01a7.jpg?v=1763698995"
    }
   },
   "carat": 0.25
  },
  {
   "rank": 774,
   "id": "gid://shopify/Product/7476266303672",
   "title": "0.30 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71588lb",
   "handle": "wedding-bands-71588lb",
   "priceNow": 1014.99,
   "priceWas": 3150.0,
   "pctOff": 68,
   "core": "71588",
   "inStock": true,
   "createdAt": "2024-03-10T18:51:57Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1z4cHcmxd3fZF_N0l9q6xu7I0JwIjwcHv",
      "b": "https://lh3.googleusercontent.com/d/1LYCjrPKQif2aRRMGFLEyjCrs3-7uEYQ2",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1wPn2fZVI3oFqiccdSXLDRlGB3TFZ50YT",
      "b": "https://lh3.googleusercontent.com/d/1FswTm4y-utBTRkIGFhEplW0wYxwx_824",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1kgYvMJ3qh15LBSSkYfQ3L7dh_CImxNXs",
      "b": "https://lh3.googleusercontent.com/d/1tMyUAVPXWWSkEqcrUxUNjDoBsatTfoVM",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_37ab8078-b60a-49f9-81a2-02034e0a96a9.jpg?v=1710106649"
   },
   "carat": 0.3
  },
  {
   "rank": 775,
   "id": "gid://shopify/Product/7476266139832",
   "title": "0.45 CT Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-110341lb",
   "handle": "wedding-bands-110341lb",
   "priceNow": 1287.99,
   "priceWas": 3990.0,
   "pctOff": 68,
   "core": "110341",
   "inStock": true,
   "createdAt": "2024-03-10T18:51:55Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1gwnSLDFvt_pYYHKTJT6ghZAyXJhupVDb",
      "b": "https://lh3.googleusercontent.com/d/1RJB43eoMmjcrq-ITrJd3fwfaSEVrgZUs",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1rpxSu4VzbMRcRB8JvgaKFF9LBgziD8Bp",
      "b": "https://lh3.googleusercontent.com/d/19wdw2sEIPypYl7K5HDap_3xZuQxzuYuL",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1MLIbgWXm8xM8KsQ01dFm5ggr4hIWdjW1",
      "b": "https://lh3.googleusercontent.com/d/1Psh8nmy7P6rap32miJ768h7ubQTJW5Dl",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_909d6acc-2335-404a-9cb5-c9fe720f5ae5.jpg?v=1710108379"
   },
   "carat": 0.45
  },
  {
   "rank": 776,
   "id": "gid://shopify/Product/7476266074296",
   "title": "1.10 CT Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-15263lb",
   "handle": "wedding-bands-15263lb",
   "priceNow": 1443.99,
   "priceWas": 4480.0,
   "pctOff": 68,
   "core": "15263",
   "inStock": true,
   "createdAt": "2024-03-10T18:51:54Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_9aea093c-3a93-470b-9cb8-e5a328ccc837.jpg?v=1763699079",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_9aea093c-3a93-470b-9cb8-e5a328ccc837.jpg?v=1763699079",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/y3_06551980-d02e-4a6d-b426-0c1fe9ebdc8b.jpg?v=1763699079",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/r3_4b15f257-c667-46bd-a639-d0c955e9daa8.jpg?v=1763699079"
    }
   },
   "carat": 1.1
  },
  {
   "rank": 777,
   "id": "gid://shopify/Product/7476265975992",
   "title": "0.20 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-110331lb",
   "handle": "wedding-bands-110331lb",
   "priceNow": 898.99,
   "priceWas": 3060.0,
   "pctOff": 71,
   "core": "110331",
   "inStock": true,
   "createdAt": "2024-03-10T18:51:53Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1w98njpORbrvjkmVLfEL6M_iyrP2kHijV",
      "b": "https://lh3.googleusercontent.com/d/1bRb6ZMCVk1WXgjl4bAIGnxZ7EDHHez9U",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1nhAXsEL43xa3f-orn9nqoKUGo4bvRzl0",
      "b": "https://lh3.googleusercontent.com/d/1bAgBe6wu13NhBWWbr2aY2yNHxP0m-7a0",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1QbH7lyBiuRY-sI6N2tkuBKxui8VSR3uf",
      "b": "https://lh3.googleusercontent.com/d/1CbfmMIZmsY94-LFGTMrWo9b6so0TMq8J",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_a721d449-23b9-4def-8ae6-ddd89d8a7c24.jpg?v=1710109256"
   },
   "carat": 0.2
  },
  {
   "rank": 778,
   "id": "gid://shopify/Product/7476265877688",
   "title": "0.90 CT Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-15706lb",
   "handle": "wedding-bands-15706lb",
   "priceNow": 1407.99,
   "priceWas": 4360.0,
   "pctOff": 68,
   "core": "15706",
   "inStock": true,
   "createdAt": "2024-03-10T18:51:50Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1UzUO_seG48AYMcuDlS2N1JaN-8unY4Xw",
      "b": "https://lh3.googleusercontent.com/d/1erenxUQ2Nm6hYjgagvr80UHRxQeH5TGl",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1uBToWlbNbLMNTLm1wgGFdL94hZp2rMU-",
      "b": "https://lh3.googleusercontent.com/d/1OxAlfU7xgWLS8B7UKWpzr1s3FkyFt3cq",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1z7lldCMRpkxBhu5k5De0MyEaWJ3jmztU",
      "b": "https://lh3.googleusercontent.com/d/14JxKz1NNh_ROEAuoJykTZT2G9qTqWnql",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_e6d66460-4d3a-4498-85e8-7849e7e838ba.jpg?v=1710258641"
   },
   "carat": 0.9
  },
  {
   "rank": 779,
   "id": "gid://shopify/Product/7476265844920",
   "title": "0.25 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71778lb",
   "handle": "wedding-bands-71778lb",
   "priceNow": 811.99,
   "priceWas": 2760.0,
   "pctOff": 71,
   "core": "71778",
   "inStock": true,
   "createdAt": "2024-03-10T18:51:49Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1wz3POmlgbpFeqSpJ8RPzm41YqT8Yj3eO",
      "b": "https://lh3.googleusercontent.com/d/1YPwdtMlxcDfIaZ7giUoxT9RkQhKUp4CL",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1psJpLBbPT43_Im3XTULyjJxT2TBKhlch",
      "b": "https://lh3.googleusercontent.com/d/1B_6qzas6S0aNHpe4HJ_VxAucEIUvi8XJ",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Le3OziNKUJhUGrpQ2tORfoAzvoFw8aZ-",
      "b": "https://lh3.googleusercontent.com/d/1ZWj2MfPbJGf3v5CJAkN_ev0fnJ1yC7sU",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_3714860e-aff3-49bf-b322-16602a624243.jpg?v=1763699079"
   },
   "carat": 0.25
  },
  {
   "rank": 780,
   "id": "gid://shopify/Product/7476265779384",
   "title": "1.65 CT Princess Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-16046lb",
   "handle": "wedding-bands-16046lb",
   "priceNow": 1827.99,
   "priceWas": 5670.0,
   "pctOff": 68,
   "core": "16046",
   "inStock": true,
   "createdAt": "2024-03-10T18:51:48Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1JfLtBm4TY0pX2Ye3LdHPP2ZQWi-Cwz5N",
      "b": "https://lh3.googleusercontent.com/d/1PTRRSCtzG-h3kqwMBW2Q46pEslmq7mhA",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1YC9hHAspB7wF5Y0WI1QjnJx6Yxi__XQI",
      "b": "https://lh3.googleusercontent.com/d/1IHCvxgGJQTrPfSpQW3dsYO2L9Kzpmhhi",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ZvA9e5h67en1tcma8Gmlpdgn_REcXVon",
      "b": "https://lh3.googleusercontent.com/d/1cgLU_Fie5-6lfjn7u8N5IUvpORLmUCcM",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_2089e2d7-541e-4cba-90c8-c97d5a823d18.jpg?v=1763699079"
   },
   "carat": 1.65
  },
  {
   "rank": 781,
   "id": "gid://shopify/Product/7476265713848",
   "title": "0.60 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-16078lb",
   "handle": "wedding-bands-16078lb",
   "priceNow": 950.99,
   "priceWas": 3230.0,
   "pctOff": 71,
   "core": "16078",
   "inStock": true,
   "createdAt": "2024-03-10T18:51:45Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1RVWvX-Fg92x1tNphhq9fo529EjqXzVUu",
      "b": "https://lh3.googleusercontent.com/d/1T3xXIlxeLqTPep4c0hc30pzP0QtyPnF9",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1ryu9X_lPUtsDS68YBlpWpt7lt04aSr78",
      "b": "https://lh3.googleusercontent.com/d/1Wp-DNd20uJuTgXifKezEWK14m1vnpL9b",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1vrVKRXAtZEDI7Kf0aEYZcimEPwEj5E7Z",
      "b": "https://lh3.googleusercontent.com/d/1stRqvOm5aJ_HzYCJX3xzD_5k4c-wXRkn",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_57da51ea-b1b5-4376-b1be-40282e3dc2b9.jpg?v=1763699079"
   },
   "carat": 0.6
  },
  {
   "rank": 782,
   "id": "gid://shopify/Product/7476265582776",
   "title": "0.50 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-16021lb",
   "handle": "wedding-bands-16021lb",
   "priceNow": 905.99,
   "priceWas": 3080.0,
   "pctOff": 71,
   "core": "16021",
   "inStock": true,
   "createdAt": "2024-03-10T18:51:43Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1Nk8ggKfl82SrETzy_qKUUujudBPciW5L",
      "b": "https://lh3.googleusercontent.com/d/10WU2HHj1R6NRydT4BILimEEMXH1U2m9q",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1im87DcoXQKijZ-W6Z0gxNNseXneGSpvV",
      "b": "https://lh3.googleusercontent.com/d/1FPp_gcI_IZYaHzVIpo13_X7yAYXEQcEm",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1rj3WAc5Mc0xA3jzJvLQLsMA-KGb3K2O5",
      "b": "https://lh3.googleusercontent.com/d/11mQxVN4AE7etE8c41bJcwsrkhws1cgGk",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_696731f6-468c-4015-8f7e-3c2997155448.jpg?v=1710264620"
   },
   "carat": 0.5
  },
  {
   "rank": 783,
   "id": "gid://shopify/Product/7476265517240",
   "title": "0.25 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-71781lb",
   "handle": "wedding-bands-71781lb",
   "priceNow": 809.99,
   "priceWas": 2750.0,
   "pctOff": 71,
   "core": "71781",
   "inStock": true,
   "createdAt": "2024-03-10T18:51:41Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/10mLh6D2shmwP9Vit1lDBHEk3cthk7ARp",
      "b": "https://lh3.googleusercontent.com/d/1Z9QSKJ1OWuBaAxlm35ZGSIl4He-Ikomu",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1dA937Y_fPH3if7VzZzo5BsU5S6M0bgrf",
      "b": "https://lh3.googleusercontent.com/d/1LRDuKwWrWqi0L9yPdSa5i0CqCwlA8h2K",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1pctJ3qPQCoFOl88nov89hEWyG4nqVk9o",
      "b": "https://lh3.googleusercontent.com/d/1QG6brgzKSm8PuzzO-kuVjWH2znVE1Jlv",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_2dd09cbe-1124-4412-a401-1bcbc6ef8b20.jpg?v=1763699103"
   },
   "carat": 0.25
  },
  {
   "rank": 784,
   "id": "gid://shopify/Product/7476265451704",
   "title": "0.60 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-15297lb",
   "handle": "wedding-bands-15297lb",
   "priceNow": 1148.99,
   "priceWas": 3560.0,
   "pctOff": 68,
   "core": "15297",
   "inStock": true,
   "createdAt": "2024-03-10T18:51:39Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1a2L19tJEEhTPDB8Xz_q5VlVZj66mqKJw",
      "b": "https://lh3.googleusercontent.com/d/1_0g5h9_DQc1BeUeZpUrtGUhzi4ExXKqY",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/12t-kmckk6MMIHuVAn6o3AgDCKs8B1NAV",
      "b": "https://lh3.googleusercontent.com/d/14J26ob57F6dX8YqNNp6Hsyk5oVHhFRQv",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/10xbalny0qrbigk72GpNzjdBTj0NKG9Ww",
      "b": "https://lh3.googleusercontent.com/d/1Zt2NsoQkpjEZ16NLF3apTIGM7AVM8yhe",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_c28601b1-4060-4f00-9add-2bcbdbd9d4c4.jpg?v=1710267167"
   },
   "carat": 0.6
  },
  {
   "rank": 785,
   "id": "gid://shopify/Product/7476265418936",
   "title": "3.00-6.00 CT Emerald Cut Lab Grown Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71612lb",
   "handle": "eternity-rings-71612lb",
   "priceNow": 1925.99,
   "priceWas": 5970.0,
   "pctOff": 68,
   "core": "71612",
   "inStock": true,
   "createdAt": "2024-03-10T18:51:36Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1VHKMdiUobCofk0RIRhDdgAYZaoPhDQnN",
      "b": "https://lh3.googleusercontent.com/d/1-3n-VNRv3Cl-NY5ftT-4ur_rw4K6BjTb",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1a3RqwyWnMk4u8QtD2aBSfi-h4AelIeSF",
      "b": "https://lh3.googleusercontent.com/d/1s4BrSE8hScliuLHcoUj8RsUAFJftLOPL",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1zDeMwL7uiPw4AzEV3ztMTf_8DuRXZg01",
      "b": "https://lh3.googleusercontent.com/d/1Cn7FWejtNnQXyWnhbURN3nkyH_dzr9Uz",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_ca23acde-f537-424c-8299-5eeafd5063b8.jpg?v=1763697467"
   },
   "carat": 3.0,
   "caratMax": 6.0
  },
  {
   "rank": 786,
   "id": "gid://shopify/Product/7476265353400",
   "title": "0.25 CT Round Cut Lab Grown Diamonds - Wedding Band",
   "url": "/products/wedding-bands-15625lb",
   "handle": "wedding-bands-15625lb",
   "priceNow": 897.99,
   "priceWas": 3050.0,
   "pctOff": 71,
   "core": "15625",
   "inStock": true,
   "createdAt": "2024-03-10T18:51:35Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1zBxilgj4pPGDMP1xnknNWbXpa50FwawN",
      "b": "https://lh3.googleusercontent.com/d/1rMENalcLj8Za32gnBdHpcOcXn-s5ZRpZ",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1RY3pON77m10t79ECJ8yga2JRqOR6zrv_",
      "b": "https://lh3.googleusercontent.com/d/1jaxd6uG4A8miyxFNTIT-L4gQZo-uCESG",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/14eQOS154qcpotrCoRV4hFe-BRNxLEUhm",
      "b": "https://lh3.googleusercontent.com/d/1kOc7UZ0NeqUcMi_CnPTkmfZ35t09Pu3X",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_171ca465-1be4-490c-a340-0c26253b8977.jpg?v=1763699103"
   },
   "carat": 0.25
  },
  {
   "rank": 787,
   "id": "gid://shopify/Product/7476265255096",
   "title": "2.00-6.00 CT Round Cut Lab Grown Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71691lb",
   "handle": "eternity-rings-71691lb",
   "priceNow": 1844.99,
   "priceWas": 5720.0,
   "pctOff": 68,
   "core": "71691",
   "inStock": true,
   "createdAt": "2024-03-10T18:51:31Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1OBmY1CACTSLb0NxSHfanHoGuUG-TvK_A",
      "b": "https://lh3.googleusercontent.com/d/1JKalh0IuiPlJsyPUGrbRoIFnataIAj9f",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1_XZ8lb37WAq-3KMPHQVIljAdGBtu8A1O",
      "b": "https://lh3.googleusercontent.com/d/1cT8pin5Uzarl8q70JOzAgj_UugkWAia-",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ktU-OQzLK144qJYAKV-GJysmkSkgBdrL",
      "b": "https://lh3.googleusercontent.com/d/1d71cpGgCjAemaLV8MPe_ezuPtnNEMFoV",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_c47371dc-b94e-499a-ad68-61eb1cddf98a.jpg?v=1710270863"
   },
   "carat": 2.0,
   "caratMax": 6.0
  },
  {
   "rank": 788,
   "id": "gid://shopify/Product/7476265156792",
   "title": "2.20 CT Round Cut Lab Grown Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15381lb",
   "handle": "eternity-rings-15381lb",
   "priceNow": 2557.99,
   "priceWas": 7930.0,
   "pctOff": 68,
   "core": "15381",
   "inStock": true,
   "createdAt": "2024-03-10T18:51:28Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/11AOCmK2XAyVv5CS4OknTVRCwiK43uotN",
      "b": "https://lh3.googleusercontent.com/d/1MGcM2RaXJdN_fB--SH6cFOSPQoA6jaiS",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1VzvLCPSl3l2yTl3HF9T31ENLCLaZN5os",
      "b": "https://lh3.googleusercontent.com/d/14sMWIJidaggbC_t3Axpi0IIf3DTT5aU8",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1RPfzSn4msK2fbxAJUoCbiBkKbZ47dA9H",
      "b": "https://lh3.googleusercontent.com/d/1_NZmvc8vutUcf7U283m_xucHQTpvDO-0",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_1e232ff5-7366-4db8-8129-2308e05a3db7.jpg?v=1710271607"
   },
   "carat": 2.2
  },
  {
   "rank": 789,
   "id": "gid://shopify/Product/7476265124024",
   "title": "2.50 CT Princess Cut Lab Grown Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15366lb",
   "handle": "eternity-rings-15366lb",
   "priceNow": 1865.99,
   "priceWas": 5780.0,
   "pctOff": 68,
   "core": "15366",
   "inStock": true,
   "createdAt": "2024-03-10T18:51:27Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1RHIMhadpxGXK0gOr2vEi15WzYMbIAp_h",
      "b": "https://lh3.googleusercontent.com/d/13gGAjdLIuqCF93ImqKlnNh4rkmIXr-SV",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1xv4BLMQtdDssV-xaqlToqavmFOzE4JnV",
      "b": "https://lh3.googleusercontent.com/d/123idjBRXAj_jDHBBs1ObkzGE6fG5VtQJ",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1u1MGG_5Nzf02Xp8SkgNDnLimOsmWJXRt",
      "b": "https://lh3.googleusercontent.com/d/1_fJOI6HVrNmbT_2ss-5gs5j4SEvsupTi",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_e418fcb4-174c-4108-96c1-a4fd996af49f.jpg?v=1763699103"
   },
   "carat": 2.5
  },
  {
   "rank": 790,
   "id": "gid://shopify/Product/7476264992952",
   "title": "1.50-5.00 CT Round Cut Lab Grown Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71690lb",
   "handle": "eternity-rings-71690lb",
   "priceNow": 1445.99,
   "priceWas": 4480.0,
   "pctOff": 68,
   "core": "71690",
   "inStock": true,
   "createdAt": "2024-03-10T18:51:24Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1mYRjX_77un3E-LRxtUpwvEsWepcTMv9G",
      "b": "https://lh3.googleusercontent.com/d/1HUcZueo8dpMrnsVxY6tr13DU_opR3O3-",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1Lk6XpyAFEPFP0ZVWgLqSLiKnah7AQRa-",
      "b": "https://lh3.googleusercontent.com/d/1OTtNFrldsGThPxCYaX3yfAMD-LpGuJi1",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/10HJG-eih88gmqWNbxRv6XnagWv3eSX11",
      "b": "https://lh3.googleusercontent.com/d/1KNpnxNoP-Rv-IAABv4I7ELxWQYPaPsC3",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_26e2726e-fb8d-490d-a0fb-eb0c783f1d49.jpg?v=1710281173"
   },
   "carat": 1.5,
   "caratMax": 5.0
  },
  {
   "rank": 791,
   "id": "gid://shopify/Product/7476264927416",
   "title": "1.70 CT Round Cut Lab Grown Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-15951lb",
   "handle": "eternity-rings-15951lb",
   "priceNow": 1706.99,
   "priceWas": 5290.0,
   "pctOff": 68,
   "core": "15951",
   "inStock": true,
   "createdAt": "2024-03-10T18:51:23Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1e8GZnToV9m175HlJ9dLAlHAI0jX-0IXK",
      "b": "https://lh3.googleusercontent.com/d/1YvxQcHX0xYlxv9dNbNNf8v-ylijpLcu-",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1hEWP9zMxkUA4iDT4KGvf6HgzuJlqozJn",
      "b": "https://lh3.googleusercontent.com/d/1oTAUUjXHfvSHomclYhXWqp5yu2T2BmaA",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1JiVTsM-6iU6-qlmV7iKtjPRrCHzvoSxe",
      "b": "https://lh3.googleusercontent.com/d/1PLBKbLc9zjFI0Aa4jnPEvCd7GX3I3pBc",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w2_70a3ba7a-46a3-4d1e-aaaa-0f00372c1ebd.jpg?v=1710283392"
   },
   "carat": 1.7
  },
  {
   "rank": 792,
   "id": "gid://shopify/Product/7476264894648",
   "title": "1.50-5.00 CT Round Cut Lab Grown Diamonds - Eternity Rings",
   "url": "/products/eternity-rings-71689lb",
   "handle": "eternity-rings-71689lb",
   "priceNow": 1247.99,
   "priceWas": 3870.0,
   "pctOff": 68,
   "core": "71689",
   "inStock": true,
   "createdAt": "2024-03-10T18:51:21Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1bI-wqQ8OBaGb_KpO71vts7FSat2V-XPl",
      "b": "https://lh3.googleusercontent.com/d/1ialtB6_kZfrp29jrr9gyLadzRRHIFlMz",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1CUxz4xZyf_tvGmjA-jK6VqnS8EwQ33D2",
      "b": "https://lh3.googleusercontent.com/d/1G_7BG94YEvgtVev9gN1CC5X5LtyDttI4",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Jfs0kAM4o5Zj7QLaAiwIy7V0rdd1Tg_L",
      "b": "https://lh3.googleusercontent.com/d/1exNrY1wCf8Y5HXztmlCFd6VxvehFadA5",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/w3_231c0053-9e60-489c-99c8-e83c7344beb5.jpg?v=1710285862"
   },
   "carat": 1.5,
   "caratMax": 5.0
  },
  {
   "rank": 793,
   "id": "gid://shopify/Product/7395798843576",
   "title": "Four-Prong 0.60-5.00 CT Round Cut Lab Grown Diamonds - Stud Earrings",
   "url": "/products/copy-of-0-60-5-00-ct-round-cut-lab-grown-diamonds-stud-earrings",
   "handle": "copy-of-0-60-5-00-ct-round-cut-lab-grown-diamonds-stud-earrings",
   "priceNow": 636.99,
   "priceWas": 1848.0,
   "pctOff": 66,
   "core": null,
   "inStock": true,
   "createdAt": "2023-12-19T16:18:32Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/060-500-ct-round-cut-lab-grown-diamonds-stud-earrings-425997_279b6a71-f0a2-42c9-9f6c-ef33e58015d9.jpg?v=1703002738",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/060-500-ct-round-cut-lab-grown-diamonds-stud-earrings-425997_279b6a71-f0a2-42c9-9f6c-ef33e58015d9.jpg?v=1703002738",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/060-500-ct-round-cut-lab-grown-diamonds-stud-earrings-900416_d352ff6c-3c8e-4ae8-a5f5-754ff70bf960.jpg?v=1703003022",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/060-500-ct-round-cut-lab-grown-diamonds-stud-earrings-986181_b8f69b28-512c-42c0-af11-ad0af8a903d4.jpg?v=1703003022"
    }
   },
   "carat": 0.6,
   "caratMax": 5.0
  },
  {
   "rank": 794,
   "id": "gid://shopify/Product/7370417340600",
   "title": "2.00-6.00 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/2-00-6-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-21091lb",
   "handle": "2-00-6-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-21091lb",
   "priceNow": 3680.99,
   "priceWas": 11410.0,
   "pctOff": 68,
   "core": "21091",
   "inStock": true,
   "createdAt": "2023-11-17T14:39:05Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-600-ct-round-cut-lab-grown-diamonds-tennis-bracelet-283449.jpg?v=1705358429",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-600-ct-round-cut-lab-grown-diamonds-tennis-bracelet-283449.jpg?v=1705358429",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-600-ct-round-cut-lab-grown-diamonds-tennis-bracelet-371480.jpg?v=1763699115",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-600-ct-round-cut-lab-grown-diamonds-tennis-bracelet-920456.jpg?v=1763699116"
    }
   },
   "carat": 2.0,
   "caratMax": 6.0
  },
  {
   "rank": 795,
   "id": "gid://shopify/Product/7370417307832",
   "title": "1.00-6.00 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/1-00-6-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-21093lb",
   "handle": "1-00-6-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-21093lb",
   "priceNow": 2736.99,
   "priceWas": 8480.0,
   "pctOff": 68,
   "core": "21093",
   "inStock": true,
   "createdAt": "2023-11-17T14:38:54Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-600-ct-round-cut-lab-grown-diamonds-tennis-bracelet-801054.jpg?v=1706306854",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-600-ct-round-cut-lab-grown-diamonds-tennis-bracelet-801054.jpg?v=1706306854",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-600-ct-round-cut-lab-grown-diamonds-tennis-bracelet-409448.jpg?v=1763699116",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-600-ct-round-cut-lab-grown-diamonds-tennis-bracelet-968041.jpg?v=1763699116"
    }
   },
   "carat": 1.0,
   "caratMax": 6.0
  },
  {
   "rank": 796,
   "id": "gid://shopify/Product/7370417275064",
   "title": "2.00-6.00 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/2-00-6-00-ct-round-cut-diamonds-tennis-bracelet-21092lb",
   "handle": "2-00-6-00-ct-round-cut-diamonds-tennis-bracelet-21092lb",
   "priceNow": 3780.99,
   "priceWas": 11720.0,
   "pctOff": 68,
   "core": "21092",
   "inStock": true,
   "createdAt": "2023-11-17T14:38:50Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-600-ct-round-cut-diamonds-tennis-bracelet-366809.jpg?v=1706307079",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-600-ct-round-cut-diamonds-tennis-bracelet-366809.jpg?v=1706307079",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-600-ct-round-cut-diamonds-tennis-bracelet-626731.jpg?v=1763699116",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-600-ct-round-cut-diamonds-tennis-bracelet-658969.jpg?v=1763699116"
    }
   },
   "carat": 2.0,
   "caratMax": 6.0
  },
  {
   "rank": 797,
   "id": "gid://shopify/Product/7366547275960",
   "title": "2.00-3.00 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/2-00-4-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-21090lb",
   "handle": "2-00-4-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-21090lb",
   "priceNow": 4301.99,
   "priceWas": 13340.0,
   "pctOff": 68,
   "core": "21090",
   "inStock": true,
   "createdAt": "2023-11-14T13:10:26Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-400-ct-round-cut-lab-grown-diamonds-tennis-bracelet-787320.jpg?v=1705356968",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-400-ct-round-cut-lab-grown-diamonds-tennis-bracelet-787320.jpg?v=1705356968",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-400-ct-round-cut-lab-grown-diamonds-tennis-bracelet-896693.jpg?v=1763699115",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-400-ct-round-cut-lab-grown-diamonds-tennis-bracelet-872820.jpg?v=1763699116"
    }
   },
   "carat": 2.0,
   "caratMax": 3.0
  },
  {
   "rank": 798,
   "id": "gid://shopify/Product/7366547210424",
   "title": "1.50-4.00 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/1-50-4-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-21089lb",
   "handle": "1-50-4-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-21089lb",
   "priceNow": 4239.99,
   "priceWas": 13140.0,
   "pctOff": 68,
   "core": "21089",
   "inStock": true,
   "createdAt": "2023-11-14T13:10:22Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/150-400-ct-round-cut-lab-grown-diamonds-tennis-bracelet-511244.jpg?v=1705354079",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/150-400-ct-round-cut-lab-grown-diamonds-tennis-bracelet-511244.jpg?v=1705354079",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/150-400-ct-round-cut-lab-grown-diamonds-tennis-bracelet-625144.jpg?v=1763699115",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/150-400-ct-round-cut-lab-grown-diamonds-tennis-bracelet-304310.jpg?v=1763699116"
    }
   },
   "carat": 1.5,
   "caratMax": 4.0
  },
  {
   "rank": 799,
   "id": "gid://shopify/Product/7366547079352",
   "title": "0.50-1.00 CT Round Cut Lab Grown Diamonds - Designer Bracelets",
   "url": "/products/0-50-1-00-ct-round-cut-lab-grown-diamonds-diamond-bracelet-21087lb",
   "handle": "0-50-1-00-ct-round-cut-lab-grown-diamonds-diamond-bracelet-21087lb",
   "priceNow": 3704.99,
   "priceWas": 11490.0,
   "pctOff": 68,
   "core": "21087",
   "inStock": true,
   "createdAt": "2023-11-14T13:10:03Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-100-ct-round-cut-lab-grown-diamonds-diamond-bracelet-896831.jpg?v=1705353266",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-100-ct-round-cut-lab-grown-diamonds-diamond-bracelet-896831.jpg?v=1705353266",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-100-ct-round-cut-lab-grown-diamonds-diamond-bracelet-539040.jpg?v=1763699116",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-100-ct-round-cut-lab-grown-diamonds-diamond-bracelet-580790.jpg?v=1763699116"
    }
   },
   "carat": 0.5,
   "caratMax": 1.0
  },
  {
   "rank": 800,
   "id": "gid://shopify/Product/7366547046584",
   "title": "2.00-4.00 CT Round Cut Lab Grown Diamonds - Designer Bracelets",
   "url": "/products/2-00-4-00-ct-round-cut-lab-grown-diamonds-diamond-bracelet-21010lb",
   "handle": "2-00-4-00-ct-round-cut-lab-grown-diamonds-diamond-bracelet-21010lb",
   "priceNow": 5727.99,
   "priceWas": 16610.0,
   "pctOff": 66,
   "core": "21010",
   "inStock": true,
   "createdAt": "2023-11-14T13:09:53Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-400-ct-round-cut-lab-grown-diamonds-diamond-bracelet-877874.jpg?v=1705356657",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-400-ct-round-cut-lab-grown-diamonds-diamond-bracelet-877874.jpg?v=1705356657",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-400-ct-round-cut-lab-grown-diamonds-diamond-bracelet-980183.jpg?v=1763699116",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-400-ct-round-cut-lab-grown-diamonds-diamond-bracelet-365893.jpg?v=1763699116"
    }
   },
   "carat": 2.0,
   "caratMax": 4.0
  },
  {
   "rank": 801,
   "id": "gid://shopify/Product/7366547013816",
   "title": "2.00-4.50 CT Round Cut Lab Grown Diamonds - Designer Bracelets",
   "url": "/products/2-00-4-50-ct-round-cut-lab-grown-diamonds-diamond-bracelet-21009lb",
   "handle": "2-00-4-50-ct-round-cut-lab-grown-diamonds-diamond-bracelet-21009lb",
   "priceNow": 3456.99,
   "priceWas": 10720.0,
   "pctOff": 68,
   "core": "21009",
   "inStock": true,
   "createdAt": "2023-11-14T13:09:42Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-450-ct-round-cut-lab-grown-diamonds-diamond-bracelet-301635.jpg?v=1705357114",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-450-ct-round-cut-lab-grown-diamonds-diamond-bracelet-301635.jpg?v=1705357114",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-450-ct-round-cut-lab-grown-diamonds-diamond-bracelet-866857.jpg?v=1763699116",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-450-ct-round-cut-lab-grown-diamonds-diamond-bracelet-979881.jpg?v=1763699116"
    }
   },
   "carat": 2.0,
   "caratMax": 4.5
  },
  {
   "rank": 802,
   "id": "gid://shopify/Product/7366546948280",
   "title": "2.75-5.00 CT Princess Cut Lab Grown Diamonds - Designer Bracelets",
   "url": "/products/2-75-5-00-ct-princess-cut-lab-grown-diamonds-diamond-bracelet-21008lb",
   "handle": "2-75-5-00-ct-princess-cut-lab-grown-diamonds-diamond-bracelet-21008lb",
   "priceNow": 3821.99,
   "priceWas": 11850.0,
   "pctOff": 68,
   "core": "21008",
   "inStock": true,
   "createdAt": "2023-11-14T13:09:38Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/275-500-ct-princess-cut-lab-grown-diamonds-diamond-bracelet-818370.jpg?v=1705359052",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/275-500-ct-princess-cut-lab-grown-diamonds-diamond-bracelet-818370.jpg?v=1705359052",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/275-500-ct-princess-cut-lab-grown-diamonds-diamond-bracelet-585734.jpg?v=1763699116",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/275-500-ct-princess-cut-lab-grown-diamonds-diamond-bracelet-337326.jpg?v=1763699116"
    }
   },
   "carat": 2.75,
   "caratMax": 5.0
  },
  {
   "rank": 803,
   "id": "gid://shopify/Product/7366546882744",
   "title": "2.50-5.00 CT Princess & Round Cut Lab Grown Diamonds - Designer Bracelets",
   "url": "/products/2-50-5-00-ct-round-princess-cut-lab-grown-diamonds-diamond-bracelet-21007lb",
   "handle": "2-50-5-00-ct-round-princess-cut-lab-grown-diamonds-diamond-bracelet-21007lb",
   "priceNow": 3874.99,
   "priceWas": 12010.0,
   "pctOff": 68,
   "core": "21007",
   "inStock": true,
   "createdAt": "2023-11-14T13:09:34Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/250-500-ct-round-princess-cut-lab-grown-diamonds-diamond-bracelet-667509.jpg?v=1705358729",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/250-500-ct-round-princess-cut-lab-grown-diamonds-diamond-bracelet-667509.jpg?v=1705358729",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/250-500-ct-round-princess-cut-lab-grown-diamonds-diamond-bracelet-575494.jpg?v=1763699264",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/250-500-ct-round-princess-cut-lab-grown-diamonds-diamond-bracelet-584974.jpg?v=1763699264"
    }
   },
   "carat": 2.5,
   "caratMax": 5.0
  },
  {
   "rank": 804,
   "id": "gid://shopify/Product/7366546849976",
   "title": "2.00-4.00 CT Round Cut Lab Grown Diamonds - Designer Bracelets",
   "url": "/products/2-00-4-00-ct-round-cut-lab-grown-diamonds-four-prong-setting-diamond-bracelet-21006lb",
   "handle": "2-00-4-00-ct-round-cut-lab-grown-diamonds-four-prong-setting-diamond-bracelet-21006lb",
   "priceNow": 3328.99,
   "priceWas": 10320.0,
   "pctOff": 68,
   "core": "21006",
   "inStock": true,
   "createdAt": "2023-11-14T13:09:23Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-400-ct-round-cut-lab-grown-diamonds-diamond-bracelet-157607.jpg?v=1705356827",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-400-ct-round-cut-lab-grown-diamonds-diamond-bracelet-157607.jpg?v=1705356827",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-400-ct-round-cut-lab-grown-diamonds-diamond-bracelet-205258.jpg?v=1763699264",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-400-ct-round-cut-lab-grown-diamonds-diamond-bracelet-249838.jpg?v=1763699264"
    }
   },
   "carat": 2.0,
   "caratMax": 4.0
  },
  {
   "rank": 805,
   "id": "gid://shopify/Product/7330692759736",
   "title": "0.60-5.00 CT Princess Cut Lab Grown Diamonds - Stud Earrings",
   "url": "/products/0-60-5-00-ct-princess-cut-lab-grown-diamonds-stud-earrings-71902lb",
   "handle": "0-60-5-00-ct-princess-cut-lab-grown-diamonds-stud-earrings-71902lb",
   "priceNow": 1230.99,
   "priceWas": 3820.0,
   "pctOff": 68,
   "core": "71902",
   "inStock": true,
   "createdAt": "2023-10-20T15:07:23Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1zQ1HVshVuCmz63pxj998qVNQghE5gYGo",
      "b": "https://lh3.googleusercontent.com/d/1KJQPvOVSKYRDkkd0V6pm-o32mCTZPM_x",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1t21nxe18ZNSxaSUjXNNX9ogghkka9S5-",
      "b": "https://lh3.googleusercontent.com/d/1pqbtTGWVEB12KtC9tFCZqmaRpXTCULSH",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/11Ud9P9pyvRMTCwpsefJvrkxveNewqboH",
      "b": "https://lh3.googleusercontent.com/d/1H0OgH_e1uBy9RpxA92iKHiQykOoSkbjq",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-princess-cut-lab-grown-diamonds-stud-earrings-647120.jpg?v=1698786141"
   },
   "carat": 0.6,
   "caratMax": 5.0
  },
  {
   "rank": 806,
   "id": "gid://shopify/Product/7330474426552",
   "title": "0.75-5.15 CT Emerald & Round Cut Lab Grown Diamonds - Stud Earrings",
   "url": "/products/0-75-5-15-ct-round-emerald-cut-lab-grown-diamonds-stud-earrings-71903lb",
   "handle": "0-75-5-15-ct-round-emerald-cut-lab-grown-diamonds-stud-earrings-71903lb",
   "priceNow": 1326.99,
   "priceWas": 4110.0,
   "pctOff": 68,
   "core": "71903",
   "inStock": true,
   "createdAt": "2023-10-20T09:21:05Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1MoHAZkKpLgVzFv4Z5DucDlMbRUyOZY_2",
      "b": "https://lh3.googleusercontent.com/d/1T2lNbhF469CFAnlFE2cGt-3sHGl5T9CB",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/100tdH_ZLOUzKxYA6KTd9vGt5jiqZKZVm",
      "b": "https://lh3.googleusercontent.com/d/1gqK46Ni5DNfUH9zT3A-YMBXU8gQIY8wW",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1i57JaeoKm3EiRF6flFs7XnXsfbWVE-zO",
      "b": "https://lh3.googleusercontent.com/d/1dHVhkxYZ9KeYIFMOg0fA3kRB0LAFGaNa",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/075-515-ct-round-emerald-cut-lab-grown-diamonds-stud-earrings-761864.jpg?v=1705958381"
   },
   "carat": 0.75,
   "caratMax": 5.15
  },
  {
   "rank": 807,
   "id": "gid://shopify/Product/7330474000568",
   "title": "0.60-5.00 CT Princess Cut Lab Grown Diamonds - Stud Earrings",
   "url": "/products/0-60-5-00-ct-princess-cut-lab-grown-diamonds-stud-earrings-71196lb",
   "handle": "0-60-5-00-ct-princess-cut-lab-grown-diamonds-stud-earrings-71196lb",
   "priceNow": 1230.99,
   "priceWas": 3820.0,
   "pctOff": 68,
   "core": "71196",
   "inStock": true,
   "createdAt": "2023-10-20T09:20:44Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-princess-cut-lab-grown-diamonds-stud-earrings-771525.jpg?v=1698786140",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-princess-cut-lab-grown-diamonds-stud-earrings-771525.jpg?v=1698786140",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-princess-cut-lab-grown-diamonds-stud-earrings-434928.jpg?v=1764289618",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-princess-cut-lab-grown-diamonds-stud-earrings-203585.jpg?v=1763699264"
    }
   },
   "carat": 0.6,
   "caratMax": 5.0
  },
  {
   "rank": 808,
   "id": "gid://shopify/Product/7330473410744",
   "title": "0.60-5.00 CT Round Cut Lab Grown Diamonds - Stud Earrings",
   "url": "/products/0-60-5-00-ct-round-cut-lab-grown-diamonds-stud-earrings-71898lb",
   "handle": "0-60-5-00-ct-round-cut-lab-grown-diamonds-stud-earrings-71898lb",
   "priceNow": 1327.99,
   "priceWas": 4120.0,
   "pctOff": 68,
   "core": "71898",
   "inStock": true,
   "createdAt": "2023-10-20T09:20:23Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/12ZwYA9mpAjmWYbt2lf8K9ax46Mg9vWhs",
      "b": "https://lh3.googleusercontent.com/d/12Enhcp08BDF-q42QS-n2TXZzuaKstc6x",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1ySm0tMzHAeTGAITGP9o8lE8OSf7lDQaC",
      "b": "https://lh3.googleusercontent.com/d/1IdhfEpfR6ZA-TtZTq5-ugCLsKbrpvFS5",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ttM4eEFdZSU6BXN4SLlfsBoHg_jKFl8m",
      "b": "https://lh3.googleusercontent.com/d/15OZJ0GWUS9zCGi-VnGheq3eFXBCGLJUn",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-round-cut-lab-grown-diamonds-stud-earrings-733164.jpg?v=1698786142"
   },
   "carat": 0.6,
   "caratMax": 5.0
  },
  {
   "rank": 809,
   "id": "gid://shopify/Product/7330473214136",
   "title": "0.60-5.00 CT Radiant Cut Lab Grown Diamonds - Stud Earrings",
   "url": "/products/0-60-5-00-ct-radiant-cut-lab-grown-diamonds-stud-earrings-71925lb",
   "handle": "0-60-5-00-ct-radiant-cut-lab-grown-diamonds-stud-earrings-71925lb",
   "priceNow": 1449.99,
   "priceWas": 4490.0,
   "pctOff": 68,
   "core": "71925",
   "inStock": true,
   "createdAt": "2023-10-20T09:20:09Z",
   "shape": "radiant",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1ukxEsFlGz1tvhYvv1FKeBTVEQHLYmByI",
      "b": "https://lh3.googleusercontent.com/d/1FIdCaoI0j4Bhir_4CSBxE39kaxv-L0sg",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/126uP7WUlRz5xSrBQKqZp43XDFJm7VTu-",
      "b": "https://lh3.googleusercontent.com/d/1UywoYaX6Fis_nUG7xNe1SBd9QTx5_V9j",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1UV5Pyx5lll7dvEiQvPBIs1VkTbLzAJqJ",
      "b": "https://lh3.googleusercontent.com/d/11MolfNXuzqJK1S0HYTy12qdMkxaBClKk",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-radiant-cut-lab-grown-diamonds-stud-earrings-901679.jpg?v=1698786141"
   },
   "carat": 0.6,
   "caratMax": 5.0
  },
  {
   "rank": 810,
   "id": "gid://shopify/Product/7330472951992",
   "title": "0.60-5.00 CT Radiant Cut Lab Grown Diamonds - Stud Earrings",
   "url": "/products/0-60-5-00-ct-radiant-cut-lab-grown-diamonds-stud-earrings-71924lb",
   "handle": "0-60-5-00-ct-radiant-cut-lab-grown-diamonds-stud-earrings-71924lb",
   "priceNow": 1449.99,
   "priceWas": 4490.0,
   "pctOff": 68,
   "core": "71924",
   "inStock": true,
   "createdAt": "2023-10-20T09:19:55Z",
   "shape": "radiant",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1btOaErlAkez3Su1FKG8lxVgOhkSA27_O",
      "b": "https://lh3.googleusercontent.com/d/1_ZLrW3NywL2oFesf1n9AqJie-N8k4fqY",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1wk8PjKRq_7fdPkt9M3YVMa2JL1LZByP6",
      "b": "https://lh3.googleusercontent.com/d/1C9ornZxazK8swQmrrtijFRhT9b0CKvi_",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/19rnH0wMEitD0ET-1qV-yxsDsN0YigfWX",
      "b": "https://lh3.googleusercontent.com/d/1BKrQt_0TGMqcunqjPjD1SEhr2-jrXEfw",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-radiant-cut-lab-grown-diamonds-stud-earrings-344961.jpg?v=1698786141"
   },
   "carat": 0.6,
   "caratMax": 5.0
  },
  {
   "rank": 811,
   "id": "gid://shopify/Product/7330472722616",
   "title": "0.70-5.10 CT Cushion & Round Cut Lab Grown Diamonds - Stud Earrings",
   "url": "/products/0-70-5-10-ct-round-cushion-cut-lab-grown-diamonds-stud-earrings-71923lb",
   "handle": "0-70-5-10-ct-round-cushion-cut-lab-grown-diamonds-stud-earrings-71923lb",
   "priceNow": 1478.99,
   "priceWas": 4580.0,
   "pctOff": 68,
   "core": "71923",
   "inStock": true,
   "createdAt": "2023-10-20T09:19:40Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/124xP2VuAvga0bxZBNag-IJBFKFVQRtTe",
      "b": "https://lh3.googleusercontent.com/d/1Q4SC_TE5dvQJ2yvXoGR-bKAwAl_87cGd",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1PcsQKo0IQVMK0i4QFZrh9tugmS2XPmBu",
      "b": "https://lh3.googleusercontent.com/d/1rYXPZPY-eFoz_RTvupl6S7eXRcVmYa5L",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/14p8UVnKZolt0n78B86Tp15Hie1HF58il",
      "b": "https://lh3.googleusercontent.com/d/1M2Id7Xy1tkvYqOgblpDYt7MHGCTZFXkw",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/070-510-ct-round-cushion-cut-lab-grown-diamonds-stud-earrings-298643.jpg?v=1705958527"
   },
   "carat": 0.7,
   "caratMax": 5.1
  },
  {
   "rank": 812,
   "id": "gid://shopify/Product/7330472427704",
   "title": "0.60-5.00 CT Cushion Cut Lab Grown Diamonds - Stud Earrings",
   "url": "/products/0-60-5-00-ct-cushion-cut-lab-grown-diamonds-stud-earrings-71922lb",
   "handle": "0-60-5-00-ct-cushion-cut-lab-grown-diamonds-stud-earrings-71922lb",
   "priceNow": 1152.99,
   "priceWas": 3570.0,
   "pctOff": 68,
   "core": "71922",
   "inStock": true,
   "createdAt": "2023-10-20T09:19:27Z",
   "shape": "cushion",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1d6_Iz5kRwYJd-XfoKbadPZAuLaSHe_VU",
      "b": "https://lh3.googleusercontent.com/d/1UCLOCK5BBtBBJRY1dIfZxEUsnT3EHgCF",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1ex7af9s3K_RfTJwn877UxSK_3GGRLbFr",
      "b": "https://lh3.googleusercontent.com/d/1OhlFnZYn_ZoD9x7d1gZNDRJUoe3WBWd5",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1yW7Dn7FKfJxygR6Rzs-x03KRMYJzJLgO",
      "b": "https://lh3.googleusercontent.com/d/1dSL_L_kbRQSFkWMzT74LBK3pXuNr4duK",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-cushion-cut-lab-grown-diamonds-stud-earrings-680624.jpg?v=1698786139"
   },
   "carat": 0.6,
   "caratMax": 5.0
  },
  {
   "rank": 813,
   "id": "gid://shopify/Product/7330471968952",
   "title": "0.60-5.00 CT Oval Cut Lab Grown Diamonds - Stud Earrings",
   "url": "/products/0-60-5-00-ct-oval-cut-lab-grown-diamonds-stud-earrings-71920lb",
   "handle": "0-60-5-00-ct-oval-cut-lab-grown-diamonds-stud-earrings-71920lb",
   "priceNow": 1354.99,
   "priceWas": 4200.0,
   "pctOff": 68,
   "core": "71920",
   "inStock": true,
   "createdAt": "2023-10-20T09:19:00Z",
   "shape": "oval",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/18mbdHAcHAbBydRrRKxmOkgoONRCzM9G4",
      "b": "https://lh3.googleusercontent.com/d/1vRzoqA4loYujqnZ9-xNZ8lyLakJyMzg1",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1FUCHviSIXOUTos_a7NY7WKTHiH5vxu3R",
      "b": "https://lh3.googleusercontent.com/d/1AXve1OqZyoQR6o9c9G4ERGGtY7xoBuWQ",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1g-goJ22ohCtL-yutYYeS56I0iB3p5_9f",
      "b": "https://lh3.googleusercontent.com/d/1FFHMelTu2xRJofj3QqZkSIW92Z7AQu8O",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-oval-cut-lab-grown-diamonds-stud-earrings-469015.jpg?v=1698786140"
   },
   "carat": 0.6,
   "caratMax": 5.0
  },
  {
   "rank": 814,
   "id": "gid://shopify/Product/7330471739576",
   "title": "0.60-5.00 CT Marquise Cut Lab Grown Diamonds - Stud Earrings",
   "url": "/products/0-60-5-00-ct-marquise-cut-lab-grown-diamonds-stud-earrings-71919lb",
   "handle": "0-60-5-00-ct-marquise-cut-lab-grown-diamonds-stud-earrings-71919lb",
   "priceNow": 1334.99,
   "priceWas": 4140.0,
   "pctOff": 68,
   "core": "71919",
   "inStock": true,
   "createdAt": "2023-10-20T09:18:50Z",
   "shape": "marquise",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1sH89lNdpQOhOI0KFGynbU19t89ZRSrpj",
      "b": "https://lh3.googleusercontent.com/d/1GBNUpKOoUn_MHojOt4yjC37KN7IYQbo2",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1QxBo8SdIwWf47DK3i2OgoIYl2_WtB4wX",
      "b": "https://lh3.googleusercontent.com/d/1Qm1UU3BsiNKOfOILmq-TRqgxl23IB7sN",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1QWqRgbdXTQCcnOn5SN8uXjDYUrgKat8w",
      "b": "https://lh3.googleusercontent.com/d/1M1jcJMV5vnMD8a2_KGi5Hw5sIcuzXGrw",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-marquise-cut-lab-grown-diamonds-stud-earrings-335331.jpg?v=1698786140"
   },
   "carat": 0.6,
   "caratMax": 5.0
  },
  {
   "rank": 815,
   "id": "gid://shopify/Product/7330471542968",
   "title": "0.60-5.00 CT Marquise Cut Lab Grown Diamonds - Stud Earrings",
   "url": "/products/0-60-5-00-ct-marquise-cut-lab-grown-diamonds-stud-earrings-71918lb",
   "handle": "0-60-5-00-ct-marquise-cut-lab-grown-diamonds-stud-earrings-71918lb",
   "priceNow": 1829.99,
   "priceWas": 5670.0,
   "pctOff": 68,
   "core": "71918",
   "inStock": true,
   "createdAt": "2023-10-20T09:18:38Z",
   "shape": "marquise",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/13My_7ZeqiBQ4OMaZWftCne3u5p7oKs5F",
      "b": "https://lh3.googleusercontent.com/d/1PYkGTXVvnMI0s1-YClLXRr7ImVPX9rx1",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1C_lY2EdQvFZyqIF1jC2tGtBz0FtNfpS4",
      "b": "https://lh3.googleusercontent.com/d/1SfHUuPZDQNRANhnQL7xx398Mfpv21p-Q",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1JQg9QlJHqkIQxOSWLLuHPcEPmQFMtRRs",
      "b": "https://lh3.googleusercontent.com/d/1ykFZeFRk2ubj3AV63NLeMwNvaxgqZpyf",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-marquise-cut-lab-grown-diamonds-stud-earrings-482855.jpg?v=1698786139"
   },
   "carat": 0.6,
   "caratMax": 5.0
  },
  {
   "rank": 816,
   "id": "gid://shopify/Product/7328611958968",
   "title": "0.80-5.20 CT Oval & Round Cut Lab Grown Diamonds - Stud Earrings",
   "url": "/products/0-80-5-20-ct-round-oval-cut-lab-grown-diamonds-stud-earrings-71917lb",
   "handle": "0-80-5-20-ct-round-oval-cut-lab-grown-diamonds-stud-earrings-71917lb",
   "priceNow": 1332.99,
   "priceWas": 4130.0,
   "pctOff": 68,
   "core": "71917",
   "inStock": true,
   "createdAt": "2023-10-19T09:12:21Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1uPuIe0xItM8vB-s2AYk2L5PY4PUF18Hi",
      "b": "https://lh3.googleusercontent.com/d/1CnjtHuotIqkgTXg4KVGdpZjqoxrMjN3a",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1nxuOe2lj5iyqW9xQDtHXDIGiRGAsR38E",
      "b": "https://lh3.googleusercontent.com/d/1ZjPWENp9oA3a2jwrTo8pv0c0xaZmQhJn",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1V0ema__Lq2fOzAUmL_yaCFJtXYmRpoKR",
      "b": "https://lh3.googleusercontent.com/d/1kyTYML15feHnKaGtzboQtCZi5k2RUvIa",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/080-520-ct-round-oval-cut-lab-grown-diamonds-stud-earrings-974320.jpg?v=1699393723"
   },
   "carat": 0.8,
   "caratMax": 5.2
  },
  {
   "rank": 817,
   "id": "gid://shopify/Product/7328611139768",
   "title": "0.60-5.00 CT Emerald Cut Lab Grown Diamonds - Stud Earrings",
   "url": "/products/0-60-5-00-ct-emerald-cut-lab-grown-diamonds-stud-earrings-71904lb",
   "handle": "0-60-5-00-ct-emerald-cut-lab-grown-diamonds-stud-earrings-71904lb",
   "priceNow": 1602.99,
   "priceWas": 4970.0,
   "pctOff": 68,
   "core": "71904",
   "inStock": true,
   "createdAt": "2023-10-19T09:12:07Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1XAeyziXNDr6re7e31_Sz_hJIyeYPA9kM",
      "b": "https://lh3.googleusercontent.com/d/1iRdKwdoqslbOmItCHaZXt8drLkDiAKdM",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1RHHrmVRIAw8IZvVjhCVOueSdncBCdxdu",
      "b": "https://lh3.googleusercontent.com/d/1zSaE3dPhQzAJeKKmNVmYhVe5NrZeTDiM",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1dORG62ig3BNMV2YhNdVkV-ktTlsunpVE",
      "b": "https://lh3.googleusercontent.com/d/1hS72oNViVbGUPyE8VcloyEWxuZqvlL9F",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-emerald-cut-lab-grown-diamonds-stud-earrings-480948.jpg?v=1698786139"
   },
   "carat": 0.6,
   "caratMax": 5.0
  },
  {
   "rank": 818,
   "id": "gid://shopify/Product/7328608452792",
   "title": "0.72-5.12 CT Pear & Round Cut Lab Grown Diamonds - Stud Earrings",
   "url": "/products/0-72-5-12-ct-round-pear-cut-lab-grown-diamonds-stud-earrings-71936lb",
   "handle": "0-72-5-12-ct-round-pear-cut-lab-grown-diamonds-stud-earrings-71936lb",
   "priceNow": 1518.99,
   "priceWas": 4710.0,
   "pctOff": 68,
   "core": "71936",
   "inStock": true,
   "createdAt": "2023-10-19T09:11:22Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1H8OMnIXfVTwG4nGGWdq9WAgdUAlqcomv",
      "b": "https://lh3.googleusercontent.com/d/1ZAGQd-NaTxBBDvcsoOW_VeDvowp1AX3A",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1X4EDcmfLnXmazTCGraPW72rE0P6KAKdN",
      "b": "https://lh3.googleusercontent.com/d/1OrBP8XaO9QeiRjtDYYD0nFQWiIiSXx_B",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1TMMN39MtFTT-cMJmIcpsbwG-OYUg8rkf",
      "b": "https://lh3.googleusercontent.com/d/1la_kG1PMlcOHUWA6hOtZT0ovJJmD0gMc",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/072-512-ct-round-pear-cut-lab-grown-diamonds-stud-earrings-717788.jpg?v=1699392421"
   },
   "carat": 0.72,
   "caratMax": 5.12
  },
  {
   "rank": 819,
   "id": "gid://shopify/Product/7328607862968",
   "title": "0.60-5.00 CT Radiant Cut Lab Grown Diamonds - Stud Earrings",
   "url": "/products/0-60-5-00-ct-radiant-cut-lab-grown-diamonds-stud-earrings-15416lb",
   "handle": "0-60-5-00-ct-radiant-cut-lab-grown-diamonds-stud-earrings-15416lb",
   "priceNow": 861.99,
   "priceWas": 2501.0,
   "pctOff": 66,
   "core": "15416",
   "inStock": true,
   "createdAt": "2023-10-19T09:11:13Z",
   "shape": "radiant",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-radiant-cut-lab-grown-diamonds-stud-earrings-938814.jpg?v=1698786141",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-radiant-cut-lab-grown-diamonds-stud-earrings-938814.jpg?v=1698786141",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-radiant-cut-lab-grown-diamonds-stud-earrings-610561.jpg?v=1698786141",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-radiant-cut-lab-grown-diamonds-stud-earrings-396533.jpg?v=1698943728"
    }
   },
   "carat": 0.6,
   "caratMax": 5.0
  },
  {
   "rank": 820,
   "id": "gid://shopify/Product/7328607404216",
   "title": "0.60-5.00 CT Princess Cut Lab Grown Diamonds - Stud Earrings",
   "url": "/products/0-60-5-00-ct-princess-cut-lab-grown-diamonds-stud-earrings-16201lb",
   "handle": "0-60-5-00-ct-princess-cut-lab-grown-diamonds-stud-earrings-16201lb",
   "priceNow": 1230.99,
   "priceWas": 3820.0,
   "pctOff": 68,
   "core": "16201",
   "inStock": true,
   "createdAt": "2023-10-19T09:10:59Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/18jVh9gWdx-0JW8lPNM7825_FU67IVZoQ",
      "b": "https://lh3.googleusercontent.com/d/15rpVMQCDYeR2AZZHA9oWmRmjwYmgjXVp",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1NYhq05prQWNMAomsmu8VtKE1Rx7VT73l",
      "b": "https://lh3.googleusercontent.com/d/1zqbJh95Z3W_Ky8XMz2ztyWgnOnNhE37u",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1FyrecZUtYpi810upt0Ey11nQzA3-AwYI",
      "b": "https://lh3.googleusercontent.com/d/1PHpWl_yjAT0s_mvCvIoko10Dh8AAuNyH",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-princess-cut-lab-grown-diamonds-stud-earrings-506754.jpg?v=1698786140"
   },
   "carat": 0.6,
   "caratMax": 5.0
  },
  {
   "rank": 821,
   "id": "gid://shopify/Product/7328606683320",
   "title": "0.60-5.00 CT Round Cut Lab Grown Diamonds - Stud Earrings",
   "url": "/products/0-60-5-00-ct-round-cut-lab-grown-diamonds-stud-earrings-16200lb",
   "handle": "0-60-5-00-ct-round-cut-lab-grown-diamonds-stud-earrings-16200lb",
   "priceNow": 1327.99,
   "priceWas": 4120.0,
   "pctOff": 68,
   "core": "16200",
   "inStock": true,
   "createdAt": "2023-10-19T09:10:44Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-round-cut-lab-grown-diamonds-stud-earrings-367558.jpg?v=1698786142",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-round-cut-lab-grown-diamonds-stud-earrings-367558.jpg?v=1698786142",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-round-cut-lab-grown-diamonds-stud-earrings-341921.jpg?v=1763699265",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-round-cut-lab-grown-diamonds-stud-earrings-908958.jpg?v=1763699266"
    }
   },
   "carat": 0.6,
   "caratMax": 5.0
  },
  {
   "rank": 822,
   "id": "gid://shopify/Product/7328605077688",
   "title": "0.60-5.00 CT Princess Cut Lab Grown Diamonds - Stud Earrings",
   "url": "/products/0-60-5-00-ct-princess-cut-lab-grown-diamonds-stud-earrings-15420lb",
   "handle": "0-60-5-00-ct-princess-cut-lab-grown-diamonds-stud-earrings-15420lb",
   "priceNow": 1092.99,
   "priceWas": 3390.0,
   "pctOff": 68,
   "core": "15420",
   "inStock": true,
   "createdAt": "2023-10-19T09:09:59Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1rpCIbSeCR59c2DRp5oPq3pEsNPeXB_A8",
      "b": "https://lh3.googleusercontent.com/d/1NKYXmpRqG0qPW5Haei6iYjvfWWzD0vJV",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/13lamdx3ZbCPrEEKqog7h2K3WpaFsi09_",
      "b": "https://lh3.googleusercontent.com/d/1MJXCbtrjqwAvdOJc5Cbynq7zMSnGaXzf",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1-WnhCNctekEX58xhb53uRyaRVd2fpGpC",
      "b": "https://lh3.googleusercontent.com/d/1hPjtFJhrqVnH-lmuK1iYOFOY0spHFIRN",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-princess-cut-lab-grown-diamonds-stud-earrings-925030.jpg?v=1698786140"
   },
   "carat": 0.6,
   "caratMax": 5.0
  },
  {
   "rank": 823,
   "id": "gid://shopify/Product/7328602980536",
   "title": "0.60-5.00 CT Radiant Cut Lab Grown Diamonds - Stud Earrings",
   "url": "/products/0-60-5-00-ct-radiant-cut-lab-grown-diamonds-stud-earrings-71926lb",
   "handle": "0-60-5-00-ct-radiant-cut-lab-grown-diamonds-stud-earrings-71926lb",
   "priceNow": 1449.99,
   "priceWas": 4490.0,
   "pctOff": 68,
   "core": "71926",
   "inStock": true,
   "createdAt": "2023-10-19T09:09:19Z",
   "shape": "radiant",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1hYbHYqycDXFSlhOjLznqjrg0vQ4AsLnr",
      "b": "https://lh3.googleusercontent.com/d/13HB_mVjV0D6HJdPvBi8q5-6HwMS_vEMc",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1onj3NcdO3Q3aAosI4Y6oKxE_L3on5CLb",
      "b": "https://lh3.googleusercontent.com/d/19RBqu0841_khyatPHFQtKCX5MBaX-H-X",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1SVCbPZHtRJOXRsqLXjn_AgUalKZOGN57",
      "b": "https://lh3.googleusercontent.com/d/1LINVelOHjgG49OmyLDpI2LcuD9jT-ns0",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-radiant-cut-lab-grown-diamonds-stud-earrings-729865.jpg?v=1698786141"
   },
   "carat": 0.6,
   "caratMax": 5.0
  },
  {
   "rank": 824,
   "id": "gid://shopify/Product/7328602226872",
   "title": "0.80-5.20 CT Ascher & Round Cut Lab Grown Diamonds - Stud Earrings",
   "url": "/products/0-80-5-20-ct-round-ascher-cut-lab-grown-diamonds-stud-earrings-71935lb",
   "handle": "0-80-5-20-ct-round-ascher-cut-lab-grown-diamonds-stud-earrings-71935lb",
   "priceNow": 1246.99,
   "priceWas": 3870.0,
   "pctOff": 68,
   "core": "71935",
   "inStock": true,
   "createdAt": "2023-10-19T09:09:05Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1PnENigtvoEnKUIxQbcD7u-3HnSnrlwBd",
      "b": "https://lh3.googleusercontent.com/d/14WcTn6oerRjaXpgLxBkIY00q_rKBgr41",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1RTBIctEb5VcrGk_jBbRPYP62nDAVpzQg",
      "b": "https://lh3.googleusercontent.com/d/1CLWHpZ1T_WYu3kEdQOgCRV-LpTTtJ55L",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1JQnKvzMnfxApZkTyz6YbFzGkN3zvh8y6",
      "b": "https://lh3.googleusercontent.com/d/1BmVAe14BIXu0z87n4HsDWtXUkGlZimTE",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/080-520-ct-round-ascher-cut-lab-grown-diamonds-stud-earrings-532891.jpg?v=1699393723"
   },
   "carat": 0.8,
   "caratMax": 5.2
  },
  {
   "rank": 825,
   "id": "gid://shopify/Product/7328601637048",
   "title": "0.60-5.00 CT Ascher Cut Lab Grown Diamonds - Stud Earrings",
   "url": "/products/0-60-5-00-ct-ascher-cut-lab-grown-diamonds-stud-earrings-71934lb",
   "handle": "0-60-5-00-ct-ascher-cut-lab-grown-diamonds-stud-earrings-71934lb",
   "priceNow": 1230.99,
   "priceWas": 3820.0,
   "pctOff": 68,
   "core": "71934",
   "inStock": true,
   "createdAt": "2023-10-19T09:08:52Z",
   "shape": "asscher",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1zakIb8Y5ZkMx4LG1W4DEolNSV8N29qg6",
      "b": "https://lh3.googleusercontent.com/d/1R9yEDdRD6ptOuOGk0qqZ5mLm3drxCYi4",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1YD8sesGwyKo4BYuJXH71ajJlYbHy6WMo",
      "b": "https://lh3.googleusercontent.com/d/1vi2Yi-FATNvRRvu6m6XUBGmm3JhLiomY",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1VCjbwIjdbendYVMnLCEaTIeDdNV2_YXE",
      "b": "https://lh3.googleusercontent.com/d/13puapZmuVn0iVlEYvHq8ya9Imfl9bx7C",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-ascher-cut-lab-grown-diamonds-stud-earrings-103756.jpg?v=1698786139"
   },
   "carat": 0.6,
   "caratMax": 5.0
  },
  {
   "rank": 826,
   "id": "gid://shopify/Product/7328601047224",
   "title": "0.60-5.00 CT Ascher Cut Lab Grown Diamonds - Stud Earrings",
   "url": "/products/0-60-5-00-ct-ascher-cut-lab-grown-diamonds-stud-earrings-71933lb",
   "handle": "0-60-5-00-ct-ascher-cut-lab-grown-diamonds-stud-earrings-71933lb",
   "priceNow": 1230.99,
   "priceWas": 3820.0,
   "pctOff": 68,
   "core": "71933",
   "inStock": true,
   "createdAt": "2023-10-19T09:08:39Z",
   "shape": "asscher",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1LyjJQpB0GEme6FWCikDpx8H_WRzVB7hx",
      "b": "https://lh3.googleusercontent.com/d/1dsxgW6LbYpbLmIw4RhUlPcT42oKyp3_D",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1Dmqs5h2iHMHtUGSWYMREwfh_Coy9XzgV",
      "b": "https://lh3.googleusercontent.com/d/1YlcilXrcCW5sYO3K0XxrvDkWdFmYGYE4",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1XtJvQGi7NxSvD2PTrgPHEOuzn5QRLZVK",
      "b": "https://lh3.googleusercontent.com/d/12NuyFvkL7ja8TgYwgUyA1728_UyLm7cS",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-500-ct-ascher-cut-lab-grown-diamonds-stud-earrings-187059.jpg?v=1698786139"
   },
   "carat": 0.6,
   "caratMax": 5.0
  },
  {
   "rank": 827,
   "id": "gid://shopify/Product/7305752346808",
   "title": "2.05-7.55 CT Princess Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/2-05-4-55-ct-princess-cut-lab-grown-diamonds-bridal-set-15719lb",
   "handle": "2-05-4-55-ct-princess-cut-lab-grown-diamonds-bridal-set-15719lb",
   "priceNow": 3067.99,
   "priceWas": 9510.0,
   "pctOff": 68,
   "core": "15719",
   "inStock": true,
   "createdAt": "2023-08-12T13:45:44Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1lFqVBfXHFamD-G8F__Q46hQbRZApcamE",
      "b": "https://lh3.googleusercontent.com/d/1_lQdBLeWWLaXQfhbH4SPjzu3aMQxeUyj",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1uEs-4uyUDUH7UaNS1zV7PsYaQiozVlGP",
      "b": "https://lh3.googleusercontent.com/d/1TqmL9l5ZzzGGE6EBMRcSSXZbJxbJN8it",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1opHi_m7sy52J-AeL5gOnxgJ7Zh0nmJGL",
      "b": "https://lh3.googleusercontent.com/d/18hMHF8iMMwrvwIoc-DynJBB9H0yBH1k8",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/205-455-ct-princess-cut-lab-grown-diamonds-bridal-set-922505.jpg?v=1714758787"
   },
   "carat": 2.05,
   "caratMax": 7.55
  },
  {
   "rank": 828,
   "id": "gid://shopify/Product/7305752215736",
   "title": "1.90-7.40 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-90-4-40-ct-round-cut-lab-grown-diamonds-bridal-set-21072lb",
   "handle": "1-90-4-40-ct-round-cut-lab-grown-diamonds-bridal-set-21072lb",
   "priceNow": 2611.99,
   "priceWas": 8100.0,
   "pctOff": 68,
   "core": "21072",
   "inStock": true,
   "createdAt": "2023-08-12T13:45:31Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/190-440-ct-round-cut-lab-grown-diamonds-bridal-set-466302.jpg?v=1714758837",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/190-440-ct-round-cut-lab-grown-diamonds-bridal-set-466302.jpg?v=1714758837",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/190-440-ct-round-cut-lab-grown-diamonds-bridal-set-122626.jpg?v=1763699332",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/190-440-ct-round-cut-lab-grown-diamonds-bridal-set-575231.jpg?v=1763699332"
    }
   },
   "carat": 1.9,
   "caratMax": 7.4
  },
  {
   "rank": 829,
   "id": "gid://shopify/Product/7305752051896",
   "title": "1.25-6.75 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-25-3-75-ct-round-cut-lab-grown-diamonds-bridal-set-21070lb",
   "handle": "1-25-3-75-ct-round-cut-lab-grown-diamonds-bridal-set-21070lb",
   "priceNow": 1496.99,
   "priceWas": 4640.0,
   "pctOff": 68,
   "core": "21070",
   "inStock": true,
   "createdAt": "2023-08-12T13:45:17Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/125-375-ct-round-cut-lab-grown-diamonds-bridal-set-477161.jpg?v=1714758939",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/125-375-ct-round-cut-lab-grown-diamonds-bridal-set-477161.jpg?v=1714758939",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/125-375-ct-round-cut-lab-grown-diamonds-bridal-set-287727.jpg?v=1763699331",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/125-375-ct-round-cut-lab-grown-diamonds-bridal-set-581090.jpg?v=1763699332"
    }
   },
   "carat": 1.25,
   "caratMax": 6.75
  },
  {
   "rank": 830,
   "id": "gid://shopify/Product/7305751855288",
   "title": "1.25-6.75 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-25-3-75-ct-round-cut-lab-grown-diamonds-bridal-set-21066lb",
   "handle": "1-25-3-75-ct-round-cut-lab-grown-diamonds-bridal-set-21066lb",
   "priceNow": 1884.99,
   "priceWas": 5840.0,
   "pctOff": 68,
   "core": "21066",
   "inStock": true,
   "createdAt": "2023-08-12T13:44:42Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/125-375-ct-round-cut-lab-grown-diamonds-bridal-set-326372.jpg?v=1714759174",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/125-375-ct-round-cut-lab-grown-diamonds-bridal-set-326372.jpg?v=1714759174",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/125-375-ct-round-cut-lab-grown-diamonds-bridal-set-593817.jpg?v=1763699332",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/125-375-ct-round-cut-lab-grown-diamonds-bridal-set-950888.jpg?v=1763699332"
    }
   },
   "carat": 1.25,
   "caratMax": 6.75
  },
  {
   "rank": 831,
   "id": "gid://shopify/Product/7305751822520",
   "title": "1.20-6.70 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-20-3-70-ct-round-cut-lab-grown-diamonds-bridal-set-21065lb",
   "handle": "1-20-3-70-ct-round-cut-lab-grown-diamonds-bridal-set-21065lb",
   "priceNow": 2110.99,
   "priceWas": 6540.0,
   "pctOff": 68,
   "core": "21065",
   "inStock": true,
   "createdAt": "2023-08-12T13:44:30Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/120-370-ct-round-cut-lab-grown-diamonds-bridal-set-515169.jpg?v=1714759214",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/120-370-ct-round-cut-lab-grown-diamonds-bridal-set-515169.jpg?v=1714759214",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/120-370-ct-round-cut-lab-grown-diamonds-bridal-set-111760.jpg?v=1763699332",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/120-370-ct-round-cut-lab-grown-diamonds-bridal-set-459600.jpg?v=1763699332"
    }
   },
   "carat": 1.2,
   "caratMax": 6.7
  },
  {
   "rank": 832,
   "id": "gid://shopify/Product/7305751789752",
   "title": "1.10-6.60 CT Emerald & Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-10-3-60-ct-round-emerald-cut-lab-grown-diamonds-bridal-set-21064lb",
   "handle": "1-10-3-60-ct-round-emerald-cut-lab-grown-diamonds-bridal-set-21064lb",
   "priceNow": 2002.99,
   "priceWas": 6210.0,
   "pctOff": 68,
   "core": "21064",
   "inStock": true,
   "createdAt": "2023-08-12T13:44:18Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/110-360-ct-round-emerald-cut-lab-grown-diamonds-bridal-set-612874.jpg?v=1714759762",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/110-360-ct-round-emerald-cut-lab-grown-diamonds-bridal-set-612874.jpg?v=1714759762",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/110-360-ct-round-emerald-cut-lab-grown-diamonds-bridal-set-199139.jpg?v=1763699332",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/110-360-ct-round-emerald-cut-lab-grown-diamonds-bridal-set-557439.jpg?v=1763699332"
    }
   },
   "carat": 1.1,
   "caratMax": 6.6
  },
  {
   "rank": 833,
   "id": "gid://shopify/Product/7305751724216",
   "title": "1.90-7.40 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-90-4-40-ct-princess-round-cut-lab-grown-diamonds-bridal-set-21062lb",
   "handle": "1-90-4-40-ct-princess-round-cut-lab-grown-diamonds-bridal-set-21062lb",
   "priceNow": 2776.99,
   "priceWas": 8610.0,
   "pctOff": 68,
   "core": "21062",
   "inStock": true,
   "createdAt": "2023-08-12T13:43:53Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/190-440-ct-princess-round-cut-lab-grown-diamonds-bridal-set-580066.jpg?v=1714759909",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/190-440-ct-princess-round-cut-lab-grown-diamonds-bridal-set-580066.jpg?v=1714759909",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/190-440-ct-princess-round-cut-lab-grown-diamonds-bridal-set-571171.jpg?v=1763699333",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/190-440-ct-princess-round-cut-lab-grown-diamonds-bridal-set-316480.jpg?v=1763699333"
    }
   },
   "carat": 1.9,
   "caratMax": 7.4
  },
  {
   "rank": 834,
   "id": "gid://shopify/Product/7305710731448",
   "title": "0.70-6.20 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/0-70-3-20-ct-round-ascher-cut-lab-grown-diamonds-bridal-set-21060lb",
   "handle": "0-70-3-20-ct-round-ascher-cut-lab-grown-diamonds-bridal-set-21060lb",
   "priceNow": 1731.99,
   "priceWas": 5370.0,
   "pctOff": 68,
   "core": "21060",
   "inStock": true,
   "createdAt": "2023-08-11T22:38:20Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/070-320-ct-round-ascher-cut-lab-grown-diamonds-bridal-set-664696.jpg?v=1714759949",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/070-320-ct-round-ascher-cut-lab-grown-diamonds-bridal-set-664696.jpg?v=1714759949",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/070-320-ct-round-ascher-cut-lab-grown-diamonds-bridal-set-883495.jpg?v=1763699363",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/070-320-ct-round-ascher-cut-lab-grown-diamonds-bridal-set-981007.jpg?v=1763699363"
    }
   },
   "carat": 0.7,
   "caratMax": 6.2
  },
  {
   "rank": 835,
   "id": "gid://shopify/Product/7305710600376",
   "title": "0.70-6.20 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/0-70-3-20-ct-round-princess-cut-diamonds-bridal-set-21058lb",
   "handle": "0-70-3-20-ct-round-princess-cut-diamonds-bridal-set-21058lb",
   "priceNow": 1803.99,
   "priceWas": 5590.0,
   "pctOff": 68,
   "core": "21058",
   "inStock": true,
   "createdAt": "2023-08-11T22:37:59Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/070-320-ct-round-princess-cut-diamonds-bridal-set-979691.jpg?v=1714760124",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/070-320-ct-round-princess-cut-diamonds-bridal-set-979691.jpg?v=1714760124",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/070-320-ct-round-princess-cut-diamonds-bridal-set-550546.jpg?v=1763699363",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/070-320-ct-round-princess-cut-diamonds-bridal-set-667434.jpg?v=1763699363"
    }
   },
   "carat": 0.7,
   "caratMax": 6.2
  },
  {
   "rank": 836,
   "id": "gid://shopify/Product/7305710502072",
   "title": "0.95-6.45 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/0-95-3-45-ct-round-princess-cut-lab-grown-diamonds-bridal-set-21057lb",
   "handle": "0-95-3-45-ct-round-princess-cut-lab-grown-diamonds-bridal-set-21057lb",
   "priceNow": 2047.99,
   "priceWas": 6350.0,
   "pctOff": 68,
   "core": "21057",
   "inStock": true,
   "createdAt": "2023-08-11T22:37:48Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/095-345-ct-round-princess-cut-lab-grown-diamonds-bridal-set-672592.jpg?v=1714760161",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/095-345-ct-round-princess-cut-lab-grown-diamonds-bridal-set-672592.jpg?v=1714760161",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/095-345-ct-round-princess-cut-lab-grown-diamonds-bridal-set-826029.jpg?v=1763699363",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/095-345-ct-round-princess-cut-lab-grown-diamonds-bridal-set-146916.jpg?v=1763699363"
    }
   },
   "carat": 0.95,
   "caratMax": 6.45
  },
  {
   "rank": 837,
   "id": "gid://shopify/Product/7305710436536",
   "title": "0.80-6.30 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/0-80-3-30-ct-round-princess-cut-lab-grown-diamonds-bridal-set-21056lb",
   "handle": "0-80-3-30-ct-round-princess-cut-lab-grown-diamonds-bridal-set-21056lb",
   "priceNow": 2136.99,
   "priceWas": 6620.0,
   "pctOff": 68,
   "core": "21056",
   "inStock": true,
   "createdAt": "2023-08-11T22:37:37Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/080-330-ct-round-princess-cut-lab-grown-diamonds-bridal-set-642996.jpg?v=1714760198",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/080-330-ct-round-princess-cut-lab-grown-diamonds-bridal-set-642996.jpg?v=1714760198",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/080-330-ct-round-princess-cut-lab-grown-diamonds-bridal-set-143985.jpg?v=1763699363",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/080-330-ct-round-princess-cut-lab-grown-diamonds-bridal-set-160580.jpg?v=1763699363"
    }
   },
   "carat": 0.8,
   "caratMax": 6.3
  },
  {
   "rank": 838,
   "id": "gid://shopify/Product/7305710371000",
   "title": "1.10-6.60 CT Princess Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-10-3-60-ct-princess-cut-lab-grown-diamonds-bridal-set-21055lb",
   "handle": "1-10-3-60-ct-princess-cut-lab-grown-diamonds-bridal-set-21055lb",
   "priceNow": 2220.99,
   "priceWas": 6890.0,
   "pctOff": 68,
   "core": "21055",
   "inStock": true,
   "createdAt": "2023-08-11T22:37:26Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/110-360-ct-princess-cut-lab-grown-diamonds-bridal-set-545567.jpg?v=1714760232",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/110-360-ct-princess-cut-lab-grown-diamonds-bridal-set-545567.jpg?v=1714760232",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/110-360-ct-princess-cut-lab-grown-diamonds-bridal-set-832483.jpg?v=1763699363",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/110-360-ct-princess-cut-lab-grown-diamonds-bridal-set-831101.jpg?v=1763699363"
    }
   },
   "carat": 1.1,
   "caratMax": 6.6
  },
  {
   "rank": 839,
   "id": "gid://shopify/Product/7305710207160",
   "title": "0.75-6.25 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/0-75-3-25-ct-round-cut-lab-grown-diamonds-bridal-set-21053lb",
   "handle": "0-75-3-25-ct-round-cut-lab-grown-diamonds-bridal-set-21053lb",
   "priceNow": 1746.99,
   "priceWas": 5420.0,
   "pctOff": 68,
   "core": "21053",
   "inStock": true,
   "createdAt": "2023-08-11T22:37:12Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/075-325-ct-round-cut-lab-grown-diamonds-bridal-set-546751.jpg?v=1714760306",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/075-325-ct-round-cut-lab-grown-diamonds-bridal-set-546751.jpg?v=1714760306",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/075-325-ct-round-cut-lab-grown-diamonds-bridal-set-420014.jpg?v=1763699364",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/075-325-ct-round-cut-lab-grown-diamonds-bridal-set-772999.jpg?v=1763699363"
    }
   },
   "carat": 0.75,
   "caratMax": 6.25
  },
  {
   "rank": 840,
   "id": "gid://shopify/Product/7305710108856",
   "title": "0.75-6.25 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/0-75-3-25-ct-round-cut-lab-grown-diamonds-bridal-set-21052lb",
   "handle": "0-75-3-25-ct-round-cut-lab-grown-diamonds-bridal-set-21052lb",
   "priceNow": 1746.99,
   "priceWas": 5420.0,
   "pctOff": 68,
   "core": "21052",
   "inStock": true,
   "createdAt": "2023-08-11T22:37:00Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/075-325-ct-round-cut-lab-grown-diamonds-bridal-set-682416.jpg?v=1714760343",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/075-325-ct-round-cut-lab-grown-diamonds-bridal-set-682416.jpg?v=1714760343",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/075-325-ct-round-cut-lab-grown-diamonds-bridal-set-663063.jpg?v=1763699364",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/075-325-ct-round-cut-lab-grown-diamonds-bridal-set-479428.jpg?v=1763699363"
    }
   },
   "carat": 0.75,
   "caratMax": 6.25
  },
  {
   "rank": 841,
   "id": "gid://shopify/Product/7305709977784",
   "title": "0.70-6.20 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/0-70-3-20-ct-round-cut-lab-grown-diamonds-bridal-set-21051lb",
   "handle": "0-70-3-20-ct-round-cut-lab-grown-diamonds-bridal-set-21051lb",
   "priceNow": 1985.99,
   "priceWas": 6160.0,
   "pctOff": 68,
   "core": "21051",
   "inStock": true,
   "createdAt": "2023-08-11T22:36:49Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/070-320-ct-round-cut-lab-grown-diamonds-bridal-set-669576.jpg?v=1714760381",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/070-320-ct-round-cut-lab-grown-diamonds-bridal-set-669576.jpg?v=1714760381",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/070-320-ct-round-cut-lab-grown-diamonds-bridal-set-445298.jpg?v=1763699363",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/070-320-ct-round-cut-lab-grown-diamonds-bridal-set-265858.jpg?v=1763699363"
    }
   },
   "carat": 0.7,
   "caratMax": 6.2
  },
  {
   "rank": 842,
   "id": "gid://shopify/Product/7305709781176",
   "title": "0.90-6.40 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/0-90-3-40-ct-round-cushion-cut-lab-grown-diamonds-bridal-set-21049lb",
   "handle": "0-90-3-40-ct-round-cushion-cut-lab-grown-diamonds-bridal-set-21049lb",
   "priceNow": 2035.99,
   "priceWas": 6310.0,
   "pctOff": 68,
   "core": "21049",
   "inStock": true,
   "createdAt": "2023-08-11T22:36:29Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/090-340-ct-round-cushion-cut-lab-grown-diamonds-bridal-set-613021.jpg?v=1714760429",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/090-340-ct-round-cushion-cut-lab-grown-diamonds-bridal-set-613021.jpg?v=1714760429",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/090-340-ct-round-cushion-cut-lab-grown-diamonds-bridal-set-713099.jpg?v=1763699363",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/090-340-ct-round-cushion-cut-lab-grown-diamonds-bridal-set-946716.jpg?v=1763699363"
    }
   },
   "carat": 0.9,
   "caratMax": 6.4
  },
  {
   "rank": 843,
   "id": "gid://shopify/Product/7305447014584",
   "title": "0.75-6.25 CT Radiant & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/0-75-3-25-ct-round-radiant-cut-lab-grown-diamonds-bridal-set-21047lb",
   "handle": "0-75-3-25-ct-round-radiant-cut-lab-grown-diamonds-bridal-set-21047lb",
   "priceNow": 1794.99,
   "priceWas": 5560.0,
   "pctOff": 68,
   "core": "21047",
   "inStock": true,
   "createdAt": "2023-08-10T22:57:18Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/075-325-ct-round-radiant-cut-lab-grown-diamonds-bridal-set-707531.jpg?v=1714760513",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/075-325-ct-round-radiant-cut-lab-grown-diamonds-bridal-set-707531.jpg?v=1714760513",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/075-325-ct-round-radiant-cut-lab-grown-diamonds-bridal-set-257444.jpg?v=1763699364",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/075-325-ct-round-radiant-cut-lab-grown-diamonds-bridal-set-408762.jpg?v=1763699364"
    }
   },
   "carat": 0.75,
   "caratMax": 6.25
  },
  {
   "rank": 844,
   "id": "gid://shopify/Product/7305446981816",
   "title": "0.75-6.25 CT Pear & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/0-75-3-25-ct-round-pear-cut-lab-grown-diamonds-bridal-set-21046lb",
   "handle": "0-75-3-25-ct-round-pear-cut-lab-grown-diamonds-bridal-set-21046lb",
   "priceNow": 1747.99,
   "priceWas": 5420.0,
   "pctOff": 68,
   "core": "21046",
   "inStock": true,
   "createdAt": "2023-08-10T22:57:06Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/075-325-ct-round-pear-cut-lab-grown-diamonds-bridal-set-396282.jpg?v=1714760550",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/075-325-ct-round-pear-cut-lab-grown-diamonds-bridal-set-396282.jpg?v=1714760550",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/075-325-ct-round-pear-cut-lab-grown-diamonds-bridal-set-809388.jpg?v=1763699364",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/075-325-ct-round-pear-cut-lab-grown-diamonds-bridal-set-875172.jpg?v=1763699364"
    }
   },
   "carat": 0.75,
   "caratMax": 6.25
  },
  {
   "rank": 845,
   "id": "gid://shopify/Product/7305446916280",
   "title": "0.65-6.15 CT Pear & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/0-65-3-15-ct-round-pear-cut-lab-grown-diamonds-bridal-set-21045lb",
   "handle": "0-65-3-15-ct-round-pear-cut-lab-grown-diamonds-bridal-set-21045lb",
   "priceNow": 2192.99,
   "priceWas": 6800.0,
   "pctOff": 68,
   "core": "21045",
   "inStock": true,
   "createdAt": "2023-08-10T22:56:53Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/065-315-ct-round-pear-cut-lab-grown-diamonds-bridal-set-249025.jpg?v=1714760589",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/065-315-ct-round-pear-cut-lab-grown-diamonds-bridal-set-249025.jpg?v=1714760589",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/065-315-ct-round-pear-cut-lab-grown-diamonds-bridal-set-884969.jpg?v=1763699364",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/065-315-ct-round-pear-cut-lab-grown-diamonds-bridal-set-659852.jpg?v=1763699364"
    }
   },
   "carat": 0.65,
   "caratMax": 6.15
  },
  {
   "rank": 846,
   "id": "gid://shopify/Product/7305446883512",
   "title": "0.70-6.20 CT Pear & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/0-70-3-20-ct-round-pear-cut-lab-grown-diamonds-bridal-set-21044lb",
   "handle": "0-70-3-20-ct-round-pear-cut-lab-grown-diamonds-bridal-set-21044lb",
   "priceNow": 1728.99,
   "priceWas": 5360.0,
   "pctOff": 68,
   "core": "21044",
   "inStock": true,
   "createdAt": "2023-08-10T22:56:47Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/070-320-ct-round-pear-cut-lab-grown-diamonds-bridal-set-441255.jpg?v=1714760630",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/070-320-ct-round-pear-cut-lab-grown-diamonds-bridal-set-441255.jpg?v=1714760630",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/070-320-ct-round-pear-cut-lab-grown-diamonds-bridal-set-833147.jpg?v=1763699364",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/070-320-ct-round-pear-cut-lab-grown-diamonds-bridal-set-877039.jpg?v=1763699364"
    }
   },
   "carat": 0.7,
   "caratMax": 6.2
  },
  {
   "rank": 847,
   "id": "gid://shopify/Product/7305446654136",
   "title": "3.20-8.70 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/3-20-5-70-ct-round-cut-lab-grown-diamonds-bridal-set-15343lb",
   "handle": "3-20-5-70-ct-round-cut-lab-grown-diamonds-bridal-set-15343lb",
   "priceNow": 3038.99,
   "priceWas": 9420.0,
   "pctOff": 68,
   "core": "15343",
   "inStock": true,
   "createdAt": "2023-08-10T22:56:15Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1ibPwvciizwg2jz3TLLHfbRvQewFkeUvZ",
      "b": "https://lh3.googleusercontent.com/d/1SQ_eJtNpuh0YnQ0esMBaF_5zv_y8os2c",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1nQOJ8iZfCJziTMbBS0hKdfIabP1bOBJu",
      "b": "https://lh3.googleusercontent.com/d/1cTPOzb8O0j1Ok0y93Rc9nInNJaCLSaR-",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1LFeqHMMaxc9w41wDa5P21W-lfBuR_5pf",
      "b": "https://lh3.googleusercontent.com/d/1qvy8o5GGqUbTpC1LcJcEPxCizMnHWQrz",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/320-570-ct-round-cut-lab-grown-diamonds-bridal-set-891349.jpg?v=1714760801"
   },
   "carat": 3.2,
   "caratMax": 8.7
  },
  {
   "rank": 848,
   "id": "gid://shopify/Product/7305446490296",
   "title": "1.25-6.75 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-25-3-75-ct-princess-round-cut-lab-grown-diamonds-bridal-set-15349lb",
   "handle": "1-25-3-75-ct-princess-round-cut-lab-grown-diamonds-bridal-set-15349lb",
   "priceNow": 2744.99,
   "priceWas": 8510.0,
   "pctOff": 68,
   "core": "15349",
   "inStock": true,
   "createdAt": "2023-08-10T22:55:53Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1cCV8qLGnXyzwUZeSOxh9gcjjMdY3OnRg",
      "b": "https://lh3.googleusercontent.com/d/1nOd4SUhiL_yc2LKfJOV9FU1FSGyKBGw_",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1Pa52LiAMj49naOqrPMvGqSE-sk1DlI-a",
      "b": "https://lh3.googleusercontent.com/d/1PDwAqA-fv4BPbf4OlfbJ2yGqJk1lWxQM",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1j-3JfTw-N3m21c3dsqgPHAoP09pyYGhZ",
      "b": "https://lh3.googleusercontent.com/d/15aVW0XTJWLHWMcH4o-WeEk8MsWgv0pK9",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/125-375-ct-princess-round-cut-lab-grown-diamonds-bridal-set-823423.jpg?v=1763505320"
   },
   "carat": 1.25,
   "caratMax": 6.75
  },
  {
   "rank": 849,
   "id": "gid://shopify/Product/7305421848760",
   "title": "1.70-7.20 CT Princess Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-70-4-20-ct-princess-cut-lab-grown-diamonds-bridal-set-21040lb",
   "handle": "1-70-4-20-ct-princess-cut-lab-grown-diamonds-bridal-set-21040lb",
   "priceNow": 2683.99,
   "priceWas": 8320.0,
   "pctOff": 68,
   "core": "21040",
   "inStock": true,
   "createdAt": "2023-08-10T19:11:27Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/170-420-ct-princess-cut-lab-grown-diamonds-bridal-set-747071.jpg?v=1714761105",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/170-420-ct-princess-cut-lab-grown-diamonds-bridal-set-747071.jpg?v=1714761105",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/170-420-ct-princess-cut-lab-grown-diamonds-bridal-set-166824.jpg?v=1763699374",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/170-420-ct-princess-cut-lab-grown-diamonds-bridal-set-964757.jpg?v=1763699374"
    }
   },
   "carat": 1.7,
   "caratMax": 7.2
  },
  {
   "rank": 850,
   "id": "gid://shopify/Product/7305326592184",
   "title": "3.10-8.60 CT Emerald & Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/3-10-5-60-ct-round-princess-emerald-cut-lab-grown-diamonds-bridal-set-16042lb",
   "handle": "3-10-5-60-ct-round-princess-emerald-cut-lab-grown-diamonds-bridal-set-16042lb",
   "priceNow": 3310.99,
   "priceWas": 10260.0,
   "pctOff": 68,
   "core": "16042",
   "inStock": true,
   "createdAt": "2023-08-09T22:38:54Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1swKdBVBI6mOFTBgN7usrqG8xjFwEsqqq",
      "b": "https://lh3.googleusercontent.com/d/1lqQiiFcNZeAxgwgHdkaphoT2BnKNWW9n",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/18eSV6jRMmOc1PpQSl9lzjmhgivaoSoeW",
      "b": "https://lh3.googleusercontent.com/d/1x353YQuTPVFf4qylodtQ1ZN8bGJkk-Fz",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1mTgO5sGm2t-eKsZYWyQQ6E2TTD7LrK8U",
      "b": "https://lh3.googleusercontent.com/d/1XMiCVspwlYOibkhJ0EpBZs1W28tCXtwj",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/310-560-ct-round-princess-emerald-cut-lab-grown-diamonds-bridal-set-417986.jpg?v=1714761180"
   },
   "carat": 3.1,
   "caratMax": 8.6
  },
  {
   "rank": 851,
   "id": "gid://shopify/Product/7305326559416",
   "title": "0.85-6.35 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/0-85-3-35-ct-round-cut-lab-grown-diamonds-bridal-set-110318lb",
   "handle": "0-85-3-35-ct-round-cut-lab-grown-diamonds-bridal-set-110318lb",
   "priceNow": 1950.99,
   "priceWas": 6050.0,
   "pctOff": 68,
   "core": "110318",
   "inStock": true,
   "createdAt": "2023-08-09T22:38:47Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1yURvIryWc7r_ztSv_LOMThD_pblclKl4",
      "b": "https://lh3.googleusercontent.com/d/1Y03dFxD7fojLc2Khwnd5uZja8gDN8LRR",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1esTr3OFXPICefQJZRrEU12EDLEZ5SnFD",
      "b": "https://lh3.googleusercontent.com/d/1ibsKzJ5-GrG4zy8VgUiwr7R0DVWw5MTd",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ZDeSPA-1wEuu4WBf4hJxws31uWtb-k2T",
      "b": "https://lh3.googleusercontent.com/d/1YfOVgvuZ_xzMN11_G0V8NbZuS7d9RouX",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/085-335-ct-round-cut-lab-grown-diamonds-bridal-set-481649.jpg?v=1714761220"
   },
   "carat": 0.85,
   "caratMax": 6.35
  },
  {
   "rank": 852,
   "id": "gid://shopify/Product/7305326493880",
   "title": "1.10-6.60 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-10-3-60-ct-round-cut-lab-grown-diamonds-bridal-set-110329lb",
   "handle": "1-10-3-60-ct-round-cut-lab-grown-diamonds-bridal-set-110329lb",
   "priceNow": 1902.99,
   "priceWas": 5900.0,
   "pctOff": 68,
   "core": "110329",
   "inStock": true,
   "createdAt": "2023-08-09T22:38:27Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1KfNqpdRwcP_DEA2Ppj1wy1UWl0XSzd75",
      "b": "https://lh3.googleusercontent.com/d/1omG1yoTDNe7_2cgbWsmDqGnIRxXve-hw",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1YmxyO58Y971-8gWREhyp3PXCP4p9Ukql",
      "b": "https://lh3.googleusercontent.com/d/1KBp5jupD3kJZgU3b8cXjYh9-oz_aiCZR",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1PP-fOidXgv_A_x7Ruf_wjZRsTescPGVk",
      "b": "https://lh3.googleusercontent.com/d/1VY78nxFFbrigvrjvS9NkYmbs9xWDiGmR",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/110-360-ct-round-cut-lab-grown-diamonds-bridal-set-631795.jpg?v=1714761292"
   },
   "carat": 1.1,
   "caratMax": 6.6
  },
  {
   "rank": 853,
   "id": "gid://shopify/Product/7305309028536",
   "title": "1.55-7.05 CT Princess Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-55-4-05-ct-princess-cut-lab-grown-diamonds-bridal-set-21033lb",
   "handle": "1-55-4-05-ct-princess-cut-lab-grown-diamonds-bridal-set-21033lb",
   "priceNow": 2318.99,
   "priceWas": 7190.0,
   "pctOff": 68,
   "core": "21033",
   "inStock": true,
   "createdAt": "2023-08-09T19:32:22Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/155-405-ct-princess-cut-lab-grown-diamonds-bridal-set-485126.jpg?v=1714761327",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/155-405-ct-princess-cut-lab-grown-diamonds-bridal-set-485126.jpg?v=1714761327",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/155-405-ct-princess-cut-lab-grown-diamonds-bridal-set-776621.jpg?v=1763699521",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/155-405-ct-princess-cut-lab-grown-diamonds-bridal-set-488783.jpg?v=1763699521"
    }
   },
   "carat": 1.55,
   "caratMax": 7.05
  },
  {
   "rank": 854,
   "id": "gid://shopify/Product/7305308995768",
   "title": "1.30-6.80 CT Oval & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-30-3-80-ct-round-oval-cut-lab-grown-diamonds-bridal-set-110342lb",
   "handle": "1-30-3-80-ct-round-oval-cut-lab-grown-diamonds-bridal-set-110342lb",
   "priceNow": 2058.99,
   "priceWas": 6380.0,
   "pctOff": 68,
   "core": "110342",
   "inStock": true,
   "createdAt": "2023-08-09T19:32:11Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1m3Tj3zj5uDBJrTLnN1-5TN3BHmLwXDKg",
      "b": "https://lh3.googleusercontent.com/d/1WIQt8cz5izD2odwXAlfowMe0Wpou9wJ-",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/14KIn7GgAxXYtSIdIHKilEM1uUErdCsIa",
      "b": "https://lh3.googleusercontent.com/d/1_V0V3W3eqLZqO1lCQ5HwwQVX7O_wOA-6",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1tB-oDOcF8LHRH3WX8U85U1GTDIojBXrT",
      "b": "https://lh3.googleusercontent.com/d/1RXhX_Y2Rnc1PYpDu3wfgRoTbj7xSySTs",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/130-380-ct-round-oval-cut-lab-grown-diamonds-bridal-set-622587.jpg?v=1714761362"
   },
   "carat": 1.3,
   "caratMax": 6.8
  },
  {
   "rank": 855,
   "id": "gid://shopify/Product/7305308897464",
   "title": "1.15-6.65 CT Oval & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-15-3-65-ct-round-oval-cut-lab-grown-diamonds-bridal-set-21034lb",
   "handle": "1-15-3-65-ct-round-oval-cut-lab-grown-diamonds-bridal-set-21034lb",
   "priceNow": 2439.99,
   "priceWas": 7560.0,
   "pctOff": 68,
   "core": "21034",
   "inStock": true,
   "createdAt": "2023-08-09T19:31:47Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/115-365-ct-round-oval-cut-lab-grown-diamonds-bridal-set-665008.jpg?v=1714761399",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/115-365-ct-round-oval-cut-lab-grown-diamonds-bridal-set-665008.jpg?v=1714761399",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/115-365-ct-round-oval-cut-lab-grown-diamonds-bridal-set-893348.jpg?v=1763699521",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/115-365-ct-round-oval-cut-lab-grown-diamonds-bridal-set-735859.jpg?v=1763699521"
    }
   },
   "carat": 1.15,
   "caratMax": 6.65
  },
  {
   "rank": 856,
   "id": "gid://shopify/Product/7305308864696",
   "title": "1.35-6.85 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-35-3-85-ct-round-cut-lab-grown-diamonds-bridal-set-21035lb",
   "handle": "1-35-3-85-ct-round-cut-lab-grown-diamonds-bridal-set-21035lb",
   "priceNow": 2211.99,
   "priceWas": 6860.0,
   "pctOff": 68,
   "core": "21035",
   "inStock": true,
   "createdAt": "2023-08-09T19:31:43Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/135-385-ct-round-cut-lab-grown-diamonds-bridal-set-960358.jpg?v=1714761435",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/135-385-ct-round-cut-lab-grown-diamonds-bridal-set-960358.jpg?v=1714761435",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/135-385-ct-round-cut-lab-grown-diamonds-bridal-set-954626.jpg?v=1763699521",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/135-385-ct-round-cut-lab-grown-diamonds-bridal-set-210773.jpg?v=1763699521"
    }
   },
   "carat": 1.35,
   "caratMax": 6.85
  },
  {
   "rank": 857,
   "id": "gid://shopify/Product/7305211379896",
   "title": "1.55-7.05 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-55-4-05-ct-round-princess-cut-lab-grown-diamonds-bridal-set-21032lb",
   "handle": "1-55-4-05-ct-round-princess-cut-lab-grown-diamonds-bridal-set-21032lb",
   "priceNow": 2359.99,
   "priceWas": 7320.0,
   "pctOff": 68,
   "core": "21032",
   "inStock": true,
   "createdAt": "2023-08-08T21:59:51Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/155-405-ct-round-princess-cut-lab-grown-diamonds-bridal-set-103374.jpg?v=1714761471",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/155-405-ct-round-princess-cut-lab-grown-diamonds-bridal-set-103374.jpg?v=1714761471",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/155-405-ct-round-princess-cut-lab-grown-diamonds-bridal-set-126722.jpg?v=1763699521",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/155-405-ct-round-princess-cut-lab-grown-diamonds-bridal-set-418543.jpg?v=1763699521"
    }
   },
   "carat": 1.55,
   "caratMax": 7.05
  },
  {
   "rank": 858,
   "id": "gid://shopify/Product/7305211347128",
   "title": "1.40-6.90 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-40-3-90-ct-round-cut-lab-grown-diamonds-bridal-set-21031lb",
   "handle": "1-40-3-90-ct-round-cut-lab-grown-diamonds-bridal-set-21031lb",
   "priceNow": 2209.99,
   "priceWas": 6850.0,
   "pctOff": 68,
   "core": "21031",
   "inStock": true,
   "createdAt": "2023-08-08T21:59:40Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/140-390-ct-round-cut-lab-grown-diamonds-bridal-set-512909.jpg?v=1714761511",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/140-390-ct-round-cut-lab-grown-diamonds-bridal-set-512909.jpg?v=1714761511",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/140-390-ct-round-cut-lab-grown-diamonds-bridal-set-353733.jpg?v=1763699521",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/140-390-ct-round-cut-lab-grown-diamonds-bridal-set-207871.jpg?v=1763699521"
    }
   },
   "carat": 1.4,
   "caratMax": 6.9
  },
  {
   "rank": 859,
   "id": "gid://shopify/Product/7305211314360",
   "title": "1.30-6.80 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-30-3-80-ct-princess-round-cut-lab-grown-diamonds-bridal-set-110340lb",
   "handle": "1-30-3-80-ct-princess-round-cut-lab-grown-diamonds-bridal-set-110340lb",
   "priceNow": 2262.99,
   "priceWas": 7020.0,
   "pctOff": 68,
   "core": "110340",
   "inStock": true,
   "createdAt": "2023-08-08T21:59:33Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1fQ3nDjGi2LWJ6WhgqfsYER2P-grocEiE",
      "b": "https://lh3.googleusercontent.com/d/1jfnXpYqHgSunKosIJHSCKVSkFOlV7tJp",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1N2RcvySt89WOYHP_dyXvh3k89GtTvIIk",
      "b": "https://lh3.googleusercontent.com/d/1gPGPRaHH06nJ5JMorXYWtHBGUBmC9mhh",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/16XaslOnt2GDtW9z7m83b5PVH1WzqdEMo",
      "b": "https://lh3.googleusercontent.com/d/19FdMAKMBHXTXInaBwb45uw3OBATUvP1T",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/130-380-ct-princess-round-cut-lab-grown-diamonds-bridal-set-647636.jpg?v=1714761545"
   },
   "carat": 1.3,
   "caratMax": 6.8
  },
  {
   "rank": 860,
   "id": "gid://shopify/Product/7305211216056",
   "title": "2.25-7.75 CT Princess Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/2-25-4-75-ct-princess-cut-lab-grown-diamonds-bridal-set-21030lb",
   "handle": "2-25-4-75-ct-princess-cut-lab-grown-diamonds-bridal-set-21030lb",
   "priceNow": 3035.99,
   "priceWas": 9410.0,
   "pctOff": 68,
   "core": "21030",
   "inStock": true,
   "createdAt": "2023-08-08T21:59:25Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/225-475-ct-princess-cut-lab-grown-diamonds-bridal-set-867663.jpg?v=1714761584",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/225-475-ct-princess-cut-lab-grown-diamonds-bridal-set-867663.jpg?v=1714761584",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/225-475-ct-princess-cut-lab-grown-diamonds-bridal-set-207478.jpg?v=1763699521",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/225-475-ct-princess-cut-lab-grown-diamonds-bridal-set-706678.jpg?v=1763699521"
    }
   },
   "carat": 2.25,
   "caratMax": 7.75
  },
  {
   "rank": 861,
   "id": "gid://shopify/Product/7305211183288",
   "title": "1.00-6.50 CT Emerald & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-00-3-50-ct-round-emerald-cut-lab-grown-diamonds-bridal-set-110397lb",
   "handle": "1-00-3-50-ct-round-emerald-cut-lab-grown-diamonds-bridal-set-110397lb",
   "priceNow": 2094.99,
   "priceWas": 6490.0,
   "pctOff": 68,
   "core": "110397",
   "inStock": true,
   "createdAt": "2023-08-08T21:59:16Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/10VPbAGr8loO2MaM45XgP6bKdUtgut2-m",
      "b": "https://lh3.googleusercontent.com/d/1CtMitI4OIJYRKRdHTq1fFQcRSCT6oocV",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/132d_4BcDELv1R7zQooWCfY0s7vHObnnA",
      "b": "https://lh3.googleusercontent.com/d/1o88XT6x7hsMTvfkebYhnr2C_a5UnjsWa",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1TzAzryFO5jhCiCajSnS6xsFlzRnjdJ7S",
      "b": "https://lh3.googleusercontent.com/d/1tkU7cZf48UrFRhWq7yBoi5XKAnyFE1U1",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-350-ct-round-emerald-cut-lab-grown-diamonds-bridal-set-703329.jpg?v=1714761620"
   },
   "carat": 1.0,
   "caratMax": 6.5
  },
  {
   "rank": 862,
   "id": "gid://shopify/Product/7305192702136",
   "title": "0.95-6.45 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/0-95-3-45-ct-round-cut-lab-grown-diamonds-bridal-set-110363lb",
   "handle": "0-95-3-45-ct-round-cut-lab-grown-diamonds-bridal-set-110363lb",
   "priceNow": 2175.99,
   "priceWas": 6750.0,
   "pctOff": 68,
   "core": "110363",
   "inStock": true,
   "createdAt": "2023-08-08T18:02:36Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1KZlu-pLLhj9mOGouRJwlns_pHp8_d0RC",
      "b": "https://lh3.googleusercontent.com/d/1i0mgg204FLzJsQsCZMTybcQzViFJ-wmD",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1mZKU_OnElfgb4gmgkhwMso4dxM62GafP",
      "b": "https://lh3.googleusercontent.com/d/1SSujcygXqzHfEW1V3rxhYD-oAMFuaGAR",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1LoFlUD7OXcWYjhza8F2Ky2OAiz02IwTy",
      "b": "https://lh3.googleusercontent.com/d/1KLasmyVoDkpUp_PiiBot2uAVA57Hk8Nn",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/095-345-ct-round-cut-lab-grown-diamonds-bridal-set-908721.jpg?v=1697640154"
   },
   "carat": 0.95,
   "caratMax": 6.45
  },
  {
   "rank": 863,
   "id": "gid://shopify/Product/7305192669368",
   "title": "1.00-6.50 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-00-3-50-ct-round-princess-cut-lab-grown-diamonds-bridal-set-110365lb",
   "handle": "1-00-3-50-ct-round-princess-cut-lab-grown-diamonds-bridal-set-110365lb",
   "priceNow": 2272.99,
   "priceWas": 7050.0,
   "pctOff": 68,
   "core": "110365",
   "inStock": true,
   "createdAt": "2023-08-08T18:02:33Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1ox35PsbHmc6pQZmzsKyl7HsXqAio8pOp",
      "b": "https://lh3.googleusercontent.com/d/1VNzcab5jotZU0KCX8j89ps9ZESR8-xjG",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1PBhwuFfaeg2BxlKbsAIgIeJn61eUX7dP",
      "b": "https://lh3.googleusercontent.com/d/1ZbDBlgByRgXV3A_wWE1wM-EQ9JLVrfwE",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1CueG-DVJmhKOtRT4_BdJC4XtG2Owkdzd",
      "b": "https://lh3.googleusercontent.com/d/1TEFG82Fkk8n-hcKUYBq1XMNUQC4O7M3y",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-350-ct-round-princess-cut-lab-grown-diamonds-bridal-set-250099.jpg?v=1697640155"
   },
   "carat": 1.0,
   "caratMax": 6.5
  },
  {
   "rank": 864,
   "id": "gid://shopify/Product/7305192538296",
   "title": "1.70-7.20 CT Oval & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-70-4-20-ct-round-and-oval-cut-lab-grown-diamonds-bridal-set-110359ovlb",
   "handle": "1-70-4-20-ct-round-and-oval-cut-lab-grown-diamonds-bridal-set-110359ovlb",
   "priceNow": 2558.99,
   "priceWas": 7930.0,
   "pctOff": 68,
   "core": "110359",
   "inStock": true,
   "createdAt": "2023-08-08T18:02:19Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1oya6Pj0YgH_N-XZsPIbkzePMly-Skq3i",
      "b": "https://lh3.googleusercontent.com/d/1LkO0dQceUPXXcYW-5YtbufTT4awYOhFo",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/11KiFONyEqvj0EX-QCLLBTCVCHMPqIcWf",
      "b": "https://lh3.googleusercontent.com/d/10dtgtjSJrvaLTa95Goy9Hdx_TDIK_sEQ",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ElOFRyaKahw8m0CobMQhegtIE-uzuwjd",
      "b": "https://lh3.googleusercontent.com/d/1HQpQ42fyALi5RyrMGOloFiBMoVJQbrzM",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/170-420-ct-round-and-oval-cut-lab-grown-diamonds-bridal-set-559045.jpg?v=1697640164"
   },
   "carat": 1.7,
   "caratMax": 7.2
  },
  {
   "rank": 865,
   "id": "gid://shopify/Product/7305192472760",
   "title": "1.70-7.20 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-70-4-20-ct-round-and-oval-cut-lab-grown-diamonds-bridal-set-110359lb",
   "handle": "1-70-4-20-ct-round-and-oval-cut-lab-grown-diamonds-bridal-set-110359lb",
   "priceNow": 2542.99,
   "priceWas": 7880.0,
   "pctOff": 68,
   "core": "110359",
   "inStock": true,
   "createdAt": "2023-08-08T18:02:05Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1oya6Pj0YgH_N-XZsPIbkzePMly-Skq3i",
      "b": "https://lh3.googleusercontent.com/d/1LkO0dQceUPXXcYW-5YtbufTT4awYOhFo",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/11KiFONyEqvj0EX-QCLLBTCVCHMPqIcWf",
      "b": "https://lh3.googleusercontent.com/d/10dtgtjSJrvaLTa95Goy9Hdx_TDIK_sEQ",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ElOFRyaKahw8m0CobMQhegtIE-uzuwjd",
      "b": "https://lh3.googleusercontent.com/d/1HQpQ42fyALi5RyrMGOloFiBMoVJQbrzM",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/170-420-ct-round-and-oval-cut-lab-grown-diamonds-bridal-set-233955.jpg?v=1697640163"
   },
   "carat": 1.7,
   "caratMax": 7.2
  },
  {
   "rank": 866,
   "id": "gid://shopify/Product/7304432615608",
   "title": "0.85-6.35 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/0-85-3-35-ct-round-princess-cut-lab-grown-diamonds-bridal-set-21029lb",
   "handle": "0-85-3-35-ct-round-princess-cut-lab-grown-diamonds-bridal-set-21029lb",
   "priceNow": 2127.99,
   "priceWas": 6600.0,
   "pctOff": 68,
   "core": "21029",
   "inStock": true,
   "createdAt": "2023-08-04T00:17:53Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/085-335-ct-round-princess-cut-lab-grown-diamonds-bridal-set-206585.jpg?v=1714761656",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/085-335-ct-round-princess-cut-lab-grown-diamonds-bridal-set-206585.jpg?v=1714761656",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/085-335-ct-round-princess-cut-lab-grown-diamonds-bridal-set-643460.jpg?v=1763699522",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/085-335-ct-round-princess-cut-lab-grown-diamonds-bridal-set-822354.jpg?v=1763699522"
    }
   },
   "carat": 0.85,
   "caratMax": 6.35
  },
  {
   "rank": 867,
   "id": "gid://shopify/Product/7304432582840",
   "title": "1.00-6.50 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-00-3-50-ct-round-cut-lab-grown-diamonds-bridal-set-21027lb",
   "handle": "1-00-3-50-ct-round-cut-lab-grown-diamonds-bridal-set-21027lb",
   "priceNow": 2129.99,
   "priceWas": 6600.0,
   "pctOff": 68,
   "core": "21027",
   "inStock": true,
   "createdAt": "2023-08-04T00:17:46Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-350-ct-round-cut-lab-grown-diamonds-bridal-set-976033.jpg?v=1714761691",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-350-ct-round-cut-lab-grown-diamonds-bridal-set-976033.jpg?v=1714761691",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-350-ct-round-cut-lab-grown-diamonds-bridal-set-644931.jpg?v=1763699522",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-350-ct-round-cut-lab-grown-diamonds-bridal-set-749276.jpg?v=1763699522"
    }
   },
   "carat": 1.0,
   "caratMax": 6.5
  },
  {
   "rank": 868,
   "id": "gid://shopify/Product/7304432451768",
   "title": "0.60-6.10 CT Radiant & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/0-60-3-10-ct-round-radiant-cut-lab-grown-diamonds-bridal-set-21023lb",
   "handle": "0-60-3-10-ct-round-radiant-cut-lab-grown-diamonds-bridal-set-21023lb",
   "priceNow": 1980.99,
   "priceWas": 6140.0,
   "pctOff": 68,
   "core": "21023",
   "inStock": true,
   "createdAt": "2023-08-04T00:17:15Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-310-ct-round-radiant-cut-lab-grown-diamonds-bridal-set-589969.jpg?v=1714761773",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-310-ct-round-radiant-cut-lab-grown-diamonds-bridal-set-589969.jpg?v=1714761773",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-310-ct-round-radiant-cut-lab-grown-diamonds-bridal-set-825862.jpg?v=1763699564",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/060-310-ct-round-radiant-cut-lab-grown-diamonds-bridal-set-590181.jpg?v=1763699564"
    }
   },
   "carat": 0.6,
   "caratMax": 6.1
  },
  {
   "rank": 869,
   "id": "gid://shopify/Product/7304432386232",
   "title": "0.95-6.45 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/0-95-3-45-ct-round-cut-lab-grown-diamonds-bridal-set-21021lb",
   "handle": "0-95-3-45-ct-round-cut-lab-grown-diamonds-bridal-set-21021lb",
   "priceNow": 1878.99,
   "priceWas": 5820.0,
   "pctOff": 68,
   "core": "21021",
   "inStock": true,
   "createdAt": "2023-08-04T00:17:08Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/095-345-ct-round-cut-lab-grown-diamonds-bridal-set-277361.jpg?v=1714761845",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/095-345-ct-round-cut-lab-grown-diamonds-bridal-set-277361.jpg?v=1714761845",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/095-345-ct-round-cut-lab-grown-diamonds-bridal-set-996903.jpg?v=1763699564",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/095-345-ct-round-cut-lab-grown-diamonds-bridal-set-527089.jpg?v=1763699564"
    }
   },
   "carat": 0.95,
   "caratMax": 6.45
  },
  {
   "rank": 870,
   "id": "gid://shopify/Product/7304432287928",
   "title": "1.65-7.15 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-65-4-15-ct-round-cut-lab-grown-diamonds-bridal-set-71799lb",
   "handle": "1-65-4-15-ct-round-cut-lab-grown-diamonds-bridal-set-71799lb",
   "priceNow": 2642.99,
   "priceWas": 8190.0,
   "pctOff": 68,
   "core": "71799",
   "inStock": true,
   "createdAt": "2023-08-04T00:16:54Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1oXHjDq90j75D20dkO_mpv_oqbju3sKBr",
      "b": "https://lh3.googleusercontent.com/d/1vOR_Q7CpucNmK__ofFG2pCvPRBFLA2jj",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/17Uw4Z77UB75XR1U32XrKIMhxQ8FJADzq",
      "b": "https://lh3.googleusercontent.com/d/16wmw19WEeheXCJzQJY5yKUajzMMtHBqw",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1De0psaTnH4uJeqpQGN3neTGy2swr8f_Z",
      "b": "https://lh3.googleusercontent.com/d/1HEDanFfH3VnNujwmkspZVHEMvCJP1s6H",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/165-415-ct-round-cut-lab-grown-diamonds-bridal-set-257472.jpg?v=1714761916"
   },
   "carat": 1.65,
   "caratMax": 7.15
  },
  {
   "rank": 871,
   "id": "gid://shopify/Product/7304432222392",
   "title": "0.95-6.45 CT Princess & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/0-95-3-45-ct-round-princess-cut-lab-grown-diamonds-bridal-set-16025lb",
   "handle": "0-95-3-45-ct-round-princess-cut-lab-grown-diamonds-bridal-set-16025lb",
   "priceNow": 2153.99,
   "priceWas": 6680.0,
   "pctOff": 68,
   "core": "16025",
   "inStock": true,
   "createdAt": "2023-08-04T00:16:40Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/17b3cE0qsx0NGaYiDl8EVwWDVumPDKd2G",
      "b": "https://lh3.googleusercontent.com/d/1vTDRA092bC5dl-h5Hl9CumeA4Pg5cUU6",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/16GCSsPEbv-TQ4k88yRNISJw8vpfUTtCa",
      "b": "https://lh3.googleusercontent.com/d/1IP8uDQtu65_xB6TkIj832d296LMNSm9b",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1laDuOf6-NqqHuNrSa4R20z3zeU2nG-uj",
      "b": "https://lh3.googleusercontent.com/d/1rZt4FYx7q7041Ay6gj_Uwk1DDcf2eiY6",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/095-345-ct-round-princess-cut-lab-grown-diamonds-bridal-set-926013.jpg?v=1714761953"
   },
   "carat": 0.95,
   "caratMax": 6.45
  },
  {
   "rank": 872,
   "id": "gid://shopify/Product/7304432124088",
   "title": "1.30-6.80 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-30-3-80-ct-round-cut-lab-grown-diamonds-bridal-set-21018lb",
   "handle": "1-30-3-80-ct-round-cut-lab-grown-diamonds-bridal-set-21018lb",
   "priceNow": 1839.99,
   "priceWas": 5700.0,
   "pctOff": 68,
   "core": "21018",
   "inStock": true,
   "createdAt": "2023-08-04T00:16:04Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/130-380-ct-round-cut-lab-grown-diamonds-bridal-set-503020.jpg?v=1714762175",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/130-380-ct-round-cut-lab-grown-diamonds-bridal-set-503020.jpg?v=1714762175",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/130-380-ct-round-cut-lab-grown-diamonds-bridal-set-490947.jpg?v=1763699630",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/130-380-ct-round-cut-lab-grown-diamonds-bridal-set-755186.jpg?v=1763699630"
    }
   },
   "carat": 1.3,
   "caratMax": 6.8
  },
  {
   "rank": 873,
   "id": "gid://shopify/Product/7304431993016",
   "title": "2.65-8.15 CT Emerald & Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/2-65-5-15-ct-round-emerald-cut-lab-grown-diamonds-bridal-set-71632lb",
   "handle": "2-65-5-15-ct-round-emerald-cut-lab-grown-diamonds-bridal-set-71632lb",
   "priceNow": 3022.99,
   "priceWas": 9370.0,
   "pctOff": 68,
   "core": "71632",
   "inStock": true,
   "createdAt": "2023-08-04T00:15:36Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1s9mVIS_wAPJR3j0qeeDHLCskg9ZsV5tI",
      "b": "https://lh3.googleusercontent.com/d/1UqEGuIvnT6poZM0RVeUFeeIu30UijTu6",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1nwoFDJSeyix6Jbs5YmgLLpG6sw5Hxbvp",
      "b": "https://lh3.googleusercontent.com/d/1ukkO9ys23IGAT3FFm6Fgxea9TvBoRrii",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1HnKEwI0xnn0WnSwDzs8qZKAfQ2aof01Q",
      "b": "https://lh3.googleusercontent.com/d/1Czn90ZgdOSl20mYr5yzdHMuD4dBAwgMw",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/265-515-ct-round-emerald-cut-lab-grown-diamonds-bridal-set-167722.jpg?v=1714762211"
   },
   "carat": 2.65,
   "caratMax": 8.15
  },
  {
   "rank": 874,
   "id": "gid://shopify/Product/7304431960248",
   "title": "1.35-6.85 CT Round Cut Lab Grown Diamonds - Bridal Set",
   "url": "/products/1-35-3-85-ct-round-cut-lab-grown-diamonds-bridal-set-110346lb",
   "handle": "1-35-3-85-ct-round-cut-lab-grown-diamonds-bridal-set-110346lb",
   "priceNow": 2000.99,
   "priceWas": 6200.0,
   "pctOff": 68,
   "core": "110346",
   "inStock": true,
   "createdAt": "2023-08-04T00:15:24Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1SII4pnIeDRs9CrOC9FapebPmk7pi5x_C",
      "b": "https://lh3.googleusercontent.com/d/1w9Xk5yEsidLNknW2OCfCo5XeV8IkoBWe",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1fEifw0Zm36ic_IIUfUjN6qBb6DAZsFwU",
      "b": "https://lh3.googleusercontent.com/d/1troo3h9pteOo3G5ya1GSWhwQiBLek3Id",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1VFRKBddH-8BPIOWD9Jjcv9_nhgVAGuUe",
      "b": "https://lh3.googleusercontent.com/d/1RDLUaN0mKBYpnqMEv65cbFCP4yR7GxBR",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/135-385-ct-round-cut-lab-grown-diamonds-bridal-set-914069.jpg?v=1714762259"
   },
   "carat": 1.35,
   "caratMax": 6.85
  },
  {
   "rank": 875,
   "id": "gid://shopify/Product/7304057847992",
   "title": "1.20-6.70 CT Princess Cut Lab Grown Diamonds - Three Stone Rings",
   "url": "/products/1-20-3-70-ct-princess-cut-lab-grown-diamonds-three-stone-ring-15322lb",
   "handle": "1-20-3-70-ct-princess-cut-lab-grown-diamonds-three-stone-ring-15322lb",
   "priceNow": 1860.99,
   "priceWas": 5770.0,
   "pctOff": 68,
   "core": "15322",
   "inStock": true,
   "createdAt": "2023-08-01T23:59:55Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/11cBizbN0Gk8WDWAUxwgGUMBYrv9s0_v7",
      "b": "https://lh3.googleusercontent.com/d/13x4Do677QhKSTDuuk-T92f7VRCqlI6f2",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/19nGXl2Z0ImE_EjSkobzkvw5IThx1cTYy",
      "b": "https://lh3.googleusercontent.com/d/12zG9N8BLKZOXEzZDChwhYxCOxs4hyJ5U",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1If6mboYXvzNySDDviBXKbe2_5Bq_AEq9",
      "b": "https://lh3.googleusercontent.com/d/16aKYrZ7JogrSG7JMP115ozdaVwX5VbRy",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/120-370-ct-princess-cut-lab-grown-diamonds-three-stone-ring-153770.jpg?v=1763766476"
   },
   "carat": 1.2,
   "caratMax": 6.7
  },
  {
   "rank": 876,
   "id": "gid://shopify/Product/7304057716920",
   "title": "1.65-7.15 CT Round Cut Lab Grown Diamonds - Three Stone Rings",
   "url": "/products/1-65-4-15-ct-round-cut-lab-grown-diamonds-three-stone-ring-15656lb",
   "handle": "1-65-4-15-ct-round-cut-lab-grown-diamonds-three-stone-ring-15656lb",
   "priceNow": 1930.99,
   "priceWas": 5990.0,
   "pctOff": 68,
   "core": "15656",
   "inStock": true,
   "createdAt": "2023-08-01T23:59:14Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1VL1vM4KQI74wddbQROXSe0gwt0uTlyJ5",
      "b": "https://lh3.googleusercontent.com/d/1GvN8ZnI9NrLUpLz_ApG8KnHajfNHS4T4",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1S3AcRKqWxMpI5_2cyporzFpYWsR62Y-d",
      "b": "https://lh3.googleusercontent.com/d/1eMkbz2NO2_36pd8mvZORnrNxVO731vC5",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ZJNRVR3koC3vz4NSu_6jMqZ_F7h-xixu",
      "b": "https://lh3.googleusercontent.com/d/1rYLP5fhzIbead1z5-1UqrJ1QCyq1FsEn",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/165-415-ct-round-cut-lab-grown-diamonds-three-stone-ring-232345.jpg?v=1763766482"
   },
   "carat": 1.65,
   "caratMax": 7.15
  },
  {
   "rank": 877,
   "id": "gid://shopify/Product/7304057651384",
   "title": "2.70-8.20 CT Princess & Round Cut Lab Grown Diamonds - Three Stone Rings",
   "url": "/products/2-70-5-20-ct-round-princess-cut-lab-grown-diamonds-three-stone-ring-71739lb",
   "handle": "2-70-5-20-ct-round-princess-cut-lab-grown-diamonds-three-stone-ring-71739lb",
   "priceNow": 2177.99,
   "priceWas": 6750.0,
   "pctOff": 68,
   "core": "71739",
   "inStock": true,
   "createdAt": "2023-08-01T23:58:54Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/18JWivDuCrDJuNF4LBvEGRbtU44fCjd1N",
      "b": "https://lh3.googleusercontent.com/d/1GqxRachYkPwQdpzI_JHbxhWSM_fM9AWT",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1p-VX_505FLqv6Eh6s-goen43saxm7Oi_",
      "b": "https://lh3.googleusercontent.com/d/1lF4MMVsjkZ79hbPD3aXLYGaWZ17ppEom",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1CyrEeSGrAO9Ch8G2asfa8CsxmL0oyHco",
      "b": "https://lh3.googleusercontent.com/d/1V5qO1D0tai6bmAwWbGlLszAX_7EUeToY",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/270-520-ct-round-princess-cut-lab-grown-diamonds-three-stone-ring-917695.jpg?v=1763766481"
   },
   "carat": 2.7,
   "caratMax": 8.2
  },
  {
   "rank": 878,
   "id": "gid://shopify/Product/7304057585848",
   "title": "0.95-6.45 CT Round Cut Lab Grown Diamonds - Three Stone Rings",
   "url": "/products/0-95-3-45-ct-round-cut-lab-grown-diamonds-three-stone-ring-102808lb",
   "handle": "0-95-3-45-ct-round-cut-lab-grown-diamonds-three-stone-ring-102808lb",
   "priceNow": 1312.99,
   "priceWas": 4070.0,
   "pctOff": 68,
   "core": "102808",
   "inStock": true,
   "createdAt": "2023-08-01T23:58:31Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1D5PzG8lIHdSh5kIC4-qCQhBVjUFkteDc",
      "b": "https://lh3.googleusercontent.com/d/1zza_lcpT6bwYWlUsnqscYZ6C8XflhxGL",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1s6w2nIWET0HiKPX7vpL3zOe9WYm6ooU4",
      "b": "https://lh3.googleusercontent.com/d/1urvThJ_gnQ8finGyGOjO6xJILXe2A9_N",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ZVlG4J1nFys-mK7WA6u1H2sbygRVdEq7",
      "b": "https://lh3.googleusercontent.com/d/1WRU_KJENrvHL3T-Gp4z2KMwuh7QUgpkc",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/095-345-ct-round-cut-lab-grown-diamonds-three-stone-ring-920063.jpg?v=1763766480"
   },
   "carat": 0.95,
   "caratMax": 6.45
  },
  {
   "rank": 879,
   "id": "gid://shopify/Product/7304057553080",
   "title": "0.80-6.30 CT Emerald & Princess Cut Lab Grown Diamonds - Three Stone Rings",
   "url": "/products/0-80-3-30-ct-round-emerald-cut-lab-grown-diamonds-three-stone-ring-102797lb",
   "handle": "0-80-3-30-ct-round-emerald-cut-lab-grown-diamonds-three-stone-ring-102797lb",
   "priceNow": 1433.99,
   "priceWas": 4450.0,
   "pctOff": 68,
   "core": "102797",
   "inStock": true,
   "createdAt": "2023-08-01T23:58:25Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1744s-SAD-8NLKplXBG6DD0eUguMovhvy",
      "b": "https://lh3.googleusercontent.com/d/1ytpJGj22Mln8Of2V_sURZlrJ7ZkLqiPs",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1DveMsU1g_tTDh3Tmocf9ZnOL8RgwmXOz",
      "b": "https://lh3.googleusercontent.com/d/1rVz0b44Sr_E8qRsqSqtc2Ng_Dy1DNL6b",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/15A8nRkuMupTZjZcsig6ADsXKqY3PdKLS",
      "b": "https://lh3.googleusercontent.com/d/1rswPh6HjewBWfaQPOoEUYQzD5eHWvxqU",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/080-330-ct-round-emerald-cut-lab-grown-diamonds-three-stone-ring-839830.jpg?v=1763766480"
   },
   "carat": 0.8,
   "caratMax": 6.3
  },
  {
   "rank": 880,
   "id": "gid://shopify/Product/7304057487544",
   "title": "0.85-6.35 CT Princess Cut Lab Grown Diamonds - Three Stone Rings",
   "url": "/products/0-85-3-35-ct-princess-cut-lab-grown-diamonds-three-stone-ring-102804lb",
   "handle": "0-85-3-35-ct-princess-cut-lab-grown-diamonds-three-stone-ring-102804lb",
   "priceNow": 1371.99,
   "priceWas": 4250.0,
   "pctOff": 68,
   "core": "102804",
   "inStock": true,
   "createdAt": "2023-08-01T23:58:13Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1-RWBYciIGtsCuI6swav1yLNQEOGwSXXE",
      "b": "https://lh3.googleusercontent.com/d/1Ehy-4T0AVES7GNHnUe3eraX_-X510e_k",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1CoIflpH0IM4a1i5ASQxBCcW7yUZhVe2e",
      "b": "https://lh3.googleusercontent.com/d/1TClc7AuDZdv8kIEQIXLHD6-WvHOl3Xdv",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1mKJgX2jD0PpOF1lD0NaiBoDMlDMAAqEd",
      "b": "https://lh3.googleusercontent.com/d/1_4s2f6a_eEaJUhrILVQkQr93V1AuDR3v",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/085-335-ct-princess-cut-lab-grown-diamonds-three-stone-ring-617858.jpg?v=1763766481"
   },
   "carat": 0.85,
   "caratMax": 6.35
  },
  {
   "rank": 881,
   "id": "gid://shopify/Product/7304031142072",
   "title": "0.75-6.25 CT Round Cut Lab Grown Diamonds - Halo Rings",
   "url": "/products/0-75-3-25-ct-round-cut-lab-grown-diamonds-halo-ring-71929lb",
   "handle": "0-75-3-25-ct-round-cut-lab-grown-diamonds-halo-ring-71929lb",
   "priceNow": 1498.99,
   "priceWas": 4650.0,
   "pctOff": 68,
   "core": "71929",
   "inStock": true,
   "createdAt": "2023-08-01T18:39:32Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1X3AT4RhXq9YmwTZysD9qR69t_8bx_8EG",
      "b": "https://lh3.googleusercontent.com/d/1zPScDmcTWvjLC311bmpalWquWaAYuPat",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1NgbADArgWKfr9F8r-c0mxmaoqfxAlidV",
      "b": "https://lh3.googleusercontent.com/d/15vJz1bfvkF9Ul4fqd3q9Cwby6jrcSpsm",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1pJxlAuqyZE80-fIZPFRdzmInj_UCHCaw",
      "b": "https://lh3.googleusercontent.com/d/1zdch8ypNiIPG0wt1MZiq5Wyf6-zy7P2-",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/075-325-ct-round-cut-lab-grown-diamonds-halo-ring-443025.jpg?v=1714499792"
   },
   "carat": 0.75,
   "caratMax": 6.25
  },
  {
   "rank": 882,
   "id": "gid://shopify/Product/7304031109304",
   "title": "0.80-6.30 CT Princess & Round Cut Lab Grown Diamonds - Halo Rings",
   "url": "/products/0-80-3-30-ct-round-princess-cut-lab-grown-diamonds-halo-ring-71930lb",
   "handle": "0-80-3-30-ct-round-princess-cut-lab-grown-diamonds-halo-ring-71930lb",
   "priceNow": 1577.99,
   "priceWas": 4890.0,
   "pctOff": 68,
   "core": "71930",
   "inStock": true,
   "createdAt": "2023-08-01T18:39:29Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1UAGEDrWHsg6zmdYOF1PWusvVzTbvAvOh",
      "b": "https://lh3.googleusercontent.com/d/150TRfC0vV3_UUuJX9umvhP0bm2LfWW8o",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1wQIey2YZeoivz5cFk3mniO61wZznOVVk",
      "b": "https://lh3.googleusercontent.com/d/1nvWq_zEvDX9KS0Hob7I07WwsrehDvYUn",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1g5qJEiDV0pIblF_Y72JLhwq72xy3ELP3",
      "b": "https://lh3.googleusercontent.com/d/1jN_450AbS_TxxaiEj91zsJSRp5lhgNN1",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/080-330-ct-round-princess-cut-lab-grown-diamonds-halo-ring-525766.jpg?v=1714499829"
   },
   "carat": 0.8,
   "caratMax": 6.3
  },
  {
   "rank": 883,
   "id": "gid://shopify/Product/7304031076536",
   "title": "1.00-6.50 CT Round Cut Lab Grown Diamonds - Halo Rings",
   "url": "/products/1-00-3-50-ct-round-cut-lab-grown-diamonds-halo-ring-71938lb",
   "handle": "1-00-3-50-ct-round-cut-lab-grown-diamonds-halo-ring-71938lb",
   "priceNow": 1866.99,
   "priceWas": 5790.0,
   "pctOff": 68,
   "core": "71938",
   "inStock": true,
   "createdAt": "2023-08-01T18:39:17Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/17OldCZYHGVIr2Xw9rGQ5LTSFLFvOHGfi",
      "b": "https://lh3.googleusercontent.com/d/1h3o3L1Pd6o4Dh1BC_FwvBS0zllrttPxR",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1ntg2zMnEfHV-yVkVvQ0nH8U_nlEpSpDo",
      "b": "https://lh3.googleusercontent.com/d/1-Eiu0wiMbcGGkmIVzOczIvv8nB9Khw7r",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1R5ZXnrcaGqqEHcdzeFsOzUsLwUAIBz9l",
      "b": "https://lh3.googleusercontent.com/d/1lVP4PhwIwbx_taL_VkwLAeC_2WaeBIIo",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-350-ct-round-cut-lab-grown-diamonds-halo-ring-706069.jpg?v=1714499870"
   },
   "carat": 1.0,
   "caratMax": 6.5
  },
  {
   "rank": 884,
   "id": "gid://shopify/Product/7303610499256",
   "title": "0.75-6.25 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/0-75-3-25-ct-round-princess-cut-lab-grown-diamonds-engagement-ring-15219lb",
   "handle": "0-75-3-25-ct-round-princess-cut-lab-grown-diamonds-engagement-ring-15219lb",
   "priceNow": 1839.99,
   "priceWas": 5700.0,
   "pctOff": 68,
   "core": "15219",
   "inStock": true,
   "createdAt": "2023-07-28T19:25:03Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1gYvTxh1f1Iu2BkVYd_6SVrJTADQsf9v7",
      "b": "https://lh3.googleusercontent.com/d/15IloVK4iVkkMTFjoFZ43-_YUkgyzrT4H",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1cnNoY8Q3BNpxEBetLnZu4WU7ueW8fOs8",
      "b": "https://lh3.googleusercontent.com/d/10JDJhr1vANnjAs-OGvrtLah6r6qMkMKY",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/11tZnCCdwkAx3i3m7Fs_i4xYT7tbfJat6",
      "b": "https://lh3.googleusercontent.com/d/1fmC4qVRnf7MFtRN01ElFTusvlY_GcQoe",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/075-325-ct-round-princess-cut-lab-grown-diamonds-engagement-ring-837979.jpg?v=1765415252"
   },
   "carat": 0.75,
   "caratMax": 6.25
  },
  {
   "rank": 885,
   "id": "gid://shopify/Product/7303610433720",
   "title": "1.80-7.30 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/1-80-4-30-ct-round-cut-lab-grown-diamonds-engagement-ring-15229lb",
   "handle": "1-80-4-30-ct-round-cut-lab-grown-diamonds-engagement-ring-15229lb",
   "priceNow": 1920.99,
   "priceWas": 5960.0,
   "pctOff": 68,
   "core": "15229",
   "inStock": true,
   "createdAt": "2023-07-28T19:24:54Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1ASyfpFzv-Vltdi_r8gpsuYidOy21rWIa",
      "b": "https://lh3.googleusercontent.com/d/1BQdz3k4f9aJO6dvEyhCrhJg_Ttx_lLr8",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1MfZEI5zYNOrK9zP8cH6LqmJwUwgMuqLm",
      "b": "https://lh3.googleusercontent.com/d/1KV63FkyS4hSsm4aZTV2vNMDZL-UDNwev",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1MXPfovM3CKnpAzJJ86UQXqGXr9dIqQk7",
      "b": "https://lh3.googleusercontent.com/d/13Xz1ue6kM8Kpdq3y-4Nm4-wKg4lmx3mx",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/180-430-ct-round-cut-lab-grown-diamonds-engagement-ring-943020.jpg?v=1765415262"
   },
   "carat": 1.8,
   "caratMax": 7.3
  },
  {
   "rank": 886,
   "id": "gid://shopify/Product/7303610400952",
   "title": "1.30-6.80 CT Princess Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/1-30-3-80-ct-princess-cut-lab-grown-diamonds-engagement-ring-15234lb",
   "handle": "1-30-3-80-ct-princess-cut-lab-grown-diamonds-engagement-ring-15234lb",
   "priceNow": 1903.99,
   "priceWas": 5900.0,
   "pctOff": 68,
   "core": "15234",
   "inStock": true,
   "createdAt": "2023-07-28T19:24:47Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1ijWCSVx1-nd4OewSbSWOHNFD0IZW_vlR",
      "b": "https://lh3.googleusercontent.com/d/1XbsX341s9Yv_bGoTN0R06s2fb4SMY9p-",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1SRamxX5f0X69u2iBPDhR6rcn1VrSDOCD",
      "b": "https://lh3.googleusercontent.com/d/1C4BkIxX5pK79AlTnvL3LABzQvu-jZsSV",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1HWsnboJMaUa3mv3LFab8oAO4YNshanls",
      "b": "https://lh3.googleusercontent.com/d/1oYSW3ZWTRY-R8-L8YfmhXfjtd1hixNtj",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/130-380-ct-princess-cut-lab-grown-diamonds-engagement-ring-702818.jpg?v=1765415264"
   },
   "carat": 1.3,
   "caratMax": 6.8
  },
  {
   "rank": 887,
   "id": "gid://shopify/Product/7303610335416",
   "title": "0.65-6.15 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/0-65-3-15-ct-round-cut-lab-grown-diamonds-engagement-ring-15245lb",
   "handle": "0-65-3-15-ct-round-cut-lab-grown-diamonds-engagement-ring-15245lb",
   "priceNow": 1676.99,
   "priceWas": 5200.0,
   "pctOff": 68,
   "core": "15245",
   "inStock": true,
   "createdAt": "2023-07-28T19:24:35Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1yIWjMMEG-UKIVudRx_7q1P_Lo4UB-Y8x",
      "b": "https://lh3.googleusercontent.com/d/1tN6POhDGfTAdu7_8sSsiwQlPt_QN8msv",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1rsvo2ANufV5ZbjD7H29UYE68MWQKUNYg",
      "b": "https://lh3.googleusercontent.com/d/13DAa0L66pBlxrkWP1p9qsx3O29IoGbG6",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1kV-a7-HgIIXV9j4hCNeB1f-G2UEVUsON",
      "b": "https://lh3.googleusercontent.com/d/1K_iN3rqs6yUMBO1usWqQHYngnI9bUsrN",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/065-315-ct-round-cut-lab-grown-diamonds-engagement-ring-750001.jpg?v=1765415265"
   },
   "carat": 0.65,
   "caratMax": 6.15
  },
  {
   "rank": 888,
   "id": "gid://shopify/Product/7303610302648",
   "title": "0.80-6.30 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/0-80-3-30-ct-round-princess-cut-lab-grown-diamonds-engagement-ring-15247lb",
   "handle": "0-80-3-30-ct-round-princess-cut-lab-grown-diamonds-engagement-ring-15247lb",
   "priceNow": 1752.99,
   "priceWas": 5430.0,
   "pctOff": 68,
   "core": "15247",
   "inStock": true,
   "createdAt": "2023-07-28T19:24:32Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1SjflZArdEOx3mOjsL48JKBcVyRhx7J_5",
      "b": "https://lh3.googleusercontent.com/d/1Y66cnLlDWJnhsVbJ9HcHtnH7-xkfTsR0",
      "angles": [
       5,
       6
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1j9u7GPhaoS1xcmbUxWspFf1g4G8LBbMw",
      "b": "https://lh3.googleusercontent.com/d/1BQkCfwtKh0Fpv99x_BM8Ch30F0s5EkMV",
      "angles": [
       5,
       6
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/18iJfOXcl-r7JFDXaLIAQMugNpmID8upj",
      "b": "https://lh3.googleusercontent.com/d/1ronJemRvIi2k5_O4mY2YwupnE-to6xeq",
      "angles": [
       5,
       6
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/080-330-ct-round-princess-cut-lab-grown-diamonds-engagement-ring-551083.jpg?v=1765415278"
   },
   "carat": 0.8,
   "caratMax": 6.3
  },
  {
   "rank": 889,
   "id": "gid://shopify/Product/7303610106040",
   "title": "1.50-7.00 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/1-50-4-00-ct-round-princess-cut-lab-grown-diamonds-engagement-ring-15670lb",
   "handle": "1-50-4-00-ct-round-princess-cut-lab-grown-diamonds-engagement-ring-15670lb",
   "priceNow": 1779.99,
   "priceWas": 5520.0,
   "pctOff": 68,
   "core": "15670",
   "inStock": true,
   "createdAt": "2023-07-28T19:24:02Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/11NC3yiumJIzl65mHPIrozvMfBKN2Ml2T",
      "b": "https://lh3.googleusercontent.com/d/1vNVT6qSaevK8v4WiHZ-Ns91nCyxRscEZ",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1LCHrVbGeuxNqHRvwcuv8OYk887rpgmn-",
      "b": "https://lh3.googleusercontent.com/d/1M3rEZEDBfOonZvBIr5NzyqDlQEONCaPm",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1PtFIa0JGIYuoQUiIbX_oFueKdu_9ecFL",
      "b": "https://lh3.googleusercontent.com/d/1llGkWOHvrQVGYHi2dx6tgGQHxKCeuWiF",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/150-400-ct-round-princess-cut-lab-grown-diamonds-engagement-ring-376100.jpg?v=1765415292"
   },
   "carat": 1.5,
   "caratMax": 7.0
  },
  {
   "rank": 890,
   "id": "gid://shopify/Product/7303609712824",
   "title": "2.10-7.60 CT Emerald & Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/2-10-4-60-ct-round-emerald-princess-cut-lab-grown-diamonds-engagement-ring-16040lb",
   "handle": "2-10-4-60-ct-round-emerald-princess-cut-lab-grown-diamonds-engagement-ring-16040lb",
   "priceNow": 2169.99,
   "priceWas": 6730.0,
   "pctOff": 68,
   "core": "16040",
   "inStock": true,
   "createdAt": "2023-07-28T19:23:21Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1_mQtdZ5q4udmZICSJWp5CBGXK2Tgjcer",
      "b": "https://lh3.googleusercontent.com/d/1YP2XQpCMBjbEzWWdRYGeo33jpdzEYpGD",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1UtQ6_WbmvfQLialyhWCxkqC61d2syJ1A",
      "b": "https://lh3.googleusercontent.com/d/1XYZQ8mpBQ9gNprMatnfuuiQHjHZZzg9-",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1vPO4Lgl-G222FUmau7xVWzX1YBG_m1qz",
      "b": "https://lh3.googleusercontent.com/d/1ePUDw0az9dtG4CCRZQRJ-rLE8SuFOJCy",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/210-460-ct-round-emerald-princess-cut-lab-grown-diamonds-engagement-ring-203118.jpg?v=1765415319"
   },
   "carat": 2.1,
   "caratMax": 7.6
  },
  {
   "rank": 891,
   "id": "gid://shopify/Product/7303609581752",
   "title": "0.65-6.15 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/0-65-3-15-ct-round-cut-lab-grown-diamonds-engagement-ring-71660lb",
   "handle": "0-65-3-15-ct-round-cut-lab-grown-diamonds-engagement-ring-71660lb",
   "priceNow": 1154.99,
   "priceWas": 3580.0,
   "pctOff": 68,
   "core": "71660",
   "inStock": true,
   "createdAt": "2023-07-28T19:23:00Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1o8HLrf_mCbJzuxa7j-q5lT9zRAiyCyTb",
      "b": "https://lh3.googleusercontent.com/d/1dck9Yr-GNyrBBN3-QWhIWGhuGW5Zl4x1",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1Oa5e5n0RX4TsyLGANaZtu9KT0wJWaSGT",
      "b": "https://lh3.googleusercontent.com/d/1KFh_oicB4E2BkNk5sw37R7xlKKa7-wOd",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1LutgGkbfdkcRG0p5JICBASvqm7C6JhfM",
      "b": "https://lh3.googleusercontent.com/d/1VJG2sSFofmmwlkqembwCaQo0jcgftSt-",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/065-315-ct-round-cut-lab-grown-diamonds-engagement-ring-313924.jpg?v=1714069673"
   },
   "carat": 0.65,
   "caratMax": 6.15
  },
  {
   "rank": 892,
   "id": "gid://shopify/Product/7303609548984",
   "title": "0.70-6.20 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/0-70-3-20-ct-round-cut-lab-grown-diamonds-engagement-ring-71668lb",
   "handle": "0-70-3-20-ct-round-cut-lab-grown-diamonds-engagement-ring-71668lb",
   "priceNow": 1542.99,
   "priceWas": 4780.0,
   "pctOff": 68,
   "core": "71668",
   "inStock": true,
   "createdAt": "2023-07-28T19:22:53Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1yyrNDI6_EdyKZXvADf-EjY8aJ_vkDw7x",
      "b": "https://lh3.googleusercontent.com/d/1wBDroZw2ZtJr6zBNWFfFd5zaH7C5pdWO",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1hRg2TyHX3CoXpLfvZKAgBRlcP4SlfiVa",
      "b": "https://lh3.googleusercontent.com/d/1qCwMyUngKu-xE8h9SWsCYQ-t9DfQQx0x",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1dnVQF2cIrdqQWY0siyo6G8mvfGUeZnxX",
      "b": "https://lh3.googleusercontent.com/d/1-BwZLe-NNfYwTC9sm7SpMB6hLMgrltqR",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/070-320-ct-round-cut-lab-grown-diamonds-engagement-ring-999683.jpg?v=1714069891"
   },
   "carat": 0.7,
   "caratMax": 6.2
  },
  {
   "rank": 893,
   "id": "gid://shopify/Product/7303609450680",
   "title": "0.75-6.25 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/0-75-3-25-ct-round-cut-lab-grown-diamonds-engagement-ring-71741lb",
   "handle": "0-75-3-25-ct-round-cut-lab-grown-diamonds-engagement-ring-71741lb",
   "priceNow": 1311.99,
   "priceWas": 4070.0,
   "pctOff": 68,
   "core": "71741",
   "inStock": true,
   "createdAt": "2023-07-28T19:22:45Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1v4glr2IqIyh0yaJc-YUdGSPNqevGM1n-",
      "b": "https://lh3.googleusercontent.com/d/1UJHRdT21t7KKOXIpKtMTQlVrThaaHX9X",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1NMoCgoAcSObwp2AW-gU2ggaad7e8J8R7",
      "b": "https://lh3.googleusercontent.com/d/1G4K8eyFJbvbJSO1HU046XPIdtxPEctj_",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/17LPX3Yki26zjU5x_OSUTtOmMZFgkDhCZ",
      "b": "https://lh3.googleusercontent.com/d/1SW1wtfmRcFriRTFR_UwGzWmIU5CHhVSU",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/075-325-ct-round-cut-lab-grown-diamonds-engagement-ring-759525.jpg?v=1714070103"
   },
   "carat": 0.75,
   "caratMax": 6.25
  },
  {
   "rank": 894,
   "id": "gid://shopify/Product/7303609385144",
   "title": "0.90-6.40 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/0-90-3-40-ct-round-cut-lab-grown-diamonds-engagement-ring-71753lb",
   "handle": "0-90-3-40-ct-round-cut-lab-grown-diamonds-engagement-ring-71753lb",
   "priceNow": 1571.99,
   "priceWas": 4870.0,
   "pctOff": 68,
   "core": "71753",
   "inStock": true,
   "createdAt": "2023-07-28T19:22:33Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1cnKpf9rL5kT7wfbZK--JXZ6KT1hoaFv_",
      "b": "https://lh3.googleusercontent.com/d/1rJSXpBISc9JN9oduCFHdzqNT1ky25Ztu",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1t8LXKm8BsaqGHWhDgpaEU9d66H8J7Pa-",
      "b": "https://lh3.googleusercontent.com/d/18hqiSRy7oCipy-vItGARqWtfmv2bJKHd",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/16Y70x842JEkQScZvfEjbdJ-p3f447Emk",
      "b": "https://lh3.googleusercontent.com/d/1C6peyjKumRPcBG2zZtzQqA2XdqoL5d8B",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/090-340-ct-round-cut-lab-grown-diamonds-engagement-ring-417455.jpg?v=1714071572"
   },
   "carat": 0.9,
   "caratMax": 6.4
  },
  {
   "rank": 895,
   "id": "gid://shopify/Product/7303609319608",
   "title": "0.95-6.45 CT Oval & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/0-95-3-45-ct-round-oval-cut-lab-grown-diamonds-engagement-ring-71813lb",
   "handle": "0-95-3-45-ct-round-oval-cut-lab-grown-diamonds-engagement-ring-71813lb",
   "priceNow": 1918.99,
   "priceWas": 5950.0,
   "pctOff": 68,
   "core": "71813",
   "inStock": true,
   "createdAt": "2023-07-28T19:22:22Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1myciUs9LKkCvGp931GftA4R7z-xCbi5l",
      "b": "https://lh3.googleusercontent.com/d/10Ga4ZleDUqFRu1FhXG7pzePzzKghss82",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1RYNFBtqCf_uKqXNTI-IFddRJa2TtCPuk",
      "b": "https://lh3.googleusercontent.com/d/1wlpFFzAUhhboZn8d6ICiSagzRMruwYLg",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/10YS97CioIcCyYQXYUnrRHlZoDd10PXI-",
      "b": "https://lh3.googleusercontent.com/d/1oa4TG-RaLReD_f3mtQK6o0A52aWYJkOR",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/095-345-ct-round-oval-cut-lab-grown-diamonds-engagement-ring-196117.jpg?v=1714498977"
   },
   "carat": 0.95,
   "caratMax": 6.45
  },
  {
   "rank": 896,
   "id": "gid://shopify/Product/7303236124856",
   "title": "1.00-6.50 CT Princess Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/1-00-3-50-ct-princess-cut-lab-grown-diamonds-engagement-ring-71853lb",
   "handle": "1-00-3-50-ct-princess-cut-lab-grown-diamonds-engagement-ring-71853lb",
   "priceNow": 1860.99,
   "priceWas": 5770.0,
   "pctOff": 68,
   "core": "71853",
   "inStock": true,
   "createdAt": "2023-07-26T21:57:50Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1ep3mKsyy5f8gOEqs6J0i5QeuvpfU0L8j",
      "b": "https://lh3.googleusercontent.com/d/1F8Vx-bFVSZBv6qoXBiI21HW5z-5QmaRh",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1Yu9rcHx7BaCDAGbpHzoFlh517EPJeam_",
      "b": "https://lh3.googleusercontent.com/d/1khXtS7ODCYpzGoWXfic0baWnANBWZ9Zz",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1b8yaDgkS5B2Iq4NppRvCb7sVpagNCwMK",
      "b": "https://lh3.googleusercontent.com/d/1maoPe1gfv3iiuwl7luq0HsQIK-lyzh7x",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-350-ct-princess-cut-lab-grown-diamonds-engagement-ring-206715.jpg?v=1714499022"
   },
   "carat": 1.0,
   "caratMax": 6.5
  },
  {
   "rank": 897,
   "id": "gid://shopify/Product/7303236026552",
   "title": "1.20-6.70 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/1-20-3-70-ct-round-cut-lab-grown-diamonds-engagement-ring-71870lb",
   "handle": "1-20-3-70-ct-round-cut-lab-grown-diamonds-engagement-ring-71870lb",
   "priceNow": 1456.99,
   "priceWas": 4520.0,
   "pctOff": 68,
   "core": "71870",
   "inStock": true,
   "createdAt": "2023-07-26T21:57:37Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1Gqn3KAm1gN2yW4hxYDNuxtu7pU8K94dK",
      "b": "https://lh3.googleusercontent.com/d/1mAzPusiQEM91rksVmGBwLRAV2NdS0Pk2",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1F1FJbP4BwQY8RVI8BFIf5zDFHchWL6rG",
      "b": "https://lh3.googleusercontent.com/d/1b02WWUG8DUSl1UM7_tybS9Xgj00WjdF5",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ChMvAkF-V1AA8tXz06NMOomwNpGqETPf",
      "b": "https://lh3.googleusercontent.com/d/1F65hbg4qPoNyEh-RIo8W2RVuWon35lfh",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/120-370-ct-round-cut-lab-grown-diamonds-engagement-ring-181085.jpg?v=1714499118"
   },
   "carat": 1.2,
   "caratMax": 6.7
  },
  {
   "rank": 898,
   "id": "gid://shopify/Product/7303235961016",
   "title": "1.30-6.80 CT Princess Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/1-30-3-80-ct-princess-cut-lab-grown-diamonds-engagement-ring-71883lb",
   "handle": "1-30-3-80-ct-princess-cut-lab-grown-diamonds-engagement-ring-71883lb",
   "priceNow": 1962.99,
   "priceWas": 6090.0,
   "pctOff": 68,
   "core": "71883",
   "inStock": true,
   "createdAt": "2023-07-26T21:57:21Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1RFXa24osp6dKIFWaPdJoqlLZAGIudRDA",
      "b": "https://lh3.googleusercontent.com/d/1CU6J7Woxu2tsoWvor2qNzrCvMxhGxKOO",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1ecUdu7Qej7t2ZNet7q1Bx4MHPcIETvOe",
      "b": "https://lh3.googleusercontent.com/d/1n_CYt0Pa-OZE_k80guxQG5iLRmceTuhS",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1O1kbhOd3iU6TeFNkCu6N6p2-T2tkXKPy",
      "b": "https://lh3.googleusercontent.com/d/1dCkjLL8DOYFA6cgaDphzDSHZ97hSXvbr",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/130-380-ct-princess-cut-lab-grown-diamonds-engagement-ring-104013.jpg?v=1714499165"
   },
   "carat": 1.3,
   "caratMax": 6.8
  },
  {
   "rank": 899,
   "id": "gid://shopify/Product/7303235895480",
   "title": "0.80-6.30 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/0-80-3-30-ct-round-cut-lab-grown-diamonds-engagement-ring-21016lb",
   "handle": "0-80-3-30-ct-round-cut-lab-grown-diamonds-engagement-ring-21016lb",
   "priceNow": 1351.99,
   "priceWas": 4190.0,
   "pctOff": 68,
   "core": "21016",
   "inStock": true,
   "createdAt": "2023-07-26T21:56:55Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/080-330-ct-round-cut-lab-grown-diamonds-engagement-ring-674219.jpg?v=1714071073",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/080-330-ct-round-cut-lab-grown-diamonds-engagement-ring-674219.jpg?v=1714071073",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/080-330-ct-round-cut-lab-grown-diamonds-engagement-ring-307690.jpg?v=1763699708",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/080-330-ct-round-cut-lab-grown-diamonds-engagement-ring-333125.jpg?v=1763699708"
    }
   },
   "carat": 0.8,
   "caratMax": 6.3
  },
  {
   "rank": 900,
   "id": "gid://shopify/Product/7303235862712",
   "title": "0.70-6.20 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/0-70-3-20-ct-round-cut-lab-grown-diamonds-engagement-ring-21015lb",
   "handle": "0-70-3-20-ct-round-cut-lab-grown-diamonds-engagement-ring-21015lb",
   "priceNow": 1600.99,
   "priceWas": 4960.0,
   "pctOff": 68,
   "core": "21015",
   "inStock": true,
   "createdAt": "2023-07-26T21:56:43Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/070-320-ct-round-cut-lab-grown-diamonds-engagement-ring-759877.jpg?v=1714069833",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/070-320-ct-round-cut-lab-grown-diamonds-engagement-ring-759877.jpg?v=1714069833",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/070-320-ct-round-cut-lab-grown-diamonds-engagement-ring-430417.jpg?v=1763699708",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/070-320-ct-round-cut-lab-grown-diamonds-engagement-ring-913447.jpg?v=1763699708"
    }
   },
   "carat": 0.7,
   "caratMax": 6.2
  },
  {
   "rank": 901,
   "id": "gid://shopify/Product/7303235666104",
   "title": "1.15-6.65 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/1-15-3-65-ct-round-cut-lab-grown-diamonds-engagement-ring-71797lb",
   "handle": "1-15-3-65-ct-round-cut-lab-grown-diamonds-engagement-ring-71797lb",
   "priceNow": 1732.99,
   "priceWas": 5370.0,
   "pctOff": 68,
   "core": "71797",
   "inStock": true,
   "createdAt": "2023-07-26T21:56:13Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1uW82pbKNWw6lrO9UBspr8WK3v7F6Broj",
      "b": "https://lh3.googleusercontent.com/d/14JWRATHyze__jfhdTMxTrW1fU5Xd0uDS",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1T2BKrm6G1ANtixoqrlGx1uPY0_u2Sl_q",
      "b": "https://lh3.googleusercontent.com/d/1W6fycmeQgT3l60gioTcGZtHcIOzLLpoP",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1jnqO5yLZBh5FnIPkob9JPiAfZziLvZkq",
      "b": "https://lh3.googleusercontent.com/d/1Pzu8WKQXpOQHyL8CWc0Exnql2hvSNCcL",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/files/71797LB_W3.jpg?v=1714499250"
   },
   "carat": 1.15,
   "caratMax": 6.65
  },
  {
   "rank": 902,
   "id": "gid://shopify/Product/7303235600568",
   "title": "1.25-6.75 CT Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/1-25-3-75-ct-round-cut-lab-grown-diamonds-engagement-ring-71773lb",
   "handle": "1-25-3-75-ct-round-cut-lab-grown-diamonds-engagement-ring-71773lb",
   "priceNow": 1905.99,
   "priceWas": 5910.0,
   "pctOff": 68,
   "core": "71773",
   "inStock": true,
   "createdAt": "2023-07-26T21:56:05Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1jm7curm4OlNrkq-yr0vkE-55tmW9SsOY",
      "b": "https://lh3.googleusercontent.com/d/1BxwNMFNr4xN7j2ilEVyrRgMc9mgVAjja",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/16_R1Cs6vlqqra3DMbFWYyahAgBnDSUv5",
      "b": "https://lh3.googleusercontent.com/d/1xdVrsC2eJXNH3-TdUsfjnhxTDoBNMrG-",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1TUil8jv9HVytJb28g0XcwN6cKTasGmR2",
      "b": "https://lh3.googleusercontent.com/d/1UBX9CIsBs5bdpbrGFAlDm8tb1n-fO6Vb",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/125-375-ct-round-cut-lab-grown-diamonds-engagement-ring-184435.jpg?v=1714499301"
   },
   "carat": 1.25,
   "caratMax": 6.75
  },
  {
   "rank": 903,
   "id": "gid://shopify/Product/7303137067192",
   "title": "0.65-6.15 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/0-65-3-15-ct-round-princess-cut-lab-grown-diamonds-engagement-ring-16023lb",
   "handle": "0-65-3-15-ct-round-princess-cut-lab-grown-diamonds-engagement-ring-16023lb",
   "priceNow": 1450.99,
   "priceWas": 4500.0,
   "pctOff": 68,
   "core": "16023",
   "inStock": true,
   "createdAt": "2023-07-26T17:48:17Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1MEHP4iscJzMC_c3kBN1txDnoPKmvtso7",
      "b": "https://lh3.googleusercontent.com/d/1JGyoGAWhcPXt33luzZGDlz7M0Ji_x7a7",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1y13AtC9gjk7nSy-3bQgr5C-TkoXVm0aO",
      "b": "https://lh3.googleusercontent.com/d/1IiN3Lg47i_t1FF7iXkb-IT4ikSKGaVyb",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1S5S3KiH_RksIaEOy4jbGeXDHHrJu0BT3",
      "b": "https://lh3.googleusercontent.com/d/1EAhK3fo_vpnka7odBCcmLo1f1UfB5cab",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/065-315-ct-round-princess-cut-lab-grown-diamonds-engagement-ring-693057.jpg?v=1714069571"
   },
   "carat": 0.65,
   "caratMax": 6.15
  },
  {
   "rank": 904,
   "id": "gid://shopify/Product/7303137001656",
   "title": "1.30-6.80 CT Princess & Round Cut Lab Grown Diamonds - Engagement Ring",
   "url": "/products/1-30-3-80-ct-round-princess-cut-lab-grown-diamonds-engagement-ring-15240lb",
   "handle": "1-30-3-80-ct-round-princess-cut-lab-grown-diamonds-engagement-ring-15240lb",
   "priceNow": 1909.99,
   "priceWas": 5920.0,
   "pctOff": 68,
   "core": "15240",
   "inStock": true,
   "createdAt": "2023-07-26T17:48:08Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/16MAfGea2DsGJ8TMKyh7w75lxddoy9Tv1",
      "b": "https://lh3.googleusercontent.com/d/1_oQu2FhRjkgXuu12kFJwe7T7hvtdQHO5",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1YkLXnQHY0BfTzVPT6mzjIsZyhpCQxJ1b",
      "b": "https://lh3.googleusercontent.com/d/1SMPYkwbF9HwwMmD3hOst9Wiyp7uSgCSb",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1FcLCWKiNb2UCvuWZA48scbLdlJn0wO3K",
      "b": "https://lh3.googleusercontent.com/d/143SIeiVVM5IDneX3obYL3c-OsvCylz8D",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/130-380-ct-round-princess-cut-lab-grown-diamonds-engagement-ring-388925.jpg?v=1714499389"
   },
   "carat": 1.3,
   "caratMax": 6.8
  },
  {
   "rank": 905,
   "id": "gid://shopify/Product/7302928400568",
   "title": "0.50-6.00 CT Princess Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/0-50-3-00-ct-princess-cut-lab-grown-diamonds-solitaire-ring-15407lb",
   "handle": "0-50-3-00-ct-princess-cut-lab-grown-diamonds-solitaire-ring-15407lb",
   "priceNow": 1248.99,
   "priceWas": 3870.0,
   "pctOff": 68,
   "core": "15407",
   "inStock": true,
   "createdAt": "2023-07-24T23:16:02Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1G8be7bFCAA9v35j-DjRf0I9De3JVT5NK",
      "b": "https://lh3.googleusercontent.com/d/1KlpCLAz2VVrI0rZJFOjMT4OuDyRRLTmq",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1PRgjqJIbH0rx4jjrkmDhLgs2vKs5hIba",
      "b": "https://lh3.googleusercontent.com/d/1P0nOn9YeXBV0EBgSozGGTKwIB5yklxll",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1rPgPCe1FgVXN-Tqa10gaFUmib5Mp8hiK",
      "b": "https://lh3.googleusercontent.com/d/1SuL47FKntVHKnr5VlKnEQqkX22llLLHF",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-princess-cut-lab-grown-diamonds-solitaire-ring-239179.jpg?v=1763748619"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 906,
   "id": "gid://shopify/Product/7302928367800",
   "title": "0.50-6.00 CT Ascher Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/0-50-3-00-ct-ascher-cut-lab-grown-diamonds-solitaire-ring-15657lb",
   "handle": "0-50-3-00-ct-ascher-cut-lab-grown-diamonds-solitaire-ring-15657lb",
   "priceNow": 1248.99,
   "priceWas": 3870.0,
   "pctOff": 68,
   "core": "15657",
   "inStock": true,
   "createdAt": "2023-07-24T23:15:53Z",
   "shape": "asscher",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1UIP38u18u-LkJd5OdibNvYivd0EGsVqJ",
      "b": "https://lh3.googleusercontent.com/d/1PxqAQjZCV8QuM1AOTsv_tIRNLPwlEvmK",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1NBwZULX_YLMeP4mGG09OEoi7CQFZ2FVH",
      "b": "https://lh3.googleusercontent.com/d/1-urWqOnhPPmoYgRQIPbh51S_5EehW9_z",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1X0hRap2ZSvK1M3vFwNXF_vto9aqxrS5n",
      "b": "https://lh3.googleusercontent.com/d/1voe2ueBk0UiP9ISgyyoQhYZoKTeASWAp",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-ascher-cut-lab-grown-diamonds-solitaire-ring-418783.jpg?v=1763748618"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 907,
   "id": "gid://shopify/Product/7302928236728",
   "title": "0.50-6.00 CT Princess Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/0-50-3-00-ct-princess-cut-lab-grown-diamonds-solitaire-ring-71658lb",
   "handle": "0-50-3-00-ct-princess-cut-lab-grown-diamonds-solitaire-ring-71658lb",
   "priceNow": 1000.99,
   "priceWas": 3100.0,
   "pctOff": 68,
   "core": "71658",
   "inStock": true,
   "createdAt": "2023-07-24T23:15:31Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1B8fXp6hwJVAprBkNn0U0s9oiQRmP2Uqk",
      "b": "https://lh3.googleusercontent.com/d/1uMkry6ObyJl-dVqqbB-sqlTta3fnw5oY",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1IygfnB3ZHuRsbrky9SL_cIWTPfKsRbWq",
      "b": "https://lh3.googleusercontent.com/d/1V0S4JefbyWVe1Q7afqCdYsYXk6tB1RFU",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/15yzB6STgTmu9-vTJZNx1sX3tpY-bCDy-",
      "b": "https://lh3.googleusercontent.com/d/1nguK-t3IIfA4CzD0T18nMXvFIJbrdaF7",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-princess-cut-lab-grown-diamonds-solitaire-ring-327196.jpg?v=1763748634"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 908,
   "id": "gid://shopify/Product/7302928203960",
   "title": "0.50-6.00 CT Princess Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/0-50-3-00-ct-princess-cut-lab-grown-diamonds-solitaire-ring-71656lb",
   "handle": "0-50-3-00-ct-princess-cut-lab-grown-diamonds-solitaire-ring-71656lb",
   "priceNow": 1372.99,
   "priceWas": 4260.0,
   "pctOff": 68,
   "core": "71656",
   "inStock": true,
   "createdAt": "2023-07-24T23:15:24Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1focuBX2AVAVuWsdc_pXu3c0UVspi9_Gf",
      "b": "https://lh3.googleusercontent.com/d/1dT52IhftyLfB5covfmpBA8AAn66YLv-j",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1F0Pv8r6IKH_MDAQTzZraLgM5LejmnglY",
      "b": "https://lh3.googleusercontent.com/d/17upiNAI-gf3x1QNLO76nG6mJiYhn03Qb",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/12qbRxkTjR9Hbk5-O2rfiWk7te3aV4KXB",
      "b": "https://lh3.googleusercontent.com/d/1mdg-Mc0fiYNVgZXyvdDebcMtXiBTGLx_",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-princess-cut-lab-grown-diamonds-solitaire-ring-637626.jpg?v=1763748613"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 909,
   "id": "gid://shopify/Product/7302750404792",
   "title": "0.50-6.00 CT Princess Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/0-50-3-00-ct-princess-cut-lab-grown-diamonds-solitaire-ring-71811lb",
   "handle": "0-50-3-00-ct-princess-cut-lab-grown-diamonds-solitaire-ring-71811lb",
   "priceNow": 1496.99,
   "priceWas": 4640.0,
   "pctOff": 68,
   "core": "71811",
   "inStock": true,
   "createdAt": "2023-07-21T22:33:09Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-princess-cut-lab-grown-diamonds-solitaire-ring-143333.jpg?v=1763748619"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 910,
   "id": "gid://shopify/Product/7302750372024",
   "title": "0.50-6.00 CT Princess Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/0-50-3-00-ct-princess-cut-lab-grown-diamonds-solitaire-ring-71812lb",
   "handle": "0-50-3-00-ct-princess-cut-lab-grown-diamonds-solitaire-ring-71812lb",
   "priceNow": 1000.99,
   "priceWas": 3100.0,
   "pctOff": 68,
   "core": "71812",
   "inStock": true,
   "createdAt": "2023-07-21T22:33:03Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1-xe3nbkfrZ1sXwtlh1lNLnwO4YwDvhBs",
      "b": "https://lh3.googleusercontent.com/d/1RArfUgqHMIy3jdIH7si2GYkRlsGd-4he",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/16u0ZAsfPOSB4dtWoBqo1O7PytiQBFfzv",
      "b": "https://lh3.googleusercontent.com/d/1tpZke0m022kXQ1JGvc-AMjKmduPw8ISt",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1KJYlmgBRP36D7-mRib1bmi9wTf4HPEOG",
      "b": "https://lh3.googleusercontent.com/d/1I0W-pffuyzeSUGFyRbpyqryi6_X0XtZw",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-princess-cut-lab-grown-diamonds-solitaire-ring-535428.jpg?v=1763748627"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 911,
   "id": "gid://shopify/Product/7302750339256",
   "title": "0.50-6.00 CT Round Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/0-50-3-00-ct-round-cut-lab-grown-diamonds-solitaire-ring-71735lb",
   "handle": "0-50-3-00-ct-round-cut-lab-grown-diamonds-solitaire-ring-71735lb",
   "priceNow": 1186.99,
   "priceWas": 3680.0,
   "pctOff": 68,
   "core": "71735",
   "inStock": true,
   "createdAt": "2023-07-21T22:32:55Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1VUbWsskvUYIdsRGP4x2ByFTjvMWKi-9v",
      "b": "https://lh3.googleusercontent.com/d/1vmkNUD_9yhOKFi7H06UahDaAUfYnKdwy",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1H3UDxt8BkUssPMPZzrC7TEh2YDiuImy6",
      "b": "https://lh3.googleusercontent.com/d/1KdiEx9vUAglCCcMN9DdqmmYDm-0VqrVA",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1WBlnPHeVPnaZwmepKVQIvLZTcV_WJeKG",
      "b": "https://lh3.googleusercontent.com/d/1FUf1b3c3LfV3R8YZYVSqgqHt1LKVQMVP",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-round-cut-lab-grown-diamonds-solitaire-ring-534535.jpg?v=1763748619"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 912,
   "id": "gid://shopify/Product/7302750306488",
   "title": "0.50-6.00 CT Round Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/0-50-3-00-ct-round-cut-lab-grown-diamonds-solitaire-ring-71726lb",
   "handle": "0-50-3-00-ct-round-cut-lab-grown-diamonds-solitaire-ring-71726lb",
   "priceNow": 1186.99,
   "priceWas": 3680.0,
   "pctOff": 68,
   "core": "71726",
   "inStock": true,
   "createdAt": "2023-07-21T22:32:43Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/17A9_Zzcy-91jTSl8Ud5hsvECQoeQPNQm",
      "b": "https://lh3.googleusercontent.com/d/1ZxAm3DGknAf4jpbNjUfvGXccGC9TnpAR",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1YDw931EcN-loxh_In-kh5LGT1b3Izg0g",
      "b": "https://lh3.googleusercontent.com/d/1hkuiV8uccy7eWJe-66YN_iXHwxkuF7nl",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1aFRGB26Y-ZfrIlQJ6kz5BixuClhYDrfL",
      "b": "https://lh3.googleusercontent.com/d/1FyQV_fvBRCAPAJmnm2gomXOLKGenBumh",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-round-cut-lab-grown-diamonds-solitaire-ring-956802.jpg?v=1763748614"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 913,
   "id": "gid://shopify/Product/7302750208184",
   "title": "0.50-6.00 CT Cushion Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/0-50-3-00-ct-cushion-cut-lab-grown-diamonds-solitaire-ring-71814lb",
   "handle": "0-50-3-00-ct-cushion-cut-lab-grown-diamonds-solitaire-ring-71814lb",
   "priceNow": 1496.99,
   "priceWas": 4640.0,
   "pctOff": 68,
   "core": "71814",
   "inStock": true,
   "createdAt": "2023-07-21T22:32:19Z",
   "shape": "cushion",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1XLwHH-gdUtYq3LIrV_AdOR6Z_KWJF6xh",
      "b": "https://lh3.googleusercontent.com/d/1oz9QL4X_kjURps9bTLXiQEcjzFHsGL1j",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/12mVG4_DpH3Dki36O2xDUiDTzVwyApoze",
      "b": "https://lh3.googleusercontent.com/d/1PFyFnPTdN6bOI059gfIwA5MEZlfqHxu9",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1dREig_KhRzIkERNeT6bQTM11ZEK7Qqea",
      "b": "https://lh3.googleusercontent.com/d/1kQJbMXyi5tQ4-hBB1MgyhW69favv1Z8p",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-cushion-cut-lab-grown-diamonds-solitaire-ring-808741.jpg?v=1763748633"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 914,
   "id": "gid://shopify/Product/7302750175416",
   "title": "0.50-6.00 CT Cushion Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/0-50-3-00-ct-cushion-cut-lab-grown-diamonds-solitaire-ring-71817lb",
   "handle": "0-50-3-00-ct-cushion-cut-lab-grown-diamonds-solitaire-ring-71817lb",
   "priceNow": 1620.99,
   "priceWas": 5030.0,
   "pctOff": 68,
   "core": "71817",
   "inStock": true,
   "createdAt": "2023-07-21T22:32:07Z",
   "shape": "cushion",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/12zM8-eFzCqUFKq489dibDAcixz4BYjET",
      "b": "https://lh3.googleusercontent.com/d/1N3lgjw-7YCqp8OhonnzMn24bMB1wl8w5",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1oYpjDOVMG130SUcPxejuiL0_UGt4GHqU",
      "b": "https://lh3.googleusercontent.com/d/1BGBuT7vlvrPiM7apqo7D3Ga6ZJs6nQZH",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1MN_EyAJsilkS7zdLvJp5yqEFsqGQQPRX",
      "b": "https://lh3.googleusercontent.com/d/1UrHLyqPTDInuPAGrd_xuiu5Wwn4P6F19",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-cushion-cut-lab-grown-diamonds-solitaire-ring-270753.jpg?v=1763748633"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 915,
   "id": "gid://shopify/Product/7302750142648",
   "title": "0.50-6.00 CT Radiant Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/0-50-3-00-ct-radiant-cut-lab-grown-diamonds-solitaire-ring-71835lb",
   "handle": "0-50-3-00-ct-radiant-cut-lab-grown-diamonds-solitaire-ring-71835lb",
   "priceNow": 1237.99,
   "priceWas": 3840.0,
   "pctOff": 68,
   "core": "71835",
   "inStock": true,
   "createdAt": "2023-07-21T22:31:57Z",
   "shape": "radiant",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1ZdYc5-V4xGzoyfnlGcU4_yF2xxuwXpJU",
      "b": "https://lh3.googleusercontent.com/d/1q-Jdh8cpXq9AgCQcv3-yDkhos-QTQTvP",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/134eAX8L7RWHS064PUZ99TAtaMh8yVkY3",
      "b": "https://lh3.googleusercontent.com/d/1TrkonguMlkNqq7OsSnN1teQfxPPPSF4G",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1KxNlYe1VT-uKyXeh6d2ZkxmId8XqPLAz",
      "b": "https://lh3.googleusercontent.com/d/1Xr2qPPfbknT3llxACRzbXLj0ukTdsO4n",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-radiant-cut-lab-grown-diamonds-solitaire-ring-247344.jpg?v=1763748633"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 916,
   "id": "gid://shopify/Product/7302750109880",
   "title": "0.50-6.00 CT Pear Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/0-50-3-00-ct-pear-cut-lab-grown-diamonds-solitaire-ring-71841lb",
   "handle": "0-50-3-00-ct-pear-cut-lab-grown-diamonds-solitaire-ring-71841lb",
   "priceNow": 1187.99,
   "priceWas": 3680.0,
   "pctOff": 68,
   "core": "71841",
   "inStock": true,
   "createdAt": "2023-07-21T22:31:51Z",
   "shape": "pear",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1yPGgsObtXXNnBdvcfgkO-Gt7Fw4pWhX_",
      "b": "https://lh3.googleusercontent.com/d/1r4AmskThkVhsinjDXAb18GbehgHifyAD",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1OLtRKDy4uXyitBqHFCarOT-jvfc2i9nc",
      "b": "https://lh3.googleusercontent.com/d/1fT5STwoBHftmTqV6Me0hUZ_Mb7huMfvU",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1Aeotb2RJPX4QnqW5UbG10_68Jz0CKjUN",
      "b": "https://lh3.googleusercontent.com/d/1swemN-33kilUMVtUJg1dxxLWKN77WM9T",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-pear-cut-lab-grown-diamonds-solitaire-ring-374018.jpg?v=1763748633"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 917,
   "id": "gid://shopify/Product/7302743752888",
   "title": "0.50-6.00 CT Pear Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/0-50-3-00-ct-pear-cut-lab-grown-diamonds-solitaire-ring-71886lb",
   "handle": "0-50-3-00-ct-pear-cut-lab-grown-diamonds-solitaire-ring-71886lb",
   "priceNow": 1192.99,
   "priceWas": 3700.0,
   "pctOff": 68,
   "core": "71886",
   "inStock": true,
   "createdAt": "2023-07-21T21:25:46Z",
   "shape": "pear",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1KGMK0UlNaRdKQAIwDBPVBYGWQdVzJFB4",
      "b": "https://lh3.googleusercontent.com/d/1B5NXQyMBUsht16_KETLc_8CAJfdrOWQd",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1pF1LniWP-n6X8oyXv7FrRSYT3UI-2Vg4",
      "b": "https://lh3.googleusercontent.com/d/1lCQszHySgdRwtv1yOJlbdICemU_ntkDn",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1SDmxzNJ_iJMD9LgAvp30eqUAxXuKSQH_",
      "b": "https://lh3.googleusercontent.com/d/1rf70gzhpX87ciXcmUOBz1NosJU-u5Eho",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-pear-cut-lab-grown-diamonds-solitaire-ring-168245.jpg?v=1763748619"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 918,
   "id": "gid://shopify/Product/7302743720120",
   "title": "0.50-6.00 CT Round Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/0-50-3-00-ct-round-cut-lab-grown-diamonds-solitaire-ring-110386lb",
   "handle": "0-50-3-00-ct-round-cut-lab-grown-diamonds-solitaire-ring-110386lb",
   "priceNow": 1186.99,
   "priceWas": 3680.0,
   "pctOff": 68,
   "core": "110386",
   "inStock": true,
   "createdAt": "2023-07-21T21:25:39Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/13DfosCQ3ebRfTeXiK8ZTiCaa-R4F2nrf",
      "b": "https://lh3.googleusercontent.com/d/1-Wgj4a7lvXTObHmyVzPi-12keysDYJS2",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1I1BuD7i2bjXFAfUyCDD2n7WQHrKfIMbS",
      "b": "https://lh3.googleusercontent.com/d/1wN07GCafANhYrtcRZk99y9-Y5hSfgt7_",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1IOsVvPdhSS9eFtHelo8_FwQrTD6sE-Yq",
      "b": "https://lh3.googleusercontent.com/d/12hwknbRCmX60ASWhDOfSZIJSw_3FFtSy",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-round-cut-lab-grown-diamonds-solitaire-ring-648032.jpg?v=1763748631"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 919,
   "id": "gid://shopify/Product/7302743687352",
   "title": "0.50-6.00 CT Princess Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/0-50-3-00-ct-princess-cut-lab-grown-diamonds-solitaire-ring-71837lb",
   "handle": "0-50-3-00-ct-princess-cut-lab-grown-diamonds-solitaire-ring-71837lb",
   "priceNow": 1372.99,
   "priceWas": 4260.0,
   "pctOff": 68,
   "core": "71837",
   "inStock": true,
   "createdAt": "2023-07-21T21:25:32Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1jZczC0BWJcmMB23M3gkCml5DgbPrHfNF",
      "b": "https://lh3.googleusercontent.com/d/13PI6eLPNLvNR-wTewV9FgfvC0ryMXBmn",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1yy7EJOWzswObTYmu6QPzTTXZb9Alpu_O",
      "b": "https://lh3.googleusercontent.com/d/1kiGqHBw-7P6vPWORKXKIV0HSGE42gCnB",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1KHZ0oU2aEWZyQKLplhMU3QmHAsQowdpd",
      "b": "https://lh3.googleusercontent.com/d/1VtZt_pTUZCiDXfAeoMwfn4L8NkrMPs25",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-princess-cut-lab-grown-diamonds-solitaire-ring-425536.jpg?v=1763748633"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 920,
   "id": "gid://shopify/Product/7302743621816",
   "title": "0.50-6.00 CT Radiant Cut Lab Grown Diamonds - Solitaire Rings",
   "url": "/products/0-50-3-00-ct-radiant-cut-lab-grown-diamonds-solitaire-ring-71818lb",
   "handle": "0-50-3-00-ct-radiant-cut-lab-grown-diamonds-solitaire-ring-71818lb",
   "priceNow": 1361.99,
   "priceWas": 4220.0,
   "pctOff": 68,
   "core": "71818",
   "inStock": true,
   "createdAt": "2023-07-21T21:25:29Z",
   "shape": "radiant",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/14VZkFOkMyk3Q5eXnE88RojQooFv73ab2",
      "b": "https://lh3.googleusercontent.com/d/1MyMxGAPPmlXnuyDAV6E15Ex6tfAyXC5I",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1eNZbvZRSc9WTJO7OJpa__aF75v_IKzxh",
      "b": "https://lh3.googleusercontent.com/d/1N-E5VSQlh5ldx-gg7cmpQo8hku0WwCpx",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1juooCJvvkQ_o4zRO-n8w-5z0Z-FTyFMi",
      "b": "https://lh3.googleusercontent.com/d/1k5SuZ3IRmlimSpTjAJ86H2DdpLLvS9c1",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-radiant-cut-lab-grown-diamonds-solitaire-ring-202182.jpg?v=1763748633"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 921,
   "id": "gid://shopify/Product/7302740082872",
   "title": "1.00-4.00 CT Round Cut Lab Grown Diamonds - Designer Bracelets",
   "url": "/products/1-00-4-00-ct-round-cut-lab-grown-diamonds-diamond-bracelet-408608lb",
   "handle": "1-00-4-00-ct-round-cut-lab-grown-diamonds-diamond-bracelet-408608lb",
   "priceNow": 3568.99,
   "priceWas": 11060.0,
   "pctOff": 68,
   "core": "408608",
   "inStock": true,
   "createdAt": "2023-07-21T20:48:32Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-400-ct-round-cut-lab-grown-diamonds-designer-bracelet-935700.jpg?v=1705353553",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-400-ct-round-cut-lab-grown-diamonds-designer-bracelet-935700.jpg?v=1705353553",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-400-ct-round-cut-lab-grown-diamonds-designer-bracelet-721039.jpg?v=1763699838",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-400-ct-round-cut-lab-grown-diamonds-designer-bracelet-391660.jpg?v=1763699838"
    }
   },
   "carat": 1.0,
   "caratMax": 4.0
  },
  {
   "rank": 922,
   "id": "gid://shopify/Product/7302740050104",
   "title": "1.00-2.00 CT Round Cut Lab Grown Diamonds - Designer Bracelets",
   "url": "/products/1-00-2-00-ct-round-cut-lab-grown-diamonds-diamond-bracelet-336179lb",
   "handle": "1-00-2-00-ct-round-cut-lab-grown-diamonds-diamond-bracelet-336179lb",
   "priceNow": 3962.99,
   "priceWas": 12290.0,
   "pctOff": 68,
   "core": "336179",
   "inStock": true,
   "createdAt": "2023-07-21T20:48:26Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-200-ct-round-cut-lab-grown-diamonds-designer-bracelet-171078.jpg?v=1705353284",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-200-ct-round-cut-lab-grown-diamonds-designer-bracelet-171078.jpg?v=1705353284",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-200-ct-round-cut-lab-grown-diamonds-designer-bracelet-895032.jpg?v=1763699838",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-200-ct-round-cut-lab-grown-diamonds-designer-bracelet-246287.jpg?v=1763699838"
    }
   },
   "carat": 1.0,
   "caratMax": 2.0
  },
  {
   "rank": 923,
   "id": "gid://shopify/Product/7302721405112",
   "title": "2.50-5.50 CT Round Cut Lab Grown Diamonds - Designer Bracelets",
   "url": "/products/2-50-5-50-ct-round-cut-lab-grown-diamonds-diamond-bracelet-426336lb",
   "handle": "2-50-5-50-ct-round-cut-lab-grown-diamonds-diamond-bracelet-426336lb",
   "priceNow": 3917.99,
   "priceWas": 12150.0,
   "pctOff": 68,
   "core": "426336",
   "inStock": true,
   "createdAt": "2023-07-21T17:43:17Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/250-550-ct-round-cut-lab-grown-diamonds-designer-bracelet-506612.jpg?v=1705358789",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/250-550-ct-round-cut-lab-grown-diamonds-designer-bracelet-506612.jpg?v=1705358789",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/250-550-ct-round-cut-lab-grown-diamonds-designer-bracelet-544397.jpg?v=1763699838",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/250-550-ct-round-cut-lab-grown-diamonds-designer-bracelet-317550.jpg?v=1763699838"
    }
   },
   "carat": 2.5,
   "caratMax": 5.5
  },
  {
   "rank": 924,
   "id": "gid://shopify/Product/7302721372344",
   "title": "4.00-6.00 CT Round Cut Lab Grown Diamonds - Designer Bracelets",
   "url": "/products/4-00-6-00-ct-round-cut-lab-grown-diamonds-diamond-bracelet-405066lb",
   "handle": "4-00-6-00-ct-round-cut-lab-grown-diamonds-diamond-bracelet-405066lb",
   "priceNow": 4377.99,
   "priceWas": 13570.0,
   "pctOff": 68,
   "core": "405066",
   "inStock": true,
   "createdAt": "2023-07-21T17:43:14Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/400-600-ct-round-cut-lab-grown-diamonds-designer-bracelet-208400.jpg?v=1705364903",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/400-600-ct-round-cut-lab-grown-diamonds-designer-bracelet-208400.jpg?v=1705364903",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/400-600-ct-round-cut-lab-grown-diamonds-designer-bracelet-950653.jpg?v=1763699897",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/400-600-ct-round-cut-lab-grown-diamonds-designer-bracelet-509918.jpg?v=1763699897"
    }
   },
   "carat": 4.0,
   "caratMax": 6.0
  },
  {
   "rank": 925,
   "id": "gid://shopify/Product/7302721306808",
   "title": "3.50-4.00 CT Round Cut Lab Grown Diamonds - Designer Bracelets",
   "url": "/products/3-50-4-00-ct-round-cut-lab-grown-diamonds-diamond-bracelet-336032lb",
   "handle": "3-50-4-00-ct-round-cut-lab-grown-diamonds-diamond-bracelet-336032lb",
   "priceNow": 5216.99,
   "priceWas": 15130.0,
   "pctOff": 66,
   "core": "336032",
   "inStock": true,
   "createdAt": "2023-07-21T17:43:03Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/350-400-ct-round-cut-lab-grown-diamonds-designer-bracelet-854563.jpg?v=1705362341",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/350-400-ct-round-cut-lab-grown-diamonds-designer-bracelet-854563.jpg?v=1705362341",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/350-400-ct-round-cut-lab-grown-diamonds-designer-bracelet-589459.jpg?v=1763699898",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/350-400-ct-round-cut-lab-grown-diamonds-designer-bracelet-206814.jpg?v=1763699898"
    }
   },
   "carat": 3.5,
   "caratMax": 4.0
  },
  {
   "rank": 926,
   "id": "gid://shopify/Product/7302721274040",
   "title": "5.00-7.00 CT Round Cut Lab Grown Diamonds - Designer Bracelets",
   "url": "/products/5-00-7-00-ct-round-cut-lab-grown-diamonds-diamond-bracelet-426056lb",
   "handle": "5-00-7-00-ct-round-cut-lab-grown-diamonds-diamond-bracelet-426056lb",
   "priceNow": 6195.99,
   "priceWas": 17970.0,
   "pctOff": 66,
   "core": "426056",
   "inStock": true,
   "createdAt": "2023-07-21T17:43:01Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/500-700-ct-round-cut-lab-grown-diamonds-designer-bracelet-126486.jpg?v=1705364989",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/500-700-ct-round-cut-lab-grown-diamonds-designer-bracelet-126486.jpg?v=1705364989",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/500-700-ct-round-cut-lab-grown-diamonds-designer-bracelet-262157.jpg?v=1763699897",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/500-700-ct-round-cut-lab-grown-diamonds-designer-bracelet-652538.jpg?v=1763699898"
    }
   },
   "carat": 5.0,
   "caratMax": 7.0
  },
  {
   "rank": 927,
   "id": "gid://shopify/Product/7302721241272",
   "title": "5.50-6.50 CT Round Cut Lab Grown Diamonds - Designer Bracelets",
   "url": "/products/5-50-6-50-ct-round-cut-lab-grown-diamonds-diamond-bracelet-407460lb",
   "handle": "5-50-6-50-ct-round-cut-lab-grown-diamonds-diamond-bracelet-407460lb",
   "priceNow": 6293.99,
   "priceWas": 18250.0,
   "pctOff": 66,
   "core": "407460",
   "inStock": true,
   "createdAt": "2023-07-21T17:42:54Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/550-650-ct-round-cut-lab-grown-diamonds-designer-bracelet-227379.jpg?v=1705365430",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/550-650-ct-round-cut-lab-grown-diamonds-designer-bracelet-227379.jpg?v=1705365430",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/550-650-ct-round-cut-lab-grown-diamonds-designer-bracelet-856634.jpg?v=1763699898",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/550-650-ct-round-cut-lab-grown-diamonds-designer-bracelet-205776.jpg?v=1763699898"
    }
   },
   "carat": 5.5,
   "caratMax": 6.5
  },
  {
   "rank": 928,
   "id": "gid://shopify/Product/7302629490872",
   "title": "7.00-9.00 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/7-00-9-00-ct-round-cut-lab-grown-diamonds-diamond-bracelet-396049lb",
   "handle": "7-00-9-00-ct-round-cut-lab-grown-diamonds-diamond-bracelet-396049lb",
   "priceNow": 8008.99,
   "priceWas": 23230.0,
   "pctOff": 66,
   "core": "396049",
   "inStock": true,
   "createdAt": "2023-07-20T22:12:22Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/700-900-ct-round-cut-lab-grown-diamonds-tennis-bracelet-471485.jpg?v=1705365521",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/700-900-ct-round-cut-lab-grown-diamonds-tennis-bracelet-471485.jpg?v=1705365521",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/700-900-ct-round-cut-lab-grown-diamonds-tennis-bracelet-552938.jpg?v=1763699897",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/700-900-ct-round-cut-lab-grown-diamonds-tennis-bracelet-432400.jpg?v=1763699898"
    }
   },
   "carat": 7.0,
   "caratMax": 9.0
  },
  {
   "rank": 929,
   "id": "gid://shopify/Product/7302629425336",
   "title": "2.00-5.00 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/2-00-5-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-317440lb",
   "handle": "2-00-5-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-317440lb",
   "priceNow": 5387.99,
   "priceWas": 15630.0,
   "pctOff": 66,
   "core": "317440",
   "inStock": true,
   "createdAt": "2023-07-20T22:12:18Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-500-ct-round-cut-lab-grown-diamonds-tennis-bracelet-878273.jpg?v=1705357670",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-500-ct-round-cut-lab-grown-diamonds-tennis-bracelet-878273.jpg?v=1705357670",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-500-ct-round-cut-lab-grown-diamonds-tennis-bracelet-468991.jpg?v=1763699897",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-500-ct-round-cut-lab-grown-diamonds-tennis-bracelet-693076.jpg?v=1763699897"
    }
   },
   "carat": 2.0,
   "caratMax": 5.0
  },
  {
   "rank": 930,
   "id": "gid://shopify/Product/7302629359800",
   "title": "4.00-13.50 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/4-00-13-50-ct-princess-cut-lab-grown-diamonds-tennis-bracelet-317251lb",
   "handle": "4-00-13-50-ct-princess-cut-lab-grown-diamonds-tennis-bracelet-317251lb",
   "priceNow": 4697.99,
   "priceWas": 14560.0,
   "pctOff": 68,
   "core": "317251",
   "inStock": true,
   "createdAt": "2023-07-20T22:12:13Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/400-1350-ct-round-cut-lab-grown-diamonds-tennis-bracelet-462499.jpg?v=1705363224",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/400-1350-ct-round-cut-lab-grown-diamonds-tennis-bracelet-462499.jpg?v=1705363224",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/400-1350-ct-round-cut-lab-grown-diamonds-tennis-bracelet-165532.jpg?v=1763697499",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/400-1350-ct-round-cut-lab-grown-diamonds-tennis-bracelet-797354.jpg?v=1763697499"
    }
   },
   "carat": 4.0,
   "caratMax": 13.5
  },
  {
   "rank": 931,
   "id": "gid://shopify/Product/7302629195960",
   "title": "5.50 CT Princess Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/5-50-ct-princess-cut-lab-grown-diamonds-tennis-bracelet-425888lb",
   "handle": "5-50-ct-princess-cut-lab-grown-diamonds-tennis-bracelet-425888lb",
   "priceNow": 5879.99,
   "priceWas": 17050.0,
   "pctOff": 66,
   "core": "425888",
   "inStock": true,
   "createdAt": "2023-07-20T22:12:01Z",
   "shape": "princess",
   "origin": "lab",
   "rating": 4.0,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/550-ct-princess-cut-lab-grown-diamonds-tennis-bracelet-301888.jpg?v=1705365305",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/550-ct-princess-cut-lab-grown-diamonds-tennis-bracelet-301888.jpg?v=1705365305",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/550-ct-princess-cut-lab-grown-diamonds-tennis-bracelet-577970.jpg?v=1763699898",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/550-ct-princess-cut-lab-grown-diamonds-tennis-bracelet-628455.jpg?v=1763699898"
    }
   },
   "carat": 5.5
  },
  {
   "rank": 932,
   "id": "gid://shopify/Product/7302597574840",
   "title": "4.05-7.50 CT Princess & Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/4-05-7-50-ct-princess-round-cut-lab-grown-diamonds-tennis-bracelet-425482lb",
   "handle": "4-05-7-50-ct-princess-round-cut-lab-grown-diamonds-tennis-bracelet-425482lb",
   "priceNow": 5527.99,
   "priceWas": 16030.0,
   "pctOff": 66,
   "core": "425482",
   "inStock": true,
   "createdAt": "2023-07-20T18:33:49Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/405-750-ct-princess-round-cut-lab-grown-diamonds-tennis-bracelet-620546.jpg?v=1705364948",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/405-750-ct-princess-round-cut-lab-grown-diamonds-tennis-bracelet-620546.jpg?v=1705364948",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/405-750-ct-princess-round-cut-lab-grown-diamonds-tennis-bracelet-680910.jpg?v=1763699897",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/405-750-ct-princess-round-cut-lab-grown-diamonds-tennis-bracelet-298159.jpg?v=1763699898"
    }
   },
   "carat": 4.05,
   "caratMax": 7.5
  },
  {
   "rank": 933,
   "id": "gid://shopify/Product/7302597542072",
   "title": "3.50-5.00 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/3-50-5-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-426378lb",
   "handle": "3-50-5-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-426378lb",
   "priceNow": 5380.99,
   "priceWas": 15600.0,
   "pctOff": 66,
   "core": "426378",
   "inStock": true,
   "createdAt": "2023-07-20T18:33:47Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/350-500-ct-round-cut-lab-grown-diamonds-tennis-bracelet-152470.jpg?v=1705362385",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/350-500-ct-round-cut-lab-grown-diamonds-tennis-bracelet-152470.jpg?v=1705362385",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/350-500-ct-round-cut-lab-grown-diamonds-tennis-bracelet-563365.jpg?v=1763699897",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/350-500-ct-round-cut-lab-grown-diamonds-tennis-bracelet-950722.jpg?v=1763699898"
    }
   },
   "carat": 3.5,
   "caratMax": 5.0
  },
  {
   "rank": 934,
   "id": "gid://shopify/Product/7302597476536",
   "title": "3.00-10.00 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/3-00-10-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-426420lb",
   "handle": "3-00-10-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-426420lb",
   "priceNow": 4096.99,
   "priceWas": 12700.0,
   "pctOff": 68,
   "core": "426420",
   "inStock": true,
   "createdAt": "2023-07-20T18:33:43Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/300-1000-ct-round-cut-lab-grown-diamonds-tennis-bracelet-737225.jpg?v=1705359597",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/300-1000-ct-round-cut-lab-grown-diamonds-tennis-bracelet-737225.jpg?v=1705359597",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/300-1000-ct-round-cut-lab-grown-diamonds-tennis-bracelet-904734.jpg?v=1763700003",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/300-1000-ct-round-cut-lab-grown-diamonds-tennis-bracelet-392487.jpg?v=1763700003"
    }
   },
   "carat": 3.0,
   "caratMax": 10.0
  },
  {
   "rank": 935,
   "id": "gid://shopify/Product/7302597411000",
   "title": "1.00-5.00 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/1-00-5-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-425594lb",
   "handle": "1-00-5-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-425594lb",
   "priceNow": 3254.99,
   "priceWas": 10090.0,
   "pctOff": 68,
   "core": "425594",
   "inStock": true,
   "createdAt": "2023-07-20T18:33:40Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-500-ct-round-cut-lab-grown-diamonds-tennis-bracelet-366479.jpg?v=1705353850",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-500-ct-round-cut-lab-grown-diamonds-tennis-bracelet-366479.jpg?v=1705353850",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-500-ct-round-cut-lab-grown-diamonds-tennis-bracelet-256308.jpg?v=1763700003",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-500-ct-round-cut-lab-grown-diamonds-tennis-bracelet-226684.jpg?v=1763700003"
    }
   },
   "carat": 1.0,
   "caratMax": 5.0
  },
  {
   "rank": 936,
   "id": "gid://shopify/Product/7302597378232",
   "title": "1.50-8.00 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/1-50-8-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-104152lb",
   "handle": "1-50-8-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-104152lb",
   "priceNow": 3690.99,
   "priceWas": 11440.0,
   "pctOff": 68,
   "core": "104152",
   "inStock": true,
   "createdAt": "2023-07-20T18:33:37Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/150-800-ct-round-cut-lab-grown-diamonds-tennis-bracelet-878106.jpg?v=1705354175",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/150-800-ct-round-cut-lab-grown-diamonds-tennis-bracelet-878106.jpg?v=1705354175",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/150-800-ct-round-cut-lab-grown-diamonds-tennis-bracelet-970980.jpg?v=1763700003",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/150-800-ct-round-cut-lab-grown-diamonds-tennis-bracelet-282596.jpg?v=1763700003"
    }
   },
   "carat": 1.5,
   "caratMax": 8.0
  },
  {
   "rank": 937,
   "id": "gid://shopify/Product/7302513459384",
   "title": "3.00-7.00 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/3-00-7-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-104393lb",
   "handle": "3-00-7-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-104393lb",
   "priceNow": 3981.99,
   "priceWas": 12340.0,
   "pctOff": 68,
   "core": "104393",
   "inStock": true,
   "createdAt": "2023-07-19T22:43:22Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/300-700-ct-round-cut-lab-grown-diamonds-tennis-bracelet-899383.jpg?v=1705359747",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/300-700-ct-round-cut-lab-grown-diamonds-tennis-bracelet-899383.jpg?v=1705359747",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/300-700-ct-round-cut-lab-grown-diamonds-tennis-bracelet-872108.jpg?v=1763700004",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/300-700-ct-round-cut-lab-grown-diamonds-tennis-bracelet-449737.jpg?v=1763700004"
    }
   },
   "carat": 3.0,
   "caratMax": 7.0
  },
  {
   "rank": 938,
   "id": "gid://shopify/Product/7302513426616",
   "title": "2.00-12.00 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/2-00-12-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-407628lb",
   "handle": "2-00-12-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-407628lb",
   "priceNow": 3142.99,
   "priceWas": 9740.0,
   "pctOff": 68,
   "core": "407628",
   "inStock": true,
   "createdAt": "2023-07-19T22:43:05Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-1200-ct-round-cut-lab-grown-diamonds-tennis-bracelet-949089.jpg?v=1705354339",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-1200-ct-round-cut-lab-grown-diamonds-tennis-bracelet-949089.jpg?v=1705354339",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-1200-ct-round-cut-lab-grown-diamonds-tennis-bracelet-455864.jpg?v=1763700004",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-1200-ct-round-cut-lab-grown-diamonds-tennis-bracelet-481509.jpg?v=1763700003"
    }
   },
   "carat": 2.0,
   "caratMax": 12.0
  },
  {
   "rank": 939,
   "id": "gid://shopify/Product/7302513361080",
   "title": "2.50-6.00 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/2-50-6-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-376345lb",
   "handle": "2-50-6-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-376345lb",
   "priceNow": 5748.99,
   "priceWas": 16670.0,
   "pctOff": 66,
   "core": "376345",
   "inStock": true,
   "createdAt": "2023-07-19T22:42:50Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/250-600-ct-round-cut-lab-grown-diamonds-tennis-bracelet-622905.jpg?v=1705358834",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/250-600-ct-round-cut-lab-grown-diamonds-tennis-bracelet-622905.jpg?v=1705358834",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/250-600-ct-round-cut-lab-grown-diamonds-tennis-bracelet-845297.jpg?v=1763700003",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/250-600-ct-round-cut-lab-grown-diamonds-tennis-bracelet-324906.jpg?v=1763700003"
    }
   },
   "carat": 2.5,
   "caratMax": 6.0
  },
  {
   "rank": 940,
   "id": "gid://shopify/Product/7302513328312",
   "title": "2.50-10.50 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/2-50-10-50-ct-round-cut-lab-grown-diamonds-tennis-bracelet-426728lb",
   "handle": "2-50-10-50-ct-round-cut-lab-grown-diamonds-tennis-bracelet-426728lb",
   "priceNow": 4990.99,
   "priceWas": 15470.0,
   "pctOff": 68,
   "core": "426728",
   "inStock": true,
   "createdAt": "2023-07-19T22:42:33Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/250-1050-ct-round-cut-lab-grown-diamonds-tennis-bracelet-159309.jpg?v=1705358676",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/250-1050-ct-round-cut-lab-grown-diamonds-tennis-bracelet-159309.jpg?v=1705358676",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/250-1050-ct-round-cut-lab-grown-diamonds-tennis-bracelet-478400.jpg?v=1763700003",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/250-1050-ct-round-cut-lab-grown-diamonds-tennis-bracelet-682425.jpg?v=1763700003"
    }
   },
   "carat": 2.5,
   "caratMax": 10.5
  },
  {
   "rank": 941,
   "id": "gid://shopify/Product/7302513295544",
   "title": "1.00-9.00 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/1-00-9-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-376163lb",
   "handle": "1-00-9-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-376163lb",
   "priceNow": 3036.99,
   "priceWas": 9410.0,
   "pctOff": 68,
   "core": "376163",
   "inStock": true,
   "createdAt": "2023-07-19T22:42:13Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-900-ct-round-cut-lab-grown-diamonds-tennis-bracelet-152776.jpg?v=1705353944",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-900-ct-round-cut-lab-grown-diamonds-tennis-bracelet-152776.jpg?v=1705353944",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-900-ct-round-cut-lab-grown-diamonds-tennis-bracelet-220209.jpg?v=1764324389",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-900-ct-round-cut-lab-grown-diamonds-tennis-bracelet-187489.jpg?v=1763700003"
    }
   },
   "carat": 1.0,
   "caratMax": 9.0
  },
  {
   "rank": 942,
   "id": "gid://shopify/Product/7302500286648",
   "title": "1.00-5.00 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/1-00-5-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-409273lb",
   "handle": "1-00-5-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-409273lb",
   "priceNow": 3254.99,
   "priceWas": 10090.0,
   "pctOff": 68,
   "core": "409273",
   "inStock": true,
   "createdAt": "2023-07-19T21:00:34Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-500-ct-round-cut-lab-grown-diamonds-tennis-bracelet-888316.jpg?v=1705353742",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-500-ct-round-cut-lab-grown-diamonds-tennis-bracelet-888316.jpg?v=1705353742",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-500-ct-round-cut-lab-grown-diamonds-tennis-bracelet-923419.jpg?v=1763700004",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-500-ct-round-cut-lab-grown-diamonds-tennis-bracelet-778259.jpg?v=1763700004"
    }
   },
   "carat": 1.0,
   "caratMax": 5.0
  },
  {
   "rank": 943,
   "id": "gid://shopify/Product/7302500188344",
   "title": "1.00-3.00 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/1-00-3-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-426854lb",
   "handle": "1-00-3-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-426854lb",
   "priceNow": 3968.99,
   "priceWas": 12300.0,
   "pctOff": 68,
   "core": "426854",
   "inStock": true,
   "createdAt": "2023-07-19T21:00:17Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-300-ct-round-cut-lab-grown-diamonds-tennis-bracelet-240763.jpg?v=1705353426",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-300-ct-round-cut-lab-grown-diamonds-tennis-bracelet-240763.jpg?v=1705353426",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-300-ct-round-cut-lab-grown-diamonds-tennis-bracelet-110938.jpg?v=1763700003",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-300-ct-round-cut-lab-grown-diamonds-tennis-bracelet-248511.jpg?v=1763700003"
    }
   },
   "carat": 1.0,
   "caratMax": 3.0
  },
  {
   "rank": 944,
   "id": "gid://shopify/Product/7302500122808",
   "title": "1.50 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/1-50-ct-round-cut-lab-grown-diamonds-tennis-bracelet-426896lb",
   "handle": "1-50-ct-round-cut-lab-grown-diamonds-tennis-bracelet-426896lb",
   "priceNow": 4096.99,
   "priceWas": 12700.0,
   "pctOff": 68,
   "core": "426896",
   "inStock": true,
   "createdAt": "2023-07-19T21:00:02Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/150-ct-round-cut-lab-grown-diamonds-tennis-bracelet-685566.jpg?v=1705354023",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/150-ct-round-cut-lab-grown-diamonds-tennis-bracelet-685566.jpg?v=1705354023",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/150-ct-round-cut-lab-grown-diamonds-tennis-bracelet-135680.jpg?v=1763700003",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/150-ct-round-cut-lab-grown-diamonds-tennis-bracelet-172807.jpg?v=1763700003"
    }
   },
   "carat": 1.5
  },
  {
   "rank": 945,
   "id": "gid://shopify/Product/7302500024504",
   "title": "2.00-9.00 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/2-00-9-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-407306lb",
   "handle": "2-00-9-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-407306lb",
   "priceNow": 4114.99,
   "priceWas": 12760.0,
   "pctOff": 68,
   "core": "407306",
   "inStock": true,
   "createdAt": "2023-07-19T20:59:47Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-900-ct-round-cut-lab-grown-diamonds-tennis-bracelet-787545.jpg?v=1705358634",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-900-ct-round-cut-lab-grown-diamonds-tennis-bracelet-787545.jpg?v=1705358634",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-900-ct-round-cut-lab-grown-diamonds-tennis-bracelet-390183.jpg?v=1763700003",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-900-ct-round-cut-lab-grown-diamonds-tennis-bracelet-698943.jpg?v=1763700003"
    }
   },
   "carat": 2.0,
   "caratMax": 9.0
  },
  {
   "rank": 946,
   "id": "gid://shopify/Product/7302499958968",
   "title": "2.00-8.00 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/2-00-8-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-426210lb",
   "handle": "2-00-8-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-426210lb",
   "priceNow": 3999.99,
   "priceWas": 12400.0,
   "pctOff": 68,
   "core": "426210",
   "inStock": true,
   "createdAt": "2023-07-19T20:59:29Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-800-ct-round-cut-lab-grown-diamonds-tennis-bracelet-788494.jpg?v=1705358591",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-800-ct-round-cut-lab-grown-diamonds-tennis-bracelet-788494.jpg?v=1705358591",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-800-ct-round-cut-lab-grown-diamonds-tennis-bracelet-689704.jpg?v=1763700003",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-800-ct-round-cut-lab-grown-diamonds-tennis-bracelet-655416.jpg?v=1763700003"
    }
   },
   "carat": 2.0,
   "caratMax": 8.0
  },
  {
   "rank": 947,
   "id": "gid://shopify/Product/7302479052984",
   "title": "2.00 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/2-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-426560lb",
   "handle": "2-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-426560lb",
   "priceNow": 4329.99,
   "priceWas": 13420.0,
   "pctOff": 68,
   "core": "426560",
   "inStock": true,
   "createdAt": "2023-07-19T17:43:07Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-ct-round-cut-lab-grown-diamonds-tennis-bracelet-324210.jpg?v=1705354214",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-ct-round-cut-lab-grown-diamonds-tennis-bracelet-324210.jpg?v=1705354214",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-ct-round-cut-lab-grown-diamonds-tennis-bracelet-658783.jpg?v=1763700003",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-ct-round-cut-lab-grown-diamonds-tennis-bracelet-301796.jpg?v=1763700003"
    }
   },
   "carat": 2.0
  },
  {
   "rank": 948,
   "id": "gid://shopify/Product/7302479020216",
   "title": "2.00-7.00 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/2-00-7-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-404744lb",
   "handle": "2-00-7-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-404744lb",
   "priceNow": 4217.99,
   "priceWas": 13080.0,
   "pctOff": 68,
   "core": "404744",
   "inStock": true,
   "createdAt": "2023-07-19T17:42:53Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-700-ct-round-cut-lab-grown-diamonds-tennis-bracelet-261125.jpg?v=1705358552",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-700-ct-round-cut-lab-grown-diamonds-tennis-bracelet-261125.jpg?v=1705358552",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-700-ct-round-cut-lab-grown-diamonds-tennis-bracelet-774235.jpg?v=1763700003",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-700-ct-round-cut-lab-grown-diamonds-tennis-bracelet-775243.jpg?v=1763700004"
    }
   },
   "carat": 2.0,
   "caratMax": 7.0
  },
  {
   "rank": 949,
   "id": "gid://shopify/Product/7302478954680",
   "title": "2.00-6.00 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/2-00-6-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-376387lb",
   "handle": "2-00-6-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-376387lb",
   "priceNow": 3336.99,
   "priceWas": 10340.0,
   "pctOff": 68,
   "core": "376387",
   "inStock": true,
   "createdAt": "2023-07-19T17:42:36Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-600-ct-round-cut-lab-grown-diamonds-tennis-bracelet-867912.jpg?v=1705358389",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-600-ct-round-cut-lab-grown-diamonds-tennis-bracelet-867912.jpg?v=1705358389",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-600-ct-round-cut-lab-grown-diamonds-tennis-bracelet-613453.jpg?v=1763700003",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-600-ct-round-cut-lab-grown-diamonds-tennis-bracelet-499914.jpg?v=1763700004"
    }
   },
   "carat": 2.0,
   "caratMax": 6.0
  },
  {
   "rank": 950,
   "id": "gid://shopify/Product/7302478921912",
   "title": "2.00-7.00 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/2-00-7-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-404912lb",
   "handle": "2-00-7-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-404912lb",
   "priceNow": 4114.99,
   "priceWas": 12760.0,
   "pctOff": 68,
   "core": "404912",
   "inStock": true,
   "createdAt": "2023-07-19T17:42:18Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-700-ct-round-cut-lab-grown-diamonds-tennis-bracelet-413968.jpg?v=1705358510",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-700-ct-round-cut-lab-grown-diamonds-tennis-bracelet-413968.jpg?v=1705358510",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-700-ct-round-cut-lab-grown-diamonds-tennis-bracelet-776092.jpg?v=1763700004",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-700-ct-round-cut-lab-grown-diamonds-tennis-bracelet-563174.jpg?v=1763700004"
    }
   },
   "carat": 2.0,
   "caratMax": 7.0
  },
  {
   "rank": 951,
   "id": "gid://shopify/Product/7302478889144",
   "title": "2.00-5.00 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/2-00-5-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-376443lb",
   "handle": "2-00-5-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-376443lb",
   "priceNow": 5499.99,
   "priceWas": 15950.0,
   "pctOff": 66,
   "core": "376443",
   "inStock": true,
   "createdAt": "2023-07-19T17:42:01Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-500-ct-round-cut-lab-grown-diamonds-tennis-bracelet-651352.jpg?v=1705357298",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-500-ct-round-cut-lab-grown-diamonds-tennis-bracelet-651352.jpg?v=1705357298",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-500-ct-round-cut-lab-grown-diamonds-tennis-bracelet-372669.jpg?v=1763700004",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-500-ct-round-cut-lab-grown-diamonds-tennis-bracelet-959223.jpg?v=1763700004"
    }
   },
   "carat": 2.0,
   "caratMax": 5.0
  },
  {
   "rank": 952,
   "id": "gid://shopify/Product/7302141903032",
   "title": "3.50 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/3-50-ct-round-cut-lab-grown-diamonds-tennis-bracelet-71114lb",
   "handle": "3-50-ct-round-cut-lab-grown-diamonds-tennis-bracelet-71114lb",
   "priceNow": 2874.99,
   "priceWas": 8016.0,
   "pctOff": 64,
   "core": "71114",
   "inStock": true,
   "createdAt": "2023-07-17T22:50:09Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/350-ct-round-cut-lab-grown-diamonds-tennis-bracelet-814735.jpg?v=1705359894",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/350-ct-round-cut-lab-grown-diamonds-tennis-bracelet-814735.jpg?v=1705359894",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/350-ct-round-cut-lab-grown-diamonds-tennis-bracelet-692687.jpg?v=1705359894",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/350-ct-round-cut-lab-grown-diamonds-tennis-bracelet-612488.jpg?v=1705359894"
    }
   },
   "carat": 3.5
  },
  {
   "rank": 953,
   "id": "gid://shopify/Product/7302141837496",
   "title": "1.00-7.00 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/1-00-7-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-71783lb",
   "handle": "1-00-7-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-71783lb",
   "priceNow": 2986.99,
   "priceWas": 9260.0,
   "pctOff": 68,
   "core": "71783",
   "inStock": true,
   "createdAt": "2023-07-17T22:49:54Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-700-ct-round-cut-lab-grown-diamonds-tennis-bracelet-920864.jpg?v=1705353930",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-700-ct-round-cut-lab-grown-diamonds-tennis-bracelet-920864.jpg?v=1705353930",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-700-ct-round-cut-lab-grown-diamonds-tennis-bracelet-686142.jpg?v=1763700004",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-700-ct-round-cut-lab-grown-diamonds-tennis-bracelet-138612.jpg?v=1763700004"
    }
   },
   "carat": 1.0,
   "caratMax": 7.0
  },
  {
   "rank": 954,
   "id": "gid://shopify/Product/7302141804728",
   "title": "1.00-4.00 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/1-00-4-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-425300lb",
   "handle": "1-00-4-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-425300lb",
   "priceNow": 3790.99,
   "priceWas": 11750.0,
   "pctOff": 68,
   "core": "425300",
   "inStock": true,
   "createdAt": "2023-07-17T22:49:38Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-400-ct-round-cut-lab-grown-diamonds-tennis-bracelet-245825.jpg?v=1705353607",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-400-ct-round-cut-lab-grown-diamonds-tennis-bracelet-245825.jpg?v=1705353607",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-400-ct-round-cut-lab-grown-diamonds-tennis-bracelet-531195.jpg?v=1763700073",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-400-ct-round-cut-lab-grown-diamonds-tennis-bracelet-779567.jpg?v=1763700074"
    }
   },
   "carat": 1.0,
   "caratMax": 4.0
  },
  {
   "rank": 955,
   "id": "gid://shopify/Product/7302141739192",
   "title": "1.00-2.00 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/1-00-2-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-407418lb",
   "handle": "1-00-2-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-407418lb",
   "priceNow": 4262.99,
   "priceWas": 13220.0,
   "pctOff": 68,
   "core": "407418",
   "inStock": true,
   "createdAt": "2023-07-17T22:49:22Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/407418LB_w2.jpg?v=1705353340",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/407418LB_w2.jpg?v=1705353340",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-200-ct-round-cut-lab-grown-diamonds-tennis-bracelet-264487.jpg?v=1763700074",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-200-ct-round-cut-lab-grown-diamonds-tennis-bracelet-634498.jpg?v=1763700074"
    }
   },
   "carat": 1.0,
   "caratMax": 2.0
  },
  {
   "rank": 956,
   "id": "gid://shopify/Product/7302141673656",
   "title": "2.00-13.00 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/2-00-13-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-408909lb",
   "handle": "2-00-13-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-408909lb",
   "priceNow": 3987.99,
   "priceWas": 12360.0,
   "pctOff": 68,
   "core": "408909",
   "inStock": true,
   "createdAt": "2023-07-17T22:49:04Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-1300-ct-round-cut-lab-grown-diamonds-tennis-bracelet-374228.jpg?v=1705356588",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-1300-ct-round-cut-lab-grown-diamonds-tennis-bracelet-374228.jpg?v=1705356588",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-1300-ct-round-cut-lab-grown-diamonds-tennis-bracelet-173071.jpg?v=1763700074",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-1300-ct-round-cut-lab-grown-diamonds-tennis-bracelet-226647.jpg?v=1763700074"
    }
   },
   "carat": 2.0,
   "caratMax": 13.0
  },
  {
   "rank": 957,
   "id": "gid://shopify/Product/7302123225272",
   "title": "1.00-3.00 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/1-00-3-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-426812lb",
   "handle": "1-00-3-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-426812lb",
   "priceNow": 3968.99,
   "priceWas": 12300.0,
   "pctOff": 68,
   "core": "426812",
   "inStock": true,
   "createdAt": "2023-07-17T19:34:32Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-300-ct-round-cut-lab-grown-diamonds-tennis-bracelet-506244.jpg?v=1705353384",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-300-ct-round-cut-lab-grown-diamonds-tennis-bracelet-506244.jpg?v=1705353384",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-300-ct-round-cut-lab-grown-diamonds-tennis-bracelet-989560.jpg?v=1763700074",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-300-ct-round-cut-lab-grown-diamonds-tennis-bracelet-152802.jpg?v=1763700074"
    }
   },
   "carat": 1.0,
   "caratMax": 3.0
  },
  {
   "rank": 958,
   "id": "gid://shopify/Product/7302123192504",
   "title": "1.00-5.00 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/1-00-5-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-425664lb",
   "handle": "1-00-5-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-425664lb",
   "priceNow": 5305.99,
   "priceWas": 15390.0,
   "pctOff": 66,
   "core": "425664",
   "inStock": true,
   "createdAt": "2023-07-17T19:34:13Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-500-ct-round-cut-lab-grown-diamonds-tennis-bracelet-617487.jpg?v=1705353696",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-500-ct-round-cut-lab-grown-diamonds-tennis-bracelet-617487.jpg?v=1705353696",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-500-ct-round-cut-lab-grown-diamonds-tennis-bracelet-877219.jpg?v=1763700074",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-500-ct-round-cut-lab-grown-diamonds-tennis-bracelet-928291.jpg?v=1763700074"
    }
   },
   "carat": 1.0,
   "caratMax": 5.0
  },
  {
   "rank": 959,
   "id": "gid://shopify/Product/7302123061432",
   "title": "3.00-6.00 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/3-00-6-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-425734lb",
   "handle": "3-00-6-00-ct-round-cut-lab-grown-diamonds-tennis-bracelet-425734lb",
   "priceNow": 4305.99,
   "priceWas": 13350.0,
   "pctOff": 68,
   "core": "425734",
   "inStock": true,
   "createdAt": "2023-07-17T19:33:54Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/300-600-ct-round-cut-lab-grown-diamonds-tennis-bracelet-905005.jpg?v=1705359637",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/300-600-ct-round-cut-lab-grown-diamonds-tennis-bracelet-905005.jpg?v=1705359637",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/300-600-ct-round-cut-lab-grown-diamonds-tennis-bracelet-306720.jpg?v=1763700074",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/300-600-ct-round-cut-lab-grown-diamonds-tennis-bracelet-572659.jpg?v=1763700074"
    }
   },
   "carat": 3.0,
   "caratMax": 6.0
  },
  {
   "rank": 960,
   "id": "gid://shopify/Product/7302123028664",
   "title": "3.20 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/3-20-3-20-ct-round-cut-lab-grown-diamonds-tennis-bracelet-71122lb",
   "handle": "3-20-3-20-ct-round-cut-lab-grown-diamonds-tennis-bracelet-71122lb",
   "priceNow": 4736.99,
   "priceWas": 14680.0,
   "pctOff": 68,
   "core": "71122",
   "inStock": true,
   "createdAt": "2023-07-17T19:33:39Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/320-320-ct-round-cut-lab-grown-diamonds-tennis-bracelet-419881.jpg?v=1705359824",
    "byColor": {
     "white": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/320-320-ct-round-cut-lab-grown-diamonds-tennis-bracelet-419881.jpg?v=1705359824",
     "yellow": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/320-320-ct-round-cut-lab-grown-diamonds-tennis-bracelet-894087.jpg?v=1763700076",
     "rose": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/320-320-ct-round-cut-lab-grown-diamonds-tennis-bracelet-242444.jpg?v=1763700074"
    }
   },
   "carat": 3.2
  },
  {
   "rank": 961,
   "id": "gid://shopify/Product/7302122963128",
   "title": "1.00-3.15 CT Round Cut Lab Grown Diamonds - Tennis Bracelet",
   "url": "/products/1-00-3-15-ct-round-cut-lab-grown-diamonds-tennis-bracelet-71140lb",
   "handle": "1-00-3-15-ct-round-cut-lab-grown-diamonds-tennis-bracelet-71140lb",
   "priceNow": 3055.99,
   "priceWas": 9470.0,
   "pctOff": 68,
   "core": "71140",
   "inStock": true,
   "createdAt": "2023-07-17T19:33:20Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1mPdY6gipXE4ytvPpL_UbjHiLV6NNCAX1",
      "b": "https://lh3.googleusercontent.com/d/15KfrngIzOY-FA6LoVEuO3ewh1jcTwUYA",
      "angles": [
       1,
       2
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1SaG3Iwy-fbkKIx0HcH_vQKDIvfHxjpTz",
      "b": "https://lh3.googleusercontent.com/d/1bDj51_grjK615GyBwKUIbvj6fKl106Wt",
      "angles": [
       1,
       2
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/193aXp0D9JH_s5Cryn468JaLK8pfXQ_Lx",
      "b": "https://lh3.googleusercontent.com/d/1gdzp51IKTC6VeHQm27RrrbIUjVS6Ad6L",
      "angles": [
       1,
       2
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-315-ct-round-cut-lab-grown-diamonds-tennis-bracelet-853322.jpg?v=1705353513"
   },
   "carat": 1.0,
   "caratMax": 3.15
  },
  {
   "rank": 962,
   "id": "gid://shopify/Product/7301511184568",
   "title": "0.50-6.00 CT Pear Cut Lab Grown Diamonds - Solitaire Pendant",
   "url": "/products/0-50-3-00-ct-pear-cut-lab-grown-diamonds-solitaire-pendant-21005lb",
   "handle": "0-50-3-00-ct-pear-cut-lab-grown-diamonds-solitaire-pendant-21005lb",
   "priceNow": 837.99,
   "priceWas": 2850.0,
   "pctOff": 71,
   "core": "21005",
   "inStock": true,
   "createdAt": "2023-07-14T22:54:21Z",
   "shape": "pear",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-pear-cut-lab-grown-diamonds-solitaire-pendant-983937.jpg?v=1697640144"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 963,
   "id": "gid://shopify/Product/7301511151800",
   "title": "0.50-6.00 CT Oval Cut Lab Grown Diamonds - Solitaire Pendant",
   "url": "/products/0-50-3-00-ct-oval-cut-lab-grown-diamonds-solitaire-pendant-21004lb",
   "handle": "0-50-3-00-ct-oval-cut-lab-grown-diamonds-solitaire-pendant-21004lb",
   "priceNow": 850.99,
   "priceWas": 2890.0,
   "pctOff": 71,
   "core": "21004",
   "inStock": true,
   "createdAt": "2023-07-14T22:54:02Z",
   "shape": "oval",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-oval-cut-lab-grown-diamonds-solitaire-pendant-146534.jpg?v=1697640143"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 964,
   "id": "gid://shopify/Product/7301496602808",
   "title": "0.50-6.00 CT Pear Cut Lab Grown Diamonds - Solitaire Pendant",
   "url": "/products/0-50-3-00-ct-pear-cut-lab-grown-diamonds-solitaire-pendant-15504pelb",
   "handle": "0-50-3-00-ct-pear-cut-lab-grown-diamonds-solitaire-pendant-15504pelb",
   "priceNow": 975.99,
   "priceWas": 3220.0,
   "pctOff": 70,
   "core": "15504",
   "inStock": true,
   "createdAt": "2023-07-14T19:36:08Z",
   "shape": "pear",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-pear-cut-lab-grown-diamonds-solitaire-pendant-482816.jpg?v=1697640143"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 965,
   "id": "gid://shopify/Product/7301496504504",
   "title": "0.50-6.00 CT Princess Cut Lab Grown Diamonds - Solitaire Pendant",
   "url": "/products/0-50-3-00-ct-princess-cut-lab-grown-diamonds-solitaire-pendant-15504prlb",
   "handle": "0-50-3-00-ct-princess-cut-lab-grown-diamonds-solitaire-pendant-15504prlb",
   "priceNow": 1037.99,
   "priceWas": 3220.0,
   "pctOff": 68,
   "core": "15504",
   "inStock": true,
   "createdAt": "2023-07-14T19:35:15Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "cdn",
    "single": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-princess-cut-lab-grown-diamonds-solitaire-pendant-885223.jpg?v=1697640145"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 966,
   "id": "gid://shopify/Product/7301457871032",
   "title": "0.50-6.00 CT Princess Cut Lab Grown Diamonds - Solitaire Pendant",
   "url": "/products/0-50-3-00-ct-princess-cut-lab-grown-diamonds-solitaire-pendant-102676prlb",
   "handle": "0-50-3-00-ct-princess-cut-lab-grown-diamonds-solitaire-pendant-102676prlb",
   "priceNow": 1037.99,
   "priceWas": 3220.0,
   "pctOff": 68,
   "core": "102676",
   "inStock": true,
   "createdAt": "2023-07-14T18:20:27Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1rsa2R-gvKZPisip1rKrYTmGOGYZh9QcT",
      "b": "https://lh3.googleusercontent.com/d/1tDT-AG1rCXAhoROzxT1LKwIYhW4vHSw9",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1RlZfF78VgJcFLMz8P2JDORrHq8oAaSnR",
      "b": "https://lh3.googleusercontent.com/d/1i6oGRzdUfIo5aGaD4HqjW2UasmmXdBUy",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1EXQrfaZtrMNVMXthx8wbO4eP6eYFXr3u",
      "b": "https://lh3.googleusercontent.com/d/1PUN79_8gQcR471SnZWZXkFw9FFpCE25N",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-princess-cut-lab-grown-diamonds-solitaire-pendant-862696.jpg?v=1697640145"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 967,
   "id": "gid://shopify/Product/7301365530808",
   "title": "0.50-6.00 CT Heart Cut Lab Grown Diamonds - Solitaire Pendant",
   "url": "/products/0-50-3-00-ct-heart-cut-lab-grown-diamonds-solitaire-pendant-102690htlb",
   "handle": "0-50-3-00-ct-heart-cut-lab-grown-diamonds-solitaire-pendant-102690htlb",
   "priceNow": 1075.99,
   "priceWas": 3340.0,
   "pctOff": 68,
   "core": "102690",
   "inStock": true,
   "createdAt": "2023-07-13T22:12:49Z",
   "shape": "heart",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1u2BL4RbwVrafM-VwBgck1lrA1WRI-WKV",
      "b": "https://lh3.googleusercontent.com/d/1udW0FvvZlmSxcO2itIjUBBn51x2VdGxz",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1-0b-VkMEhCfdrI7Csp_eaaxppFHX8C6N",
      "b": "https://lh3.googleusercontent.com/d/1mWDu5MKSLP_UjNqEDq1xmwEEJPFahpTT",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1-PLqcq_7KTDGMtsmNwMPlafcVFUoHOLZ",
      "b": "https://lh3.googleusercontent.com/d/1XyVv1xKMs2O_gio934bEJ4tCWmJqXEH2",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-heart-cut-lab-grown-diamonds-solitaire-pendant-827358.jpg?v=1697640143"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 968,
   "id": "gid://shopify/Product/7301365498040",
   "title": "0.50-6.00 CT Oval Cut Lab Grown Diamonds - Solitaire Pendant",
   "url": "/products/0-50-3-00-ct-oval-cut-lab-grown-diamonds-solitaire-pendant-102690ovlb",
   "handle": "0-50-3-00-ct-oval-cut-lab-grown-diamonds-solitaire-pendant-102690ovlb",
   "priceNow": 1125.99,
   "priceWas": 3490.0,
   "pctOff": 68,
   "core": "102690",
   "inStock": true,
   "createdAt": "2023-07-13T22:12:32Z",
   "shape": "oval",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1u2BL4RbwVrafM-VwBgck1lrA1WRI-WKV",
      "b": "https://lh3.googleusercontent.com/d/1udW0FvvZlmSxcO2itIjUBBn51x2VdGxz",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1-0b-VkMEhCfdrI7Csp_eaaxppFHX8C6N",
      "b": "https://lh3.googleusercontent.com/d/1mWDu5MKSLP_UjNqEDq1xmwEEJPFahpTT",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1-PLqcq_7KTDGMtsmNwMPlafcVFUoHOLZ",
      "b": "https://lh3.googleusercontent.com/d/1XyVv1xKMs2O_gio934bEJ4tCWmJqXEH2",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-oval-cut-lab-grown-diamonds-solitaire-pendant-260457.jpg?v=1697640143"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 969,
   "id": "gid://shopify/Product/7301365432504",
   "title": "0.50-6.00 CT Princess Cut Lab Grown Diamonds - Solitaire Pendant",
   "url": "/products/0-50-3-00-ct-princess-cut-lab-grown-diamonds-solitaire-pendant-102690prlb",
   "handle": "0-50-3-00-ct-princess-cut-lab-grown-diamonds-solitaire-pendant-102690prlb",
   "priceNow": 1175.99,
   "priceWas": 3650.0,
   "pctOff": 68,
   "core": "102690",
   "inStock": true,
   "createdAt": "2023-07-13T22:11:57Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1u2BL4RbwVrafM-VwBgck1lrA1WRI-WKV",
      "b": "https://lh3.googleusercontent.com/d/1udW0FvvZlmSxcO2itIjUBBn51x2VdGxz",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1-0b-VkMEhCfdrI7Csp_eaaxppFHX8C6N",
      "b": "https://lh3.googleusercontent.com/d/1mWDu5MKSLP_UjNqEDq1xmwEEJPFahpTT",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1-PLqcq_7KTDGMtsmNwMPlafcVFUoHOLZ",
      "b": "https://lh3.googleusercontent.com/d/1XyVv1xKMs2O_gio934bEJ4tCWmJqXEH2",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-300-ct-princess-cut-lab-grown-diamonds-solitaire-pendant-292176.jpg?v=1697640145"
   },
   "carat": 0.5,
   "caratMax": 6.0
  },
  {
   "rank": 970,
   "id": "gid://shopify/Product/7301087002808",
   "title": "1.00 CT Round Cut Lab Grown Diamonds - Eternity Rings",
   "url": "/products/1-00-ct-round-cut-lab-grown-diamonds-eternity-ring-15374lb",
   "handle": "1-00-ct-round-cut-lab-grown-diamonds-eternity-ring-15374lb",
   "priceNow": 1440.99,
   "priceWas": 4470.0,
   "pctOff": 68,
   "core": "15374",
   "inStock": true,
   "createdAt": "2023-07-11T18:07:11Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1mupJmZEnkit6b4c9yLJZPv-iVA4mLltN",
      "b": "https://lh3.googleusercontent.com/d/1CsylaFUeM82r4Epgu3cV2VGTafhfi7tk",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1HOq6coJBBuxZBKZIyRsLMu_Q8RIR3j33",
      "b": "https://lh3.googleusercontent.com/d/1nK0Sz2vQu3AzLrSqKCzH6__X-lqVwlSW",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1wSBFBt1KVIDZdYgK4E0ggldCit00X8vv",
      "b": "https://lh3.googleusercontent.com/d/1tM02lnAhvWadQn8oqwUfGK0Pos9mCNux",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/100-ct-round-cut-lab-grown-diamonds-eternity-ring-851783.jpg?v=1697640154"
   },
   "carat": 1.0
  },
  {
   "rank": 971,
   "id": "gid://shopify/Product/7301080318136",
   "title": "1.50 CT Princess & Round Cut Lab Grown Diamonds - Eternity Rings",
   "url": "/products/1-50-ct-round-princess-cut-lab-grown-diamonds-eternity-ring-15947lb",
   "handle": "1-50-ct-round-princess-cut-lab-grown-diamonds-eternity-ring-15947lb",
   "priceNow": 1431.99,
   "priceWas": 4440.0,
   "pctOff": 68,
   "core": "15947",
   "inStock": true,
   "createdAt": "2023-07-11T16:43:43Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1yynZxOtY64RTjfcLyo3WIIW9SXtotDaN",
      "b": "https://lh3.googleusercontent.com/d/1mexvmzWpBg5KzR8I0VooY1Z-4fDk5V_E",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/10HRq2HWnFjyrx_-KolWv7OLLHoerb3sY",
      "b": "https://lh3.googleusercontent.com/d/1lz9E-MqluXEeHaYRcohSmsqtIz9YjmWl",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/10cukc7JldLVNVBwGMq6Tqr5YLJEjivg1",
      "b": "https://lh3.googleusercontent.com/d/1VjY5teaKHHchOkqOsTIYXux-pGi0MK9K",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/150-ct-round-princess-cut-lab-grown-diamonds-eternity-ring-728814.jpg?v=1697640161"
   },
   "carat": 1.5
  },
  {
   "rank": 972,
   "id": "gid://shopify/Product/7301079892152",
   "title": "5.20 CT Emerald Cut Lab Grown Diamonds - Eternity Rings",
   "url": "/products/5-20-ct-emerald-cut-lab-grown-diamonds-eternity-ring-15955lb",
   "handle": "5-20-ct-emerald-cut-lab-grown-diamonds-eternity-ring-15955lb",
   "priceNow": 2615.99,
   "priceWas": 8110.0,
   "pctOff": 68,
   "core": "15955",
   "inStock": true,
   "createdAt": "2023-07-11T16:33:46Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1HFCRg5dS54CcAI8nRUt9jfyT9V-WPZQg",
      "b": "https://lh3.googleusercontent.com/d/1Xshg97AadUeVYGfQTpRWxzoL34BQQkEg",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1EAizKjJxllFof9NqcSPSVxwqMdKeu1tt",
      "b": "https://lh3.googleusercontent.com/d/1VqUu6tczDZLvnL0ym_WCdf09eFCHqxPw",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1_scObWzoBFrUz4aiAsrY2o4zHBADaEyG",
      "b": "https://lh3.googleusercontent.com/d/1bu0xsvy0OID172BIv4HmJUAL5gGTfrCp",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/520-ct-emerald-cut-lab-grown-diamonds-eternity-ring-332147.jpg?v=1697640171"
   },
   "carat": 5.2
  },
  {
   "rank": 973,
   "id": "gid://shopify/Product/7301079859384",
   "title": "4.60 CT Princess Cut Lab Grown Diamonds - Eternity Rings",
   "url": "/products/4-60-ct-princess-cut-lab-grown-diamonds-eternity-ring-15953lb",
   "handle": "4-60-ct-princess-cut-lab-grown-diamonds-eternity-ring-15953lb",
   "priceNow": 2644.99,
   "priceWas": 8200.0,
   "pctOff": 68,
   "core": "15953",
   "inStock": true,
   "createdAt": "2023-07-11T16:33:31Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1RIQYoGSvWzabJhx6jtOr1bS5BxC_ksWb",
      "b": "https://lh3.googleusercontent.com/d/1iilSOsdNAyda3VkABHArWWvF0ZI7pPJ_",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/10wFQaAlEDMy_48rVLnJ_-7-_DeIihOep",
      "b": "https://lh3.googleusercontent.com/d/1sVVsW01d6QhLnf5bIwcUMbGU88H8-HHw",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1a0eB7oUXF1z7IU52768KB7on0LK0hfB1",
      "b": "https://lh3.googleusercontent.com/d/12hKPlE0nH-XGIXgSaPZ3_Xpj3UeFk2DH",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/460-ct-princess-cut-lab-grown-diamonds-eternity-ring-281942.jpg?v=1697640171"
   },
   "carat": 4.6
  },
  {
   "rank": 974,
   "id": "gid://shopify/Product/7301071831224",
   "title": "1.50-5.00 CT Round Cut Lab Grown Diamonds - Eternity Rings",
   "url": "/products/1-50-5-00-ct-round-cut-lab-grown-diamonds-eternity-ring-71688lb",
   "handle": "1-50-5-00-ct-round-cut-lab-grown-diamonds-eternity-ring-71688lb",
   "priceNow": 1247.99,
   "priceWas": 3870.0,
   "pctOff": 68,
   "core": "71688",
   "inStock": true,
   "createdAt": "2023-07-11T14:58:33Z",
   "shape": "round",
   "origin": "lab",
   "rating": 5.0,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/13fQQ9e7xP-xGJl1ihSeJ289QBnzMFYCj",
      "b": "https://lh3.googleusercontent.com/d/1qKlIOrs9EAkSgEuMnhq30kPO297E5IFb",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1DelxLSdZEwB76Eck1JHRTWdwHMiapH9q",
      "b": "https://lh3.googleusercontent.com/d/1YOQFlHqrYSCwWqG6zCn9IiGWIzj50nNR",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1pZ29gUXUr5KdN0_8DhFLgGvHwc3Ve99t",
      "b": "https://lh3.googleusercontent.com/d/1BKiYj9E2jbq055Lmt2e6SyW5Lo3Nhts1",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/150-500-ct-round-cut-lab-grown-diamonds-eternity-ring-832054.jpg?v=1697640162"
   },
   "carat": 1.5,
   "caratMax": 5.0
  },
  {
   "rank": 975,
   "id": "gid://shopify/Product/7301071438008",
   "title": "2.00-4.00 CT Princess Cut Lab Grown Diamonds - Eternity Rings",
   "url": "/products/2-00-4-00-ct-princess-cut-lab-grown-diamonds-eternity-ring-71705lb",
   "handle": "2-00-4-00-ct-princess-cut-lab-grown-diamonds-eternity-ring-71705lb",
   "priceNow": 1585.99,
   "priceWas": 4920.0,
   "pctOff": 68,
   "core": "71705",
   "inStock": true,
   "createdAt": "2023-07-11T14:57:41Z",
   "shape": "princess",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1pQvVo2k1RjZ_1Y--f09ogyiKkBebkcB5",
      "b": "https://lh3.googleusercontent.com/d/1N89bvy2kaeYyuTvVwwkKw_q-TALVvcUq",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/15vDe1ohz9XYE0b_jWINYy7Cd3gEvKbwj",
      "b": "https://lh3.googleusercontent.com/d/1SjWwYjW3_nNtZi0sf_BeyCgMixHXhbzB",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1XFRoieftKceGUYdEFFZI-IIXZL0uM-U5",
      "b": "https://lh3.googleusercontent.com/d/1LKj4RijZmVWz-ciYtajKRuJ_Ekv8ysm8",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/200-400-ct-princess-cut-lab-grown-diamonds-eternity-ring-681692.jpg?v=1697640166"
   },
   "carat": 2.0,
   "caratMax": 4.0
  },
  {
   "rank": 976,
   "id": "gid://shopify/Product/7300756635832",
   "title": "0.50-2.00 CT Round Cut Lab Grown Diamonds - Eternity Rings",
   "url": "/products/0-50-2-00-ct-round-cut-lab-grown-diamonds-eternity-ring-71730lb",
   "handle": "0-50-2-00-ct-round-cut-lab-grown-diamonds-eternity-ring-71730lb",
   "priceNow": 927.99,
   "priceWas": 3160.0,
   "pctOff": 71,
   "core": "71730",
   "inStock": true,
   "createdAt": "2023-07-10T20:54:38Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1NEclVh_byFVu1-CdlMgDVxgNt0Mzs0rk",
      "b": "https://lh3.googleusercontent.com/d/1ToUBvs5qggoh_YPku9SkdPmJYEgTNem3",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1TJQO-B0LCHrulkrpKjk0Y41X4U7A_TbF",
      "b": "https://lh3.googleusercontent.com/d/1sMZrORvdCT1kcm-GnRSAUMuZuY13OWLV",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1bXszf4wyCRyoqaZfhldBzrmQJTRyjMZg",
      "b": "https://lh3.googleusercontent.com/d/1savTjO-HpAslVmRMBRwDfzwBgrGVqrZM",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/050-200-ct-round-cut-lab-grown-diamonds-eternity-ring-277651.jpg?v=1697640141"
   },
   "carat": 0.5,
   "caratMax": 2.0
  },
  {
   "rank": 977,
   "id": "gid://shopify/Product/7300756570296",
   "title": "4.00-6.00 CT Round Cut Lab Grown Diamonds - Eternity Rings",
   "url": "/products/4-00-6-00-ct-round-cut-lab-grown-diamonds-eternity-ring-71708lb",
   "handle": "4-00-6-00-ct-round-cut-lab-grown-diamonds-eternity-ring-71708lb",
   "priceNow": 3472.99,
   "priceWas": 10770.0,
   "pctOff": 68,
   "core": "71708",
   "inStock": true,
   "createdAt": "2023-07-10T20:54:20Z",
   "shape": "round",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1N1v5mYDxU_i5zzIGUEFd3PETKbgSqddW",
      "b": "https://lh3.googleusercontent.com/d/18cWic6CatdFH3_9dAcyIUF-ReEMAuHM_",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1fsJOq5L5UyNrq5W7XvPZE12pvTjnnh2t",
      "b": "https://lh3.googleusercontent.com/d/1x4fWNBKmRix_UDX2P7jVpW-HST0ngOt5",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1f-qBhcACozUbLGypVXTK2FDWGUiD4Le1",
      "b": "https://lh3.googleusercontent.com/d/1_nzr76UaA-LaG1v_cM9lRFr6d6gDyj9z",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/400-600-ct-round-cut-lab-grown-diamonds-eternity-ring-200889.jpg?v=1697640171"
   },
   "carat": 4.0,
   "caratMax": 6.0
  },
  {
   "rank": 978,
   "id": "gid://shopify/Product/7300738810040",
   "title": "2.50 CT Emerald Cut Lab Grown Diamonds - Eternity Rings",
   "url": "/products/2-50-ct-emerald-cut-lab-grown-diamonds-eternity-ring-71757lb",
   "handle": "2-50-ct-emerald-cut-lab-grown-diamonds-eternity-ring-71757lb",
   "priceNow": 2054.99,
   "priceWas": 6370.0,
   "pctOff": 68,
   "core": "71757",
   "inStock": true,
   "createdAt": "2023-07-10T18:13:11Z",
   "shape": "emerald",
   "origin": "lab",
   "rating": null,
   "images": {
    "source": "render-drive",
    "byColor": {
     "white": {
      "a": "https://lh3.googleusercontent.com/d/1YxARV1Z6IcnD42nWssE1MBXeeDFRITNh",
      "b": "https://lh3.googleusercontent.com/d/16MIMdoqBGuEBSFSxJJx-j2QglSGPF20G",
      "angles": [
       3,
       4
      ]
     },
     "yellow": {
      "a": "https://lh3.googleusercontent.com/d/1qawBkw8rleHIiK0aD9vY85gGBq3cq18j",
      "b": "https://lh3.googleusercontent.com/d/1rjdk-ugk-Ra0krNB5sXpNX8ZHkaSURqh",
      "angles": [
       3,
       4
      ]
     },
     "rose": {
      "a": "https://lh3.googleusercontent.com/d/1ue43VndeFDURBNF9tlK_qce1CWjS9Zsv",
      "b": "https://lh3.googleusercontent.com/d/1hOu4S7U-cDBbq3GvZeR7XWKQjxthcAyI",
      "angles": [
       3,
       4
      ]
     }
    },
    "cdn": "https://cdn.shopify.com/s/files/1/0481/4595/7027/products/250-ct-emerald-cut-lab-grown-diamonds-eternity-ring-300299.jpg?v=1697640168"
   },
   "carat": 2.5
  }
 ],
 "filterNote": "Derived from the live lab-grown-diamonds shelf (989 products). Dropped 7 zero-price items - all of them free-gift SKUs (docapp-free-gift-* handles and their clones) whose priceWas values are also scrambled - and 4 natural-diamond pieces (4 tennis bracelets) that do not belong on a lab shelf. Both are live-data defects for Stage 2, not page decisions. 2 surviving titles still carry the price baked into the title text; the card naming must strip a trailing ' - $X'."
};
